/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: bun run demo/scripts/generate-handlers.ts
 * Generated at: 2026-01-21T23:35:49.635Z
 *
 * This file contains MSW handlers for all API endpoints,
 * generated from server controller definitions.
 */

import { http, HttpResponse } from 'msw';

// Demo data embedded from db-dump JSON files
const demoData: Record<string, any[]> = {
  "transaction": [
    {
      "id": "txn_6sww3pbqc05qxqncb39gw0hham",
      "createdAt": "2026-01-15T16:57:00.000Z",
      "updatedAt": "2026-01-15T16:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5.19,
      "currency": "EUR",
      "description": "Payment to Spar: S-202601-6724",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_g3qfxvmr4t3khens09b43478j9",
      "fspDate": "2026-01-15T15:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_g3qfxvmr4t3khens09b43478j9",
        "bookingDate": "2026-01-15",
        "valueDate": "2026-01-15",
        "bookingDateTime": "2026-01-15T16:57:00.000Z",
        "valueDateTime": "2026-01-15T16:57:00.000Z",
        "transactionAmount": {
          "amount": "5.19",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Spar: S-202601-6724",
        "remittanceInformationUnstructuredArray": [
          "Payment to Spar",
          "S-202601-6724"
        ],
        "debtorName": "Spar"
      },
      "paymentId": null,
      "reference": "S-202601-6724",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g32eshsphp8z5k4nrvg",
      "clustering": {
        "description": "Spar",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Spar' based on payment details",
        "updatedAt": "2026-01-15T16:57:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Spar",
        "iban": "DE77412091708461310",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_79tsyxspp433gcystc7qsfpvzj",
      "createdAt": "2026-01-15T16:31:00.000Z",
      "updatedAt": "2026-01-15T16:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.26,
      "currency": "EUR",
      "description": "Payment to Jarek's Kitchen: JK-202601-2957",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_kcvq7tjgx6epwmpc086wgdpb0p",
      "fspDate": "2026-01-15T15:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_kcvq7tjgx6epwmpc086wgdpb0p",
        "bookingDate": "2026-01-15",
        "valueDate": "2026-01-15",
        "bookingDateTime": "2026-01-15T16:31:00.000Z",
        "valueDateTime": "2026-01-15T16:31:00.000Z",
        "transactionAmount": {
          "amount": "14.26",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jarek's Kitchen: JK-202601-2957",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jarek's Kitchen",
          "JK-202601-2957"
        ],
        "debtorName": "Jarek's Kitchen"
      },
      "paymentId": null,
      "reference": "JK-202601-2957",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9ynmeshspjjhrjb91rve",
      "clustering": {
        "description": "Jarek's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Jarek's Kitchen' based on payment details",
        "updatedAt": "2026-01-15T16:31:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Jarek's Kitchen",
        "iban": "DE92223413927868720",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_crmsrcak2qv1gx46ty313k1rx4",
      "createdAt": "2026-01-15T14:56:00.000Z",
      "updatedAt": "2026-01-15T14:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 13.92,
      "currency": "EUR",
      "description": "Payment to Finom: F-202601-2822",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xfz6mrhgdjv0qsdzv2zy48w3e8",
      "fspDate": "2026-01-15T13:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xfz6mrhgdjv0qsdzv2zy48w3e8",
        "bookingDate": "2026-01-15",
        "valueDate": "2026-01-15",
        "bookingDateTime": "2026-01-15T14:56:00.000Z",
        "valueDateTime": "2026-01-15T14:56:00.000Z",
        "transactionAmount": {
          "amount": "13.92",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Finom: F-202601-2822",
        "remittanceInformationUnstructuredArray": [
          "Payment to Finom",
          "F-202601-2822"
        ],
        "debtorName": "Finom"
      },
      "paymentId": null,
      "reference": "F-202601-2822",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0yxeshspjws0xeeqa1k",
      "clustering": {
        "description": "Finom",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Finom' based on payment details",
        "updatedAt": "2026-01-15T14:56:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Finom",
        "iban": "DE88513106098024350",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_k40aypv1r24mvnrr8wch5nw7gr",
      "createdAt": "2026-01-15T14:20:00.000Z",
      "updatedAt": "2026-01-15T14:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 148.45,
      "currency": "GBP",
      "description": "Payment to Aer Lingus: AL-202601-9105",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mtma8zy6xvbqpx9s67t8xv14fa",
      "fspDate": "2026-01-15T13:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mtma8zy6xvbqpx9s67t8xv14fa",
        "bookingDate": "2026-01-15",
        "valueDate": "2026-01-15",
        "bookingDateTime": "2026-01-15T14:20:00.000Z",
        "valueDateTime": "2026-01-15T14:20:00.000Z",
        "transactionAmount": {
          "amount": "148.45",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Aer Lingus: AL-202601-9105",
        "remittanceInformationUnstructuredArray": [
          "Payment to Aer Lingus",
          "AL-202601-9105"
        ],
        "debtorName": "Aer Lingus"
      },
      "paymentId": null,
      "reference": "AL-202601-9105",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnekfvhrjnk2qd4ej2sf",
      "clustering": {
        "description": "Aer Lingus",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Aer Lingus' based on payment details",
        "updatedAt": "2026-01-15T14:20:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Aer Lingus",
        "iban": null,
        "bic": null,
        "sortCode": "489817",
        "accountNumber": "39942163"
      }
    },
    {
      "id": "txn_ta1c0ee7chnwt6qt5vnjmtvnkx",
      "createdAt": "2026-01-14T15:34:00.000Z",
      "updatedAt": "2026-01-14T15:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17.95,
      "currency": "EUR",
      "description": "Payment to Marquette: M-202601-3016",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_sbxft77mm9w69cthde6xszzdqx",
      "fspDate": "2026-01-14T14:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_sbxft77mm9w69cthde6xszzdqx",
        "bookingDate": "2026-01-14",
        "valueDate": "2026-01-14",
        "bookingDateTime": "2026-01-14T15:34:00.000Z",
        "valueDateTime": "2026-01-14T15:34:00.000Z",
        "transactionAmount": {
          "amount": "17.95",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marquette: M-202601-3016",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marquette",
          "M-202601-3016"
        ],
        "debtorName": "Marquette"
      },
      "paymentId": null,
      "reference": "M-202601-3016",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1npeshspm6wcf3gtsdh",
      "clustering": {
        "description": "Marquette",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marquette' based on payment details",
        "updatedAt": "2026-01-14T15:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marquette",
        "iban": "DE63325934729934800",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fbpgwyad2rpmd1q46x2mg3zt3d",
      "createdAt": "2026-01-14T15:15:00.000Z",
      "updatedAt": "2026-01-14T15:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 454.45,
      "currency": "USD",
      "description": "Payment to Kandji: K-202601-3317",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w41n6a8d9tmb6rtfk7btr90y0s",
      "fspDate": "2026-01-14T14:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w41n6a8d9tmb6rtfk7btr90y0s",
        "bookingDate": "2026-01-14",
        "valueDate": "2026-01-14",
        "bookingDateTime": "2026-01-14T15:15:00.000Z",
        "valueDateTime": "2026-01-14T15:15:00.000Z",
        "transactionAmount": {
          "amount": "454.45",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kandji: K-202601-3317",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kandji",
          "K-202601-3317"
        ],
        "debtorName": "Kandji"
      },
      "paymentId": null,
      "reference": "K-202601-3317",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax4veshspjmy8ae028r6",
      "clustering": {
        "description": "Kandji",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kandji' based on payment details",
        "updatedAt": "2026-01-14T15:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kandji",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_t2tq6w8krpwxhqff45s9aj2qs6",
      "createdAt": "2026-01-14T13:24:00.000Z",
      "updatedAt": "2026-01-14T13:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 16.02,
      "currency": "GBP",
      "description": "Payment to Transport for London: TFL-202601-5416",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_544swhper40a8rh27z6dqvg6pg",
      "fspDate": "2026-01-14T12:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_544swhper40a8rh27z6dqvg6pg",
        "bookingDate": "2026-01-14",
        "valueDate": "2026-01-14",
        "bookingDateTime": "2026-01-14T13:24:00.000Z",
        "valueDateTime": "2026-01-14T13:24:00.000Z",
        "transactionAmount": {
          "amount": "16.02",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Transport for London: TFL-202601-5416",
        "remittanceInformationUnstructuredArray": [
          "Payment to Transport for London",
          "TFL-202601-5416"
        ],
        "debtorName": "Transport for London"
      },
      "paymentId": null,
      "reference": "TFL-202601-5416",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgk7fvhrjp0v7hz9q786",
      "clustering": {
        "description": "Transport for London",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Transport for London' based on payment details",
        "updatedAt": "2026-01-14T13:24:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Transport for London",
        "iban": null,
        "bic": null,
        "sortCode": "907372",
        "accountNumber": "32820910"
      }
    },
    {
      "id": "txn_s8mxg8m9v989jdmg4k5vesb6p1",
      "createdAt": "2026-01-14T11:55:00.000Z",
      "updatedAt": "2026-01-14T11:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 46.18,
      "currency": "GBP",
      "description": "Payment to Deliveroo: D-202601-7772",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6jzq4kzcz4qaeqaprb4pfjmj5t",
      "fspDate": "2026-01-14T10:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6jzq4kzcz4qaeqaprb4pfjmj5t",
        "bookingDate": "2026-01-14",
        "valueDate": "2026-01-14",
        "bookingDateTime": "2026-01-14T11:55:00.000Z",
        "valueDateTime": "2026-01-14T11:55:00.000Z",
        "transactionAmount": {
          "amount": "46.18",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Deliveroo: D-202601-7772",
        "remittanceInformationUnstructuredArray": [
          "Payment to Deliveroo",
          "D-202601-7772"
        ],
        "debtorName": "Deliveroo"
      },
      "paymentId": null,
      "reference": "D-202601-7772",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmcfvhrjp16bczghe88",
      "clustering": {
        "description": "Deliveroo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Deliveroo' based on payment details",
        "updatedAt": "2026-01-14T11:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Deliveroo",
        "iban": null,
        "bic": null,
        "sortCode": "819839",
        "accountNumber": "70037709"
      }
    },
    {
      "id": "txn_c3g222r4hbjgtr71yv0d61tqsh",
      "createdAt": "2026-01-13T16:29:00.000Z",
      "updatedAt": "2026-01-13T16:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.91,
      "currency": "USD",
      "description": "Payment to Linear: L-202601-5397",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_m0jexb0b6xwnyrb627mx5h3qk2",
      "fspDate": "2026-01-13T15:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_m0jexb0b6xwnyrb627mx5h3qk2",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T16:29:00.000Z",
        "valueDateTime": "2026-01-13T16:29:00.000Z",
        "transactionAmount": {
          "amount": "9.91",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Linear: L-202601-5397",
        "remittanceInformationUnstructuredArray": [
          "Payment to Linear",
          "L-202601-5397"
        ],
        "debtorName": "Linear"
      },
      "paymentId": null,
      "reference": "L-202601-5397",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc1eshspj0mxd2vh6zx",
      "clustering": {
        "description": "Linear",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Linear' based on payment details",
        "updatedAt": "2026-01-13T16:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Linear",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_f4ewtkqynkpys6xp11rf7qjz3d",
      "createdAt": "2026-01-13T15:00:00.000Z",
      "updatedAt": "2026-01-13T15:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 0.01,
      "currency": "EUR",
      "description": "Payment to Emma Fitzgerald: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_158kmyf70rxnmpdx6p2z8tkng4",
      "fspDate": "2026-01-13T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0yd8drmencb0ddcqc1qfnr9",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T14:00:00.000Z",
        "valueDateTime": "2026-01-13T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-0.01",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Emma Fitzgerald: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Emma Fitzgerald: July 2025 Payroll"
        ],
        "debtorName": "Emma Fitzgerald"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtceshspj98ga0ebagk",
      "clustering": {
        "description": "Emma Fitzgerald",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Emma Fitzgerald' as the recipient name for the payroll transaction",
        "updatedAt": "2025-09-27T10:49:04.203Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vz2kwtgz03y81ts4qz83a6mrq8",
      "createdAt": "2026-01-13T14:47:00.000Z",
      "updatedAt": "2026-01-13T14:47:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 48.73,
      "currency": "GBP",
      "description": "Payment to ICO: I-202601-9362",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vaxvdha9taxx5eekhgf8k9yjj1",
      "fspDate": "2026-01-13T13:47:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vaxvdha9taxx5eekhgf8k9yjj1",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T14:47:00.000Z",
        "valueDateTime": "2026-01-13T14:47:00.000Z",
        "transactionAmount": {
          "amount": "48.73",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to ICO: I-202601-9362",
        "remittanceInformationUnstructuredArray": [
          "Payment to ICO",
          "I-202601-9362"
        ],
        "debtorName": "ICO"
      },
      "paymentId": null,
      "reference": "I-202601-9362",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4gyfvhrjnsxtfs19v9b",
      "clustering": {
        "description": "ICO",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'ICO' based on payment details",
        "updatedAt": "2026-01-13T14:47:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "ICO",
        "iban": null,
        "bic": null,
        "sortCode": "693673",
        "accountNumber": "70594207"
      }
    },
    {
      "id": "txn_h2f4nqb2jyh4x26z60bybjgrcb",
      "createdAt": "2026-01-13T14:44:00.000Z",
      "updatedAt": "2026-01-13T14:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.18,
      "currency": "USD",
      "description": "Payment to Reflect Software: RS-202601-3020",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_j1by4xzzec1bn0zw0jr467xwnn",
      "fspDate": "2026-01-13T13:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_j1by4xzzec1bn0zw0jr467xwnn",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T14:44:00.000Z",
        "valueDateTime": "2026-01-13T14:44:00.000Z",
        "transactionAmount": {
          "amount": "10.18",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Reflect Software: RS-202601-3020",
        "remittanceInformationUnstructuredArray": [
          "Payment to Reflect Software",
          "RS-202601-3020"
        ],
        "debtorName": "Reflect Software"
      },
      "paymentId": null,
      "reference": "RS-202601-3020",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wfmeshsphxg0s376ywm",
      "clustering": {
        "description": "Reflect Software",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Reflect Software' based on payment details",
        "updatedAt": "2026-01-13T14:44:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Reflect Software",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1hj8drdh0ngvv6fv9kfy45c6j7",
      "createdAt": "2026-01-13T14:12:00.000Z",
      "updatedAt": "2026-01-13T14:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 30208.21,
      "currency": "EUR",
      "description": "Payment from EuroTech Innovations - INV-202601-5017",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_tapha064aa90ffbtkqj3rky22h",
      "fspDate": "2026-01-13T13:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_tapha064aa90ffbtkqj3rky22h",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T14:12:00.000Z",
        "valueDateTime": "2026-01-13T14:12:00.000Z",
        "transactionAmount": {
          "amount": "30208.21",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from EuroTech Innovations - INV-202601-5017",
        "remittanceInformationUnstructuredArray": [
          "Payment from EuroTech Innovations",
          "INV-202601-5017"
        ],
        "creditorName": "EuroTech Innovations"
      },
      "paymentId": null,
      "reference": "INV-202601-5017",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m17gcz62vyhqqefr5q41a31k5f",
      "clustering": {
        "description": "EuroTech Innovations",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'EuroTech Innovations'",
        "updatedAt": "2026-01-13T14:12:00.000Z"
      },
      "payer": {
        "name": "EuroTech Innovations",
        "iban": "DE51575474320201160",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_frd204dxk9hpqxp3zyjznvw9sz",
      "createdAt": "2026-01-13T14:00:00.000Z",
      "updatedAt": "2026-01-13T14:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 8306.17,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_d110dq237a3hnf6841bjgs5ykj",
      "fspDate": "2026-01-13T13:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk835r86ww0wd",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T13:00:00.000Z",
        "valueDateTime": "2026-01-13T13:00:00.000Z",
        "transactionAmount": {
          "amount": "8306.17",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code and extracted 'Currency Exchange' as the description",
        "updatedAt": "2025-09-29T18:24:29.667Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1a1shnsxm3swps5v6ffkvm967g",
      "createdAt": "2026-01-13T12:00:00.000Z",
      "updatedAt": "2026-01-13T12:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1363.2,
      "currency": "EUR",
      "description": "Upwork -818427462ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_9rpykfgsbxc7f8pxfxj6y8aq98",
      "fspDate": "2026-01-13T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1m0dfpx3p0b",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T11:00:00.000Z",
        "valueDateTime": "2026-01-13T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-1363.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -818427462ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -818427462ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Upwork' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.262Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_t804z3nnq3ybxdregtkehyq1j1",
      "createdAt": "2026-01-13T11:06:00.000Z",
      "updatedAt": "2026-01-13T11:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 188.82,
      "currency": "GBP",
      "description": "Payment to Kiwi.com: K-202601-4872",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mpxamh0c07hc4m311f0b58whde",
      "fspDate": "2026-01-13T10:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mpxamh0c07hc4m311f0b58whde",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T11:06:00.000Z",
        "valueDateTime": "2026-01-13T11:06:00.000Z",
        "transactionAmount": {
          "amount": "188.82",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kiwi.com: K-202601-4872",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kiwi.com",
          "K-202601-4872"
        ],
        "debtorName": "Kiwi.com"
      },
      "paymentId": null,
      "reference": "K-202601-4872",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9q1fvhrjp371wrcstvr",
      "clustering": {
        "description": "Kiwi.com",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kiwi.com' based on payment details",
        "updatedAt": "2026-01-13T11:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kiwi.com",
        "iban": null,
        "bic": null,
        "sortCode": "594841",
        "accountNumber": "24702299"
      }
    },
    {
      "id": "txn_xzrcfn4prm1w0t5q223qwaa2cj",
      "createdAt": "2026-01-13T10:00:00.000Z",
      "updatedAt": "2026-01-13T10:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3000,
      "currency": "GBP",
      "description": "To Grow Your Boat Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_qyvdtqqm3hgj7p32j9yc38dgpx",
      "fspDate": "2026-01-13T09:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hpe8pvk81t1jr8g8j5",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T09:00:00.000Z",
        "valueDateTime": "2026-01-13T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Grow Your Boat Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Grow Your Boat Ltd"
        ],
        "debtorName": "Grow Your Boat Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "clustering": {
        "description": "Grow Your Boat Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Grow Your Boat Ltd' from 'To Grow Your Boat Ltd'",
        "updatedAt": "2025-09-29T18:24:29.644Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gm1y4bq6xdqad92ypx2bth7ftj",
      "createdAt": "2026-01-13T10:00:00.000Z",
      "updatedAt": "2026-01-13T10:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 2377.26,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_d14f7cq3pr467j6q34bd2mbkrk",
      "fspDate": "2026-01-13T09:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2feknczfk7s42a875c4bpkj",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T09:00:00.000Z",
        "valueDateTime": "2026-01-13T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-2377.26",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the core description for a currency conversion transaction, based on the 'EXCHANGE' code",
        "updatedAt": "2025-09-27T10:42:40.403Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2yzw4w6tekpysa52v9b3xywa1p",
      "createdAt": "2026-01-13T09:00:00.000Z",
      "updatedAt": "2026-01-13T09:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 0.01,
      "currency": "GBP",
      "description": "To Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_5a0g4dyganz9vyw1c4y7qe5wfb",
      "fspDate": "2026-01-13T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8edd30dbfjx",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T08:00:00.000Z",
        "valueDateTime": "2026-01-13T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-0.01",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance UK Ltd"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Seapoint Finance UK Ltd' from 'To Seapoint Finance UK Ltd'",
        "updatedAt": "2025-09-29T18:25:48.643Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_g7t5tm5avhfcfez9sa3ydamg1c",
      "createdAt": "2026-01-13T08:00:00.000Z",
      "updatedAt": "2026-01-13T08:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29493.56,
      "currency": "EUR",
      "description": "To Revenue Commissioners",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_cjt2706xvykb3saxkx9ssvjrcf",
      "fspDate": "2026-01-13T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1acxckktbbc",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T07:00:00.000Z",
        "valueDateTime": "2026-01-13T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-29493.56",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Revenue Commissioners",
        "remittanceInformationUnstructuredArray": [
          "To Revenue Commissioners"
        ],
        "debtorName": "REVENUE COMMISSION"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g53eshsphprhxzbraqp",
      "clustering": {
        "description": "Revenue Commissioners",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Revenue Commissioners' from 'To Revenue Commissioners'",
        "updatedAt": "2025-09-27T10:52:10.107Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ey1ejhnpj33fw9mzy9yxbqdx78",
      "createdAt": "2026-01-12T16:58:00.000Z",
      "updatedAt": "2026-01-12T16:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 19.75,
      "currency": "USD",
      "description": "Payment to Claude.ai: C-202601-7635",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bmktfkkjn7rae56e2w69thwft0",
      "fspDate": "2026-01-12T15:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bmktfkkjn7rae56e2w69thwft0",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T16:58:00.000Z",
        "valueDateTime": "2026-01-12T16:58:00.000Z",
        "transactionAmount": {
          "amount": "19.75",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Claude.ai: C-202601-7635",
        "remittanceInformationUnstructuredArray": [
          "Payment to Claude.ai",
          "C-202601-7635"
        ],
        "debtorName": "Claude.ai"
      },
      "paymentId": null,
      "reference": "C-202601-7635",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5j1eshspjz017vq1wgn",
      "clustering": {
        "description": "Claude.ai",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Claude.ai' based on payment details",
        "updatedAt": "2026-01-12T16:58:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Claude.ai",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_c6919mr4skhq1tb1ka1xs33fzf",
      "createdAt": "2026-01-12T16:45:00.000Z",
      "updatedAt": "2026-01-12T16:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 38.93,
      "currency": "EUR",
      "description": "Payment to Delhi2Dublin: D-202601-3621",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9dvhbggjp3pvgp4f49kazjwdrb",
      "fspDate": "2026-01-12T15:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9dvhbggjp3pvgp4f49kazjwdrb",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T16:45:00.000Z",
        "valueDateTime": "2026-01-12T16:45:00.000Z",
        "transactionAmount": {
          "amount": "38.93",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Delhi2Dublin: D-202601-3621",
        "remittanceInformationUnstructuredArray": [
          "Payment to Delhi2Dublin",
          "D-202601-3621"
        ],
        "debtorName": "Delhi2Dublin"
      },
      "paymentId": null,
      "reference": "D-202601-3621",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0x5eshspjwbxzrhs5dn",
      "clustering": {
        "description": "Delhi2Dublin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Delhi2Dublin' based on payment details",
        "updatedAt": "2026-01-12T16:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Delhi2Dublin",
        "iban": "DE87294399909654670",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xhb8sd5bnccpm7013npp068wxw",
      "createdAt": "2026-01-12T16:13:00.000Z",
      "updatedAt": "2026-01-12T16:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 31.54,
      "currency": "GBP",
      "description": "Payment to Argos: A-202601-7359",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zmsgvny6b29jnmysdfjp068jfx",
      "fspDate": "2026-01-12T15:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zmsgvny6b29jnmysdfjp068jfx",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T16:13:00.000Z",
        "valueDateTime": "2026-01-12T16:13:00.000Z",
        "transactionAmount": {
          "amount": "31.54",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Argos: A-202601-7359",
        "remittanceInformationUnstructuredArray": [
          "Payment to Argos",
          "A-202601-7359"
        ],
        "debtorName": "Argos"
      },
      "paymentId": null,
      "reference": "A-202601-7359",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgp9fvhrjp1ker17rwy0",
      "clustering": {
        "description": "Argos",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Argos' based on payment details",
        "updatedAt": "2026-01-12T16:13:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Argos",
        "iban": null,
        "bic": null,
        "sortCode": "623753",
        "accountNumber": "88125532"
      }
    },
    {
      "id": "txn_37g2b4pwe8wqs9m9mwtyyz6et4",
      "createdAt": "2026-01-12T14:43:00.000Z",
      "updatedAt": "2026-01-12T14:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 41961.56,
      "currency": "GBP",
      "description": "Payment from Global Solutions Ltd - INV-202601-6619",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4bghr4rpmx4eazn6ftq2b6k5gx",
      "fspDate": "2026-01-12T13:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4bghr4rpmx4eazn6ftq2b6k5gx",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T14:43:00.000Z",
        "valueDateTime": "2026-01-12T14:43:00.000Z",
        "transactionAmount": {
          "amount": "41961.56",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Global Solutions Ltd - INV-202601-6619",
        "remittanceInformationUnstructuredArray": [
          "Payment from Global Solutions Ltd",
          "INV-202601-6619"
        ],
        "creditorName": "Global Solutions Ltd"
      },
      "paymentId": null,
      "reference": "INV-202601-6619",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_th3hfveyjxh2erds1n633s02yd",
      "clustering": {
        "description": "Global Solutions Ltd",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Global Solutions Ltd'",
        "updatedAt": "2026-01-12T14:43:00.000Z"
      },
      "payer": {
        "name": "Global Solutions Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "462878",
        "accountNumber": "40994643"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_dzyva5jckrk0xh4m27b82jj1pj",
      "createdAt": "2026-01-12T13:43:00.000Z",
      "updatedAt": "2026-01-12T13:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 44.12,
      "currency": "GBP",
      "description": "Payment to Captain Nemo: CN-202601-1293",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_knnjdp00xtsgse7d3nc3e1s12w",
      "fspDate": "2026-01-12T12:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_knnjdp00xtsgse7d3nc3e1s12w",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T13:43:00.000Z",
        "valueDateTime": "2026-01-12T13:43:00.000Z",
        "transactionAmount": {
          "amount": "44.12",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Captain Nemo: CN-202601-1293",
        "remittanceInformationUnstructuredArray": [
          "Payment to Captain Nemo",
          "CN-202601-1293"
        ],
        "debtorName": "Captain Nemo"
      },
      "paymentId": null,
      "reference": "CN-202601-1293",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fm8nzsfzz9aen1pftqn9qr",
      "clustering": {
        "description": "Captain Nemo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Captain Nemo' based on payment details",
        "updatedAt": "2026-01-12T13:43:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Captain Nemo",
        "iban": null,
        "bic": null,
        "sortCode": "947440",
        "accountNumber": "29979845"
      }
    },
    {
      "id": "txn_xpyk2nza6dsazhwkv76vkfdy86",
      "createdAt": "2026-01-12T13:10:00.000Z",
      "updatedAt": "2026-01-12T13:10:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 840.93,
      "currency": "USD",
      "description": "Payment to GitHub, Inc.: GI-202601-6355",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_phz7905mj7md2yfsxvk1vw3p62",
      "fspDate": "2026-01-12T12:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_phz7905mj7md2yfsxvk1vw3p62",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T13:10:00.000Z",
        "valueDateTime": "2026-01-12T13:10:00.000Z",
        "transactionAmount": {
          "amount": "840.93",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GitHub, Inc.: GI-202601-6355",
        "remittanceInformationUnstructuredArray": [
          "Payment to GitHub, Inc.",
          "GI-202601-6355"
        ],
        "debtorName": "GitHub, Inc."
      },
      "paymentId": null,
      "reference": "GI-202601-6355",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_xj643cpp5p1awyrrqgqpf67q4d",
      "clustering": {
        "description": "GitHub, Inc.",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'GitHub, Inc.' based on payment details",
        "updatedAt": "2026-01-12T13:10:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GitHub, Inc.",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gdd4bb1x228mvtvt6cvxca76wa",
      "createdAt": "2026-01-12T13:00:00.000Z",
      "updatedAt": "2026-01-12T13:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 132.03,
      "currency": "EUR",
      "description": "Payment to Slack: S-202601-4151",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_y6zvcay9e5epd4kw67cbanwfec",
      "fspDate": "2026-01-12T12:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_y6zvcay9e5epd4kw67cbanwfec",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T13:00:00.000Z",
        "valueDateTime": "2026-01-12T13:00:00.000Z",
        "transactionAmount": {
          "amount": "132.03",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack: S-202601-4151",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack",
          "S-202601-4151"
        ],
        "debtorName": "Slack"
      },
      "paymentId": null,
      "reference": "S-202601-4151",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtb9eshspk6e4wt4npvh",
      "clustering": {
        "description": "Slack",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack' based on payment details",
        "updatedAt": "2026-01-12T13:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack",
        "iban": "DE64529008550277080",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_16xtc30zmdrsrwcpcp6x3s06b8",
      "createdAt": "2026-01-12T11:15:00.000Z",
      "updatedAt": "2026-01-12T11:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2012.49,
      "currency": "EUR",
      "description": "Payment to Patrick Walsh: PW-202601-7879",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_cb5t8whgtb4nv84kkxd9xgaqkg",
      "fspDate": "2026-01-12T10:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_cb5t8whgtb4nv84kkxd9xgaqkg",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T11:15:00.000Z",
        "valueDateTime": "2026-01-12T11:15:00.000Z",
        "transactionAmount": {
          "amount": "2012.49",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Patrick Walsh: PW-202601-7879",
        "remittanceInformationUnstructuredArray": [
          "Payment to Patrick Walsh",
          "PW-202601-7879"
        ],
        "debtorName": "Patrick Walsh"
      },
      "paymentId": null,
      "reference": "PW-202601-7879",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqmzweshspm8kq27v8562",
      "clustering": {
        "description": "Patrick Walsh",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Patrick Walsh' based on payment details",
        "updatedAt": "2026-01-12T11:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Patrick Walsh",
        "iban": "DE51159364617606776",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nkw63yhkq161wjwgzrbnpn24pb",
      "createdAt": "2026-01-12T10:01:00.000Z",
      "updatedAt": "2026-01-12T10:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 147.66,
      "currency": "USD",
      "description": "Payment to Anthropic: A-202601-9140",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w5qt4hcm68v9d9g0qtrzh42pzf",
      "fspDate": "2026-01-12T09:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w5qt4hcm68v9d9g0qtrzh42pzf",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T10:01:00.000Z",
        "valueDateTime": "2026-01-12T10:01:00.000Z",
        "transactionAmount": {
          "amount": "147.66",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic: A-202601-9140",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic",
          "A-202601-9140"
        ],
        "debtorName": "Anthropic"
      },
      "paymentId": null,
      "reference": "A-202601-9140",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0y2eshspjwh0d2fxb76",
      "clustering": {
        "description": "Anthropic",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic' based on payment details",
        "updatedAt": "2026-01-12T10:01:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_r522qkmc4m6j6xqpqmej8aet93",
      "createdAt": "2026-01-12T09:29:00.000Z",
      "updatedAt": "2026-01-12T09:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2022.08,
      "currency": "EUR",
      "description": "Payment to Sophie Laurent: SL-202601-1467",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_x5dqvhbhcdzks3th034mbkq2h9",
      "fspDate": "2026-01-12T08:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_x5dqvhbhcdzks3th034mbkq2h9",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T09:29:00.000Z",
        "valueDateTime": "2026-01-12T09:29:00.000Z",
        "transactionAmount": {
          "amount": "2022.08",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sophie Laurent: SL-202601-1467",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sophie Laurent",
          "SL-202601-1467"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": "SL-202601-1467",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc5eshspj0rxb4j151x",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sophie Laurent' based on payment details",
        "updatedAt": "2026-01-12T09:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sophie Laurent",
        "iban": "DE78297425964725570",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_91dry2jmm359a0mx22nxv6fmm3",
      "createdAt": "2026-01-12T08:00:00.000Z",
      "updatedAt": "2026-01-12T08:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 24.4,
      "currency": "EUR",
      "description": "Sumup *taxi Mffmppv7",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_603dyx6nzjzrgmwh8vn15d6t8s",
      "fspDate": "2026-01-12T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0veybwvjzt1",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T07:00:00.000Z",
        "valueDateTime": "2026-01-12T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-24.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *taxi Mffmppv7",
        "remittanceInformationUnstructuredArray": [
          "Sumup *taxi Mffmppv7"
        ],
        "debtorName": "Taxi Service"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqn02eshspm8y4jy7tt7k",
      "clustering": {
        "description": "Taxi Service",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Taxi Service' from 'Sumup *taxi Mffmppv7'",
        "updatedAt": "2025-09-27T10:50:08.438Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yc170cyvgkbbhgay6ppew8616d",
      "createdAt": "2026-01-11T16:41:00.000Z",
      "updatedAt": "2026-01-11T16:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12.4,
      "currency": "EUR",
      "description": "Payment to Mama's Boy: MB-202601-2451",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xgvgew2anqw9c7fsj6x52ry5r9",
      "fspDate": "2026-01-11T15:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xgvgew2anqw9c7fsj6x52ry5r9",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T16:41:00.000Z",
        "valueDateTime": "2026-01-11T16:41:00.000Z",
        "transactionAmount": {
          "amount": "12.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mama's Boy: MB-202601-2451",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mama's Boy",
          "MB-202601-2451"
        ],
        "debtorName": "Mama's Boy"
      },
      "paymentId": null,
      "reference": "MB-202601-2451",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcneshspna4jnfvyh0c",
      "clustering": {
        "description": "Mama's Boy",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mama's Boy' based on payment details",
        "updatedAt": "2026-01-11T16:41:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mama's Boy",
        "iban": "DE76101440631987470",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_m4dcj5c2qyp8kcdeyrpnq01ayg",
      "createdAt": "2026-01-11T15:36:00.000Z",
      "updatedAt": "2026-01-11T15:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 37163.14,
      "currency": "EUR",
      "description": "Payment from Nordic Digital AB - INV-202601-9017",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jrrekxdxmapxg9yymx6p9410mv",
      "fspDate": "2026-01-11T14:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jrrekxdxmapxg9yymx6p9410mv",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T15:36:00.000Z",
        "valueDateTime": "2026-01-11T15:36:00.000Z",
        "transactionAmount": {
          "amount": "37163.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nordic Digital AB - INV-202601-9017",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nordic Digital AB",
          "INV-202601-9017"
        ],
        "creditorName": "Nordic Digital AB"
      },
      "paymentId": null,
      "reference": "INV-202601-9017",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_q7sgetg8gwgf23ac9gdqmk8cz4",
      "clustering": {
        "description": "Nordic Digital AB",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nordic Digital AB'",
        "updatedAt": "2026-01-11T15:36:00.000Z"
      },
      "payer": {
        "name": "Nordic Digital AB",
        "iban": "DE22755341079698960",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vzyv41nm2b1shqtzkd72hg31h5",
      "createdAt": "2026-01-11T15:17:00.000Z",
      "updatedAt": "2026-01-11T15:17:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.32,
      "currency": "EUR",
      "description": "Payment to Suhas Falafel: SF-202601-9804",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vrzshr0cstbqat77pt51whaqyr",
      "fspDate": "2026-01-11T14:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vrzshr0cstbqat77pt51whaqyr",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T15:17:00.000Z",
        "valueDateTime": "2026-01-11T15:17:00.000Z",
        "transactionAmount": {
          "amount": "14.32",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Suhas Falafel: SF-202601-9804",
        "remittanceInformationUnstructuredArray": [
          "Payment to Suhas Falafel",
          "SF-202601-9804"
        ],
        "debtorName": "Suhas Falafel"
      },
      "paymentId": null,
      "reference": "SF-202601-9804",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmadbeshspkkgwerj0myb",
      "clustering": {
        "description": "Suhas Falafel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Suhas Falafel' based on payment details",
        "updatedAt": "2026-01-11T15:17:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Suhas Falafel",
        "iban": "DE26469135868758304",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4av43qp4ekdkc165pfvyj0mje3",
      "createdAt": "2026-01-11T14:48:00.000Z",
      "updatedAt": "2026-01-11T14:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2630.46,
      "currency": "EUR",
      "description": "Payment to Marta Kowalska Consulting: MKC-202601-7913",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_enjs2gd61qcrtc9n0hn168h5wa",
      "fspDate": "2026-01-11T13:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_enjs2gd61qcrtc9n0hn168h5wa",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T14:48:00.000Z",
        "valueDateTime": "2026-01-11T14:48:00.000Z",
        "transactionAmount": {
          "amount": "2630.46",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marta Kowalska Consulting: MKC-202601-7913",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marta Kowalska Consulting",
          "MKC-202601-7913"
        ],
        "debtorName": "Marta Kowalska Consulting"
      },
      "paymentId": null,
      "reference": "MKC-202601-7913",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj39eshspnh92mjbyz8s",
      "clustering": {
        "description": "Marta Kowalska Consulting",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marta Kowalska Consulting' based on payment details",
        "updatedAt": "2026-01-11T14:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marta Kowalska Consulting",
        "iban": "DE54829200985489600",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yz4jzx8a689tzxn63np5gx0ban",
      "createdAt": "2026-01-11T13:05:00.000Z",
      "updatedAt": "2026-01-11T13:05:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 30827.13,
      "currency": "GBP",
      "description": "Payment from Innovation Partners - INV-202601-8854",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hf5z4atdvqbv60v6yc6fcchrtr",
      "fspDate": "2026-01-11T12:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hf5z4atdvqbv60v6yc6fcchrtr",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T13:05:00.000Z",
        "valueDateTime": "2026-01-11T13:05:00.000Z",
        "transactionAmount": {
          "amount": "30827.13",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Innovation Partners - INV-202601-8854",
        "remittanceInformationUnstructuredArray": [
          "Payment from Innovation Partners",
          "INV-202601-8854"
        ],
        "creditorName": "Innovation Partners"
      },
      "paymentId": null,
      "reference": "INV-202601-8854",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m4xtykg61y9kjq9cjdr8bewyz0",
      "clustering": {
        "description": "Innovation Partners",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Innovation Partners'",
        "updatedAt": "2026-01-11T13:05:00.000Z"
      },
      "payer": {
        "name": "Innovation Partners",
        "iban": null,
        "bic": null,
        "sortCode": "642845",
        "accountNumber": "27950099"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_sh6w6dssnejfmq3mkmr1rr920h",
      "createdAt": "2026-01-11T12:39:00.000Z",
      "updatedAt": "2026-01-11T12:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 32.8,
      "currency": "EUR",
      "description": "Payment to Veremark: V-202601-1064",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2pf955xdravyhva6b7gd6hsce4",
      "fspDate": "2026-01-11T11:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2pf955xdravyhva6b7gd6hsce4",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T12:39:00.000Z",
        "valueDateTime": "2026-01-11T12:39:00.000Z",
        "transactionAmount": {
          "amount": "32.80",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Veremark: V-202601-1064",
        "remittanceInformationUnstructuredArray": [
          "Payment to Veremark",
          "V-202601-1064"
        ],
        "debtorName": "Veremark"
      },
      "paymentId": null,
      "reference": "V-202601-1064",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwc3eshspn9n53st1zft",
      "clustering": {
        "description": "Veremark",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Veremark' based on payment details",
        "updatedAt": "2026-01-11T12:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Veremark",
        "iban": "DE80287253265701340",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xqx63tw29572ye5mc4gcmfepzt",
      "createdAt": "2026-01-11T12:04:00.000Z",
      "updatedAt": "2026-01-11T12:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 42600.14,
      "currency": "EUR",
      "description": "Payment from Nexus Consulting GmbH - INV-202601-1482",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_q5bcg7t5jjh2hhgv0z4917yyak",
      "fspDate": "2026-01-11T11:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_q5bcg7t5jjh2hhgv0z4917yyak",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T12:04:00.000Z",
        "valueDateTime": "2026-01-11T12:04:00.000Z",
        "transactionAmount": {
          "amount": "42600.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nexus Consulting GmbH - INV-202601-1482",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nexus Consulting GmbH",
          "INV-202601-1482"
        ],
        "creditorName": "Nexus Consulting GmbH"
      },
      "paymentId": null,
      "reference": "INV-202601-1482",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_631832eta7hj1n2x0gedv5fm59",
      "clustering": {
        "description": "Nexus Consulting GmbH",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nexus Consulting GmbH'",
        "updatedAt": "2026-01-11T12:04:00.000Z"
      },
      "payer": {
        "name": "Nexus Consulting GmbH",
        "iban": "DE45196343071462650",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nkxqhjcvbhjwr3mpsqe00984pj",
      "createdAt": "2026-01-11T11:00:00.000Z",
      "updatedAt": "2026-01-11T11:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.42,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_t572035wjafe19mr92q8z0hd1f",
      "fspDate": "2026-01-11T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0qa4c08b8am",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T10:00:00.000Z",
        "valueDateTime": "2026-01-11T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-17.42",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cursor' from 'Cursor, Ai Powered Ide'",
        "updatedAt": "2025-09-27T10:50:08.301Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_sad60erspb1rx4q4r69y0kc5th",
      "createdAt": "2026-01-11T09:00:00.000Z",
      "updatedAt": "2026-01-11T09:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 37.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_cgdk97h833xmzb17981cc2e3vc",
      "fspDate": "2026-01-11T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2empapqfk7s2z0y7vg5s004",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T08:00:00.000Z",
        "valueDateTime": "2026-01-11T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-37.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:42:40.408Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8pjdz28qwzbwf72f9gktajzd7v",
      "createdAt": "2026-01-11T08:00:00.000Z",
      "updatedAt": "2026-01-11T08:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 9454,
      "currency": "GBP",
      "description": "SEAPOINT FINANCE  LIMITED. From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_p3ry1nybvjd6ncjqdw2xczgvv2",
      "fspDate": "2026-01-11T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k35t8vmbe8prf0pfa3d8n1fy",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T07:00:00.000Z",
        "valueDateTime": "2026-01-11T07:00:00.000Z",
        "transactionAmount": {
          "amount": "9454.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
        "remittanceInformationUnstructuredArray": [
          "From SEAPOINT FINANCE UK INVESTMENTS LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK Investments",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance UK Investments' from 'From SEAPOINT FINANCE UK INVESTMENTS LIMITED', removing 'From ' prefix and 'LIMITED' suffix",
        "updatedAt": "2025-09-29T18:23:50.845Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wbe33xtfq9vpzmr4rj7s139s83",
      "createdAt": "2026-01-10T17:00:00.000Z",
      "updatedAt": "2026-01-10T17:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 11950.69,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_3dgq8hhrs0ak8wdd9cdhsebff5",
      "fspDate": "2026-01-10T16:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk86kdc8vydtf",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T16:00:00.000Z",
        "valueDateTime": "2026-01-10T16:00:00.000Z",
        "transactionAmount": {
          "amount": "11950.69",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.129Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xw5314weakr6h8spzmnd5xfr7f",
      "createdAt": "2026-01-10T16:48:00.000Z",
      "updatedAt": "2026-01-10T16:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 23.16,
      "currency": "EUR",
      "description": "Payment to Muhammad Tashf: MT-202601-4215",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jkaa79wkmwnqwj37w382x6s8sp",
      "fspDate": "2026-01-10T15:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jkaa79wkmwnqwj37w382x6s8sp",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T16:48:00.000Z",
        "valueDateTime": "2026-01-10T16:48:00.000Z",
        "transactionAmount": {
          "amount": "23.16",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Muhammad Tashf: MT-202601-4215",
        "remittanceInformationUnstructuredArray": [
          "Payment to Muhammad Tashf",
          "MT-202601-4215"
        ],
        "debtorName": "Muhammad Tashf"
      },
      "paymentId": null,
      "reference": "MT-202601-4215",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkgjeshspnx4pqb9b6ze",
      "clustering": {
        "description": "Muhammad Tashf",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Muhammad Tashf' based on payment details",
        "updatedAt": "2026-01-10T16:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Muhammad Tashf",
        "iban": "DE27823265340394990",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7ya0sjcffrky23fybkfs1nx70p",
      "createdAt": "2026-01-10T16:00:00.000Z",
      "updatedAt": "2026-01-10T16:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 84.02,
      "currency": "EUR",
      "description": "Paddle.net* Open Excha",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_34h76fkyvr9w8b171h61e8ds5h",
      "fspDate": "2026-01-10T15:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0rjbcknfq9r7n2ywvw2mmy8",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T15:00:00.000Z",
        "valueDateTime": "2026-01-10T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-84.02",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Paddle.net* Open Excha",
        "remittanceInformationUnstructuredArray": [
          "Paddle.net* Open Excha"
        ],
        "debtorName": "Paddle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax3veshspjmhphswafsq",
      "clustering": {
        "description": "Paddle",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Paddle' from 'Paddle.net* Open Excha', removing the .net* Open Excha suffix",
        "updatedAt": "2025-09-27T10:49:04.325Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jjwt0kpz59g92m7xgc37ap6jc8",
      "createdAt": "2026-01-10T16:00:00.000Z",
      "updatedAt": "2026-01-10T16:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4250,
      "currency": "GBP",
      "description": "Payment to Amazon Web Services EMEA SARL: AWS-2025-847291",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_5grc5v4k7q5cmag3th0x3fz1sv",
      "fspDate": "2026-01-10T15:00:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_h71yz3x4mp2j0rhmd0jjrgq2px",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T15:00:00.000Z",
        "valueDateTime": "2026-01-10T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-4250.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amazon Web Services EMEA SARL: AWS-2025-847291",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amazon Web Services EMEA SARL: AWS-2025-847291"
        ],
        "debtorName": "Amazon Web Services EMEA SARL"
      },
      "paymentId": null,
      "reference": "AWS-2025-847291",
      "beneficiaryId": "benf_vy5tcadsq8hq6zp05dzeh2tatq",
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_zj7v3fq41pb9h3pwx6cbzwmfx4",
      "clustering": {
        "description": "Amazon Web Services EMEA SARL",
        "confidenceScore": "0.95",
        "rationale": "Identified as payment to Amazon Web Services EMEA SARL based on remittance information.",
        "updatedAt": "2025-12-15T10:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amazon Web Services EMEA SARL",
        "iban": "LU280000123456789012",
        "bic": "CITILULX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jzswfgpk85rqycdba9ken2h6cz",
      "createdAt": "2026-01-10T16:00:00.000Z",
      "updatedAt": "2026-01-10T16:00:00.000Z",
      "status": "BOOKED",
      "type": "OTHER",
      "isCredit": false,
      "amount": 60,
      "currency": "EUR",
      "description": "Expenses app charges",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_mntx999rr3ss52b831h1b62v0q",
      "fspDate": "2026-01-10T15:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1eg6yhm4jmf",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T15:00:00.000Z",
        "valueDateTime": "2026-01-10T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-60.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "OTHER",
        "remittanceInformationUnstructured": "Expenses app charges",
        "remittanceInformationUnstructuredArray": [
          "Expenses app charges"
        ],
        "debtorName": "Expenses App"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mw3eshspjaesn0nt38r",
      "clustering": {
        "description": "Expenses App",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Expenses App' from 'Expenses app charges'.",
        "updatedAt": "2025-09-27T10:52:47.463Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_93pp58800brhzkbwc0eqv3rpja",
      "createdAt": "2026-01-10T14:45:00.000Z",
      "updatedAt": "2026-01-10T14:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.99,
      "currency": "EUR",
      "description": "Payment to An Post: AP-202601-4667",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_j1bnqtcybz0b5v25tevkg9dyh2",
      "fspDate": "2026-01-10T13:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_j1bnqtcybz0b5v25tevkg9dyh2",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T14:45:00.000Z",
        "valueDateTime": "2026-01-10T14:45:00.000Z",
        "transactionAmount": {
          "amount": "3.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to An Post: AP-202601-4667",
        "remittanceInformationUnstructuredArray": [
          "Payment to An Post",
          "AP-202601-4667"
        ],
        "debtorName": "An Post"
      },
      "paymentId": null,
      "reference": "AP-202601-4667",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwdneshspna9pr7b1tc2",
      "clustering": {
        "description": "An Post",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'An Post' based on payment details",
        "updatedAt": "2026-01-10T14:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "An Post",
        "iban": "DE48761795046897820",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_r3kqndpzs4kj3m4mmr793t07b8",
      "createdAt": "2026-01-10T14:10:00.000Z",
      "updatedAt": "2026-01-10T14:10:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.91,
      "currency": "USD",
      "description": "Payment to Figma: F-202601-5118",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_37fmfrq2gbt5v9tk44sdbkvej3",
      "fspDate": "2026-01-10T13:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_37fmfrq2gbt5v9tk44sdbkvej3",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T14:10:00.000Z",
        "valueDateTime": "2026-01-10T14:10:00.000Z",
        "transactionAmount": {
          "amount": "14.91",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Figma: F-202601-5118",
        "remittanceInformationUnstructuredArray": [
          "Payment to Figma",
          "F-202601-5118"
        ],
        "debtorName": "Figma"
      },
      "paymentId": null,
      "reference": "F-202601-5118",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdq3eshspk9qt2a4er00",
      "clustering": {
        "description": "Figma",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Figma' based on payment details",
        "updatedAt": "2026-01-10T14:10:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Figma",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_h4nzmytm4ckxt4ncdz4gb2w5xr",
      "createdAt": "2026-01-10T12:00:00.000Z",
      "updatedAt": "2026-01-10T12:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 125,
      "currency": "EUR",
      "description": "Company Ultimate plan fee",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_0k7rdmcg421hcrd2nyc5c0aytj",
      "fspDate": "2026-01-10T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xq4wv1fvqsn5xyw7t6f4t4",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T11:00:00.000Z",
        "valueDateTime": "2026-01-10T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-125.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Company Ultimate plan fee",
        "remittanceInformationUnstructuredArray": [
          "Company Ultimate plan fee"
        ],
        "debtorName": "Company"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mvseshspja4gsxz03at",
      "clustering": {
        "description": "Revolut Fees",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Revolut' as the institution name from 'Company Ultimate plan fee' and code: 'TRANSFER'",
        "updatedAt": "2025-09-27T10:49:04.226Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_g8dny6cb22kpr2sn1qk2hda4vk",
      "createdAt": "2026-01-10T08:00:00.000Z",
      "updatedAt": "2026-01-10T08:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_fsn8bx1s4zs73yf2wvcjeqvvb6",
      "fspDate": "2026-01-10T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k26xg786fk7s0pkvpqf8x0sx",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T07:00:00.000Z",
        "valueDateTime": "2026-01-10T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-5.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Companies Registration' from the transaction description, removing the 'Companies Registration Office' details.",
        "updatedAt": "2025-09-27T10:43:55.425Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xez5918wsa0avxvmm078p0m0e4",
      "createdAt": "2026-01-10T08:00:00.000Z",
      "updatedAt": "2026-01-10T08:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12000,
      "currency": "GBP",
      "description": "To Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_4w0nf9kwfw011jsfq7vbp4p9vk",
      "fspDate": "2026-01-10T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3wzvcvhe4btjfaq1nrqw1r1",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T07:00:00.000Z",
        "valueDateTime": "2026-01-10T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-12000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance UK Ltd"
        ],
        "debtorName": "Seapoint Finance UK Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance UK' from 'To Seapoint Finance UK Ltd', removing 'To ' prefix and 'Ltd' suffix",
        "updatedAt": "2025-09-29T18:23:50.771Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ksf0mwnt7tkqgaa5k7v7sabaed",
      "createdAt": "2026-01-10T08:00:00.000Z",
      "updatedAt": "2026-01-10T08:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.27,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_s64fjyq2fxx2ceg3fsjzs4dx0n",
      "fspDate": "2026-01-10T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3qv1xr7esm9bvxf06t72r20",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T07:00:00.000Z",
        "valueDateTime": "2026-01-10T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-17.27",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Cursor' from 'Cursor, Ai Powered Ide', removing any additional information.",
        "updatedAt": "2025-09-27T10:39:39.660Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9m71w7h64ten9w3g5q71xe4c1b",
      "createdAt": "2026-01-09T17:00:00.000Z",
      "updatedAt": "2026-01-09T17:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_c8j8w7f5vc7k76apg4p9hm3vzx",
      "fspDate": "2026-01-09T16:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3az28h4eh2t0hda6yth632y",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T16:00:00.000Z",
        "valueDateTime": "2026-01-09T16:00:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:40:26.905Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fyacrqydagf9dz2h78eac5r589",
      "createdAt": "2026-01-09T16:27:00.000Z",
      "updatedAt": "2026-01-09T16:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 51.02,
      "currency": "GBP",
      "description": "Payment to Pembroke Hall Limited: PHL-202601-6628",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5xx3bbfw3w0a2xygsa8tpc70j3",
      "fspDate": "2026-01-09T15:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5xx3bbfw3w0a2xygsa8tpc70j3",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T16:27:00.000Z",
        "valueDateTime": "2026-01-09T16:27:00.000Z",
        "transactionAmount": {
          "amount": "51.02",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pembroke Hall Limited: PHL-202601-6628",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pembroke Hall Limited",
          "PHL-202601-6628"
        ],
        "debtorName": "Pembroke Hall Limited"
      },
      "paymentId": null,
      "reference": "PHL-202601-6628",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fpgn1yfzz9aex3cr77xa32",
      "clustering": {
        "description": "Pembroke Hall Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pembroke Hall Limited' based on payment details",
        "updatedAt": "2026-01-09T16:27:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pembroke Hall Limited",
        "iban": null,
        "bic": null,
        "sortCode": "471791",
        "accountNumber": "49654627"
      }
    },
    {
      "id": "txn_7w76xjmywc4d4w77epjwdj0x9z",
      "createdAt": "2026-01-09T16:15:00.000Z",
      "updatedAt": "2026-01-09T16:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 23.95,
      "currency": "EUR",
      "description": "Payment to Mak Slim Foods: MSF-202601-2199",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9k9ge2036rj4m1y4x4t8am936v",
      "fspDate": "2026-01-09T15:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9k9ge2036rj4m1y4x4t8am936v",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T16:15:00.000Z",
        "valueDateTime": "2026-01-09T16:15:00.000Z",
        "transactionAmount": {
          "amount": "23.95",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mak Slim Foods: MSF-202601-2199",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mak Slim Foods",
          "MSF-202601-2199"
        ],
        "debtorName": "Mak Slim Foods"
      },
      "paymentId": null,
      "reference": "MSF-202601-2199",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2yeshspkgyzwx8hqrq",
      "clustering": {
        "description": "Mak Slim Foods",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mak Slim Foods' based on payment details",
        "updatedAt": "2026-01-09T16:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mak Slim Foods",
        "iban": "DE30750062661815464",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_e9p231ah2dytd2vdqqj71c7yxr",
      "createdAt": "2026-01-09T15:46:00.000Z",
      "updatedAt": "2026-01-09T15:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 31.24,
      "currency": "EUR",
      "description": "Payment to Sweet Salt: SS-202601-3646",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_baf5yxzmt16yb7958nr5qc3qpk",
      "fspDate": "2026-01-09T14:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_baf5yxzmt16yb7958nr5qc3qpk",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T15:46:00.000Z",
        "valueDateTime": "2026-01-09T15:46:00.000Z",
        "transactionAmount": {
          "amount": "31.24",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sweet Salt: SS-202601-3646",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sweet Salt",
          "SS-202601-3646"
        ],
        "debtorName": "Sweet Salt"
      },
      "paymentId": null,
      "reference": "SS-202601-3646",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmad4eshspkk8z9xs58fk",
      "clustering": {
        "description": "Sweet Salt",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sweet Salt' based on payment details",
        "updatedAt": "2026-01-09T15:46:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sweet Salt",
        "iban": "DE16201527976106560",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yjznkqz7z25z3cbfqnpkfnr6m4",
      "createdAt": "2026-01-09T15:39:00.000Z",
      "updatedAt": "2026-01-09T15:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3316.37,
      "currency": "GBP",
      "description": "Payment to Yapily: Y-202601-1230",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_db525ezvy35fdc6cayss93whra",
      "fspDate": "2026-01-09T14:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_db525ezvy35fdc6cayss93whra",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T15:39:00.000Z",
        "valueDateTime": "2026-01-09T15:39:00.000Z",
        "transactionAmount": {
          "amount": "3316.37",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Yapily: Y-202601-1230",
        "remittanceInformationUnstructuredArray": [
          "Payment to Yapily",
          "Y-202601-1230"
        ],
        "debtorName": "Yapily"
      },
      "paymentId": null,
      "reference": "Y-202601-1230",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf94qfvhrjn51jet0pt56",
      "clustering": {
        "description": "Yapily",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Yapily' based on payment details",
        "updatedAt": "2026-01-09T15:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Yapily",
        "iban": null,
        "bic": null,
        "sortCode": "824644",
        "accountNumber": "69137811"
      }
    },
    {
      "id": "txn_bbdbtfysc0wv05nsz76bs0ntmv",
      "createdAt": "2026-01-09T15:00:00.000Z",
      "updatedAt": "2026-01-09T15:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 1710.68,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_d6d87mxyn68swg5tf1qr8q2adw",
      "fspDate": "2026-01-09T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk87jf561kxj1",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T14:00:00.000Z",
        "valueDateTime": "2026-01-09T14:00:00.000Z",
        "transactionAmount": {
          "amount": "1710.68",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.145Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0b7d4tqft174x2g8yy1y522n49",
      "createdAt": "2026-01-09T14:22:00.000Z",
      "updatedAt": "2026-01-09T14:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 24.17,
      "currency": "EUR",
      "description": "Payment to Hotpot: H-202601-8206",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pzwkggaw0m2qgaqs231hd1qkm2",
      "fspDate": "2026-01-09T13:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pzwkggaw0m2qgaqs231hd1qkm2",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T14:22:00.000Z",
        "valueDateTime": "2026-01-09T14:22:00.000Z",
        "transactionAmount": {
          "amount": "24.17",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Hotpot: H-202601-8206",
        "remittanceInformationUnstructuredArray": [
          "Payment to Hotpot",
          "H-202601-8206"
        ],
        "debtorName": "Hotpot"
      },
      "paymentId": null,
      "reference": "H-202601-8206",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0wweshspkzqgyrcgqe7",
      "clustering": {
        "description": "Hotpot",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Hotpot' based on payment details",
        "updatedAt": "2026-01-09T14:22:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Hotpot",
        "iban": "DE63478246191551740",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5zs89vmw5fnm47p6ea300j5ydb",
      "createdAt": "2026-01-09T14:00:00.000Z",
      "updatedAt": "2026-01-09T14:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2000,
      "currency": "GBP",
      "description": "To Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_ks27sbeh975c5kmyhs8dt172yc",
      "fspDate": "2026-01-09T13:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk87d3f5a2t68",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T13:00:00.000Z",
        "valueDateTime": "2026-01-09T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-2000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance UK Ltd"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Seapoint Finance UK' from 'To Seapoint Finance UK Ltd'",
        "updatedAt": "2025-09-29T18:25:01.143Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pa9wckks2p1brx9efjfyeeh5bn",
      "createdAt": "2026-01-09T12:00:00.000Z",
      "updatedAt": "2026-01-09T12:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6003.2,
      "currency": "EUR",
      "description": "Payment to Luca Moretti: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_vz8h26x6r1hgr65x4p38rsd321",
      "fspDate": "2026-01-09T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k10kr2c9e4dr6r31av3hxs5q",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T11:00:00.000Z",
        "valueDateTime": "2026-01-09T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-6003.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Luca Moretti: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Luca Moretti: July 2025 Payroll"
        ],
        "debtorName": "Luca Moretti"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsbeshspj7jp8q6rygp",
      "clustering": {
        "description": "Luca Moretti",
        "confidenceScore": "0.95",
        "rationale": "Extracted employee name 'Luca Moretti' from 'Payment to Luca Moretti: July 2025 Payroll'",
        "updatedAt": "2025-09-27T10:48:02.788Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_avygs8am0eyh9w6c0x8a2a03vt",
      "createdAt": "2026-01-09T11:53:00.000Z",
      "updatedAt": "2026-01-09T11:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.87,
      "currency": "EUR",
      "description": "Payment to Tula Mexican Grill: TMG-202601-4826",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_84kt8sv3t8jzckf2yhspcrb8q9",
      "fspDate": "2026-01-09T10:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_84kt8sv3t8jzckf2yhspcrb8q9",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T11:53:00.000Z",
        "valueDateTime": "2026-01-09T11:53:00.000Z",
        "transactionAmount": {
          "amount": "25.87",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tula Mexican Grill: TMG-202601-4826",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tula Mexican Grill",
          "TMG-202601-4826"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": "TMG-202601-4826",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tula Mexican Grill' based on payment details",
        "updatedAt": "2026-01-09T11:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tula Mexican Grill",
        "iban": "DE27923460340260360",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_71mc35sh92jyj4x80nf0d3mryv",
      "createdAt": "2026-01-09T11:00:00.000Z",
      "updatedAt": "2026-01-09T11:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 519.9,
      "currency": "GBP",
      "description": "Payment to Slack Technologies Limited: SLK-UK-2026-0105",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_cg9mvz3yc9527ctyqb9kbd7c6f",
      "fspDate": "2026-01-09T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_e4p3vqn5k5pn95g9znmem1zxpm",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T10:00:00.000Z",
        "valueDateTime": "2026-01-09T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-519.90",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack Technologies Limited: SLK-UK-2026-0105",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack Technologies Limited: SLK-UK-2026-0105"
        ],
        "debtorName": "Slack Technologies Limited"
      },
      "paymentId": null,
      "reference": "SLK-UK-2026-0105",
      "beneficiaryId": "benf_423n0p675xecav56xpy6rxhv9m",
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_6m3t4s5pcz3g5997sxc586yj3f",
      "clustering": {
        "description": "Slack Technologies Limited",
        "confidenceScore": "0.95",
        "rationale": "Identified as payment to Slack Technologies Limited based on remittance information.",
        "updatedAt": "2026-01-10T10:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack Technologies Limited",
        "iban": null,
        "bic": null,
        "sortCode": "20-00-00",
        "accountNumber": "73849201"
      }
    },
    {
      "id": "txn_jzhzeexn4hr1a6t3txt7ky7pr1",
      "createdAt": "2026-01-09T10:00:00.000Z",
      "updatedAt": "2026-01-09T10:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 103.04,
      "currency": "EUR",
      "description": "Superhuman",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_7bn03tywk6px5zy844cvrke7bh",
      "fspDate": "2026-01-09T09:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2empapqfk7s2z16b9gexx1g",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T09:00:00.000Z",
        "valueDateTime": "2026-01-09T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-103.04",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Superhuman",
        "remittanceInformationUnstructuredArray": [
          "Superhuman"
        ],
        "debtorName": "Superhuman"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5mceshspjzn83y9tqy1",
      "clustering": {
        "description": "Superhuman",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Superhuman' from 'Superhuman'",
        "updatedAt": "2025-09-27T10:42:40.419Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_atpt8645wxdh11d53aa1bee4c8",
      "createdAt": "2026-01-09T08:00:00.000Z",
      "updatedAt": "2026-01-09T08:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 28,
      "currency": "EUR",
      "description": "Frn*hold.free-Now.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_1knkwpjtcpk57d9vfqbqjrygys",
      "fspDate": "2026-01-09T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1q2e5ysgnej",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T07:00:00.000Z",
        "valueDateTime": "2026-01-09T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-28.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Frn*hold.free-Now.com",
        "remittanceInformationUnstructuredArray": [
          "Frn*hold.free-Now.com"
        ],
        "debtorName": "Free Now"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj31eshspnh3qzqhcd5r",
      "clustering": {
        "description": "Free Now",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Free Now' from the raw transaction description, removing the 'Frn*hold.free-Now.com' prefix.",
        "updatedAt": "2025-09-27T10:53:55.673Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5v8p97xx8m0k40927z8ps3x09z",
      "createdAt": "2026-01-08T17:00:00.000Z",
      "updatedAt": "2026-01-08T17:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 8500,
      "currency": "GBP",
      "description": "Salary - Sarah Mitchell - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_3c4fncd5jwrgzrvbsfp552zxjx",
      "fspDate": "2026-01-08T16:00:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_t0mbgzgrv0xzz2ae7tnn09mt2v",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T16:00:00.000Z",
        "valueDateTime": "2026-01-08T16:00:00.000Z",
        "transactionAmount": {
          "amount": "-8500.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Sarah Mitchell",
        "remittanceInformationUnstructuredArray": [
          "Salary - Sarah Mitchell"
        ]
      },
      "paymentId": "pmnt_b1q1xwfrt9zw5y5hwvgy3qjk8g",
      "reference": "PAY-DEC-2025-MITCHELL",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sarah Mitchell",
        "iban": null,
        "bic": null,
        "sortCode": "20-00-00",
        "accountNumber": "12345601"
      }
    },
    {
      "id": "txn_fm70kfa1m2yrjpdk4h9aq8wa06",
      "createdAt": "2026-01-08T16:00:00.000Z",
      "updatedAt": "2026-01-08T16:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 23,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_72z3tygs0rt3ts3d6fnaamk5qe",
      "fspDate": "2026-01-08T15:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0zh3f8n73sg",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T15:00:00.000Z",
        "valueDateTime": "2026-01-08T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-23.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'OpenAI' from 'Openai *chatgpt Subscr', removing 'Openai *' prefix",
        "updatedAt": "2025-09-27T10:50:52.471Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1xw5e00nwvshv1jcmy63d6psbf",
      "createdAt": "2026-01-08T16:00:00.000Z",
      "updatedAt": "2026-01-08T16:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_gwz92wfbdy8rmeth23wp10qpet",
      "fspDate": "2026-01-08T15:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k12vyakpe4dr6y192n42sczm",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T15:00:00.000Z",
        "valueDateTime": "2026-01-08T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Burger Cartel' from 'Burger Cartel Limited'",
        "updatedAt": "2025-09-27T10:48:02.702Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2fz9f332r28w8bsycvh007917a",
      "createdAt": "2026-01-08T16:00:00.000Z",
      "updatedAt": "2026-01-08T16:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 135.99,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_xm3gymyff3pcw3d152qh2fw0g8",
      "fspDate": "2026-01-08T15:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1kygt9jrpst",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T15:00:00.000Z",
        "valueDateTime": "2026-01-08T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-135.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'OpenAI' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.217Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0bdyf1wj59bm65mm051bx8fkqg",
      "createdAt": "2026-01-08T15:21:00.000Z",
      "updatedAt": "2026-01-08T15:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7.02,
      "currency": "GBP",
      "description": "Payment to Pret A Manger: PAM-202601-1056",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ehkjmq4jze14hg37vxx4vfgjk8",
      "fspDate": "2026-01-08T14:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ehkjmq4jze14hg37vxx4vfgjk8",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T15:21:00.000Z",
        "valueDateTime": "2026-01-08T15:21:00.000Z",
        "transactionAmount": {
          "amount": "7.02",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pret A Manger: PAM-202601-1056",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pret A Manger",
          "PAM-202601-1056"
        ],
        "debtorName": "Pret A Manger"
      },
      "paymentId": null,
      "reference": "PAM-202601-1056",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crphqeshspmfftkxpt85b",
      "clustering": {
        "description": "Pret A Manger",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pret A Manger' based on payment details",
        "updatedAt": "2026-01-08T15:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pret A Manger",
        "iban": null,
        "bic": null,
        "sortCode": "633589",
        "accountNumber": "64026695"
      }
    },
    {
      "id": "txn_s7e7mkbrbn7t6t52hdd37e8xks",
      "createdAt": "2026-01-08T15:19:00.000Z",
      "updatedAt": "2026-01-08T15:19:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.19,
      "currency": "USD",
      "description": "Payment to Notion: N-202601-1938",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_c7ecwn3e3bpaqn3jf31y44ck3r",
      "fspDate": "2026-01-08T14:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_c7ecwn3e3bpaqn3jf31y44ck3r",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T15:19:00.000Z",
        "valueDateTime": "2026-01-08T15:19:00.000Z",
        "transactionAmount": {
          "amount": "10.19",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Notion: N-202601-1938",
        "remittanceInformationUnstructuredArray": [
          "Payment to Notion",
          "N-202601-1938"
        ],
        "debtorName": "Notion"
      },
      "paymentId": null,
      "reference": "N-202601-1938",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtcyeshspk6y0e76tesb",
      "clustering": {
        "description": "Notion",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Notion' based on payment details",
        "updatedAt": "2026-01-08T15:19:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Notion",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9b7hsx5j6mdmqj9ykhkv846m92",
      "createdAt": "2026-01-08T15:00:00.000Z",
      "updatedAt": "2026-01-08T15:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1506.71,
      "currency": "EUR",
      "description": "Upwork -824982385ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_m5p3g2dcbev4t7t0fyn2stwkwt",
      "fspDate": "2026-01-08T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0vsmrxy1x28",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T14:00:00.000Z",
        "valueDateTime": "2026-01-08T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-1506.71",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -824982385ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -824982385ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Upwork' from 'Upwork -824982385ref', removing '-824982385ref' suffix",
        "updatedAt": "2025-09-27T10:50:52.343Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bzz4bx6batc61gv5zqfcngbnxr",
      "createdAt": "2026-01-08T14:54:00.000Z",
      "updatedAt": "2026-01-08T14:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1.71,
      "currency": "GBP",
      "description": "Payment to Mylands: M-202601-9704",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_sgfypk363kny2km9z63szc0ey9",
      "fspDate": "2026-01-08T13:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_sgfypk363kny2km9z63szc0ey9",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T14:54:00.000Z",
        "valueDateTime": "2026-01-08T14:54:00.000Z",
        "transactionAmount": {
          "amount": "1.71",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mylands: M-202601-9704",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mylands",
          "M-202601-9704"
        ],
        "debtorName": "Mylands"
      },
      "paymentId": null,
      "reference": "M-202601-9704",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbnxzzfvhrjp5np8trhg47",
      "clustering": {
        "description": "Mylands",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mylands' based on payment details",
        "updatedAt": "2026-01-08T14:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mylands",
        "iban": null,
        "bic": null,
        "sortCode": "898284",
        "accountNumber": "48715894"
      }
    },
    {
      "id": "txn_13a42k867g83aadr3n89sk3xsd",
      "createdAt": "2026-01-08T14:02:00.000Z",
      "updatedAt": "2026-01-08T14:02:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.05,
      "currency": "USD",
      "description": "Payment to Google Play: GP-202601-1337",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_n2g2hpsf5bvamn3vxngf60b2hf",
      "fspDate": "2026-01-08T13:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_n2g2hpsf5bvamn3vxngf60b2hf",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T14:02:00.000Z",
        "valueDateTime": "2026-01-08T14:02:00.000Z",
        "transactionAmount": {
          "amount": "3.05",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Google Play: GP-202601-1337",
        "remittanceInformationUnstructuredArray": [
          "Payment to Google Play",
          "GP-202601-1337"
        ],
        "debtorName": "Google Play"
      },
      "paymentId": null,
      "reference": "GP-202601-1337",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wjeeshsphy7nnkfq48b",
      "clustering": {
        "description": "Google Play",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Google Play' based on payment details",
        "updatedAt": "2026-01-08T14:02:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Google Play",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_990zdc1qja4zhqeceyccg0zvm4",
      "createdAt": "2026-01-08T12:54:00.000Z",
      "updatedAt": "2026-01-08T12:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 270.39,
      "currency": "GBP",
      "description": "Payment to British Airways: BA-202601-9264",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_aqn8yp5ae0depgr44efzjw7ra7",
      "fspDate": "2026-01-08T11:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_aqn8yp5ae0depgr44efzjw7ra7",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T12:54:00.000Z",
        "valueDateTime": "2026-01-08T12:54:00.000Z",
        "transactionAmount": {
          "amount": "270.39",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to British Airways: BA-202601-9264",
        "remittanceInformationUnstructuredArray": [
          "Payment to British Airways",
          "BA-202601-9264"
        ],
        "debtorName": "British Airways"
      },
      "paymentId": null,
      "reference": "BA-202601-9264",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9m2fvhrjp2hhm5q9efq",
      "clustering": {
        "description": "British Airways",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'British Airways' based on payment details",
        "updatedAt": "2026-01-08T12:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "British Airways",
        "iban": null,
        "bic": null,
        "sortCode": "804057",
        "accountNumber": "88903570"
      }
    },
    {
      "id": "txn_891hham2mj44fyh2h7nnygfhpd",
      "createdAt": "2026-01-08T11:13:00.000Z",
      "updatedAt": "2026-01-08T11:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3566.82,
      "currency": "USD",
      "description": "Payment to OpenAI, LLC: OL-202601-6660",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zfv77xcgp9mwnqtwrd7xj4v2w0",
      "fspDate": "2026-01-08T10:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zfv77xcgp9mwnqtwrd7xj4v2w0",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T11:13:00.000Z",
        "valueDateTime": "2026-01-08T11:13:00.000Z",
        "transactionAmount": {
          "amount": "3566.82",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to OpenAI, LLC: OL-202601-6660",
        "remittanceInformationUnstructuredArray": [
          "Payment to OpenAI, LLC",
          "OL-202601-6660"
        ],
        "debtorName": "OpenAI, LLC"
      },
      "paymentId": null,
      "reference": "OL-202601-6660",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1bss5kk7dqrqznncrn6c0w8y4p",
      "clustering": {
        "description": "OpenAI, LLC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'OpenAI, LLC' based on payment details",
        "updatedAt": "2026-01-08T11:13:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "OpenAI, LLC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5xv459g9c91r3dtw5z43vtaqe3",
      "createdAt": "2026-01-08T10:00:00.000Z",
      "updatedAt": "2026-01-08T10:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "EUR",
      "description": "Google *temporary Hold",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_d6j6yx3z91ynqb1m5mfsba85p0",
      "fspDate": "2026-01-08T09:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0x0zqbws36m",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T09:00:00.000Z",
        "valueDateTime": "2026-01-08T09:00:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Google *temporary Hold",
        "remittanceInformationUnstructuredArray": [
          "Google *temporary Hold"
        ],
        "debtorName": "Google"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdrteshspka3qwhrnts0",
      "clustering": {
        "description": "Google",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Google' from 'Google *temporary Hold', removing 'Google *' prefix",
        "updatedAt": "2025-09-27T10:50:52.431Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fx0mvdtqj7b0t0bs4b8v0j3f96",
      "createdAt": "2026-01-08T08:00:00.000Z",
      "updatedAt": "2026-01-08T08:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 3.9,
      "currency": "GBP",
      "description": "Fcb Coffee Paddington",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_jf3dd7zwtsb4gx2hmc7x82zpx1",
      "fspDate": "2026-01-08T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8gqkjnnd0ft",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T07:00:00.000Z",
        "valueDateTime": "2026-01-08T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-3.90",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Fcb Coffee Paddington",
        "remittanceInformationUnstructuredArray": [
          "Fcb Coffee Paddington"
        ],
        "debtorName": "FCB Coffee"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmmfvhrjp1d532dm1jy",
      "clustering": {
        "description": "FCB Coffee",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'FCB Coffee' from 'Fcb Coffee Paddington'",
        "updatedAt": "2025-09-29T18:26:40.968Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_r35ast5b48avtek5x05j0nqfbh",
      "createdAt": "2026-01-07T15:40:00.000Z",
      "updatedAt": "2026-01-07T15:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 66260.65,
      "currency": "GBP",
      "description": "Payment from Enterprise Systems Inc - INV-202601-8845",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5xtmv15n2qg90vx4324yt6e1f2",
      "fspDate": "2026-01-07T14:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5xtmv15n2qg90vx4324yt6e1f2",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T15:40:00.000Z",
        "valueDateTime": "2026-01-07T15:40:00.000Z",
        "transactionAmount": {
          "amount": "66260.65",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Enterprise Systems Inc - INV-202601-8845",
        "remittanceInformationUnstructuredArray": [
          "Payment from Enterprise Systems Inc",
          "INV-202601-8845"
        ],
        "creditorName": "Enterprise Systems Inc"
      },
      "paymentId": null,
      "reference": "INV-202601-8845",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1jqt0xq8p3az0ed45aqq7npx6w",
      "clustering": {
        "description": "Enterprise Systems Inc",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Enterprise Systems Inc'",
        "updatedAt": "2026-01-07T15:40:00.000Z"
      },
      "payer": {
        "name": "Enterprise Systems Inc",
        "iban": null,
        "bic": null,
        "sortCode": "949320",
        "accountNumber": "36914944"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_111wrkzz1ejpn91916ykbepsxa",
      "createdAt": "2026-01-07T14:00:00.000Z",
      "updatedAt": "2026-01-07T14:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6585.5,
      "currency": "EUR",
      "description": "To Leonie Schaefer",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_bt16awrwjwx4987r0f9nedvqtn",
      "fspDate": "2026-01-07T13:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1d76k5ssyga",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T13:00:00.000Z",
        "valueDateTime": "2026-01-07T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-6585.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Leonie Schaefer",
        "remittanceInformationUnstructuredArray": [
          "To Leonie Schaefer"
        ],
        "debtorName": "Leonie Schaffer"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zs6eshspj7aqq6j2203",
      "clustering": {
        "description": "Leonie Schaefer",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Leonie Schaefer' from 'To Leonie Schaefer'.",
        "updatedAt": "2025-09-27T10:52:47.391Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ngdjn4q1dz5dy16sdnywatgv0h",
      "createdAt": "2026-01-07T13:04:00.000Z",
      "updatedAt": "2026-01-07T13:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.58,
      "currency": "USD",
      "description": "Payment to GitHub: G-202601-4881",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_j7pbx2m2bpctcg38se0zdet2b1",
      "fspDate": "2026-01-07T12:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_j7pbx2m2bpctcg38se0zdet2b1",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T13:04:00.000Z",
        "valueDateTime": "2026-01-07T13:04:00.000Z",
        "transactionAmount": {
          "amount": "20.58",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GitHub: G-202601-4881",
        "remittanceInformationUnstructuredArray": [
          "Payment to GitHub",
          "G-202601-4881"
        ],
        "debtorName": "GitHub"
      },
      "paymentId": null,
      "reference": "G-202601-4881",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wd4eshsphxfd9s33j9t",
      "clustering": {
        "description": "GitHub",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'GitHub' based on payment details",
        "updatedAt": "2026-01-07T13:04:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GitHub",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pqr9kkw2ka779gdzs6tzasm7dr",
      "createdAt": "2026-01-07T13:00:00.000Z",
      "updatedAt": "2026-01-07T13:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 103,
      "currency": "EUR",
      "description": "giftmall.es",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_ckss8qra0mfz6nxcwty2xmwpbw",
      "fspDate": "2026-01-07T12:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1a1dkbx7qsd",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T12:00:00.000Z",
        "valueDateTime": "2026-01-07T12:00:00.000Z",
        "transactionAmount": {
          "amount": "-103.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "giftmall.es",
        "remittanceInformationUnstructuredArray": [
          "giftmall.es"
        ],
        "debtorName": "GiftMall"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpfaeshspmwtrg2tk9zk",
      "clustering": {
        "description": "GiftMall",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'GiftMall' from 'giftmall.es'",
        "updatedAt": "2025-09-27T10:52:10.068Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wdkqw60a0b8mg74nx2qhb8megf",
      "createdAt": "2026-01-07T13:00:00.000Z",
      "updatedAt": "2026-01-07T13:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3690,
      "currency": "EUR",
      "description": "Payment to PEMBROKEHALL LTD: 151170",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_8gtj9ashndwpabzrwej7rksn30",
      "fspDate": "2026-01-07T12:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k44sfpcmf68sptbjahhqs0m1",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T12:00:00.000Z",
        "valueDateTime": "2026-01-07T12:00:00.000Z",
        "transactionAmount": {
          "amount": "-3690.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to PEMBROKEHALL LTD: 151170",
        "remittanceInformationUnstructuredArray": [
          "Payment to PEMBROKEHALL LTD: 151170"
        ],
        "debtorName": "PEMBROKEHALL LTD"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzdeshsphm46adfgbg7",
      "clustering": {
        "description": "Pembrokehall",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Pembrokehall' from 'Payment to PEMBROKEHALL LTD: 151170', removing 'Payment to ' prefix and ' LTD' suffix.",
        "updatedAt": "2025-09-27T10:39:39.595Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n55kakv3360h96ebt02km0q6t0",
      "createdAt": "2026-01-07T12:32:00.000Z",
      "updatedAt": "2026-01-07T12:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1.97,
      "currency": "EUR",
      "description": "Payment to Merrion Row Post Office: MRP-202601-7532",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qk0yxhbcakzbtb8npsthx24e3n",
      "fspDate": "2026-01-07T11:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qk0yxhbcakzbtb8npsthx24e3n",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T12:32:00.000Z",
        "valueDateTime": "2026-01-07T12:32:00.000Z",
        "transactionAmount": {
          "amount": "1.97",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Merrion Row Post Office: MRP-202601-7532",
        "remittanceInformationUnstructuredArray": [
          "Payment to Merrion Row Post Office",
          "MRP-202601-7532"
        ],
        "debtorName": "Merrion Row Post Office"
      },
      "paymentId": null,
      "reference": "MRP-202601-7532",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj0neshspngm4dw1pq8h",
      "clustering": {
        "description": "Merrion Row Post Office",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Merrion Row Post Office' based on payment details",
        "updatedAt": "2026-01-07T12:32:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Merrion Row Post Office",
        "iban": "DE43644055064724100",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fcetw4gsba93sgjx71pnmc9ker",
      "createdAt": "2026-01-07T12:00:00.000Z",
      "updatedAt": "2026-01-07T12:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 40000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_y1b1ca5ctvyg30hkskv144rrkp",
      "fspDate": "2026-01-07T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk14vtgjmdq18",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T11:00:00.000Z",
        "valueDateTime": "2026-01-07T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-40000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:52:09.921Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ccs09ebx719a2e2222marjrr68",
      "createdAt": "2026-01-07T11:12:00.000Z",
      "updatedAt": "2026-01-07T11:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.69,
      "currency": "EUR",
      "description": "Payment to Cafe And Noodle: CAN-202601-8604",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_267asv3pa2nf8na39rbfwnw75w",
      "fspDate": "2026-01-07T10:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_267asv3pa2nf8na39rbfwnw75w",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T11:12:00.000Z",
        "valueDateTime": "2026-01-07T11:12:00.000Z",
        "transactionAmount": {
          "amount": "15.69",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cafe And Noodle: CAN-202601-8604",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cafe And Noodle",
          "CAN-202601-8604"
        ],
        "debtorName": "Cafe And Noodle"
      },
      "paymentId": null,
      "reference": "CAN-202601-8604",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpd8eshspmwjjpzayxx2",
      "clustering": {
        "description": "Cafe And Noodle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cafe And Noodle' based on payment details",
        "updatedAt": "2026-01-07T11:12:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cafe And Noodle",
        "iban": "DE55147575620593576",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fyvepj5v8ffjtqtb3qy15r9jnf",
      "createdAt": "2026-01-07T10:55:00.000Z",
      "updatedAt": "2026-01-07T10:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1208.01,
      "currency": "GBP",
      "description": "Payment to Adam Rankin: AR-202601-1310",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pk1nvktzy75pzyk3yhftmxf1zb",
      "fspDate": "2026-01-07T09:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pk1nvktzy75pzyk3yhftmxf1zb",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T10:55:00.000Z",
        "valueDateTime": "2026-01-07T10:55:00.000Z",
        "transactionAmount": {
          "amount": "1208.01",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Adam Rankin: AR-202601-1310",
        "remittanceInformationUnstructuredArray": [
          "Payment to Adam Rankin",
          "AR-202601-1310"
        ],
        "debtorName": "Adam Rankin"
      },
      "paymentId": null,
      "reference": "AR-202601-1310",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2zfvhrjnc124tr3b2s",
      "clustering": {
        "description": "Adam Rankin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Adam Rankin' based on payment details",
        "updatedAt": "2026-01-07T10:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Adam Rankin",
        "iban": null,
        "bic": null,
        "sortCode": "302660",
        "accountNumber": "34886803"
      }
    },
    {
      "id": "txn_jph2h3xmyx7wjx8assqr74am0k",
      "createdAt": "2026-01-07T09:12:00.000Z",
      "updatedAt": "2026-01-07T09:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 13.93,
      "currency": "EUR",
      "description": "Payment to A Taste of Thai: ATO-202601-8227",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_kmfr6a5k47sddgy0yzdam2jrbh",
      "fspDate": "2026-01-07T08:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_kmfr6a5k47sddgy0yzdam2jrbh",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T09:12:00.000Z",
        "valueDateTime": "2026-01-07T09:12:00.000Z",
        "transactionAmount": {
          "amount": "13.93",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to A Taste of Thai: ATO-202601-8227",
        "remittanceInformationUnstructuredArray": [
          "Payment to A Taste of Thai",
          "ATO-202601-8227"
        ],
        "debtorName": "A Taste of Thai"
      },
      "paymentId": null,
      "reference": "ATO-202601-8227",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1m2eshspm6a6wp0a9jq",
      "clustering": {
        "description": "A Taste of Thai",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'A Taste of Thai' based on payment details",
        "updatedAt": "2026-01-07T09:12:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "A Taste of Thai",
        "iban": "DE48653078606016560",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xq157n3t685q9enwr6ch39rvvd",
      "createdAt": "2026-01-07T09:00:00.000Z",
      "updatedAt": "2026-01-07T09:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 5976.71,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_2kdger8w2j03jekf667wjfkxnj",
      "fspDate": "2026-01-07T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk88gpxvsrkam",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T08:00:00.000Z",
        "valueDateTime": "2026-01-07T08:00:00.000Z",
        "transactionAmount": {
          "amount": "5976.71",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.166Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7q3mehv04pyqq75y3pnvv2cbe7",
      "createdAt": "2026-01-07T09:00:00.000Z",
      "updatedAt": "2026-01-07T09:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_bp26rg28rh79yd35a4dj86n71k",
      "fspDate": "2026-01-07T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk1888d5kkn9y",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T08:00:00.000Z",
        "valueDateTime": "2026-01-07T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-5.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration Office",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Companies Registration Office' from 'Companies Registration'",
        "updatedAt": "2025-09-27T10:52:09.969Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_sd7qha8mzee0bf80tf04pex8kd",
      "createdAt": "2026-01-07T09:00:00.000Z",
      "updatedAt": "2026-01-07T09:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 2336.61,
      "currency": "EUR",
      "description": "Exchanged to EUR Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_q1hwfrkcd3ts0g49mjhrchtj1s",
      "fspDate": "2026-01-07T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk16hzhtwrxse",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T08:00:00.000Z",
        "valueDateTime": "2026-01-07T08:00:00.000Z",
        "transactionAmount": {
          "amount": "2336.61",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to EUR Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to EUR Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the currency conversion transaction with code 'EXCHANGE'.",
        "updatedAt": "2025-09-27T10:51:38.287Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7t7ey404kmn4k6c33v3ex41gnp",
      "createdAt": "2026-01-06T15:59:00.000Z",
      "updatedAt": "2026-01-06T15:59:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 60.24,
      "currency": "GBP",
      "description": "Payment to LinkedIn: L-202601-7437",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bdtd8wwpx9797b5sgt12geva5a",
      "fspDate": "2026-01-06T14:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bdtd8wwpx9797b5sgt12geva5a",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T15:59:00.000Z",
        "valueDateTime": "2026-01-06T15:59:00.000Z",
        "transactionAmount": {
          "amount": "60.24",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to LinkedIn: L-202601-7437",
        "remittanceInformationUnstructuredArray": [
          "Payment to LinkedIn",
          "L-202601-7437"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": "L-202601-7437",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'LinkedIn' based on payment details",
        "updatedAt": "2026-01-06T15:59:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "LinkedIn",
        "iban": null,
        "bic": null,
        "sortCode": "197426",
        "accountNumber": "33768099"
      }
    },
    {
      "id": "txn_m8qfe8pwqv6bwwj1cj2d7w410k",
      "createdAt": "2026-01-06T15:55:00.000Z",
      "updatedAt": "2026-01-06T15:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7427.46,
      "currency": "EUR",
      "description": "Payment to Jonas Novak: JN-202601-3915",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qhhj94grv4qhtp47j0vmht6xr5",
      "fspDate": "2026-01-06T14:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qhhj94grv4qhtp47j0vmht6xr5",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T15:55:00.000Z",
        "valueDateTime": "2026-01-06T15:55:00.000Z",
        "transactionAmount": {
          "amount": "7427.46",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jonas Novak: JN-202601-3915",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jonas Novak",
          "JN-202601-3915"
        ],
        "debtorName": "Jonas Novak"
      },
      "paymentId": null,
      "reference": "JN-202601-3915",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x01eshsphmk5k2axdrt",
      "clustering": {
        "description": "Jonas Novak",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Jonas Novak' based on payment details",
        "updatedAt": "2026-01-06T15:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Jonas Novak",
        "iban": "DE56139985306461790",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7bxwzfey7bars918aeq43g34ba",
      "createdAt": "2026-01-06T15:20:00.000Z",
      "updatedAt": "2026-01-06T15:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 26.42,
      "currency": "EUR",
      "description": "Payment to XAI: X-202601-6966",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ttsdct8q0dhheeysr8x6n6x6wg",
      "fspDate": "2026-01-06T14:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ttsdct8q0dhheeysr8x6n6x6wg",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T15:20:00.000Z",
        "valueDateTime": "2026-01-06T15:20:00.000Z",
        "transactionAmount": {
          "amount": "26.42",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to XAI: X-202601-6966",
        "remittanceInformationUnstructuredArray": [
          "Payment to XAI",
          "X-202601-6966"
        ],
        "debtorName": "XAI"
      },
      "paymentId": null,
      "reference": "X-202601-6966",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgt8yeshspk60ezf5bsne",
      "clustering": {
        "description": "XAI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'XAI' based on payment details",
        "updatedAt": "2026-01-06T15:20:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "XAI",
        "iban": "DE58005383006606540",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_w7hbyhbxb55c1hmk894jdkcdq2",
      "createdAt": "2026-01-06T15:00:00.000Z",
      "updatedAt": "2026-01-06T15:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 46.66,
      "currency": "EUR",
      "description": "www.heathrowexpress.co",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_vehzp4kxk412cw7we5whzdmzyp",
      "fspDate": "2026-01-06T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0ykzc3q8phr",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T14:00:00.000Z",
        "valueDateTime": "2026-01-06T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-46.66",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "www.heathrowexpress.co",
        "remittanceInformationUnstructuredArray": [
          "www.heathrowexpress.co"
        ],
        "debtorName": "Heathrow Express"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpg2eshspmf0nznfw91y",
      "clustering": {
        "description": "Heathrow Express",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Heathrow Express' from 'www.heathrowexpress.co'",
        "updatedAt": "2025-09-27T10:50:52.407Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1apmnfzpfzha9z9cp4a2s5ynzc",
      "createdAt": "2026-01-06T14:58:00.000Z",
      "updatedAt": "2026-01-06T14:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 33.64,
      "currency": "EUR",
      "description": "Payment to The Woolshed: TW-202601-2314",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_yav8hf5kj99jb8yxv6m9h81s87",
      "fspDate": "2026-01-06T13:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_yav8hf5kj99jb8yxv6m9h81s87",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T14:58:00.000Z",
        "valueDateTime": "2026-01-06T14:58:00.000Z",
        "transactionAmount": {
          "amount": "33.64",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Woolshed: TW-202601-2314",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Woolshed",
          "TW-202601-2314"
        ],
        "debtorName": "The Woolshed"
      },
      "paymentId": null,
      "reference": "TW-202601-2314",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1pkeshspm729w29ytag",
      "clustering": {
        "description": "The Woolshed",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Woolshed' based on payment details",
        "updatedAt": "2026-01-06T14:58:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Woolshed",
        "iban": "DE78683865616212820",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3eeg4a548kwd61wb37p16f7er8",
      "createdAt": "2026-01-06T14:34:00.000Z",
      "updatedAt": "2026-01-06T14:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 21.31,
      "currency": "EUR",
      "description": "Payment to The Pig And Heifer: TPA-202601-8196",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gpgma2f30j211qn9re5cwf1gq3",
      "fspDate": "2026-01-06T13:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gpgma2f30j211qn9re5cwf1gq3",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T14:34:00.000Z",
        "valueDateTime": "2026-01-06T14:34:00.000Z",
        "transactionAmount": {
          "amount": "21.31",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Pig And Heifer: TPA-202601-8196",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Pig And Heifer",
          "TPA-202601-8196"
        ],
        "debtorName": "The Pig And Heifer"
      },
      "paymentId": null,
      "reference": "TPA-202601-8196",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g5weshsphq7y8rf4z8z",
      "clustering": {
        "description": "The Pig And Heifer",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Pig And Heifer' based on payment details",
        "updatedAt": "2026-01-06T14:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Pig And Heifer",
        "iban": "DE79883264600576800",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_kz26r3mx40g2jfqda9zkbdgh7k",
      "createdAt": "2026-01-06T12:59:00.000Z",
      "updatedAt": "2026-01-06T12:59:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 32.09,
      "currency": "EUR",
      "description": "Payment to Sentry: S-202601-1972",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_d2179hznqgk0w555rsd6yj70vs",
      "fspDate": "2026-01-06T11:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_d2179hznqgk0w555rsd6yj70vs",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T12:59:00.000Z",
        "valueDateTime": "2026-01-06T12:59:00.000Z",
        "transactionAmount": {
          "amount": "32.09",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sentry: S-202601-1972",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sentry",
          "S-202601-1972"
        ],
        "debtorName": "Sentry"
      },
      "paymentId": null,
      "reference": "S-202601-1972",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdn2eshspk97jdcm57ef",
      "clustering": {
        "description": "Sentry",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sentry' based on payment details",
        "updatedAt": "2026-01-06T12:59:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sentry",
        "iban": "DE89217911900607950",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ssc0cnzajhv74adc1jq4jbfef6",
      "createdAt": "2026-01-06T12:00:00.000Z",
      "updatedAt": "2026-01-06T12:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 2589.88,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_m1y2ag19mt103t3frx7mh4c726",
      "fspDate": "2026-01-06T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ksfsfdfzwbd14ny6h98vq4",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T11:00:00.000Z",
        "valueDateTime": "2026-01-06T11:00:00.000Z",
        "transactionAmount": {
          "amount": "2589.88",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.851Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_83gd3y9gg8nnhasgpz3gbyj89n",
      "createdAt": "2026-01-06T12:00:00.000Z",
      "updatedAt": "2026-01-06T12:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 323.8,
      "currency": "GBP",
      "description": "Hotel At Booking.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_p3pn75pv80421z7k9xs0xf1hxq",
      "fspDate": "2026-01-06T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8hh1xthrzsv",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T11:00:00.000Z",
        "valueDateTime": "2026-01-06T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-323.80",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Hotel At Booking.com",
        "remittanceInformationUnstructuredArray": [
          "Hotel At Booking.com"
        ],
        "debtorName": "Booking.com"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9p5fvhrjp2td9pd9rat",
      "clustering": {
        "description": "Booking.com",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Booking.com' from 'Hotel At Booking.com'",
        "updatedAt": "2025-09-29T18:26:40.988Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1y74n4xq4tmndvnv1wbq9821zt",
      "createdAt": "2026-01-06T11:43:00.000Z",
      "updatedAt": "2026-01-06T11:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2774.34,
      "currency": "USD",
      "description": "Payment to Anthropic PBC: AP-202601-7133",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rnq759r23f1gw9wpcrwr2px3em",
      "fspDate": "2026-01-06T10:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rnq759r23f1gw9wpcrwr2px3em",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T11:43:00.000Z",
        "valueDateTime": "2026-01-06T11:43:00.000Z",
        "transactionAmount": {
          "amount": "2774.34",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic PBC: AP-202601-7133",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic PBC",
          "AP-202601-7133"
        ],
        "debtorName": "Anthropic PBC"
      },
      "paymentId": null,
      "reference": "AP-202601-7133",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_vnn6fxhm5daqv7bh39b88k2t9d",
      "clustering": {
        "description": "Anthropic PBC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic PBC' based on payment details",
        "updatedAt": "2026-01-06T11:43:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic PBC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nccaafg1be5st8e63begh23w20",
      "createdAt": "2026-01-06T09:53:00.000Z",
      "updatedAt": "2026-01-06T09:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 30.04,
      "currency": "EUR",
      "description": "Payment to Shaka Poke: SP-202601-7025",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rg3w40avgq6kbjjw937k7p6mmx",
      "fspDate": "2026-01-06T08:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rg3w40avgq6kbjjw937k7p6mmx",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T09:53:00.000Z",
        "valueDateTime": "2026-01-06T09:53:00.000Z",
        "transactionAmount": {
          "amount": "30.04",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Shaka Poke: SP-202601-7025",
        "remittanceInformationUnstructuredArray": [
          "Payment to Shaka Poke",
          "SP-202601-7025"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": "SP-202601-7025",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Shaka Poke' based on payment details",
        "updatedAt": "2026-01-06T09:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Shaka Poke",
        "iban": "DE46632244317893400",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7j8gna5j589nwqskpm421mxr4p",
      "createdAt": "2026-01-06T09:08:00.000Z",
      "updatedAt": "2026-01-06T09:08:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 24585.45,
      "currency": "GBP",
      "description": "Payment from Digital Ventures Group - INV-202601-9551",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_y2e2q63efntymf266ngcs9n81d",
      "fspDate": "2026-01-06T08:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_y2e2q63efntymf266ngcs9n81d",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T09:08:00.000Z",
        "valueDateTime": "2026-01-06T09:08:00.000Z",
        "transactionAmount": {
          "amount": "24585.45",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Digital Ventures Group - INV-202601-9551",
        "remittanceInformationUnstructuredArray": [
          "Payment from Digital Ventures Group",
          "INV-202601-9551"
        ],
        "creditorName": "Digital Ventures Group"
      },
      "paymentId": null,
      "reference": "INV-202601-9551",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_mj6n80che7b1rf41e9c0gtanqb",
      "clustering": {
        "description": "Digital Ventures Group",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Digital Ventures Group'",
        "updatedAt": "2026-01-06T09:08:00.000Z"
      },
      "payer": {
        "name": "Digital Ventures Group",
        "iban": null,
        "bic": null,
        "sortCode": "930839",
        "accountNumber": "79333065"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_53wn7zpxcv2y1wc3751533j47s",
      "createdAt": "2026-01-06T09:00:00.000Z",
      "updatedAt": "2026-01-06T09:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.51,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_zqtxn7m1r6v9537g93bkmsxb3c",
      "fspDate": "2026-01-06T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1fpmbemeh1r152xnpv2rgw4",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T08:00:00.000Z",
        "valueDateTime": "2026-01-06T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-17.51",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Cursor' from 'Cursor, Ai Powered Ide'",
        "updatedAt": "2025-09-27T10:45:11.586Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_tak14zegzzkytmkf1mt5gbf08f",
      "createdAt": "2026-01-06T09:00:00.000Z",
      "updatedAt": "2026-01-06T09:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17104.51,
      "currency": "GBP",
      "description": "To Amwins Global Risks B.V.",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_n0q96y095aray2drsnd6na42xm",
      "fspDate": "2026-01-06T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk82whzetb6f3",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T08:00:00.000Z",
        "valueDateTime": "2026-01-06T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-17104.51",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Amwins Global Risks B.V.",
        "remittanceInformationUnstructuredArray": [
          "To Amwins Global Risks B.V."
        ],
        "debtorName": "Modulr Finance B.V. EUR"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2bfvhrjnbz808baykh",
      "clustering": {
        "description": "Amwins Global Risks B.V.",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Amwins Global Risks B.V.' from 'To Amwins Global Risks B.V.'",
        "updatedAt": "2025-09-29T18:24:29.663Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zqx5c4rg7qhz55m8cm1zjrf1bj",
      "createdAt": "2026-01-05T16:38:00.000Z",
      "updatedAt": "2026-01-05T16:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 27459.69,
      "currency": "EUR",
      "description": "Payment from Alpine Software SA - INV-202601-5523",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0tnzemdddwse96c96xbenxpssq",
      "fspDate": "2026-01-05T15:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0tnzemdddwse96c96xbenxpssq",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T16:38:00.000Z",
        "valueDateTime": "2026-01-05T16:38:00.000Z",
        "transactionAmount": {
          "amount": "27459.69",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Alpine Software SA - INV-202601-5523",
        "remittanceInformationUnstructuredArray": [
          "Payment from Alpine Software SA",
          "INV-202601-5523"
        ],
        "creditorName": "Alpine Software SA"
      },
      "paymentId": null,
      "reference": "INV-202601-5523",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_nk7g93a6fpe8ybm4hppdmmfgsw",
      "clustering": {
        "description": "Alpine Software SA",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Alpine Software SA'",
        "updatedAt": "2026-01-05T16:38:00.000Z"
      },
      "payer": {
        "name": "Alpine Software SA",
        "iban": "DE66607568983937100",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yb9h810pgga4v0xf65ps2pday3",
      "createdAt": "2026-01-05T15:40:00.000Z",
      "updatedAt": "2026-01-05T15:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1879.18,
      "currency": "EUR",
      "description": "Payment to Bank of Ireland: BOI-202601-6481",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_dczyj6gw7eadfjt6e3a77mbk96",
      "fspDate": "2026-01-05T14:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_dczyj6gw7eadfjt6e3a77mbk96",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T15:40:00.000Z",
        "valueDateTime": "2026-01-05T15:40:00.000Z",
        "transactionAmount": {
          "amount": "1879.18",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bank of Ireland: BOI-202601-6481",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bank of Ireland",
          "BOI-202601-6481"
        ],
        "debtorName": "Bank of Ireland"
      },
      "paymentId": null,
      "reference": "BOI-202601-6481",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a24eshspnzbnpcam1v1",
      "clustering": {
        "description": "Bank of Ireland",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bank of Ireland' based on payment details",
        "updatedAt": "2026-01-05T15:40:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bank of Ireland",
        "iban": "DE47051776139162230",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_s4dtn5cmm80exvpc1qsgc92q20",
      "createdAt": "2026-01-05T15:00:00.000Z",
      "updatedAt": "2026-01-05T15:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 20000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_8g18amz0xbepgyt0pt8nkpw9yk",
      "fspDate": "2026-01-05T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n6ekeh2tcaqkf0kh6p0b",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T14:00:00.000Z",
        "valueDateTime": "2026-01-05T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-20000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name due to the 'EXCHANGE' transaction code.",
        "updatedAt": "2025-09-27T10:39:39.718Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9a7r6smq9554eahx1pp5vy3q3f",
      "createdAt": "2026-01-05T13:00:00.000Z",
      "updatedAt": "2026-01-05T13:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 10000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_v29y94wt9h2cbrq765hc3rekhf",
      "fspDate": "2026-01-05T12:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n6ekeh2tcaqee732e7dw",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T12:00:00.000Z",
        "valueDateTime": "2026-01-05T12:00:00.000Z",
        "transactionAmount": {
          "amount": "-10000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name due to the 'EXCHANGE' transaction code.",
        "updatedAt": "2025-09-27T10:39:39.714Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3t172wsx9dkbzh3sgrht8m3mck",
      "createdAt": "2026-01-05T13:00:00.000Z",
      "updatedAt": "2026-01-05T13:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2050,
      "currency": "GBP",
      "description": "Nest",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_qtp5g28a9web5sd3t1y7fvgzpe",
      "fspDate": "2026-01-05T12:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ksfsfdfzwbd14vvbs1w6s1",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T12:00:00.000Z",
        "valueDateTime": "2026-01-05T12:00:00.000Z",
        "transactionAmount": {
          "amount": "-2050.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Nest",
        "remittanceInformationUnstructuredArray": [
          "Nest"
        ],
        "debtorName": "Nest"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf96wfvhrjn5f3jx2wta0",
      "clustering": {
        "description": "Nest",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Nest' from 'Nest'",
        "updatedAt": "2025-09-29T18:23:50.863Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_hwyfxtb4n0nx9z7j3am742ypvr",
      "createdAt": "2026-01-05T12:54:00.000Z",
      "updatedAt": "2026-01-05T12:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 144.55,
      "currency": "EUR",
      "description": "Payment to Naomi's Kitchen: NK-202601-7017",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_033nptac6mnysy9fem4qbnchfr",
      "fspDate": "2026-01-05T11:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_033nptac6mnysy9fem4qbnchfr",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T12:54:00.000Z",
        "valueDateTime": "2026-01-05T12:54:00.000Z",
        "transactionAmount": {
          "amount": "144.55",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Naomi's Kitchen: NK-202601-7017",
        "remittanceInformationUnstructuredArray": [
          "Payment to Naomi's Kitchen",
          "NK-202601-7017"
        ],
        "debtorName": "Naomi's Kitchen"
      },
      "paymentId": null,
      "reference": "NK-202601-7017",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh3deshspkhegxj7z9nq",
      "clustering": {
        "description": "Naomi's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Naomi's Kitchen' based on payment details",
        "updatedAt": "2026-01-05T12:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Naomi's Kitchen",
        "iban": "DE57352178600419590",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fk5w4399v1m0ka1px4t27zwt02",
      "createdAt": "2026-01-05T12:39:00.000Z",
      "updatedAt": "2026-01-05T12:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3642.57,
      "currency": "GBP",
      "description": "Payment to WealthKernel: W-202601-7588",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nh73nzgw49d3324p01myw325vg",
      "fspDate": "2026-01-05T11:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nh73nzgw49d3324p01myw325vg",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T12:39:00.000Z",
        "valueDateTime": "2026-01-05T12:39:00.000Z",
        "transactionAmount": {
          "amount": "3642.57",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to WealthKernel: W-202601-7588",
        "remittanceInformationUnstructuredArray": [
          "Payment to WealthKernel",
          "W-202601-7588"
        ],
        "debtorName": "WealthKernel"
      },
      "paymentId": null,
      "reference": "W-202601-7588",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhng0fvhrjnk93frdx83x",
      "clustering": {
        "description": "WealthKernel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'WealthKernel' based on payment details",
        "updatedAt": "2026-01-05T12:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "WealthKernel",
        "iban": null,
        "bic": null,
        "sortCode": "341910",
        "accountNumber": "91645848"
      }
    },
    {
      "id": "txn_b5mpdz8qrq0att276jdzgrmjq8",
      "createdAt": "2026-01-05T11:18:00.000Z",
      "updatedAt": "2026-01-05T11:18:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 33.36,
      "currency": "GBP",
      "description": "Payment to Modulr Finance: MF-202601-6878",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6j9g4xrwyfz416qzb2e4akwawt",
      "fspDate": "2026-01-05T10:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6j9g4xrwyfz416qzb2e4akwawt",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T11:18:00.000Z",
        "valueDateTime": "2026-01-05T11:18:00.000Z",
        "transactionAmount": {
          "amount": "33.36",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Modulr Finance: MF-202601-6878",
        "remittanceInformationUnstructuredArray": [
          "Payment to Modulr Finance",
          "MF-202601-6878"
        ],
        "debtorName": "Modulr Finance"
      },
      "paymentId": null,
      "reference": "MF-202601-6878",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Modulr Finance' based on payment details",
        "updatedAt": "2026-01-05T11:18:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Modulr Finance",
        "iban": null,
        "bic": null,
        "sortCode": "462596",
        "accountNumber": "20267216"
      }
    },
    {
      "id": "txn_d1y9ma7dxfvrgat07cc7fm3xna",
      "createdAt": "2026-01-05T11:00:00.000Z",
      "updatedAt": "2026-01-05T11:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 20.85,
      "currency": "EUR",
      "description": "1password",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_m0j2jq7rdnk3214hnd5n3pd9ws",
      "fspDate": "2026-01-05T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3az28h4eh2t0hd5xz84d7rz",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T10:00:00.000Z",
        "valueDateTime": "2026-01-05T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-20.85",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "1password",
        "remittanceInformationUnstructuredArray": [
          "1password"
        ],
        "debtorName": "1Password"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxpeshspjghv7zy63at",
      "clustering": {
        "description": "1Password",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name '1Password' from '1password'",
        "updatedAt": "2025-09-27T10:40:26.908Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_15zy3vzzgav3sbpcfdppgvp2h6",
      "createdAt": "2026-01-05T09:00:00.000Z",
      "updatedAt": "2026-01-05T09:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 93.6,
      "currency": "EUR",
      "description": "zapier.com/charge",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_zcjcsd1yccqrq99pn5vza9vz4p",
      "fspDate": "2026-01-05T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk20ahxec4e0t",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T08:00:00.000Z",
        "valueDateTime": "2026-01-05T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-93.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "zapier.com/charge",
        "remittanceInformationUnstructuredArray": [
          "zapier.com/charge"
        ],
        "debtorName": "Zapier"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2aeshspkg92jdy8vh4",
      "clustering": {
        "description": "Zapier",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zapier' from 'zapier.com/charge'",
        "updatedAt": "2025-09-27T10:54:50.772Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0r7hmzydbt12f3yt7cpbb7x3wz",
      "createdAt": "2026-01-05T09:00:00.000Z",
      "updatedAt": "2026-01-05T09:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 34.55,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_9rarnr6x6t1myej3zn5jqjs43g",
      "fspDate": "2026-01-05T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1wkxf1tena8nqvfg1ctfkd3",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T08:00:00.000Z",
        "valueDateTime": "2026-01-05T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-34.55",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Cursor' from the transaction description, removing the ', Ai Powered Ide' suffix.",
        "updatedAt": "2025-09-27T10:43:55.520Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_w42x7m6yckwnpdvmkp2417v33g",
      "createdAt": "2026-01-05T08:00:00.000Z",
      "updatedAt": "2026-01-05T08:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14.92,
      "currency": "GBP",
      "description": "Uber * Pending",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_f0rzjka856t0rvgyxzck8ht66c",
      "fspDate": "2026-01-05T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk82h0nb369ew",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T07:00:00.000Z",
        "valueDateTime": "2026-01-05T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-14.92",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Uber * Pending",
        "remittanceInformationUnstructuredArray": [
          "Uber * Pending"
        ],
        "debtorName": "Uber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Uber",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Uber' from 'Uber * Pending'",
        "updatedAt": "2025-09-29T18:24:29.655Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4hedtyrq36mjar86czbb701exv",
      "createdAt": "2026-01-04T17:00:00.000Z",
      "updatedAt": "2026-01-04T17:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 46.59,
      "currency": "EUR",
      "description": "www.heathrowexpress.co",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_0r870srr99pr0gk7qpkr247gq1",
      "fspDate": "2026-01-04T16:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0y3565nx9k4",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T16:00:00.000Z",
        "valueDateTime": "2026-01-04T16:00:00.000Z",
        "transactionAmount": {
          "amount": "-46.59",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "www.heathrowexpress.co",
        "remittanceInformationUnstructuredArray": [
          "www.heathrowexpress.co"
        ],
        "debtorName": "Heathrow Express"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpg2eshspmf0nznfw91y",
      "clustering": {
        "description": "Heathrow Express",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Heathrow Express' from 'www.heathrowexpress.co'",
        "updatedAt": "2025-09-27T10:50:52.301Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wrkfcjwj67tyd42pwfsnp98emx",
      "createdAt": "2026-01-04T16:00:00.000Z",
      "updatedAt": "2026-01-04T16:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 36,
      "currency": "EUR",
      "description": "Draculas Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_5znvnkvmh45qxneedp8gp5mxw5",
      "fspDate": "2026-01-04T15:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk22kybtga34w",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T15:00:00.000Z",
        "valueDateTime": "2026-01-04T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-36.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Draculas Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Draculas Kitchen"
        ],
        "debtorName": "Dracula's Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcgeshspn9xska0mg5b",
      "clustering": {
        "description": "Dracula's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Dracula's Kitchen' from 'Draculas Kitchen'",
        "updatedAt": "2025-09-27T10:54:50.857Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wrg9x5zm3j4qd15dmqac8adnpe",
      "createdAt": "2026-01-04T15:22:00.000Z",
      "updatedAt": "2026-01-04T15:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.91,
      "currency": "EUR",
      "description": "Payment to Pinecone Coffee: PC-202601-8874",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1gd3p1kvjkpkp2hbrbswrcp7gc",
      "fspDate": "2026-01-04T14:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1gd3p1kvjkpkp2hbrbswrcp7gc",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T15:22:00.000Z",
        "valueDateTime": "2026-01-04T15:22:00.000Z",
        "transactionAmount": {
          "amount": "3.91",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pinecone Coffee: PC-202601-8874",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pinecone Coffee",
          "PC-202601-8874"
        ],
        "debtorName": "Pinecone Coffee"
      },
      "paymentId": null,
      "reference": "PC-202601-8874",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh31eshspkh23ahabkmn",
      "clustering": {
        "description": "Pinecone Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pinecone Coffee' based on payment details",
        "updatedAt": "2026-01-04T15:22:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pinecone Coffee",
        "iban": "DE57591158775620456",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_kd158h0af18ryzfcydaqfbpz6y",
      "createdAt": "2026-01-04T14:45:00.000Z",
      "updatedAt": "2026-01-04T14:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 289.33,
      "currency": "EUR",
      "description": "Payment to Bang Restaurant: BR-202601-9400",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6hnxnffnjn5se7bhqn2ghhq9vc",
      "fspDate": "2026-01-04T13:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6hnxnffnjn5se7bhqn2ghhq9vc",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T14:45:00.000Z",
        "valueDateTime": "2026-01-04T14:45:00.000Z",
        "transactionAmount": {
          "amount": "289.33",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bang Restaurant: BR-202601-9400",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bang Restaurant",
          "BR-202601-9400"
        ],
        "debtorName": "Bang Restaurant"
      },
      "paymentId": null,
      "reference": "BR-202601-9400",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpk3eshspmfgtm6vkpxj",
      "clustering": {
        "description": "Bang Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bang Restaurant' based on payment details",
        "updatedAt": "2026-01-04T14:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bang Restaurant",
        "iban": "DE87258098241525970",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ec5rz4xypn4kvsq1gc524cc3n2",
      "createdAt": "2026-01-04T14:00:00.000Z",
      "updatedAt": "2026-01-04T14:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 18,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_rqza0t8fwcgyabtj48tnqj9vwc",
      "fspDate": "2026-01-04T13:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0s7bdgx9nqc",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T13:00:00.000Z",
        "valueDateTime": "2026-01-04T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-18.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Burger Cartel' from 'Burger Cartel Limited'",
        "updatedAt": "2025-09-27T10:50:08.341Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_c44bac8demy8mzrevg3hv5jgn2",
      "createdAt": "2026-01-04T14:00:00.000Z",
      "updatedAt": "2026-01-04T14:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3000,
      "currency": "GBP",
      "description": "To Grow Your Boat Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_9h3yvz005brs23vqtkxr0y8j8s",
      "fspDate": "2026-01-04T13:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk821r6vq8v32",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T13:00:00.000Z",
        "valueDateTime": "2026-01-04T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Grow Your Boat Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Grow Your Boat Ltd"
        ],
        "debtorName": "Grow Your Boat Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "clustering": {
        "description": "Grow Your Boat Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Grow Your Boat Ltd' from 'To Grow Your Boat Ltd'",
        "updatedAt": "2025-09-29T18:24:29.648Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qs3jmz575qrywwpg3cq80ekf2t",
      "createdAt": "2026-01-04T14:00:00.000Z",
      "updatedAt": "2026-01-04T14:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 6.45,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_zf6v9javyqazaph2nw4dnzj6aw",
      "fspDate": "2026-01-04T13:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1mksd7rd917",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T13:00:00.000Z",
        "valueDateTime": "2026-01-04T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-6.45",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'DocuSign' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.224Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_z7waxz6ymrb0enc1qb8kbw6dk8",
      "createdAt": "2026-01-04T12:00:00.000Z",
      "updatedAt": "2026-01-04T12:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Sq *amba",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_crzfeh42jra391x79jgcg1bpec",
      "fspDate": "2026-01-04T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3wzvbyze4btjekhhee2zmtg",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T11:00:00.000Z",
        "valueDateTime": "2026-01-04T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *amba",
        "remittanceInformationUnstructuredArray": [
          "Sq *amba"
        ],
        "debtorName": "Amba"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g1aeshsphp662hfbd17",
      "clustering": {
        "description": "Amba",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Amba' from 'Sq *amba', removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:39:39.637Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zf3fw0c3db9e5a67ftv58mmnnz",
      "createdAt": "2026-01-04T11:00:00.000Z",
      "updatedAt": "2026-01-04T11:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_kdyrmn0jdcga9aqf3x8sgdytcs",
      "fspDate": "2026-01-04T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0v71ajzq03b",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T10:00:00.000Z",
        "valueDateTime": "2026-01-04T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing 'Sq *' prefix",
        "updatedAt": "2025-09-27T10:50:52.257Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jyew5g28sv5ks0zrrzb06fzhy6",
      "createdAt": "2026-01-04T10:23:00.000Z",
      "updatedAt": "2026-01-04T10:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 91.27,
      "currency": "EUR",
      "description": "Payment to Irish Rail: IR-202601-5754",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_tc1bx66vzv032tnkzhbkzebg9y",
      "fspDate": "2026-01-04T09:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_tc1bx66vzv032tnkzhbkzebg9y",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T10:23:00.000Z",
        "valueDateTime": "2026-01-04T10:23:00.000Z",
        "transactionAmount": {
          "amount": "91.27",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Irish Rail: IR-202601-5754",
        "remittanceInformationUnstructuredArray": [
          "Payment to Irish Rail",
          "IR-202601-5754"
        ],
        "debtorName": "Irish Rail"
      },
      "paymentId": null,
      "reference": "IR-202601-5754",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax69eshspjn90xv3cz0y",
      "clustering": {
        "description": "Irish Rail",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Irish Rail' based on payment details",
        "updatedAt": "2026-01-04T10:23:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Irish Rail",
        "iban": "DE31846376108528470",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_84a68s8n5s480pw3y3p2gvvn3m",
      "createdAt": "2026-01-04T10:00:00.000Z",
      "updatedAt": "2026-01-04T10:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 40,
      "currency": "EUR",
      "description": "Mamma Mia Restaurant",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_v2a07qqq6h43zzqa5s4bsqza4c",
      "fspDate": "2026-01-04T09:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1qeknfff7zx",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T09:00:00.000Z",
        "valueDateTime": "2026-01-04T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-40.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Mamma Mia Restaurant",
        "remittanceInformationUnstructuredArray": [
          "Mamma Mia Restaurant"
        ],
        "debtorName": "Mamma Mia Restaurant"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj1yeshspngr1g523f6q",
      "clustering": {
        "description": "Mamma Mia Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Mamma Mia Restaurant' from the raw transaction description.",
        "updatedAt": "2025-09-27T10:53:55.656Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n8515typrc06qe5qtqvve5a4ak",
      "createdAt": "2026-01-04T08:00:00.000Z",
      "updatedAt": "2026-01-04T08:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 70,
      "currency": "EUR",
      "description": "Retool",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_evpah9p2tj38g9fqwd9apnkyra",
      "fspDate": "2026-01-04T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1ytk1gjjv42",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T07:00:00.000Z",
        "valueDateTime": "2026-01-04T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-70.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Retool",
        "remittanceInformationUnstructuredArray": [
          "Retool"
        ],
        "debtorName": "Retool"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdp6eshspk9a3b1e6677",
      "clustering": {
        "description": "Retool",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Retool' from 'Retool'.",
        "updatedAt": "2025-09-27T10:54:12.563Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zg1ra4g93939x20ken9b89gq0a",
      "createdAt": "2026-01-03T16:00:00.000Z",
      "updatedAt": "2026-01-03T16:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4988.83,
      "currency": "EUR",
      "description": "To Sophie Laurent",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_mw72e0nc7vaz45hdtngpv2p67a",
      "fspDate": "2026-01-03T15:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1dxs9x79ev9",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T15:00:00.000Z",
        "valueDateTime": "2026-01-03T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-4988.83",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Sophie Laurent",
        "remittanceInformationUnstructuredArray": [
          "To Sophie Laurent"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsseshspj86qckgs7na",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Sophie Laurent' from 'To Sophie Laurent'.",
        "updatedAt": "2025-09-27T10:52:47.362Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_27q8zsctftxnzh78npe1ck36nw",
      "createdAt": "2026-01-03T15:10:00.000Z",
      "updatedAt": "2026-01-03T15:10:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 229.01,
      "currency": "EUR",
      "description": "Payment to Welcome to the Jungle: WTT-202601-1235",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_dxzkb8eyds1ryyef5p2cch0hhk",
      "fspDate": "2026-01-03T14:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_dxzkb8eyds1ryyef5p2cch0hhk",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T15:10:00.000Z",
        "valueDateTime": "2026-01-03T15:10:00.000Z",
        "transactionAmount": {
          "amount": "229.01",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Welcome to the Jungle: WTT-202601-1235",
        "remittanceInformationUnstructuredArray": [
          "Payment to Welcome to the Jungle",
          "WTT-202601-1235"
        ],
        "debtorName": "Welcome to the Jungle"
      },
      "paymentId": null,
      "reference": "WTT-202601-1235",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkfxeshspnwz7ebn2y1d",
      "clustering": {
        "description": "Welcome to the Jungle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Welcome to the Jungle' based on payment details",
        "updatedAt": "2026-01-03T15:10:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Welcome to the Jungle",
        "iban": "DE40880566796816480",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_d43406h2wy4t76hwqyen7vh2tn",
      "createdAt": "2026-01-03T15:00:00.000Z",
      "updatedAt": "2026-01-03T15:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 65,
      "currency": "EUR",
      "description": "Payment to Company Formations International Limited: 139524",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_98xn09jkes5bzc45mnjdwzr8c7",
      "fspDate": "2026-01-03T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jygq5aqkfew8jfdhssxrbe0y",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T14:00:00.000Z",
        "valueDateTime": "2026-01-03T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-65.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Company Formations International Limited: 139524",
        "remittanceInformationUnstructuredArray": [
          "Payment to Company Formations International Limited: 139524"
        ],
        "debtorName": "Company Formations International Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cvstpeshspn39955xdf4m",
      "clustering": {
        "description": "Company Formations International Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Company Formations International Limited' from 'Payment to Company Formations International Limited: 139524'.",
        "updatedAt": "2025-09-27T10:52:47.446Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qnge7a3ry1j5k6j6h6s5nst1ef",
      "createdAt": "2026-01-03T14:07:00.000Z",
      "updatedAt": "2026-01-03T14:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 97.86,
      "currency": "EUR",
      "description": "Payment to Attio: A-202601-4227",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_sgzrjff422skvkhmz3tnrg7ndw",
      "fspDate": "2026-01-03T13:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_sgzrjff422skvkhmz3tnrg7ndw",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T14:07:00.000Z",
        "valueDateTime": "2026-01-03T14:07:00.000Z",
        "transactionAmount": {
          "amount": "97.86",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Attio: A-202601-4227",
        "remittanceInformationUnstructuredArray": [
          "Payment to Attio",
          "A-202601-4227"
        ],
        "debtorName": "Attio"
      },
      "paymentId": null,
      "reference": "A-202601-4227",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspj5eshspmpcdfterchh",
      "clustering": {
        "description": "Attio",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Attio' based on payment details",
        "updatedAt": "2026-01-03T14:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Attio",
        "iban": "DE33302042892660620",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ab957r4fsqr9ektq25vhjmz0kp",
      "createdAt": "2026-01-03T14:00:00.000Z",
      "updatedAt": "2026-01-03T14:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 48,
      "currency": "EUR",
      "description": "Calendly",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_xw58q1t7xj14xjfjy28rtwqzbq",
      "fspDate": "2026-01-03T13:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0xe86j572rh",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T13:00:00.000Z",
        "valueDateTime": "2026-01-03T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-48.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Calendly",
        "remittanceInformationUnstructuredArray": [
          "Calendly"
        ],
        "debtorName": "Calendly"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtc5eshspk6kqa7yaywk",
      "clustering": {
        "description": "Calendly",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Calendly' from 'Calendly'",
        "updatedAt": "2025-09-27T10:50:52.375Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_071pt7zq5h47qrgkspj49a8f8h",
      "createdAt": "2026-01-03T11:00:00.000Z",
      "updatedAt": "2026-01-03T11:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 15.6,
      "currency": "EUR",
      "description": "Sumup *taxi Paul Barr",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_gfmmpm2f6mcxrg38300bx7yts6",
      "fspDate": "2026-01-03T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg247ae8pvk26khggjqtwb",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T10:00:00.000Z",
        "valueDateTime": "2026-01-03T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-15.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *taxi Paul Barr",
        "remittanceInformationUnstructuredArray": [
          "Sumup *taxi Paul Barr"
        ],
        "debtorName": "Paul Barr"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Taxi",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Taxi' from 'Sumup *taxi Paul Barr', removing the 'Sumup *' prefix and 'Paul Barr' location details",
        "updatedAt": "2025-09-27T10:55:13.243Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4bzt2am6y52fa14jrqgxz9sq2j",
      "createdAt": "2026-01-03T11:00:00.000Z",
      "updatedAt": "2026-01-03T11:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 3214.25,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_414qjew095r2qphfykcwz35ess",
      "fspDate": "2026-01-03T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k21rq21jf2181cbh5fy3hya9",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T10:00:00.000Z",
        "valueDateTime": "2026-01-03T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-3214.25",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the description for the currency conversion transaction.",
        "updatedAt": "2025-09-27T10:43:55.482Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0p46hb4pt1q02fh8am38d8egj5",
      "createdAt": "2026-01-03T11:00:00.000Z",
      "updatedAt": "2026-01-03T11:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_wtcz0e9kj0mz7p6y5qrdnavg1m",
      "fspDate": "2026-01-03T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk228cvqqmyw6",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T10:00:00.000Z",
        "valueDateTime": "2026-01-03T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Burger Cartel' from 'Burger Cartel Limited'",
        "updatedAt": "2025-09-27T10:54:50.809Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nfwzy2germvhgftjahtczs6mhk",
      "createdAt": "2026-01-03T11:00:00.000Z",
      "updatedAt": "2026-01-03T11:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.17,
      "currency": "EUR",
      "description": "Payment to Don Canizales: DC-202601-7023",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_55bqsyyybvzhwbv9b5zg3sq1e1",
      "fspDate": "2026-01-03T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_55bqsyyybvzhwbv9b5zg3sq1e1",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T11:00:00.000Z",
        "valueDateTime": "2026-01-03T11:00:00.000Z",
        "transactionAmount": {
          "amount": "15.17",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Don Canizales: DC-202601-7023",
        "remittanceInformationUnstructuredArray": [
          "Payment to Don Canizales",
          "DC-202601-7023"
        ],
        "debtorName": "Don Canizales"
      },
      "paymentId": null,
      "reference": "DC-202601-7023",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "clustering": {
        "description": "Don Canizales",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Don Canizales' based on payment details",
        "updatedAt": "2026-01-03T11:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Don Canizales",
        "iban": "DE26550170228563484",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7x037273hkfqnsk5vbh7tga321",
      "createdAt": "2026-01-03T10:06:00.000Z",
      "updatedAt": "2026-01-03T10:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 53431.18,
      "currency": "GBP",
      "description": "Payment from TechCorp Industries - INV-202601-6598",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rdhg4rcqvcqer3wjjjpjeapasy",
      "fspDate": "2026-01-03T09:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rdhg4rcqvcqer3wjjjpjeapasy",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T10:06:00.000Z",
        "valueDateTime": "2026-01-03T10:06:00.000Z",
        "transactionAmount": {
          "amount": "53431.18",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from TechCorp Industries - INV-202601-6598",
        "remittanceInformationUnstructuredArray": [
          "Payment from TechCorp Industries",
          "INV-202601-6598"
        ],
        "creditorName": "TechCorp Industries"
      },
      "paymentId": null,
      "reference": "INV-202601-6598",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_hkz708jvra375hd19t65j65vvt",
      "clustering": {
        "description": "TechCorp Industries",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'TechCorp Industries'",
        "updatedAt": "2026-01-03T10:06:00.000Z"
      },
      "payer": {
        "name": "TechCorp Industries",
        "iban": null,
        "bic": null,
        "sortCode": "826378",
        "accountNumber": "28451107"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_shyzwn94vjfv1d973z449jbvd3",
      "createdAt": "2026-01-03T09:31:00.000Z",
      "updatedAt": "2026-01-03T09:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 11.99,
      "currency": "EUR",
      "description": "Payment to Beanhive: B-202601-4681",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_e7mvz3zgg2cd1928p10ajsejbs",
      "fspDate": "2026-01-03T08:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_e7mvz3zgg2cd1928p10ajsejbs",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T09:31:00.000Z",
        "valueDateTime": "2026-01-03T09:31:00.000Z",
        "transactionAmount": {
          "amount": "11.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Beanhive: B-202601-4681",
        "remittanceInformationUnstructuredArray": [
          "Payment to Beanhive",
          "B-202601-4681"
        ],
        "debtorName": "Beanhive"
      },
      "paymentId": null,
      "reference": "B-202601-4681",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmacweshspkk5mv2ktdq4",
      "clustering": {
        "description": "Beanhive",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Beanhive' based on payment details",
        "updatedAt": "2026-01-03T09:31:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Beanhive",
        "iban": "DE69187569254724984",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_dcn2d2kmpfqzttw4j6fskkqskk",
      "createdAt": "2026-01-02T16:39:00.000Z",
      "updatedAt": "2026-01-02T16:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 24.13,
      "currency": "EUR",
      "description": "Payment to Tang: T-202601-8992",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w41myr71kg176a2yr81qrmnb61",
      "fspDate": "2026-01-02T15:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w41myr71kg176a2yr81qrmnb61",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T16:39:00.000Z",
        "valueDateTime": "2026-01-02T16:39:00.000Z",
        "transactionAmount": {
          "amount": "24.13",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tang: T-202601-8992",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tang",
          "T-202601-8992"
        ],
        "debtorName": "Tang"
      },
      "paymentId": null,
      "reference": "T-202601-8992",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gseshspjyrwgx4ccwg",
      "clustering": {
        "description": "Tang",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tang' based on payment details",
        "updatedAt": "2026-01-02T16:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tang",
        "iban": "DE68118462676982180",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_29j309gpf3yxjpm6g3r61vhkek",
      "createdAt": "2026-01-02T16:07:00.000Z",
      "updatedAt": "2026-01-02T16:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 22.29,
      "currency": "EUR",
      "description": "Payment to Salt Cellar Cafe: SCC-202601-2122",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_m2vj0714vbvqdawrtbrgtc2zh1",
      "fspDate": "2026-01-02T15:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_m2vj0714vbvqdawrtbrgtc2zh1",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T16:07:00.000Z",
        "valueDateTime": "2026-01-02T16:07:00.000Z",
        "transactionAmount": {
          "amount": "22.29",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Salt Cellar Cafe: SCC-202601-2122",
        "remittanceInformationUnstructuredArray": [
          "Payment to Salt Cellar Cafe",
          "SCC-202601-2122"
        ],
        "debtorName": "Salt Cellar Cafe"
      },
      "paymentId": null,
      "reference": "SCC-202601-2122",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0x9eshspkzthwr7rcm3",
      "clustering": {
        "description": "Salt Cellar Cafe",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Salt Cellar Cafe' based on payment details",
        "updatedAt": "2026-01-02T16:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Salt Cellar Cafe",
        "iban": "DE35091239479755784",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_10twnj0zdqe569t6r0xn108q11",
      "createdAt": "2026-01-02T15:00:00.000Z",
      "updatedAt": "2026-01-02T15:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_REFUND",
      "isCredit": true,
      "amount": 0.93,
      "currency": "EUR",
      "description": "Refund from Paddle.net* Geoguessr",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_sdsepqc4bhgv3j28d5p3sj572x",
      "fspDate": "2026-01-02T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k26xg786fk7s0pkptygbe5hm",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T14:00:00.000Z",
        "valueDateTime": "2026-01-02T14:00:00.000Z",
        "transactionAmount": {
          "amount": "0.93",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_REFUND",
        "remittanceInformationUnstructured": "Refund from Paddle.net* Geoguessr",
        "remittanceInformationUnstructuredArray": [
          "Refund from Paddle.net* Geoguessr"
        ],
        "debtorName": "Paddle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax3veshspjmhphswafsq",
      "clustering": {
        "description": "Paddle",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Paddle' from 'Refund from Paddle.net* Geoguessr'",
        "updatedAt": "2025-09-27T10:42:40.445Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nrmj0027bhknmb6bncb3zb57c4",
      "createdAt": "2026-01-02T15:00:00.000Z",
      "updatedAt": "2026-01-02T15:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4909.83,
      "currency": "EUR",
      "description": "To Hugo Weber",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_bmbkvs5ektwgr41gzs4zdw7ak7",
      "fspDate": "2026-01-02T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1e0y40eskgq",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T14:00:00.000Z",
        "valueDateTime": "2026-01-02T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-4909.83",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Hugo Weber",
        "remittanceInformationUnstructuredArray": [
          "To Hugo Weber"
        ],
        "debtorName": "Hugo Weber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtteshspj9hmeqmzmdw",
      "clustering": {
        "description": "Hugo Weber",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Hugo Weber' from 'To Hugo Weber'.",
        "updatedAt": "2025-09-27T10:52:47.370Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4r33g0a20xgd7g70ar1vwbpy29",
      "createdAt": "2026-01-02T13:47:00.000Z",
      "updatedAt": "2026-01-02T13:47:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 37815.43,
      "currency": "GBP",
      "description": "Payment from DataDriven Analytics - INV-202601-8350",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jb472cccc65c4dkrr8x9hv8n2v",
      "fspDate": "2026-01-02T12:47:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jb472cccc65c4dkrr8x9hv8n2v",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T13:47:00.000Z",
        "valueDateTime": "2026-01-02T13:47:00.000Z",
        "transactionAmount": {
          "amount": "37815.43",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from DataDriven Analytics - INV-202601-8350",
        "remittanceInformationUnstructuredArray": [
          "Payment from DataDriven Analytics",
          "INV-202601-8350"
        ],
        "creditorName": "DataDriven Analytics"
      },
      "paymentId": null,
      "reference": "INV-202601-8350",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_jy64mwn8y868akxp0c6s337dms",
      "clustering": {
        "description": "DataDriven Analytics",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'DataDriven Analytics'",
        "updatedAt": "2026-01-02T13:47:00.000Z"
      },
      "payer": {
        "name": "DataDriven Analytics",
        "iban": null,
        "bic": null,
        "sortCode": "426522",
        "accountNumber": "76396418"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5t81m2qe6rkac7h2bnxxn7k04r",
      "createdAt": "2026-01-02T12:34:00.000Z",
      "updatedAt": "2026-01-02T12:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 13.32,
      "currency": "EUR",
      "description": "Payment to Tortilla Latin Food: TLF-202601-1096",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_j4abwz89f134c315x9n0c20mdb",
      "fspDate": "2026-01-02T11:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_j4abwz89f134c315x9n0c20mdb",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T12:34:00.000Z",
        "valueDateTime": "2026-01-02T12:34:00.000Z",
        "transactionAmount": {
          "amount": "13.32",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tortilla Latin Food: TLF-202601-1096",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tortilla Latin Food",
          "TLF-202601-1096"
        ],
        "debtorName": "Tortilla Latin Food"
      },
      "paymentId": null,
      "reference": "TLF-202601-1096",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspgkeshspmp0mmzf2w0c",
      "clustering": {
        "description": "Tortilla Latin Food",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tortilla Latin Food' based on payment details",
        "updatedAt": "2026-01-02T12:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tortilla Latin Food",
        "iban": "DE19561581300506676",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qzpjyszd5mn82ag6cxbfpa8b56",
      "createdAt": "2026-01-02T12:00:00.000Z",
      "updatedAt": "2026-01-02T12:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 146.48,
      "currency": "GBP",
      "description": "Ryanair",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_rgnfey317vbd74fae36dgmk2m6",
      "fspDate": "2026-01-02T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8j6kx2m6znp",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T11:00:00.000Z",
        "valueDateTime": "2026-01-02T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-146.48",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Ryanair",
        "remittanceInformationUnstructuredArray": [
          "Ryanair"
        ],
        "debtorName": "Ryanair"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctphbeshspmx6q13ktd74",
      "clustering": {
        "description": "Ryanair",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Ryanair' from 'Ryanair'",
        "updatedAt": "2025-09-29T18:26:40.982Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_e2z2xqtrrcmt7m65jtzpdk05wv",
      "createdAt": "2026-01-02T11:48:00.000Z",
      "updatedAt": "2026-01-02T11:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 601.26,
      "currency": "EUR",
      "description": "Payment to Clayton Hotel Burlington: CHB-202601-2875",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_d6p23d0ak41mhkq38fja8p7706",
      "fspDate": "2026-01-02T10:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_d6p23d0ak41mhkq38fja8p7706",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T11:48:00.000Z",
        "valueDateTime": "2026-01-02T11:48:00.000Z",
        "transactionAmount": {
          "amount": "601.26",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Burlington: CHB-202601-2875",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Burlington",
          "CHB-202601-2875"
        ],
        "debtorName": "Clayton Hotel Burlington"
      },
      "paymentId": null,
      "reference": "CHB-202601-2875",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crppkeshspmfw2e0m4xdm",
      "clustering": {
        "description": "Clayton Hotel Burlington",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Burlington' based on payment details",
        "updatedAt": "2026-01-02T11:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Burlington",
        "iban": "DE44424711646892560",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mffd5684qd1twtjsxmvbcjnwvm",
      "createdAt": "2026-01-02T11:39:00.000Z",
      "updatedAt": "2026-01-02T11:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 514.64,
      "currency": "GBP",
      "description": "Payment to Ginger Bistro: GB-202601-8089",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_db4c1gns9sh9nhceqx5tpswdjj",
      "fspDate": "2026-01-02T10:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_db4c1gns9sh9nhceqx5tpswdjj",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T11:39:00.000Z",
        "valueDateTime": "2026-01-02T11:39:00.000Z",
        "transactionAmount": {
          "amount": "514.64",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Ginger Bistro: GB-202601-8089",
        "remittanceInformationUnstructuredArray": [
          "Payment to Ginger Bistro",
          "GB-202601-8089"
        ],
        "debtorName": "Ginger Bistro"
      },
      "paymentId": null,
      "reference": "GB-202601-8089",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk6skfvhrjntfdd23av1a",
      "clustering": {
        "description": "Ginger Bistro",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Ginger Bistro' based on payment details",
        "updatedAt": "2026-01-02T11:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Ginger Bistro",
        "iban": null,
        "bic": null,
        "sortCode": "967172",
        "accountNumber": "11859718"
      }
    },
    {
      "id": "txn_bc95vesvvhsm3ryme8g3w0h53a",
      "createdAt": "2026-01-02T11:39:00.000Z",
      "updatedAt": "2026-01-02T11:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 115,
      "currency": "GBP",
      "description": "Payment to Clayton Hotel Belfast: CHB-202601-4217",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_26yc60p42mypxv5ww7sy61961j",
      "fspDate": "2026-01-02T10:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_26yc60p42mypxv5ww7sy61961j",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T11:39:00.000Z",
        "valueDateTime": "2026-01-02T11:39:00.000Z",
        "transactionAmount": {
          "amount": "115.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Belfast: CHB-202601-4217",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Belfast",
          "CHB-202601-4217"
        ],
        "debtorName": "Clayton Hotel Belfast"
      },
      "paymentId": null,
      "reference": "CHB-202601-4217",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4hyfvhrjnt1zqpqqyns",
      "clustering": {
        "description": "Clayton Hotel Belfast",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Belfast' based on payment details",
        "updatedAt": "2026-01-02T11:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Belfast",
        "iban": null,
        "bic": null,
        "sortCode": "657240",
        "accountNumber": "43893185"
      }
    },
    {
      "id": "txn_rf5eptbpqbtt1eywkdx4h8jcbe",
      "createdAt": "2026-01-02T11:00:00.000Z",
      "updatedAt": "2026-01-02T11:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 615,
      "currency": "EUR",
      "description": "Payment to Denis Breen & Co Ltd: INV-11134",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_bpq0bkn5ce354axx466tvpsaw8",
      "fspDate": "2026-01-02T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3jn5vbre8prs3vbznnpz7jc",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T10:00:00.000Z",
        "valueDateTime": "2026-01-02T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-615.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Denis Breen & Co Ltd: INV-11134",
        "remittanceInformationUnstructuredArray": [
          "Payment to Denis Breen & Co Ltd: INV-11134"
        ],
        "debtorName": "Denis Breen & Co Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zb1eshspj0854px1k2v",
      "clustering": {
        "description": "Denis Breen & Co",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Denis Breen & Co' from 'Payment to Denis Breen & Co Ltd: INV-11134'",
        "updatedAt": "2025-09-27T10:40:26.797Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yv900tjedbaw5zk7xp80y31wyx",
      "createdAt": "2026-01-02T10:15:00.000Z",
      "updatedAt": "2026-01-02T10:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.31,
      "currency": "EUR",
      "description": "Payment to Seoul Kitchen: SK-202601-6969",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_m7kd3gnv53m3e6spzz9cqvx0vy",
      "fspDate": "2026-01-02T09:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_m7kd3gnv53m3e6spzz9cqvx0vy",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T10:15:00.000Z",
        "valueDateTime": "2026-01-02T10:15:00.000Z",
        "transactionAmount": {
          "amount": "15.31",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Seoul Kitchen: SK-202601-6969",
        "remittanceInformationUnstructuredArray": [
          "Payment to Seoul Kitchen",
          "SK-202601-6969"
        ],
        "debtorName": "Seoul Kitchen"
      },
      "paymentId": null,
      "reference": "SK-202601-6969",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pzaeshspjhkemvf76tx",
      "clustering": {
        "description": "Seoul Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Seoul Kitchen' based on payment details",
        "updatedAt": "2026-01-02T10:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Seoul Kitchen",
        "iban": "DE79002673427435540",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yfa3gbad6283yxnqtkyg16vtnj",
      "createdAt": "2026-01-02T10:00:00.000Z",
      "updatedAt": "2026-01-02T10:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 6031.24,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_rk02jjq478txfhcm15t7p0w4s1",
      "fspDate": "2026-01-02T09:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk82bc455646n",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T09:00:00.000Z",
        "valueDateTime": "2026-01-02T09:00:00.000Z",
        "transactionAmount": {
          "amount": "6031.24",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code and extracted 'Currency Exchange' as the description",
        "updatedAt": "2025-09-29T18:24:29.651Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5j8vqejtqjwwfgs7wm89hfrzk7",
      "createdAt": "2026-01-02T10:00:00.000Z",
      "updatedAt": "2026-01-02T10:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 41.68,
      "currency": "EUR",
      "description": "Wispr",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_83q1fbhgn7qtgs55h7et1f0fcf",
      "fspDate": "2026-01-02T09:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0e8rfh4exraqe0f7bann4r5",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T09:00:00.000Z",
        "valueDateTime": "2026-01-02T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-41.68",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Wispr",
        "remittanceInformationUnstructuredArray": [
          "Wispr"
        ],
        "debtorName": "Wispr"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax6ceshspjngxatk00nd",
      "clustering": {
        "description": "Wispr",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Wispr' from 'Wispr'",
        "updatedAt": "2025-09-27T10:49:37.631Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fss96j9bvp9tb59d9jdj95bbxy",
      "createdAt": "2026-01-02T09:00:00.000Z",
      "updatedAt": "2026-01-02T09:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3950,
      "currency": "GBP",
      "description": "Salary - Priya Sharma - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_732sd9mqde2wmrm39wjkr5agmt",
      "fspDate": "2026-01-02T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_ym57gwctrk18dm2nd00kyrmd2t",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T08:00:00.000Z",
        "valueDateTime": "2026-01-02T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-3950.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Priya Sharma",
        "remittanceInformationUnstructuredArray": [
          "Salary - Priya Sharma"
        ]
      },
      "paymentId": "pmnt_9as0h59mrv08jj8391v0a02gej",
      "reference": "PAY-DEC-2025-SHARMA",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Priya Sharma",
        "iban": null,
        "bic": null,
        "sortCode": "30-15-89",
        "accountNumber": "56789012"
      }
    },
    {
      "id": "txn_wsxnfn9k23d0mj7mq355wgf59q",
      "createdAt": "2026-01-02T08:00:00.000Z",
      "updatedAt": "2026-01-02T08:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 3.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_4y6yfg1qm3q6kfjjyr3ndpyayf",
      "fspDate": "2026-01-02T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1x6vm04nxxr",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T07:00:00.000Z",
        "valueDateTime": "2026-01-02T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-3.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Companies Registration' from 'Companies Registration'.",
        "updatedAt": "2025-09-27T10:54:12.539Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9m4w4vcxew1ht2frsk3pdqwdkp",
      "createdAt": "2026-01-01T16:53:00.000Z",
      "updatedAt": "2026-01-01T16:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.57,
      "currency": "EUR",
      "description": "Payment to Tavily AI: TA-202601-3832",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_e2rtsbgfw3ndjh5a12txqct82t",
      "fspDate": "2026-01-01T15:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_e2rtsbgfw3ndjh5a12txqct82t",
        "bookingDate": "2026-01-01",
        "valueDate": "2026-01-01",
        "bookingDateTime": "2026-01-01T16:53:00.000Z",
        "valueDateTime": "2026-01-01T16:53:00.000Z",
        "transactionAmount": {
          "amount": "25.57",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tavily AI: TA-202601-3832",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tavily AI",
          "TA-202601-3832"
        ],
        "debtorName": "Tavily AI"
      },
      "paymentId": null,
      "reference": "TA-202601-3832",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ceerteshspk5wmka0h0ee",
      "clustering": {
        "description": "Tavily AI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tavily AI' based on payment details",
        "updatedAt": "2026-01-01T16:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tavily AI",
        "iban": "DE87211485002786600",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_tafgjyv576ecy3t3evw4425m36",
      "createdAt": "2026-01-01T15:49:00.000Z",
      "updatedAt": "2026-01-01T15:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 36076.42,
      "currency": "GBP",
      "description": "Payment from CloudFirst Technologies - INV-202601-5758",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_s5nay0gjwhg5bwxgw4aenzkdvc",
      "fspDate": "2026-01-01T14:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_s5nay0gjwhg5bwxgw4aenzkdvc",
        "bookingDate": "2026-01-01",
        "valueDate": "2026-01-01",
        "bookingDateTime": "2026-01-01T15:49:00.000Z",
        "valueDateTime": "2026-01-01T15:49:00.000Z",
        "transactionAmount": {
          "amount": "36076.42",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from CloudFirst Technologies - INV-202601-5758",
        "remittanceInformationUnstructuredArray": [
          "Payment from CloudFirst Technologies",
          "INV-202601-5758"
        ],
        "creditorName": "CloudFirst Technologies"
      },
      "paymentId": null,
      "reference": "INV-202601-5758",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_v3gga6hnqqf8p85ezhv67qxfkw",
      "clustering": {
        "description": "CloudFirst Technologies",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'CloudFirst Technologies'",
        "updatedAt": "2026-01-01T15:49:00.000Z"
      },
      "payer": {
        "name": "CloudFirst Technologies",
        "iban": null,
        "bic": null,
        "sortCode": "685344",
        "accountNumber": "81648199"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fmee0j36cryrn21354jy1v9p23",
      "createdAt": "2026-01-01T15:31:00.000Z",
      "updatedAt": "2026-01-01T15:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 39.49,
      "currency": "GBP",
      "description": "Payment to Financial Times: FT-202601-7707",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_g2g5f00j0xsk5nfg0s914py3xm",
      "fspDate": "2026-01-01T14:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_g2g5f00j0xsk5nfg0s914py3xm",
        "bookingDate": "2026-01-01",
        "valueDate": "2026-01-01",
        "bookingDateTime": "2026-01-01T15:31:00.000Z",
        "valueDateTime": "2026-01-01T15:31:00.000Z",
        "transactionAmount": {
          "amount": "39.49",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Financial Times: FT-202601-7707",
        "remittanceInformationUnstructuredArray": [
          "Payment to Financial Times",
          "FT-202601-7707"
        ],
        "debtorName": "Financial Times"
      },
      "paymentId": null,
      "reference": "FT-202601-7707",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gjeshspjygqrrg6sk5",
      "clustering": {
        "description": "Financial Times",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Financial Times' based on payment details",
        "updatedAt": "2026-01-01T15:31:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Financial Times",
        "iban": null,
        "bic": null,
        "sortCode": "518806",
        "accountNumber": "90658197"
      }
    },
    {
      "id": "txn_53w4x8t52hzneegec472vh6dcy",
      "createdAt": "2026-01-01T15:18:00.000Z",
      "updatedAt": "2026-01-01T15:18:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 26267.17,
      "currency": "GBP",
      "description": "Payment from SmartScale Solutions - INV-202601-8486",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2g839jvdpm2j6gbwn8yry578yh",
      "fspDate": "2026-01-01T14:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2g839jvdpm2j6gbwn8yry578yh",
        "bookingDate": "2026-01-01",
        "valueDate": "2026-01-01",
        "bookingDateTime": "2026-01-01T15:18:00.000Z",
        "valueDateTime": "2026-01-01T15:18:00.000Z",
        "transactionAmount": {
          "amount": "26267.17",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from SmartScale Solutions - INV-202601-8486",
        "remittanceInformationUnstructuredArray": [
          "Payment from SmartScale Solutions",
          "INV-202601-8486"
        ],
        "creditorName": "SmartScale Solutions"
      },
      "paymentId": null,
      "reference": "INV-202601-8486",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_k9wmdwkshbazmh9e7aq4wj85ej",
      "clustering": {
        "description": "SmartScale Solutions",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'SmartScale Solutions'",
        "updatedAt": "2026-01-01T15:18:00.000Z"
      },
      "payer": {
        "name": "SmartScale Solutions",
        "iban": null,
        "bic": null,
        "sortCode": "782286",
        "accountNumber": "77380939"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ajc6bww099qdpf3pr38vhkntxp",
      "createdAt": "2026-01-01T11:14:00.000Z",
      "updatedAt": "2026-01-01T11:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 21.27,
      "currency": "EUR",
      "description": "Payment to Anthony Moore: AM-202601-8803",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_s42zvcfx0gmnb8rr70bx6g2kcv",
      "fspDate": "2026-01-01T10:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_s42zvcfx0gmnb8rr70bx6g2kcv",
        "bookingDate": "2026-01-01",
        "valueDate": "2026-01-01",
        "bookingDateTime": "2026-01-01T11:14:00.000Z",
        "valueDateTime": "2026-01-01T11:14:00.000Z",
        "transactionAmount": {
          "amount": "21.27",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthony Moore: AM-202601-8803",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthony Moore",
          "AM-202601-8803"
        ],
        "debtorName": "Anthony Moore"
      },
      "paymentId": null,
      "reference": "AM-202601-8803",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a2keshspnzq7m9sbpn2",
      "clustering": {
        "description": "Anthony Moore",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthony Moore' based on payment details",
        "updatedAt": "2026-01-01T11:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthony Moore",
        "iban": "DE63697530329108550",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mzhn2z9s9w0kx3g1wgdckk6yk6",
      "createdAt": "2026-01-01T10:44:00.000Z",
      "updatedAt": "2026-01-01T10:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 807.52,
      "currency": "GBP",
      "description": "Payment to Charles Russell Speechlys: CRS-202601-3676",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_q8ffvad6xmvd8rqknn076bc26t",
      "fspDate": "2026-01-01T09:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_q8ffvad6xmvd8rqknn076bc26t",
        "bookingDate": "2026-01-01",
        "valueDate": "2026-01-01",
        "bookingDateTime": "2026-01-01T10:44:00.000Z",
        "valueDateTime": "2026-01-01T10:44:00.000Z",
        "transactionAmount": {
          "amount": "807.52",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Charles Russell Speechlys: CRS-202601-3676",
        "remittanceInformationUnstructuredArray": [
          "Payment to Charles Russell Speechlys",
          "CRS-202601-3676"
        ],
        "debtorName": "Charles Russell Speechlys"
      },
      "paymentId": null,
      "reference": "CRS-202601-3676",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgh1fvhrjp0n7wme8cae",
      "clustering": {
        "description": "Charles Russell Speechlys",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Charles Russell Speechlys' based on payment details",
        "updatedAt": "2026-01-01T10:44:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Charles Russell Speechlys",
        "iban": null,
        "bic": null,
        "sortCode": "562984",
        "accountNumber": "73307674"
      }
    },
    {
      "id": "txn_ey7pje9rh7xf5016nmgv89eybr",
      "createdAt": "2026-01-01T10:25:00.000Z",
      "updatedAt": "2026-01-01T10:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 57.02,
      "currency": "GBP",
      "description": "Payment to GoCardless: G-202601-9031",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0wnznckkbjrhe16ykb6zkr59m0",
      "fspDate": "2026-01-01T09:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0wnznckkbjrhe16ykb6zkr59m0",
        "bookingDate": "2026-01-01",
        "valueDate": "2026-01-01",
        "bookingDateTime": "2026-01-01T10:25:00.000Z",
        "valueDateTime": "2026-01-01T10:25:00.000Z",
        "transactionAmount": {
          "amount": "57.02",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GoCardless: G-202601-9031",
        "remittanceInformationUnstructuredArray": [
          "Payment to GoCardless",
          "G-202601-9031"
        ],
        "debtorName": "GoCardless"
      },
      "paymentId": null,
      "reference": "G-202601-9031",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5k6eshspjzd728cagsr",
      "clustering": {
        "description": "GoCardless",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'GoCardless' based on payment details",
        "updatedAt": "2026-01-01T10:25:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GoCardless",
        "iban": null,
        "bic": null,
        "sortCode": "874731",
        "accountNumber": "35253894"
      }
    },
    {
      "id": "txn_31685qj1xpj9pjb2sqdcwrpjpp",
      "createdAt": "2026-01-01T09:56:00.000Z",
      "updatedAt": "2026-01-01T09:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7793.33,
      "currency": "EUR",
      "description": "Payment to Cormac Byrne: CB-202601-1740",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vja09xdmmgy17z6a49mjdttbv7",
      "fspDate": "2026-01-01T08:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vja09xdmmgy17z6a49mjdttbv7",
        "bookingDate": "2026-01-01",
        "valueDate": "2026-01-01",
        "bookingDateTime": "2026-01-01T09:56:00.000Z",
        "valueDateTime": "2026-01-01T09:56:00.000Z",
        "transactionAmount": {
          "amount": "7793.33",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cormac Byrne: CB-202601-1740",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cormac Byrne",
          "CB-202601-1740"
        ],
        "debtorName": "Cormac Byrne"
      },
      "paymentId": null,
      "reference": "CB-202601-1740",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zspeshspj7tfmtn8s05",
      "clustering": {
        "description": "Cormac Byrne",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cormac Byrne' based on payment details",
        "updatedAt": "2026-01-01T09:56:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cormac Byrne",
        "iban": "DE69424858237964620",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pw02smn0hb7ka2nmb4vh4jp58h",
      "createdAt": "2025-12-31T15:26:00.000Z",
      "updatedAt": "2025-12-31T15:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 38991.74,
      "currency": "EUR",
      "description": "Payment from Nexus Consulting GmbH - INV-202512-8291",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_sjf2wkm0tkd9texzjbx2jrqj28",
      "fspDate": "2025-12-31T14:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_sjf2wkm0tkd9texzjbx2jrqj28",
        "bookingDate": "2025-12-31",
        "valueDate": "2025-12-31",
        "bookingDateTime": "2025-12-31T15:26:00.000Z",
        "valueDateTime": "2025-12-31T15:26:00.000Z",
        "transactionAmount": {
          "amount": "38991.74",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nexus Consulting GmbH - INV-202512-8291",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nexus Consulting GmbH",
          "INV-202512-8291"
        ],
        "creditorName": "Nexus Consulting GmbH"
      },
      "paymentId": null,
      "reference": "INV-202512-8291",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_631832eta7hj1n2x0gedv5fm59",
      "clustering": {
        "description": "Nexus Consulting GmbH",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nexus Consulting GmbH'",
        "updatedAt": "2025-12-31T15:26:00.000Z"
      },
      "payer": {
        "name": "Nexus Consulting GmbH",
        "iban": "DE82166890948980600",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8tbv3mzm7y6r0mv1ejn1zbzmvg",
      "createdAt": "2025-12-31T10:25:00.000Z",
      "updatedAt": "2025-12-31T10:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12.25,
      "currency": "EUR",
      "description": "Payment to Mama's Boy: MB-202512-4031",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_29wzecfbp6447rpwwqrbxfvxc8",
      "fspDate": "2025-12-31T09:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_29wzecfbp6447rpwwqrbxfvxc8",
        "bookingDate": "2025-12-31",
        "valueDate": "2025-12-31",
        "bookingDateTime": "2025-12-31T10:25:00.000Z",
        "valueDateTime": "2025-12-31T10:25:00.000Z",
        "transactionAmount": {
          "amount": "12.25",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mama's Boy: MB-202512-4031",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mama's Boy",
          "MB-202512-4031"
        ],
        "debtorName": "Mama's Boy"
      },
      "paymentId": null,
      "reference": "MB-202512-4031",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcneshspna4jnfvyh0c",
      "clustering": {
        "description": "Mama's Boy",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mama's Boy' based on payment details",
        "updatedAt": "2025-12-31T10:25:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mama's Boy",
        "iban": "DE76297951689273470",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ry6mapksvkrwpre2kv39yy7xqy",
      "createdAt": "2025-12-31T09:41:00.000Z",
      "updatedAt": "2025-12-31T09:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 24511.74,
      "currency": "EUR",
      "description": "Payment from Alpine Software SA - INV-202512-6693",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_kyyrp3zbvqeeztq5vy2dcsdrnb",
      "fspDate": "2025-12-31T08:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_kyyrp3zbvqeeztq5vy2dcsdrnb",
        "bookingDate": "2025-12-31",
        "valueDate": "2025-12-31",
        "bookingDateTime": "2025-12-31T09:41:00.000Z",
        "valueDateTime": "2025-12-31T09:41:00.000Z",
        "transactionAmount": {
          "amount": "24511.74",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Alpine Software SA - INV-202512-6693",
        "remittanceInformationUnstructuredArray": [
          "Payment from Alpine Software SA",
          "INV-202512-6693"
        ],
        "creditorName": "Alpine Software SA"
      },
      "paymentId": null,
      "reference": "INV-202512-6693",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_nk7g93a6fpe8ybm4hppdmmfgsw",
      "clustering": {
        "description": "Alpine Software SA",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Alpine Software SA'",
        "updatedAt": "2025-12-31T09:41:00.000Z"
      },
      "payer": {
        "name": "Alpine Software SA",
        "iban": "DE56775638210031330",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ehz8phxtmgf7aqvkg2m63f7rgf",
      "createdAt": "2025-12-31T09:36:00.000Z",
      "updatedAt": "2025-12-31T09:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2693.21,
      "currency": "EUR",
      "description": "Payment to Marta Kowalska Consulting: MKC-202512-4994",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_100ab5q6y0z39k1mcw2s1bzccn",
      "fspDate": "2025-12-31T08:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_100ab5q6y0z39k1mcw2s1bzccn",
        "bookingDate": "2025-12-31",
        "valueDate": "2025-12-31",
        "bookingDateTime": "2025-12-31T09:36:00.000Z",
        "valueDateTime": "2025-12-31T09:36:00.000Z",
        "transactionAmount": {
          "amount": "2693.21",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marta Kowalska Consulting: MKC-202512-4994",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marta Kowalska Consulting",
          "MKC-202512-4994"
        ],
        "debtorName": "Marta Kowalska Consulting"
      },
      "paymentId": null,
      "reference": "MKC-202512-4994",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj39eshspnh92mjbyz8s",
      "clustering": {
        "description": "Marta Kowalska Consulting",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marta Kowalska Consulting' based on payment details",
        "updatedAt": "2025-12-31T09:36:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marta Kowalska Consulting",
        "iban": "DE78756465500077800",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_v8bt9g323rd324e0gy46mzap0d",
      "createdAt": "2025-12-30T16:19:00.000Z",
      "updatedAt": "2025-12-30T16:19:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 119.96,
      "currency": "EUR",
      "description": "Payment to Giftmall.es: G-202512-7757",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_acfty8ha60r8gp1ry15ydhembe",
      "fspDate": "2025-12-30T15:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_acfty8ha60r8gp1ry15ydhembe",
        "bookingDate": "2025-12-30",
        "valueDate": "2025-12-30",
        "bookingDateTime": "2025-12-30T16:19:00.000Z",
        "valueDateTime": "2025-12-30T16:19:00.000Z",
        "transactionAmount": {
          "amount": "119.96",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Giftmall.es: G-202512-7757",
        "remittanceInformationUnstructuredArray": [
          "Payment to Giftmall.es",
          "G-202512-7757"
        ],
        "debtorName": "Giftmall.es"
      },
      "paymentId": null,
      "reference": "G-202512-7757",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpfaeshspmwtrg2tk9zk",
      "clustering": {
        "description": "Giftmall.es",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Giftmall.es' based on payment details",
        "updatedAt": "2025-12-30T16:19:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Giftmall.es",
        "iban": "DE74758473114181000",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4gdk887hcw0wy413rc6hd0vcg7",
      "createdAt": "2025-12-30T16:06:00.000Z",
      "updatedAt": "2025-12-30T16:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 35.75,
      "currency": "EUR",
      "description": "Payment to FREE NOW: FN-202512-5404",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_c0pgnvfb51yft1fb2xzqea2f6x",
      "fspDate": "2025-12-30T15:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_c0pgnvfb51yft1fb2xzqea2f6x",
        "bookingDate": "2025-12-30",
        "valueDate": "2025-12-30",
        "bookingDateTime": "2025-12-30T16:06:00.000Z",
        "valueDateTime": "2025-12-30T16:06:00.000Z",
        "transactionAmount": {
          "amount": "35.75",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to FREE NOW: FN-202512-5404",
        "remittanceInformationUnstructuredArray": [
          "Payment to FREE NOW",
          "FN-202512-5404"
        ],
        "debtorName": "FREE NOW"
      },
      "paymentId": null,
      "reference": "FN-202512-5404",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj31eshspnh3qzqhcd5r",
      "clustering": {
        "description": "FREE NOW",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'FREE NOW' based on payment details",
        "updatedAt": "2025-12-30T16:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "FREE NOW",
        "iban": "DE58546057547560590",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_y9q2njzr78nqg6fwbk3hex4c33",
      "createdAt": "2025-12-30T15:33:00.000Z",
      "updatedAt": "2025-12-30T15:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2776.58,
      "currency": "USD",
      "description": "Payment to Anthropic PBC: AP-202512-9595",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_29tj2x2pw4bvk235a5xa6r9v13",
      "fspDate": "2025-12-30T14:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_29tj2x2pw4bvk235a5xa6r9v13",
        "bookingDate": "2025-12-30",
        "valueDate": "2025-12-30",
        "bookingDateTime": "2025-12-30T15:33:00.000Z",
        "valueDateTime": "2025-12-30T15:33:00.000Z",
        "transactionAmount": {
          "amount": "2776.58",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic PBC: AP-202512-9595",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic PBC",
          "AP-202512-9595"
        ],
        "debtorName": "Anthropic PBC"
      },
      "paymentId": null,
      "reference": "AP-202512-9595",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_vnn6fxhm5daqv7bh39b88k2t9d",
      "clustering": {
        "description": "Anthropic PBC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic PBC' based on payment details",
        "updatedAt": "2025-12-30T15:33:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic PBC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_rz7sqwwb00qzcfwthfpaxjka58",
      "createdAt": "2025-12-30T10:17:00.000Z",
      "updatedAt": "2025-12-30T10:17:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 147.13,
      "currency": "GBP",
      "description": "Payment to Ryanair: R-202512-9841",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_b8nk7e6m6yft48cfkwnpqhn3ms",
      "fspDate": "2025-12-30T09:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_b8nk7e6m6yft48cfkwnpqhn3ms",
        "bookingDate": "2025-12-30",
        "valueDate": "2025-12-30",
        "bookingDateTime": "2025-12-30T10:17:00.000Z",
        "valueDateTime": "2025-12-30T10:17:00.000Z",
        "transactionAmount": {
          "amount": "147.13",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Ryanair: R-202512-9841",
        "remittanceInformationUnstructuredArray": [
          "Payment to Ryanair",
          "R-202512-9841"
        ],
        "debtorName": "Ryanair"
      },
      "paymentId": null,
      "reference": "R-202512-9841",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctphbeshspmx6q13ktd74",
      "clustering": {
        "description": "Ryanair",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Ryanair' based on payment details",
        "updatedAt": "2025-12-30T10:17:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Ryanair",
        "iban": null,
        "bic": null,
        "sortCode": "797679",
        "accountNumber": "62999531"
      }
    },
    {
      "id": "txn_01k6bbebzafvhrjmw7qjc25y7b",
      "createdAt": "2025-12-29T16:31:00.000Z",
      "updatedAt": "2025-12-29T16:31:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 10000,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8mhrtvhc2b6",
      "fspDate": "2025-12-29T15:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8mhrtvhc2b6",
        "bookingDate": "2025-12-29",
        "valueDate": "2025-12-29",
        "bookingDateTime": "2025-12-29T15:31:00.000Z",
        "valueDateTime": "2025-12-29T15:31:00.000Z",
        "transactionAmount": {
          "amount": "10000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified this as a currency exchange transaction based on the 'EXCHANGE' code in the raw transaction record",
        "updatedAt": "2025-09-29T18:27:23.763Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xkkanyv9rpejmgrbs851wm9p8a",
      "createdAt": "2025-12-29T14:40:00.000Z",
      "updatedAt": "2025-12-29T14:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5.04,
      "currency": "EUR",
      "description": "Payment to Expenses App: EA-202512-2799",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_r5w6t62x2w3na29a8khwwxwj4w",
      "fspDate": "2025-12-29T13:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_r5w6t62x2w3na29a8khwwxwj4w",
        "bookingDate": "2025-12-29",
        "valueDate": "2025-12-29",
        "bookingDateTime": "2025-12-29T14:40:00.000Z",
        "valueDateTime": "2025-12-29T14:40:00.000Z",
        "transactionAmount": {
          "amount": "5.04",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Expenses App: EA-202512-2799",
        "remittanceInformationUnstructuredArray": [
          "Payment to Expenses App",
          "EA-202512-2799"
        ],
        "debtorName": "Expenses App"
      },
      "paymentId": null,
      "reference": "EA-202512-2799",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mw3eshspjaesn0nt38r",
      "clustering": {
        "description": "Expenses App",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Expenses App' based on payment details",
        "updatedAt": "2025-12-29T14:40:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Expenses App",
        "iban": "DE41621356357159064",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bgf9mddkz0b0yd4swwtd698649",
      "createdAt": "2025-12-29T12:42:00.000Z",
      "updatedAt": "2025-12-29T12:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 48.92,
      "currency": "EUR",
      "description": "Payment to Calendly: C-202512-9854",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4mkzpar150mcdyz5b3d10hh5jp",
      "fspDate": "2025-12-29T11:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4mkzpar150mcdyz5b3d10hh5jp",
        "bookingDate": "2025-12-29",
        "valueDate": "2025-12-29",
        "bookingDateTime": "2025-12-29T12:42:00.000Z",
        "valueDateTime": "2025-12-29T12:42:00.000Z",
        "transactionAmount": {
          "amount": "48.92",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Calendly: C-202512-9854",
        "remittanceInformationUnstructuredArray": [
          "Payment to Calendly",
          "C-202512-9854"
        ],
        "debtorName": "Calendly"
      },
      "paymentId": null,
      "reference": "C-202512-9854",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtc5eshspk6kqa7yaywk",
      "clustering": {
        "description": "Calendly",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Calendly' based on payment details",
        "updatedAt": "2025-12-29T12:42:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Calendly",
        "iban": "DE83653075647145150",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_akkq8q4pm8qshapapqg42bt0ze",
      "createdAt": "2025-12-29T12:25:00.000Z",
      "updatedAt": "2025-12-29T12:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 23714.06,
      "currency": "GBP",
      "description": "Payment from SmartScale Solutions - INV-202512-5341",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_njvw3hescfped3cze9vwdq6rz1",
      "fspDate": "2025-12-29T11:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_njvw3hescfped3cze9vwdq6rz1",
        "bookingDate": "2025-12-29",
        "valueDate": "2025-12-29",
        "bookingDateTime": "2025-12-29T12:25:00.000Z",
        "valueDateTime": "2025-12-29T12:25:00.000Z",
        "transactionAmount": {
          "amount": "23714.06",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from SmartScale Solutions - INV-202512-5341",
        "remittanceInformationUnstructuredArray": [
          "Payment from SmartScale Solutions",
          "INV-202512-5341"
        ],
        "creditorName": "SmartScale Solutions"
      },
      "paymentId": null,
      "reference": "INV-202512-5341",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_k9wmdwkshbazmh9e7aq4wj85ej",
      "clustering": {
        "description": "SmartScale Solutions",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'SmartScale Solutions'",
        "updatedAt": "2025-12-29T12:25:00.000Z"
      },
      "payer": {
        "name": "SmartScale Solutions",
        "iban": null,
        "bic": null,
        "sortCode": "743970",
        "accountNumber": "84176677"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7f8evwc3de33x6qg1y141yarhp",
      "createdAt": "2025-12-29T12:05:00.000Z",
      "updatedAt": "2025-12-29T12:05:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 36.37,
      "currency": "EUR",
      "description": "Payment to Dracula's Kitchen: DK-202512-4874",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_v9dp85h679nw0dqtjx6hy4v8nq",
      "fspDate": "2025-12-29T11:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_v9dp85h679nw0dqtjx6hy4v8nq",
        "bookingDate": "2025-12-29",
        "valueDate": "2025-12-29",
        "bookingDateTime": "2025-12-29T12:05:00.000Z",
        "valueDateTime": "2025-12-29T12:05:00.000Z",
        "transactionAmount": {
          "amount": "36.37",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Dracula's Kitchen: DK-202512-4874",
        "remittanceInformationUnstructuredArray": [
          "Payment to Dracula's Kitchen",
          "DK-202512-4874"
        ],
        "debtorName": "Dracula's Kitchen"
      },
      "paymentId": null,
      "reference": "DK-202512-4874",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcgeshspn9xska0mg5b",
      "clustering": {
        "description": "Dracula's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Dracula's Kitchen' based on payment details",
        "updatedAt": "2025-12-29T12:05:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Dracula's Kitchen",
        "iban": "DE91836739408209730",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmsrzysd2dmr",
      "createdAt": "2025-12-29T11:30:00.000Z",
      "updatedAt": "2025-12-29T11:30:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 52,
      "currency": "GBP",
      "description": "www.ico.org.uk",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8jbs6xvpar3",
      "fspDate": "2025-12-29T10:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8jbs6xvpar3",
        "bookingDate": "2025-12-29",
        "valueDate": "2025-12-29",
        "bookingDateTime": "2025-12-29T10:30:00.000Z",
        "valueDateTime": "2025-12-29T10:30:00.000Z",
        "transactionAmount": {
          "amount": "-52.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "www.ico.org.uk",
        "remittanceInformationUnstructuredArray": [
          "www.ico.org.uk"
        ],
        "debtorName": "ICO"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4gyfvhrjnsxtfs19v9b",
      "clustering": {
        "description": "ICO",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'ICO' from 'www.ico.org.uk'",
        "updatedAt": "2025-09-29T18:26:40.991Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_h4je75hx1wd7j3b4gghb0w11zg",
      "createdAt": "2025-12-29T11:23:00.000Z",
      "updatedAt": "2025-12-29T11:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 26111.32,
      "currency": "GBP",
      "description": "Payment from Innovation Partners - INV-202512-9077",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_h5pk64vm7zyygs5jerqpd6eb3y",
      "fspDate": "2025-12-29T10:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_h5pk64vm7zyygs5jerqpd6eb3y",
        "bookingDate": "2025-12-29",
        "valueDate": "2025-12-29",
        "bookingDateTime": "2025-12-29T11:23:00.000Z",
        "valueDateTime": "2025-12-29T11:23:00.000Z",
        "transactionAmount": {
          "amount": "26111.32",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Innovation Partners - INV-202512-9077",
        "remittanceInformationUnstructuredArray": [
          "Payment from Innovation Partners",
          "INV-202512-9077"
        ],
        "creditorName": "Innovation Partners"
      },
      "paymentId": null,
      "reference": "INV-202512-9077",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m4xtykg61y9kjq9cjdr8bewyz0",
      "clustering": {
        "description": "Innovation Partners",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Innovation Partners'",
        "updatedAt": "2025-12-29T11:23:00.000Z"
      },
      "payer": {
        "name": "Innovation Partners",
        "iban": null,
        "bic": null,
        "sortCode": "685714",
        "accountNumber": "86796019"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm2kb02j736x",
      "createdAt": "2025-12-29T10:23:00.000Z",
      "updatedAt": "2025-12-29T10:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3300,
      "currency": "GBP",
      "description": "Payment to Yapily Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k422kax1esm9g4z9eqfyg4pa",
      "fspDate": "2025-12-29T09:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k422kax1esm9g4z9eqfyg4pa",
        "bookingDate": "2025-12-29",
        "valueDate": "2025-12-29",
        "bookingDateTime": "2025-12-29T09:23:00.000Z",
        "valueDateTime": "2025-12-29T09:23:00.000Z",
        "transactionAmount": {
          "amount": "-3300.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Yapily Limited",
        "remittanceInformationUnstructuredArray": [
          "Payment to Yapily Limited"
        ],
        "debtorName": "Yapily Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf94qfvhrjn51jet0pt56",
      "clustering": {
        "description": "Yapily",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Yapily' from 'Payment to Yapily Limited', removing 'Payment to ' prefix and 'Limited' suffix",
        "updatedAt": "2025-09-29T18:23:50.758Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm7xcbjc7xs0",
      "createdAt": "2025-12-29T08:48:00.000Z",
      "updatedAt": "2025-12-29T08:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 11812.78,
      "currency": "GBP",
      "description": "Payment to SEAPOINT FINANCE  LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1fpje2seh1r0v7bvw7hvyaw",
      "fspDate": "2025-12-29T07:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1fpje2seh1r0v7bvw7hvyaw",
        "bookingDate": "2025-12-29",
        "valueDate": "2025-12-29",
        "bookingDateTime": "2025-12-29T07:48:00.000Z",
        "valueDateTime": "2025-12-29T07:48:00.000Z",
        "transactionAmount": {
          "amount": "-11812.78",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to SEAPOINT FINANCE  LIMITED",
        "remittanceInformationUnstructuredArray": [
          "Payment to SEAPOINT FINANCE  LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Seapoint Finance Limited' from 'Payment to SEAPOINT FINANCE  LIMITED', removing the prefix 'Payment to '",
        "updatedAt": "2025-09-29T18:24:29.609Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5pmd97janx92m1psxz3yp2tpyv",
      "createdAt": "2025-12-28T17:12:00.000Z",
      "updatedAt": "2025-12-28T17:12:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 2800,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_xw3v43k4d6f9xxbj01cjg7h5qd",
      "fspDate": "2025-12-28T16:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k21rpzyzf2181bvdrtrt3y6q",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T16:12:00.000Z",
        "valueDateTime": "2025-12-28T16:12:00.000Z",
        "transactionAmount": {
          "amount": "2800.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.904Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vteedqyk3a0cjj8dgjxwjraj7e",
      "createdAt": "2025-12-28T16:28:00.000Z",
      "updatedAt": "2025-12-28T16:28:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 855.24,
      "currency": "USD",
      "description": "Payment to GitHub, Inc.: GI-202512-6020",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jdty80c5n74w88wt0ajsvs54sv",
      "fspDate": "2025-12-28T15:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jdty80c5n74w88wt0ajsvs54sv",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T16:28:00.000Z",
        "valueDateTime": "2025-12-28T16:28:00.000Z",
        "transactionAmount": {
          "amount": "855.24",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GitHub, Inc.: GI-202512-6020",
        "remittanceInformationUnstructuredArray": [
          "Payment to GitHub, Inc.",
          "GI-202512-6020"
        ],
        "debtorName": "GitHub, Inc."
      },
      "paymentId": null,
      "reference": "GI-202512-6020",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_xj643cpp5p1awyrrqgqpf67q4d",
      "clustering": {
        "description": "GitHub, Inc.",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'GitHub, Inc.' based on payment details",
        "updatedAt": "2025-12-28T16:28:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GitHub, Inc.",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qetxvmmpghz5ktp4j51zxh2aqj",
      "createdAt": "2025-12-28T16:04:00.000Z",
      "updatedAt": "2025-12-28T16:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Payment to Finom: F-202512-4057",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_t2s4a2qzq0td506j0hrmhg9hkc",
      "fspDate": "2025-12-28T15:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_t2s4a2qzq0td506j0hrmhg9hkc",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T16:04:00.000Z",
        "valueDateTime": "2025-12-28T16:04:00.000Z",
        "transactionAmount": {
          "amount": "14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Finom: F-202512-4057",
        "remittanceInformationUnstructuredArray": [
          "Payment to Finom",
          "F-202512-4057"
        ],
        "debtorName": "Finom"
      },
      "paymentId": null,
      "reference": "F-202512-4057",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0yxeshspjws0xeeqa1k",
      "clustering": {
        "description": "Finom",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Finom' based on payment details",
        "updatedAt": "2025-12-28T16:04:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Finom",
        "iban": "DE43303132919554104",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mma965e9ghe6gtmtwrydaq4het",
      "createdAt": "2025-12-28T15:53:00.000Z",
      "updatedAt": "2025-12-28T15:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4.1,
      "currency": "EUR",
      "description": "Payment to An Post: AP-202512-5917",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_m2byb0240s0d9v3apejsx63a7v",
      "fspDate": "2025-12-28T14:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_m2byb0240s0d9v3apejsx63a7v",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T15:53:00.000Z",
        "valueDateTime": "2025-12-28T15:53:00.000Z",
        "transactionAmount": {
          "amount": "4.10",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to An Post: AP-202512-5917",
        "remittanceInformationUnstructuredArray": [
          "Payment to An Post",
          "AP-202512-5917"
        ],
        "debtorName": "An Post"
      },
      "paymentId": null,
      "reference": "AP-202512-5917",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwdneshspna9pr7b1tc2",
      "clustering": {
        "description": "An Post",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'An Post' based on payment details",
        "updatedAt": "2025-12-28T15:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "An Post",
        "iban": "DE61615803941254680",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg2y4t0da5sp",
      "createdAt": "2025-12-28T15:13:00.000Z",
      "updatedAt": "2025-12-28T15:13:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 32.61,
      "currency": "EUR",
      "description": "Sentry",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0z1fxhs01yb",
      "fspDate": "2025-12-28T14:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0z1fxhs01yb",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T14:13:00.000Z",
        "valueDateTime": "2025-12-28T14:13:00.000Z",
        "transactionAmount": {
          "amount": "-32.61",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sentry",
        "remittanceInformationUnstructuredArray": [
          "Sentry"
        ],
        "debtorName": "Sentry"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdn2eshspk97jdcm57ef",
      "clustering": {
        "description": "Sentry",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Sentry' from 'Sentry'",
        "updatedAt": "2025-09-27T10:50:52.449Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8n61nsp9x1fwjvdf4eetsg7wdm",
      "createdAt": "2025-12-28T12:17:00.000Z",
      "updatedAt": "2025-12-28T12:17:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3539.91,
      "currency": "USD",
      "description": "Payment to OpenAI, LLC: OL-202512-6583",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_s1zvqr9zgz186t8nkky6ma6b4s",
      "fspDate": "2025-12-28T11:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_s1zvqr9zgz186t8nkky6ma6b4s",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T12:17:00.000Z",
        "valueDateTime": "2025-12-28T12:17:00.000Z",
        "transactionAmount": {
          "amount": "3539.91",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to OpenAI, LLC: OL-202512-6583",
        "remittanceInformationUnstructuredArray": [
          "Payment to OpenAI, LLC",
          "OL-202512-6583"
        ],
        "debtorName": "OpenAI, LLC"
      },
      "paymentId": null,
      "reference": "OL-202512-6583",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1bss5kk7dqrqznncrn6c0w8y4p",
      "clustering": {
        "description": "OpenAI, LLC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'OpenAI, LLC' based on payment details",
        "updatedAt": "2025-12-28T12:17:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "OpenAI, LLC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gwfdb0rbtwxyvjgt568cg33se8",
      "createdAt": "2025-12-28T11:41:00.000Z",
      "updatedAt": "2025-12-28T11:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 450.23,
      "currency": "GBP",
      "description": "booking.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_gkzedfw5zb9fw7699dqpvn1782",
      "fspDate": "2025-12-28T10:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8kt64v285xc",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T10:41:00.000Z",
        "valueDateTime": "2025-12-28T10:41:00.000Z",
        "transactionAmount": {
          "amount": "-450.23",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "booking.com",
        "remittanceInformationUnstructuredArray": [
          "booking.com"
        ],
        "debtorName": "Booking.com"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9p5fvhrjp2td9pd9rat",
      "clustering": {
        "description": "Booking.com",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Booking.com' from 'booking.com'",
        "updatedAt": "2025-09-29T18:27:23.735Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6gpt0nsg2y4fnh7s824tt14578",
      "createdAt": "2025-12-28T11:41:00.000Z",
      "updatedAt": "2025-12-28T11:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 132.12,
      "currency": "EUR",
      "description": "Figma",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_3sp4fq8gmsmrk6dvxmqp2r0q4h",
      "fspDate": "2025-12-28T10:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1t1gjkcena8mn82235tqa6q",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T10:41:00.000Z",
        "valueDateTime": "2025-12-28T10:41:00.000Z",
        "transactionAmount": {
          "amount": "-132.12",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Figma",
        "remittanceInformationUnstructuredArray": [
          "Figma"
        ],
        "debtorName": "Figma"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdq3eshspk9qt2a4er00",
      "clustering": {
        "description": "Figma",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Figma' from the transaction description.",
        "updatedAt": "2025-09-27T10:43:55.534Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfx4s63szs32",
      "createdAt": "2025-12-28T11:06:00.000Z",
      "updatedAt": "2025-12-28T11:06:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 50,
      "currency": "EUR",
      "description": "Uber * Pending",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0tnf00m11wz",
      "fspDate": "2025-12-28T10:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0tnf00m11wz",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T10:06:00.000Z",
        "valueDateTime": "2025-12-28T10:06:00.000Z",
        "transactionAmount": {
          "amount": "-50.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Uber * Pending",
        "remittanceInformationUnstructuredArray": [
          "Uber * Pending"
        ],
        "debtorName": "Uber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Uber",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Uber' from 'Uber * Pending'",
        "updatedAt": "2025-09-27T10:50:08.369Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5grbnveyfkf6bdzvzzarm0mnx7",
      "createdAt": "2025-12-28T09:11:00.000Z",
      "updatedAt": "2025-12-28T09:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 31458.1,
      "currency": "GBP",
      "description": "Payment from CloudFirst Technologies - INV-202512-3810",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4e66qgnw85zs1rv6qyb52g2rwr",
      "fspDate": "2025-12-28T08:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4e66qgnw85zs1rv6qyb52g2rwr",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T09:11:00.000Z",
        "valueDateTime": "2025-12-28T09:11:00.000Z",
        "transactionAmount": {
          "amount": "31458.10",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from CloudFirst Technologies - INV-202512-3810",
        "remittanceInformationUnstructuredArray": [
          "Payment from CloudFirst Technologies",
          "INV-202512-3810"
        ],
        "creditorName": "CloudFirst Technologies"
      },
      "paymentId": null,
      "reference": "INV-202512-3810",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_v3gga6hnqqf8p85ezhv67qxfkw",
      "clustering": {
        "description": "CloudFirst Technologies",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'CloudFirst Technologies'",
        "updatedAt": "2025-12-28T09:11:00.000Z"
      },
      "payer": {
        "name": "CloudFirst Technologies",
        "iban": null,
        "bic": null,
        "sortCode": "230017",
        "accountNumber": "48160637"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfda3szxn8k3",
      "createdAt": "2025-12-27T17:44:00.000Z",
      "updatedAt": "2025-12-27T17:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2000,
      "currency": "EUR",
      "description": "To BOI 2 COLLEGE GREEN, Davy",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k12vyakne4dr6y0q4zjyvv2e",
      "fspDate": "2025-12-27T16:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k12vyakne4dr6y0q4zjyvv2e",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T16:44:00.000Z",
        "valueDateTime": "2025-12-27T16:44:00.000Z",
        "transactionAmount": {
          "amount": "-2000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To BOI 2 COLLEGE GREEN, Davy",
        "remittanceInformationUnstructuredArray": [
          "To BOI 2 COLLEGE GREEN, Davy"
        ],
        "debtorName": "BOI 2 COLLEGE GREEN, Davy"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc5eshspj0rxb4j151x",
      "clustering": {
        "description": "BOI 2 COLLEGE GREEN",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'BOI 2 COLLEGE GREEN' from 'To BOI 2 COLLEGE GREEN, Davy'",
        "updatedAt": "2025-09-27T10:48:02.683Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfj1bhnfny37",
      "createdAt": "2025-12-27T17:39:00.000Z",
      "updatedAt": "2025-12-27T17:39:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 9.5,
      "currency": "EUR",
      "description": "The Pig And Heifer",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0v4ra3afvqsmk2w5s5pqayz",
      "fspDate": "2025-12-27T16:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0v4ra3afvqsmk2w5s5pqayz",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T16:39:00.000Z",
        "valueDateTime": "2025-12-27T16:39:00.000Z",
        "transactionAmount": {
          "amount": "-9.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "The Pig And Heifer",
        "remittanceInformationUnstructuredArray": [
          "The Pig And Heifer"
        ],
        "debtorName": "The Pig And Heifer"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g5weshsphq7y8rf4z8z",
      "clustering": {
        "description": "The Pig And Heifer",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'The Pig And Heifer' from the transaction description",
        "updatedAt": "2025-09-27T10:49:04.273Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_q77j5vzdpv8h4gqkhr32aj4m6m",
      "createdAt": "2025-12-27T14:55:00.000Z",
      "updatedAt": "2025-12-27T14:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 28.15,
      "currency": "EUR",
      "description": "Payment to Sweet Salt: SS-202512-8829",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pqyxb4p17e187630tc7qd1y50s",
      "fspDate": "2025-12-27T13:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pqyxb4p17e187630tc7qd1y50s",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T14:55:00.000Z",
        "valueDateTime": "2025-12-27T14:55:00.000Z",
        "transactionAmount": {
          "amount": "28.15",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sweet Salt: SS-202512-8829",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sweet Salt",
          "SS-202512-8829"
        ],
        "debtorName": "Sweet Salt"
      },
      "paymentId": null,
      "reference": "SS-202512-8829",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmad4eshspkk8z9xs58fk",
      "clustering": {
        "description": "Sweet Salt",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sweet Salt' based on payment details",
        "updatedAt": "2025-12-27T14:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sweet Salt",
        "iban": "DE97868193692865180",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3n14350nqpvse3c9btrdr0j52e",
      "createdAt": "2025-12-27T14:50:00.000Z",
      "updatedAt": "2025-12-27T14:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 686.99,
      "currency": "GBP",
      "description": "Payment to Ginger Bistro: GB-202512-4870",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_d948629p6yktpj6qpahqrep9j5",
      "fspDate": "2025-12-27T13:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_d948629p6yktpj6qpahqrep9j5",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T14:50:00.000Z",
        "valueDateTime": "2025-12-27T14:50:00.000Z",
        "transactionAmount": {
          "amount": "686.99",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Ginger Bistro: GB-202512-4870",
        "remittanceInformationUnstructuredArray": [
          "Payment to Ginger Bistro",
          "GB-202512-4870"
        ],
        "debtorName": "Ginger Bistro"
      },
      "paymentId": null,
      "reference": "GB-202512-4870",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk6skfvhrjntfdd23av1a",
      "clustering": {
        "description": "Ginger Bistro",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Ginger Bistro' based on payment details",
        "updatedAt": "2025-12-27T14:50:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Ginger Bistro",
        "iban": null,
        "bic": null,
        "sortCode": "114300",
        "accountNumber": "70419628"
      }
    },
    {
      "id": "txn_wjk6aeyvb0d3ym9xkp20ftqgrw",
      "createdAt": "2025-12-27T12:58:00.000Z",
      "updatedAt": "2025-12-27T12:58:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 98.4,
      "currency": "EUR",
      "description": "Figma",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_kcyceysf9sdyy4kdwbh2f6y7be",
      "fspDate": "2025-12-27T11:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1zey24hebvw",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T11:58:00.000Z",
        "valueDateTime": "2025-12-27T11:58:00.000Z",
        "transactionAmount": {
          "amount": "-98.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Figma",
        "remittanceInformationUnstructuredArray": [
          "Figma"
        ],
        "debtorName": "Figma"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdq3eshspk9qt2a4er00",
      "clustering": {
        "description": "Figma",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Figma' from 'Figma'.",
        "updatedAt": "2025-09-27T10:54:12.596Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg0r55w76ma5",
      "createdAt": "2025-12-27T12:37:00.000Z",
      "updatedAt": "2025-12-27T12:37:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 438.55,
      "currency": "EUR",
      "description": "Tst-Bang-Restaurant",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0vnkbvytjdy",
      "fspDate": "2025-12-27T11:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0vnkbvytjdy",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T11:37:00.000Z",
        "valueDateTime": "2025-12-27T11:37:00.000Z",
        "transactionAmount": {
          "amount": "-438.55",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tst-Bang-Restaurant",
        "remittanceInformationUnstructuredArray": [
          "Tst-Bang-Restaurant"
        ],
        "debtorName": "Bang Restaurant"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpk3eshspmfgtm6vkpxj",
      "clustering": {
        "description": "Bang Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Bang Restaurant' from 'Tst-Bang-Restaurant', removing 'Tst-' prefix",
        "updatedAt": "2025-09-27T10:50:52.360Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_prc8ppv8epy345gwc8w0enxt3w",
      "createdAt": "2025-12-27T12:14:00.000Z",
      "updatedAt": "2025-12-27T12:14:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 16997.53,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_np7dw4y6qncm4brt9mvbd4n74n",
      "fspDate": "2025-12-27T11:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8faqrpz5f4a",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T11:14:00.000Z",
        "valueDateTime": "2025-12-27T11:14:00.000Z",
        "transactionAmount": {
          "amount": "16997.53",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the core business name for the currency conversion transaction",
        "updatedAt": "2025-09-29T18:26:40.943Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_r39w9nmme7jtkbrh1y5ad0ejby",
      "createdAt": "2025-12-27T10:39:00.000Z",
      "updatedAt": "2025-12-27T10:39:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 48.68,
      "currency": "GBP",
      "description": "Linkedin Sn *644171954",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_8z4xck0cea7prv92crv2h5fw23",
      "fspDate": "2025-12-27T09:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk89xdes3h3s4",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T09:39:00.000Z",
        "valueDateTime": "2025-12-27T09:39:00.000Z",
        "transactionAmount": {
          "amount": "-48.68",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin Sn *644171954",
        "remittanceInformationUnstructuredArray": [
          "Linkedin Sn *644171954"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'LinkedIn' from 'Linkedin Sn *644171954'",
        "updatedAt": "2025-09-29T18:25:48.439Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n84rpdgm5zpgv09rd7edr2wswx",
      "createdAt": "2025-12-27T09:57:00.000Z",
      "updatedAt": "2025-12-27T09:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.13,
      "currency": "GBP",
      "description": "Payment to FCB Coffee: FC-202512-6489",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_973nq6xp42sb1vtx2dze4p41yf",
      "fspDate": "2025-12-27T08:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_973nq6xp42sb1vtx2dze4p41yf",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T09:57:00.000Z",
        "valueDateTime": "2025-12-27T09:57:00.000Z",
        "transactionAmount": {
          "amount": "3.13",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to FCB Coffee: FC-202512-6489",
        "remittanceInformationUnstructuredArray": [
          "Payment to FCB Coffee",
          "FC-202512-6489"
        ],
        "debtorName": "FCB Coffee"
      },
      "paymentId": null,
      "reference": "FC-202512-6489",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmmfvhrjp1d532dm1jy",
      "clustering": {
        "description": "FCB Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'FCB Coffee' based on payment details",
        "updatedAt": "2025-12-27T09:57:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "FCB Coffee",
        "iban": null,
        "bic": null,
        "sortCode": "244712",
        "accountNumber": "74602284"
      }
    },
    {
      "id": "txn_y3we40ewhrxkpz1apzz98qgt6h",
      "createdAt": "2025-12-27T09:56:00.000Z",
      "updatedAt": "2025-12-27T09:56:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Tortilla Latin Food 1",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_m6675dxs7pvzm8z78hr5a9ay7g",
      "fspDate": "2025-12-27T08:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk10rm1phrf3h",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T08:56:00.000Z",
        "valueDateTime": "2025-12-27T08:56:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tortilla Latin Food 1",
        "remittanceInformationUnstructuredArray": [
          "Tortilla Latin Food 1"
        ],
        "debtorName": "Tortilla Mexican Grill"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspgkeshspmp0mmzf2w0c",
      "clustering": {
        "description": "Tortilla Latin Food",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Tortilla Latin Food' from 'Tortilla Latin Food 1', removing the store number suffix.",
        "updatedAt": "2025-09-27T10:51:38.168Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph1fdb2cy1hq",
      "createdAt": "2025-12-26T17:02:00.000Z",
      "updatedAt": "2025-12-26T17:02:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 98.4,
      "currency": "EUR",
      "description": "Figma",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1zey24hebvw",
      "fspDate": "2025-12-26T16:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1zey24hebvw",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T11:58:00.000Z",
        "valueDateTime": "2025-12-27T11:58:00.000Z",
        "transactionAmount": {
          "amount": "-98.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Figma",
        "remittanceInformationUnstructuredArray": [
          "Figma"
        ],
        "debtorName": "Figma"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdq3eshspk9qt2a4er00",
      "clustering": {
        "description": "Figma",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Figma' from 'Figma'.",
        "updatedAt": "2025-09-27T10:54:12.596Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_a699bwtt1ewy02r78afsrjk0d2",
      "createdAt": "2025-12-26T14:55:00.000Z",
      "updatedAt": "2025-12-26T14:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 22.38,
      "currency": "EUR",
      "description": "Payment to Tula Mexican Grill: TMG-202512-5388",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5nn2szyvzwrtsgk9rrt6j594n6",
      "fspDate": "2025-12-26T13:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5nn2szyvzwrtsgk9rrt6j594n6",
        "bookingDate": "2025-12-26",
        "valueDate": "2025-12-26",
        "bookingDateTime": "2025-12-26T14:55:00.000Z",
        "valueDateTime": "2025-12-26T14:55:00.000Z",
        "transactionAmount": {
          "amount": "22.38",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tula Mexican Grill: TMG-202512-5388",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tula Mexican Grill",
          "TMG-202512-5388"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": "TMG-202512-5388",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tula Mexican Grill' based on payment details",
        "updatedAt": "2025-12-26T14:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tula Mexican Grill",
        "iban": "DE32519445652510628",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0bd2hgj7g3vkj5t73j9jka7vy9",
      "createdAt": "2025-12-26T13:27:00.000Z",
      "updatedAt": "2025-12-26T13:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 442.51,
      "currency": "USD",
      "description": "Payment to Kandji: K-202512-4644",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vejbyqcqq5rch02cwe4y4nvr6d",
      "fspDate": "2025-12-26T12:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vejbyqcqq5rch02cwe4y4nvr6d",
        "bookingDate": "2025-12-26",
        "valueDate": "2025-12-26",
        "bookingDateTime": "2025-12-26T13:27:00.000Z",
        "valueDateTime": "2025-12-26T13:27:00.000Z",
        "transactionAmount": {
          "amount": "442.51",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kandji: K-202512-4644",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kandji",
          "K-202512-4644"
        ],
        "debtorName": "Kandji"
      },
      "paymentId": null,
      "reference": "K-202512-4644",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax4veshspjmy8ae028r6",
      "clustering": {
        "description": "Kandji",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kandji' based on payment details",
        "updatedAt": "2025-12-26T13:27:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kandji",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_z7k21qnbm3hy6pqajev02qw407",
      "createdAt": "2025-12-26T13:05:00.000Z",
      "updatedAt": "2025-12-26T13:05:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 229,
      "currency": "EUR",
      "description": "wttj.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_27gmh136t48grn6h0fcdkfbqv2",
      "fspDate": "2025-12-26T12:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk21m2n8vzdch",
        "bookingDate": "2025-12-26",
        "valueDate": "2025-12-26",
        "bookingDateTime": "2025-12-26T12:05:00.000Z",
        "valueDateTime": "2025-12-26T12:05:00.000Z",
        "transactionAmount": {
          "amount": "-229.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "wttj.com",
        "remittanceInformationUnstructuredArray": [
          "wttj.com"
        ],
        "debtorName": "Welcome to the Jungle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkfxeshspnwz7ebn2y1d",
      "clustering": {
        "description": "Welcome to the Jungle",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Welcome to the Jungle' from 'wttj.com'",
        "updatedAt": "2025-09-27T10:54:50.798Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3av9dz7xn2beeknwb2eqqk42bj",
      "createdAt": "2025-12-25T16:53:00.000Z",
      "updatedAt": "2025-12-25T16:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1315.25,
      "currency": "GBP",
      "description": "Payment to Adam Rankin: AR-202512-4600",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_s0vhm1pmpmn34892dtwz2qgw8q",
      "fspDate": "2025-12-25T15:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_s0vhm1pmpmn34892dtwz2qgw8q",
        "bookingDate": "2025-12-25",
        "valueDate": "2025-12-25",
        "bookingDateTime": "2025-12-25T16:53:00.000Z",
        "valueDateTime": "2025-12-25T16:53:00.000Z",
        "transactionAmount": {
          "amount": "1315.25",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Adam Rankin: AR-202512-4600",
        "remittanceInformationUnstructuredArray": [
          "Payment to Adam Rankin",
          "AR-202512-4600"
        ],
        "debtorName": "Adam Rankin"
      },
      "paymentId": null,
      "reference": "AR-202512-4600",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2zfvhrjnc124tr3b2s",
      "clustering": {
        "description": "Adam Rankin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Adam Rankin' based on payment details",
        "updatedAt": "2025-12-25T16:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Adam Rankin",
        "iban": null,
        "bic": null,
        "sortCode": "524548",
        "accountNumber": "26676336"
      }
    },
    {
      "id": "txn_0rqqq2jv6224x1768pq9d7v5kd",
      "createdAt": "2025-12-25T16:33:00.000Z",
      "updatedAt": "2025-12-25T16:33:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 19.5,
      "currency": "EUR",
      "description": "Mak Slim Foods",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_9zxmsz0epjd2qg7f0d8w51n9j3",
      "fspDate": "2025-12-25T15:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1jaadqbfk0vtsr93p53xdk8",
        "bookingDate": "2025-12-25",
        "valueDate": "2025-12-25",
        "bookingDateTime": "2025-12-25T15:33:00.000Z",
        "valueDateTime": "2025-12-25T15:33:00.000Z",
        "transactionAmount": {
          "amount": "-19.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Mak Slim Foods",
        "remittanceInformationUnstructuredArray": [
          "Mak Slim Foods"
        ],
        "debtorName": "Mak Slim Foods"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2yeshspkgyzwx8hqrq",
      "clustering": {
        "description": "Mak Slim Foods",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Mak Slim Foods' from the transaction description",
        "updatedAt": "2025-09-27T10:45:11.531Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg5khsmmytpk",
      "createdAt": "2025-12-25T13:01:00.000Z",
      "updatedAt": "2025-12-25T13:01:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 9700,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk102wk8j899h",
      "fspDate": "2025-12-25T12:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk102wk8j899h",
        "bookingDate": "2025-12-25",
        "valueDate": "2025-12-25",
        "bookingDateTime": "2025-12-25T12:01:00.000Z",
        "valueDateTime": "2025-12-25T12:01:00.000Z",
        "transactionAmount": {
          "amount": "-9700.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the currency conversion transaction with code 'EXCHANGE'.",
        "updatedAt": "2025-09-27T10:51:38.211Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_c7sfernax4pt70d6kvbv9d3yzr",
      "createdAt": "2025-12-25T12:04:00.000Z",
      "updatedAt": "2025-12-25T12:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 91.1,
      "currency": "EUR",
      "description": "Payment to Zapier: Z-202512-5605",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5cpxhwc1c73czq9j5emzsr05hw",
      "fspDate": "2025-12-25T11:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5cpxhwc1c73czq9j5emzsr05hw",
        "bookingDate": "2025-12-25",
        "valueDate": "2025-12-25",
        "bookingDateTime": "2025-12-25T12:04:00.000Z",
        "valueDateTime": "2025-12-25T12:04:00.000Z",
        "transactionAmount": {
          "amount": "91.10",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Zapier: Z-202512-5605",
        "remittanceInformationUnstructuredArray": [
          "Payment to Zapier",
          "Z-202512-5605"
        ],
        "debtorName": "Zapier"
      },
      "paymentId": null,
      "reference": "Z-202512-5605",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2aeshspkg92jdy8vh4",
      "clustering": {
        "description": "Zapier",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Zapier' based on payment details",
        "updatedAt": "2025-12-25T12:04:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Zapier",
        "iban": "DE17682627668642796",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2yd1dpahr0nth95qdaqkfvwx60",
      "createdAt": "2025-12-25T10:29:00.000Z",
      "updatedAt": "2025-12-25T10:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 21719.51,
      "currency": "GBP",
      "description": "Payment from Digital Ventures Group - INV-202512-5710",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6qzp1ee7y2c01vf21xyfp7xzzx",
      "fspDate": "2025-12-25T09:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6qzp1ee7y2c01vf21xyfp7xzzx",
        "bookingDate": "2025-12-25",
        "valueDate": "2025-12-25",
        "bookingDateTime": "2025-12-25T10:29:00.000Z",
        "valueDateTime": "2025-12-25T10:29:00.000Z",
        "transactionAmount": {
          "amount": "21719.51",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Digital Ventures Group - INV-202512-5710",
        "remittanceInformationUnstructuredArray": [
          "Payment from Digital Ventures Group",
          "INV-202512-5710"
        ],
        "creditorName": "Digital Ventures Group"
      },
      "paymentId": null,
      "reference": "INV-202512-5710",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_mj6n80che7b1rf41e9c0gtanqb",
      "clustering": {
        "description": "Digital Ventures Group",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Digital Ventures Group'",
        "updatedAt": "2025-12-25T10:29:00.000Z"
      },
      "payer": {
        "name": "Digital Ventures Group",
        "iban": null,
        "bic": null,
        "sortCode": "678625",
        "accountNumber": "91414875"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_z22tfwbdr5hcrbfy0dggd5x690",
      "createdAt": "2025-12-25T09:46:00.000Z",
      "updatedAt": "2025-12-25T09:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 40375.91,
      "currency": "GBP",
      "description": "Payment from Global Solutions Ltd - INV-202512-5263",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_b13ar3aavaj4djasqf682vpwjf",
      "fspDate": "2025-12-25T08:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_b13ar3aavaj4djasqf682vpwjf",
        "bookingDate": "2025-12-25",
        "valueDate": "2025-12-25",
        "bookingDateTime": "2025-12-25T09:46:00.000Z",
        "valueDateTime": "2025-12-25T09:46:00.000Z",
        "transactionAmount": {
          "amount": "40375.91",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Global Solutions Ltd - INV-202512-5263",
        "remittanceInformationUnstructuredArray": [
          "Payment from Global Solutions Ltd",
          "INV-202512-5263"
        ],
        "creditorName": "Global Solutions Ltd"
      },
      "paymentId": null,
      "reference": "INV-202512-5263",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_th3hfveyjxh2erds1n633s02yd",
      "clustering": {
        "description": "Global Solutions Ltd",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Global Solutions Ltd'",
        "updatedAt": "2025-12-25T09:46:00.000Z"
      },
      "payer": {
        "name": "Global Solutions Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "675618",
        "accountNumber": "28267611"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_b7g0fkk8yhe7r7h6a0c0ntygeg",
      "createdAt": "2025-12-25T09:20:00.000Z",
      "updatedAt": "2025-12-25T09:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2056.17,
      "currency": "EUR",
      "description": "Payment to Bank of Ireland: BOI-202512-5179",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gg2539nhx7b8pjtppj57hkscds",
      "fspDate": "2025-12-25T08:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gg2539nhx7b8pjtppj57hkscds",
        "bookingDate": "2025-12-25",
        "valueDate": "2025-12-25",
        "bookingDateTime": "2025-12-25T09:20:00.000Z",
        "valueDateTime": "2025-12-25T09:20:00.000Z",
        "transactionAmount": {
          "amount": "2056.17",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bank of Ireland: BOI-202512-5179",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bank of Ireland",
          "BOI-202512-5179"
        ],
        "debtorName": "Bank of Ireland"
      },
      "paymentId": null,
      "reference": "BOI-202512-5179",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a24eshspnzbnpcam1v1",
      "clustering": {
        "description": "Bank of Ireland",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bank of Ireland' based on payment details",
        "updatedAt": "2025-12-25T09:20:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bank of Ireland",
        "iban": "DE86776944140776720",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xarebg2pwm73yn1djckp9dnen2",
      "createdAt": "2025-12-24T14:46:00.000Z",
      "updatedAt": "2025-12-24T14:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 101.65,
      "currency": "EUR",
      "description": "Linkedin Pre P44594755",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_seeqxmt3q3pfa3rxxw92rrx049",
      "fspDate": "2025-12-24T13:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk135b60b0wjv",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T13:46:00.000Z",
        "valueDateTime": "2025-12-24T13:46:00.000Z",
        "transactionAmount": {
          "amount": "-101.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin Pre P44594755",
        "remittanceInformationUnstructuredArray": [
          "Linkedin Pre P44594755"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'LinkedIn' from 'Linkedin Pre P44594755', removing the 'Pre P44594755' suffix.",
        "updatedAt": "2025-09-27T10:51:38.235Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vccsjhrgs9ajpex3cadzwtwy7q",
      "createdAt": "2025-12-24T14:33:00.000Z",
      "updatedAt": "2025-12-24T14:33:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 11,
      "currency": "EUR",
      "description": "Beanhive",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_drez1mvdnsrmrmnb4qpswd7eq3",
      "fspDate": "2025-12-24T13:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1d5gytnesj8a90y46vpe2ws",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T13:33:00.000Z",
        "valueDateTime": "2025-12-24T13:33:00.000Z",
        "transactionAmount": {
          "amount": "-11.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Beanhive",
        "remittanceInformationUnstructuredArray": [
          "Beanhive"
        ],
        "debtorName": "Beanhive"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmacweshspkk5mv2ktdq4",
      "clustering": {
        "description": "Beanhive",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Beanhive' from the transaction description",
        "updatedAt": "2025-09-27T10:45:11.604Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pd204f4vjyrgfqnxx65s9mc9qz",
      "createdAt": "2025-12-24T14:29:00.000Z",
      "updatedAt": "2025-12-24T14:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.24,
      "currency": "USD",
      "description": "Payment to Claude.ai: C-202512-8705",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1rtwmy4gnmkf06y95fbhy01xej",
      "fspDate": "2025-12-24T13:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1rtwmy4gnmkf06y95fbhy01xej",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T14:29:00.000Z",
        "valueDateTime": "2025-12-24T14:29:00.000Z",
        "transactionAmount": {
          "amount": "20.24",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Claude.ai: C-202512-8705",
        "remittanceInformationUnstructuredArray": [
          "Payment to Claude.ai",
          "C-202512-8705"
        ],
        "debtorName": "Claude.ai"
      },
      "paymentId": null,
      "reference": "C-202512-8705",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5j1eshspjz017vq1wgn",
      "clustering": {
        "description": "Claude.ai",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Claude.ai' based on payment details",
        "updatedAt": "2025-12-24T14:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Claude.ai",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pffztmccemghm1685samp5sqad",
      "createdAt": "2025-12-24T13:58:00.000Z",
      "updatedAt": "2025-12-24T13:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 84.99,
      "currency": "GBP",
      "description": "Payment to Clayton Hotel Belfast: CHB-202512-7450",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_dq9evvshb40hf1nsvsza1aekcz",
      "fspDate": "2025-12-24T12:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_dq9evvshb40hf1nsvsza1aekcz",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T13:58:00.000Z",
        "valueDateTime": "2025-12-24T13:58:00.000Z",
        "transactionAmount": {
          "amount": "84.99",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Belfast: CHB-202512-7450",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Belfast",
          "CHB-202512-7450"
        ],
        "debtorName": "Clayton Hotel Belfast"
      },
      "paymentId": null,
      "reference": "CHB-202512-7450",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4hyfvhrjnt1zqpqqyns",
      "clustering": {
        "description": "Clayton Hotel Belfast",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Belfast' based on payment details",
        "updatedAt": "2025-12-24T13:58:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Belfast",
        "iban": null,
        "bic": null,
        "sortCode": "737867",
        "accountNumber": "53097720"
      }
    },
    {
      "id": "txn_9a0170259rg5f6ddpqsxy0tryt",
      "createdAt": "2025-12-24T13:04:00.000Z",
      "updatedAt": "2025-12-24T13:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29.27,
      "currency": "EUR",
      "description": "Payment to Delhi2Dublin: D-202512-6455",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_aam911w7tqdct99bprxjycekaj",
      "fspDate": "2025-12-24T12:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_aam911w7tqdct99bprxjycekaj",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T13:04:00.000Z",
        "valueDateTime": "2025-12-24T13:04:00.000Z",
        "transactionAmount": {
          "amount": "29.27",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Delhi2Dublin: D-202512-6455",
        "remittanceInformationUnstructuredArray": [
          "Payment to Delhi2Dublin",
          "D-202512-6455"
        ],
        "debtorName": "Delhi2Dublin"
      },
      "paymentId": null,
      "reference": "D-202512-6455",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0x5eshspjwbxzrhs5dn",
      "clustering": {
        "description": "Delhi2Dublin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Delhi2Dublin' based on payment details",
        "updatedAt": "2025-12-24T13:04:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Delhi2Dublin",
        "iban": "DE37530923183113300",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mydhsyxwnsf0pjj4q08zhgyeqy",
      "createdAt": "2025-12-24T13:02:00.000Z",
      "updatedAt": "2025-12-24T13:02:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.57,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_b07b0sxw7ttennzwq2c96sw284",
      "fspDate": "2025-12-24T12:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1t1gjkbena8mn7vtz9bzqk3",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T12:02:00.000Z",
        "valueDateTime": "2025-12-24T12:02:00.000Z",
        "transactionAmount": {
          "amount": "-17.57",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Cursor' from the transaction description, removing the ', Ai Powered Ide' suffix.",
        "updatedAt": "2025-09-27T10:43:55.549Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_v1g9xrjexkv7q581k6hb902weq",
      "createdAt": "2025-12-24T12:04:00.000Z",
      "updatedAt": "2025-12-24T12:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 98.86,
      "currency": "EUR",
      "description": "Payment to Attio: A-202512-1610",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_31dy425yz9ftmqq1wapxjha5h3",
      "fspDate": "2025-12-24T11:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_31dy425yz9ftmqq1wapxjha5h3",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T12:04:00.000Z",
        "valueDateTime": "2025-12-24T12:04:00.000Z",
        "transactionAmount": {
          "amount": "98.86",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Attio: A-202512-1610",
        "remittanceInformationUnstructuredArray": [
          "Payment to Attio",
          "A-202512-1610"
        ],
        "debtorName": "Attio"
      },
      "paymentId": null,
      "reference": "A-202512-1610",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspj5eshspmpcdfterchh",
      "clustering": {
        "description": "Attio",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Attio' based on payment details",
        "updatedAt": "2025-12-24T12:04:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Attio",
        "iban": "DE38130587753907576",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm3pkm8e20jf",
      "createdAt": "2025-12-24T09:36:00.000Z",
      "updatedAt": "2025-12-24T09:36:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 17288.8,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3n8n7m0eh2tcb9a6xvp8pwn",
      "fspDate": "2025-12-24T08:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n7m0eh2tcb9a6xvp8pwn",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T08:36:00.000Z",
        "valueDateTime": "2025-12-24T08:36:00.000Z",
        "transactionAmount": {
          "amount": "17288.80",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.811Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xc4jkazv2vmw1930f11csjgngm",
      "createdAt": "2025-12-23T15:45:00.000Z",
      "updatedAt": "2025-12-23T15:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 32444.08,
      "currency": "EUR",
      "description": "Payment from Nordic Digital AB - INV-202512-9086",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vdx3b6wm5gvtn3qdh91b2bx31n",
      "fspDate": "2025-12-23T14:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vdx3b6wm5gvtn3qdh91b2bx31n",
        "bookingDate": "2025-12-23",
        "valueDate": "2025-12-23",
        "bookingDateTime": "2025-12-23T15:45:00.000Z",
        "valueDateTime": "2025-12-23T15:45:00.000Z",
        "transactionAmount": {
          "amount": "32444.08",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nordic Digital AB - INV-202512-9086",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nordic Digital AB",
          "INV-202512-9086"
        ],
        "creditorName": "Nordic Digital AB"
      },
      "paymentId": null,
      "reference": "INV-202512-9086",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_q7sgetg8gwgf23ac9gdqmk8cz4",
      "clustering": {
        "description": "Nordic Digital AB",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nordic Digital AB'",
        "updatedAt": "2025-12-23T15:45:00.000Z"
      },
      "payer": {
        "name": "Nordic Digital AB",
        "iban": "DE87301299145977060",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4vyaf0x82w315qpvzc8kzghpkt",
      "createdAt": "2025-12-23T14:23:00.000Z",
      "updatedAt": "2025-12-23T14:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 35665.24,
      "currency": "GBP",
      "description": "Payment from DataDriven Analytics - INV-202512-4279",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ast38714dm70cxvqr9prehssg2",
      "fspDate": "2025-12-23T13:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ast38714dm70cxvqr9prehssg2",
        "bookingDate": "2025-12-23",
        "valueDate": "2025-12-23",
        "bookingDateTime": "2025-12-23T14:23:00.000Z",
        "valueDateTime": "2025-12-23T14:23:00.000Z",
        "transactionAmount": {
          "amount": "35665.24",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from DataDriven Analytics - INV-202512-4279",
        "remittanceInformationUnstructuredArray": [
          "Payment from DataDriven Analytics",
          "INV-202512-4279"
        ],
        "creditorName": "DataDriven Analytics"
      },
      "paymentId": null,
      "reference": "INV-202512-4279",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_jy64mwn8y868akxp0c6s337dms",
      "clustering": {
        "description": "DataDriven Analytics",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'DataDriven Analytics'",
        "updatedAt": "2025-12-23T14:23:00.000Z"
      },
      "payer": {
        "name": "DataDriven Analytics",
        "iban": null,
        "bic": null,
        "sortCode": "115238",
        "accountNumber": "62128499"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fjzsp1gb8wakrx9y29tk8jcaa8",
      "createdAt": "2025-12-23T12:02:00.000Z",
      "updatedAt": "2025-12-23T12:02:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.88,
      "currency": "EUR",
      "description": "Payment to Taxi Service: TS-202512-7952",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mstwdrhydawcbvpgw1r6jyt5rd",
      "fspDate": "2025-12-23T11:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mstwdrhydawcbvpgw1r6jyt5rd",
        "bookingDate": "2025-12-23",
        "valueDate": "2025-12-23",
        "bookingDateTime": "2025-12-23T12:02:00.000Z",
        "valueDateTime": "2025-12-23T12:02:00.000Z",
        "transactionAmount": {
          "amount": "20.88",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Taxi Service: TS-202512-7952",
        "remittanceInformationUnstructuredArray": [
          "Payment to Taxi Service",
          "TS-202512-7952"
        ],
        "debtorName": "Taxi Service"
      },
      "paymentId": null,
      "reference": "TS-202512-7952",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqn02eshspm8y4jy7tt7k",
      "clustering": {
        "description": "Taxi Service",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Taxi Service' based on payment details",
        "updatedAt": "2025-12-23T12:02:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Taxi Service",
        "iban": "DE37830452668001440",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fq69r7rsnhr68wa56dc2kdzybx",
      "createdAt": "2025-12-22T12:21:00.000Z",
      "updatedAt": "2025-12-22T12:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 11.44,
      "currency": "EUR",
      "description": "Payment to Jarek's Kitchen: JK-202512-4045",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zqxm230c7ph262s9mw5re93r4e",
      "fspDate": "2025-12-22T11:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zqxm230c7ph262s9mw5re93r4e",
        "bookingDate": "2025-12-22",
        "valueDate": "2025-12-22",
        "bookingDateTime": "2025-12-22T12:21:00.000Z",
        "valueDateTime": "2025-12-22T12:21:00.000Z",
        "transactionAmount": {
          "amount": "11.44",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jarek's Kitchen: JK-202512-4045",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jarek's Kitchen",
          "JK-202512-4045"
        ],
        "debtorName": "Jarek's Kitchen"
      },
      "paymentId": null,
      "reference": "JK-202512-4045",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9ynmeshspjjhrjb91rve",
      "clustering": {
        "description": "Jarek's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Jarek's Kitchen' based on payment details",
        "updatedAt": "2025-12-22T12:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Jarek's Kitchen",
        "iban": "DE75221203243515700",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_m3pbyzg7kxg9cn8tca72ywmjvm",
      "createdAt": "2025-12-22T11:34:00.000Z",
      "updatedAt": "2025-12-22T11:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12.05,
      "currency": "EUR",
      "description": "Payment to Suhas Falafel: SF-202512-2450",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bmqqzth5eyh4ykz29v9rfwwf19",
      "fspDate": "2025-12-22T10:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bmqqzth5eyh4ykz29v9rfwwf19",
        "bookingDate": "2025-12-22",
        "valueDate": "2025-12-22",
        "bookingDateTime": "2025-12-22T11:34:00.000Z",
        "valueDateTime": "2025-12-22T11:34:00.000Z",
        "transactionAmount": {
          "amount": "12.05",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Suhas Falafel: SF-202512-2450",
        "remittanceInformationUnstructuredArray": [
          "Payment to Suhas Falafel",
          "SF-202512-2450"
        ],
        "debtorName": "Suhas Falafel"
      },
      "paymentId": null,
      "reference": "SF-202512-2450",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmadbeshspkkgwerj0myb",
      "clustering": {
        "description": "Suhas Falafel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Suhas Falafel' based on payment details",
        "updatedAt": "2025-12-22T11:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Suhas Falafel",
        "iban": "DE68201214823164136",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ymxstfhr84wnfayc9re2bn55vq",
      "createdAt": "2025-12-22T11:11:00.000Z",
      "updatedAt": "2025-12-22T11:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 218.8,
      "currency": "GBP",
      "description": "Payment to Aer Lingus: AL-202512-5354",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w7yznqt72p6qc60nk3j17f607q",
      "fspDate": "2025-12-22T10:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w7yznqt72p6qc60nk3j17f607q",
        "bookingDate": "2025-12-22",
        "valueDate": "2025-12-22",
        "bookingDateTime": "2025-12-22T11:11:00.000Z",
        "valueDateTime": "2025-12-22T11:11:00.000Z",
        "transactionAmount": {
          "amount": "218.80",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Aer Lingus: AL-202512-5354",
        "remittanceInformationUnstructuredArray": [
          "Payment to Aer Lingus",
          "AL-202512-5354"
        ],
        "debtorName": "Aer Lingus"
      },
      "paymentId": null,
      "reference": "AL-202512-5354",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnekfvhrjnk2qd4ej2sf",
      "clustering": {
        "description": "Aer Lingus",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Aer Lingus' based on payment details",
        "updatedAt": "2025-12-22T11:11:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Aer Lingus",
        "iban": null,
        "bic": null,
        "sortCode": "719702",
        "accountNumber": "24803925"
      }
    },
    {
      "id": "txn_vq6hb70y00eq3fpm58e5wwkegx",
      "createdAt": "2025-12-22T10:29:00.000Z",
      "updatedAt": "2025-12-22T10:29:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 42613.56,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_rxpqp8768y5379bcz6v8xyk5y3",
      "fspDate": "2025-12-22T09:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk84djq864nkz",
        "bookingDate": "2025-12-22",
        "valueDate": "2025-12-22",
        "bookingDateTime": "2025-12-22T09:29:00.000Z",
        "valueDateTime": "2025-12-22T09:29:00.000Z",
        "transactionAmount": {
          "amount": "42613.56",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code and extracted 'Currency Exchange' as the description",
        "updatedAt": "2025-09-29T18:24:29.691Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_h9yvjx29j3qp8jgvd6026h0cpv",
      "createdAt": "2025-12-21T16:51:00.000Z",
      "updatedAt": "2025-12-21T16:51:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4939.74,
      "currency": "EUR",
      "description": "Payment to Emma Fitzgerald: Aug 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_zpqa1t7qhrjwytjzvf2xk1nqsk",
      "fspDate": "2025-12-21T15:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc1m6qe8prm04svd474r78",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T15:51:00.000Z",
        "valueDateTime": "2025-12-21T15:51:00.000Z",
        "transactionAmount": {
          "amount": "-4939.74",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Emma Fitzgerald: Aug 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Emma Fitzgerald: Aug 2025 Payroll"
        ],
        "debtorName": "Emma Fitzgerald"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtceshspj98ga0ebagk",
      "clustering": {
        "description": "Emma Fitzgerald",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Emma Fitzgerald' from 'Payment to Emma Fitzgerald: Aug 2025 Payroll'",
        "updatedAt": "2025-09-27T10:40:26.879Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n38p7r05pfnvqj8f50rnjqjzpz",
      "createdAt": "2025-12-21T15:10:00.000Z",
      "updatedAt": "2025-12-21T15:10:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 62.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_w6zawf20an0ark1djbry6n44c9",
      "fspDate": "2025-12-21T14:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0pbqh4ggy1m",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T14:10:00.000Z",
        "valueDateTime": "2025-12-21T14:10:00.000Z",
        "transactionAmount": {
          "amount": "-62.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:49:37.735Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3cbt3vtf2e50hj5gh4zwz198p4",
      "createdAt": "2025-12-21T13:44:00.000Z",
      "updatedAt": "2025-12-21T13:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6667,
      "currency": "EUR",
      "description": "Payment to Jonas Novak: 2025-00002",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_t37twskmwyvefm87t50jxr02fx",
      "fspDate": "2025-12-21T12:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1d323dme4dr9hh6b9d6j31s",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T12:44:00.000Z",
        "valueDateTime": "2025-12-21T12:44:00.000Z",
        "transactionAmount": {
          "amount": "-6667.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jonas Novak: 2025-00002",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jonas Novak: 2025-00002"
        ],
        "debtorName": "Jonas Novak"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x01eshsphmk5k2axdrt",
      "clustering": {
        "description": "Jonas Novak",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Jonas Novak' from 'Payment to Jonas Novak: 2025-00002'",
        "updatedAt": "2025-09-27T10:45:11.623Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8cnt6geeb753rrhd8r0m5yf9k7",
      "createdAt": "2025-12-21T13:21:00.000Z",
      "updatedAt": "2025-12-21T13:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 16.02,
      "currency": "GBP",
      "description": "Payment to Transport for London: TFL-202512-4710",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_y71g2r5fqbt8xvmekdv5hbqh9s",
      "fspDate": "2025-12-21T12:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_y71g2r5fqbt8xvmekdv5hbqh9s",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T13:21:00.000Z",
        "valueDateTime": "2025-12-21T13:21:00.000Z",
        "transactionAmount": {
          "amount": "16.02",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Transport for London: TFL-202512-4710",
        "remittanceInformationUnstructuredArray": [
          "Payment to Transport for London",
          "TFL-202512-4710"
        ],
        "debtorName": "Transport for London"
      },
      "paymentId": null,
      "reference": "TFL-202512-4710",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgk7fvhrjp0v7hz9q786",
      "clustering": {
        "description": "Transport for London",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Transport for London' based on payment details",
        "updatedAt": "2025-12-21T13:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Transport for London",
        "iban": null,
        "bic": null,
        "sortCode": "303080",
        "accountNumber": "56453427"
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmrwcwjt2xgn",
      "createdAt": "2025-12-21T10:46:00.000Z",
      "updatedAt": "2025-12-21T10:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 29,
      "currency": "GBP",
      "description": "www.argos.co.uk",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8h8tdcga5yp",
      "fspDate": "2025-12-21T09:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8h8tdcga5yp",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T09:46:00.000Z",
        "valueDateTime": "2025-12-21T09:46:00.000Z",
        "transactionAmount": {
          "amount": "-29.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "www.argos.co.uk",
        "remittanceInformationUnstructuredArray": [
          "www.argos.co.uk"
        ],
        "debtorName": "Argos"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgp9fvhrjp1ker17rwy0",
      "clustering": {
        "description": "Argos",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Argos' from 'www.argos.co.uk'",
        "updatedAt": "2025-09-29T18:26:40.979Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0h3d56q9cwn0dazqyjp7rt2ybe",
      "createdAt": "2025-12-21T08:22:00.000Z",
      "updatedAt": "2025-12-21T08:22:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 41.66,
      "currency": "EUR",
      "description": "Wispr",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_akryyhf87h60g210mt5544xq9z",
      "fspDate": "2025-12-21T07:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2y32qp1e009rppzyd1zebh4",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T07:22:00.000Z",
        "valueDateTime": "2025-12-21T07:22:00.000Z",
        "transactionAmount": {
          "amount": "-41.66",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Wispr",
        "remittanceInformationUnstructuredArray": [
          "Wispr"
        ],
        "debtorName": "Wispr"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax6ceshspjngxatk00nd",
      "clustering": {
        "description": "Wispr",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Wispr' from the transaction description.",
        "updatedAt": "2025-09-27T10:41:48.239Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfmhzjprwpth",
      "createdAt": "2025-12-20T16:27:00.000Z",
      "updatedAt": "2025-12-20T16:27:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 24.31,
      "currency": "EUR",
      "description": "Anthropic Claude Team",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0gv54bwfq9r590jsr8z7x9j",
      "fspDate": "2025-12-20T15:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0gv54bwfq9r590jsr8z7x9j",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T15:27:00.000Z",
        "valueDateTime": "2025-12-20T15:27:00.000Z",
        "transactionAmount": {
          "amount": "-24.31",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Anthropic Claude Team",
        "remittanceInformationUnstructuredArray": [
          "Anthropic Claude Team"
        ],
        "debtorName": "Anthropic"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0y2eshspjwh0d2fxb76",
      "clustering": {
        "description": "Anthropic",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Anthropic' from 'Anthropic Claude Team', removing 'Claude Team' suffix",
        "updatedAt": "2025-09-27T10:49:04.360Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_w2xg213zgjbcwdf3jaenj3xpdp",
      "createdAt": "2025-12-20T12:25:00.000Z",
      "updatedAt": "2025-12-20T12:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1.92,
      "currency": "EUR",
      "description": "Payment to Merrion Row Post Office: MRP-202512-9415",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_fakkdz29yme6zj66r347h2dcne",
      "fspDate": "2025-12-20T11:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_fakkdz29yme6zj66r347h2dcne",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T12:25:00.000Z",
        "valueDateTime": "2025-12-20T12:25:00.000Z",
        "transactionAmount": {
          "amount": "1.92",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Merrion Row Post Office: MRP-202512-9415",
        "remittanceInformationUnstructuredArray": [
          "Payment to Merrion Row Post Office",
          "MRP-202512-9415"
        ],
        "debtorName": "Merrion Row Post Office"
      },
      "paymentId": null,
      "reference": "MRP-202512-9415",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj0neshspngm4dw1pq8h",
      "clustering": {
        "description": "Merrion Row Post Office",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Merrion Row Post Office' based on payment details",
        "updatedAt": "2025-12-20T12:25:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Merrion Row Post Office",
        "iban": "DE32957839928156612",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jdxehz5ta18c6gq891kg6gaskq",
      "createdAt": "2025-12-20T11:14:00.000Z",
      "updatedAt": "2025-12-20T11:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 51.38,
      "currency": "EUR",
      "description": "Payment to Heathrow Express: HE-202512-8208",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wegqqv8mxmn121cn9jt53watff",
      "fspDate": "2025-12-20T10:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wegqqv8mxmn121cn9jt53watff",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T11:14:00.000Z",
        "valueDateTime": "2025-12-20T11:14:00.000Z",
        "transactionAmount": {
          "amount": "51.38",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Heathrow Express: HE-202512-8208",
        "remittanceInformationUnstructuredArray": [
          "Payment to Heathrow Express",
          "HE-202512-8208"
        ],
        "debtorName": "Heathrow Express"
      },
      "paymentId": null,
      "reference": "HE-202512-8208",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpg2eshspmf0nznfw91y",
      "clustering": {
        "description": "Heathrow Express",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Heathrow Express' based on payment details",
        "updatedAt": "2025-12-20T11:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Heathrow Express",
        "iban": "DE44801270972832610",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfftbtm0ke21",
      "createdAt": "2025-12-20T10:57:00.000Z",
      "updatedAt": "2025-12-20T10:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4919.23,
      "currency": "EUR",
      "description": "Payment to Emma Fitzgerald: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k10kr2c1e4dr6r2bvmzq53x7",
      "fspDate": "2025-12-20T09:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k10kr2c1e4dr6r2bvmzq53x7",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T09:57:00.000Z",
        "valueDateTime": "2025-12-20T09:57:00.000Z",
        "transactionAmount": {
          "amount": "-4919.23",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Emma Fitzgerald: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Emma Fitzgerald: July 2025 Payroll"
        ],
        "debtorName": "Emma Fitzgerald"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtceshspj98ga0ebagk",
      "clustering": {
        "description": "Emma Fitzgerald",
        "confidenceScore": "0.95",
        "rationale": "Extracted employee name 'Emma Fitzgerald' from 'Payment to Emma Fitzgerald: July 2025 Payroll'",
        "updatedAt": "2025-09-27T10:48:02.778Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yr5dt51ge56f13f8xa3rxtn8pk",
      "createdAt": "2025-12-20T10:46:00.000Z",
      "updatedAt": "2025-12-20T10:46:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 90,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_g84n2dzjpkghey1e03sxvw3cgx",
      "fspDate": "2025-12-20T09:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2feknczfk7s42a6b1fs0vbm",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T09:46:00.000Z",
        "valueDateTime": "2025-12-20T09:46:00.000Z",
        "transactionAmount": {
          "amount": "-90.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the core description for a currency conversion transaction, based on the 'EXCHANGE' code",
        "updatedAt": "2025-09-27T10:42:40.399Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_byb4efajp5m6yn4vrr65az8z2s",
      "createdAt": "2025-12-20T10:32:00.000Z",
      "updatedAt": "2025-12-20T10:32:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_2m9cta568m4kfrz7fjf1m0wqth",
      "fspDate": "2025-12-20T09:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3qv1xr6esm9bvx4h027jf3j",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T09:32:00.000Z",
        "valueDateTime": "2025-12-20T09:32:00.000Z",
        "transactionAmount": {
          "amount": "-17.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Shaka Poke' from 'Sq *shaka Poke', removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:39:39.643Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_k9dkvdvb4vmq575h15w9v2myz8",
      "createdAt": "2025-12-20T10:32:00.000Z",
      "updatedAt": "2025-12-20T10:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4277.34,
      "currency": "GBP",
      "description": "Payment to Amazon Web Services EMEA SARL: AWS-202512-1977",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_cephqaz36998zc2ydan8a0m3t5",
      "fspDate": "2025-12-20T09:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_cephqaz36998zc2ydan8a0m3t5",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T10:32:00.000Z",
        "valueDateTime": "2025-12-20T10:32:00.000Z",
        "transactionAmount": {
          "amount": "4277.34",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amazon Web Services EMEA SARL: AWS-202512-1977",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amazon Web Services EMEA SARL",
          "AWS-202512-1977"
        ],
        "debtorName": "Amazon Web Services EMEA SARL"
      },
      "paymentId": null,
      "reference": "AWS-202512-1977",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_zj7v3fq41pb9h3pwx6cbzwmfx4",
      "clustering": {
        "description": "Amazon Web Services EMEA SARL",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amazon Web Services EMEA SARL' based on payment details",
        "updatedAt": "2025-12-20T10:32:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amazon Web Services EMEA SARL",
        "iban": null,
        "bic": null,
        "sortCode": "956825",
        "accountNumber": "10117533"
      }
    },
    {
      "id": "txn_wdbz1mzync2vbjstn3xfkj3j7m",
      "createdAt": "2025-12-20T08:01:00.000Z",
      "updatedAt": "2025-12-20T08:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 232.16,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_shed4xej21thwcrdp1e1sj9xgn",
      "fspDate": "2025-12-20T07:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0e8rfh4exraqe0kkrzm2v9t",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T07:01:00.000Z",
        "valueDateTime": "2025-12-20T07:01:00.000Z",
        "transactionAmount": {
          "amount": "-232.16",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'OpenAI' from 'Openai *chatgpt Subscr'",
        "updatedAt": "2025-09-27T10:49:37.646Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_am5a109d83n2tx8nc70tv9zhyr",
      "createdAt": "2025-12-19T16:32:00.000Z",
      "updatedAt": "2025-12-19T16:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 61117.54,
      "currency": "GBP",
      "description": "Payment from Enterprise Systems Inc - INV-202512-3757",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_p62x7e1nd3c3e2bq5b54d14ba6",
      "fspDate": "2025-12-19T15:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_p62x7e1nd3c3e2bq5b54d14ba6",
        "bookingDate": "2025-12-19",
        "valueDate": "2025-12-19",
        "bookingDateTime": "2025-12-19T16:32:00.000Z",
        "valueDateTime": "2025-12-19T16:32:00.000Z",
        "transactionAmount": {
          "amount": "61117.54",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Enterprise Systems Inc - INV-202512-3757",
        "remittanceInformationUnstructuredArray": [
          "Payment from Enterprise Systems Inc",
          "INV-202512-3757"
        ],
        "creditorName": "Enterprise Systems Inc"
      },
      "paymentId": null,
      "reference": "INV-202512-3757",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1jqt0xq8p3az0ed45aqq7npx6w",
      "clustering": {
        "description": "Enterprise Systems Inc",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Enterprise Systems Inc'",
        "updatedAt": "2025-12-19T16:32:00.000Z"
      },
      "payer": {
        "name": "Enterprise Systems Inc",
        "iban": null,
        "bic": null,
        "sortCode": "355003",
        "accountNumber": "14509646"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_978zrnx8kb4s5ekat0hvzesq82",
      "createdAt": "2025-12-19T12:35:00.000Z",
      "updatedAt": "2025-12-19T12:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.87,
      "currency": "EUR",
      "description": "Payment to XAI: X-202512-6117",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_dcnye7ftpdtfxwcqznwn944djt",
      "fspDate": "2025-12-19T11:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_dcnye7ftpdtfxwcqznwn944djt",
        "bookingDate": "2025-12-19",
        "valueDate": "2025-12-19",
        "bookingDateTime": "2025-12-19T12:35:00.000Z",
        "valueDateTime": "2025-12-19T12:35:00.000Z",
        "transactionAmount": {
          "amount": "25.87",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to XAI: X-202512-6117",
        "remittanceInformationUnstructuredArray": [
          "Payment to XAI",
          "X-202512-6117"
        ],
        "debtorName": "XAI"
      },
      "paymentId": null,
      "reference": "X-202512-6117",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgt8yeshspk60ezf5bsne",
      "clustering": {
        "description": "XAI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'XAI' based on payment details",
        "updatedAt": "2025-12-19T12:35:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "XAI",
        "iban": "DE60443264390133470",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nd7qg9938akb12j1mjasp3bfv9",
      "createdAt": "2025-12-19T11:07:00.000Z",
      "updatedAt": "2025-12-19T11:07:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 16.5,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_bzbqncn65b4fz9r812bq8xgpnf",
      "fspDate": "2025-12-19T10:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3qv1xr7esm9bvxq9pqmddqr",
        "bookingDate": "2025-12-19",
        "valueDate": "2025-12-19",
        "bookingDateTime": "2025-12-19T10:07:00.000Z",
        "valueDateTime": "2025-12-19T10:07:00.000Z",
        "transactionAmount": {
          "amount": "-16.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Shaka Poke' from 'Sq *shaka Poke', removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:39:39.648Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9h1scs3xsm9p1c3jcd3knsp82n",
      "createdAt": "2025-12-18T15:14:00.000Z",
      "updatedAt": "2025-12-18T15:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 22.29,
      "currency": "EUR",
      "description": "Payment to Anthony Moore: AM-202512-6019",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_g8vcf6h15kezwyw6f9v7rm5zzs",
      "fspDate": "2025-12-18T14:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_g8vcf6h15kezwyw6f9v7rm5zzs",
        "bookingDate": "2025-12-18",
        "valueDate": "2025-12-18",
        "bookingDateTime": "2025-12-18T15:14:00.000Z",
        "valueDateTime": "2025-12-18T15:14:00.000Z",
        "transactionAmount": {
          "amount": "22.29",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthony Moore: AM-202512-6019",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthony Moore",
          "AM-202512-6019"
        ],
        "debtorName": "Anthony Moore"
      },
      "paymentId": null,
      "reference": "AM-202512-6019",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a2keshspnzq7m9sbpn2",
      "clustering": {
        "description": "Anthony Moore",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthony Moore' based on payment details",
        "updatedAt": "2025-12-18T15:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthony Moore",
        "iban": "DE93952879246298080",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgeywvyxh7sa",
      "createdAt": "2025-12-17T15:47:00.000Z",
      "updatedAt": "2025-12-17T15:47:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4939.74,
      "currency": "EUR",
      "description": "To Emma Fitzgerald",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1cm6mzr20se",
      "fspDate": "2025-12-17T14:47:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1cm6mzr20se",
        "bookingDate": "2025-12-17",
        "valueDate": "2025-12-17",
        "bookingDateTime": "2025-12-17T14:47:00.000Z",
        "valueDateTime": "2025-12-17T14:47:00.000Z",
        "transactionAmount": {
          "amount": "-4939.74",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Emma Fitzgerald",
        "remittanceInformationUnstructuredArray": [
          "To Emma Fitzgerald"
        ],
        "debtorName": "Emma Fitzgerald"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtceshspj98ga0ebagk",
      "clustering": {
        "description": "Emma Fitzgerald",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Emma Fitzgerald' from 'To Emma Fitzgerald'.",
        "updatedAt": "2025-09-27T10:52:47.341Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgsq700rq119",
      "createdAt": "2025-12-17T15:11:00.000Z",
      "updatedAt": "2025-12-17T15:11:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1pjj4yy8vz8",
      "fspDate": "2025-12-17T14:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1pjj4yy8vz8",
        "bookingDate": "2025-12-17",
        "valueDate": "2025-12-17",
        "bookingDateTime": "2025-12-17T14:11:00.000Z",
        "valueDateTime": "2025-12-17T14:11:00.000Z",
        "transactionAmount": {
          "amount": "-25.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Zakura' from the raw transaction description.",
        "updatedAt": "2025-09-27T10:53:55.643Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8gd9kyjk43vdzn6gy58c4hsgm2",
      "createdAt": "2025-12-17T12:01:00.000Z",
      "updatedAt": "2025-12-17T12:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Sumup *doncanizales",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_z4d2v75ac3hgj6s54ag8kfw780",
      "fspDate": "2025-12-17T11:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1jaadqbfk0vtsr7p9spxj07",
        "bookingDate": "2025-12-17",
        "valueDate": "2025-12-17",
        "bookingDateTime": "2025-12-17T11:01:00.000Z",
        "valueDateTime": "2025-12-17T11:01:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *doncanizales",
        "remittanceInformationUnstructuredArray": [
          "Sumup *doncanizales"
        ],
        "debtorName": "Don Canizales"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "clustering": {
        "description": "Sumup",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Sumup' from 'Sumup *doncanizales', removing the Sumup * prefix",
        "updatedAt": "2025-09-27T10:45:11.522Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xsgzx58dre20k03x6dxk2g1enc",
      "createdAt": "2025-12-17T11:58:00.000Z",
      "updatedAt": "2025-12-17T11:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 635.31,
      "currency": "EUR",
      "description": "Payment to Clayton Hotel Burlington: CHB-202512-5985",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qk7qkc83tx7efk5h8x6eax6xk2",
      "fspDate": "2025-12-17T10:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qk7qkc83tx7efk5h8x6eax6xk2",
        "bookingDate": "2025-12-17",
        "valueDate": "2025-12-17",
        "bookingDateTime": "2025-12-17T11:58:00.000Z",
        "valueDateTime": "2025-12-17T11:58:00.000Z",
        "transactionAmount": {
          "amount": "635.31",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Burlington: CHB-202512-5985",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Burlington",
          "CHB-202512-5985"
        ],
        "debtorName": "Clayton Hotel Burlington"
      },
      "paymentId": null,
      "reference": "CHB-202512-5985",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crppkeshspmfw2e0m4xdm",
      "clustering": {
        "description": "Clayton Hotel Burlington",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Burlington' based on payment details",
        "updatedAt": "2025-12-17T11:58:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Burlington",
        "iban": "DE74582217353965000",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_hkx2hcwbvbaja5ehxqkn1xsmf9",
      "createdAt": "2025-12-17T11:34:00.000Z",
      "updatedAt": "2025-12-17T11:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 40.64,
      "currency": "GBP",
      "description": "Payment to Deliveroo: D-202512-1548",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rrs4cwjezms9m127mfygkf909h",
      "fspDate": "2025-12-17T10:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rrs4cwjezms9m127mfygkf909h",
        "bookingDate": "2025-12-17",
        "valueDate": "2025-12-17",
        "bookingDateTime": "2025-12-17T11:34:00.000Z",
        "valueDateTime": "2025-12-17T11:34:00.000Z",
        "transactionAmount": {
          "amount": "40.64",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Deliveroo: D-202512-1548",
        "remittanceInformationUnstructuredArray": [
          "Payment to Deliveroo",
          "D-202512-1548"
        ],
        "debtorName": "Deliveroo"
      },
      "paymentId": null,
      "reference": "D-202512-1548",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmcfvhrjp16bczghe88",
      "clustering": {
        "description": "Deliveroo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Deliveroo' based on payment details",
        "updatedAt": "2025-12-17T11:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Deliveroo",
        "iban": null,
        "bic": null,
        "sortCode": "405238",
        "accountNumber": "29466528"
      }
    },
    {
      "id": "txn_p3c224pm4mt7b76bj4za0dbr9j",
      "createdAt": "2025-12-17T10:27:00.000Z",
      "updatedAt": "2025-12-17T10:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3690,
      "currency": "EUR",
      "description": "Payment to PEMBROKEHALL LTD: 150895",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_0srw8ahnbrs95wf39zavxfr4r5",
      "fspDate": "2025-12-17T09:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0f8571wfvqsgxc1va4bj5f8",
        "bookingDate": "2025-12-17",
        "valueDate": "2025-12-17",
        "bookingDateTime": "2025-12-17T09:27:00.000Z",
        "valueDateTime": "2025-12-17T09:27:00.000Z",
        "transactionAmount": {
          "amount": "-3690.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to PEMBROKEHALL LTD: 150895",
        "remittanceInformationUnstructuredArray": [
          "Payment to PEMBROKEHALL LTD: 150895"
        ],
        "debtorName": "PEMBROKEHALL LTD"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzdeshsphm46adfgbg7",
      "clustering": {
        "description": "PEMBROKEHALL LTD",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'PEMBROKEHALL LTD' from 'Payment to PEMBROKEHALL LTD: 150895'",
        "updatedAt": "2025-09-27T10:49:37.665Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg83gq7e0nvz",
      "createdAt": "2025-12-16T17:27:00.000Z",
      "updatedAt": "2025-12-16T17:27:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 40000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2472e8pvk14vtgjmdq18",
      "fspDate": "2025-12-16T16:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk14vtgjmdq18",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T11:00:00.000Z",
        "valueDateTime": "2026-01-07T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-40000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:52:09.921Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf6hh3q9s3xy",
      "createdAt": "2025-12-16T17:22:00.000Z",
      "updatedAt": "2025-12-16T17:22:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 3465.14,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1jbe51pfk0vv2ww457f8w1q",
      "fspDate": "2025-12-16T16:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1jbe51pfk0vv2ww457f8w1q",
        "bookingDate": "2025-12-16",
        "valueDate": "2025-12-16",
        "bookingDateTime": "2025-12-16T16:22:00.000Z",
        "valueDateTime": "2025-12-16T16:22:00.000Z",
        "transactionAmount": {
          "amount": "-3465.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:45:11.515Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yhhscfwd9pjbqwzefy6feyrrac",
      "createdAt": "2025-12-16T15:35:00.000Z",
      "updatedAt": "2025-12-16T15:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4500,
      "currency": "GBP",
      "description": "To Wealthkernel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_pr899sra5kc2e28sb14xcezb7p",
      "fspDate": "2025-12-16T14:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk880hc55k840",
        "bookingDate": "2025-12-16",
        "valueDate": "2025-12-16",
        "bookingDateTime": "2025-12-16T14:35:00.000Z",
        "valueDateTime": "2025-12-16T14:35:00.000Z",
        "transactionAmount": {
          "amount": "-4500.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Wealthkernel Limited",
        "remittanceInformationUnstructuredArray": [
          "To Wealthkernel Limited"
        ],
        "debtorName": "Wealthkernel Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhng0fvhrjnk93frdx83x",
      "clustering": {
        "description": "Wealthkernel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Wealthkernel' from 'To Wealthkernel Limited'",
        "updatedAt": "2025-09-29T18:25:01.153Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfwn0zc9ckk1",
      "createdAt": "2025-12-16T14:29:00.000Z",
      "updatedAt": "2025-12-16T14:29:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Sq *seoul Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0secmeke4hf",
      "fspDate": "2025-12-16T13:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0secmeke4hf",
        "bookingDate": "2025-12-16",
        "valueDate": "2025-12-16",
        "bookingDateTime": "2025-12-16T13:29:00.000Z",
        "valueDateTime": "2025-12-16T13:29:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *seoul Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Sq *seoul Kitchen"
        ],
        "debtorName": "Seoul Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pzaeshspjhkemvf76tx",
      "clustering": {
        "description": "Seoul Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seoul Kitchen' from 'Sq *seoul Kitchen'",
        "updatedAt": "2025-09-27T10:50:08.356Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_90x725k7er4bz7nr9hnap5rrxk",
      "createdAt": "2025-12-16T11:37:00.000Z",
      "updatedAt": "2025-12-16T11:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 33.64,
      "currency": "EUR",
      "description": "Payment to The Woolshed: TW-202512-4837",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_x5hf2qmg2xvfv94mp2tqd6pnn7",
      "fspDate": "2025-12-16T10:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_x5hf2qmg2xvfv94mp2tqd6pnn7",
        "bookingDate": "2025-12-16",
        "valueDate": "2025-12-16",
        "bookingDateTime": "2025-12-16T11:37:00.000Z",
        "valueDateTime": "2025-12-16T11:37:00.000Z",
        "transactionAmount": {
          "amount": "33.64",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Woolshed: TW-202512-4837",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Woolshed",
          "TW-202512-4837"
        ],
        "debtorName": "The Woolshed"
      },
      "paymentId": null,
      "reference": "TW-202512-4837",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1pkeshspm729w29ytag",
      "clustering": {
        "description": "The Woolshed",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Woolshed' based on payment details",
        "updatedAt": "2025-12-16T11:37:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Woolshed",
        "iban": "DE29667359888710090",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_98t44dp89jv0z0we6e2qg9mvmq",
      "createdAt": "2025-12-15T16:14:00.000Z",
      "updatedAt": "2025-12-15T16:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 624.43,
      "currency": "EUR",
      "description": "Payment to Denis Breen & Co: DB&-202512-8017",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2m5avsf091nc2z52ywxt1842yp",
      "fspDate": "2025-12-15T15:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2m5avsf091nc2z52ywxt1842yp",
        "bookingDate": "2025-12-15",
        "valueDate": "2025-12-15",
        "bookingDateTime": "2025-12-15T16:14:00.000Z",
        "valueDateTime": "2025-12-15T16:14:00.000Z",
        "transactionAmount": {
          "amount": "624.43",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Denis Breen & Co: DB&-202512-8017",
        "remittanceInformationUnstructuredArray": [
          "Payment to Denis Breen & Co",
          "DB&-202512-8017"
        ],
        "debtorName": "Denis Breen & Co"
      },
      "paymentId": null,
      "reference": "DB&-202512-8017",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zb1eshspj0854px1k2v",
      "clustering": {
        "description": "Denis Breen & Co",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Denis Breen & Co' based on payment details",
        "updatedAt": "2025-12-15T16:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Denis Breen & Co",
        "iban": "DE15590180985934770",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_y2wq8wzf14ca94amvqk216badg",
      "createdAt": "2025-12-15T13:59:00.000Z",
      "updatedAt": "2025-12-15T13:59:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 13,
      "currency": "EUR",
      "description": "Sumup *doncanizales",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_m0q84qkh90xcjz1hda7n8qng2z",
      "fspDate": "2025-12-15T12:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0rzth9r2tmz",
        "bookingDate": "2025-12-15",
        "valueDate": "2025-12-15",
        "bookingDateTime": "2025-12-15T12:59:00.000Z",
        "valueDateTime": "2025-12-15T12:59:00.000Z",
        "transactionAmount": {
          "amount": "-13.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *doncanizales",
        "remittanceInformationUnstructuredArray": [
          "Sumup *doncanizales"
        ],
        "debtorName": "Don Canizales"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "clustering": {
        "description": "Don Canizales",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Don Canizales' from 'Sumup *doncanizales'",
        "updatedAt": "2025-09-27T10:50:08.349Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wj1jat6wc0xyq9j4cm8fnjeb0b",
      "createdAt": "2025-12-15T12:29:00.000Z",
      "updatedAt": "2025-12-15T12:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.6,
      "currency": "EUR",
      "description": "Payment to Companies Registration Office: CRO-202512-8345",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5aq0j9326g9day0nramyd27jhk",
      "fspDate": "2025-12-15T11:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5aq0j9326g9day0nramyd27jhk",
        "bookingDate": "2025-12-15",
        "valueDate": "2025-12-15",
        "bookingDateTime": "2025-12-15T12:29:00.000Z",
        "valueDateTime": "2025-12-15T12:29:00.000Z",
        "transactionAmount": {
          "amount": "20.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Companies Registration Office: CRO-202512-8345",
        "remittanceInformationUnstructuredArray": [
          "Payment to Companies Registration Office",
          "CRO-202512-8345"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": "CRO-202512-8345",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration Office",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Companies Registration Office' based on payment details",
        "updatedAt": "2025-12-15T12:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Companies Registration Office",
        "iban": "DE31208147017081530",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_612jkyeqasej49nnvvmdwzaqnd",
      "createdAt": "2025-12-15T10:49:00.000Z",
      "updatedAt": "2025-12-15T10:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1972.02,
      "currency": "EUR",
      "description": "Payment to Patrick Walsh: PW-202512-4544",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mda7vebw9p97m1qepm6sbd85a8",
      "fspDate": "2025-12-15T09:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mda7vebw9p97m1qepm6sbd85a8",
        "bookingDate": "2025-12-15",
        "valueDate": "2025-12-15",
        "bookingDateTime": "2025-12-15T10:49:00.000Z",
        "valueDateTime": "2025-12-15T10:49:00.000Z",
        "transactionAmount": {
          "amount": "1972.02",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Patrick Walsh: PW-202512-4544",
        "remittanceInformationUnstructuredArray": [
          "Payment to Patrick Walsh",
          "PW-202512-4544"
        ],
        "debtorName": "Patrick Walsh"
      },
      "paymentId": null,
      "reference": "PW-202512-4544",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqmzweshspm8kq27v8562",
      "clustering": {
        "description": "Patrick Walsh",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Patrick Walsh' based on payment details",
        "updatedAt": "2025-12-15T10:49:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Patrick Walsh",
        "iban": "DE59711748798506216",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wcwb5yq12625d8nx9t8904n2v6",
      "createdAt": "2025-12-15T09:24:00.000Z",
      "updatedAt": "2025-12-15T09:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.03,
      "currency": "USD",
      "description": "Payment to Google Play: GP-202512-4324",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bn3gjrmq1a928j7j0bfkh8dbvw",
      "fspDate": "2025-12-15T08:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bn3gjrmq1a928j7j0bfkh8dbvw",
        "bookingDate": "2025-12-15",
        "valueDate": "2025-12-15",
        "bookingDateTime": "2025-12-15T09:24:00.000Z",
        "valueDateTime": "2025-12-15T09:24:00.000Z",
        "transactionAmount": {
          "amount": "3.03",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Google Play: GP-202512-4324",
        "remittanceInformationUnstructuredArray": [
          "Payment to Google Play",
          "GP-202512-4324"
        ],
        "debtorName": "Google Play"
      },
      "paymentId": null,
      "reference": "GP-202512-4324",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wjeeshsphy7nnkfq48b",
      "clustering": {
        "description": "Google Play",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Google Play' based on payment details",
        "updatedAt": "2025-12-15T09:24:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Google Play",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0vp3gbb2q70c3rrmqs4v2av37r",
      "createdAt": "2025-12-15T09:20:00.000Z",
      "updatedAt": "2025-12-15T09:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 26.46,
      "currency": "GBP",
      "description": "Payment to Modulr Finance: MF-202512-9846",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qdm2kw315vypc88smxyyrhs1tv",
      "fspDate": "2025-12-15T08:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qdm2kw315vypc88smxyyrhs1tv",
        "bookingDate": "2025-12-15",
        "valueDate": "2025-12-15",
        "bookingDateTime": "2025-12-15T09:20:00.000Z",
        "valueDateTime": "2025-12-15T09:20:00.000Z",
        "transactionAmount": {
          "amount": "26.46",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Modulr Finance: MF-202512-9846",
        "remittanceInformationUnstructuredArray": [
          "Payment to Modulr Finance",
          "MF-202512-9846"
        ],
        "debtorName": "Modulr Finance"
      },
      "paymentId": null,
      "reference": "MF-202512-9846",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Modulr Finance' based on payment details",
        "updatedAt": "2025-12-15T09:20:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Modulr Finance",
        "iban": null,
        "bic": null,
        "sortCode": "335750",
        "accountNumber": "84082656"
      }
    },
    {
      "id": "txn_kt7zpzw7rhcezyssj0h7s1n1bg",
      "createdAt": "2025-12-14T14:41:00.000Z",
      "updatedAt": "2025-12-14T14:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 24.3,
      "currency": "EUR",
      "description": "Payment to Tang: T-202512-6368",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_82fs8v8awpmkwp44hpz259652b",
      "fspDate": "2025-12-14T13:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_82fs8v8awpmkwp44hpz259652b",
        "bookingDate": "2025-12-14",
        "valueDate": "2025-12-14",
        "bookingDateTime": "2025-12-14T14:41:00.000Z",
        "valueDateTime": "2025-12-14T14:41:00.000Z",
        "transactionAmount": {
          "amount": "24.30",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tang: T-202512-6368",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tang",
          "T-202512-6368"
        ],
        "debtorName": "Tang"
      },
      "paymentId": null,
      "reference": "T-202512-6368",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gseshspjyrwgx4ccwg",
      "clustering": {
        "description": "Tang",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tang' based on payment details",
        "updatedAt": "2025-12-14T14:41:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tang",
        "iban": "DE44807035574345770",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yez2tkcha61qkbbyzcek5az4w9",
      "createdAt": "2025-12-14T12:22:00.000Z",
      "updatedAt": "2025-12-14T12:22:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_nca3eznmcrs09b4n21829jazgt",
      "fspDate": "2025-12-14T11:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1sv1vzp520q",
        "bookingDate": "2025-12-14",
        "valueDate": "2025-12-14",
        "bookingDateTime": "2025-12-14T11:22:00.000Z",
        "valueDateTime": "2025-12-14T11:22:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Coffee Angel' from the raw transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:53:55.716Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8rx9kyw7ty34w8tmaabprhhjde",
      "createdAt": "2025-12-14T11:33:00.000Z",
      "updatedAt": "2025-12-14T11:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2.25,
      "currency": "GBP",
      "description": "Payment to Mylands: M-202512-9767",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_z09368x3r924emsme86zc822pn",
      "fspDate": "2025-12-14T10:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_z09368x3r924emsme86zc822pn",
        "bookingDate": "2025-12-14",
        "valueDate": "2025-12-14",
        "bookingDateTime": "2025-12-14T11:33:00.000Z",
        "valueDateTime": "2025-12-14T11:33:00.000Z",
        "transactionAmount": {
          "amount": "2.25",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mylands: M-202512-9767",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mylands",
          "M-202512-9767"
        ],
        "debtorName": "Mylands"
      },
      "paymentId": null,
      "reference": "M-202512-9767",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbnxzzfvhrjp5np8trhg47",
      "clustering": {
        "description": "Mylands",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mylands' based on payment details",
        "updatedAt": "2025-12-14T11:33:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mylands",
        "iban": null,
        "bic": null,
        "sortCode": "689722",
        "accountNumber": "62537748"
      }
    },
    {
      "id": "txn_mygg53axr36av2zvzfatzstsey",
      "createdAt": "2025-12-14T10:38:00.000Z",
      "updatedAt": "2025-12-14T10:38:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 15470.12,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_6r860xpeq1n0hz1a4s0kbh39ga",
      "fspDate": "2025-12-14T09:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk21a3xnkqc3v",
        "bookingDate": "2025-12-14",
        "valueDate": "2025-12-14",
        "bookingDateTime": "2025-12-14T09:38:00.000Z",
        "valueDateTime": "2025-12-14T09:38:00.000Z",
        "transactionAmount": {
          "amount": "-15470.12",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange as the merchant name for the currency conversion transaction based on the 'EXCHANGE' code",
        "updatedAt": "2025-09-27T10:54:50.816Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mbdnzd4erctnkcf3jwt3swf5dq",
      "createdAt": "2025-12-14T10:34:00.000Z",
      "updatedAt": "2025-12-14T10:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 58.21,
      "currency": "GBP",
      "description": "Payment to Pembroke Hall Limited: PHL-202512-6862",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_kr1d9g8srn1mpj20fr6rhr3wgx",
      "fspDate": "2025-12-14T09:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_kr1d9g8srn1mpj20fr6rhr3wgx",
        "bookingDate": "2025-12-14",
        "valueDate": "2025-12-14",
        "bookingDateTime": "2025-12-14T10:34:00.000Z",
        "valueDateTime": "2025-12-14T10:34:00.000Z",
        "transactionAmount": {
          "amount": "58.21",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pembroke Hall Limited: PHL-202512-6862",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pembroke Hall Limited",
          "PHL-202512-6862"
        ],
        "debtorName": "Pembroke Hall Limited"
      },
      "paymentId": null,
      "reference": "PHL-202512-6862",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fpgn1yfzz9aex3cr77xa32",
      "clustering": {
        "description": "Pembroke Hall Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pembroke Hall Limited' based on payment details",
        "updatedAt": "2025-12-14T10:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pembroke Hall Limited",
        "iban": null,
        "bic": null,
        "sortCode": "750047",
        "accountNumber": "88159141"
      }
    },
    {
      "id": "txn_q1kf9w7q4vaqwhbnjk8qxerb37",
      "createdAt": "2025-12-14T09:36:00.000Z",
      "updatedAt": "2025-12-14T09:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3280.4,
      "currency": "GBP",
      "description": "Payment to Grow Your Boat Ltd: GYB-202512-8743",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ec5tnnth6dc1wy5axg5k53s5mx",
      "fspDate": "2025-12-14T08:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ec5tnnth6dc1wy5axg5k53s5mx",
        "bookingDate": "2025-12-14",
        "valueDate": "2025-12-14",
        "bookingDateTime": "2025-12-14T09:36:00.000Z",
        "valueDateTime": "2025-12-14T09:36:00.000Z",
        "transactionAmount": {
          "amount": "3280.40",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Grow Your Boat Ltd: GYB-202512-8743",
        "remittanceInformationUnstructuredArray": [
          "Payment to Grow Your Boat Ltd",
          "GYB-202512-8743"
        ],
        "debtorName": "Grow Your Boat Ltd"
      },
      "paymentId": null,
      "reference": "GYB-202512-8743",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "clustering": {
        "description": "Grow Your Boat Ltd",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Grow Your Boat Ltd' based on payment details",
        "updatedAt": "2025-12-14T09:36:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Grow Your Boat Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "800474",
        "accountNumber": "75303301"
      }
    },
    {
      "id": "txn_kew7nhd17aa99yw6r8mkywmj8g",
      "createdAt": "2025-12-14T09:06:00.000Z",
      "updatedAt": "2025-12-14T09:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 16.67,
      "currency": "EUR",
      "description": "Payment to Burger Cartel: BC-202512-1345",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_13evhm3yp6jrkgg1kwfm4ybc5q",
      "fspDate": "2025-12-14T08:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_13evhm3yp6jrkgg1kwfm4ybc5q",
        "bookingDate": "2025-12-14",
        "valueDate": "2025-12-14",
        "bookingDateTime": "2025-12-14T09:06:00.000Z",
        "valueDateTime": "2025-12-14T09:06:00.000Z",
        "transactionAmount": {
          "amount": "16.67",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Burger Cartel: BC-202512-1345",
        "remittanceInformationUnstructuredArray": [
          "Payment to Burger Cartel",
          "BC-202512-1345"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": "BC-202512-1345",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Burger Cartel' based on payment details",
        "updatedAt": "2025-12-14T09:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Burger Cartel",
        "iban": "DE74613651076588910",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfcd1y5zbts7",
      "createdAt": "2025-12-13T14:29:00.000Z",
      "updatedAt": "2025-12-13T14:29:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 182.6,
      "currency": "EUR",
      "description": "Reflect Software Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k15eb0nme4dr76ae9vem46fz",
      "fspDate": "2025-12-13T13:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k15eb0nme4dr76ae9vem46fz",
        "bookingDate": "2025-12-13",
        "valueDate": "2025-12-13",
        "bookingDateTime": "2025-12-13T13:29:00.000Z",
        "valueDateTime": "2025-12-13T13:29:00.000Z",
        "transactionAmount": {
          "amount": "-182.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Reflect Software Inc.",
        "remittanceInformationUnstructuredArray": [
          "Reflect Software Inc."
        ],
        "debtorName": "Reflect Software"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wfmeshsphxg0s376ywm",
      "clustering": {
        "description": "Reflect Software",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Reflect Software' from 'Reflect Software Inc.'",
        "updatedAt": "2025-09-27T10:48:02.642Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pam14jj0fw5ndc9pr4jtxq62hd",
      "createdAt": "2025-12-12T13:53:00.000Z",
      "updatedAt": "2025-12-12T13:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 128.69,
      "currency": "EUR",
      "description": "Payment to Slack: S-202512-8694",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_761byy93bjmt568t1601qpdd7h",
      "fspDate": "2025-12-12T12:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_761byy93bjmt568t1601qpdd7h",
        "bookingDate": "2025-12-12",
        "valueDate": "2025-12-12",
        "bookingDateTime": "2025-12-12T13:53:00.000Z",
        "valueDateTime": "2025-12-12T13:53:00.000Z",
        "transactionAmount": {
          "amount": "128.69",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack: S-202512-8694",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack",
          "S-202512-8694"
        ],
        "debtorName": "Slack"
      },
      "paymentId": null,
      "reference": "S-202512-8694",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtb9eshspk6e4wt4npvh",
      "clustering": {
        "description": "Slack",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack' based on payment details",
        "updatedAt": "2025-12-12T13:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack",
        "iban": "DE51705081794927180",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgftp6v9h66h",
      "createdAt": "2025-12-12T10:55:00.000Z",
      "updatedAt": "2025-12-12T10:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7733.84,
      "currency": "EUR",
      "description": "To Cormac Byrne",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1d8626218z9",
      "fspDate": "2025-12-12T09:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1d8626218z9",
        "bookingDate": "2025-12-12",
        "valueDate": "2025-12-12",
        "bookingDateTime": "2025-12-12T09:55:00.000Z",
        "valueDateTime": "2025-12-12T09:55:00.000Z",
        "transactionAmount": {
          "amount": "-7733.84",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Cormac Byrne",
        "remittanceInformationUnstructuredArray": [
          "To Cormac Byrne"
        ],
        "debtorName": "Cormac Byrne"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zspeshspj7tfmtn8s05",
      "clustering": {
        "description": "Cormac Byrne",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Cormac Byrne' from 'To Cormac Byrne'.",
        "updatedAt": "2025-09-27T10:52:47.384Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vc6sscdr06n26yb2pn6c9h30xj",
      "createdAt": "2025-12-12T10:07:00.000Z",
      "updatedAt": "2025-12-12T10:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.39,
      "currency": "EUR",
      "description": "Payment to Pinecone Coffee: PC-202512-6916",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ydm5t40arvx0p0v4xn99mf4s1v",
      "fspDate": "2025-12-12T09:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ydm5t40arvx0p0v4xn99mf4s1v",
        "bookingDate": "2025-12-12",
        "valueDate": "2025-12-12",
        "bookingDateTime": "2025-12-12T10:07:00.000Z",
        "valueDateTime": "2025-12-12T10:07:00.000Z",
        "transactionAmount": {
          "amount": "3.39",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pinecone Coffee: PC-202512-6916",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pinecone Coffee",
          "PC-202512-6916"
        ],
        "debtorName": "Pinecone Coffee"
      },
      "paymentId": null,
      "reference": "PC-202512-6916",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh31eshspkh23ahabkmn",
      "clustering": {
        "description": "Pinecone Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pinecone Coffee' based on payment details",
        "updatedAt": "2025-12-12T10:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pinecone Coffee",
        "iban": "DE49599517812596180",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xee38dnnwt2149as59mnjx25n5",
      "createdAt": "2025-12-12T09:21:00.000Z",
      "updatedAt": "2025-12-12T09:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 600,
      "currency": "EUR",
      "description": "To Company Formations International Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_xq95aay02nds5frfcddezjjj1g",
      "fspDate": "2025-12-12T08:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1yd1y32w3k5",
        "bookingDate": "2025-12-12",
        "valueDate": "2025-12-12",
        "bookingDateTime": "2025-12-12T08:21:00.000Z",
        "valueDateTime": "2025-12-12T08:21:00.000Z",
        "transactionAmount": {
          "amount": "-600.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Company Formations International Limited",
        "remittanceInformationUnstructuredArray": [
          "To Company Formations International Limited"
        ],
        "debtorName": "Company Formations International Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cvstpeshspn39955xdf4m",
      "clustering": {
        "description": "Company Formations International",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Company Formations International' from 'To Company Formations International Limited', removing the 'Limited' suffix.",
        "updatedAt": "2025-09-27T10:54:12.584Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_r4mcs8brzdbswfznk76nwk2gzm",
      "createdAt": "2025-12-12T08:57:00.000Z",
      "updatedAt": "2025-12-12T08:57:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 6.4,
      "currency": "GBP",
      "description": "Pret A Manger Ni002 Be",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_xns4y63a3rh46wmdsdy2bq44bn",
      "fspDate": "2025-12-12T07:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8cbmsmzzkqz",
        "bookingDate": "2025-12-12",
        "valueDate": "2025-12-12",
        "bookingDateTime": "2025-12-12T07:57:00.000Z",
        "valueDateTime": "2025-12-12T07:57:00.000Z",
        "transactionAmount": {
          "amount": "-6.40",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Pret A Manger Ni002 Be",
        "remittanceInformationUnstructuredArray": [
          "Pret A Manger Ni002 Be"
        ],
        "debtorName": "Pret A Manger"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crphqeshspmfftkxpt85b",
      "clustering": {
        "description": "Pret A Manger",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Pret A Manger' from 'Pret A Manger Ni002 Be'",
        "updatedAt": "2025-09-29T18:25:48.575Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gc495qp5wjzz2zstmmqb713564",
      "createdAt": "2025-12-12T08:34:00.000Z",
      "updatedAt": "2025-12-12T08:34:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14.5,
      "currency": "EUR",
      "description": "Sumup *a Taste Of Tha",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_46pzj1nxs3wj5xg7510j66g4r9",
      "fspDate": "2025-12-12T07:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1jwg698zmhq",
        "bookingDate": "2025-12-12",
        "valueDate": "2025-12-12",
        "bookingDateTime": "2025-12-12T07:34:00.000Z",
        "valueDateTime": "2025-12-12T07:34:00.000Z",
        "transactionAmount": {
          "amount": "-14.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *a Taste Of Tha",
        "remittanceInformationUnstructuredArray": [
          "Sumup *a Taste Of Tha"
        ],
        "debtorName": "A Taste of Thai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1m2eshspm6a6wp0a9jq",
      "clustering": {
        "description": "A Taste of Thai",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'A Taste of Thai' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.151Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zj8sqttww8qjwm7arw014tgmkg",
      "createdAt": "2025-12-11T15:30:00.000Z",
      "updatedAt": "2025-12-11T15:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 27304.24,
      "currency": "EUR",
      "description": "Payment from EuroTech Innovations - INV-202512-1972",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_cjk0rdcegk447w7252xqjefjs1",
      "fspDate": "2025-12-11T14:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_cjk0rdcegk447w7252xqjefjs1",
        "bookingDate": "2025-12-11",
        "valueDate": "2025-12-11",
        "bookingDateTime": "2025-12-11T15:30:00.000Z",
        "valueDateTime": "2025-12-11T15:30:00.000Z",
        "transactionAmount": {
          "amount": "27304.24",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from EuroTech Innovations - INV-202512-1972",
        "remittanceInformationUnstructuredArray": [
          "Payment from EuroTech Innovations",
          "INV-202512-1972"
        ],
        "creditorName": "EuroTech Innovations"
      },
      "paymentId": null,
      "reference": "INV-202512-1972",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m17gcz62vyhqqefr5q41a31k5f",
      "clustering": {
        "description": "EuroTech Innovations",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'EuroTech Innovations'",
        "updatedAt": "2025-12-11T15:30:00.000Z"
      },
      "payer": {
        "name": "EuroTech Innovations",
        "iban": "DE32028432951070350",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmdr3s8wqvxz",
      "createdAt": "2025-12-11T14:46:00.000Z",
      "updatedAt": "2025-12-11T14:46:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 2823.6,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk85rfn22ky4k",
      "fspDate": "2025-12-11T13:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk85rfn22ky4k",
        "bookingDate": "2025-12-11",
        "valueDate": "2025-12-11",
        "bookingDateTime": "2025-12-11T13:46:00.000Z",
        "valueDateTime": "2025-12-11T13:46:00.000Z",
        "transactionAmount": {
          "amount": "2823.60",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.126Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ts18jjw0e4yc0y625vrzzy669e",
      "createdAt": "2025-12-11T12:06:00.000Z",
      "updatedAt": "2025-12-11T12:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 96.05,
      "currency": "EUR",
      "description": "Payment to Irish Rail: IR-202512-5614",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5mq1fjeknsc0d93vr2nsxjc7sz",
      "fspDate": "2025-12-11T11:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5mq1fjeknsc0d93vr2nsxjc7sz",
        "bookingDate": "2025-12-11",
        "valueDate": "2025-12-11",
        "bookingDateTime": "2025-12-11T12:06:00.000Z",
        "valueDateTime": "2025-12-11T12:06:00.000Z",
        "transactionAmount": {
          "amount": "96.05",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Irish Rail: IR-202512-5614",
        "remittanceInformationUnstructuredArray": [
          "Payment to Irish Rail",
          "IR-202512-5614"
        ],
        "debtorName": "Irish Rail"
      },
      "paymentId": null,
      "reference": "IR-202512-5614",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax69eshspjn90xv3cz0y",
      "clustering": {
        "description": "Irish Rail",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Irish Rail' based on payment details",
        "updatedAt": "2025-12-11T12:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Irish Rail",
        "iban": "DE29825786379017524",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1sx4rx4f5prk2ce42zz0xmrjhs",
      "createdAt": "2025-12-11T09:35:00.000Z",
      "updatedAt": "2025-12-11T09:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 47864.76,
      "currency": "GBP",
      "description": "Payment from TechCorp Industries - INV-202512-3581",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2kzzpgxaqc76atc10e1dewmmh2",
      "fspDate": "2025-12-11T08:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2kzzpgxaqc76atc10e1dewmmh2",
        "bookingDate": "2025-12-11",
        "valueDate": "2025-12-11",
        "bookingDateTime": "2025-12-11T09:35:00.000Z",
        "valueDateTime": "2025-12-11T09:35:00.000Z",
        "transactionAmount": {
          "amount": "47864.76",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from TechCorp Industries - INV-202512-3581",
        "remittanceInformationUnstructuredArray": [
          "Payment from TechCorp Industries",
          "INV-202512-3581"
        ],
        "creditorName": "TechCorp Industries"
      },
      "paymentId": null,
      "reference": "INV-202512-3581",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_hkz708jvra375hd19t65j65vvt",
      "clustering": {
        "description": "TechCorp Industries",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'TechCorp Industries'",
        "updatedAt": "2025-12-11T09:35:00.000Z"
      },
      "payer": {
        "name": "TechCorp Industries",
        "iban": null,
        "bic": null,
        "sortCode": "477022",
        "accountNumber": "80509229"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7n0b43kn00f289gaqr991e1vgk",
      "createdAt": "2025-12-11T09:25:00.000Z",
      "updatedAt": "2025-12-11T09:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 36.38,
      "currency": "EUR",
      "description": "Payment to Mamma Mia Restaurant: MMR-202512-7118",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wqzw9pqyda00vpa1tbrd8rmn62",
      "fspDate": "2025-12-11T08:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wqzw9pqyda00vpa1tbrd8rmn62",
        "bookingDate": "2025-12-11",
        "valueDate": "2025-12-11",
        "bookingDateTime": "2025-12-11T09:25:00.000Z",
        "valueDateTime": "2025-12-11T09:25:00.000Z",
        "transactionAmount": {
          "amount": "36.38",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mamma Mia Restaurant: MMR-202512-7118",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mamma Mia Restaurant",
          "MMR-202512-7118"
        ],
        "debtorName": "Mamma Mia Restaurant"
      },
      "paymentId": null,
      "reference": "MMR-202512-7118",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj1yeshspngr1g523f6q",
      "clustering": {
        "description": "Mamma Mia Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mamma Mia Restaurant' based on payment details",
        "updatedAt": "2025-12-11T09:25:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mamma Mia Restaurant",
        "iban": "DE39276365379361430",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_sqmzpya8508m9vtjbd19exw2gp",
      "createdAt": "2025-12-11T09:10:00.000Z",
      "updatedAt": "2025-12-11T09:10:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Sq *seoul Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_bpk6ypadt9x0m7krc1z3v4bqjb",
      "fspDate": "2025-12-11T08:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k38cnkeheh2szmpptj1660k0",
        "bookingDate": "2025-12-11",
        "valueDate": "2025-12-11",
        "bookingDateTime": "2025-12-11T08:10:00.000Z",
        "valueDateTime": "2025-12-11T08:10:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *seoul Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Sq *seoul Kitchen"
        ],
        "debtorName": "Seoul Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pzaeshspjhkemvf76tx",
      "clustering": {
        "description": "Seoul Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Seoul Kitchen' from the 'Sq *seoul Kitchen' transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:41:48.153Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfyhaxcxhc0n",
      "createdAt": "2025-12-10T14:34:00.000Z",
      "updatedAt": "2025-12-10T14:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 127.25,
      "currency": "EUR",
      "description": "Payment to GoCardless SAS: INV-SAS-61953",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jzrabzkpf25ttezzh41bz2hg",
      "fspDate": "2025-12-10T13:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jzrabzkpf25ttezzh41bz2hg",
        "bookingDate": "2025-12-10",
        "valueDate": "2025-12-10",
        "bookingDateTime": "2025-12-10T13:34:00.000Z",
        "valueDateTime": "2025-12-10T13:34:00.000Z",
        "transactionAmount": {
          "amount": "-127.25",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GoCardless SAS: INV-SAS-61953",
        "remittanceInformationUnstructuredArray": [
          "Payment to GoCardless SAS: INV-SAS-61953"
        ],
        "debtorName": "GoCardless SAS"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5k6eshspjzd728cagsr",
      "clustering": {
        "description": "GoCardless SAS",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'GoCardless SAS' from 'Payment to GoCardless SAS: INV-SAS-61953'",
        "updatedAt": "2025-09-27T10:50:08.422Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n6fcap2z7jnrfvgq9c93g6fhvs",
      "createdAt": "2025-12-10T14:32:00.000Z",
      "updatedAt": "2025-12-10T14:32:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 262.58,
      "currency": "GBP",
      "description": "British Airways Plc",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_rbhqmhz8jfa5npjjdqb53jy0hj",
      "fspDate": "2025-12-10T13:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8kh6afa9med",
        "bookingDate": "2025-12-10",
        "valueDate": "2025-12-10",
        "bookingDateTime": "2025-12-10T13:32:00.000Z",
        "valueDateTime": "2025-12-10T13:32:00.000Z",
        "transactionAmount": {
          "amount": "-262.58",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "British Airways Plc",
        "remittanceInformationUnstructuredArray": [
          "British Airways Plc"
        ],
        "debtorName": "British Airways"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9m2fvhrjp2hhm5q9efq",
      "clustering": {
        "description": "British Airways",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'British Airways' from 'British Airways Plc'",
        "updatedAt": "2025-09-29T18:27:23.722Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_d0j2wp9gngbfkwajy9155n7m12",
      "createdAt": "2025-12-09T17:49:00.000Z",
      "updatedAt": "2025-12-09T17:49:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 23.2,
      "currency": "EUR",
      "description": "Sumup *muhammad Tashf",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_dwkhfq1gye1nrk8bjr9ees1111",
      "fspDate": "2025-12-09T16:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk22tp5b5pkf7",
        "bookingDate": "2025-12-09",
        "valueDate": "2025-12-09",
        "bookingDateTime": "2025-12-09T16:49:00.000Z",
        "valueDateTime": "2025-12-09T16:49:00.000Z",
        "transactionAmount": {
          "amount": "-23.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *muhammad Tashf",
        "remittanceInformationUnstructuredArray": [
          "Sumup *muhammad Tashf"
        ],
        "debtorName": "Muhammad Tashf"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkgjeshspnx4pqb9b6ze",
      "clustering": {
        "description": "Muhammad Tashf",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Muhammad Tashf' from 'Sumup *muhammad Tashf', removing the 'Sumup *' prefix",
        "updatedAt": "2025-09-27T10:54:50.860Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zhbtm8qn6ehbfs7rj8brdzwpyt",
      "createdAt": "2025-12-09T16:52:00.000Z",
      "updatedAt": "2025-12-09T16:52:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.24,
      "currency": "EUR",
      "description": "Payment to Amba: A-202512-8863",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_es5wha8q0yp2cqvttxvr9ftwzk",
      "fspDate": "2025-12-09T15:52:00.000Z",
      "fspRecord": {
        "transactionId": "txn_es5wha8q0yp2cqvttxvr9ftwzk",
        "bookingDate": "2025-12-09",
        "valueDate": "2025-12-09",
        "bookingDateTime": "2025-12-09T16:52:00.000Z",
        "valueDateTime": "2025-12-09T16:52:00.000Z",
        "transactionAmount": {
          "amount": "20.24",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amba: A-202512-8863",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amba",
          "A-202512-8863"
        ],
        "debtorName": "Amba"
      },
      "paymentId": null,
      "reference": "A-202512-8863",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g1aeshsphp662hfbd17",
      "clustering": {
        "description": "Amba",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amba' based on payment details",
        "updatedAt": "2025-12-09T16:52:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amba",
        "iban": "DE38882752231221520",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_rvr998nprt95qmy87cv0tpgmbs",
      "createdAt": "2025-12-09T15:27:00.000Z",
      "updatedAt": "2025-12-09T15:27:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.5,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_ahph8dxr6tey57xe38qmjaafw9",
      "fspDate": "2025-12-09T14:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0nzyjtcfq9r6nnxyxpmnew1",
        "bookingDate": "2025-12-09",
        "valueDate": "2025-12-09",
        "bookingDateTime": "2025-12-09T14:27:00.000Z",
        "valueDateTime": "2025-12-09T14:27:00.000Z",
        "transactionAmount": {
          "amount": "-17.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cursor' from 'Cursor, Ai Powered Ide', removing the ', Ai Powered Ide' suffix",
        "updatedAt": "2025-09-27T10:49:04.347Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfqh3ssjqtm2",
      "createdAt": "2025-12-09T08:42:00.000Z",
      "updatedAt": "2025-12-09T08:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 26,
      "currency": "EUR",
      "description": "Salt Cellar Cafe",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg246ze8pvk0mwvtx96bhd",
      "fspDate": "2025-12-09T07:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg246ze8pvk0mwvtx96bhd",
        "bookingDate": "2025-12-09",
        "valueDate": "2025-12-09",
        "bookingDateTime": "2025-12-09T07:42:00.000Z",
        "valueDateTime": "2025-12-09T07:42:00.000Z",
        "transactionAmount": {
          "amount": "-26.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Salt Cellar Cafe",
        "remittanceInformationUnstructuredArray": [
          "Salt Cellar Cafe"
        ],
        "debtorName": "Salt Cellar Cafe"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0x9eshspkzthwr7rcm3",
      "clustering": {
        "description": "Salt Cellar Cafe",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Salt Cellar Cafe' from 'Salt Cellar Cafe'",
        "updatedAt": "2025-09-27T10:49:37.687Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg6mbx16j05h",
      "createdAt": "2025-12-09T08:24:00.000Z",
      "updatedAt": "2025-12-09T08:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 442.92,
      "currency": "EUR",
      "description": "Google Gsuite_seapoint",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2472e8pvk13qw7v4acwn",
      "fspDate": "2025-12-09T07:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk13qw7v4acwn",
        "bookingDate": "2025-12-09",
        "valueDate": "2025-12-09",
        "bookingDateTime": "2025-12-09T07:24:00.000Z",
        "valueDateTime": "2025-12-09T07:24:00.000Z",
        "transactionAmount": {
          "amount": "-442.92",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Google Gsuite_seapoint",
        "remittanceInformationUnstructuredArray": [
          "Google Gsuite_seapoint"
        ],
        "debtorName": "Google"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdrteshspka3qwhrnts0",
      "clustering": {
        "description": "Google",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Google' from 'Google Gsuite_seapoint', removing the '_seapoint' suffix.",
        "updatedAt": "2025-09-27T10:51:38.244Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg4a8eaths4t",
      "createdAt": "2025-12-08T11:12:00.000Z",
      "updatedAt": "2025-12-08T11:12:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 76,
      "currency": "EUR",
      "description": "Retool",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk10fjz4c1rxn",
      "fspDate": "2025-12-08T10:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk10fjz4c1rxn",
        "bookingDate": "2025-12-08",
        "valueDate": "2025-12-08",
        "bookingDateTime": "2025-12-08T10:12:00.000Z",
        "valueDateTime": "2025-12-08T10:12:00.000Z",
        "transactionAmount": {
          "amount": "-76.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Retool",
        "remittanceInformationUnstructuredArray": [
          "Retool"
        ],
        "debtorName": "Retool"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdp6eshspk9a3b1e6677",
      "clustering": {
        "description": "Retool",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Retool' from 'Retool'",
        "updatedAt": "2025-09-27T10:50:52.499Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xxeshspefy23rtqg6n",
      "createdAt": "2025-12-08T11:02:00.000Z",
      "updatedAt": "2025-12-08T11:02:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29483.85,
      "currency": "EUR",
      "description": "To Revenue Commissioners",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3qv1xr7esm9bvxscma8zvhg",
      "fspDate": "2025-12-08T10:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3qv1xr7esm9bvxscma8zvhg",
        "bookingDate": "2025-12-08",
        "valueDate": "2025-12-08",
        "bookingDateTime": "2025-12-08T10:02:00.000Z",
        "valueDateTime": "2025-12-08T10:02:00.000Z",
        "transactionAmount": {
          "amount": "-29483.85",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Revenue Commissioners",
        "remittanceInformationUnstructuredArray": [
          "To Revenue Commissioners"
        ],
        "debtorName": "REVENUE COMMISSION"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g53eshsphprhxzbraqp",
      "clustering": {
        "description": "Revenue Commissioners",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Revenue Commissioners' from 'To Revenue Commissioners'.",
        "updatedAt": "2025-09-27T10:39:39.667Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_tmh4kwmjx2nvekgjsf7nz5gb92",
      "createdAt": "2025-12-08T09:19:00.000Z",
      "updatedAt": "2025-12-08T09:19:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 16919.44,
      "currency": "GBP",
      "description": "Payment to Amwins Global Risks: AGR-202512-8526",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_h42tbs8tpzpqxk14jd27jzfwzd",
      "fspDate": "2025-12-08T08:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_h42tbs8tpzpqxk14jd27jzfwzd",
        "bookingDate": "2025-12-08",
        "valueDate": "2025-12-08",
        "bookingDateTime": "2025-12-08T09:19:00.000Z",
        "valueDateTime": "2025-12-08T09:19:00.000Z",
        "transactionAmount": {
          "amount": "16919.44",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amwins Global Risks: AGR-202512-8526",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amwins Global Risks",
          "AGR-202512-8526"
        ],
        "debtorName": "Amwins Global Risks"
      },
      "paymentId": null,
      "reference": "AGR-202512-8526",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2bfvhrjnbz808baykh",
      "clustering": {
        "description": "Amwins Global Risks",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amwins Global Risks' based on payment details",
        "updatedAt": "2025-12-08T09:19:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amwins Global Risks",
        "iban": null,
        "bic": null,
        "sortCode": "484981",
        "accountNumber": "64757082"
      }
    },
    {
      "id": "txn_f3t58bs7899fzf31nw5s0secm8",
      "createdAt": "2025-12-07T15:32:00.000Z",
      "updatedAt": "2025-12-07T15:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 13.19,
      "currency": "EUR",
      "description": "Payment to Cafe And Noodle: CAN-202512-4090",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_24615gxgdxcfajb5enr1xhf0wj",
      "fspDate": "2025-12-07T14:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_24615gxgdxcfajb5enr1xhf0wj",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T15:32:00.000Z",
        "valueDateTime": "2025-12-07T15:32:00.000Z",
        "transactionAmount": {
          "amount": "13.19",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cafe And Noodle: CAN-202512-4090",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cafe And Noodle",
          "CAN-202512-4090"
        ],
        "debtorName": "Cafe And Noodle"
      },
      "paymentId": null,
      "reference": "CAN-202512-4090",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpd8eshspmwjjpzayxx2",
      "clustering": {
        "description": "Cafe And Noodle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cafe And Noodle' based on payment details",
        "updatedAt": "2025-12-07T15:32:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cafe And Noodle",
        "iban": "DE74008737760907710",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mery6c9af5c5evwqwgdt4nshq1",
      "createdAt": "2025-12-07T15:30:00.000Z",
      "updatedAt": "2025-12-07T15:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 26.08,
      "currency": "EUR",
      "description": "Payment to Tavily AI: TA-202512-6584",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_84htvr7nck0pa3jyw23e5jmcn7",
      "fspDate": "2025-12-07T14:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_84htvr7nck0pa3jyw23e5jmcn7",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T15:30:00.000Z",
        "valueDateTime": "2025-12-07T15:30:00.000Z",
        "transactionAmount": {
          "amount": "26.08",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tavily AI: TA-202512-6584",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tavily AI",
          "TA-202512-6584"
        ],
        "debtorName": "Tavily AI"
      },
      "paymentId": null,
      "reference": "TA-202512-6584",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ceerteshspk5wmka0h0ee",
      "clustering": {
        "description": "Tavily AI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tavily AI' based on payment details",
        "updatedAt": "2025-12-07T15:30:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tavily AI",
        "iban": "DE46752796556630280",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bmjfgtxg87wvgfkz9ad037428y",
      "createdAt": "2025-12-07T14:59:00.000Z",
      "updatedAt": "2025-12-07T14:59:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_sbttdfdvvh0vymx1asf12b46xg",
      "fspDate": "2025-12-07T13:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1mwq45xexy9b7qj8anzfhqy",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T13:59:00.000Z",
        "valueDateTime": "2025-12-07T13:59:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Zakura' from the transaction description.",
        "updatedAt": "2025-09-27T10:43:55.566Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm9vs40jwe1n",
      "createdAt": "2025-12-07T13:01:00.000Z",
      "updatedAt": "2025-12-07T13:01:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 6031.24,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk82bc455646n",
      "fspDate": "2025-12-07T12:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk82bc455646n",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T09:00:00.000Z",
        "valueDateTime": "2026-01-02T09:00:00.000Z",
        "transactionAmount": {
          "amount": "6031.24",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code and extracted 'Currency Exchange' as the description",
        "updatedAt": "2025-09-29T18:24:29.651Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9341gvcahx4q3444waykybkww7",
      "createdAt": "2025-12-07T12:25:00.000Z",
      "updatedAt": "2025-12-07T12:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 8.14,
      "currency": "USD",
      "description": "Payment to 1Password: 1-202512-8659",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hcnczqxa32yqthyrnyy8cn81te",
      "fspDate": "2025-12-07T11:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hcnczqxa32yqthyrnyy8cn81te",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T12:25:00.000Z",
        "valueDateTime": "2025-12-07T12:25:00.000Z",
        "transactionAmount": {
          "amount": "8.14",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to 1Password: 1-202512-8659",
        "remittanceInformationUnstructuredArray": [
          "Payment to 1Password",
          "1-202512-8659"
        ],
        "debtorName": "1Password"
      },
      "paymentId": null,
      "reference": "1-202512-8659",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxpeshspjghv7zy63at",
      "clustering": {
        "description": "1Password",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor '1Password' based on payment details",
        "updatedAt": "2025-12-07T12:25:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "1Password",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_m2rrzxmzz2sndj9qjmb3by7zn2",
      "createdAt": "2025-12-07T11:46:00.000Z",
      "updatedAt": "2025-12-07T11:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 9454,
      "currency": "GBP",
      "description": "SEAPOINT FINANCE  LIMITED. From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_z071r694x39p9cfw9163fv9ehb",
      "fspDate": "2025-12-07T10:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xwbp37fq9r9ascwgdz6hnb",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T10:46:00.000Z",
        "valueDateTime": "2025-12-07T10:46:00.000Z",
        "transactionAmount": {
          "amount": "9454.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
        "remittanceInformationUnstructuredArray": [
          "From SEAPOINT FINANCE UK INVESTMENTS LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance Uk Investments Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Seapoint Finance Uk Investments Limited' from 'From SEAPOINT FINANCE UK INVESTMENTS LIMITED'",
        "updatedAt": "2025-09-29T18:24:29.635Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n0fwvzkrsbkszrwqfhpe1ndkkw",
      "createdAt": "2025-12-07T09:54:00.000Z",
      "updatedAt": "2025-12-07T09:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 157,
      "currency": "GBP",
      "description": "To Seapoint Finance Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_g3rzsx2vmxfes56v0nzpr0jdrc",
      "fspDate": "2025-12-07T08:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2fekr20fk7s42ejh9gp1mm6",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T08:54:00.000Z",
        "valueDateTime": "2025-12-07T08:54:00.000Z",
        "transactionAmount": {
          "amount": "-157.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance Limited",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance Limited"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance' from 'To Seapoint Finance Limited', removing 'To ' prefix and 'Limited' suffix",
        "updatedAt": "2025-09-29T18:23:50.869Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0w89y04v1k8vxcrvg25xthwygk",
      "createdAt": "2025-12-07T09:23:00.000Z",
      "updatedAt": "2025-12-07T09:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.97,
      "currency": "EUR",
      "description": "Payment to Revolut: R-202512-9092",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qnrj6ktqj23xm3van8kw2khwzx",
      "fspDate": "2025-12-07T08:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qnrj6ktqj23xm3van8kw2khwzx",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T09:23:00.000Z",
        "valueDateTime": "2025-12-07T09:23:00.000Z",
        "transactionAmount": {
          "amount": "9.97",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Revolut: R-202512-9092",
        "remittanceInformationUnstructuredArray": [
          "Payment to Revolut",
          "R-202512-9092"
        ],
        "debtorName": "Revolut"
      },
      "paymentId": null,
      "reference": "R-202512-9092",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mvseshspja4gsxz03at",
      "clustering": {
        "description": "Revolut",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Revolut' based on payment details",
        "updatedAt": "2025-12-07T09:23:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Revolut",
        "iban": "DE19904160546004976",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_52w5y78gn1r7fy754qkqnsn5vh",
      "createdAt": "2025-12-07T09:12:00.000Z",
      "updatedAt": "2025-12-07T09:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 33.08,
      "currency": "EUR",
      "description": "Payment to Veremark: V-202512-8543",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_17a9c1cxpnftwymczv7ze9pmwc",
      "fspDate": "2025-12-07T08:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_17a9c1cxpnftwymczv7ze9pmwc",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T09:12:00.000Z",
        "valueDateTime": "2025-12-07T09:12:00.000Z",
        "transactionAmount": {
          "amount": "33.08",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Veremark: V-202512-8543",
        "remittanceInformationUnstructuredArray": [
          "Payment to Veremark",
          "V-202512-8543"
        ],
        "debtorName": "Veremark"
      },
      "paymentId": null,
      "reference": "V-202512-8543",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwc3eshspn9n53st1zft",
      "clustering": {
        "description": "Veremark",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Veremark' based on payment details",
        "updatedAt": "2025-12-07T09:12:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Veremark",
        "iban": "DE92008192388410770",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf6ejcrjf6xj",
      "createdAt": "2025-12-06T13:25:00.000Z",
      "updatedAt": "2025-12-06T13:25:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 6229.7,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1mwq45xexy9b7qz9573k1t0",
      "fspDate": "2025-12-06T12:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1mwq45xexy9b7qz9573k1t0",
        "bookingDate": "2025-12-06",
        "valueDate": "2025-12-06",
        "bookingDateTime": "2025-12-06T12:25:00.000Z",
        "valueDateTime": "2025-12-06T12:25:00.000Z",
        "transactionAmount": {
          "amount": "-6229.70",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:45:11.491Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_05jefwws31x4wskxgkb6h9xqjx",
      "createdAt": "2025-12-06T11:04:00.000Z",
      "updatedAt": "2025-12-06T11:04:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 20.71,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_6bpmpx5567jb4m0x566gqrfrnj",
      "fspDate": "2025-12-06T10:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ry974re009pf8ek1h16fpc",
        "bookingDate": "2025-12-06",
        "valueDate": "2025-12-06",
        "bookingDateTime": "2025-12-06T10:04:00.000Z",
        "valueDateTime": "2025-12-06T10:04:00.000Z",
        "transactionAmount": {
          "amount": "-20.71",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'OpenAI' from the 'Openai *chatgpt Subscr' transaction description, removing the 'Openai *' prefix.",
        "updatedAt": "2025-09-27T10:41:48.243Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zcaaxx108d9ga88dpshd5j0qtk",
      "createdAt": "2025-12-06T10:26:00.000Z",
      "updatedAt": "2025-12-06T10:26:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 5.75,
      "currency": "EUR",
      "description": "Spar Middle Baggot St",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_a3dsbyds4779vr2m3q1cfzc21k",
      "fspDate": "2025-12-06T09:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3tden41esm9d0hwxap3kd6c",
        "bookingDate": "2025-12-06",
        "valueDate": "2025-12-06",
        "bookingDateTime": "2025-12-06T09:26:00.000Z",
        "valueDateTime": "2025-12-06T09:26:00.000Z",
        "transactionAmount": {
          "amount": "-5.75",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Spar Middle Baggot St",
        "remittanceInformationUnstructuredArray": [
          "Spar Middle Baggot St"
        ],
        "debtorName": "Spar"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g32eshsphp8z5k4nrvg",
      "clustering": {
        "description": "Spar",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Spar' from 'Spar Middle Baggot St', removing the location details.",
        "updatedAt": "2025-09-27T10:39:39.640Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmhs8gc93yvb",
      "createdAt": "2025-12-06T10:19:00.000Z",
      "updatedAt": "2025-12-06T10:19:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "GBP",
      "description": "Linkedin P629924934",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8a8pmx0y3dn",
      "fspDate": "2025-12-06T09:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8a8pmx0y3dn",
        "bookingDate": "2025-12-06",
        "valueDate": "2025-12-06",
        "bookingDateTime": "2025-12-06T09:19:00.000Z",
        "valueDateTime": "2025-12-06T09:19:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin P629924934",
        "remittanceInformationUnstructuredArray": [
          "Linkedin P629924934"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'LinkedIn' from 'Linkedin P629924934'",
        "updatedAt": "2025-09-29T18:25:48.504Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfg1y5wzfj77",
      "createdAt": "2025-12-06T09:45:00.000Z",
      "updatedAt": "2025-12-06T09:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6003.2,
      "currency": "EUR",
      "description": "Payment to Luca Moretti: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k10kr2c9e4dr6r31av3hxs5q",
      "fspDate": "2025-12-06T08:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k10kr2c9e4dr6r31av3hxs5q",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T11:00:00.000Z",
        "valueDateTime": "2026-01-09T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-6003.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Luca Moretti: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Luca Moretti: July 2025 Payroll"
        ],
        "debtorName": "Luca Moretti"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsbeshspj7jp8q6rygp",
      "clustering": {
        "description": "Luca Moretti",
        "confidenceScore": "0.95",
        "rationale": "Extracted employee name 'Luca Moretti' from 'Payment to Luca Moretti: July 2025 Payroll'",
        "updatedAt": "2025-09-27T10:48:02.788Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgr699zq52en",
      "createdAt": "2025-12-06T08:34:00.000Z",
      "updatedAt": "2025-12-06T08:34:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1363.2,
      "currency": "EUR",
      "description": "Upwork -818427462ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1m0dfpx3p0b",
      "fspDate": "2025-12-06T07:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1m0dfpx3p0b",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T11:00:00.000Z",
        "valueDateTime": "2026-01-13T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-1363.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -818427462ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -818427462ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Upwork' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.262Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_78f2sr6p55w358azmrf11d2gn6",
      "createdAt": "2025-12-06T08:03:00.000Z",
      "updatedAt": "2025-12-06T08:03:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 212.06,
      "currency": "EUR",
      "description": "Notion Labs, Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_vhfymqmr94snm6aqy10hqfpvvb",
      "fspDate": "2025-12-06T07:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0ys4crrjpkk",
        "bookingDate": "2025-12-06",
        "valueDate": "2025-12-06",
        "bookingDateTime": "2025-12-06T07:03:00.000Z",
        "valueDateTime": "2025-12-06T07:03:00.000Z",
        "transactionAmount": {
          "amount": "-212.06",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Notion Labs, Inc.",
        "remittanceInformationUnstructuredArray": [
          "Notion Labs, Inc."
        ],
        "debtorName": "Notion"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtcyeshspk6y0e76tesb",
      "clustering": {
        "description": "Notion",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Notion' from 'Notion Labs, Inc.'",
        "updatedAt": "2025-09-27T10:50:52.435Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspghe2r6sfjvr",
      "createdAt": "2025-12-05T17:26:00.000Z",
      "updatedAt": "2025-12-05T17:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 65,
      "currency": "EUR",
      "description": "Payment to Company Formations International Limited: 139525",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jygqe7gqf20bmpc9qmf341aa",
      "fspDate": "2025-12-05T16:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jygqe7gqf20bmpc9qmf341aa",
        "bookingDate": "2025-12-05",
        "valueDate": "2025-12-05",
        "bookingDateTime": "2025-12-05T16:26:00.000Z",
        "valueDateTime": "2025-12-05T16:26:00.000Z",
        "transactionAmount": {
          "amount": "-65.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Company Formations International Limited: 139525",
        "remittanceInformationUnstructuredArray": [
          "Payment to Company Formations International Limited: 139525"
        ],
        "debtorName": "Company Formations International Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cvstpeshspn39955xdf4m",
      "clustering": {
        "description": "Company Formations International Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Company Formations International Limited' from 'Payment to Company Formations International Limited: 139525'.",
        "updatedAt": "2025-09-27T10:52:47.441Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y8eshsph71t98fc5en",
      "createdAt": "2025-12-05T16:14:00.000Z",
      "updatedAt": "2025-12-05T16:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5314.97,
      "currency": "EUR",
      "description": "To Eoin Kelleher",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk24v5gq58814",
      "fspDate": "2025-12-05T15:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk24v5gq58814",
        "bookingDate": "2025-12-05",
        "valueDate": "2025-12-05",
        "bookingDateTime": "2025-12-05T15:14:00.000Z",
        "valueDateTime": "2025-12-05T15:14:00.000Z",
        "transactionAmount": {
          "amount": "-5314.97",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Eoin Kelleher",
        "remittanceInformationUnstructuredArray": [
          "To Eoin Kelleher"
        ],
        "debtorName": "Eoin Kelleher"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zrteshspj73enyj46qt",
      "clustering": {
        "description": "Eoin Kelleher",
        "confidenceScore": "0.95",
        "rationale": "Extracted core recipient name 'Eoin Kelleher' from 'To Eoin Kelleher'",
        "updatedAt": "2025-09-27T10:54:50.907Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_33neyb7mc8p6gtvwfst2pd2my1",
      "createdAt": "2025-12-05T14:35:00.000Z",
      "updatedAt": "2025-12-05T14:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5700,
      "currency": "GBP",
      "description": "Salary - Rebecca Williams - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_gjs2hqq7asqye2eqmfzmwph7bn",
      "fspDate": "2025-12-05T13:35:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_z43p7rv02wvwa1erwvnqmzrpqw",
        "bookingDate": "2025-12-05",
        "valueDate": "2025-12-05",
        "bookingDateTime": "2025-12-05T13:35:00.000Z",
        "valueDateTime": "2025-12-05T13:35:00.000Z",
        "transactionAmount": {
          "amount": "-5700.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Rebecca Williams",
        "remittanceInformationUnstructuredArray": [
          "Salary - Rebecca Williams"
        ]
      },
      "paymentId": "pmnt_9jmbpvrjbyhnnfayk15f8q2r8t",
      "reference": "PAY-DEC-2025-WILLIAMS",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Rebecca Williams",
        "iban": null,
        "bic": null,
        "sortCode": "40-05-30",
        "accountNumber": "78901234"
      }
    },
    {
      "id": "txn_vw6spsaz11dyp50nf888sb4gwb",
      "createdAt": "2025-12-05T14:32:00.000Z",
      "updatedAt": "2025-12-05T14:32:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 48,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_yzphx0ababtgv37b48cnh5zjry",
      "fspDate": "2025-12-05T13:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1rthbqt4n17",
        "bookingDate": "2025-12-05",
        "valueDate": "2025-12-05",
        "bookingDateTime": "2025-12-05T13:32:00.000Z",
        "valueDateTime": "2025-12-05T13:32:00.000Z",
        "transactionAmount": {
          "amount": "-48.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Shaka Poke' from the raw transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:53:55.698Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vmgs3c07171sybg8vr8a7wa9yh",
      "createdAt": "2025-12-05T13:56:00.000Z",
      "updatedAt": "2025-12-05T13:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 525.15,
      "currency": "GBP",
      "description": "Payment to Slack Technologies Limited: STL-202512-7652",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_b5wm9k25js54g1628wtf8z2tt1",
      "fspDate": "2025-12-05T12:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_b5wm9k25js54g1628wtf8z2tt1",
        "bookingDate": "2025-12-05",
        "valueDate": "2025-12-05",
        "bookingDateTime": "2025-12-05T13:56:00.000Z",
        "valueDateTime": "2025-12-05T13:56:00.000Z",
        "transactionAmount": {
          "amount": "525.15",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack Technologies Limited: STL-202512-7652",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack Technologies Limited",
          "STL-202512-7652"
        ],
        "debtorName": "Slack Technologies Limited"
      },
      "paymentId": null,
      "reference": "STL-202512-7652",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_6m3t4s5pcz3g5997sxc586yj3f",
      "clustering": {
        "description": "Slack Technologies Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack Technologies Limited' based on payment details",
        "updatedAt": "2025-12-05T13:56:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack Technologies Limited",
        "iban": null,
        "bic": null,
        "sortCode": "712303",
        "accountNumber": "24089213"
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm6sbrar12rc",
      "createdAt": "2025-12-05T13:23:00.000Z",
      "updatedAt": "2025-12-05T13:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3000,
      "currency": "GBP",
      "description": "Payment to SEAPOINT FINANCE  LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1jbfygheh1r3x090d4akypn",
      "fspDate": "2025-12-05T12:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1jbfygheh1r3x090d4akypn",
        "bookingDate": "2025-12-05",
        "valueDate": "2025-12-05",
        "bookingDateTime": "2025-12-05T12:23:00.000Z",
        "valueDateTime": "2025-12-05T12:23:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to SEAPOINT FINANCE  LIMITED",
        "remittanceInformationUnstructuredArray": [
          "Payment to SEAPOINT FINANCE  LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Seapoint Finance Limited' from 'Payment to SEAPOINT FINANCE  LIMITED', removing the prefix 'Payment to '",
        "updatedAt": "2025-09-29T18:24:29.595Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_r5004ees50evy7jek4d9svjbyg",
      "createdAt": "2025-12-05T10:13:00.000Z",
      "updatedAt": "2025-12-05T10:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1098.74,
      "currency": "GBP",
      "description": "Payment to Charles Russell Speechlys: CRS-202512-7594",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_11wksz3p43ad6t95ptxv6t85kr",
      "fspDate": "2025-12-05T09:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_11wksz3p43ad6t95ptxv6t85kr",
        "bookingDate": "2025-12-05",
        "valueDate": "2025-12-05",
        "bookingDateTime": "2025-12-05T10:13:00.000Z",
        "valueDateTime": "2025-12-05T10:13:00.000Z",
        "transactionAmount": {
          "amount": "1098.74",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Charles Russell Speechlys: CRS-202512-7594",
        "remittanceInformationUnstructuredArray": [
          "Payment to Charles Russell Speechlys",
          "CRS-202512-7594"
        ],
        "debtorName": "Charles Russell Speechlys"
      },
      "paymentId": null,
      "reference": "CRS-202512-7594",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgh1fvhrjp0n7wme8cae",
      "clustering": {
        "description": "Charles Russell Speechlys",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Charles Russell Speechlys' based on payment details",
        "updatedAt": "2025-12-05T10:13:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Charles Russell Speechlys",
        "iban": null,
        "bic": null,
        "sortCode": "163161",
        "accountNumber": "98751475"
      }
    },
    {
      "id": "txn_q1erw119ce7mrwb9p1gpbs4x53",
      "createdAt": "2025-12-04T17:40:00.000Z",
      "updatedAt": "2025-12-04T17:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2000,
      "currency": "EUR",
      "description": "To BOI 2 COLLEGE GREEN, Davy",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_p8gg44vx43x68wf9xp3j9181qs",
      "fspDate": "2025-12-04T16:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1cedd3qgwg9",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T16:40:00.000Z",
        "valueDateTime": "2025-12-04T16:40:00.000Z",
        "transactionAmount": {
          "amount": "-2000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To BOI 2 COLLEGE GREEN, Davy",
        "remittanceInformationUnstructuredArray": [
          "To BOI 2 COLLEGE GREEN, Davy"
        ],
        "debtorName": "BOI 2 COLLEGE GREEN, Davy"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc5eshspj0rxb4j151x",
      "clustering": {
        "description": "BOI 2 COLLEGE GREEN, Davy",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'BOI 2 COLLEGE GREEN, Davy' from 'To BOI 2 COLLEGE GREEN, Davy'",
        "updatedAt": "2025-09-27T10:52:10.128Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspekwhxdzpdmq",
      "createdAt": "2025-12-04T15:54:00.000Z",
      "updatedAt": "2025-12-04T15:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2000,
      "currency": "EUR",
      "description": "Payment to BOI 2 COLLEGE GREEN, Davy: 0228635 Sophie Laurent",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gc5chheh2t404gaz9hx814",
      "fspDate": "2025-12-04T14:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc5chheh2t404gaz9hx814",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T14:54:00.000Z",
        "valueDateTime": "2025-12-04T14:54:00.000Z",
        "transactionAmount": {
          "amount": "-2000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to BOI 2 COLLEGE GREEN, Davy: 0228635 Sophie Laurent",
        "remittanceInformationUnstructuredArray": [
          "Payment to BOI 2 COLLEGE GREEN, Davy: 0228635 Sophie Laurent"
        ],
        "debtorName": "BOI 2 COLLEGE GREEN, Davy"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc5eshspj0rxb4j151x",
      "clustering": {
        "description": "BOI 2 COLLEGE GREEN, Davy",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'BOI 2 COLLEGE GREEN, Davy' from 'Payment to BOI 2 COLLEGE GREEN, Davy: 0228635 Sophie Laurent'",
        "updatedAt": "2025-09-27T10:40:26.848Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jxk5x5w1wwey2dr3t2gwsaxv8z",
      "createdAt": "2025-12-04T15:38:00.000Z",
      "updatedAt": "2025-12-04T15:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 24.87,
      "currency": "USD",
      "description": "Payment to DocuSign: D-202512-7289",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gxyexgr6zrnm6317qghbw3qh8v",
      "fspDate": "2025-12-04T14:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gxyexgr6zrnm6317qghbw3qh8v",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T15:38:00.000Z",
        "valueDateTime": "2025-12-04T15:38:00.000Z",
        "transactionAmount": {
          "amount": "24.87",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to DocuSign: D-202512-7289",
        "remittanceInformationUnstructuredArray": [
          "Payment to DocuSign",
          "D-202512-7289"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": "D-202512-7289",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'DocuSign' based on payment details",
        "updatedAt": "2025-12-04T15:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "DocuSign",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_38r1fp7rvetet90fpeep2x0v2x",
      "createdAt": "2025-12-04T15:16:00.000Z",
      "updatedAt": "2025-12-04T15:16:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_gtft0358nsyf8dmnpmx3bzyr7d",
      "fspDate": "2025-12-04T14:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k30nfe7yfzwbhvda2808t8x5",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T14:16:00.000Z",
        "valueDateTime": "2025-12-04T14:16:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Coffee Angel' from the 'Sq *coffeeangel' transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:41:48.231Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8dyryvvx6z5t8p89cs3498gbf8",
      "createdAt": "2025-12-04T14:59:00.000Z",
      "updatedAt": "2025-12-04T14:59:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4940.18,
      "currency": "EUR",
      "description": "Payment to Hugo Weber: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_yrj20c404cpj8eyw45csskfkbf",
      "fspDate": "2025-12-04T13:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k10kr2bpe4dr6r1ezjtmjf98",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T13:59:00.000Z",
        "valueDateTime": "2025-12-04T13:59:00.000Z",
        "transactionAmount": {
          "amount": "-4940.18",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Hugo Weber: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Hugo Weber: July 2025 Payroll"
        ],
        "debtorName": "Hugo Weber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtteshspj9hmeqmzmdw",
      "clustering": {
        "description": "Hugo Weber",
        "confidenceScore": "0.95",
        "rationale": "Extracted employee name 'Hugo Weber' from 'Payment to Hugo Weber: July 2025 Payroll'",
        "updatedAt": "2025-09-27T10:48:02.770Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mjfjxz660q15tdx37wzvzgz1j3",
      "createdAt": "2025-12-04T13:29:00.000Z",
      "updatedAt": "2025-12-04T13:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 135.23,
      "currency": "EUR",
      "description": "Payment to Naomi's Kitchen: NK-202512-1232",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gfn85n6m3ym7f644w1gt6d01r0",
      "fspDate": "2025-12-04T12:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gfn85n6m3ym7f644w1gt6d01r0",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T13:29:00.000Z",
        "valueDateTime": "2025-12-04T13:29:00.000Z",
        "transactionAmount": {
          "amount": "135.23",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Naomi's Kitchen: NK-202512-1232",
        "remittanceInformationUnstructuredArray": [
          "Payment to Naomi's Kitchen",
          "NK-202512-1232"
        ],
        "debtorName": "Naomi's Kitchen"
      },
      "paymentId": null,
      "reference": "NK-202512-1232",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh3deshspkhegxj7z9nq",
      "clustering": {
        "description": "Naomi's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Naomi's Kitchen' based on payment details",
        "updatedAt": "2025-12-04T13:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Naomi's Kitchen",
        "iban": "DE53351634734940610",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xre8avz72de1gc4527kf3epnsr",
      "createdAt": "2025-12-04T11:32:00.000Z",
      "updatedAt": "2025-12-04T11:32:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_3v5xyaanbm4bpt80hf06ndntfq",
      "fspDate": "2025-12-04T10:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1bnc8ged6yf",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T10:32:00.000Z",
        "valueDateTime": "2025-12-04T10:32:00.000Z",
        "transactionAmount": {
          "amount": "-25.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:52:10.121Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n8yhtthnpbzgsdqh4j9cwmcaev",
      "createdAt": "2025-12-04T11:05:00.000Z",
      "updatedAt": "2025-12-04T11:05:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4100,
      "currency": "GBP",
      "description": "Salary - Michael Taylor - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_srem8q8tazst3hq3k7jc50j342",
      "fspDate": "2025-12-04T10:05:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_x62hfcvd47a0af0tqqp2wdeb0t",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T10:05:00.000Z",
        "valueDateTime": "2025-12-04T10:05:00.000Z",
        "transactionAmount": {
          "amount": "-4100.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Michael Taylor",
        "remittanceInformationUnstructuredArray": [
          "Salary - Michael Taylor"
        ]
      },
      "paymentId": "pmnt_kfrbmt4scanx753mqwq1jccppt",
      "reference": "PAY-DEC-2025-TAYLOR",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Michael Taylor",
        "iban": null,
        "bic": null,
        "sortCode": "20-00-00",
        "accountNumber": "45678901"
      }
    },
    {
      "id": "txn_jp8kpvc2a1qy37vw3rjxjsvs0b",
      "createdAt": "2025-12-04T09:45:00.000Z",
      "updatedAt": "2025-12-04T09:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 39.23,
      "currency": "GBP",
      "description": "Payment to Financial Times: FT-202512-7381",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_x8c8b61zybn27xbtvkzh2eyd2c",
      "fspDate": "2025-12-04T08:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_x8c8b61zybn27xbtvkzh2eyd2c",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T09:45:00.000Z",
        "valueDateTime": "2025-12-04T09:45:00.000Z",
        "transactionAmount": {
          "amount": "39.23",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Financial Times: FT-202512-7381",
        "remittanceInformationUnstructuredArray": [
          "Payment to Financial Times",
          "FT-202512-7381"
        ],
        "debtorName": "Financial Times"
      },
      "paymentId": null,
      "reference": "FT-202512-7381",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gjeshspjygqrrg6sk5",
      "clustering": {
        "description": "Financial Times",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Financial Times' based on payment details",
        "updatedAt": "2025-12-04T09:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Financial Times",
        "iban": null,
        "bic": null,
        "sortCode": "715019",
        "accountNumber": "31383643"
      }
    },
    {
      "id": "txn_92jpw4hss3btsrvmteeqs7260c",
      "createdAt": "2025-12-04T09:33:00.000Z",
      "updatedAt": "2025-12-04T09:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7733.86,
      "currency": "EUR",
      "description": "To Cormac Byrne",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_x32khcynfc4ng5ra9ybm7kthjb",
      "fspDate": "2025-12-04T08:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk23x9d8zp5dg",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T08:33:00.000Z",
        "valueDateTime": "2025-12-04T08:33:00.000Z",
        "transactionAmount": {
          "amount": "-7733.86",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Cormac Byrne",
        "remittanceInformationUnstructuredArray": [
          "To Cormac Byrne"
        ],
        "debtorName": "Cormac Byrne"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zspeshspj7tfmtn8s05",
      "clustering": {
        "description": "Cormac Byrne",
        "confidenceScore": "0.95",
        "rationale": "Extracted core recipient name 'Cormac Byrne' from 'To Cormac Byrne'",
        "updatedAt": "2025-09-27T10:54:50.879Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_r6krsdtjtd8hq2gdrw93c99fs7",
      "createdAt": "2025-12-04T08:22:00.000Z",
      "updatedAt": "2025-12-04T08:22:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 8.62,
      "currency": "EUR",
      "description": "Github, Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_q2b3a9rj56hpb3d09byzw743v0",
      "fspDate": "2025-12-04T07:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k15eb0nme4dr76a0398abw6j",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T07:22:00.000Z",
        "valueDateTime": "2025-12-04T07:22:00.000Z",
        "transactionAmount": {
          "amount": "-8.62",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Github, Inc.",
        "remittanceInformationUnstructuredArray": [
          "Github, Inc."
        ],
        "debtorName": "GitHub"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wd4eshsphxfd9s33j9t",
      "clustering": {
        "description": "Github",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Github' from 'Github, Inc.'",
        "updatedAt": "2025-09-27T10:48:02.627Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n705ar13nqd24rmxraj6d4p6q2",
      "createdAt": "2025-12-03T16:55:00.000Z",
      "updatedAt": "2025-12-03T16:55:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 77.6,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_0q0rdfszbjj1a3r2n3w5yzq0vz",
      "fspDate": "2025-12-03T15:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2fekr20fk7s42evr7fdsvtv",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T15:55:00.000Z",
        "valueDateTime": "2025-12-03T15:55:00.000Z",
        "transactionAmount": {
          "amount": "77.60",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.880Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8pxn86aq1bgke55tqggttttbwg",
      "createdAt": "2025-12-03T16:27:00.000Z",
      "updatedAt": "2025-12-03T16:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 0.01,
      "currency": "EUR",
      "description": "Payment to Emma Fitzgerald: Penny test - payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_psrpn77jy4h3w7643an92natxy",
      "fspDate": "2025-12-03T15:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xvewqdfvqsnjbtk72jzm0h",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T15:27:00.000Z",
        "valueDateTime": "2025-12-03T15:27:00.000Z",
        "transactionAmount": {
          "amount": "-0.01",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Emma Fitzgerald: Penny test - payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Emma Fitzgerald: Penny test - payroll"
        ],
        "debtorName": "Emma Fitzgerald"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtceshspj98ga0ebagk",
      "clustering": {
        "description": "Payment to Emma Fitzgerald",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core description 'Payment to Emma Fitzgerald' from the raw transaction record, removing the 'Penny test - payroll' suffix.",
        "updatedAt": "2025-09-27T10:49:12.155Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2bqvbr1r6wbcgrpyzy92v7hkdx",
      "createdAt": "2025-12-03T14:21:00.000Z",
      "updatedAt": "2025-12-03T14:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.97,
      "currency": "EUR",
      "description": "Payment to Marquette: M-202512-6043",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gey59qf5wk4pgskp9p9m2h3sr0",
      "fspDate": "2025-12-03T13:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gey59qf5wk4pgskp9p9m2h3sr0",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T14:21:00.000Z",
        "valueDateTime": "2025-12-03T14:21:00.000Z",
        "transactionAmount": {
          "amount": "15.97",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marquette: M-202512-6043",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marquette",
          "M-202512-6043"
        ],
        "debtorName": "Marquette"
      },
      "paymentId": null,
      "reference": "M-202512-6043",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1npeshspm6wcf3gtsdh",
      "clustering": {
        "description": "Marquette",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marquette' based on payment details",
        "updatedAt": "2025-12-03T14:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marquette",
        "iban": "DE53621300293041330",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9j199j0dkxxfw53nwfek7vpq4c",
      "createdAt": "2025-12-03T13:40:00.000Z",
      "updatedAt": "2025-12-03T13:40:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 168.27,
      "currency": "EUR",
      "description": "linear.app",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_pbyn1wxkv2214d4g4cqxwdppx2",
      "fspDate": "2025-12-03T12:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1ajkjk3hdh1",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T12:40:00.000Z",
        "valueDateTime": "2025-12-03T12:40:00.000Z",
        "transactionAmount": {
          "amount": "-168.27",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "linear.app",
        "remittanceInformationUnstructuredArray": [
          "linear.app"
        ],
        "debtorName": "Linear"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc1eshspj0mxd2vh6zx",
      "clustering": {
        "description": "Linear",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Linear' from 'linear.app'",
        "updatedAt": "2025-09-27T10:52:10.117Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gyw18r8sep79x4m0fn2m8e347z",
      "createdAt": "2025-12-03T11:05:00.000Z",
      "updatedAt": "2025-12-03T11:05:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 22.66,
      "currency": "EUR",
      "description": "Payment to Hotpot: H-202512-3923",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_dxhvyhkh1jsygyzbn9z324xwnn",
      "fspDate": "2025-12-03T10:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_dxhvyhkh1jsygyzbn9z324xwnn",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T11:05:00.000Z",
        "valueDateTime": "2025-12-03T11:05:00.000Z",
        "transactionAmount": {
          "amount": "22.66",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Hotpot: H-202512-3923",
        "remittanceInformationUnstructuredArray": [
          "Payment to Hotpot",
          "H-202512-3923"
        ],
        "debtorName": "Hotpot"
      },
      "paymentId": null,
      "reference": "H-202512-3923",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0wweshspkzqgyrcgqe7",
      "clustering": {
        "description": "Hotpot",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Hotpot' based on payment details",
        "updatedAt": "2025-12-03T11:05:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Hotpot",
        "iban": "DE52201568689347440",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_thq1re9xn3h1qajv9dthz8c5ff",
      "createdAt": "2025-12-03T10:10:00.000Z",
      "updatedAt": "2025-12-03T10:10:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 172.47,
      "currency": "GBP",
      "description": "Payment to Kiwi.com: K-202512-1629",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nxtcwp651pyzbed3mvat1cwxj2",
      "fspDate": "2025-12-03T09:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nxtcwp651pyzbed3mvat1cwxj2",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T10:10:00.000Z",
        "valueDateTime": "2025-12-03T10:10:00.000Z",
        "transactionAmount": {
          "amount": "172.47",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kiwi.com: K-202512-1629",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kiwi.com",
          "K-202512-1629"
        ],
        "debtorName": "Kiwi.com"
      },
      "paymentId": null,
      "reference": "K-202512-1629",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9q1fvhrjp371wrcstvr",
      "clustering": {
        "description": "Kiwi.com",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kiwi.com' based on payment details",
        "updatedAt": "2025-12-03T10:10:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kiwi.com",
        "iban": null,
        "bic": null,
        "sortCode": "352076",
        "accountNumber": "65289804"
      }
    },
    {
      "id": "txn_bbqz7rdgsrndgwszft2d5cpm8e",
      "createdAt": "2025-12-03T09:59:00.000Z",
      "updatedAt": "2025-12-03T09:59:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 59.81,
      "currency": "GBP",
      "description": "Payment to Captain Nemo: CN-202512-9319",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_437sn0sxbghq2xk9sktgb7b695",
      "fspDate": "2025-12-03T08:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_437sn0sxbghq2xk9sktgb7b695",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T09:59:00.000Z",
        "valueDateTime": "2025-12-03T09:59:00.000Z",
        "transactionAmount": {
          "amount": "59.81",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Captain Nemo: CN-202512-9319",
        "remittanceInformationUnstructuredArray": [
          "Payment to Captain Nemo",
          "CN-202512-9319"
        ],
        "debtorName": "Captain Nemo"
      },
      "paymentId": null,
      "reference": "CN-202512-9319",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fm8nzsfzz9aen1pftqn9qr",
      "clustering": {
        "description": "Captain Nemo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Captain Nemo' based on payment details",
        "updatedAt": "2025-12-03T09:59:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Captain Nemo",
        "iban": null,
        "bic": null,
        "sortCode": "947196",
        "accountNumber": "74318745"
      }
    },
    {
      "id": "txn_01k65c32y1eshspf73qd4mb4rh",
      "createdAt": "2025-12-03T09:10:00.000Z",
      "updatedAt": "2025-12-03T09:10:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 19.5,
      "currency": "EUR",
      "description": "Mak Slim Foods",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1jaadqbfk0vtsr93p53xdk8",
      "fspDate": "2025-12-03T08:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1jaadqbfk0vtsr93p53xdk8",
        "bookingDate": "2025-12-25",
        "valueDate": "2025-12-25",
        "bookingDateTime": "2025-12-25T15:33:00.000Z",
        "valueDateTime": "2025-12-25T15:33:00.000Z",
        "transactionAmount": {
          "amount": "-19.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Mak Slim Foods",
        "remittanceInformationUnstructuredArray": [
          "Mak Slim Foods"
        ],
        "debtorName": "Mak Slim Foods"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2yeshspkgyzwx8hqrq",
      "clustering": {
        "description": "Mak Slim Foods",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Mak Slim Foods' from the transaction description",
        "updatedAt": "2025-09-27T10:45:11.531Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4d3765ejkaeq34zfwsf98j938v",
      "createdAt": "2025-12-02T10:03:00.000Z",
      "updatedAt": "2025-12-02T10:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29.65,
      "currency": "USD",
      "description": "Payment to Superhuman: S-202512-9800",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jep0b5nht9b81d6gas84ggprbj",
      "fspDate": "2025-12-02T09:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jep0b5nht9b81d6gas84ggprbj",
        "bookingDate": "2025-12-02",
        "valueDate": "2025-12-02",
        "bookingDateTime": "2025-12-02T10:03:00.000Z",
        "valueDateTime": "2025-12-02T10:03:00.000Z",
        "transactionAmount": {
          "amount": "29.65",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Superhuman: S-202512-9800",
        "remittanceInformationUnstructuredArray": [
          "Payment to Superhuman",
          "S-202512-9800"
        ],
        "debtorName": "Superhuman"
      },
      "paymentId": null,
      "reference": "S-202512-9800",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5mceshspjzn83y9tqy1",
      "clustering": {
        "description": "Superhuman",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Superhuman' based on payment details",
        "updatedAt": "2025-12-02T10:03:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Superhuman",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_je28b9djqdpkv2qw0ysmkbg8xh",
      "createdAt": "2025-11-30T16:27:00.000Z",
      "updatedAt": "2025-11-30T16:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.5,
      "currency": "EUR",
      "description": "Payment to Taxi Service: TS-202511-8700",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qggabyf3qppm08fnjyn9x7a6hg",
      "fspDate": "2025-11-30T15:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qggabyf3qppm08fnjyn9x7a6hg",
        "bookingDate": "2025-11-30",
        "valueDate": "2025-11-30",
        "bookingDateTime": "2025-11-30T16:27:00.000Z",
        "valueDateTime": "2025-11-30T16:27:00.000Z",
        "transactionAmount": {
          "amount": "25.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Taxi Service: TS-202511-8700",
        "remittanceInformationUnstructuredArray": [
          "Payment to Taxi Service",
          "TS-202511-8700"
        ],
        "debtorName": "Taxi Service"
      },
      "paymentId": null,
      "reference": "TS-202511-8700",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqn02eshspm8y4jy7tt7k",
      "clustering": {
        "description": "Taxi Service",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Taxi Service' based on payment details",
        "updatedAt": "2025-11-30T16:27:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Taxi Service",
        "iban": "DE34270589532174744",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_s0vceyw70mek2a04368jqqgkxg",
      "createdAt": "2025-11-30T14:45:00.000Z",
      "updatedAt": "2025-11-30T14:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 230.21,
      "currency": "EUR",
      "description": "Payment to Welcome to the Jungle: WTT-202511-5753",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_yncyja80mkspcsjrxs6k3s34my",
      "fspDate": "2025-11-30T13:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_yncyja80mkspcsjrxs6k3s34my",
        "bookingDate": "2025-11-30",
        "valueDate": "2025-11-30",
        "bookingDateTime": "2025-11-30T14:45:00.000Z",
        "valueDateTime": "2025-11-30T14:45:00.000Z",
        "transactionAmount": {
          "amount": "230.21",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Welcome to the Jungle: WTT-202511-5753",
        "remittanceInformationUnstructuredArray": [
          "Payment to Welcome to the Jungle",
          "WTT-202511-5753"
        ],
        "debtorName": "Welcome to the Jungle"
      },
      "paymentId": null,
      "reference": "WTT-202511-5753",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkfxeshspnwz7ebn2y1d",
      "clustering": {
        "description": "Welcome to the Jungle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Welcome to the Jungle' based on payment details",
        "updatedAt": "2025-11-30T14:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Welcome to the Jungle",
        "iban": "DE23836076837485450",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7j57v7rbnr2kvkk8dvjt89fern",
      "createdAt": "2025-11-30T12:54:00.000Z",
      "updatedAt": "2025-11-30T12:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 22.14,
      "currency": "EUR",
      "description": "Payment to The Pig And Heifer: TPA-202511-7748",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_cysp3wd445pdm4eyv669zf1f28",
      "fspDate": "2025-11-30T11:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_cysp3wd445pdm4eyv669zf1f28",
        "bookingDate": "2025-11-30",
        "valueDate": "2025-11-30",
        "bookingDateTime": "2025-11-30T12:54:00.000Z",
        "valueDateTime": "2025-11-30T12:54:00.000Z",
        "transactionAmount": {
          "amount": "22.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Pig And Heifer: TPA-202511-7748",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Pig And Heifer",
          "TPA-202511-7748"
        ],
        "debtorName": "The Pig And Heifer"
      },
      "paymentId": null,
      "reference": "TPA-202511-7748",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g5weshsphq7y8rf4z8z",
      "clustering": {
        "description": "The Pig And Heifer",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Pig And Heifer' based on payment details",
        "updatedAt": "2025-11-30T12:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Pig And Heifer",
        "iban": "DE81198207034880670",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_12pn231sbadn6a31xbk9txba66",
      "createdAt": "2025-11-30T12:24:00.000Z",
      "updatedAt": "2025-11-30T12:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.39,
      "currency": "EUR",
      "description": "Payment to Tavily AI: TA-202511-9696",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_my5ejt29jmmamxmhg91dnz22pv",
      "fspDate": "2025-11-30T11:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_my5ejt29jmmamxmhg91dnz22pv",
        "bookingDate": "2025-11-30",
        "valueDate": "2025-11-30",
        "bookingDateTime": "2025-11-30T12:24:00.000Z",
        "valueDateTime": "2025-11-30T12:24:00.000Z",
        "transactionAmount": {
          "amount": "25.39",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tavily AI: TA-202511-9696",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tavily AI",
          "TA-202511-9696"
        ],
        "debtorName": "Tavily AI"
      },
      "paymentId": null,
      "reference": "TA-202511-9696",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ceerteshspk5wmka0h0ee",
      "clustering": {
        "description": "Tavily AI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tavily AI' based on payment details",
        "updatedAt": "2025-11-30T12:24:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tavily AI",
        "iban": "DE36031649279898260",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_f1q8x9jmwk4beh8hazv3e8qj7n",
      "createdAt": "2025-11-29T16:44:00.000Z",
      "updatedAt": "2025-11-29T16:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1863.99,
      "currency": "EUR",
      "description": "Payment to Sophie Laurent: SL-202511-5197",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bf1xx5wyx24pcdwgpds1g4a6bg",
      "fspDate": "2025-11-29T15:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bf1xx5wyx24pcdwgpds1g4a6bg",
        "bookingDate": "2025-11-29",
        "valueDate": "2025-11-29",
        "bookingDateTime": "2025-11-29T16:44:00.000Z",
        "valueDateTime": "2025-11-29T16:44:00.000Z",
        "transactionAmount": {
          "amount": "1863.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sophie Laurent: SL-202511-5197",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sophie Laurent",
          "SL-202511-5197"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": "SL-202511-5197",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc5eshspj0rxb4j151x",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sophie Laurent' based on payment details",
        "updatedAt": "2025-11-29T16:44:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sophie Laurent",
        "iban": "DE33014496393400076",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6g1q5bdps6arv022asmvnkafdq",
      "createdAt": "2025-11-29T13:59:00.000Z",
      "updatedAt": "2025-11-29T13:59:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 51.94,
      "currency": "GBP",
      "description": "Payment to Pembroke Hall Limited: PHL-202511-3710",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_akphhpjf769bsbm7vf83jk3cma",
      "fspDate": "2025-11-29T12:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_akphhpjf769bsbm7vf83jk3cma",
        "bookingDate": "2025-11-29",
        "valueDate": "2025-11-29",
        "bookingDateTime": "2025-11-29T13:59:00.000Z",
        "valueDateTime": "2025-11-29T13:59:00.000Z",
        "transactionAmount": {
          "amount": "51.94",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pembroke Hall Limited: PHL-202511-3710",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pembroke Hall Limited",
          "PHL-202511-3710"
        ],
        "debtorName": "Pembroke Hall Limited"
      },
      "paymentId": null,
      "reference": "PHL-202511-3710",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fpgn1yfzz9aex3cr77xa32",
      "clustering": {
        "description": "Pembroke Hall Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pembroke Hall Limited' based on payment details",
        "updatedAt": "2025-11-29T13:59:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pembroke Hall Limited",
        "iban": null,
        "bic": null,
        "sortCode": "956032",
        "accountNumber": "70623686"
      }
    },
    {
      "id": "txn_1myf2m8b7s3v9d7qt1n0jb55kv",
      "createdAt": "2025-11-29T13:15:00.000Z",
      "updatedAt": "2025-11-29T13:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 107.69,
      "currency": "EUR",
      "description": "Payment to Irish Rail: IR-202511-4139",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1p10wbe2kmyg1z8vthchh2qcwa",
      "fspDate": "2025-11-29T12:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1p10wbe2kmyg1z8vthchh2qcwa",
        "bookingDate": "2025-11-29",
        "valueDate": "2025-11-29",
        "bookingDateTime": "2025-11-29T13:15:00.000Z",
        "valueDateTime": "2025-11-29T13:15:00.000Z",
        "transactionAmount": {
          "amount": "107.69",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Irish Rail: IR-202511-4139",
        "remittanceInformationUnstructuredArray": [
          "Payment to Irish Rail",
          "IR-202511-4139"
        ],
        "debtorName": "Irish Rail"
      },
      "paymentId": null,
      "reference": "IR-202511-4139",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax69eshspjn90xv3cz0y",
      "clustering": {
        "description": "Irish Rail",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Irish Rail' based on payment details",
        "updatedAt": "2025-11-29T13:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Irish Rail",
        "iban": "DE40906733323410210",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5w3g5g3qw3rxxqcb06a8844qyk",
      "createdAt": "2025-11-29T10:21:00.000Z",
      "updatedAt": "2025-11-29T10:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3089.04,
      "currency": "EUR",
      "description": "Payment to Marta Kowalska Consulting: MKC-202511-3317",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6t8973zncwca0v9gze0h0pvnhz",
      "fspDate": "2025-11-29T09:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6t8973zncwca0v9gze0h0pvnhz",
        "bookingDate": "2025-11-29",
        "valueDate": "2025-11-29",
        "bookingDateTime": "2025-11-29T10:21:00.000Z",
        "valueDateTime": "2025-11-29T10:21:00.000Z",
        "transactionAmount": {
          "amount": "3089.04",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marta Kowalska Consulting: MKC-202511-3317",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marta Kowalska Consulting",
          "MKC-202511-3317"
        ],
        "debtorName": "Marta Kowalska Consulting"
      },
      "paymentId": null,
      "reference": "MKC-202511-3317",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj39eshspnh92mjbyz8s",
      "clustering": {
        "description": "Marta Kowalska Consulting",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marta Kowalska Consulting' based on payment details",
        "updatedAt": "2025-11-29T10:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marta Kowalska Consulting",
        "iban": "DE14028307236915758",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm53s3svw1q2",
      "createdAt": "2025-11-28T17:25:00.000Z",
      "updatedAt": "2025-11-28T17:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 157,
      "currency": "GBP",
      "description": "To Seapoint Finance Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2fekr20fk7s42ejh9gp1mm6",
      "fspDate": "2025-11-28T16:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2fekr20fk7s42ejh9gp1mm6",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T08:54:00.000Z",
        "valueDateTime": "2025-12-07T08:54:00.000Z",
        "transactionAmount": {
          "amount": "-157.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance Limited",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance Limited"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance' from 'To Seapoint Finance Limited', removing 'To ' prefix and 'Limited' suffix",
        "updatedAt": "2025-09-29T18:23:50.869Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgxpskgtf4nk",
      "createdAt": "2025-11-28T15:01:00.000Z",
      "updatedAt": "2025-11-28T15:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 203.32,
      "currency": "EUR",
      "description": "Notion Labs, Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1tgcgct1c02",
      "fspDate": "2025-11-28T14:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1tgcgct1c02",
        "bookingDate": "2025-11-28",
        "valueDate": "2025-11-28",
        "bookingDateTime": "2025-11-28T14:01:00.000Z",
        "valueDateTime": "2025-11-28T14:01:00.000Z",
        "transactionAmount": {
          "amount": "-203.32",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Notion Labs, Inc.",
        "remittanceInformationUnstructuredArray": [
          "Notion Labs, Inc."
        ],
        "debtorName": "Notion"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtcyeshspk6y0e76tesb",
      "clustering": {
        "description": "Notion",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Notion' from 'Notion Labs, Inc.', removing the 'Labs, Inc.' suffix.",
        "updatedAt": "2025-09-27T10:54:12.495Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshspgyb5jdpndjz",
      "createdAt": "2025-11-28T14:24:00.000Z",
      "updatedAt": "2025-11-28T14:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2.95,
      "currency": "EUR",
      "description": "An Post-Offices",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1xk7b2qex3j",
      "fspDate": "2025-11-28T13:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1xk7b2qex3j",
        "bookingDate": "2025-11-28",
        "valueDate": "2025-11-28",
        "bookingDateTime": "2025-11-28T13:24:00.000Z",
        "valueDateTime": "2025-11-28T13:24:00.000Z",
        "transactionAmount": {
          "amount": "-2.95",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "An Post-Offices",
        "remittanceInformationUnstructuredArray": [
          "An Post-Offices"
        ],
        "debtorName": "An Post"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwdneshspna9pr7b1tc2",
      "clustering": {
        "description": "An Post",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'An Post' from 'An Post-Offices', removing the '-Offices' suffix.",
        "updatedAt": "2025-09-27T10:54:12.518Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspghwg47bvwnb",
      "createdAt": "2025-11-28T12:52:00.000Z",
      "updatedAt": "2025-11-28T12:52:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 125,
      "currency": "EUR",
      "description": "Company Ultimate plan fee",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1eftg951e7t",
      "fspDate": "2025-11-28T11:52:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1eftg951e7t",
        "bookingDate": "2025-11-28",
        "valueDate": "2025-11-28",
        "bookingDateTime": "2025-11-28T11:52:00.000Z",
        "valueDateTime": "2025-11-28T11:52:00.000Z",
        "transactionAmount": {
          "amount": "-125.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Company Ultimate plan fee",
        "remittanceInformationUnstructuredArray": [
          "Company Ultimate plan fee"
        ],
        "debtorName": "Company"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mvseshspja4gsxz03at",
      "clustering": {
        "description": "Revolut Fees",
        "confidenceScore": "0.95",
        "rationale": "Extracted the institution name 'Revolut' as the merchant name since the transaction is a fee charged by the institution, and the description is 'Company Ultimate plan fee'.",
        "updatedAt": "2025-09-27T10:52:47.458Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wrgmg6epgper5r5zf99wzkw7gj",
      "createdAt": "2025-11-28T12:35:00.000Z",
      "updatedAt": "2025-11-28T12:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3000,
      "currency": "GBP",
      "description": "Salary - Conor Murphy - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_9pdr6bq4nxjtnrv40btync68ah",
      "fspDate": "2025-11-28T11:35:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_hryn0gxvj9dvrftqmgd437g80t",
        "bookingDate": "2025-11-28",
        "valueDate": "2025-11-28",
        "bookingDateTime": "2025-11-28T11:35:00.000Z",
        "valueDateTime": "2025-11-28T11:35:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Conor Murphy",
        "remittanceInformationUnstructuredArray": [
          "Salary - Conor Murphy"
        ]
      },
      "paymentId": "pmnt_84qdv353499f74c2hdm25w2ayp",
      "reference": "PAY-DEC-2025-MURPHY",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Conor Murphy",
        "iban": null,
        "bic": null,
        "sortCode": "90-01-23",
        "accountNumber": "67890123"
      }
    },
    {
      "id": "txn_01k65c32y0eshspes8a20vr6gp",
      "createdAt": "2025-11-28T12:17:00.000Z",
      "updatedAt": "2025-11-28T12:17:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.16,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k35t8tvce8prf098eae8w6gc",
      "fspDate": "2025-11-28T11:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k35t8tvce8prf098eae8w6gc",
        "bookingDate": "2025-11-28",
        "valueDate": "2025-11-28",
        "bookingDateTime": "2025-11-28T11:17:00.000Z",
        "valueDateTime": "2025-11-28T11:17:00.000Z",
        "transactionAmount": {
          "amount": "-17.16",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Cursor' from the 'Cursor, Ai Powered Ide' transaction description.",
        "updatedAt": "2025-09-27T10:41:48.190Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_s3b041czm347m8gg42gdrd8tj0",
      "createdAt": "2025-11-28T10:21:00.000Z",
      "updatedAt": "2025-11-28T10:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3300.13,
      "currency": "GBP",
      "description": "Payment to Yapily: Y-202511-8923",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mgrbqa7s5xv1j3aspd89azzkqr",
      "fspDate": "2025-11-28T09:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mgrbqa7s5xv1j3aspd89azzkqr",
        "bookingDate": "2025-11-28",
        "valueDate": "2025-11-28",
        "bookingDateTime": "2025-11-28T10:21:00.000Z",
        "valueDateTime": "2025-11-28T10:21:00.000Z",
        "transactionAmount": {
          "amount": "3300.13",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Yapily: Y-202511-8923",
        "remittanceInformationUnstructuredArray": [
          "Payment to Yapily",
          "Y-202511-8923"
        ],
        "debtorName": "Yapily"
      },
      "paymentId": null,
      "reference": "Y-202511-8923",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf94qfvhrjn51jet0pt56",
      "clustering": {
        "description": "Yapily",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Yapily' based on payment details",
        "updatedAt": "2025-11-28T10:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Yapily",
        "iban": null,
        "bic": null,
        "sortCode": "369595",
        "accountNumber": "71132281"
      }
    },
    {
      "id": "txn_01k65c32y4eshspg9dfen1asv9",
      "createdAt": "2025-11-28T10:19:00.000Z",
      "updatedAt": "2025-11-28T10:19:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 16000,
      "currency": "EUR",
      "description": "Payment to Modulr Finance B.V EUR: SEA001-505BV-IMP",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jz044xr1espbddvrcn567zk2",
      "fspDate": "2025-11-28T09:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jz044xr1espbddvrcn567zk2",
        "bookingDate": "2025-11-28",
        "valueDate": "2025-11-28",
        "bookingDateTime": "2025-11-28T09:19:00.000Z",
        "valueDateTime": "2025-11-28T09:19:00.000Z",
        "transactionAmount": {
          "amount": "-16000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Modulr Finance B.V. EUR: SEA001-505BV-IMP",
        "remittanceInformationUnstructuredArray": [
          "Payment to Modulr Finance B.V",
          "EUR: SEA001-505BV-IMP"
        ],
        "debtorName": "Modulr Finance B.V. EUR"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance B.V. EUR",
        "confidenceScore": "0.95",
        "rationale": "Extracted the name 'Modulr Finance B.V. EUR' from the transaction description 'Payment to Modulr Finance B.V. EUR: SEA001-505BV-IMP'.",
        "updatedAt": "2025-09-27T10:51:38.302Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfnyy42ry0fg",
      "createdAt": "2025-11-27T15:47:00.000Z",
      "updatedAt": "2025-11-27T15:47:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Jarek's Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0e8rfh5exraqe131n3v4gr8",
      "fspDate": "2025-11-27T14:47:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0e8rfh5exraqe131n3v4gr8",
        "bookingDate": "2025-11-27",
        "valueDate": "2025-11-27",
        "bookingDateTime": "2025-11-27T14:47:00.000Z",
        "valueDateTime": "2025-11-27T14:47:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Jarek's Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Jarek's Kitchen"
        ],
        "debtorName": "Jarek's Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9ynmeshspjjhrjb91rve",
      "clustering": {
        "description": "Jarek's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Jarek's Kitchen' from 'Jarek's Kitchen'",
        "updatedAt": "2025-09-27T10:49:37.615Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfqfzsyf66tq",
      "createdAt": "2025-11-27T15:24:00.000Z",
      "updatedAt": "2025-11-27T15:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 21.68,
      "currency": "EUR",
      "description": "Hotpot",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg246ze8pvk0knpsv3hkfn",
      "fspDate": "2025-11-27T14:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg246ze8pvk0knpsv3hkfn",
        "bookingDate": "2025-11-27",
        "valueDate": "2025-11-27",
        "bookingDateTime": "2025-11-27T14:24:00.000Z",
        "valueDateTime": "2025-11-27T14:24:00.000Z",
        "transactionAmount": {
          "amount": "-21.68",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Hotpot",
        "remittanceInformationUnstructuredArray": [
          "Hotpot"
        ],
        "debtorName": "Hotpot"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0wweshspkzqgyrcgqe7",
      "clustering": {
        "description": "Hotpot",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Hotpot' from 'Hotpot'",
        "updatedAt": "2025-09-27T10:49:37.682Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_y08asg98tta5fzc0w2g9pryppn",
      "createdAt": "2025-11-27T11:30:00.000Z",
      "updatedAt": "2025-11-27T11:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 50.44,
      "currency": "GBP",
      "description": "Payment to ICO: I-202511-8949",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nteyc2b9yszz6kx1qbj0jqfd7x",
      "fspDate": "2025-11-27T10:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nteyc2b9yszz6kx1qbj0jqfd7x",
        "bookingDate": "2025-11-27",
        "valueDate": "2025-11-27",
        "bookingDateTime": "2025-11-27T11:30:00.000Z",
        "valueDateTime": "2025-11-27T11:30:00.000Z",
        "transactionAmount": {
          "amount": "50.44",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to ICO: I-202511-8949",
        "remittanceInformationUnstructuredArray": [
          "Payment to ICO",
          "I-202511-8949"
        ],
        "debtorName": "ICO"
      },
      "paymentId": null,
      "reference": "I-202511-8949",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4gyfvhrjnsxtfs19v9b",
      "clustering": {
        "description": "ICO",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'ICO' based on payment details",
        "updatedAt": "2025-11-27T11:30:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "ICO",
        "iban": null,
        "bic": null,
        "sortCode": "187634",
        "accountNumber": "13054825"
      }
    },
    {
      "id": "txn_ks61a8ttc6frq6102hgfgy3406",
      "createdAt": "2025-11-27T09:43:00.000Z",
      "updatedAt": "2025-11-27T09:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 209.12,
      "currency": "GBP",
      "description": "Payment to Kiwi.com: K-202511-6663",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pqm10aser8kqzm8dft5mj94er9",
      "fspDate": "2025-11-27T08:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pqm10aser8kqzm8dft5mj94er9",
        "bookingDate": "2025-11-27",
        "valueDate": "2025-11-27",
        "bookingDateTime": "2025-11-27T09:43:00.000Z",
        "valueDateTime": "2025-11-27T09:43:00.000Z",
        "transactionAmount": {
          "amount": "209.12",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kiwi.com: K-202511-6663",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kiwi.com",
          "K-202511-6663"
        ],
        "debtorName": "Kiwi.com"
      },
      "paymentId": null,
      "reference": "K-202511-6663",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9q1fvhrjp371wrcstvr",
      "clustering": {
        "description": "Kiwi.com",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kiwi.com' based on payment details",
        "updatedAt": "2025-11-27T09:43:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kiwi.com",
        "iban": null,
        "bic": null,
        "sortCode": "198285",
        "accountNumber": "25468463"
      }
    },
    {
      "id": "txn_43380rvrt0bthk9gpcv5a8sjak",
      "createdAt": "2025-11-27T09:13:00.000Z",
      "updatedAt": "2025-11-27T09:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29.57,
      "currency": "EUR",
      "description": "Payment to Tula Mexican Grill: TMG-202511-4044",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4m3nz0ha1yx28j86b7s7rev6by",
      "fspDate": "2025-11-27T08:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4m3nz0ha1yx28j86b7s7rev6by",
        "bookingDate": "2025-11-27",
        "valueDate": "2025-11-27",
        "bookingDateTime": "2025-11-27T09:13:00.000Z",
        "valueDateTime": "2025-11-27T09:13:00.000Z",
        "transactionAmount": {
          "amount": "29.57",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tula Mexican Grill: TMG-202511-4044",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tula Mexican Grill",
          "TMG-202511-4044"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": "TMG-202511-4044",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tula Mexican Grill' based on payment details",
        "updatedAt": "2025-11-27T09:13:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tula Mexican Grill",
        "iban": "DE60280800519572536",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg5bpxt8b8wy",
      "createdAt": "2025-11-27T08:01:00.000Z",
      "updatedAt": "2025-11-27T08:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2472e8pvk12cpvdxw1aa",
      "fspDate": "2025-11-27T07:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk12cpvdxw1aa",
        "bookingDate": "2025-11-27",
        "valueDate": "2025-11-27",
        "bookingDateTime": "2025-11-27T07:01:00.000Z",
        "valueDateTime": "2025-11-27T07:01:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'.",
        "updatedAt": "2025-09-27T10:51:38.204Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebzafvhrjmvzrp8ghhma",
      "createdAt": "2025-11-27T08:01:00.000Z",
      "updatedAt": "2025-11-27T08:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4000,
      "currency": "GBP",
      "description": "To Grow Your Boat Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8mab083pj3w",
      "fspDate": "2025-11-27T07:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8mab083pj3w",
        "bookingDate": "2025-11-27",
        "valueDate": "2025-11-27",
        "bookingDateTime": "2025-11-27T07:01:00.000Z",
        "valueDateTime": "2025-11-27T07:01:00.000Z",
        "transactionAmount": {
          "amount": "-4000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Grow Your Boat Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Grow Your Boat Ltd"
        ],
        "debtorName": "Grow Your Boat Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "clustering": {
        "description": "Grow Your Boat Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Grow Your Boat Ltd' from 'To Grow Your Boat Ltd'",
        "updatedAt": "2025-09-29T18:27:23.758Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_tj9a9jpvn3d8b9rb58hkb7zpkx",
      "createdAt": "2025-11-26T14:58:00.000Z",
      "updatedAt": "2025-11-26T14:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 28472.54,
      "currency": "GBP",
      "description": "Payment from CloudFirst Technologies - INV-202511-3519",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_d5mzag529q0r9rm8pek0e3c7aq",
      "fspDate": "2025-11-26T13:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_d5mzag529q0r9rm8pek0e3c7aq",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T14:58:00.000Z",
        "valueDateTime": "2025-11-26T14:58:00.000Z",
        "transactionAmount": {
          "amount": "28472.54",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from CloudFirst Technologies - INV-202511-3519",
        "remittanceInformationUnstructuredArray": [
          "Payment from CloudFirst Technologies",
          "INV-202511-3519"
        ],
        "creditorName": "CloudFirst Technologies"
      },
      "paymentId": null,
      "reference": "INV-202511-3519",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_v3gga6hnqqf8p85ezhv67qxfkw",
      "clustering": {
        "description": "CloudFirst Technologies",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'CloudFirst Technologies'",
        "updatedAt": "2025-11-26T14:58:00.000Z"
      },
      "payer": {
        "name": "CloudFirst Technologies",
        "iban": null,
        "bic": null,
        "sortCode": "244057",
        "accountNumber": "30059313"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_d4pk71p57xp0xwe9m85k9a1fx9",
      "createdAt": "2025-11-26T13:01:00.000Z",
      "updatedAt": "2025-11-26T13:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 31477.75,
      "currency": "GBP",
      "description": "Payment from DataDriven Analytics - INV-202511-3894",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vwtsqn48tcam5fzeb9pfvpmrzt",
      "fspDate": "2025-11-26T12:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vwtsqn48tcam5fzeb9pfvpmrzt",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T13:01:00.000Z",
        "valueDateTime": "2025-11-26T13:01:00.000Z",
        "transactionAmount": {
          "amount": "31477.75",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from DataDriven Analytics - INV-202511-3894",
        "remittanceInformationUnstructuredArray": [
          "Payment from DataDriven Analytics",
          "INV-202511-3894"
        ],
        "creditorName": "DataDriven Analytics"
      },
      "paymentId": null,
      "reference": "INV-202511-3894",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_jy64mwn8y868akxp0c6s337dms",
      "clustering": {
        "description": "DataDriven Analytics",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'DataDriven Analytics'",
        "updatedAt": "2025-11-26T13:01:00.000Z"
      },
      "payer": {
        "name": "DataDriven Analytics",
        "iban": null,
        "bic": null,
        "sortCode": "298975",
        "accountNumber": "52399322"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspge01gj34e5x",
      "createdAt": "2025-11-26T12:44:00.000Z",
      "updatedAt": "2025-11-26T12:44:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 91.33,
      "currency": "EUR",
      "description": "Ryanair Uk Domestic",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1fk4xpp9vk7",
      "fspDate": "2025-11-26T11:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1fk4xpp9vk7",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T11:44:00.000Z",
        "valueDateTime": "2025-11-26T11:44:00.000Z",
        "transactionAmount": {
          "amount": "-91.33",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Ryanair Uk Domestic",
        "remittanceInformationUnstructuredArray": [
          "Ryanair Uk Domestic"
        ],
        "debtorName": "Ryanair"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctphbeshspmx6q13ktd74",
      "clustering": {
        "description": "Ryanair",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Ryanair' from 'Ryanair Uk Domestic'",
        "updatedAt": "2025-09-27T10:52:10.124Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf9amke1kgyq",
      "createdAt": "2025-11-26T12:38:00.000Z",
      "updatedAt": "2025-11-26T12:38:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 11,
      "currency": "EUR",
      "description": "Beanhive",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1d5gytnesj8a90y46vpe2ws",
      "fspDate": "2025-11-26T11:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1d5gytnesj8a90y46vpe2ws",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T13:33:00.000Z",
        "valueDateTime": "2025-12-24T13:33:00.000Z",
        "transactionAmount": {
          "amount": "-11.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Beanhive",
        "remittanceInformationUnstructuredArray": [
          "Beanhive"
        ],
        "debtorName": "Beanhive"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmacweshspkk5mv2ktdq4",
      "clustering": {
        "description": "Beanhive",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Beanhive' from the transaction description",
        "updatedAt": "2025-09-27T10:45:11.604Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4vj75ssjfqegcbpz5ryczcdbs6",
      "createdAt": "2025-11-26T11:50:00.000Z",
      "updatedAt": "2025-11-26T11:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 829.43,
      "currency": "USD",
      "description": "Payment to GitHub, Inc.: GI-202511-5874",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hq9pxnhxe141w8mfdbwq693gfa",
      "fspDate": "2025-11-26T10:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hq9pxnhxe141w8mfdbwq693gfa",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T11:50:00.000Z",
        "valueDateTime": "2025-11-26T11:50:00.000Z",
        "transactionAmount": {
          "amount": "829.43",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GitHub, Inc.: GI-202511-5874",
        "remittanceInformationUnstructuredArray": [
          "Payment to GitHub, Inc.",
          "GI-202511-5874"
        ],
        "debtorName": "GitHub, Inc."
      },
      "paymentId": null,
      "reference": "GI-202511-5874",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_xj643cpp5p1awyrrqgqpf67q4d",
      "clustering": {
        "description": "GitHub, Inc.",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'GitHub, Inc.' based on payment details",
        "updatedAt": "2025-11-26T11:50:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GitHub, Inc.",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmkmd9sd56n3",
      "createdAt": "2025-11-26T11:37:00.000Z",
      "updatedAt": "2025-11-26T11:37:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 48.68,
      "currency": "GBP",
      "description": "Linkedin P584381264",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8c7w4qkk8ev",
      "fspDate": "2025-11-26T10:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8c7w4qkk8ev",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T10:37:00.000Z",
        "valueDateTime": "2025-11-26T10:37:00.000Z",
        "transactionAmount": {
          "amount": "-48.68",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin P584381264",
        "remittanceInformationUnstructuredArray": [
          "Linkedin P584381264"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'LinkedIn' from 'Linkedin P584381264'",
        "updatedAt": "2025-09-29T18:25:48.570Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_z7s1rzsf2tjrnqpr54qv2bt8r9",
      "createdAt": "2025-11-26T11:14:00.000Z",
      "updatedAt": "2025-11-26T11:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 32.53,
      "currency": "EUR",
      "description": "Payment to Veremark: V-202511-4913",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_q97w05er635802pys0m9jkf7f8",
      "fspDate": "2025-11-26T10:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_q97w05er635802pys0m9jkf7f8",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T11:14:00.000Z",
        "valueDateTime": "2025-11-26T11:14:00.000Z",
        "transactionAmount": {
          "amount": "32.53",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Veremark: V-202511-4913",
        "remittanceInformationUnstructuredArray": [
          "Payment to Veremark",
          "V-202511-4913"
        ],
        "debtorName": "Veremark"
      },
      "paymentId": null,
      "reference": "V-202511-4913",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwc3eshspn9n53st1zft",
      "clustering": {
        "description": "Veremark",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Veremark' based on payment details",
        "updatedAt": "2025-11-26T11:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Veremark",
        "iban": "DE41353637633762510",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vxtf24136xdmzhj06vks0xdryt",
      "createdAt": "2025-11-26T10:27:00.000Z",
      "updatedAt": "2025-11-26T10:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 24.95,
      "currency": "EUR",
      "description": "Payment to Tang: T-202511-9324",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_e02q5jpmza118w4e5rnewr6ntr",
      "fspDate": "2025-11-26T09:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_e02q5jpmza118w4e5rnewr6ntr",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T10:27:00.000Z",
        "valueDateTime": "2025-11-26T10:27:00.000Z",
        "transactionAmount": {
          "amount": "24.95",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tang: T-202511-9324",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tang",
          "T-202511-9324"
        ],
        "debtorName": "Tang"
      },
      "paymentId": null,
      "reference": "T-202511-9324",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gseshspjyrwgx4ccwg",
      "clustering": {
        "description": "Tang",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tang' based on payment details",
        "updatedAt": "2025-11-26T10:27:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tang",
        "iban": "DE32186291185710816",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspemkqbmyz1vj",
      "createdAt": "2025-11-26T09:58:00.000Z",
      "updatedAt": "2025-11-26T09:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6003.2,
      "currency": "EUR",
      "description": "Payment to Luca Moretti: Aug 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gc1mgge8prm07ehxtms9hr",
      "fspDate": "2025-11-26T08:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc1mgge8prm07ehxtms9hr",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T08:58:00.000Z",
        "valueDateTime": "2025-11-26T08:58:00.000Z",
        "transactionAmount": {
          "amount": "-6003.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Luca Moretti: Aug 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Luca Moretti: Aug 2025 Payroll"
        ],
        "debtorName": "Luca Moretti"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsbeshspj7jp8q6rygp",
      "clustering": {
        "description": "Luca Moretti",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Luca Moretti' from 'Payment to Luca Moretti: Aug 2025 Payroll'",
        "updatedAt": "2025-09-27T10:40:26.861Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xhhxjf4n6x90pgtkr60fr6w8h5",
      "createdAt": "2025-11-26T09:37:00.000Z",
      "updatedAt": "2025-11-26T09:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 24161.97,
      "currency": "GBP",
      "description": "Payment from Innovation Partners - INV-202511-5601",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_50ttkx0bw8ae0sv8rbjsa36sm9",
      "fspDate": "2025-11-26T08:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_50ttkx0bw8ae0sv8rbjsa36sm9",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T09:37:00.000Z",
        "valueDateTime": "2025-11-26T09:37:00.000Z",
        "transactionAmount": {
          "amount": "24161.97",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Innovation Partners - INV-202511-5601",
        "remittanceInformationUnstructuredArray": [
          "Payment from Innovation Partners",
          "INV-202511-5601"
        ],
        "creditorName": "Innovation Partners"
      },
      "paymentId": null,
      "reference": "INV-202511-5601",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m4xtykg61y9kjq9cjdr8bewyz0",
      "clustering": {
        "description": "Innovation Partners",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Innovation Partners'",
        "updatedAt": "2025-11-26T09:37:00.000Z"
      },
      "payer": {
        "name": "Innovation Partners",
        "iban": null,
        "bic": null,
        "sortCode": "546289",
        "accountNumber": "71210126"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfxpfa362538",
      "createdAt": "2025-11-26T08:18:00.000Z",
      "updatedAt": "2025-11-26T08:18:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.99,
      "currency": "EUR",
      "description": "Paddle.net* Geoguessr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0t0zefzvcfb",
      "fspDate": "2025-11-26T07:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0t0zefzvcfb",
        "bookingDate": "2025-11-26",
        "valueDate": "2025-11-26",
        "bookingDateTime": "2025-11-26T07:18:00.000Z",
        "valueDateTime": "2025-11-26T07:18:00.000Z",
        "transactionAmount": {
          "amount": "-4.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Paddle.net* Geoguessr",
        "remittanceInformationUnstructuredArray": [
          "Paddle.net* Geoguessr"
        ],
        "debtorName": "Paddle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax3veshspjmhphswafsq",
      "clustering": {
        "description": "Paddle",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Paddle' from 'Paddle.net* Geoguessr'",
        "updatedAt": "2025-09-27T10:50:08.385Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg7mj7vfey8b",
      "createdAt": "2025-11-25T14:01:00.000Z",
      "updatedAt": "2025-11-25T14:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 97.8,
      "currency": "EUR",
      "description": "Attio",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk15sx68gw7r0",
      "fspDate": "2025-11-25T13:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk15sx68gw7r0",
        "bookingDate": "2025-11-25",
        "valueDate": "2025-11-25",
        "bookingDateTime": "2025-11-25T13:01:00.000Z",
        "valueDateTime": "2025-11-25T13:01:00.000Z",
        "transactionAmount": {
          "amount": "-97.80",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Attio",
        "remittanceInformationUnstructuredArray": [
          "Attio"
        ],
        "debtorName": "Attio"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspj5eshspmpcdfterchh",
      "clustering": {
        "description": "Attio",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Attio' from 'Attio'.",
        "updatedAt": "2025-09-27T10:51:38.268Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_np4053q92kra5aee5eyans0whf",
      "createdAt": "2025-11-25T10:07:00.000Z",
      "updatedAt": "2025-11-25T10:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 457.19,
      "currency": "USD",
      "description": "Payment to Kandji: K-202511-3561",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ga75zrbz8r5pwrk4nv8agjagdn",
      "fspDate": "2025-11-25T09:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ga75zrbz8r5pwrk4nv8agjagdn",
        "bookingDate": "2025-11-25",
        "valueDate": "2025-11-25",
        "bookingDateTime": "2025-11-25T10:07:00.000Z",
        "valueDateTime": "2025-11-25T10:07:00.000Z",
        "transactionAmount": {
          "amount": "457.19",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kandji: K-202511-3561",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kandji",
          "K-202511-3561"
        ],
        "debtorName": "Kandji"
      },
      "paymentId": null,
      "reference": "K-202511-3561",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax4veshspjmy8ae028r6",
      "clustering": {
        "description": "Kandji",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kandji' based on payment details",
        "updatedAt": "2025-11-25T10:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kandji",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfsh9b4xc4ch",
      "createdAt": "2025-11-24T16:01:00.000Z",
      "updatedAt": "2025-11-24T16:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1512.34,
      "currency": "EUR",
      "description": "Upwork -827140564ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0ngswxys292",
      "fspDate": "2025-11-24T15:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0ngswxys292",
        "bookingDate": "2025-11-24",
        "valueDate": "2025-11-24",
        "bookingDateTime": "2025-11-24T15:01:00.000Z",
        "valueDateTime": "2025-11-24T15:01:00.000Z",
        "transactionAmount": {
          "amount": "-1512.34",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -827140564ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -827140564ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Upwork' from 'Upwork -827140564ref'",
        "updatedAt": "2025-09-27T10:49:37.754Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm6m9f91ptm6",
      "createdAt": "2025-11-24T14:45:00.000Z",
      "updatedAt": "2025-11-24T14:45:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 5400,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1mwq52jexy9b8n0ms6bmqdh",
      "fspDate": "2025-11-24T13:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1mwq52jexy9b8n0ms6bmqdh",
        "bookingDate": "2025-11-24",
        "valueDate": "2025-11-24",
        "bookingDateTime": "2025-11-24T13:45:00.000Z",
        "valueDateTime": "2025-11-24T13:45:00.000Z",
        "transactionAmount": {
          "amount": "5400.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.920Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1emzddkw6ks05b5nw8bhp6p243",
      "createdAt": "2025-11-24T14:09:00.000Z",
      "updatedAt": "2025-11-24T14:09:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.08,
      "currency": "USD",
      "description": "Payment to Reflect Software: RS-202511-2353",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_3003j6bvr5qjvsy68m5fpm9zme",
      "fspDate": "2025-11-24T13:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_3003j6bvr5qjvsy68m5fpm9zme",
        "bookingDate": "2025-11-24",
        "valueDate": "2025-11-24",
        "bookingDateTime": "2025-11-24T14:09:00.000Z",
        "valueDateTime": "2025-11-24T14:09:00.000Z",
        "transactionAmount": {
          "amount": "10.08",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Reflect Software: RS-202511-2353",
        "remittanceInformationUnstructuredArray": [
          "Payment to Reflect Software",
          "RS-202511-2353"
        ],
        "debtorName": "Reflect Software"
      },
      "paymentId": null,
      "reference": "RS-202511-2353",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wfmeshsphxg0s376ywm",
      "clustering": {
        "description": "Reflect Software",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Reflect Software' based on payment details",
        "updatedAt": "2025-11-24T14:09:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Reflect Software",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_p9w7dm9med32gvwdtxb16gvnne",
      "createdAt": "2025-11-24T11:45:00.000Z",
      "updatedAt": "2025-11-24T11:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.77,
      "currency": "USD",
      "description": "Payment to Figma: F-202511-2432",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0bwawc7sc6bv9ayr8rxqxf99qa",
      "fspDate": "2025-11-24T10:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0bwawc7sc6bv9ayr8rxqxf99qa",
        "bookingDate": "2025-11-24",
        "valueDate": "2025-11-24",
        "bookingDateTime": "2025-11-24T11:45:00.000Z",
        "valueDateTime": "2025-11-24T11:45:00.000Z",
        "transactionAmount": {
          "amount": "14.77",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Figma: F-202511-2432",
        "remittanceInformationUnstructuredArray": [
          "Payment to Figma",
          "F-202511-2432"
        ],
        "debtorName": "Figma"
      },
      "paymentId": null,
      "reference": "F-202511-2432",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdq3eshspk9qt2a4er00",
      "clustering": {
        "description": "Figma",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Figma' based on payment details",
        "updatedAt": "2025-11-24T11:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Figma",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1mwjqpqez8p26pyhpdew8jspmk",
      "createdAt": "2025-11-24T10:50:00.000Z",
      "updatedAt": "2025-11-24T10:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1346.51,
      "currency": "GBP",
      "description": "Payment to Adam Rankin: AR-202511-3695",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0trdn30ca8ay25500qa708ytxm",
      "fspDate": "2025-11-24T09:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0trdn30ca8ay25500qa708ytxm",
        "bookingDate": "2025-11-24",
        "valueDate": "2025-11-24",
        "bookingDateTime": "2025-11-24T10:50:00.000Z",
        "valueDateTime": "2025-11-24T10:50:00.000Z",
        "transactionAmount": {
          "amount": "1346.51",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Adam Rankin: AR-202511-3695",
        "remittanceInformationUnstructuredArray": [
          "Payment to Adam Rankin",
          "AR-202511-3695"
        ],
        "debtorName": "Adam Rankin"
      },
      "paymentId": null,
      "reference": "AR-202511-3695",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2zfvhrjnc124tr3b2s",
      "clustering": {
        "description": "Adam Rankin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Adam Rankin' based on payment details",
        "updatedAt": "2025-11-24T10:50:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Adam Rankin",
        "iban": null,
        "bic": null,
        "sortCode": "889883",
        "accountNumber": "31924433"
      }
    },
    {
      "id": "txn_01k65c32y5eshspgfh567yqrfk",
      "createdAt": "2025-11-24T10:42:00.000Z",
      "updatedAt": "2025-11-24T10:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4909.83,
      "currency": "EUR",
      "description": "To Hugo Weber",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1e0y40eskgq",
      "fspDate": "2025-11-24T09:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1e0y40eskgq",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T14:00:00.000Z",
        "valueDateTime": "2026-01-02T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-4909.83",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Hugo Weber",
        "remittanceInformationUnstructuredArray": [
          "To Hugo Weber"
        ],
        "debtorName": "Hugo Weber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtteshspj9hmeqmzmdw",
      "clustering": {
        "description": "Hugo Weber",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Hugo Weber' from 'To Hugo Weber'.",
        "updatedAt": "2025-09-27T10:52:47.370Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_rcywb2nyej56w709frr22vzhj6",
      "createdAt": "2025-11-24T09:35:00.000Z",
      "updatedAt": "2025-11-24T09:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 22.96,
      "currency": "EUR",
      "description": "Payment to Muhammad Tashf: MT-202511-9087",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6vwj5ak4c0nv1cnv64htzkg7qh",
      "fspDate": "2025-11-24T08:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6vwj5ak4c0nv1cnv64htzkg7qh",
        "bookingDate": "2025-11-24",
        "valueDate": "2025-11-24",
        "bookingDateTime": "2025-11-24T09:35:00.000Z",
        "valueDateTime": "2025-11-24T09:35:00.000Z",
        "transactionAmount": {
          "amount": "22.96",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Muhammad Tashf: MT-202511-9087",
        "remittanceInformationUnstructuredArray": [
          "Payment to Muhammad Tashf",
          "MT-202511-9087"
        ],
        "debtorName": "Muhammad Tashf"
      },
      "paymentId": null,
      "reference": "MT-202511-9087",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkgjeshspnx4pqb9b6ze",
      "clustering": {
        "description": "Muhammad Tashf",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Muhammad Tashf' based on payment details",
        "updatedAt": "2025-11-24T09:35:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Muhammad Tashf",
        "iban": "DE45202708356382980",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg3g1j8ytcrz",
      "createdAt": "2025-11-24T08:42:00.000Z",
      "updatedAt": "2025-11-24T08:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 23,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0zh3f8n73sg",
      "fspDate": "2025-11-24T07:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0zh3f8n73sg",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T15:00:00.000Z",
        "valueDateTime": "2026-01-08T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-23.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'OpenAI' from 'Openai *chatgpt Subscr', removing 'Openai *' prefix",
        "updatedAt": "2025-09-27T10:50:52.471Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmdnb61gh5q3",
      "createdAt": "2025-11-23T16:13:00.000Z",
      "updatedAt": "2025-11-23T16:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6105.04,
      "currency": "GBP",
      "description": "To Adrian Keller",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk86c5exwk6re",
      "fspDate": "2025-11-23T15:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk86c5exwk6re",
        "bookingDate": "2025-11-23",
        "valueDate": "2025-11-23",
        "bookingDateTime": "2025-11-23T15:13:00.000Z",
        "valueDateTime": "2025-11-23T15:13:00.000Z",
        "transactionAmount": {
          "amount": "-6105.04",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Adrian Keller",
        "remittanceInformationUnstructuredArray": [
          "To Adrian Keller"
        ],
        "debtorName": "Adrian Keller"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhncmfvhrjnjwn2hxwm55",
      "clustering": {
        "description": "Adrian Keller",
        "confidenceScore": "0.95",
        "rationale": "Extracted the name 'Adrian Keller' from 'To Adrian Keller'",
        "updatedAt": "2025-09-29T18:25:01.122Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_whz7w971stszkrgmsaxqj8ztb9",
      "createdAt": "2025-11-23T15:57:00.000Z",
      "updatedAt": "2025-11-23T15:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 398.79,
      "currency": "GBP",
      "description": "Payment to Booking.com: B-202511-3342",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_k9fmt1w0bqs8xa5g3jbac9pqmn",
      "fspDate": "2025-11-23T14:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_k9fmt1w0bqs8xa5g3jbac9pqmn",
        "bookingDate": "2025-11-23",
        "valueDate": "2025-11-23",
        "bookingDateTime": "2025-11-23T15:57:00.000Z",
        "valueDateTime": "2025-11-23T15:57:00.000Z",
        "transactionAmount": {
          "amount": "398.79",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Booking.com: B-202511-3342",
        "remittanceInformationUnstructuredArray": [
          "Payment to Booking.com",
          "B-202511-3342"
        ],
        "debtorName": "Booking.com"
      },
      "paymentId": null,
      "reference": "B-202511-3342",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9p5fvhrjp2td9pd9rat",
      "clustering": {
        "description": "Booking.com",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Booking.com' based on payment details",
        "updatedAt": "2025-11-23T15:57:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Booking.com",
        "iban": null,
        "bic": null,
        "sortCode": "954154",
        "accountNumber": "58026533"
      }
    },
    {
      "id": "txn_01k65c32y6eshspgq5brd0zht7",
      "createdAt": "2025-11-23T15:19:00.000Z",
      "updatedAt": "2025-11-23T15:19:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 31,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1kq4fpq70hv",
      "fspDate": "2025-11-23T14:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1kq4fpq70hv",
        "bookingDate": "2025-11-23",
        "valueDate": "2025-11-23",
        "bookingDateTime": "2025-11-23T14:19:00.000Z",
        "valueDateTime": "2025-11-23T14:19:00.000Z",
        "transactionAmount": {
          "amount": "-31.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Shaka Poke' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.228Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6maydswvf6t6ma4ggxrewhbyjm",
      "createdAt": "2025-11-23T15:11:00.000Z",
      "updatedAt": "2025-11-23T15:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3400,
      "currency": "GBP",
      "description": "Salary - Hannah Davies - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_xxgv5dncjsqgy23ev6j8xsb2my",
      "fspDate": "2025-11-23T14:11:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_e27sj6gdb4pmcyypzp8w03r4bt",
        "bookingDate": "2025-11-23",
        "valueDate": "2025-11-23",
        "bookingDateTime": "2025-11-23T14:11:00.000Z",
        "valueDateTime": "2025-11-23T14:11:00.000Z",
        "transactionAmount": {
          "amount": "-3400.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Hannah Davies",
        "remittanceInformationUnstructuredArray": [
          "Salary - Hannah Davies"
        ]
      },
      "paymentId": "pmnt_c7ctjypt89a30xp631b80wcmsf",
      "reference": "PAY-DEC-2025-DAVIES",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Hannah Davies",
        "iban": null,
        "bic": null,
        "sortCode": "40-05-30",
        "accountNumber": "11234567"
      }
    },
    {
      "id": "txn_wx1dmvrancrr4wsmtbr3c2m9h3",
      "createdAt": "2025-11-23T13:49:00.000Z",
      "updatedAt": "2025-11-23T13:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 119.29,
      "currency": "EUR",
      "description": "Payment to Giftmall.es: G-202511-5864",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6bcyycnx3ghkf7gpjqb4xr7akc",
      "fspDate": "2025-11-23T12:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6bcyycnx3ghkf7gpjqb4xr7akc",
        "bookingDate": "2025-11-23",
        "valueDate": "2025-11-23",
        "bookingDateTime": "2025-11-23T13:49:00.000Z",
        "valueDateTime": "2025-11-23T13:49:00.000Z",
        "transactionAmount": {
          "amount": "119.29",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Giftmall.es: G-202511-5864",
        "remittanceInformationUnstructuredArray": [
          "Payment to Giftmall.es",
          "G-202511-5864"
        ],
        "debtorName": "Giftmall.es"
      },
      "paymentId": null,
      "reference": "G-202511-5864",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpfaeshspmwtrg2tk9zk",
      "clustering": {
        "description": "Giftmall.es",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Giftmall.es' based on payment details",
        "updatedAt": "2025-11-23T13:49:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Giftmall.es",
        "iban": "DE55149454511082360",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3w9gmez6b6c7ep58em0m9d9q3n",
      "createdAt": "2025-11-23T12:21:00.000Z",
      "updatedAt": "2025-11-23T12:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 35473.59,
      "currency": "EUR",
      "description": "Payment from Nexus Consulting GmbH - INV-202511-8131",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6mecw8mmapw1r2cwpwv5m9bc87",
      "fspDate": "2025-11-23T11:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6mecw8mmapw1r2cwpwv5m9bc87",
        "bookingDate": "2025-11-23",
        "valueDate": "2025-11-23",
        "bookingDateTime": "2025-11-23T12:21:00.000Z",
        "valueDateTime": "2025-11-23T12:21:00.000Z",
        "transactionAmount": {
          "amount": "35473.59",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nexus Consulting GmbH - INV-202511-8131",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nexus Consulting GmbH",
          "INV-202511-8131"
        ],
        "creditorName": "Nexus Consulting GmbH"
      },
      "paymentId": null,
      "reference": "INV-202511-8131",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_631832eta7hj1n2x0gedv5fm59",
      "clustering": {
        "description": "Nexus Consulting GmbH",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nexus Consulting GmbH'",
        "updatedAt": "2025-11-23T12:21:00.000Z"
      },
      "payer": {
        "name": "Nexus Consulting GmbH",
        "iban": "DE63674950737258584",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xweshspedk1taddtd7",
      "createdAt": "2025-11-23T12:00:00.000Z",
      "updatedAt": "2025-11-23T12:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3690,
      "currency": "EUR",
      "description": "Payment to PEMBROKEHALL LTD: 151170",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k44sfpcmf68sptbjahhqs0m1",
      "fspDate": "2025-11-23T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k44sfpcmf68sptbjahhqs0m1",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T12:00:00.000Z",
        "valueDateTime": "2026-01-07T12:00:00.000Z",
        "transactionAmount": {
          "amount": "-3690.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to PEMBROKEHALL LTD: 151170",
        "remittanceInformationUnstructuredArray": [
          "Payment to PEMBROKEHALL LTD: 151170"
        ],
        "debtorName": "PEMBROKEHALL LTD"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzdeshsphm46adfgbg7",
      "clustering": {
        "description": "Pembrokehall",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Pembrokehall' from 'Payment to PEMBROKEHALL LTD: 151170', removing 'Payment to ' prefix and ' LTD' suffix.",
        "updatedAt": "2025-09-27T10:39:39.595Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gvxwcwk4xwagpytn1n6b9pn4ct",
      "createdAt": "2025-11-23T09:45:00.000Z",
      "updatedAt": "2025-11-23T09:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 680.85,
      "currency": "EUR",
      "description": "Payment to Denis Breen & Co: DB&-202511-2296",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zswxj4zzrtygje9t9zqr8c0ss4",
      "fspDate": "2025-11-23T08:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zswxj4zzrtygje9t9zqr8c0ss4",
        "bookingDate": "2025-11-23",
        "valueDate": "2025-11-23",
        "bookingDateTime": "2025-11-23T09:45:00.000Z",
        "valueDateTime": "2025-11-23T09:45:00.000Z",
        "transactionAmount": {
          "amount": "680.85",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Denis Breen & Co: DB&-202511-2296",
        "remittanceInformationUnstructuredArray": [
          "Payment to Denis Breen & Co",
          "DB&-202511-2296"
        ],
        "debtorName": "Denis Breen & Co"
      },
      "paymentId": null,
      "reference": "DB&-202511-2296",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zb1eshspj0854px1k2v",
      "clustering": {
        "description": "Denis Breen & Co",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Denis Breen & Co' based on payment details",
        "updatedAt": "2025-11-23T09:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Denis Breen & Co",
        "iban": "DE53870642264407150",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmnw967nbq2h",
      "createdAt": "2025-11-23T08:28:00.000Z",
      "updatedAt": "2025-11-23T08:28:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 0.01,
      "currency": "GBP",
      "description": "To Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8edd30dbfjx",
      "fspDate": "2025-11-23T07:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8edd30dbfjx",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T08:00:00.000Z",
        "valueDateTime": "2026-01-13T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-0.01",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance UK Ltd"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Seapoint Finance UK Ltd' from 'To Seapoint Finance UK Ltd'",
        "updatedAt": "2025-09-29T18:25:48.643Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf2v9kgyvd45",
      "createdAt": "2025-11-22T17:02:00.000Z",
      "updatedAt": "2025-11-22T17:02:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 30.81,
      "currency": "EUR",
      "description": "Sentry",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k21rq21jf2181cbx9cbnd6em",
      "fspDate": "2025-11-22T16:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k21rq21jf2181cbx9cbnd6em",
        "bookingDate": "2025-11-22",
        "valueDate": "2025-11-22",
        "bookingDateTime": "2025-11-22T16:02:00.000Z",
        "valueDateTime": "2025-11-22T16:02:00.000Z",
        "transactionAmount": {
          "amount": "-30.81",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sentry",
        "remittanceInformationUnstructuredArray": [
          "Sentry"
        ],
        "debtorName": "Sentry"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdn2eshspk97jdcm57ef",
      "clustering": {
        "description": "Sentry",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Sentry' from the transaction description.",
        "updatedAt": "2025-09-27T10:43:55.478Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wa2zr5an9082t4e1d09rgw3807",
      "createdAt": "2025-11-22T12:48:00.000Z",
      "updatedAt": "2025-11-22T12:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 22990.47,
      "currency": "EUR",
      "description": "Payment from Alpine Software SA - INV-202511-7379",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_tbmj3vh2xtabfhh02fh28js6wp",
      "fspDate": "2025-11-22T11:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_tbmj3vh2xtabfhh02fh28js6wp",
        "bookingDate": "2025-11-22",
        "valueDate": "2025-11-22",
        "bookingDateTime": "2025-11-22T12:48:00.000Z",
        "valueDateTime": "2025-11-22T12:48:00.000Z",
        "transactionAmount": {
          "amount": "22990.47",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Alpine Software SA - INV-202511-7379",
        "remittanceInformationUnstructuredArray": [
          "Payment from Alpine Software SA",
          "INV-202511-7379"
        ],
        "creditorName": "Alpine Software SA"
      },
      "paymentId": null,
      "reference": "INV-202511-7379",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_nk7g93a6fpe8ybm4hppdmmfgsw",
      "clustering": {
        "description": "Alpine Software SA",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Alpine Software SA'",
        "updatedAt": "2025-11-22T12:48:00.000Z"
      },
      "payer": {
        "name": "Alpine Software SA",
        "iban": "DE24482172343036670",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmmnbca2dhav",
      "createdAt": "2025-11-22T11:04:00.000Z",
      "updatedAt": "2025-11-22T11:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1375,
      "currency": "GBP",
      "description": "To Gocardless",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8cqg9b72wne",
      "fspDate": "2025-11-22T10:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8cqg9b72wne",
        "bookingDate": "2025-11-22",
        "valueDate": "2025-11-22",
        "bookingDateTime": "2025-11-22T10:04:00.000Z",
        "valueDateTime": "2025-11-22T10:04:00.000Z",
        "transactionAmount": {
          "amount": "-1375.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Gocardless",
        "remittanceInformationUnstructuredArray": [
          "To Gocardless"
        ],
        "debtorName": "GoCardless SAS"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5k6eshspjzd728cagsr",
      "clustering": {
        "description": "GoCardless",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'GoCardless' from 'To Gocardless'",
        "updatedAt": "2025-09-29T18:25:48.595Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_32p3rvzwnfmws7yx1fc4ywce01",
      "createdAt": "2025-11-22T09:58:00.000Z",
      "updatedAt": "2025-11-22T09:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 23954.87,
      "currency": "EUR",
      "description": "Payment from EuroTech Innovations - INV-202511-6937",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_f8k9bkm42gbqp5f4cjpc0dakn6",
      "fspDate": "2025-11-22T08:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_f8k9bkm42gbqp5f4cjpc0dakn6",
        "bookingDate": "2025-11-22",
        "valueDate": "2025-11-22",
        "bookingDateTime": "2025-11-22T09:58:00.000Z",
        "valueDateTime": "2025-11-22T09:58:00.000Z",
        "transactionAmount": {
          "amount": "23954.87",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from EuroTech Innovations - INV-202511-6937",
        "remittanceInformationUnstructuredArray": [
          "Payment from EuroTech Innovations",
          "INV-202511-6937"
        ],
        "creditorName": "EuroTech Innovations"
      },
      "paymentId": null,
      "reference": "INV-202511-6937",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m17gcz62vyhqqefr5q41a31k5f",
      "clustering": {
        "description": "EuroTech Innovations",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'EuroTech Innovations'",
        "updatedAt": "2025-11-22T09:58:00.000Z"
      },
      "payer": {
        "name": "EuroTech Innovations",
        "iban": "DE71371991519258630",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshspgzy813rad3r",
      "createdAt": "2025-11-21T16:09:00.000Z",
      "updatedAt": "2025-11-21T16:09:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 23,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1wv73ppkfz6",
      "fspDate": "2025-11-21T15:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1wv73ppkfz6",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T15:09:00.000Z",
        "valueDateTime": "2025-11-21T15:09:00.000Z",
        "transactionAmount": {
          "amount": "-23.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'OpenAI' from 'Openai *chatgpt Subscr', removing the 'Openai *' prefix.",
        "updatedAt": "2025-09-27T10:54:12.555Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfanfwmb2z4b",
      "createdAt": "2025-11-21T15:22:00.000Z",
      "updatedAt": "2025-11-21T15:22:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 50,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1ak4azgesj89g4p8es2gtxa",
      "fspDate": "2025-11-21T14:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1ak4azgesj89g4p8es2gtxa",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T14:22:00.000Z",
        "valueDateTime": "2025-11-21T14:22:00.000Z",
        "transactionAmount": {
          "amount": "-50.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Zakura' from the transaction description",
        "updatedAt": "2025-09-27T10:45:11.642Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgfezatccrtr",
      "createdAt": "2025-11-21T13:38:00.000Z",
      "updatedAt": "2025-11-21T13:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4988.83,
      "currency": "EUR",
      "description": "To Sophie Laurent",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1dxs9x79ev9",
      "fspDate": "2025-11-21T12:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1dxs9x79ev9",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T15:00:00.000Z",
        "valueDateTime": "2026-01-03T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-4988.83",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Sophie Laurent",
        "remittanceInformationUnstructuredArray": [
          "To Sophie Laurent"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsseshspj86qckgs7na",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Sophie Laurent' from 'To Sophie Laurent'.",
        "updatedAt": "2025-09-27T10:52:47.362Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm4r6s87hbc7",
      "createdAt": "2025-11-21T13:33:00.000Z",
      "updatedAt": "2025-11-21T13:33:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2050,
      "currency": "GBP",
      "description": "Nest",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2ksfsfdfzwbd14vvbs1w6s1",
      "fspDate": "2025-11-21T12:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ksfsfdfzwbd14vvbs1w6s1",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T12:00:00.000Z",
        "valueDateTime": "2026-01-05T12:00:00.000Z",
        "transactionAmount": {
          "amount": "-2050.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Nest",
        "remittanceInformationUnstructuredArray": [
          "Nest"
        ],
        "debtorName": "Nest"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf96wfvhrjn5f3jx2wta0",
      "clustering": {
        "description": "Nest",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Nest' from 'Nest'",
        "updatedAt": "2025-09-29T18:23:50.863Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspf0emxex7wm1",
      "createdAt": "2025-11-21T12:18:00.000Z",
      "updatedAt": "2025-11-21T12:18:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 26.07,
      "currency": "EUR",
      "description": "Xai Llc",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2cbyz5keskvmh3npvy7qqre",
      "fspDate": "2025-11-21T11:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2cbyz5keskvmh3npvy7qqre",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T11:18:00.000Z",
        "valueDateTime": "2025-11-21T11:18:00.000Z",
        "transactionAmount": {
          "amount": "-26.07",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Xai Llc",
        "remittanceInformationUnstructuredArray": [
          "Xai Llc"
        ],
        "debtorName": "Xai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgt8yeshspk60ezf5bsne",
      "clustering": {
        "description": "Xai",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Xai' from 'Xai Llc'",
        "updatedAt": "2025-09-27T10:42:40.430Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8ff9dnxtzg56184kmpc91r64ke",
      "createdAt": "2025-11-21T10:54:00.000Z",
      "updatedAt": "2025-11-21T10:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.84,
      "currency": "EUR",
      "description": "Payment to Tortilla Latin Food: TLF-202511-6319",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_etq7krp0gqyk6bzxphc9jnfrdy",
      "fspDate": "2025-11-21T09:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_etq7krp0gqyk6bzxphc9jnfrdy",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T10:54:00.000Z",
        "valueDateTime": "2025-11-21T10:54:00.000Z",
        "transactionAmount": {
          "amount": "9.84",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tortilla Latin Food: TLF-202511-6319",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tortilla Latin Food",
          "TLF-202511-6319"
        ],
        "debtorName": "Tortilla Latin Food"
      },
      "paymentId": null,
      "reference": "TLF-202511-6319",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspgkeshspmp0mmzf2w0c",
      "clustering": {
        "description": "Tortilla Latin Food",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tortilla Latin Food' based on payment details",
        "updatedAt": "2025-11-21T10:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tortilla Latin Food",
        "iban": "DE67512322608641830",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfjnpf6tky7z",
      "createdAt": "2025-11-21T10:19:00.000Z",
      "updatedAt": "2025-11-21T10:19:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 62.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0rjbcknfq9r7n2kr9s6xrxy",
      "fspDate": "2025-11-21T09:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0rjbcknfq9r7n2kr9s6xrxy",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T09:19:00.000Z",
        "valueDateTime": "2025-11-21T09:19:00.000Z",
        "transactionAmount": {
          "amount": "-62.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from the transaction description",
        "updatedAt": "2025-09-27T10:49:04.295Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgd41brbvy4z",
      "createdAt": "2025-11-21T09:42:00.000Z",
      "updatedAt": "2025-11-21T09:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29493.56,
      "currency": "EUR",
      "description": "To Revenue Commissioners",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1acxckktbbc",
      "fspDate": "2025-11-21T08:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1acxckktbbc",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T07:00:00.000Z",
        "valueDateTime": "2026-01-13T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-29493.56",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Revenue Commissioners",
        "remittanceInformationUnstructuredArray": [
          "To Revenue Commissioners"
        ],
        "debtorName": "REVENUE COMMISSION"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g53eshsphprhxzbraqp",
      "clustering": {
        "description": "Revenue Commissioners",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Revenue Commissioners' from 'To Revenue Commissioners'",
        "updatedAt": "2025-09-27T10:52:10.107Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgqwh70ya4dw",
      "createdAt": "2025-11-21T09:36:00.000Z",
      "updatedAt": "2025-11-21T09:36:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 62.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1mf6vtw9sz4",
      "fspDate": "2025-11-21T08:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1mf6vtw9sz4",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T08:36:00.000Z",
        "valueDateTime": "2025-11-21T08:36:00.000Z",
        "transactionAmount": {
          "amount": "-62.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Zakura' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.252Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qmj6q5d7z50qxsjvh6expytmjy",
      "createdAt": "2025-11-21T09:36:00.000Z",
      "updatedAt": "2025-11-21T09:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7217.59,
      "currency": "EUR",
      "description": "Payment to Cormac Byrne: CB-202511-6905",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_8nr4cvdpk19rywn3p8698snvc1",
      "fspDate": "2025-11-21T08:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_8nr4cvdpk19rywn3p8698snvc1",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T09:36:00.000Z",
        "valueDateTime": "2025-11-21T09:36:00.000Z",
        "transactionAmount": {
          "amount": "7217.59",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cormac Byrne: CB-202511-6905",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cormac Byrne",
          "CB-202511-6905"
        ],
        "debtorName": "Cormac Byrne"
      },
      "paymentId": null,
      "reference": "CB-202511-6905",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zspeshspj7tfmtn8s05",
      "clustering": {
        "description": "Cormac Byrne",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cormac Byrne' based on payment details",
        "updatedAt": "2025-11-21T09:36:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cormac Byrne",
        "iban": "DE27267638777319440",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmj6j2t6vj9q",
      "createdAt": "2025-11-21T09:24:00.000Z",
      "updatedAt": "2025-11-21T09:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7176.97,
      "currency": "GBP",
      "description": "To Adrian Keller",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8aj42a2apez",
      "fspDate": "2025-11-21T08:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8aj42a2apez",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T08:24:00.000Z",
        "valueDateTime": "2025-11-21T08:24:00.000Z",
        "transactionAmount": {
          "amount": "-7176.97",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Adrian Keller",
        "remittanceInformationUnstructuredArray": [
          "To Adrian Keller"
        ],
        "debtorName": "Adrian Keller"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhncmfvhrjnjwn2hxwm55",
      "clustering": {
        "description": "Adrian Keller",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Adrian Keller' from 'To Adrian Keller'",
        "updatedAt": "2025-09-29T18:25:48.512Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xweshspedyw5sp5zkn",
      "createdAt": "2025-11-21T09:13:00.000Z",
      "updatedAt": "2025-11-21T09:13:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 1535.56,
      "currency": "EUR",
      "description": "Exchanged to USD Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k424mt19e4btmpfky36551a2",
      "fspDate": "2025-11-21T08:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k424mt19e4btmpfky36551a2",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T08:13:00.000Z",
        "valueDateTime": "2025-11-21T08:13:00.000Z",
        "transactionAmount": {
          "amount": "-1535.56",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to USD Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to USD Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name due to the 'EXCHANGE' transaction code.",
        "updatedAt": "2025-09-27T10:39:39.619Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspem75kvrz1w2",
      "createdAt": "2025-11-21T08:25:00.000Z",
      "updatedAt": "2025-11-21T08:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5314.9,
      "currency": "EUR",
      "description": "Payment to Eoin Kelleher: Aug 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gc1m61e8prm040r1a3sfh2",
      "fspDate": "2025-11-21T07:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc1m61e8prm040r1a3sfh2",
        "bookingDate": "2025-11-21",
        "valueDate": "2025-11-21",
        "bookingDateTime": "2025-11-21T07:25:00.000Z",
        "valueDateTime": "2025-11-21T07:25:00.000Z",
        "transactionAmount": {
          "amount": "-5314.90",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Eoin Kelleher: Aug 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Eoin Kelleher: Aug 2025 Payroll"
        ],
        "debtorName": "Eoin Kelleher"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zrteshspj73enyj46qt",
      "clustering": {
        "description": "Eoin Kelleher",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Eoin Kelleher' from 'Payment to Eoin Kelleher: Aug 2025 Payroll'",
        "updatedAt": "2025-09-27T10:40:26.854Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph0m64q49x7p",
      "createdAt": "2025-11-20T17:53:00.000Z",
      "updatedAt": "2025-11-20T17:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 992.47,
      "currency": "EUR",
      "description": "To Company Formations International Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1y137nmetg5",
      "fspDate": "2025-11-20T16:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1y137nmetg5",
        "bookingDate": "2025-11-20",
        "valueDate": "2025-11-20",
        "bookingDateTime": "2025-11-20T16:53:00.000Z",
        "valueDateTime": "2025-11-20T16:53:00.000Z",
        "transactionAmount": {
          "amount": "-992.47",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Company Formations International Limited",
        "remittanceInformationUnstructuredArray": [
          "To Company Formations International Limited"
        ],
        "debtorName": "Company Formations International Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cvstpeshspn39955xdf4m",
      "clustering": {
        "description": "Company Formations International",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Company Formations International' from 'To Company Formations International Limited', removing the 'Limited' suffix.",
        "updatedAt": "2025-09-27T10:54:12.573Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgde32zbtasr",
      "createdAt": "2025-11-20T17:31:00.000Z",
      "updatedAt": "2025-11-20T17:31:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 168.27,
      "currency": "EUR",
      "description": "linear.app",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1ajkjk3hdh1",
      "fspDate": "2025-11-20T16:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1ajkjk3hdh1",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T12:40:00.000Z",
        "valueDateTime": "2025-12-03T12:40:00.000Z",
        "transactionAmount": {
          "amount": "-168.27",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "linear.app",
        "remittanceInformationUnstructuredArray": [
          "linear.app"
        ],
        "debtorName": "Linear"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc1eshspj0mxd2vh6zx",
      "clustering": {
        "description": "Linear",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Linear' from 'linear.app'",
        "updatedAt": "2025-09-27T10:52:10.117Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7ehqhm364x0s90fgw4hqv7262x",
      "createdAt": "2025-11-20T16:46:00.000Z",
      "updatedAt": "2025-11-20T16:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 38.49,
      "currency": "GBP",
      "description": "Payment to Deliveroo: D-202511-3178",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_n0qj43xzc6sg9p4p78rgx1wtth",
      "fspDate": "2025-11-20T15:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_n0qj43xzc6sg9p4p78rgx1wtth",
        "bookingDate": "2025-11-20",
        "valueDate": "2025-11-20",
        "bookingDateTime": "2025-11-20T16:46:00.000Z",
        "valueDateTime": "2025-11-20T16:46:00.000Z",
        "transactionAmount": {
          "amount": "38.49",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Deliveroo: D-202511-3178",
        "remittanceInformationUnstructuredArray": [
          "Payment to Deliveroo",
          "D-202511-3178"
        ],
        "debtorName": "Deliveroo"
      },
      "paymentId": null,
      "reference": "D-202511-3178",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmcfvhrjp16bczghe88",
      "clustering": {
        "description": "Deliveroo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Deliveroo' based on payment details",
        "updatedAt": "2025-11-20T16:46:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Deliveroo",
        "iban": null,
        "bic": null,
        "sortCode": "114955",
        "accountNumber": "57286866"
      }
    },
    {
      "id": "txn_d5khah25scj4a35z5sjfvvpafm",
      "createdAt": "2025-11-20T16:32:00.000Z",
      "updatedAt": "2025-11-20T16:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1030.8,
      "currency": "GBP",
      "description": "Payment to Charles Russell Speechlys: CRS-202511-9670",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_sz65gya5a1esa4hd4xfem4fbnj",
      "fspDate": "2025-11-20T15:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_sz65gya5a1esa4hd4xfem4fbnj",
        "bookingDate": "2025-11-20",
        "valueDate": "2025-11-20",
        "bookingDateTime": "2025-11-20T16:32:00.000Z",
        "valueDateTime": "2025-11-20T16:32:00.000Z",
        "transactionAmount": {
          "amount": "1030.80",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Charles Russell Speechlys: CRS-202511-9670",
        "remittanceInformationUnstructuredArray": [
          "Payment to Charles Russell Speechlys",
          "CRS-202511-9670"
        ],
        "debtorName": "Charles Russell Speechlys"
      },
      "paymentId": null,
      "reference": "CRS-202511-9670",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgh1fvhrjp0n7wme8cae",
      "clustering": {
        "description": "Charles Russell Speechlys",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Charles Russell Speechlys' based on payment details",
        "updatedAt": "2025-11-20T16:32:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Charles Russell Speechlys",
        "iban": null,
        "bic": null,
        "sortCode": "846018",
        "accountNumber": "57955108"
      }
    },
    {
      "id": "txn_01k65c32xzeshspep4fhvrj5d2",
      "createdAt": "2025-11-20T12:46:00.000Z",
      "updatedAt": "2025-11-20T12:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 125,
      "currency": "EUR",
      "description": "Company Ultimate plan fee",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3dhf0y7eh2t1cyed5x8ajfj",
      "fspDate": "2025-11-20T11:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3dhf0y7eh2t1cyed5x8ajfj",
        "bookingDate": "2025-11-20",
        "valueDate": "2025-11-20",
        "bookingDateTime": "2025-11-20T11:46:00.000Z",
        "valueDateTime": "2025-11-20T11:46:00.000Z",
        "transactionAmount": {
          "amount": "-125.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Company Ultimate plan fee",
        "remittanceInformationUnstructuredArray": [
          "Company Ultimate plan fee"
        ],
        "debtorName": "Company"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mvseshspja4gsxz03at",
      "clustering": {
        "description": "Revolut Fees",
        "confidenceScore": "0.95",
        "rationale": "Extracted institution name 'Revolut' from 'Company Ultimate plan fee' and code: 'CHARGE'",
        "updatedAt": "2025-09-27T10:40:26.895Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_162328k8q9fstn5vm2g4n8aqne",
      "createdAt": "2025-11-20T12:29:00.000Z",
      "updatedAt": "2025-11-20T12:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.95,
      "currency": "EUR",
      "description": "Payment to Amba: A-202511-5789",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_c77fsycqtxefj83bqtn0hhvbq6",
      "fspDate": "2025-11-20T11:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_c77fsycqtxefj83bqtn0hhvbq6",
        "bookingDate": "2025-11-20",
        "valueDate": "2025-11-20",
        "bookingDateTime": "2025-11-20T12:29:00.000Z",
        "valueDateTime": "2025-11-20T12:29:00.000Z",
        "transactionAmount": {
          "amount": "20.95",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amba: A-202511-5789",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amba",
          "A-202511-5789"
        ],
        "debtorName": "Amba"
      },
      "paymentId": null,
      "reference": "A-202511-5789",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g1aeshsphp662hfbd17",
      "clustering": {
        "description": "Amba",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amba' based on payment details",
        "updatedAt": "2025-11-20T12:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amba",
        "iban": "DE93378907624481500",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y8eshsph843m0zfbsn",
      "createdAt": "2025-11-20T11:26:00.000Z",
      "updatedAt": "2025-11-20T11:26:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 45,
      "currency": "EUR",
      "description": "Frn*hold.free-Now.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg247ae8pvk26zeh1p7ns0",
      "fspDate": "2025-11-20T10:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg247ae8pvk26zeh1p7ns0",
        "bookingDate": "2025-11-20",
        "valueDate": "2025-11-20",
        "bookingDateTime": "2025-11-20T10:26:00.000Z",
        "valueDateTime": "2025-11-20T10:26:00.000Z",
        "transactionAmount": {
          "amount": "-45.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Frn*hold.free-Now.com",
        "remittanceInformationUnstructuredArray": [
          "Frn*hold.free-Now.com"
        ],
        "debtorName": "Free Now"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj31eshspnh3qzqhcd5r",
      "clustering": {
        "description": "Freenow",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Freenow' from 'Frn*hold.free-Now.com', removing the 'Frn*' prefix",
        "updatedAt": "2025-09-27T10:55:13.255Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wwcgexssvfv8n39ddb3dqtveyt",
      "createdAt": "2025-11-20T10:06:00.000Z",
      "updatedAt": "2025-11-20T10:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 36.5,
      "currency": "EUR",
      "description": "Payment to Dracula's Kitchen: DK-202511-2307",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_87d2b4r7b32178fzq4wvyejxys",
      "fspDate": "2025-11-20T09:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_87d2b4r7b32178fzq4wvyejxys",
        "bookingDate": "2025-11-20",
        "valueDate": "2025-11-20",
        "bookingDateTime": "2025-11-20T10:06:00.000Z",
        "valueDateTime": "2025-11-20T10:06:00.000Z",
        "transactionAmount": {
          "amount": "36.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Dracula's Kitchen: DK-202511-2307",
        "remittanceInformationUnstructuredArray": [
          "Payment to Dracula's Kitchen",
          "DK-202511-2307"
        ],
        "debtorName": "Dracula's Kitchen"
      },
      "paymentId": null,
      "reference": "DK-202511-2307",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcgeshspn9xska0mg5b",
      "clustering": {
        "description": "Dracula's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Dracula's Kitchen' based on payment details",
        "updatedAt": "2025-11-20T10:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Dracula's Kitchen",
        "iban": "DE62457679859795440",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmmy80yvsdgd",
      "createdAt": "2025-11-19T17:45:00.000Z",
      "updatedAt": "2025-11-19T17:45:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 579.7,
      "currency": "GBP",
      "description": "Ginger Bistro",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8cwfj5j59jx",
      "fspDate": "2025-11-19T16:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8cwfj5j59jx",
        "bookingDate": "2025-11-19",
        "valueDate": "2025-11-19",
        "bookingDateTime": "2025-11-19T16:45:00.000Z",
        "valueDateTime": "2025-11-19T16:45:00.000Z",
        "transactionAmount": {
          "amount": "-579.70",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Ginger Bistro",
        "remittanceInformationUnstructuredArray": [
          "Ginger Bistro"
        ],
        "debtorName": "Ginger Bistro"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk6skfvhrjntfdd23av1a",
      "clustering": {
        "description": "Ginger Bistro",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Ginger Bistro' from 'Ginger Bistro'",
        "updatedAt": "2025-09-29T18:25:48.610Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0fq22pwh7b869ppe1nc07b8p2f",
      "createdAt": "2025-11-19T14:08:00.000Z",
      "updatedAt": "2025-11-19T14:08:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 31177.12,
      "currency": "EUR",
      "description": "Payment from Nordic Digital AB - INV-202511-4072",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0e04q0xqdyc2mjk3qz2ra94w57",
      "fspDate": "2025-11-19T13:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0e04q0xqdyc2mjk3qz2ra94w57",
        "bookingDate": "2025-11-19",
        "valueDate": "2025-11-19",
        "bookingDateTime": "2025-11-19T14:08:00.000Z",
        "valueDateTime": "2025-11-19T14:08:00.000Z",
        "transactionAmount": {
          "amount": "31177.12",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nordic Digital AB - INV-202511-4072",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nordic Digital AB",
          "INV-202511-4072"
        ],
        "creditorName": "Nordic Digital AB"
      },
      "paymentId": null,
      "reference": "INV-202511-4072",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_q7sgetg8gwgf23ac9gdqmk8cz4",
      "clustering": {
        "description": "Nordic Digital AB",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nordic Digital AB'",
        "updatedAt": "2025-11-19T14:08:00.000Z"
      },
      "payer": {
        "name": "Nordic Digital AB",
        "iban": "DE45745853271356900",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmn41vt9neaj",
      "createdAt": "2025-11-19T11:33:00.000Z",
      "updatedAt": "2025-11-19T11:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 0.01,
      "currency": "GBP",
      "description": "SEAPOINT FINANCE  LIMITED. Payment from Seapoint Finance Uk Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8dptaj4j8es",
      "fspDate": "2025-11-19T10:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8dptaj4j8es",
        "bookingDate": "2025-11-19",
        "valueDate": "2025-11-19",
        "bookingDateTime": "2025-11-19T10:33:00.000Z",
        "valueDateTime": "2025-11-19T10:33:00.000Z",
        "transactionAmount": {
          "amount": "0.01",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Seapoint Finance Uk Limited",
        "remittanceInformationUnstructuredArray": [
          "Payment from Seapoint Finance Uk Limited"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance Uk Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the sender name 'Seapoint Finance Uk Limited' from 'Payment from Seapoint Finance Uk Limited'",
        "updatedAt": "2025-09-29T18:25:48.625Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspepkd7tm52hm",
      "createdAt": "2025-11-19T09:13:00.000Z",
      "updatedAt": "2025-11-19T09:13:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3az28h4eh2t0hda6yth632y",
      "fspDate": "2025-11-19T08:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3az28h4eh2t0hda6yth632y",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T16:00:00.000Z",
        "valueDateTime": "2026-01-09T16:00:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:40:26.905Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmrc9zgea808",
      "createdAt": "2025-11-18T13:33:00.000Z",
      "updatedAt": "2025-11-18T13:33:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 3.9,
      "currency": "GBP",
      "description": "Fcb Coffee Paddington",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8gqkjnnd0ft",
      "fspDate": "2025-11-18T12:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8gqkjnnd0ft",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T07:00:00.000Z",
        "valueDateTime": "2026-01-08T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-3.90",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Fcb Coffee Paddington",
        "remittanceInformationUnstructuredArray": [
          "Fcb Coffee Paddington"
        ],
        "debtorName": "FCB Coffee"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmmfvhrjp1d532dm1jy",
      "clustering": {
        "description": "FCB Coffee",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'FCB Coffee' from 'Fcb Coffee Paddington'",
        "updatedAt": "2025-09-29T18:26:40.968Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1wrebbgew6xe8mess6vjar2d7j",
      "createdAt": "2025-11-18T11:45:00.000Z",
      "updatedAt": "2025-11-18T11:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 34.62,
      "currency": "EUR",
      "description": "Payment to The Woolshed: TW-202511-3465",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4t648hn82tdj0ht2164r7s9fsk",
      "fspDate": "2025-11-18T10:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4t648hn82tdj0ht2164r7s9fsk",
        "bookingDate": "2025-11-18",
        "valueDate": "2025-11-18",
        "bookingDateTime": "2025-11-18T11:45:00.000Z",
        "valueDateTime": "2025-11-18T11:45:00.000Z",
        "transactionAmount": {
          "amount": "34.62",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Woolshed: TW-202511-3465",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Woolshed",
          "TW-202511-3465"
        ],
        "debtorName": "The Woolshed"
      },
      "paymentId": null,
      "reference": "TW-202511-3465",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1pkeshspm729w29ytag",
      "clustering": {
        "description": "The Woolshed",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Woolshed' based on payment details",
        "updatedAt": "2025-11-18T11:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Woolshed",
        "iban": "DE93603521441376320",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_g7b63hswys5wbscw56yxa58z7d",
      "createdAt": "2025-11-18T10:58:00.000Z",
      "updatedAt": "2025-11-18T10:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 116.76,
      "currency": "EUR",
      "description": "Payment to Naomi's Kitchen: NK-202511-5773",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_3k4e02hj1jyjev2wqm14wdz2gy",
      "fspDate": "2025-11-18T09:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_3k4e02hj1jyjev2wqm14wdz2gy",
        "bookingDate": "2025-11-18",
        "valueDate": "2025-11-18",
        "bookingDateTime": "2025-11-18T10:58:00.000Z",
        "valueDateTime": "2025-11-18T10:58:00.000Z",
        "transactionAmount": {
          "amount": "116.76",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Naomi's Kitchen: NK-202511-5773",
        "remittanceInformationUnstructuredArray": [
          "Payment to Naomi's Kitchen",
          "NK-202511-5773"
        ],
        "debtorName": "Naomi's Kitchen"
      },
      "paymentId": null,
      "reference": "NK-202511-5773",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh3deshspkhegxj7z9nq",
      "clustering": {
        "description": "Naomi's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Naomi's Kitchen' based on payment details",
        "updatedAt": "2025-11-18T10:58:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Naomi's Kitchen",
        "iban": "DE17551926191354248",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgw1050afcxq",
      "createdAt": "2025-11-18T10:46:00.000Z",
      "updatedAt": "2025-11-18T10:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1125.79,
      "currency": "EUR",
      "description": "Upwork -816283615ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1s2xvq0p8ts",
      "fspDate": "2025-11-18T09:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1s2xvq0p8ts",
        "bookingDate": "2025-11-18",
        "valueDate": "2025-11-18",
        "bookingDateTime": "2025-11-18T09:46:00.000Z",
        "valueDateTime": "2025-11-18T09:46:00.000Z",
        "transactionAmount": {
          "amount": "-1125.79",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -816283615ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -816283615ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Upwork' from the raw transaction description, removing the '-816283615ref' suffix.",
        "updatedAt": "2025-09-27T10:53:55.712Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph48pc286sdh",
      "createdAt": "2025-11-18T09:11:00.000Z",
      "updatedAt": "2025-11-18T09:11:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 10,
      "currency": "EUR",
      "description": "Mak Slim Foods",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk227a1amqsmj",
      "fspDate": "2025-11-18T08:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk227a1amqsmj",
        "bookingDate": "2025-11-18",
        "valueDate": "2025-11-18",
        "bookingDateTime": "2025-11-18T08:11:00.000Z",
        "valueDateTime": "2025-11-18T08:11:00.000Z",
        "transactionAmount": {
          "amount": "-10.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Mak Slim Foods",
        "remittanceInformationUnstructuredArray": [
          "Mak Slim Foods"
        ],
        "debtorName": "Mak Slim Foods"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2yeshspkgyzwx8hqrq",
      "clustering": {
        "description": "Mak Slim Foods",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Mak Slim Foods' from 'Mak Slim Foods'",
        "updatedAt": "2025-09-27T10:54:50.848Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm7hrwr9qvya",
      "createdAt": "2025-11-18T08:54:00.000Z",
      "updatedAt": "2025-11-18T08:54:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 3000,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1fr6fznfk0vs7efsjxgzh7w",
      "fspDate": "2025-11-18T07:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1fr6fznfk0vs7efsjxgzh7w",
        "bookingDate": "2025-11-18",
        "valueDate": "2025-11-18",
        "bookingDateTime": "2025-11-18T07:54:00.000Z",
        "valueDateTime": "2025-11-18T07:54:00.000Z",
        "transactionAmount": {
          "amount": "3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code and extracted 'Currency Exchange' as the description",
        "updatedAt": "2025-09-29T18:24:29.604Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_w250txtgawedr4ej35dtfcf785",
      "createdAt": "2025-11-17T15:29:00.000Z",
      "updatedAt": "2025-11-17T15:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 54636.48,
      "currency": "GBP",
      "description": "Payment from Enterprise Systems Inc - INV-202511-7920",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zv5vfcj8x0q1d02q4hftkrzmt4",
      "fspDate": "2025-11-17T14:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zv5vfcj8x0q1d02q4hftkrzmt4",
        "bookingDate": "2025-11-17",
        "valueDate": "2025-11-17",
        "bookingDateTime": "2025-11-17T15:29:00.000Z",
        "valueDateTime": "2025-11-17T15:29:00.000Z",
        "transactionAmount": {
          "amount": "54636.48",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Enterprise Systems Inc - INV-202511-7920",
        "remittanceInformationUnstructuredArray": [
          "Payment from Enterprise Systems Inc",
          "INV-202511-7920"
        ],
        "creditorName": "Enterprise Systems Inc"
      },
      "paymentId": null,
      "reference": "INV-202511-7920",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1jqt0xq8p3az0ed45aqq7npx6w",
      "clustering": {
        "description": "Enterprise Systems Inc",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Enterprise Systems Inc'",
        "updatedAt": "2025-11-17T15:29:00.000Z"
      },
      "payer": {
        "name": "Enterprise Systems Inc",
        "iban": null,
        "bic": null,
        "sortCode": "921246",
        "accountNumber": "93509371"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebzafvhrjmv5tv53cv6z",
      "createdAt": "2025-11-17T14:43:00.000Z",
      "updatedAt": "2025-11-17T14:43:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 262.58,
      "currency": "GBP",
      "description": "British Airways Plc",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8kh6afa9med",
      "fspDate": "2025-11-17T13:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8kh6afa9med",
        "bookingDate": "2025-12-10",
        "valueDate": "2025-12-10",
        "bookingDateTime": "2025-12-10T13:32:00.000Z",
        "valueDateTime": "2025-12-10T13:32:00.000Z",
        "transactionAmount": {
          "amount": "-262.58",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "British Airways Plc",
        "remittanceInformationUnstructuredArray": [
          "British Airways Plc"
        ],
        "debtorName": "British Airways"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9m2fvhrjp2hhm5q9efq",
      "clustering": {
        "description": "British Airways",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'British Airways' from 'British Airways Plc'",
        "updatedAt": "2025-09-29T18:27:23.722Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgsb4xvpncs4",
      "createdAt": "2025-11-17T14:35:00.000Z",
      "updatedAt": "2025-11-17T14:35:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 18,
      "currency": "EUR",
      "description": "Claude.ai Subscription",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1pb4kpxmya5",
      "fspDate": "2025-11-17T13:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1pb4kpxmya5",
        "bookingDate": "2025-11-17",
        "valueDate": "2025-11-17",
        "bookingDateTime": "2025-11-17T13:35:00.000Z",
        "valueDateTime": "2025-11-17T13:35:00.000Z",
        "transactionAmount": {
          "amount": "-18.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Claude.ai Subscription",
        "remittanceInformationUnstructuredArray": [
          "Claude.ai Subscription"
        ],
        "debtorName": "Claude.ai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5j1eshspjz017vq1wgn",
      "clustering": {
        "description": "Claude.ai",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Claude.ai' from the raw transaction description.",
        "updatedAt": "2025-09-27T10:53:55.640Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bt6hjmdy4ah9gn0j2kc9xqw19x",
      "createdAt": "2025-11-17T13:40:00.000Z",
      "updatedAt": "2025-11-17T13:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 132.13,
      "currency": "EUR",
      "description": "Payment to Slack: S-202511-9232",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_fyvrgjb88df0f5g7zc1v2pxdsm",
      "fspDate": "2025-11-17T12:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_fyvrgjb88df0f5g7zc1v2pxdsm",
        "bookingDate": "2025-11-17",
        "valueDate": "2025-11-17",
        "bookingDateTime": "2025-11-17T13:40:00.000Z",
        "valueDateTime": "2025-11-17T13:40:00.000Z",
        "transactionAmount": {
          "amount": "132.13",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack: S-202511-9232",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack",
          "S-202511-9232"
        ],
        "debtorName": "Slack"
      },
      "paymentId": null,
      "reference": "S-202511-9232",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtb9eshspk6e4wt4npvh",
      "clustering": {
        "description": "Slack",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack' based on payment details",
        "updatedAt": "2025-11-17T13:40:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack",
        "iban": "DE41529062818345384",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_t671nteaxzdj7e0y7y4bq4e5fp",
      "createdAt": "2025-11-17T11:21:00.000Z",
      "updatedAt": "2025-11-17T11:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2182.52,
      "currency": "EUR",
      "description": "Payment to Patrick Walsh: PW-202511-1322",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_r4spcf7n18v4v4rre0x78kv6se",
      "fspDate": "2025-11-17T10:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_r4spcf7n18v4v4rre0x78kv6se",
        "bookingDate": "2025-11-17",
        "valueDate": "2025-11-17",
        "bookingDateTime": "2025-11-17T11:21:00.000Z",
        "valueDateTime": "2025-11-17T11:21:00.000Z",
        "transactionAmount": {
          "amount": "2182.52",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Patrick Walsh: PW-202511-1322",
        "remittanceInformationUnstructuredArray": [
          "Payment to Patrick Walsh",
          "PW-202511-1322"
        ],
        "debtorName": "Patrick Walsh"
      },
      "paymentId": null,
      "reference": "PW-202511-1322",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqmzweshspm8kq27v8562",
      "clustering": {
        "description": "Patrick Walsh",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Patrick Walsh' based on payment details",
        "updatedAt": "2025-11-17T11:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Patrick Walsh",
        "iban": "DE15645342333656054",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgrhwv49904c",
      "createdAt": "2025-11-17T11:02:00.000Z",
      "updatedAt": "2025-11-17T11:02:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 69,
      "currency": "EUR",
      "description": "Financial Times",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1n23tvd5cx5",
      "fspDate": "2025-11-17T10:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1n23tvd5cx5",
        "bookingDate": "2025-11-17",
        "valueDate": "2025-11-17",
        "bookingDateTime": "2025-11-17T10:02:00.000Z",
        "valueDateTime": "2025-11-17T10:02:00.000Z",
        "transactionAmount": {
          "amount": "-69.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Financial Times",
        "remittanceInformationUnstructuredArray": [
          "Financial Times"
        ],
        "debtorName": "Financial Times"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gjeshspjygqrrg6sk5",
      "clustering": {
        "description": "Financial Times",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Financial Times' from the raw transaction record.",
        "updatedAt": "2025-09-27T10:54:14.174Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshspgyzqvn9tssy",
      "createdAt": "2025-11-17T10:14:00.000Z",
      "updatedAt": "2025-11-17T10:14:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1w3kvmx68kb",
      "fspDate": "2025-11-17T09:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1w3kvmx68kb",
        "bookingDate": "2025-11-17",
        "valueDate": "2025-11-17",
        "bookingDateTime": "2025-11-17T09:14:00.000Z",
        "valueDateTime": "2025-11-17T09:14:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:54:12.531Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_t07zhjsz5xh3j5086d10qkem7v",
      "createdAt": "2025-11-16T16:43:00.000Z",
      "updatedAt": "2025-11-16T16:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1882.48,
      "currency": "EUR",
      "description": "Payment to Bank of Ireland: BOI-202511-7968",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1ws8q7mjcg57hkz3zyycdvs51j",
      "fspDate": "2025-11-16T15:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1ws8q7mjcg57hkz3zyycdvs51j",
        "bookingDate": "2025-11-16",
        "valueDate": "2025-11-16",
        "bookingDateTime": "2025-11-16T16:43:00.000Z",
        "valueDateTime": "2025-11-16T16:43:00.000Z",
        "transactionAmount": {
          "amount": "1882.48",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bank of Ireland: BOI-202511-7968",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bank of Ireland",
          "BOI-202511-7968"
        ],
        "debtorName": "Bank of Ireland"
      },
      "paymentId": null,
      "reference": "BOI-202511-7968",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a24eshspnzbnpcam1v1",
      "clustering": {
        "description": "Bank of Ireland",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bank of Ireland' based on payment details",
        "updatedAt": "2025-11-16T16:43:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bank of Ireland",
        "iban": "DE33119309147370140",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xxeshspee4ky35tqr2",
      "createdAt": "2025-11-16T15:41:00.000Z",
      "updatedAt": "2025-11-16T15:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6667,
      "currency": "EUR",
      "description": "Payment to Jonas Novak: 2025-00003",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k422n4wresm9g50gvktgk21d",
      "fspDate": "2025-11-16T14:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k422n4wresm9g50gvktgk21d",
        "bookingDate": "2025-11-16",
        "valueDate": "2025-11-16",
        "bookingDateTime": "2025-11-16T14:41:00.000Z",
        "valueDateTime": "2025-11-16T14:41:00.000Z",
        "transactionAmount": {
          "amount": "-6667.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jonas Novak: 2025-00003",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jonas Novak: 2025-00003"
        ],
        "debtorName": "Jonas Novak"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x01eshsphmk5k2axdrt",
      "clustering": {
        "description": "Jonas Novak",
        "confidenceScore": "0.95",
        "rationale": "Extracted core name 'Jonas Novak' from 'Payment to Jonas Novak: 2025-00003', removing 'Payment to ' prefix.",
        "updatedAt": "2025-09-27T10:39:39.624Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5sfp23aeezbscp593pzfghyjqt",
      "createdAt": "2025-11-16T15:06:00.000Z",
      "updatedAt": "2025-11-16T15:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 164.07,
      "currency": "GBP",
      "description": "Payment to Aer Lingus: AL-202511-7132",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w1wbcp3dssms7fgnktcrkqzgpq",
      "fspDate": "2025-11-16T14:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w1wbcp3dssms7fgnktcrkqzgpq",
        "bookingDate": "2025-11-16",
        "valueDate": "2025-11-16",
        "bookingDateTime": "2025-11-16T15:06:00.000Z",
        "valueDateTime": "2025-11-16T15:06:00.000Z",
        "transactionAmount": {
          "amount": "164.07",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Aer Lingus: AL-202511-7132",
        "remittanceInformationUnstructuredArray": [
          "Payment to Aer Lingus",
          "AL-202511-7132"
        ],
        "debtorName": "Aer Lingus"
      },
      "paymentId": null,
      "reference": "AL-202511-7132",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnekfvhrjnk2qd4ej2sf",
      "clustering": {
        "description": "Aer Lingus",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Aer Lingus' based on payment details",
        "updatedAt": "2025-11-16T15:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Aer Lingus",
        "iban": null,
        "bic": null,
        "sortCode": "222233",
        "accountNumber": "39911372"
      }
    },
    {
      "id": "txn_gj7vhpw4r76kjc9446xv90sgf5",
      "createdAt": "2025-11-16T14:55:00.000Z",
      "updatedAt": "2025-11-16T14:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 34893.92,
      "currency": "GBP",
      "description": "Payment from Global Solutions Ltd - INV-202511-2046",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_53wf17p0a0cj3sdb59vtbpe936",
      "fspDate": "2025-11-16T13:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_53wf17p0a0cj3sdb59vtbpe936",
        "bookingDate": "2025-11-16",
        "valueDate": "2025-11-16",
        "bookingDateTime": "2025-11-16T14:55:00.000Z",
        "valueDateTime": "2025-11-16T14:55:00.000Z",
        "transactionAmount": {
          "amount": "34893.92",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Global Solutions Ltd - INV-202511-2046",
        "remittanceInformationUnstructuredArray": [
          "Payment from Global Solutions Ltd",
          "INV-202511-2046"
        ],
        "creditorName": "Global Solutions Ltd"
      },
      "paymentId": null,
      "reference": "INV-202511-2046",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_th3hfveyjxh2erds1n633s02yd",
      "clustering": {
        "description": "Global Solutions Ltd",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Global Solutions Ltd'",
        "updatedAt": "2025-11-16T14:55:00.000Z"
      },
      "payer": {
        "name": "Global Solutions Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "982306",
        "accountNumber": "85203014"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jnqjqxgzab5wfz8h7cj6hx711v",
      "createdAt": "2025-11-16T11:48:00.000Z",
      "updatedAt": "2025-11-16T11:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.71,
      "currency": "EUR",
      "description": "Payment to Marquette: M-202511-8719",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gh3bxb9r1a76d0662www3xtyr1",
      "fspDate": "2025-11-16T10:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gh3bxb9r1a76d0662www3xtyr1",
        "bookingDate": "2025-11-16",
        "valueDate": "2025-11-16",
        "bookingDateTime": "2025-11-16T11:48:00.000Z",
        "valueDateTime": "2025-11-16T11:48:00.000Z",
        "transactionAmount": {
          "amount": "14.71",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marquette: M-202511-8719",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marquette",
          "M-202511-8719"
        ],
        "debtorName": "Marquette"
      },
      "paymentId": null,
      "reference": "M-202511-8719",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1npeshspm6wcf3gtsdh",
      "clustering": {
        "description": "Marquette",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marquette' based on payment details",
        "updatedAt": "2025-11-16T11:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marquette",
        "iban": "DE84383144582762430",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfkhd80xvrmy",
      "createdAt": "2025-11-16T08:42:00.000Z",
      "updatedAt": "2025-11-16T08:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.5,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0nzyjtafq9r6nneg248mrep",
      "fspDate": "2025-11-16T07:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0nzyjtafq9r6nneg248mrep",
        "bookingDate": "2025-11-16",
        "valueDate": "2025-11-16",
        "bookingDateTime": "2025-11-16T07:42:00.000Z",
        "valueDateTime": "2025-11-16T07:42:00.000Z",
        "transactionAmount": {
          "amount": "-17.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cursor' from 'Cursor, Ai Powered Ide', removing the ', Ai Powered Ide' suffix",
        "updatedAt": "2025-09-27T10:49:04.334Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg8ncx51p5jc",
      "createdAt": "2025-11-16T08:41:00.000Z",
      "updatedAt": "2025-11-16T08:41:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 2336.61,
      "currency": "EUR",
      "description": "Exchanged to EUR Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk16hzhtwrxse",
      "fspDate": "2025-11-16T07:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk16hzhtwrxse",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T08:00:00.000Z",
        "valueDateTime": "2026-01-07T08:00:00.000Z",
        "transactionAmount": {
          "amount": "2336.61",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to EUR Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to EUR Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the currency conversion transaction with code 'EXCHANGE'.",
        "updatedAt": "2025-09-27T10:51:38.287Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_t2b8r77qzd7apbbpmmtrp0mts8",
      "createdAt": "2025-11-15T16:40:00.000Z",
      "updatedAt": "2025-11-15T16:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1.84,
      "currency": "GBP",
      "description": "Payment to Mylands: M-202511-2270",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1fdptp6w8g1sgpfwe1h97e1zx0",
      "fspDate": "2025-11-15T15:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1fdptp6w8g1sgpfwe1h97e1zx0",
        "bookingDate": "2025-11-15",
        "valueDate": "2025-11-15",
        "bookingDateTime": "2025-11-15T16:40:00.000Z",
        "valueDateTime": "2025-11-15T16:40:00.000Z",
        "transactionAmount": {
          "amount": "1.84",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mylands: M-202511-2270",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mylands",
          "M-202511-2270"
        ],
        "debtorName": "Mylands"
      },
      "paymentId": null,
      "reference": "M-202511-2270",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbnxzzfvhrjp5np8trhg47",
      "clustering": {
        "description": "Mylands",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mylands' based on payment details",
        "updatedAt": "2025-11-15T16:40:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mylands",
        "iban": null,
        "bic": null,
        "sortCode": "627592",
        "accountNumber": "39334741"
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm678qcwtfyw",
      "createdAt": "2025-11-15T16:24:00.000Z",
      "updatedAt": "2025-11-15T16:24:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 2800,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k21rpzyzf2181bvdrtrt3y6q",
      "fspDate": "2025-11-15T15:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k21rpzyzf2181bvdrtrt3y6q",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T16:12:00.000Z",
        "valueDateTime": "2025-12-28T16:12:00.000Z",
        "transactionAmount": {
          "amount": "2800.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.904Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph01mpv5bx5t",
      "createdAt": "2025-11-15T14:26:00.000Z",
      "updatedAt": "2025-11-15T14:26:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 70,
      "currency": "EUR",
      "description": "Retool",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1ytk1gjjv42",
      "fspDate": "2025-11-15T13:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1ytk1gjjv42",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T07:00:00.000Z",
        "valueDateTime": "2026-01-04T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-70.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Retool",
        "remittanceInformationUnstructuredArray": [
          "Retool"
        ],
        "debtorName": "Retool"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdp6eshspk9a3b1e6677",
      "clustering": {
        "description": "Retool",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Retool' from 'Retool'.",
        "updatedAt": "2025-09-27T10:54:12.563Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vkqxeqexf5h6v6z1qtzcr0spwj",
      "createdAt": "2025-11-15T14:10:00.000Z",
      "updatedAt": "2025-11-15T14:10:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.2,
      "currency": "EUR",
      "description": "Payment to Don Canizales: DC-202511-7831",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qkagnvhbpzf4wvtejhhzkr6dnp",
      "fspDate": "2025-11-15T13:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qkagnvhbpzf4wvtejhhzkr6dnp",
        "bookingDate": "2025-11-15",
        "valueDate": "2025-11-15",
        "bookingDateTime": "2025-11-15T14:10:00.000Z",
        "valueDateTime": "2025-11-15T14:10:00.000Z",
        "transactionAmount": {
          "amount": "14.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Don Canizales: DC-202511-7831",
        "remittanceInformationUnstructuredArray": [
          "Payment to Don Canizales",
          "DC-202511-7831"
        ],
        "debtorName": "Don Canizales"
      },
      "paymentId": null,
      "reference": "DC-202511-7831",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "clustering": {
        "description": "Don Canizales",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Don Canizales' based on payment details",
        "updatedAt": "2025-11-15T14:10:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Don Canizales",
        "iban": "DE61930123541814950",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_rzjycq4kzj8zr56y196ksq5szt",
      "createdAt": "2025-11-15T09:29:00.000Z",
      "updatedAt": "2025-11-15T09:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 529.59,
      "currency": "GBP",
      "description": "Payment to Slack Technologies Limited: STL-202511-6021",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ypz7qwgckn480zrvsx39aj6d9f",
      "fspDate": "2025-11-15T08:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ypz7qwgckn480zrvsx39aj6d9f",
        "bookingDate": "2025-11-15",
        "valueDate": "2025-11-15",
        "bookingDateTime": "2025-11-15T09:29:00.000Z",
        "valueDateTime": "2025-11-15T09:29:00.000Z",
        "transactionAmount": {
          "amount": "529.59",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack Technologies Limited: STL-202511-6021",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack Technologies Limited",
          "STL-202511-6021"
        ],
        "debtorName": "Slack Technologies Limited"
      },
      "paymentId": null,
      "reference": "STL-202511-6021",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_6m3t4s5pcz3g5997sxc586yj3f",
      "clustering": {
        "description": "Slack Technologies Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack Technologies Limited' based on payment details",
        "updatedAt": "2025-11-15T09:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack Technologies Limited",
        "iban": null,
        "bic": null,
        "sortCode": "954128",
        "accountNumber": "51455315"
      }
    },
    {
      "id": "txn_01k65c32y4eshspg02pbdy40b4",
      "createdAt": "2025-11-15T08:31:00.000Z",
      "updatedAt": "2025-11-15T08:31:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 42.5,
      "currency": "EUR",
      "description": "Ubr* Pending.uber.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0wm64dn8e0d",
      "fspDate": "2025-11-15T07:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0wm64dn8e0d",
        "bookingDate": "2025-11-15",
        "valueDate": "2025-11-15",
        "bookingDateTime": "2025-11-15T07:31:00.000Z",
        "valueDateTime": "2025-11-15T07:31:00.000Z",
        "transactionAmount": {
          "amount": "-42.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Ubr* Pending.uber.com",
        "remittanceInformationUnstructuredArray": [
          "Ubr* Pending.uber.com"
        ],
        "debtorName": "Uber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Uber",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Uber' from 'Ubr* Pending.uber.com', removing 'Ubr* ' prefix",
        "updatedAt": "2025-09-27T10:50:52.318Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfvxg58p0vz6",
      "createdAt": "2025-11-14T14:35:00.000Z",
      "updatedAt": "2025-11-14T14:35:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 18,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0s7bdgx9nqc",
      "fspDate": "2025-11-14T13:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0s7bdgx9nqc",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T13:00:00.000Z",
        "valueDateTime": "2026-01-04T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-18.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Burger Cartel' from 'Burger Cartel Limited'",
        "updatedAt": "2025-09-27T10:50:08.341Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6td54ab9szg4atv16x1179k3sx",
      "createdAt": "2025-11-14T13:08:00.000Z",
      "updatedAt": "2025-11-14T13:08:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 337.75,
      "currency": "EUR",
      "description": "Payment to Bang Restaurant: BR-202511-3762",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rp0ydb8rgfbpjx2xs6g6ddmssa",
      "fspDate": "2025-11-14T12:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rp0ydb8rgfbpjx2xs6g6ddmssa",
        "bookingDate": "2025-11-14",
        "valueDate": "2025-11-14",
        "bookingDateTime": "2025-11-14T13:08:00.000Z",
        "valueDateTime": "2025-11-14T13:08:00.000Z",
        "transactionAmount": {
          "amount": "337.75",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bang Restaurant: BR-202511-3762",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bang Restaurant",
          "BR-202511-3762"
        ],
        "debtorName": "Bang Restaurant"
      },
      "paymentId": null,
      "reference": "BR-202511-3762",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpk3eshspmfgtm6vkpxj",
      "clustering": {
        "description": "Bang Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bang Restaurant' based on payment details",
        "updatedAt": "2025-11-14T13:08:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bang Restaurant",
        "iban": "DE85765058651267800",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgwe54j505jt",
      "createdAt": "2025-11-14T12:15:00.000Z",
      "updatedAt": "2025-11-14T12:15:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1sv1vzp520q",
      "fspDate": "2025-11-14T11:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1sv1vzp520q",
        "bookingDate": "2025-12-14",
        "valueDate": "2025-12-14",
        "bookingDateTime": "2025-12-14T11:22:00.000Z",
        "valueDateTime": "2025-12-14T11:22:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Coffee Angel' from the raw transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:53:55.716Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspevt48e80hxk",
      "createdAt": "2025-11-14T11:37:00.000Z",
      "updatedAt": "2025-11-14T11:37:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 28,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2ry974re009pf8hpq2e4byv",
      "fspDate": "2025-11-14T10:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ry974re009pf8hpq2e4byv",
        "bookingDate": "2025-11-14",
        "valueDate": "2025-11-14",
        "bookingDateTime": "2025-11-14T10:37:00.000Z",
        "valueDateTime": "2025-11-14T10:37:00.000Z",
        "transactionAmount": {
          "amount": "-28.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Burger Cartel' from the 'Burger Cartel Limited' transaction description.",
        "updatedAt": "2025-09-27T10:41:48.257Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmkvccv4dpt6",
      "createdAt": "2025-11-14T09:42:00.000Z",
      "updatedAt": "2025-11-14T09:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 6.4,
      "currency": "GBP",
      "description": "Pret A Manger Ni002 Be",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8cbmsmzzkqz",
      "fspDate": "2025-11-14T08:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8cbmsmzzkqz",
        "bookingDate": "2025-12-12",
        "valueDate": "2025-12-12",
        "bookingDateTime": "2025-12-12T07:57:00.000Z",
        "valueDateTime": "2025-12-12T07:57:00.000Z",
        "transactionAmount": {
          "amount": "-6.40",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Pret A Manger Ni002 Be",
        "remittanceInformationUnstructuredArray": [
          "Pret A Manger Ni002 Be"
        ],
        "debtorName": "Pret A Manger"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crphqeshspmfftkxpt85b",
      "clustering": {
        "description": "Pret A Manger",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Pret A Manger' from 'Pret A Manger Ni002 Be'",
        "updatedAt": "2025-09-29T18:25:48.575Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgkpzzsk1k1p",
      "createdAt": "2025-11-14T09:17:00.000Z",
      "updatedAt": "2025-11-14T09:17:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 85.14,
      "currency": "EUR",
      "description": "Paddle.net* Open Excha",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1gnwyc696f1",
      "fspDate": "2025-11-14T08:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1gnwyc696f1",
        "bookingDate": "2025-11-14",
        "valueDate": "2025-11-14",
        "bookingDateTime": "2025-11-14T08:17:00.000Z",
        "valueDateTime": "2025-11-14T08:17:00.000Z",
        "transactionAmount": {
          "amount": "-85.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Paddle.net* Open Excha",
        "remittanceInformationUnstructuredArray": [
          "Paddle.net* Open Excha"
        ],
        "debtorName": "Paddle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax3veshspjmhphswafsq",
      "clustering": {
        "description": "Paddle",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Paddle' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.070Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfm2m03q3tfz",
      "createdAt": "2025-11-14T08:07:00.000Z",
      "updatedAt": "2025-11-14T08:07:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.5,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0nzyjtcfq9r6nnxyxpmnew1",
      "fspDate": "2025-11-14T07:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0nzyjtcfq9r6nnxyxpmnew1",
        "bookingDate": "2025-12-09",
        "valueDate": "2025-12-09",
        "bookingDateTime": "2025-12-09T14:27:00.000Z",
        "valueDateTime": "2025-12-09T14:27:00.000Z",
        "transactionAmount": {
          "amount": "-17.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cursor' from 'Cursor, Ai Powered Ide', removing the ', Ai Powered Ide' suffix",
        "updatedAt": "2025-09-27T10:49:04.347Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgbd8y17fxf1",
      "createdAt": "2025-11-13T17:47:00.000Z",
      "updatedAt": "2025-11-13T17:47:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 16,
      "currency": "EUR",
      "description": "Cafe And Noodle",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk18mtrp9rm56",
      "fspDate": "2025-11-13T16:47:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk18mtrp9rm56",
        "bookingDate": "2025-11-13",
        "valueDate": "2025-11-13",
        "bookingDateTime": "2025-11-13T16:47:00.000Z",
        "valueDateTime": "2025-11-13T16:47:00.000Z",
        "transactionAmount": {
          "amount": "-16.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cafe And Noodle",
        "remittanceInformationUnstructuredArray": [
          "Cafe And Noodle"
        ],
        "debtorName": "Cafe And Noodle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpd8eshspmwjjpzayxx2",
      "clustering": {
        "description": "Cafe And Noodle",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cafe And Noodle' from 'Cafe And Noodle'",
        "updatedAt": "2025-09-27T10:52:10.016Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gkz2kq2dsrggqsf88exzcaqbqv",
      "createdAt": "2025-11-13T12:39:00.000Z",
      "updatedAt": "2025-11-13T12:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2.24,
      "currency": "EUR",
      "description": "Payment to Merrion Row Post Office: MRP-202511-6090",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2yck4kr01wtd219q8rh5fbe8h1",
      "fspDate": "2025-11-13T11:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2yck4kr01wtd219q8rh5fbe8h1",
        "bookingDate": "2025-11-13",
        "valueDate": "2025-11-13",
        "bookingDateTime": "2025-11-13T12:39:00.000Z",
        "valueDateTime": "2025-11-13T12:39:00.000Z",
        "transactionAmount": {
          "amount": "2.24",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Merrion Row Post Office: MRP-202511-6090",
        "remittanceInformationUnstructuredArray": [
          "Payment to Merrion Row Post Office",
          "MRP-202511-6090"
        ],
        "debtorName": "Merrion Row Post Office"
      },
      "paymentId": null,
      "reference": "MRP-202511-6090",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj0neshspngm4dw1pq8h",
      "clustering": {
        "description": "Merrion Row Post Office",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Merrion Row Post Office' based on payment details",
        "updatedAt": "2025-11-13T12:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Merrion Row Post Office",
        "iban": "DE96097027450508740",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmpnj3sa2k75",
      "createdAt": "2025-11-13T11:16:00.000Z",
      "updatedAt": "2025-11-13T11:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 11409.97,
      "currency": "GBP",
      "description": "To Emily Harrington",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8f4yzkvtfr6",
      "fspDate": "2025-11-13T10:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8f4yzkvtfr6",
        "bookingDate": "2025-11-13",
        "valueDate": "2025-11-13",
        "bookingDateTime": "2025-11-13T10:16:00.000Z",
        "valueDateTime": "2025-11-13T10:16:00.000Z",
        "transactionAmount": {
          "amount": "-11409.97",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Emily Harrington",
        "remittanceInformationUnstructuredArray": [
          "To Emily Harrington"
        ],
        "debtorName": "Emily Harrington"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnawfvhrjnjkdggymq9f",
      "clustering": {
        "description": "Emily Harrington",
        "confidenceScore": "0.95",
        "rationale": "Extracted core name 'Emily Harrington' from 'To Emily Harrington'",
        "updatedAt": "2025-09-29T18:26:40.941Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gv4q37gt6zk2s9rzx2cagybzdh",
      "createdAt": "2025-11-13T10:41:00.000Z",
      "updatedAt": "2025-11-13T10:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4763.46,
      "currency": "GBP",
      "description": "Payment to WealthKernel: W-202511-3746",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vec4p777xj564a0kgsjgmy8g22",
      "fspDate": "2025-11-13T09:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vec4p777xj564a0kgsjgmy8g22",
        "bookingDate": "2025-11-13",
        "valueDate": "2025-11-13",
        "bookingDateTime": "2025-11-13T10:41:00.000Z",
        "valueDateTime": "2025-11-13T10:41:00.000Z",
        "transactionAmount": {
          "amount": "4763.46",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to WealthKernel: W-202511-3746",
        "remittanceInformationUnstructuredArray": [
          "Payment to WealthKernel",
          "W-202511-3746"
        ],
        "debtorName": "WealthKernel"
      },
      "paymentId": null,
      "reference": "W-202511-3746",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhng0fvhrjnk93frdx83x",
      "clustering": {
        "description": "WealthKernel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'WealthKernel' based on payment details",
        "updatedAt": "2025-11-13T10:41:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "WealthKernel",
        "iban": null,
        "bic": null,
        "sortCode": "964212",
        "accountNumber": "86186246"
      }
    },
    {
      "id": "txn_01k65c32y0eshspezrcvggbny3",
      "createdAt": "2025-11-12T16:50:00.000Z",
      "updatedAt": "2025-11-12T16:50:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 103.04,
      "currency": "EUR",
      "description": "Superhuman",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2empapqfk7s2z16b9gexx1g",
      "fspDate": "2025-11-12T15:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2empapqfk7s2z16b9gexx1g",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T09:00:00.000Z",
        "valueDateTime": "2026-01-09T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-103.04",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Superhuman",
        "remittanceInformationUnstructuredArray": [
          "Superhuman"
        ],
        "debtorName": "Superhuman"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5mceshspjzn83y9tqy1",
      "clustering": {
        "description": "Superhuman",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Superhuman' from 'Superhuman'",
        "updatedAt": "2025-09-27T10:42:40.419Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_q469fxkwzqmbq69k1e9n9dpm3e",
      "createdAt": "2025-11-12T16:17:00.000Z",
      "updatedAt": "2025-11-12T16:17:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 42.84,
      "currency": "EUR",
      "description": "Payment to Heathrow Express: HE-202511-7798",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9twd166a70t7xy7b7acrzd8ar3",
      "fspDate": "2025-11-12T15:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9twd166a70t7xy7b7acrzd8ar3",
        "bookingDate": "2025-11-12",
        "valueDate": "2025-11-12",
        "bookingDateTime": "2025-11-12T16:17:00.000Z",
        "valueDateTime": "2025-11-12T16:17:00.000Z",
        "transactionAmount": {
          "amount": "42.84",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Heathrow Express: HE-202511-7798",
        "remittanceInformationUnstructuredArray": [
          "Payment to Heathrow Express",
          "HE-202511-7798"
        ],
        "debtorName": "Heathrow Express"
      },
      "paymentId": null,
      "reference": "HE-202511-7798",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpg2eshspmf0nznfw91y",
      "clustering": {
        "description": "Heathrow Express",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Heathrow Express' based on payment details",
        "updatedAt": "2025-11-12T16:17:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Heathrow Express",
        "iban": "DE26373395967707360",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_k0s1x4wm4bnmcagj4t7nw36swg",
      "createdAt": "2025-11-12T15:32:00.000Z",
      "updatedAt": "2025-11-12T15:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 41938.79,
      "currency": "GBP",
      "description": "Payment from TechCorp Industries - INV-202511-1859",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ywmd12qktg9f2esdq8evmabc07",
      "fspDate": "2025-11-12T14:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ywmd12qktg9f2esdq8evmabc07",
        "bookingDate": "2025-11-12",
        "valueDate": "2025-11-12",
        "bookingDateTime": "2025-11-12T15:32:00.000Z",
        "valueDateTime": "2025-11-12T15:32:00.000Z",
        "transactionAmount": {
          "amount": "41938.79",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from TechCorp Industries - INV-202511-1859",
        "remittanceInformationUnstructuredArray": [
          "Payment from TechCorp Industries",
          "INV-202511-1859"
        ],
        "creditorName": "TechCorp Industries"
      },
      "paymentId": null,
      "reference": "INV-202511-1859",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_hkz708jvra375hd19t65j65vvt",
      "clustering": {
        "description": "TechCorp Industries",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'TechCorp Industries'",
        "updatedAt": "2025-11-12T15:32:00.000Z"
      },
      "payer": {
        "name": "TechCorp Industries",
        "iban": null,
        "bic": null,
        "sortCode": "836526",
        "accountNumber": "67700332"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bf52axq1yw37yn6a47dp5vq9ha",
      "createdAt": "2025-11-12T14:35:00.000Z",
      "updatedAt": "2025-11-12T14:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4197.94,
      "currency": "GBP",
      "description": "Payment to Amazon Web Services EMEA SARL: AWS-202511-5735",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vpzsfpz4z5640mxt3t0xbk0vz1",
      "fspDate": "2025-11-12T13:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vpzsfpz4z5640mxt3t0xbk0vz1",
        "bookingDate": "2025-11-12",
        "valueDate": "2025-11-12",
        "bookingDateTime": "2025-11-12T14:35:00.000Z",
        "valueDateTime": "2025-11-12T14:35:00.000Z",
        "transactionAmount": {
          "amount": "4197.94",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amazon Web Services EMEA SARL: AWS-202511-5735",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amazon Web Services EMEA SARL",
          "AWS-202511-5735"
        ],
        "debtorName": "Amazon Web Services EMEA SARL"
      },
      "paymentId": null,
      "reference": "AWS-202511-5735",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_zj7v3fq41pb9h3pwx6cbzwmfx4",
      "clustering": {
        "description": "Amazon Web Services EMEA SARL",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amazon Web Services EMEA SARL' based on payment details",
        "updatedAt": "2025-11-12T14:35:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amazon Web Services EMEA SARL",
        "iban": null,
        "bic": null,
        "sortCode": "728828",
        "accountNumber": "82454509"
      }
    },
    {
      "id": "txn_01k65c32y1eshspf5tv5dqsz82",
      "createdAt": "2025-11-12T12:46:00.000Z",
      "updatedAt": "2025-11-12T12:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 385.54,
      "currency": "EUR",
      "description": "Google Gsuite_seapoint",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1mwq45xexy9b7q9q3e45y5h",
      "fspDate": "2025-11-12T11:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1mwq45xexy9b7q9q3e45y5h",
        "bookingDate": "2025-11-12",
        "valueDate": "2025-11-12",
        "bookingDateTime": "2025-11-12T11:46:00.000Z",
        "valueDateTime": "2025-11-12T11:46:00.000Z",
        "transactionAmount": {
          "amount": "-385.54",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Google Gsuite_seapoint",
        "remittanceInformationUnstructuredArray": [
          "Google Gsuite_seapoint"
        ],
        "debtorName": "Google"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdrteshspka3qwhrnts0",
      "clustering": {
        "description": "Google",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Google' from the transaction description, removing the 'Gsuite_seapoint' suffix.",
        "updatedAt": "2025-09-27T10:43:55.574Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pkxndy5ce64285smgtez84gzmx",
      "createdAt": "2025-11-12T12:32:00.000Z",
      "updatedAt": "2025-11-12T12:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 91.3,
      "currency": "GBP",
      "description": "Payment to Clayton Hotel Belfast: CHB-202511-2967",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_69zc1xqh5e1psc6zwtcn1nfvhy",
      "fspDate": "2025-11-12T11:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_69zc1xqh5e1psc6zwtcn1nfvhy",
        "bookingDate": "2025-11-12",
        "valueDate": "2025-11-12",
        "bookingDateTime": "2025-11-12T12:32:00.000Z",
        "valueDateTime": "2025-11-12T12:32:00.000Z",
        "transactionAmount": {
          "amount": "91.30",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Belfast: CHB-202511-2967",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Belfast",
          "CHB-202511-2967"
        ],
        "debtorName": "Clayton Hotel Belfast"
      },
      "paymentId": null,
      "reference": "CHB-202511-2967",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4hyfvhrjnt1zqpqqyns",
      "clustering": {
        "description": "Clayton Hotel Belfast",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Belfast' based on payment details",
        "updatedAt": "2025-11-12T12:32:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Belfast",
        "iban": null,
        "bic": null,
        "sortCode": "417754",
        "accountNumber": "30864347"
      }
    },
    {
      "id": "txn_01k65c32y6eshspgnpx4sdqhws",
      "createdAt": "2025-11-12T12:28:00.000Z",
      "updatedAt": "2025-11-12T12:28:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Sq *mama?s Boy",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1j17dcavjsf",
      "fspDate": "2025-11-12T11:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1j17dcavjsf",
        "bookingDate": "2025-11-12",
        "valueDate": "2025-11-12",
        "bookingDateTime": "2025-11-12T11:28:00.000Z",
        "valueDateTime": "2025-11-12T11:28:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *mama?s Boy",
        "remittanceInformationUnstructuredArray": [
          "Sq *mama?s Boy"
        ],
        "debtorName": "Mama's Boy"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcneshspna4jnfvyh0c",
      "clustering": {
        "description": "Mama's Boy",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Mama's Boy' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.137Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xxeshspefm13x7bfrj",
      "createdAt": "2025-11-12T10:06:00.000Z",
      "updatedAt": "2025-11-12T10:06:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.27,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3qv1xr7esm9bvxf06t72r20",
      "fspDate": "2025-11-12T09:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3qv1xr7esm9bvxf06t72r20",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T07:00:00.000Z",
        "valueDateTime": "2026-01-10T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-17.27",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Cursor' from 'Cursor, Ai Powered Ide', removing any additional information.",
        "updatedAt": "2025-09-27T10:39:39.660Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wc0xe1e4bq9xea1tvy63c2fea6",
      "createdAt": "2025-11-12T09:10:00.000Z",
      "updatedAt": "2025-11-12T09:10:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 19447.46,
      "currency": "GBP",
      "description": "Payment from Digital Ventures Group - INV-202511-3252",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rzk0q9pe0vvrw0ndnr3t70gj0j",
      "fspDate": "2025-11-12T08:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rzk0q9pe0vvrw0ndnr3t70gj0j",
        "bookingDate": "2025-11-12",
        "valueDate": "2025-11-12",
        "bookingDateTime": "2025-11-12T09:10:00.000Z",
        "valueDateTime": "2025-11-12T09:10:00.000Z",
        "transactionAmount": {
          "amount": "19447.46",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Digital Ventures Group - INV-202511-3252",
        "remittanceInformationUnstructuredArray": [
          "Payment from Digital Ventures Group",
          "INV-202511-3252"
        ],
        "creditorName": "Digital Ventures Group"
      },
      "paymentId": null,
      "reference": "INV-202511-3252",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_mj6n80che7b1rf41e9c0gtanqb",
      "clustering": {
        "description": "Digital Ventures Group",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Digital Ventures Group'",
        "updatedAt": "2025-11-12T09:10:00.000Z"
      },
      "payer": {
        "name": "Digital Ventures Group",
        "iban": null,
        "bic": null,
        "sortCode": "730406",
        "accountNumber": "16844389"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg1a5ynmnymg",
      "createdAt": "2025-11-11T15:31:00.000Z",
      "updatedAt": "2025-11-11T15:31:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0xq7zhmgtwp",
      "fspDate": "2025-11-11T14:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0xq7zhmgtwp",
        "bookingDate": "2025-11-11",
        "valueDate": "2025-11-11",
        "bookingDateTime": "2025-11-11T14:31:00.000Z",
        "valueDateTime": "2025-11-11T14:31:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing 'Sq *' prefix",
        "updatedAt": "2025-09-27T10:50:52.387Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_hqrnmv3653gkkpyrvrb9e9t04w",
      "createdAt": "2025-11-11T14:25:00.000Z",
      "updatedAt": "2025-11-11T14:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 37.33,
      "currency": "EUR",
      "description": "Payment to Sweet Salt: SS-202511-9171",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_yvrw2zd6k6gjx0q94b47twv08p",
      "fspDate": "2025-11-11T13:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_yvrw2zd6k6gjx0q94b47twv08p",
        "bookingDate": "2025-11-11",
        "valueDate": "2025-11-11",
        "bookingDateTime": "2025-11-11T14:25:00.000Z",
        "valueDateTime": "2025-11-11T14:25:00.000Z",
        "transactionAmount": {
          "amount": "37.33",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sweet Salt: SS-202511-9171",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sweet Salt",
          "SS-202511-9171"
        ],
        "debtorName": "Sweet Salt"
      },
      "paymentId": null,
      "reference": "SS-202511-9171",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmad4eshspkk8z9xs58fk",
      "clustering": {
        "description": "Sweet Salt",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sweet Salt' based on payment details",
        "updatedAt": "2025-11-11T14:25:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sweet Salt",
        "iban": "DE50176093837296070",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2rf00x3p8sjgrs5qerf3f13c97",
      "createdAt": "2025-11-11T09:11:00.000Z",
      "updatedAt": "2025-11-11T09:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 563.7,
      "currency": "EUR",
      "description": "Payment to Clayton Hotel Burlington: CHB-202511-8933",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bx67g326s75s3zw8t4am05wzqs",
      "fspDate": "2025-11-11T08:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bx67g326s75s3zw8t4am05wzqs",
        "bookingDate": "2025-11-11",
        "valueDate": "2025-11-11",
        "bookingDateTime": "2025-11-11T09:11:00.000Z",
        "valueDateTime": "2025-11-11T09:11:00.000Z",
        "transactionAmount": {
          "amount": "563.70",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Burlington: CHB-202511-8933",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Burlington",
          "CHB-202511-8933"
        ],
        "debtorName": "Clayton Hotel Burlington"
      },
      "paymentId": null,
      "reference": "CHB-202511-8933",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crppkeshspmfw2e0m4xdm",
      "clustering": {
        "description": "Clayton Hotel Burlington",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Burlington' based on payment details",
        "updatedAt": "2025-11-11T09:11:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Burlington",
        "iban": "DE35300299997360870",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfhk507d7zh9",
      "createdAt": "2025-11-11T08:53:00.000Z",
      "updatedAt": "2025-11-11T08:53:00.000Z",
      "status": "BOOKED",
      "type": "OTHER",
      "isCredit": false,
      "amount": 60,
      "currency": "EUR",
      "description": "Expenses app charges",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0xq4wv1fvqsn5y5m1z2ak14",
      "fspDate": "2025-11-11T07:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xq4wv1fvqsn5y5m1z2ak14",
        "bookingDate": "2025-11-11",
        "valueDate": "2025-11-11",
        "bookingDateTime": "2025-11-11T07:53:00.000Z",
        "valueDateTime": "2025-11-11T07:53:00.000Z",
        "transactionAmount": {
          "amount": "-60.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "OTHER",
        "remittanceInformationUnstructured": "Expenses app charges",
        "remittanceInformationUnstructuredArray": [
          "Expenses app charges"
        ],
        "debtorName": "Expenses App"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mw3eshspjaesn0nt38r",
      "clustering": {
        "description": "Expenses App",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Expenses App' as the merchant name",
        "updatedAt": "2025-09-27T10:49:04.247Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm689hstfwxb",
      "createdAt": "2025-11-10T14:59:00.000Z",
      "updatedAt": "2025-11-10T14:59:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3600,
      "currency": "GBP",
      "description": "To Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1mwq52hexy9b8mvntn0f3wt",
      "fspDate": "2025-11-10T13:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1mwq52hexy9b8mvntn0f3wt",
        "bookingDate": "2025-11-10",
        "valueDate": "2025-11-10",
        "bookingDateTime": "2025-11-10T13:59:00.000Z",
        "valueDateTime": "2025-11-10T13:59:00.000Z",
        "transactionAmount": {
          "amount": "-3600.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance UK Ltd"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance UK' from 'To Seapoint Finance UK Ltd', removing 'To ' prefix and 'Ltd' suffix",
        "updatedAt": "2025-09-29T18:23:50.909Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspex40817s5q9",
      "createdAt": "2025-11-10T13:05:00.000Z",
      "updatedAt": "2025-11-10T13:05:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2pbwp66fzwbe0xm5r1xm1hc",
      "fspDate": "2025-11-10T12:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2pbwp66fzwbe0xm5r1xm1hc",
        "bookingDate": "2025-11-10",
        "valueDate": "2025-11-10",
        "bookingDateTime": "2025-11-10T12:05:00.000Z",
        "valueDateTime": "2025-11-10T12:05:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Coffee Angel' from 'Sq *coffeeangel', removing 'Sq *' prefix",
        "updatedAt": "2025-09-27T10:42:40.356Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspehsvyj0sgsd",
      "createdAt": "2025-11-10T08:20:00.000Z",
      "updatedAt": "2025-11-10T08:20:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 21.99,
      "currency": "EUR",
      "description": "Google Play Apps",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3jp8gs1e8prs7p5sgf44d0g",
      "fspDate": "2025-11-10T07:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3jp8gs1e8prs7p5sgf44d0g",
        "bookingDate": "2025-11-10",
        "valueDate": "2025-11-10",
        "bookingDateTime": "2025-11-10T07:20:00.000Z",
        "valueDateTime": "2025-11-10T07:20:00.000Z",
        "transactionAmount": {
          "amount": "-21.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Google Play Apps",
        "remittanceInformationUnstructuredArray": [
          "Google Play Apps"
        ],
        "debtorName": "Google Play"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wjeeshsphy7nnkfq48b",
      "clustering": {
        "description": "Google Play",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Google Play' from 'Google Play Apps'.",
        "updatedAt": "2025-09-27T10:39:39.728Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y8eshsph7k6jje45d9",
      "createdAt": "2025-11-09T17:53:00.000Z",
      "updatedAt": "2025-11-09T17:53:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25,
      "currency": "EUR",
      "description": "Sumup *anthony Moore",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk25at7f2mrvv",
      "fspDate": "2025-11-09T16:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk25at7f2mrvv",
        "bookingDate": "2025-11-09",
        "valueDate": "2025-11-09",
        "bookingDateTime": "2025-11-09T16:53:00.000Z",
        "valueDateTime": "2025-11-09T16:53:00.000Z",
        "transactionAmount": {
          "amount": "-25.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *anthony Moore",
        "remittanceInformationUnstructuredArray": [
          "Sumup *anthony Moore"
        ],
        "debtorName": "Anthony Moore"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a2keshspnzq7m9sbpn2",
      "clustering": {
        "description": "Anthony Moore",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Anthony Moore' from 'Sumup *anthony Moore', removing the 'Sumup *' prefix",
        "updatedAt": "2025-09-27T10:55:13.237Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6xsw15j98zcb62thwsv1jr8403",
      "createdAt": "2025-11-09T15:16:00.000Z",
      "updatedAt": "2025-11-09T15:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.21,
      "currency": "EUR",
      "description": "Payment to Salt Cellar Cafe: SCC-202511-8041",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2mtqxvpktn8ve5vyx35rg47zhg",
      "fspDate": "2025-11-09T14:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2mtqxvpktn8ve5vyx35rg47zhg",
        "bookingDate": "2025-11-09",
        "valueDate": "2025-11-09",
        "bookingDateTime": "2025-11-09T15:16:00.000Z",
        "valueDateTime": "2025-11-09T15:16:00.000Z",
        "transactionAmount": {
          "amount": "20.21",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Salt Cellar Cafe: SCC-202511-8041",
        "remittanceInformationUnstructuredArray": [
          "Payment to Salt Cellar Cafe",
          "SCC-202511-8041"
        ],
        "debtorName": "Salt Cellar Cafe"
      },
      "paymentId": null,
      "reference": "SCC-202511-8041",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0x9eshspkzthwr7rcm3",
      "clustering": {
        "description": "Salt Cellar Cafe",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Salt Cellar Cafe' based on payment details",
        "updatedAt": "2025-11-09T15:16:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Salt Cellar Cafe",
        "iban": "DE18525209068367984",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xbbb6dta91jr81sdzjd631hmne",
      "createdAt": "2025-11-09T12:22:00.000Z",
      "updatedAt": "2025-11-09T12:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 92.77,
      "currency": "EUR",
      "description": "Payment to Zapier: Z-202511-4382",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_cqe5rbmvf00mtygd1xqhbn20hh",
      "fspDate": "2025-11-09T11:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_cqe5rbmvf00mtygd1xqhbn20hh",
        "bookingDate": "2025-11-09",
        "valueDate": "2025-11-09",
        "bookingDateTime": "2025-11-09T12:22:00.000Z",
        "valueDateTime": "2025-11-09T12:22:00.000Z",
        "transactionAmount": {
          "amount": "92.77",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Zapier: Z-202511-4382",
        "remittanceInformationUnstructuredArray": [
          "Payment to Zapier",
          "Z-202511-4382"
        ],
        "debtorName": "Zapier"
      },
      "paymentId": null,
      "reference": "Z-202511-4382",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2aeshspkg92jdy8vh4",
      "clustering": {
        "description": "Zapier",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Zapier' based on payment details",
        "updatedAt": "2025-11-09T12:22:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Zapier",
        "iban": "DE15632183653872516",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfphjag4x19s",
      "createdAt": "2025-11-09T11:41:00.000Z",
      "updatedAt": "2025-11-09T11:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 8704.46,
      "currency": "EUR",
      "description": "Payment to Remote Europe Holding BV: 050IN25065451",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0f8atexfq9r56bmaxjbaehj",
      "fspDate": "2025-11-09T10:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0f8atexfq9r56bmaxjbaehj",
        "bookingDate": "2025-11-09",
        "valueDate": "2025-11-09",
        "bookingDateTime": "2025-11-09T10:41:00.000Z",
        "valueDateTime": "2025-11-09T10:41:00.000Z",
        "transactionAmount": {
          "amount": "-8704.46",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Remote Europe Holding BV: 050IN25065451",
        "remittanceInformationUnstructuredArray": [
          "Payment to Remote Europe Holding BV: 050IN25065451"
        ],
        "debtorName": "Remote Europe Holding BV"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pz7eshspjhbnt16ttyt",
      "clustering": {
        "description": "Remote Europe Holding BV",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Remote Europe Holding BV' from 'Payment to Remote Europe Holding BV: 050IN25065451'",
        "updatedAt": "2025-09-27T10:49:37.657Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf1emb7tqfx1",
      "createdAt": "2025-11-09T10:07:00.000Z",
      "updatedAt": "2025-11-09T10:07:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k26xg786fk7s0pm5f16hyeyr",
      "fspDate": "2025-11-09T09:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k26xg786fk7s0pm5f16hyeyr",
        "bookingDate": "2025-11-09",
        "valueDate": "2025-11-09",
        "bookingDateTime": "2025-11-09T09:07:00.000Z",
        "valueDateTime": "2025-11-09T09:07:00.000Z",
        "transactionAmount": {
          "amount": "-2.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Companies Registration' from the transaction description, removing the 'Companies Registration Office' details.",
        "updatedAt": "2025-09-27T10:43:55.418Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfczpee594s2",
      "createdAt": "2025-11-09T08:57:00.000Z",
      "updatedAt": "2025-11-09T08:57:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 39,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k12vyakpe4dr6y13j0qy5j6y",
      "fspDate": "2025-11-09T07:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k12vyakpe4dr6y13j0qy5j6y",
        "bookingDate": "2025-11-09",
        "valueDate": "2025-11-09",
        "bookingDateTime": "2025-11-09T07:57:00.000Z",
        "valueDateTime": "2025-11-09T07:57:00.000Z",
        "transactionAmount": {
          "amount": "-39.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'DocuSign' from 'Docusign'",
        "updatedAt": "2025-09-27T10:48:02.661Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspekd6p84df9b",
      "createdAt": "2025-11-09T08:05:00.000Z",
      "updatedAt": "2025-11-09T08:05:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gy9pnge8prrs8qydv4ttdt",
      "fspDate": "2025-11-09T07:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gy9pnge8prrs8qydv4ttdt",
        "bookingDate": "2025-11-09",
        "valueDate": "2025-11-09",
        "bookingDateTime": "2025-11-09T07:05:00.000Z",
        "valueDateTime": "2025-11-09T07:05:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Coffee Angel' from 'Sq *coffeeangel'",
        "updatedAt": "2025-09-27T10:40:26.837Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_e996ckgs9tmryc590hspzx2c0z",
      "createdAt": "2025-11-08T12:22:00.000Z",
      "updatedAt": "2025-11-08T12:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5.66,
      "currency": "EUR",
      "description": "Payment to Spar: S-202511-8970",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_j3k5zjan4zwbdqzw1jkqwers28",
      "fspDate": "2025-11-08T11:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_j3k5zjan4zwbdqzw1jkqwers28",
        "bookingDate": "2025-11-08",
        "valueDate": "2025-11-08",
        "bookingDateTime": "2025-11-08T12:22:00.000Z",
        "valueDateTime": "2025-11-08T12:22:00.000Z",
        "transactionAmount": {
          "amount": "5.66",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Spar: S-202511-8970",
        "remittanceInformationUnstructuredArray": [
          "Payment to Spar",
          "S-202511-8970"
        ],
        "debtorName": "Spar"
      },
      "paymentId": null,
      "reference": "S-202511-8970",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g32eshsphp8z5k4nrvg",
      "clustering": {
        "description": "Spar",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Spar' based on payment details",
        "updatedAt": "2025-11-08T12:22:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Spar",
        "iban": "DE45826170523264830",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfkd0nh3g2je",
      "createdAt": "2025-11-08T12:01:00.000Z",
      "updatedAt": "2025-11-08T12:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 84.02,
      "currency": "EUR",
      "description": "Paddle.net* Open Excha",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0rjbcknfq9r7n2ywvw2mmy8",
      "fspDate": "2025-11-08T11:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0rjbcknfq9r7n2ywvw2mmy8",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T15:00:00.000Z",
        "valueDateTime": "2026-01-10T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-84.02",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Paddle.net* Open Excha",
        "remittanceInformationUnstructuredArray": [
          "Paddle.net* Open Excha"
        ],
        "debtorName": "Paddle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax3veshspjmhphswafsq",
      "clustering": {
        "description": "Paddle",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Paddle' from 'Paddle.net* Open Excha', removing the .net* Open Excha suffix",
        "updatedAt": "2025-09-27T10:49:04.325Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgjts1awp0sa",
      "createdAt": "2025-11-08T11:47:00.000Z",
      "updatedAt": "2025-11-08T11:47:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 20.85,
      "currency": "EUR",
      "description": "1password",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1ga7rttx78a",
      "fspDate": "2025-11-08T10:47:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1ga7rttx78a",
        "bookingDate": "2025-11-08",
        "valueDate": "2025-11-08",
        "bookingDateTime": "2025-11-08T10:47:00.000Z",
        "valueDateTime": "2025-11-08T10:47:00.000Z",
        "transactionAmount": {
          "amount": "-20.85",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "1password",
        "remittanceInformationUnstructuredArray": [
          "1password"
        ],
        "debtorName": "1Password"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxpeshspjghv7zy63at",
      "clustering": {
        "description": "1Password",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name '1Password' from '1password'.",
        "updatedAt": "2025-09-27T10:52:47.496Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfs03rf0kxh6",
      "createdAt": "2025-11-08T08:26:00.000Z",
      "updatedAt": "2025-11-08T08:26:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 62.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0pbqh4ggy1m",
      "fspDate": "2025-11-08T07:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0pbqh4ggy1m",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T14:10:00.000Z",
        "valueDateTime": "2025-12-21T14:10:00.000Z",
        "transactionAmount": {
          "amount": "-62.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:49:37.735Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspeqycyn66836",
      "createdAt": "2025-11-05T14:26:00.000Z",
      "updatedAt": "2025-11-05T14:26:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Sq *seoul Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k38cnkeheh2szmpptj1660k0",
      "fspDate": "2025-11-05T13:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k38cnkeheh2szmpptj1660k0",
        "bookingDate": "2025-12-11",
        "valueDate": "2025-12-11",
        "bookingDateTime": "2025-12-11T08:10:00.000Z",
        "valueDateTime": "2025-12-11T08:10:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *seoul Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Sq *seoul Kitchen"
        ],
        "debtorName": "Seoul Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pzaeshspjhkemvf76tx",
      "clustering": {
        "description": "Seoul Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Seoul Kitchen' from the 'Sq *seoul Kitchen' transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:41:48.153Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gfpmcnqyrsrw7fm9b7ev96t0ax",
      "createdAt": "2025-11-05T13:34:00.000Z",
      "updatedAt": "2025-11-05T13:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.75,
      "currency": "USD",
      "description": "Payment to GitHub: G-202511-7236",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_dn16kbn6arewydd7affgg9m6vz",
      "fspDate": "2025-11-05T12:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_dn16kbn6arewydd7affgg9m6vz",
        "bookingDate": "2025-11-05",
        "valueDate": "2025-11-05",
        "bookingDateTime": "2025-11-05T13:34:00.000Z",
        "valueDateTime": "2025-11-05T13:34:00.000Z",
        "transactionAmount": {
          "amount": "20.75",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GitHub: G-202511-7236",
        "remittanceInformationUnstructuredArray": [
          "Payment to GitHub",
          "G-202511-7236"
        ],
        "debtorName": "GitHub"
      },
      "paymentId": null,
      "reference": "G-202511-7236",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wd4eshsphxfd9s33j9t",
      "clustering": {
        "description": "GitHub",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'GitHub' based on payment details",
        "updatedAt": "2025-11-05T13:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GitHub",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_w69kxk6r26y26vxn17tbh93bec",
      "createdAt": "2025-11-05T12:08:00.000Z",
      "updatedAt": "2025-11-05T12:08:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 152.97,
      "currency": "USD",
      "description": "Payment to Anthropic: A-202511-8590",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_z3dksqnrta7w8gpw8g9fcb5aqr",
      "fspDate": "2025-11-05T11:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_z3dksqnrta7w8gpw8g9fcb5aqr",
        "bookingDate": "2025-11-05",
        "valueDate": "2025-11-05",
        "bookingDateTime": "2025-11-05T12:08:00.000Z",
        "valueDateTime": "2025-11-05T12:08:00.000Z",
        "transactionAmount": {
          "amount": "152.97",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic: A-202511-8590",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic",
          "A-202511-8590"
        ],
        "debtorName": "Anthropic"
      },
      "paymentId": null,
      "reference": "A-202511-8590",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0y2eshspjwh0d2fxb76",
      "clustering": {
        "description": "Anthropic",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic' based on payment details",
        "updatedAt": "2025-11-05T12:08:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3nrq60kvkn8t27jmbtb6vzt0hh",
      "createdAt": "2025-11-05T11:01:00.000Z",
      "updatedAt": "2025-11-05T11:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 47.98,
      "currency": "EUR",
      "description": "Payment to Calendly: C-202511-4123",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_p94472km1pdp0n6mv1d7mzabkq",
      "fspDate": "2025-11-05T10:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_p94472km1pdp0n6mv1d7mzabkq",
        "bookingDate": "2025-11-05",
        "valueDate": "2025-11-05",
        "bookingDateTime": "2025-11-05T11:01:00.000Z",
        "valueDateTime": "2025-11-05T11:01:00.000Z",
        "transactionAmount": {
          "amount": "47.98",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Calendly: C-202511-4123",
        "remittanceInformationUnstructuredArray": [
          "Payment to Calendly",
          "C-202511-4123"
        ],
        "debtorName": "Calendly"
      },
      "paymentId": null,
      "reference": "C-202511-4123",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtc5eshspk6kqa7yaywk",
      "clustering": {
        "description": "Calendly",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Calendly' based on payment details",
        "updatedAt": "2025-11-05T11:01:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Calendly",
        "iban": "DE27264640385834940",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_npmhapj7wsrg1cfew7spx1jv7h",
      "createdAt": "2025-11-05T09:22:00.000Z",
      "updatedAt": "2025-11-05T09:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4.88,
      "currency": "EUR",
      "description": "Payment to Pinecone Coffee: PC-202511-4599",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1hhqrzpqak755wna6ze8h4pz04",
      "fspDate": "2025-11-05T08:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1hhqrzpqak755wna6ze8h4pz04",
        "bookingDate": "2025-11-05",
        "valueDate": "2025-11-05",
        "bookingDateTime": "2025-11-05T09:22:00.000Z",
        "valueDateTime": "2025-11-05T09:22:00.000Z",
        "transactionAmount": {
          "amount": "4.88",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pinecone Coffee: PC-202511-4599",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pinecone Coffee",
          "PC-202511-4599"
        ],
        "debtorName": "Pinecone Coffee"
      },
      "paymentId": null,
      "reference": "PC-202511-4599",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh31eshspkh23ahabkmn",
      "clustering": {
        "description": "Pinecone Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pinecone Coffee' based on payment details",
        "updatedAt": "2025-11-05T09:22:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pinecone Coffee",
        "iban": "DE43563219436771780",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pm1rt2xsg7kkzqh36bsgkvsee5",
      "createdAt": "2025-11-04T16:47:00.000Z",
      "updatedAt": "2025-11-04T16:47:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.72,
      "currency": "GBP",
      "description": "Payment to Transport for London: TFL-202511-5421",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_8bfkfkvzhr3724m10w4k908y8n",
      "fspDate": "2025-11-04T15:47:00.000Z",
      "fspRecord": {
        "transactionId": "txn_8bfkfkvzhr3724m10w4k908y8n",
        "bookingDate": "2025-11-04",
        "valueDate": "2025-11-04",
        "bookingDateTime": "2025-11-04T16:47:00.000Z",
        "valueDateTime": "2025-11-04T16:47:00.000Z",
        "transactionAmount": {
          "amount": "15.72",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Transport for London: TFL-202511-5421",
        "remittanceInformationUnstructuredArray": [
          "Payment to Transport for London",
          "TFL-202511-5421"
        ],
        "debtorName": "Transport for London"
      },
      "paymentId": null,
      "reference": "TFL-202511-5421",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgk7fvhrjp0v7hz9q786",
      "clustering": {
        "description": "Transport for London",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Transport for London' based on payment details",
        "updatedAt": "2025-11-04T16:47:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Transport for London",
        "iban": null,
        "bic": null,
        "sortCode": "872471",
        "accountNumber": "23428484"
      }
    },
    {
      "id": "txn_cvgjpz5zes629m7g19fbn427xq",
      "createdAt": "2025-11-04T16:29:00.000Z",
      "updatedAt": "2025-11-04T16:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 11.78,
      "currency": "EUR",
      "description": "Payment to Suhas Falafel: SF-202511-4217",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_smgtbd7vtttrzsd0np53dnsa76",
      "fspDate": "2025-11-04T15:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_smgtbd7vtttrzsd0np53dnsa76",
        "bookingDate": "2025-11-04",
        "valueDate": "2025-11-04",
        "bookingDateTime": "2025-11-04T16:29:00.000Z",
        "valueDateTime": "2025-11-04T16:29:00.000Z",
        "transactionAmount": {
          "amount": "11.78",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Suhas Falafel: SF-202511-4217",
        "remittanceInformationUnstructuredArray": [
          "Payment to Suhas Falafel",
          "SF-202511-4217"
        ],
        "debtorName": "Suhas Falafel"
      },
      "paymentId": null,
      "reference": "SF-202511-4217",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmadbeshspkkgwerj0myb",
      "clustering": {
        "description": "Suhas Falafel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Suhas Falafel' based on payment details",
        "updatedAt": "2025-11-04T16:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Suhas Falafel",
        "iban": "DE64397576266223170",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_c4n86pwvtjbe0p0v1ke5p6scyy",
      "createdAt": "2025-11-04T11:27:00.000Z",
      "updatedAt": "2025-11-04T11:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2850,
      "currency": "GBP",
      "description": "Salary - Emma Wilson - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_c4zs22z0n9038ve8e991q6n1yz",
      "fspDate": "2025-11-04T10:27:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_5p29mygysnx37n9apqj4r9eyhy",
        "bookingDate": "2025-11-04",
        "valueDate": "2025-11-04",
        "bookingDateTime": "2025-11-04T10:27:00.000Z",
        "valueDateTime": "2025-11-04T10:27:00.000Z",
        "transactionAmount": {
          "amount": "-2850.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Emma Wilson",
        "remittanceInformationUnstructuredArray": [
          "Salary - Emma Wilson"
        ]
      },
      "paymentId": "pmnt_rvqk9shbyytqatw23rw6m7r3ae",
      "reference": "PAY-DEC-2025-WILSON",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Emma Wilson",
        "iban": null,
        "bic": null,
        "sortCode": "20-00-00",
        "accountNumber": "31234567"
      }
    },
    {
      "id": "txn_01k65c32y6eshspgsxzccqj7s0",
      "createdAt": "2025-11-03T17:08:00.000Z",
      "updatedAt": "2025-11-03T17:08:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 40,
      "currency": "EUR",
      "description": "Mamma Mia Restaurant",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1qeknfff7zx",
      "fspDate": "2025-11-03T16:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1qeknfff7zx",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T09:00:00.000Z",
        "valueDateTime": "2026-01-04T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-40.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Mamma Mia Restaurant",
        "remittanceInformationUnstructuredArray": [
          "Mamma Mia Restaurant"
        ],
        "debtorName": "Mamma Mia Restaurant"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj1yeshspngr1g523f6q",
      "clustering": {
        "description": "Mamma Mia Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Mamma Mia Restaurant' from the raw transaction description.",
        "updatedAt": "2025-09-27T10:53:55.656Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6b8y5fzr7k66q8yyk5a0j279dp",
      "createdAt": "2025-11-03T16:51:00.000Z",
      "updatedAt": "2025-11-03T16:51:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17022.5,
      "currency": "GBP",
      "description": "Payment to Amwins Global Risks: AGR-202511-7170",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4zchs51yqjzwrpbq4h5yj7a24r",
      "fspDate": "2025-11-03T15:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4zchs51yqjzwrpbq4h5yj7a24r",
        "bookingDate": "2025-11-03",
        "valueDate": "2025-11-03",
        "bookingDateTime": "2025-11-03T16:51:00.000Z",
        "valueDateTime": "2025-11-03T16:51:00.000Z",
        "transactionAmount": {
          "amount": "17022.50",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amwins Global Risks: AGR-202511-7170",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amwins Global Risks",
          "AGR-202511-7170"
        ],
        "debtorName": "Amwins Global Risks"
      },
      "paymentId": null,
      "reference": "AGR-202511-7170",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2bfvhrjnbz808baykh",
      "clustering": {
        "description": "Amwins Global Risks",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amwins Global Risks' based on payment details",
        "updatedAt": "2025-11-03T16:51:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amwins Global Risks",
        "iban": null,
        "bic": null,
        "sortCode": "957376",
        "accountNumber": "35266926"
      }
    },
    {
      "id": "txn_01k65c32y1eshspf5hpk0mfy27",
      "createdAt": "2025-11-03T16:39:00.000Z",
      "updatedAt": "2025-11-03T16:39:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1mwq45xexy9b7qj8anzfhqy",
      "fspDate": "2025-11-03T15:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1mwq45xexy9b7qj8anzfhqy",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T13:59:00.000Z",
        "valueDateTime": "2025-12-07T13:59:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Zakura' from the transaction description.",
        "updatedAt": "2025-09-27T10:43:55.566Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_y7pj759jg2jfjs2zxvvxkn2fn2",
      "createdAt": "2025-11-03T16:37:00.000Z",
      "updatedAt": "2025-11-03T16:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 45.08,
      "currency": "GBP",
      "description": "Payment to Captain Nemo: CN-202511-9852",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gn8gyqh8kt66hq7xb5d20s9k5d",
      "fspDate": "2025-11-03T15:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gn8gyqh8kt66hq7xb5d20s9k5d",
        "bookingDate": "2025-11-03",
        "valueDate": "2025-11-03",
        "bookingDateTime": "2025-11-03T16:37:00.000Z",
        "valueDateTime": "2025-11-03T16:37:00.000Z",
        "transactionAmount": {
          "amount": "45.08",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Captain Nemo: CN-202511-9852",
        "remittanceInformationUnstructuredArray": [
          "Payment to Captain Nemo",
          "CN-202511-9852"
        ],
        "debtorName": "Captain Nemo"
      },
      "paymentId": null,
      "reference": "CN-202511-9852",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fm8nzsfzz9aen1pftqn9qr",
      "clustering": {
        "description": "Captain Nemo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Captain Nemo' based on payment details",
        "updatedAt": "2025-11-03T16:37:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Captain Nemo",
        "iban": null,
        "bic": null,
        "sortCode": "754951",
        "accountNumber": "47685707"
      }
    },
    {
      "id": "txn_01k65c32y3eshspft2zqn4sbkp",
      "createdAt": "2025-11-03T11:53:00.000Z",
      "updatedAt": "2025-11-03T11:53:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 69,
      "currency": "EUR",
      "description": "Financial Times",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0pthpqn6g1f",
      "fspDate": "2025-11-03T10:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0pthpqn6g1f",
        "bookingDate": "2025-11-03",
        "valueDate": "2025-11-03",
        "bookingDateTime": "2025-11-03T10:53:00.000Z",
        "valueDateTime": "2025-11-03T10:53:00.000Z",
        "transactionAmount": {
          "amount": "-69.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Financial Times",
        "remittanceInformationUnstructuredArray": [
          "Financial Times"
        ],
        "debtorName": "Financial Times"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gjeshspjygqrrg6sk5",
      "clustering": {
        "description": "Financial Times",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Financial Times' from 'Financial Times'",
        "updatedAt": "2025-09-27T10:49:37.767Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_p33hdhm86aah6ne029724mqp7z",
      "createdAt": "2025-11-03T11:34:00.000Z",
      "updatedAt": "2025-11-03T11:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 28.88,
      "currency": "GBP",
      "description": "Payment to Argos: A-202511-7947",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ggvvqep8a29x2kwzh9jxxjg00m",
      "fspDate": "2025-11-03T10:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ggvvqep8a29x2kwzh9jxxjg00m",
        "bookingDate": "2025-11-03",
        "valueDate": "2025-11-03",
        "bookingDateTime": "2025-11-03T11:34:00.000Z",
        "valueDateTime": "2025-11-03T11:34:00.000Z",
        "transactionAmount": {
          "amount": "28.88",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Argos: A-202511-7947",
        "remittanceInformationUnstructuredArray": [
          "Payment to Argos",
          "A-202511-7947"
        ],
        "debtorName": "Argos"
      },
      "paymentId": null,
      "reference": "A-202511-7947",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgp9fvhrjp1ker17rwy0",
      "clustering": {
        "description": "Argos",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Argos' based on payment details",
        "updatedAt": "2025-11-03T11:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Argos",
        "iban": null,
        "bic": null,
        "sortCode": "411747",
        "accountNumber": "80951500"
      }
    },
    {
      "id": "txn_4788taagw4n8sswwthqwj68966",
      "createdAt": "2025-11-02T16:11:00.000Z",
      "updatedAt": "2025-11-02T16:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 11.89,
      "currency": "EUR",
      "description": "Payment to A Taste of Thai: ATO-202511-8978",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_q96xaqyjfmms4xhhfyxs3gd90y",
      "fspDate": "2025-11-02T15:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_q96xaqyjfmms4xhhfyxs3gd90y",
        "bookingDate": "2025-11-02",
        "valueDate": "2025-11-02",
        "bookingDateTime": "2025-11-02T16:11:00.000Z",
        "valueDateTime": "2025-11-02T16:11:00.000Z",
        "transactionAmount": {
          "amount": "11.89",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to A Taste of Thai: ATO-202511-8978",
        "remittanceInformationUnstructuredArray": [
          "Payment to A Taste of Thai",
          "ATO-202511-8978"
        ],
        "debtorName": "A Taste of Thai"
      },
      "paymentId": null,
      "reference": "ATO-202511-8978",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1m2eshspm6a6wp0a9jq",
      "clustering": {
        "description": "A Taste of Thai",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'A Taste of Thai' based on payment details",
        "updatedAt": "2025-11-02T16:11:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "A Taste of Thai",
        "iban": "DE26745902617705956",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nycxv0bshaq0rq6skr04sqdqpf",
      "createdAt": "2025-11-02T15:29:00.000Z",
      "updatedAt": "2025-11-02T15:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3549.28,
      "currency": "USD",
      "description": "Payment to OpenAI, LLC: OL-202511-9901",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vdpfsx9sazv3h5fwbyj2mysn64",
      "fspDate": "2025-11-02T14:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vdpfsx9sazv3h5fwbyj2mysn64",
        "bookingDate": "2025-11-02",
        "valueDate": "2025-11-02",
        "bookingDateTime": "2025-11-02T15:29:00.000Z",
        "valueDateTime": "2025-11-02T15:29:00.000Z",
        "transactionAmount": {
          "amount": "3549.28",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to OpenAI, LLC: OL-202511-9901",
        "remittanceInformationUnstructuredArray": [
          "Payment to OpenAI, LLC",
          "OL-202511-9901"
        ],
        "debtorName": "OpenAI, LLC"
      },
      "paymentId": null,
      "reference": "OL-202511-9901",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1bss5kk7dqrqznncrn6c0w8y4p",
      "clustering": {
        "description": "OpenAI, LLC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'OpenAI, LLC' based on payment details",
        "updatedAt": "2025-11-02T15:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "OpenAI, LLC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wsb5dxwen2v85fmhe53y43td42",
      "createdAt": "2025-11-02T13:34:00.000Z",
      "updatedAt": "2025-11-02T13:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2831.81,
      "currency": "USD",
      "description": "Payment to Anthropic PBC: AP-202511-6564",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qm9feye2tkwwbq2ehwpcfet4vy",
      "fspDate": "2025-11-02T12:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qm9feye2tkwwbq2ehwpcfet4vy",
        "bookingDate": "2025-11-02",
        "valueDate": "2025-11-02",
        "bookingDateTime": "2025-11-02T13:34:00.000Z",
        "valueDateTime": "2025-11-02T13:34:00.000Z",
        "transactionAmount": {
          "amount": "2831.81",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic PBC: AP-202511-6564",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic PBC",
          "AP-202511-6564"
        ],
        "debtorName": "Anthropic PBC"
      },
      "paymentId": null,
      "reference": "AP-202511-6564",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_vnn6fxhm5daqv7bh39b88k2t9d",
      "clustering": {
        "description": "Anthropic PBC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic PBC' based on payment details",
        "updatedAt": "2025-11-02T13:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic PBC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_a9z3gcmp19k9jwn2mjce2bfrne",
      "createdAt": "2025-11-02T12:23:00.000Z",
      "updatedAt": "2025-11-02T12:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 32.7,
      "currency": "EUR",
      "description": "Payment to Delhi2Dublin: D-202511-7509",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9qarpcxxxv239r0psjm396j3d8",
      "fspDate": "2025-11-02T11:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9qarpcxxxv239r0psjm396j3d8",
        "bookingDate": "2025-11-02",
        "valueDate": "2025-11-02",
        "bookingDateTime": "2025-11-02T12:23:00.000Z",
        "valueDateTime": "2025-11-02T12:23:00.000Z",
        "transactionAmount": {
          "amount": "32.70",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Delhi2Dublin: D-202511-7509",
        "remittanceInformationUnstructuredArray": [
          "Payment to Delhi2Dublin",
          "D-202511-7509"
        ],
        "debtorName": "Delhi2Dublin"
      },
      "paymentId": null,
      "reference": "D-202511-7509",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0x5eshspjwbxzrhs5dn",
      "clustering": {
        "description": "Delhi2Dublin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Delhi2Dublin' based on payment details",
        "updatedAt": "2025-11-02T12:23:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Delhi2Dublin",
        "iban": "DE29648848456393424",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_epwhv7zxx5ae159m4kmaeagt5d",
      "createdAt": "2025-11-01T16:40:00.000Z",
      "updatedAt": "2025-11-01T16:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 22059.43,
      "currency": "GBP",
      "description": "Payment from SmartScale Solutions - INV-202511-2034",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wrvc0msjywh9cd3q6rr7p5sdrn",
      "fspDate": "2025-11-01T15:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wrvc0msjywh9cd3q6rr7p5sdrn",
        "bookingDate": "2025-11-01",
        "valueDate": "2025-11-01",
        "bookingDateTime": "2025-11-01T16:40:00.000Z",
        "valueDateTime": "2025-11-01T16:40:00.000Z",
        "transactionAmount": {
          "amount": "22059.43",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from SmartScale Solutions - INV-202511-2034",
        "remittanceInformationUnstructuredArray": [
          "Payment from SmartScale Solutions",
          "INV-202511-2034"
        ],
        "creditorName": "SmartScale Solutions"
      },
      "paymentId": null,
      "reference": "INV-202511-2034",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_k9wmdwkshbazmh9e7aq4wj85ej",
      "clustering": {
        "description": "SmartScale Solutions",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'SmartScale Solutions'",
        "updatedAt": "2025-11-01T16:40:00.000Z"
      },
      "payer": {
        "name": "SmartScale Solutions",
        "iban": null,
        "bic": null,
        "sortCode": "182746",
        "accountNumber": "79731359"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1x7a2serzkac8t33yqtpz68nab",
      "createdAt": "2025-11-01T10:38:00.000Z",
      "updatedAt": "2025-11-01T10:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.03,
      "currency": "EUR",
      "description": "Payment to Finom: F-202511-1289",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w6mcrv72n2trxpemqtan96x8ds",
      "fspDate": "2025-11-01T09:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w6mcrv72n2trxpemqtan96x8ds",
        "bookingDate": "2025-11-01",
        "valueDate": "2025-11-01",
        "bookingDateTime": "2025-11-01T10:38:00.000Z",
        "valueDateTime": "2025-11-01T10:38:00.000Z",
        "transactionAmount": {
          "amount": "14.03",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Finom: F-202511-1289",
        "remittanceInformationUnstructuredArray": [
          "Payment to Finom",
          "F-202511-1289"
        ],
        "debtorName": "Finom"
      },
      "paymentId": null,
      "reference": "F-202511-1289",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0yxeshspjws0xeeqa1k",
      "clustering": {
        "description": "Finom",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Finom' based on payment details",
        "updatedAt": "2025-11-01T10:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Finom",
        "iban": "DE90057708689905800",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_p6fm7n0bccq247c380qnme22w3",
      "createdAt": "2025-11-01T10:01:00.000Z",
      "updatedAt": "2025-11-01T10:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.04,
      "currency": "USD",
      "description": "Payment to Wispr: W-202511-3263",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2mthfx66y8y12x740a873ggr66",
      "fspDate": "2025-11-01T09:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2mthfx66y8y12x740a873ggr66",
        "bookingDate": "2025-11-01",
        "valueDate": "2025-11-01",
        "bookingDateTime": "2025-11-01T10:01:00.000Z",
        "valueDateTime": "2025-11-01T10:01:00.000Z",
        "transactionAmount": {
          "amount": "9.04",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Wispr: W-202511-3263",
        "remittanceInformationUnstructuredArray": [
          "Payment to Wispr",
          "W-202511-3263"
        ],
        "debtorName": "Wispr"
      },
      "paymentId": null,
      "reference": "W-202511-3263",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax6ceshspjngxatk00nd",
      "clustering": {
        "description": "Wispr",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Wispr' based on payment details",
        "updatedAt": "2025-11-01T10:01:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Wispr",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_47419zhew3kyb6txt4sgrqzd16",
      "createdAt": "2025-10-31T10:54:00.000Z",
      "updatedAt": "2025-10-31T10:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4.91,
      "currency": "EUR",
      "description": "Payment to Expenses App: EA-202510-2969",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_dpz2kr840txw98tb3hr60xffyy",
      "fspDate": "2025-10-31T09:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_dpz2kr840txw98tb3hr60xffyy",
        "bookingDate": "2025-10-31",
        "valueDate": "2025-10-31",
        "bookingDateTime": "2025-10-31T10:54:00.000Z",
        "valueDateTime": "2025-10-31T10:54:00.000Z",
        "transactionAmount": {
          "amount": "4.91",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Expenses App: EA-202510-2969",
        "remittanceInformationUnstructuredArray": [
          "Payment to Expenses App",
          "EA-202510-2969"
        ],
        "debtorName": "Expenses App"
      },
      "paymentId": null,
      "reference": "EA-202510-2969",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mw3eshspjaesn0nt38r",
      "clustering": {
        "description": "Expenses App",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Expenses App' based on payment details",
        "updatedAt": "2025-10-31T10:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Expenses App",
        "iban": "DE88865506773953390",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8azaa50ksc93bwrjk0w0feb9s9",
      "createdAt": "2025-10-31T09:39:00.000Z",
      "updatedAt": "2025-10-31T09:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 16.3,
      "currency": "EUR",
      "description": "Payment to Marquette: M-202510-8750",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_kxhm4f6se040gqz9km15k7arca",
      "fspDate": "2025-10-31T08:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_kxhm4f6se040gqz9km15k7arca",
        "bookingDate": "2025-10-31",
        "valueDate": "2025-10-31",
        "bookingDateTime": "2025-10-31T09:39:00.000Z",
        "valueDateTime": "2025-10-31T09:39:00.000Z",
        "transactionAmount": {
          "amount": "16.30",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marquette: M-202510-8750",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marquette",
          "M-202510-8750"
        ],
        "debtorName": "Marquette"
      },
      "paymentId": null,
      "reference": "M-202510-8750",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1npeshspm6wcf3gtsdh",
      "clustering": {
        "description": "Marquette",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marquette' based on payment details",
        "updatedAt": "2025-10-31T09:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marquette",
        "iban": "DE45943559816255250",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6f95yt89kf7n57mnyryar6kg7h",
      "createdAt": "2025-10-30T14:19:00.000Z",
      "updatedAt": "2025-10-30T14:19:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 134.86,
      "currency": "EUR",
      "description": "Payment to Naomi's Kitchen: NK-202510-7679",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xp082yraf0w5x1te9w4zy17jbt",
      "fspDate": "2025-10-30T13:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xp082yraf0w5x1te9w4zy17jbt",
        "bookingDate": "2025-10-30",
        "valueDate": "2025-10-30",
        "bookingDateTime": "2025-10-30T14:19:00.000Z",
        "valueDateTime": "2025-10-30T14:19:00.000Z",
        "transactionAmount": {
          "amount": "134.86",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Naomi's Kitchen: NK-202510-7679",
        "remittanceInformationUnstructuredArray": [
          "Payment to Naomi's Kitchen",
          "NK-202510-7679"
        ],
        "debtorName": "Naomi's Kitchen"
      },
      "paymentId": null,
      "reference": "NK-202510-7679",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh3deshspkhegxj7z9nq",
      "clustering": {
        "description": "Naomi's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Naomi's Kitchen' based on payment details",
        "updatedAt": "2025-10-30T14:19:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Naomi's Kitchen",
        "iban": "DE76476213771647890",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_byx2xv4zbhyw6da3yq3bmqyahd",
      "createdAt": "2025-10-30T13:23:00.000Z",
      "updatedAt": "2025-10-30T13:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 35.3,
      "currency": "EUR",
      "description": "Payment to The Woolshed: TW-202510-8217",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ahrfjzpn1k0ks5kws5gtdecsme",
      "fspDate": "2025-10-30T12:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ahrfjzpn1k0ks5kws5gtdecsme",
        "bookingDate": "2025-10-30",
        "valueDate": "2025-10-30",
        "bookingDateTime": "2025-10-30T13:23:00.000Z",
        "valueDateTime": "2025-10-30T13:23:00.000Z",
        "transactionAmount": {
          "amount": "35.30",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Woolshed: TW-202510-8217",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Woolshed",
          "TW-202510-8217"
        ],
        "debtorName": "The Woolshed"
      },
      "paymentId": null,
      "reference": "TW-202510-8217",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1pkeshspm729w29ytag",
      "clustering": {
        "description": "The Woolshed",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Woolshed' based on payment details",
        "updatedAt": "2025-10-30T13:23:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Woolshed",
        "iban": "DE31669080206729730",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mx6mk4v36seyykbjwewf4j2z2t",
      "createdAt": "2025-10-30T11:03:00.000Z",
      "updatedAt": "2025-10-30T11:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29.89,
      "currency": "USD",
      "description": "Payment to Superhuman: S-202510-3630",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pvhttvz9htmsb679jpz2j59p57",
      "fspDate": "2025-10-30T10:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pvhttvz9htmsb679jpz2j59p57",
        "bookingDate": "2025-10-30",
        "valueDate": "2025-10-30",
        "bookingDateTime": "2025-10-30T11:03:00.000Z",
        "valueDateTime": "2025-10-30T11:03:00.000Z",
        "transactionAmount": {
          "amount": "29.89",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Superhuman: S-202510-3630",
        "remittanceInformationUnstructuredArray": [
          "Payment to Superhuman",
          "S-202510-3630"
        ],
        "debtorName": "Superhuman"
      },
      "paymentId": null,
      "reference": "S-202510-3630",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5mceshspjzn83y9tqy1",
      "clustering": {
        "description": "Superhuman",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Superhuman' based on payment details",
        "updatedAt": "2025-10-30T11:03:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Superhuman",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5f8sz3p2bx4pxb7p392jpk6crm",
      "createdAt": "2025-10-29T16:26:00.000Z",
      "updatedAt": "2025-10-29T16:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2.33,
      "currency": "GBP",
      "description": "Payment to Mylands: M-202510-8612",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_p6zmw4qfb65t4n2h1p4g76rygk",
      "fspDate": "2025-10-29T15:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_p6zmw4qfb65t4n2h1p4g76rygk",
        "bookingDate": "2025-10-29",
        "valueDate": "2025-10-29",
        "bookingDateTime": "2025-10-29T16:26:00.000Z",
        "valueDateTime": "2025-10-29T16:26:00.000Z",
        "transactionAmount": {
          "amount": "2.33",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mylands: M-202510-8612",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mylands",
          "M-202510-8612"
        ],
        "debtorName": "Mylands"
      },
      "paymentId": null,
      "reference": "M-202510-8612",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbnxzzfvhrjp5np8trhg47",
      "clustering": {
        "description": "Mylands",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mylands' based on payment details",
        "updatedAt": "2025-10-29T16:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mylands",
        "iban": null,
        "bic": null,
        "sortCode": "539983",
        "accountNumber": "67773675"
      }
    },
    {
      "id": "txn_647xrntzrhpj8k67z7hj1nt568",
      "createdAt": "2025-10-29T16:13:00.000Z",
      "updatedAt": "2025-10-29T16:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1776.95,
      "currency": "EUR",
      "description": "Payment to Bank of Ireland: BOI-202510-9597",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gs2xks981c9fg4445ass288kpx",
      "fspDate": "2025-10-29T15:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gs2xks981c9fg4445ass288kpx",
        "bookingDate": "2025-10-29",
        "valueDate": "2025-10-29",
        "bookingDateTime": "2025-10-29T16:13:00.000Z",
        "valueDateTime": "2025-10-29T16:13:00.000Z",
        "transactionAmount": {
          "amount": "1776.95",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bank of Ireland: BOI-202510-9597",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bank of Ireland",
          "BOI-202510-9597"
        ],
        "debtorName": "Bank of Ireland"
      },
      "paymentId": null,
      "reference": "BOI-202510-9597",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a24eshspnzbnpcam1v1",
      "clustering": {
        "description": "Bank of Ireland",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bank of Ireland' based on payment details",
        "updatedAt": "2025-10-29T16:13:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bank of Ireland",
        "iban": "DE85391477213223410",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgx7hw5pn8ep",
      "createdAt": "2025-10-29T14:46:00.000Z",
      "updatedAt": "2025-10-29T14:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 16.5,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1t9016631gj",
      "fspDate": "2025-10-29T13:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1t9016631gj",
        "bookingDate": "2025-10-29",
        "valueDate": "2025-10-29",
        "bookingDateTime": "2025-10-29T13:46:00.000Z",
        "valueDateTime": "2025-10-29T13:46:00.000Z",
        "transactionAmount": {
          "amount": "-16.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Shaka Poke' from 'Sq *shaka Poke', removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:54:12.456Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wd2yzdnqb4b5gsq7knezg79cec",
      "createdAt": "2025-10-29T13:27:00.000Z",
      "updatedAt": "2025-10-29T13:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 18.02,
      "currency": "EUR",
      "description": "Payment to Salt Cellar Cafe: SCC-202510-5173",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_07w6nfz3zpcf5twsch56w3y7s5",
      "fspDate": "2025-10-29T12:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_07w6nfz3zpcf5twsch56w3y7s5",
        "bookingDate": "2025-10-29",
        "valueDate": "2025-10-29",
        "bookingDateTime": "2025-10-29T13:27:00.000Z",
        "valueDateTime": "2025-10-29T13:27:00.000Z",
        "transactionAmount": {
          "amount": "18.02",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Salt Cellar Cafe: SCC-202510-5173",
        "remittanceInformationUnstructuredArray": [
          "Payment to Salt Cellar Cafe",
          "SCC-202510-5173"
        ],
        "debtorName": "Salt Cellar Cafe"
      },
      "paymentId": null,
      "reference": "SCC-202510-5173",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0x9eshspkzthwr7rcm3",
      "clustering": {
        "description": "Salt Cellar Cafe",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Salt Cellar Cafe' based on payment details",
        "updatedAt": "2025-10-29T13:27:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Salt Cellar Cafe",
        "iban": "DE93792955867818750",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_av7e2ys9wber8pp3mq3qsmarcx",
      "createdAt": "2025-10-29T12:51:00.000Z",
      "updatedAt": "2025-10-29T12:51:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.69,
      "currency": "EUR",
      "description": "Payment to Suhas Falafel: SF-202510-8432",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wyzqvtvs8sj7je27v3z6a31ka9",
      "fspDate": "2025-10-29T11:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wyzqvtvs8sj7je27v3z6a31ka9",
        "bookingDate": "2025-10-29",
        "valueDate": "2025-10-29",
        "bookingDateTime": "2025-10-29T12:51:00.000Z",
        "valueDateTime": "2025-10-29T12:51:00.000Z",
        "transactionAmount": {
          "amount": "14.69",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Suhas Falafel: SF-202510-8432",
        "remittanceInformationUnstructuredArray": [
          "Payment to Suhas Falafel",
          "SF-202510-8432"
        ],
        "debtorName": "Suhas Falafel"
      },
      "paymentId": null,
      "reference": "SF-202510-8432",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmadbeshspkkgwerj0myb",
      "clustering": {
        "description": "Suhas Falafel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Suhas Falafel' based on payment details",
        "updatedAt": "2025-10-29T12:51:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Suhas Falafel",
        "iban": "DE84092347002658130",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_epah98r3h2qy2t9376yq6w0yj9",
      "createdAt": "2025-10-29T12:04:00.000Z",
      "updatedAt": "2025-10-29T12:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 31938.33,
      "currency": "GBP",
      "description": "Payment from Global Solutions Ltd - INV-202510-4741",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xpctkwsq6jc4d1vd3pf0dbfayb",
      "fspDate": "2025-10-29T11:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xpctkwsq6jc4d1vd3pf0dbfayb",
        "bookingDate": "2025-10-29",
        "valueDate": "2025-10-29",
        "bookingDateTime": "2025-10-29T12:04:00.000Z",
        "valueDateTime": "2025-10-29T12:04:00.000Z",
        "transactionAmount": {
          "amount": "31938.33",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Global Solutions Ltd - INV-202510-4741",
        "remittanceInformationUnstructuredArray": [
          "Payment from Global Solutions Ltd",
          "INV-202510-4741"
        ],
        "creditorName": "Global Solutions Ltd"
      },
      "paymentId": null,
      "reference": "INV-202510-4741",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_th3hfveyjxh2erds1n633s02yd",
      "clustering": {
        "description": "Global Solutions Ltd",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Global Solutions Ltd'",
        "updatedAt": "2025-10-29T12:04:00.000Z"
      },
      "payer": {
        "name": "Global Solutions Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "719929",
        "accountNumber": "44774190"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gy297r0kfzwe1389g98k7gp85s",
      "createdAt": "2025-10-29T11:26:00.000Z",
      "updatedAt": "2025-10-29T11:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1484.53,
      "currency": "GBP",
      "description": "Payment to Adam Rankin: AR-202510-1030",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gt459a4fs4kysbtqfdjggak7ph",
      "fspDate": "2025-10-29T10:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gt459a4fs4kysbtqfdjggak7ph",
        "bookingDate": "2025-10-29",
        "valueDate": "2025-10-29",
        "bookingDateTime": "2025-10-29T11:26:00.000Z",
        "valueDateTime": "2025-10-29T11:26:00.000Z",
        "transactionAmount": {
          "amount": "1484.53",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Adam Rankin: AR-202510-1030",
        "remittanceInformationUnstructuredArray": [
          "Payment to Adam Rankin",
          "AR-202510-1030"
        ],
        "debtorName": "Adam Rankin"
      },
      "paymentId": null,
      "reference": "AR-202510-1030",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2zfvhrjnc124tr3b2s",
      "clustering": {
        "description": "Adam Rankin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Adam Rankin' based on payment details",
        "updatedAt": "2025-10-29T11:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Adam Rankin",
        "iban": null,
        "bic": null,
        "sortCode": "485163",
        "accountNumber": "70341144"
      }
    },
    {
      "id": "txn_01k65c32y4eshspg8f09ws04g2",
      "createdAt": "2025-10-29T08:09:00.000Z",
      "updatedAt": "2025-10-29T08:09:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 200,
      "currency": "EUR",
      "description": "Tst-Bang-Restaurant",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1fw68eqmksc",
      "fspDate": "2025-10-29T07:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1fw68eqmksc",
        "bookingDate": "2025-10-29",
        "valueDate": "2025-10-29",
        "bookingDateTime": "2025-10-29T07:09:00.000Z",
        "valueDateTime": "2025-10-29T07:09:00.000Z",
        "transactionAmount": {
          "amount": "-200.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tst-Bang-Restaurant",
        "remittanceInformationUnstructuredArray": [
          "Tst-Bang-Restaurant"
        ],
        "debtorName": "Bang Restaurant"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpk3eshspmfgtm6vkpxj",
      "clustering": {
        "description": "Bang Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Bang Restaurant' from 'Tst-Bang-Restaurant', removing the 'Tst-' prefix.",
        "updatedAt": "2025-09-27T10:51:38.274Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgedfrtbg52e",
      "createdAt": "2025-10-28T13:13:00.000Z",
      "updatedAt": "2025-10-28T13:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2000,
      "currency": "EUR",
      "description": "To BOI 2 COLLEGE GREEN, Davy",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1cedd3qgwg9",
      "fspDate": "2025-10-28T12:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1cedd3qgwg9",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T16:40:00.000Z",
        "valueDateTime": "2025-12-04T16:40:00.000Z",
        "transactionAmount": {
          "amount": "-2000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To BOI 2 COLLEGE GREEN, Davy",
        "remittanceInformationUnstructuredArray": [
          "To BOI 2 COLLEGE GREEN, Davy"
        ],
        "debtorName": "BOI 2 COLLEGE GREEN, Davy"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc5eshspj0rxb4j151x",
      "clustering": {
        "description": "BOI 2 COLLEGE GREEN, Davy",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'BOI 2 COLLEGE GREEN, Davy' from 'To BOI 2 COLLEGE GREEN, Davy'",
        "updatedAt": "2025-09-27T10:52:10.128Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspemxvr8qx4kt",
      "createdAt": "2025-10-28T11:11:00.000Z",
      "updatedAt": "2025-10-28T11:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7733.85,
      "currency": "EUR",
      "description": "Payment to Cormac Byrne: Aug 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gc1m5pe8prm037e2b59ecd",
      "fspDate": "2025-10-28T10:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc1m5pe8prm037e2b59ecd",
        "bookingDate": "2025-10-28",
        "valueDate": "2025-10-28",
        "bookingDateTime": "2025-10-28T10:11:00.000Z",
        "valueDateTime": "2025-10-28T10:11:00.000Z",
        "transactionAmount": {
          "amount": "-7733.85",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cormac Byrne: Aug 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cormac Byrne: Aug 2025 Payroll"
        ],
        "debtorName": "Cormac Byrne"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zspeshspj7tfmtn8s05",
      "clustering": {
        "description": "Cormac Byrne",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cormac Byrne' from 'Payment to Cormac Byrne: Aug 2025 Payroll'",
        "updatedAt": "2025-09-27T10:40:26.870Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nt3kdwq519erjqb7nrgzyx72dz",
      "createdAt": "2025-10-27T14:57:00.000Z",
      "updatedAt": "2025-10-27T14:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1214.26,
      "currency": "EUR",
      "description": "Payment to Upwork: U-202510-5507",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vvv99941kn8sx99jka42hk2zjj",
      "fspDate": "2025-10-27T13:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vvv99941kn8sx99jka42hk2zjj",
        "bookingDate": "2025-10-27",
        "valueDate": "2025-10-27",
        "bookingDateTime": "2025-10-27T14:57:00.000Z",
        "valueDateTime": "2025-10-27T14:57:00.000Z",
        "transactionAmount": {
          "amount": "1214.26",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Upwork: U-202510-5507",
        "remittanceInformationUnstructuredArray": [
          "Payment to Upwork",
          "U-202510-5507"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": "U-202510-5507",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Upwork' based on payment details",
        "updatedAt": "2025-10-27T14:57:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Upwork",
        "iban": "DE14277307855228980",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmpzqsebzmd6",
      "createdAt": "2025-10-27T13:20:00.000Z",
      "updatedAt": "2025-10-27T13:20:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 16997.53,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8faqrpz5f4a",
      "fspDate": "2025-10-27T12:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8faqrpz5f4a",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T11:14:00.000Z",
        "valueDateTime": "2025-12-27T11:14:00.000Z",
        "transactionAmount": {
          "amount": "16997.53",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the core business name for the currency conversion transaction",
        "updatedAt": "2025-09-29T18:26:40.943Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgbwj8mknfps",
      "createdAt": "2025-10-27T12:18:00.000Z",
      "updatedAt": "2025-10-27T12:18:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 9.4,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk19qp2784ymr",
      "fspDate": "2025-10-27T11:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk19qp2784ymr",
        "bookingDate": "2025-10-27",
        "valueDate": "2025-10-27",
        "bookingDateTime": "2025-10-27T11:18:00.000Z",
        "valueDateTime": "2025-10-27T11:18:00.000Z",
        "transactionAmount": {
          "amount": "-9.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing 'Sq *' prefix",
        "updatedAt": "2025-09-27T10:52:10.035Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n7jrq17dnexkaqv1d511c9nmwz",
      "createdAt": "2025-10-27T10:15:00.000Z",
      "updatedAt": "2025-10-27T10:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12.57,
      "currency": "EUR",
      "description": "Payment to Mama's Boy: MB-202510-5517",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_sq30jjaqqemd9cb672z9z8qrr1",
      "fspDate": "2025-10-27T09:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_sq30jjaqqemd9cb672z9z8qrr1",
        "bookingDate": "2025-10-27",
        "valueDate": "2025-10-27",
        "bookingDateTime": "2025-10-27T10:15:00.000Z",
        "valueDateTime": "2025-10-27T10:15:00.000Z",
        "transactionAmount": {
          "amount": "12.57",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mama's Boy: MB-202510-5517",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mama's Boy",
          "MB-202510-5517"
        ],
        "debtorName": "Mama's Boy"
      },
      "paymentId": null,
      "reference": "MB-202510-5517",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcneshspna4jnfvyh0c",
      "clustering": {
        "description": "Mama's Boy",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mama's Boy' based on payment details",
        "updatedAt": "2025-10-27T10:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mama's Boy",
        "iban": "DE85589012438570930",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf9vnynrjccj",
      "createdAt": "2025-10-26T16:24:00.000Z",
      "updatedAt": "2025-10-26T16:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 33.54,
      "currency": "EUR",
      "description": "Tst-Sweet Salt",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1d5gytnesj8a9116ntxxbb5",
      "fspDate": "2025-10-26T15:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1d5gytnesj8a9116ntxxbb5",
        "bookingDate": "2025-10-26",
        "valueDate": "2025-10-26",
        "bookingDateTime": "2025-10-26T15:24:00.000Z",
        "valueDateTime": "2025-10-26T15:24:00.000Z",
        "transactionAmount": {
          "amount": "-33.54",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tst-Sweet Salt",
        "remittanceInformationUnstructuredArray": [
          "Tst-Sweet Salt"
        ],
        "debtorName": "Sweet Salt"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmad4eshspkk8z9xs58fk",
      "clustering": {
        "description": "Sweet Salt",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Sweet Salt' from 'Tst-Sweet Salt', removing the Tst- prefix",
        "updatedAt": "2025-09-27T10:45:11.618Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph2yxsfgbq74",
      "createdAt": "2025-10-26T15:44:00.000Z",
      "updatedAt": "2025-10-26T15:44:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 416.58,
      "currency": "EUR",
      "description": "Google Gsuite_seapoint",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk20ka1typ3jz",
      "fspDate": "2025-10-26T14:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk20ka1typ3jz",
        "bookingDate": "2025-10-26",
        "valueDate": "2025-10-26",
        "bookingDateTime": "2025-10-26T14:44:00.000Z",
        "valueDateTime": "2025-10-26T14:44:00.000Z",
        "transactionAmount": {
          "amount": "-416.58",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Google Gsuite_seapoint",
        "remittanceInformationUnstructuredArray": [
          "Google Gsuite_seapoint"
        ],
        "debtorName": "Google"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdrteshspka3qwhrnts0",
      "clustering": {
        "description": "Google",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Google' from 'Google Gsuite_seapoint'",
        "updatedAt": "2025-09-27T10:54:50.775Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vafarsa5qqtgr8bv6w0x6etn43",
      "createdAt": "2025-10-26T15:21:00.000Z",
      "updatedAt": "2025-10-26T15:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12.51,
      "currency": "EUR",
      "description": "Payment to Beanhive: B-202510-5595",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0n6mae4y5rwm37213y1fhk5vvq",
      "fspDate": "2025-10-26T14:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0n6mae4y5rwm37213y1fhk5vvq",
        "bookingDate": "2025-10-26",
        "valueDate": "2025-10-26",
        "bookingDateTime": "2025-10-26T15:21:00.000Z",
        "valueDateTime": "2025-10-26T15:21:00.000Z",
        "transactionAmount": {
          "amount": "12.51",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Beanhive: B-202510-5595",
        "remittanceInformationUnstructuredArray": [
          "Payment to Beanhive",
          "B-202510-5595"
        ],
        "debtorName": "Beanhive"
      },
      "paymentId": null,
      "reference": "B-202510-5595",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmacweshspkk5mv2ktdq4",
      "clustering": {
        "description": "Beanhive",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Beanhive' based on payment details",
        "updatedAt": "2025-10-26T15:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Beanhive",
        "iban": "DE86852570510162720",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_g45nrssg11mhyjr3wvxrgmje63",
      "createdAt": "2025-10-26T12:49:00.000Z",
      "updatedAt": "2025-10-26T12:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.1,
      "currency": "USD",
      "description": "Payment to Linear: L-202510-1905",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0p1xe0ttswh6m10q7pj6sfm9ja",
      "fspDate": "2025-10-26T11:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0p1xe0ttswh6m10q7pj6sfm9ja",
        "bookingDate": "2025-10-26",
        "valueDate": "2025-10-26",
        "bookingDateTime": "2025-10-26T12:49:00.000Z",
        "valueDateTime": "2025-10-26T12:49:00.000Z",
        "transactionAmount": {
          "amount": "10.10",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Linear: L-202510-1905",
        "remittanceInformationUnstructuredArray": [
          "Payment to Linear",
          "L-202510-1905"
        ],
        "debtorName": "Linear"
      },
      "paymentId": null,
      "reference": "L-202510-1905",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc1eshspj0mxd2vh6zx",
      "clustering": {
        "description": "Linear",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Linear' based on payment details",
        "updatedAt": "2025-10-26T12:49:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Linear",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_20d7d0qwzp567q9yqs96385q71",
      "createdAt": "2025-10-26T11:50:00.000Z",
      "updatedAt": "2025-10-26T11:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12.65,
      "currency": "EUR",
      "description": "Payment to A Taste of Thai: ATO-202510-5771",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1k6mtd5r3d8wk63mmj7y8ts1g4",
      "fspDate": "2025-10-26T10:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1k6mtd5r3d8wk63mmj7y8ts1g4",
        "bookingDate": "2025-10-26",
        "valueDate": "2025-10-26",
        "bookingDateTime": "2025-10-26T11:50:00.000Z",
        "valueDateTime": "2025-10-26T11:50:00.000Z",
        "transactionAmount": {
          "amount": "12.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to A Taste of Thai: ATO-202510-5771",
        "remittanceInformationUnstructuredArray": [
          "Payment to A Taste of Thai",
          "ATO-202510-5771"
        ],
        "debtorName": "A Taste of Thai"
      },
      "paymentId": null,
      "reference": "ATO-202510-5771",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1m2eshspm6a6wp0a9jq",
      "clustering": {
        "description": "A Taste of Thai",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'A Taste of Thai' based on payment details",
        "updatedAt": "2025-10-26T11:50:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "A Taste of Thai",
        "iban": "DE25131757120734704",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_azadjvqmq32gwp1sqkchg6ymjr",
      "createdAt": "2025-10-26T10:50:00.000Z",
      "updatedAt": "2025-10-26T10:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 22005.18,
      "currency": "GBP",
      "description": "Payment from Innovation Partners - INV-202510-4328",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6qyvbseyq9qhbjx020wa3tnkz1",
      "fspDate": "2025-10-26T09:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6qyvbseyq9qhbjx020wa3tnkz1",
        "bookingDate": "2025-10-26",
        "valueDate": "2025-10-26",
        "bookingDateTime": "2025-10-26T10:50:00.000Z",
        "valueDateTime": "2025-10-26T10:50:00.000Z",
        "transactionAmount": {
          "amount": "22005.18",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Innovation Partners - INV-202510-4328",
        "remittanceInformationUnstructuredArray": [
          "Payment from Innovation Partners",
          "INV-202510-4328"
        ],
        "creditorName": "Innovation Partners"
      },
      "paymentId": null,
      "reference": "INV-202510-4328",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m4xtykg61y9kjq9cjdr8bewyz0",
      "clustering": {
        "description": "Innovation Partners",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Innovation Partners'",
        "updatedAt": "2025-10-26T10:50:00.000Z"
      },
      "payer": {
        "name": "Innovation Partners",
        "iban": null,
        "bic": null,
        "sortCode": "507074",
        "accountNumber": "10239540"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfp2b2y23td6",
      "createdAt": "2025-10-25T15:12:00.000Z",
      "updatedAt": "2025-10-25T15:12:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 41.68,
      "currency": "EUR",
      "description": "Wispr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0e8rfh4exraqe0f7bann4r5",
      "fspDate": "2025-10-25T14:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0e8rfh4exraqe0f7bann4r5",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T09:00:00.000Z",
        "valueDateTime": "2026-01-02T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-41.68",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Wispr",
        "remittanceInformationUnstructuredArray": [
          "Wispr"
        ],
        "debtorName": "Wispr"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax6ceshspjngxatk00nd",
      "clustering": {
        "description": "Wispr",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Wispr' from 'Wispr'",
        "updatedAt": "2025-09-27T10:49:37.631Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0xfafswfnnmjdy0813h26x1cpc",
      "createdAt": "2025-10-25T15:03:00.000Z",
      "updatedAt": "2025-10-25T15:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 24229.85,
      "currency": "GBP",
      "description": "Payment from CloudFirst Technologies - INV-202510-2067",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_7az7va050585exybb1c50b4ac7",
      "fspDate": "2025-10-25T14:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_7az7va050585exybb1c50b4ac7",
        "bookingDate": "2025-10-25",
        "valueDate": "2025-10-25",
        "bookingDateTime": "2025-10-25T15:03:00.000Z",
        "valueDateTime": "2025-10-25T15:03:00.000Z",
        "transactionAmount": {
          "amount": "24229.85",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from CloudFirst Technologies - INV-202510-2067",
        "remittanceInformationUnstructuredArray": [
          "Payment from CloudFirst Technologies",
          "INV-202510-2067"
        ],
        "creditorName": "CloudFirst Technologies"
      },
      "paymentId": null,
      "reference": "INV-202510-2067",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_v3gga6hnqqf8p85ezhv67qxfkw",
      "clustering": {
        "description": "CloudFirst Technologies",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'CloudFirst Technologies'",
        "updatedAt": "2025-10-25T15:03:00.000Z"
      },
      "payer": {
        "name": "CloudFirst Technologies",
        "iban": null,
        "bic": null,
        "sortCode": "321927",
        "accountNumber": "59331147"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ddz048g38rxfcs308ta0ab49g3",
      "createdAt": "2025-10-25T13:55:00.000Z",
      "updatedAt": "2025-10-25T13:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 213.93,
      "currency": "GBP",
      "description": "Payment to Aer Lingus: AL-202510-8354",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2w3v01gkt3n5xzp8d5nb5mms9j",
      "fspDate": "2025-10-25T12:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2w3v01gkt3n5xzp8d5nb5mms9j",
        "bookingDate": "2025-10-25",
        "valueDate": "2025-10-25",
        "bookingDateTime": "2025-10-25T13:55:00.000Z",
        "valueDateTime": "2025-10-25T13:55:00.000Z",
        "transactionAmount": {
          "amount": "213.93",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Aer Lingus: AL-202510-8354",
        "remittanceInformationUnstructuredArray": [
          "Payment to Aer Lingus",
          "AL-202510-8354"
        ],
        "debtorName": "Aer Lingus"
      },
      "paymentId": null,
      "reference": "AL-202510-8354",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnekfvhrjnk2qd4ej2sf",
      "clustering": {
        "description": "Aer Lingus",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Aer Lingus' based on payment details",
        "updatedAt": "2025-10-25T13:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Aer Lingus",
        "iban": null,
        "bic": null,
        "sortCode": "847708",
        "accountNumber": "93344390"
      }
    },
    {
      "id": "txn_01k65c32y6eshspgq8y64bnacy",
      "createdAt": "2025-10-25T13:50:00.000Z",
      "updatedAt": "2025-10-25T13:50:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 840,
      "currency": "EUR",
      "description": "Clayton Hotel Burlingt",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1mryhd252fa",
      "fspDate": "2025-10-25T12:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1mryhd252fa",
        "bookingDate": "2025-10-25",
        "valueDate": "2025-10-25",
        "bookingDateTime": "2025-10-25T12:50:00.000Z",
        "valueDateTime": "2025-10-25T12:50:00.000Z",
        "transactionAmount": {
          "amount": "-840.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Clayton Hotel Burlingt",
        "remittanceInformationUnstructuredArray": [
          "Clayton Hotel Burlingt"
        ],
        "debtorName": "Clayton Hotel Burlington"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crppkeshspmfw2e0m4xdm",
      "clustering": {
        "description": "Clayton Hotel Burlington",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Clayton Hotel Burlington' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.240Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmm86rqkz2ep",
      "createdAt": "2025-10-25T13:24:00.000Z",
      "updatedAt": "2025-10-25T13:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 100,
      "currency": "GBP",
      "description": "Clayton Belfast Recept",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8de7q9w2hww",
      "fspDate": "2025-10-25T12:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8de7q9w2hww",
        "bookingDate": "2025-10-25",
        "valueDate": "2025-10-25",
        "bookingDateTime": "2025-10-25T12:24:00.000Z",
        "valueDateTime": "2025-10-25T12:24:00.000Z",
        "transactionAmount": {
          "amount": "-100.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Clayton Belfast Recept",
        "remittanceInformationUnstructuredArray": [
          "Clayton Belfast Recept"
        ],
        "debtorName": "Clayton Belfast"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4hyfvhrjnt1zqpqqyns",
      "clustering": {
        "description": "Clayton Belfast",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Clayton Belfast' from 'Clayton Belfast Recept'",
        "updatedAt": "2025-09-29T18:25:48.590Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjme72qyqfe1n",
      "createdAt": "2025-10-25T13:08:00.000Z",
      "updatedAt": "2025-10-25T13:08:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 11950.69,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk86kdc8vydtf",
      "fspDate": "2025-10-25T12:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk86kdc8vydtf",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T16:00:00.000Z",
        "valueDateTime": "2026-01-10T16:00:00.000Z",
        "transactionAmount": {
          "amount": "11950.69",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.129Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspenagdqnyx1p",
      "createdAt": "2025-10-25T11:49:00.000Z",
      "updatedAt": "2025-10-25T11:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4939.74,
      "currency": "EUR",
      "description": "Payment to Emma Fitzgerald: Aug 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gc1m6qe8prm04svd474r78",
      "fspDate": "2025-10-25T10:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc1m6qe8prm04svd474r78",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T15:51:00.000Z",
        "valueDateTime": "2025-12-21T15:51:00.000Z",
        "transactionAmount": {
          "amount": "-4939.74",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Emma Fitzgerald: Aug 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Emma Fitzgerald: Aug 2025 Payroll"
        ],
        "debtorName": "Emma Fitzgerald"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtceshspj98ga0ebagk",
      "clustering": {
        "description": "Emma Fitzgerald",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Emma Fitzgerald' from 'Payment to Emma Fitzgerald: Aug 2025 Payroll'",
        "updatedAt": "2025-09-27T10:40:26.879Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qa3mpwwk84krkxq5rw4y57gmm8",
      "createdAt": "2025-10-25T09:54:00.000Z",
      "updatedAt": "2025-10-25T09:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.27,
      "currency": "EUR",
      "description": "Payment to Tavily AI: TA-202510-9069",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_v9kyhsk000ztrm2erzh9af45h0",
      "fspDate": "2025-10-25T08:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_v9kyhsk000ztrm2erzh9af45h0",
        "bookingDate": "2025-10-25",
        "valueDate": "2025-10-25",
        "bookingDateTime": "2025-10-25T09:54:00.000Z",
        "valueDateTime": "2025-10-25T09:54:00.000Z",
        "transactionAmount": {
          "amount": "25.27",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tavily AI: TA-202510-9069",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tavily AI",
          "TA-202510-9069"
        ],
        "debtorName": "Tavily AI"
      },
      "paymentId": null,
      "reference": "TA-202510-9069",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ceerteshspk5wmka0h0ee",
      "clustering": {
        "description": "Tavily AI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tavily AI' based on payment details",
        "updatedAt": "2025-10-25T09:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tavily AI",
        "iban": "DE76632352131984600",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_m3gh5mar1et6d60hw30anx03yj",
      "createdAt": "2025-10-25T09:24:00.000Z",
      "updatedAt": "2025-10-25T09:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 13.94,
      "currency": "EUR",
      "description": "Payment to Finom: F-202510-3593",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hrpbg496ya0v11t80vg1ysasg3",
      "fspDate": "2025-10-25T08:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hrpbg496ya0v11t80vg1ysasg3",
        "bookingDate": "2025-10-25",
        "valueDate": "2025-10-25",
        "bookingDateTime": "2025-10-25T09:24:00.000Z",
        "valueDateTime": "2025-10-25T09:24:00.000Z",
        "transactionAmount": {
          "amount": "13.94",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Finom: F-202510-3593",
        "remittanceInformationUnstructuredArray": [
          "Payment to Finom",
          "F-202510-3593"
        ],
        "debtorName": "Finom"
      },
      "paymentId": null,
      "reference": "F-202510-3593",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0yxeshspjws0xeeqa1k",
      "clustering": {
        "description": "Finom",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Finom' based on payment details",
        "updatedAt": "2025-10-25T09:24:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Finom",
        "iban": "DE61856431117188260",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ksg9by2e4dmq714pzpk526btwz",
      "createdAt": "2025-10-25T08:07:00.000Z",
      "updatedAt": "2025-10-25T08:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 574.3,
      "currency": "GBP",
      "description": "Payment to Ginger Bistro: GB-202510-3513",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_08mnvcqtvzehw4s93b590ncwmf",
      "fspDate": "2025-10-25T07:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_08mnvcqtvzehw4s93b590ncwmf",
        "bookingDate": "2025-10-25",
        "valueDate": "2025-10-25",
        "bookingDateTime": "2025-10-25T08:07:00.000Z",
        "valueDateTime": "2025-10-25T08:07:00.000Z",
        "transactionAmount": {
          "amount": "574.30",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Ginger Bistro: GB-202510-3513",
        "remittanceInformationUnstructuredArray": [
          "Payment to Ginger Bistro",
          "GB-202510-3513"
        ],
        "debtorName": "Ginger Bistro"
      },
      "paymentId": null,
      "reference": "GB-202510-3513",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk6skfvhrjntfdd23av1a",
      "clustering": {
        "description": "Ginger Bistro",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Ginger Bistro' based on payment details",
        "updatedAt": "2025-10-25T08:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Ginger Bistro",
        "iban": null,
        "bic": null,
        "sortCode": "799695",
        "accountNumber": "93801868"
      }
    },
    {
      "id": "txn_01k65c32y7eshsph0vtc5pnxb3",
      "createdAt": "2025-10-24T15:32:00.000Z",
      "updatedAt": "2025-10-24T15:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 600,
      "currency": "EUR",
      "description": "To Company Formations International Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1yd1y32w3k5",
      "fspDate": "2025-10-24T14:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1yd1y32w3k5",
        "bookingDate": "2025-12-12",
        "valueDate": "2025-12-12",
        "bookingDateTime": "2025-12-12T08:21:00.000Z",
        "valueDateTime": "2025-12-12T08:21:00.000Z",
        "transactionAmount": {
          "amount": "-600.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Company Formations International Limited",
        "remittanceInformationUnstructuredArray": [
          "To Company Formations International Limited"
        ],
        "debtorName": "Company Formations International Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cvstpeshspn39955xdf4m",
      "clustering": {
        "description": "Company Formations International",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Company Formations International' from 'To Company Formations International Limited', removing the 'Limited' suffix.",
        "updatedAt": "2025-09-27T10:54:12.584Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfra9t7cx4hh",
      "createdAt": "2025-10-24T14:58:00.000Z",
      "updatedAt": "2025-10-24T14:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1800,
      "currency": "EUR",
      "description": "To Gocardless",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0ndk9hy6aha",
      "fspDate": "2025-10-24T13:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0ndk9hy6aha",
        "bookingDate": "2025-10-24",
        "valueDate": "2025-10-24",
        "bookingDateTime": "2025-10-24T13:58:00.000Z",
        "valueDateTime": "2025-10-24T13:58:00.000Z",
        "transactionAmount": {
          "amount": "-1800.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Gocardless",
        "remittanceInformationUnstructuredArray": [
          "To Gocardless"
        ],
        "debtorName": "GoCardless SAS"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5k6eshspjzd728cagsr",
      "clustering": {
        "description": "GoCardless SAS",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'GoCardless SAS' from 'To Gocardless'",
        "updatedAt": "2025-09-27T10:49:37.715Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_q7dwmmbvxfghzbmyv0b8g1rs62",
      "createdAt": "2025-10-24T11:23:00.000Z",
      "updatedAt": "2025-10-24T11:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 20138.1,
      "currency": "GBP",
      "description": "Payment from SmartScale Solutions - INV-202510-5161",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_3fbxxe9thq4jsb0hcyd4rzf2fc",
      "fspDate": "2025-10-24T10:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_3fbxxe9thq4jsb0hcyd4rzf2fc",
        "bookingDate": "2025-10-24",
        "valueDate": "2025-10-24",
        "bookingDateTime": "2025-10-24T11:23:00.000Z",
        "valueDateTime": "2025-10-24T11:23:00.000Z",
        "transactionAmount": {
          "amount": "20138.10",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from SmartScale Solutions - INV-202510-5161",
        "remittanceInformationUnstructuredArray": [
          "Payment from SmartScale Solutions",
          "INV-202510-5161"
        ],
        "creditorName": "SmartScale Solutions"
      },
      "paymentId": null,
      "reference": "INV-202510-5161",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_k9wmdwkshbazmh9e7aq4wj85ej",
      "clustering": {
        "description": "SmartScale Solutions",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'SmartScale Solutions'",
        "updatedAt": "2025-10-24T11:23:00.000Z"
      },
      "payer": {
        "name": "SmartScale Solutions",
        "iban": null,
        "bic": null,
        "sortCode": "140249",
        "accountNumber": "74639486"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspejjyq3k2nsh",
      "createdAt": "2025-10-24T10:58:00.000Z",
      "updatedAt": "2025-10-24T10:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5091.65,
      "currency": "EUR",
      "description": "Payment to Modulr Finance B.V EUR: SEA001-507BV",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3ke1et0eh2tc44mbrb0ysn3",
      "fspDate": "2025-10-24T09:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3ke1et0eh2tc44mbrb0ysn3",
        "bookingDate": "2025-10-24",
        "valueDate": "2025-10-24",
        "bookingDateTime": "2025-10-24T09:58:00.000Z",
        "valueDateTime": "2025-10-24T09:58:00.000Z",
        "transactionAmount": {
          "amount": "-5091.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Modulr Finance B.V. EUR: SEA001-507BV",
        "remittanceInformationUnstructuredArray": [
          "Payment to Modulr Finance B.V",
          "EUR: SEA001-507BV"
        ],
        "debtorName": "Modulr Finance B.V. EUR"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Modulr Finance' from 'Payment to Modulr Finance B.V. EUR: SEA001-507BV'",
        "updatedAt": "2025-09-27T10:40:26.791Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebzafvhrjmvc6999tcch",
      "createdAt": "2025-10-24T10:55:00.000Z",
      "updatedAt": "2025-10-24T10:55:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 450.23,
      "currency": "GBP",
      "description": "booking.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8kt64v285xc",
      "fspDate": "2025-10-24T09:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8kt64v285xc",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T10:41:00.000Z",
        "valueDateTime": "2025-12-28T10:41:00.000Z",
        "transactionAmount": {
          "amount": "-450.23",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "booking.com",
        "remittanceInformationUnstructuredArray": [
          "booking.com"
        ],
        "debtorName": "Booking.com"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9p5fvhrjp2td9pd9rat",
      "clustering": {
        "description": "Booking.com",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Booking.com' from 'booking.com'",
        "updatedAt": "2025-09-29T18:27:23.735Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_raq200khyzdaa40scmhdv8pgw3",
      "createdAt": "2025-10-24T09:15:00.000Z",
      "updatedAt": "2025-10-24T09:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 126.39,
      "currency": "EUR",
      "description": "Payment to Irish Rail: IR-202510-1524",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_g655wsr7c79vyx4anwk8eae8ft",
      "fspDate": "2025-10-24T08:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_g655wsr7c79vyx4anwk8eae8ft",
        "bookingDate": "2025-10-24",
        "valueDate": "2025-10-24",
        "bookingDateTime": "2025-10-24T09:15:00.000Z",
        "valueDateTime": "2025-10-24T09:15:00.000Z",
        "transactionAmount": {
          "amount": "126.39",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Irish Rail: IR-202510-1524",
        "remittanceInformationUnstructuredArray": [
          "Payment to Irish Rail",
          "IR-202510-1524"
        ],
        "debtorName": "Irish Rail"
      },
      "paymentId": null,
      "reference": "IR-202510-1524",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax69eshspjn90xv3cz0y",
      "clustering": {
        "description": "Irish Rail",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Irish Rail' based on payment details",
        "updatedAt": "2025-10-24T09:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Irish Rail",
        "iban": "DE64362905032473730",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nbr6bk9aqpm9470tbrbx0vp22s",
      "createdAt": "2025-10-24T08:09:00.000Z",
      "updatedAt": "2025-10-24T08:09:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 96.32,
      "currency": "EUR",
      "description": "Payment to Giftmall.es: G-202510-8027",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0kxfng9rgvdfqpk96ze5tmyf79",
      "fspDate": "2025-10-24T07:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0kxfng9rgvdfqpk96ze5tmyf79",
        "bookingDate": "2025-10-24",
        "valueDate": "2025-10-24",
        "bookingDateTime": "2025-10-24T08:09:00.000Z",
        "valueDateTime": "2025-10-24T08:09:00.000Z",
        "transactionAmount": {
          "amount": "96.32",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Giftmall.es: G-202510-8027",
        "remittanceInformationUnstructuredArray": [
          "Payment to Giftmall.es",
          "G-202510-8027"
        ],
        "debtorName": "Giftmall.es"
      },
      "paymentId": null,
      "reference": "G-202510-8027",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpfaeshspmwtrg2tk9zk",
      "clustering": {
        "description": "Giftmall.es",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Giftmall.es' based on payment details",
        "updatedAt": "2025-10-24T08:09:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Giftmall.es",
        "iban": "DE26594181828095468",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmp2nsqhq0eb",
      "createdAt": "2025-10-23T16:31:00.000Z",
      "updatedAt": "2025-10-23T16:31:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "GBP",
      "description": "wttj.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8eh8g3yce8w",
      "fspDate": "2025-10-23T15:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8eh8g3yce8w",
        "bookingDate": "2025-10-23",
        "valueDate": "2025-10-23",
        "bookingDateTime": "2025-10-23T15:31:00.000Z",
        "valueDateTime": "2025-10-23T15:31:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "wttj.com",
        "remittanceInformationUnstructuredArray": [
          "wttj.com"
        ],
        "debtorName": "Welcome to the Jungle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkfxeshspnwz7ebn2y1d",
      "clustering": {
        "description": "Welcome to the Jungle",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Welcome to the Jungle' from 'wttj.com'",
        "updatedAt": "2025-09-29T18:26:40.928Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_676xmbhyq8ptwpf147xr1tqpcm",
      "createdAt": "2025-10-23T14:36:00.000Z",
      "updatedAt": "2025-10-23T14:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2800,
      "currency": "USD",
      "description": "Payment to Anthropic PBC: ANT-2025-38291",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_239p29e932q4tthtzyn9e7hzt5",
      "fspDate": "2025-10-23T13:36:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_0z4cjsce0hg6a2mqesdmhvrhya",
        "bookingDate": "2025-10-23",
        "valueDate": "2025-10-23",
        "bookingDateTime": "2025-10-23T13:36:00.000Z",
        "valueDateTime": "2025-10-23T13:36:00.000Z",
        "transactionAmount": {
          "amount": "-2800.00",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic PBC: ANT-2025-38291",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic PBC: ANT-2025-38291"
        ],
        "debtorName": "Anthropic PBC"
      },
      "paymentId": null,
      "reference": "ANT-2025-38291",
      "beneficiaryId": "benf_xka3kqs02tx2re7za71wbk3yjd",
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_vnn6fxhm5daqv7bh39b88k2t9d",
      "clustering": {
        "description": "Anthropic PBC",
        "confidenceScore": "0.95",
        "rationale": "Identified as payment to Anthropic PBC based on remittance information.",
        "updatedAt": "2025-12-28T10:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic PBC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": "8801234567"
      }
    },
    {
      "id": "txn_7zb4dj3m8dsmmqvpdsaajzesb6",
      "createdAt": "2025-10-23T14:00:00.000Z",
      "updatedAt": "2025-10-23T14:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3259.43,
      "currency": "GBP",
      "description": "Payment to Yapily: Y-202510-2767",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xyt4009f753mr02qzp1z034b24",
      "fspDate": "2025-10-23T13:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xyt4009f753mr02qzp1z034b24",
        "bookingDate": "2025-10-23",
        "valueDate": "2025-10-23",
        "bookingDateTime": "2025-10-23T14:00:00.000Z",
        "valueDateTime": "2025-10-23T14:00:00.000Z",
        "transactionAmount": {
          "amount": "3259.43",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Yapily: Y-202510-2767",
        "remittanceInformationUnstructuredArray": [
          "Payment to Yapily",
          "Y-202510-2767"
        ],
        "debtorName": "Yapily"
      },
      "paymentId": null,
      "reference": "Y-202510-2767",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf94qfvhrjn51jet0pt56",
      "clustering": {
        "description": "Yapily",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Yapily' based on payment details",
        "updatedAt": "2025-10-23T14:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Yapily",
        "iban": null,
        "bic": null,
        "sortCode": "364264",
        "accountNumber": "88657101"
      }
    },
    {
      "id": "txn_91j4rnp0qr53r6pxqs3ypqr4bk",
      "createdAt": "2025-10-23T12:31:00.000Z",
      "updatedAt": "2025-10-23T12:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 38101.71,
      "currency": "GBP",
      "description": "Payment from TechCorp Industries - INV-202510-1618",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wr6wr7ydd6gm6jybr4mhdzvbk2",
      "fspDate": "2025-10-23T11:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wr6wr7ydd6gm6jybr4mhdzvbk2",
        "bookingDate": "2025-10-23",
        "valueDate": "2025-10-23",
        "bookingDateTime": "2025-10-23T12:31:00.000Z",
        "valueDateTime": "2025-10-23T12:31:00.000Z",
        "transactionAmount": {
          "amount": "38101.71",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from TechCorp Industries - INV-202510-1618",
        "remittanceInformationUnstructuredArray": [
          "Payment from TechCorp Industries",
          "INV-202510-1618"
        ],
        "creditorName": "TechCorp Industries"
      },
      "paymentId": null,
      "reference": "INV-202510-1618",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_hkz708jvra375hd19t65j65vvt",
      "clustering": {
        "description": "TechCorp Industries",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'TechCorp Industries'",
        "updatedAt": "2025-10-23T12:31:00.000Z"
      },
      "payer": {
        "name": "TechCorp Industries",
        "iban": null,
        "bic": null,
        "sortCode": "504559",
        "accountNumber": "66966926"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph1nv3p0wh64",
      "createdAt": "2025-10-23T09:02:00.000Z",
      "updatedAt": "2025-10-23T09:02:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1zhpv94yt9e",
      "fspDate": "2025-10-23T08:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1zhpv94yt9e",
        "bookingDate": "2025-10-23",
        "valueDate": "2025-10-23",
        "bookingDateTime": "2025-10-23T08:02:00.000Z",
        "valueDateTime": "2025-10-23T08:02:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:54:12.603Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_m27d6fe6sh11f7273ys4hzyejq",
      "createdAt": "2025-10-22T16:00:00.000Z",
      "updatedAt": "2025-10-22T16:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4100,
      "currency": "GBP",
      "description": "Salary - Michael Taylor - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_b998mk2a5910j2fvw0c8m11cm7",
      "fspDate": "2025-10-22T15:00:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_x62hfcvd47a0af0tqqp2wdeb0t",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T10:05:00.000Z",
        "valueDateTime": "2025-12-04T10:05:00.000Z",
        "transactionAmount": {
          "amount": "-4100.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Michael Taylor",
        "remittanceInformationUnstructuredArray": [
          "Salary - Michael Taylor"
        ]
      },
      "paymentId": "pmnt_kfrbmt4scanx753mqwq1jccppt",
      "reference": "PAY-DEC-2025-TAYLOR",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Michael Taylor",
        "iban": null,
        "bic": null,
        "sortCode": "20-00-00",
        "accountNumber": "45678901"
      }
    },
    {
      "id": "txn_01k65c32xzeshspen3m49dcfm5",
      "createdAt": "2025-10-22T15:32:00.000Z",
      "updatedAt": "2025-10-22T15:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5314.94,
      "currency": "EUR",
      "description": "Payment to Sophie Laurent: Aug 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gc1m5ne8prm02x1xf56mt3",
      "fspDate": "2025-10-22T14:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc1m5ne8prm02x1xf56mt3",
        "bookingDate": "2025-10-22",
        "valueDate": "2025-10-22",
        "bookingDateTime": "2025-10-22T14:32:00.000Z",
        "valueDateTime": "2025-10-22T14:32:00.000Z",
        "transactionAmount": {
          "amount": "-5314.94",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sophie Laurent: Aug 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sophie Laurent: Aug 2025 Payroll"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsseshspj86qckgs7na",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Sophie Laurent' from 'Payment to Sophie Laurent: Aug 2025 Payroll'",
        "updatedAt": "2025-09-27T10:40:26.875Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2z1xnp8zjhcnd5p3e2gc7hxwfx",
      "createdAt": "2025-10-22T14:49:00.000Z",
      "updatedAt": "2025-10-22T14:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 21.34,
      "currency": "EUR",
      "description": "Payment to Hotpot: H-202510-6387",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ssr2ek4h9p4v04398jzx3yp77f",
      "fspDate": "2025-10-22T13:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ssr2ek4h9p4v04398jzx3yp77f",
        "bookingDate": "2025-10-22",
        "valueDate": "2025-10-22",
        "bookingDateTime": "2025-10-22T14:49:00.000Z",
        "valueDateTime": "2025-10-22T14:49:00.000Z",
        "transactionAmount": {
          "amount": "21.34",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Hotpot: H-202510-6387",
        "remittanceInformationUnstructuredArray": [
          "Payment to Hotpot",
          "H-202510-6387"
        ],
        "debtorName": "Hotpot"
      },
      "paymentId": null,
      "reference": "H-202510-6387",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0wweshspkzqgyrcgqe7",
      "clustering": {
        "description": "Hotpot",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Hotpot' based on payment details",
        "updatedAt": "2025-10-22T14:49:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Hotpot",
        "iban": "DE58288028156652984",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jwkptj5a1j33c7vbncprg244fq",
      "createdAt": "2025-10-22T12:28:00.000Z",
      "updatedAt": "2025-10-22T12:28:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 282.97,
      "currency": "GBP",
      "description": "Payment to British Airways: BA-202510-4859",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_datz3kw3hjq0vkmnh204f7vpe3",
      "fspDate": "2025-10-22T11:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_datz3kw3hjq0vkmnh204f7vpe3",
        "bookingDate": "2025-10-22",
        "valueDate": "2025-10-22",
        "bookingDateTime": "2025-10-22T12:28:00.000Z",
        "valueDateTime": "2025-10-22T12:28:00.000Z",
        "transactionAmount": {
          "amount": "282.97",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to British Airways: BA-202510-4859",
        "remittanceInformationUnstructuredArray": [
          "Payment to British Airways",
          "BA-202510-4859"
        ],
        "debtorName": "British Airways"
      },
      "paymentId": null,
      "reference": "BA-202510-4859",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9m2fvhrjp2hhm5q9efq",
      "clustering": {
        "description": "British Airways",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'British Airways' based on payment details",
        "updatedAt": "2025-10-22T12:28:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "British Airways",
        "iban": null,
        "bic": null,
        "sortCode": "630012",
        "accountNumber": "76474436"
      }
    },
    {
      "id": "txn_9eh9w5z3syctjxyqje06gn9srn",
      "createdAt": "2025-10-22T11:29:00.000Z",
      "updatedAt": "2025-10-22T11:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 21.19,
      "currency": "EUR",
      "description": "Payment to Don Canizales: DC-202510-5198",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ge9bf8jvwysr9myrm1p6snjexq",
      "fspDate": "2025-10-22T10:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ge9bf8jvwysr9myrm1p6snjexq",
        "bookingDate": "2025-10-22",
        "valueDate": "2025-10-22",
        "bookingDateTime": "2025-10-22T11:29:00.000Z",
        "valueDateTime": "2025-10-22T11:29:00.000Z",
        "transactionAmount": {
          "amount": "21.19",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Don Canizales: DC-202510-5198",
        "remittanceInformationUnstructuredArray": [
          "Payment to Don Canizales",
          "DC-202510-5198"
        ],
        "debtorName": "Don Canizales"
      },
      "paymentId": null,
      "reference": "DC-202510-5198",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "clustering": {
        "description": "Don Canizales",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Don Canizales' based on payment details",
        "updatedAt": "2025-10-22T11:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Don Canizales",
        "iban": "DE81461357578611230",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfq4sv738yw2",
      "createdAt": "2025-10-22T10:20:00.000Z",
      "updatedAt": "2025-10-22T10:20:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25.1,
      "currency": "EUR",
      "description": "Tula Mexican Grill 02",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg246ze8pvk0kyss10hx29",
      "fspDate": "2025-10-22T09:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg246ze8pvk0kyss10hx29",
        "bookingDate": "2025-10-22",
        "valueDate": "2025-10-22",
        "bookingDateTime": "2025-10-22T09:20:00.000Z",
        "valueDateTime": "2025-10-22T09:20:00.000Z",
        "transactionAmount": {
          "amount": "-25.10",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tula Mexican Grill 02",
        "remittanceInformationUnstructuredArray": [
          "Tula Mexican Grill 02"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Tula Mexican Grill' from 'Tula Mexican Grill 02'",
        "updatedAt": "2025-09-27T10:49:37.670Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspevgg7vwcbsh",
      "createdAt": "2025-10-22T08:42:00.000Z",
      "updatedAt": "2025-10-22T08:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2ry974re009pf92mcarpyde",
      "fspDate": "2025-10-22T07:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ry974re009pf92mcarpyde",
        "bookingDate": "2025-10-22",
        "valueDate": "2025-10-22",
        "bookingDateTime": "2025-10-22T07:42:00.000Z",
        "valueDateTime": "2025-10-22T07:42:00.000Z",
        "transactionAmount": {
          "amount": "-2.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration Office",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Companies Registration Office' from the 'Companies Registration' transaction description.",
        "updatedAt": "2025-09-27T10:41:48.252Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jqpc48f6ayeq9n6aakg65m7f55",
      "createdAt": "2025-10-22T08:03:00.000Z",
      "updatedAt": "2025-10-22T08:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.07,
      "currency": "USD",
      "description": "Payment to Figma: F-202510-3758",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vwgrdze73j573rqqafjkxk1h4b",
      "fspDate": "2025-10-22T07:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vwgrdze73j573rqqafjkxk1h4b",
        "bookingDate": "2025-10-22",
        "valueDate": "2025-10-22",
        "bookingDateTime": "2025-10-22T08:03:00.000Z",
        "valueDateTime": "2025-10-22T08:03:00.000Z",
        "transactionAmount": {
          "amount": "15.07",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Figma: F-202510-3758",
        "remittanceInformationUnstructuredArray": [
          "Payment to Figma",
          "F-202510-3758"
        ],
        "debtorName": "Figma"
      },
      "paymentId": null,
      "reference": "F-202510-3758",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdq3eshspk9qt2a4er00",
      "clustering": {
        "description": "Figma",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Figma' based on payment details",
        "updatedAt": "2025-10-22T08:03:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Figma",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gmg3kwt3wer8cw3p3xqqw17c2n",
      "createdAt": "2025-10-21T13:05:00.000Z",
      "updatedAt": "2025-10-21T13:05:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 521.19,
      "currency": "GBP",
      "description": "Payment to Slack Technologies Limited: STL-202510-5848",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jp403y2pyng5jztzndqdnxwvky",
      "fspDate": "2025-10-21T12:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jp403y2pyng5jztzndqdnxwvky",
        "bookingDate": "2025-10-21",
        "valueDate": "2025-10-21",
        "bookingDateTime": "2025-10-21T13:05:00.000Z",
        "valueDateTime": "2025-10-21T13:05:00.000Z",
        "transactionAmount": {
          "amount": "521.19",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack Technologies Limited: STL-202510-5848",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack Technologies Limited",
          "STL-202510-5848"
        ],
        "debtorName": "Slack Technologies Limited"
      },
      "paymentId": null,
      "reference": "STL-202510-5848",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_6m3t4s5pcz3g5997sxc586yj3f",
      "clustering": {
        "description": "Slack Technologies Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack Technologies Limited' based on payment details",
        "updatedAt": "2025-10-21T13:05:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack Technologies Limited",
        "iban": null,
        "bic": null,
        "sortCode": "719534",
        "accountNumber": "88280574"
      }
    },
    {
      "id": "txn_akqx45452bfkr4j8desf9g0xmp",
      "createdAt": "2025-10-21T12:56:00.000Z",
      "updatedAt": "2025-10-21T12:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 32.1,
      "currency": "GBP",
      "description": "Payment to Argos: A-202510-2750",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1wc5b9nh8yzazjbwwwrb6rj79q",
      "fspDate": "2025-10-21T11:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1wc5b9nh8yzazjbwwwrb6rj79q",
        "bookingDate": "2025-10-21",
        "valueDate": "2025-10-21",
        "bookingDateTime": "2025-10-21T12:56:00.000Z",
        "valueDateTime": "2025-10-21T12:56:00.000Z",
        "transactionAmount": {
          "amount": "32.10",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Argos: A-202510-2750",
        "remittanceInformationUnstructuredArray": [
          "Payment to Argos",
          "A-202510-2750"
        ],
        "debtorName": "Argos"
      },
      "paymentId": null,
      "reference": "A-202510-2750",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgp9fvhrjp1ker17rwy0",
      "clustering": {
        "description": "Argos",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Argos' based on payment details",
        "updatedAt": "2025-10-21T12:56:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Argos",
        "iban": null,
        "bic": null,
        "sortCode": "261050",
        "accountNumber": "16150029"
      }
    },
    {
      "id": "txn_01k65c32xyeshspek1jqrh2d3r",
      "createdAt": "2025-10-21T12:54:00.000Z",
      "updatedAt": "2025-10-21T12:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1509.8,
      "currency": "EUR",
      "description": "Payment to Denis Breen & Co Ltd: INV-11086",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3jmms41e8prs3ret4pzn5nq",
      "fspDate": "2025-10-21T11:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3jmms41e8prs3ret4pzn5nq",
        "bookingDate": "2025-10-21",
        "valueDate": "2025-10-21",
        "bookingDateTime": "2025-10-21T11:54:00.000Z",
        "valueDateTime": "2025-10-21T11:54:00.000Z",
        "transactionAmount": {
          "amount": "-1509.80",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Denis Breen & Co Ltd: INV-11086",
        "remittanceInformationUnstructuredArray": [
          "Payment to Denis Breen & Co Ltd: INV-11086"
        ],
        "debtorName": "Denis Breen & Co Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zb1eshspj0854px1k2v",
      "clustering": {
        "description": "Denis Breen & Co Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Denis Breen & Co Ltd' from the transaction description, removing the 'Payment to ' prefix.",
        "updatedAt": "2025-09-27T10:40:36.530Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfhbnegxxbgr",
      "createdAt": "2025-10-21T09:56:00.000Z",
      "updatedAt": "2025-10-21T09:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 125,
      "currency": "EUR",
      "description": "Company Ultimate plan fee",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0xq4wv1fvqsn5xyw7t6f4t4",
      "fspDate": "2025-10-21T08:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xq4wv1fvqsn5xyw7t6f4t4",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T11:00:00.000Z",
        "valueDateTime": "2026-01-10T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-125.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Company Ultimate plan fee",
        "remittanceInformationUnstructuredArray": [
          "Company Ultimate plan fee"
        ],
        "debtorName": "Company"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mvseshspja4gsxz03at",
      "clustering": {
        "description": "Revolut Fees",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Revolut' as the institution name from 'Company Ultimate plan fee' and code: 'TRANSFER'",
        "updatedAt": "2025-09-27T10:49:04.226Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfa5g0ngswv7",
      "createdAt": "2025-10-20T11:31:00.000Z",
      "updatedAt": "2025-10-20T11:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6667,
      "currency": "EUR",
      "description": "Payment to Jonas Novak: 2025-00002",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1d323dme4dr9hh6b9d6j31s",
      "fspDate": "2025-10-20T10:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1d323dme4dr9hh6b9d6j31s",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T12:44:00.000Z",
        "valueDateTime": "2025-12-21T12:44:00.000Z",
        "transactionAmount": {
          "amount": "-6667.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jonas Novak: 2025-00002",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jonas Novak: 2025-00002"
        ],
        "debtorName": "Jonas Novak"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x01eshsphmk5k2axdrt",
      "clustering": {
        "description": "Jonas Novak",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Jonas Novak' from 'Payment to Jonas Novak: 2025-00002'",
        "updatedAt": "2025-09-27T10:45:11.623Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspenrq3fzf182",
      "createdAt": "2025-10-20T11:00:00.000Z",
      "updatedAt": "2025-10-20T11:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2210.77,
      "currency": "EUR",
      "description": "Payment to Aditi Gupta: Aug 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gc1mkye8prm08t7sdszqzr",
      "fspDate": "2025-10-20T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc1mkye8prm08t7sdszqzr",
        "bookingDate": "2025-10-20",
        "valueDate": "2025-10-20",
        "bookingDateTime": "2025-10-20T10:00:00.000Z",
        "valueDateTime": "2025-10-20T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-2210.77",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Aditi Gupta: Aug 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Aditi Gupta: Aug 2025 Payroll"
        ],
        "debtorName": "Colm Long"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtweshspj9z7hdr9t0r",
      "clustering": {
        "description": "Aditi Gupta",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Aditi Gupta' from 'Payment to Aditi Gupta: Aug 2025 Payroll'",
        "updatedAt": "2025-09-27T10:40:26.892Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgp6jqyzp6bb",
      "createdAt": "2025-10-20T09:50:00.000Z",
      "updatedAt": "2025-10-20T09:50:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 37,
      "currency": "EUR",
      "description": "Sq *amba",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1k6etmjgevj",
      "fspDate": "2025-10-20T08:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1k6etmjgevj",
        "bookingDate": "2025-10-20",
        "valueDate": "2025-10-20",
        "bookingDateTime": "2025-10-20T08:50:00.000Z",
        "valueDateTime": "2025-10-20T08:50:00.000Z",
        "transactionAmount": {
          "amount": "-37.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *amba",
        "remittanceInformationUnstructuredArray": [
          "Sq *amba"
        ],
        "debtorName": "Amba"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g1aeshsphp662hfbd17",
      "clustering": {
        "description": "Amba",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Amba' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.160Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_237et8cw10k1vvgx7pae7v1kpj",
      "createdAt": "2025-10-20T09:06:00.000Z",
      "updatedAt": "2025-10-20T09:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 158.7,
      "currency": "GBP",
      "description": "Payment to Ryanair: R-202510-7721",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_k48s9g49dxqrcck3agagbret4g",
      "fspDate": "2025-10-20T08:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_k48s9g49dxqrcck3agagbret4g",
        "bookingDate": "2025-10-20",
        "valueDate": "2025-10-20",
        "bookingDateTime": "2025-10-20T09:06:00.000Z",
        "valueDateTime": "2025-10-20T09:06:00.000Z",
        "transactionAmount": {
          "amount": "158.70",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Ryanair: R-202510-7721",
        "remittanceInformationUnstructuredArray": [
          "Payment to Ryanair",
          "R-202510-7721"
        ],
        "debtorName": "Ryanair"
      },
      "paymentId": null,
      "reference": "R-202510-7721",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctphbeshspmx6q13ktd74",
      "clustering": {
        "description": "Ryanair",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Ryanair' based on payment details",
        "updatedAt": "2025-10-20T09:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Ryanair",
        "iban": null,
        "bic": null,
        "sortCode": "234854",
        "accountNumber": "28399949"
      }
    },
    {
      "id": "txn_01k65c32y0eshsperetq3fh59s",
      "createdAt": "2025-10-20T07:14:00.000Z",
      "updatedAt": "2025-10-20T07:14:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 138.93,
      "currency": "EUR",
      "description": "Kandji",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k35t8tvce8prf0923nras428",
      "fspDate": "2025-10-20T06:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k35t8tvce8prf0923nras428",
        "bookingDate": "2025-10-20",
        "valueDate": "2025-10-20",
        "bookingDateTime": "2025-10-20T06:14:00.000Z",
        "valueDateTime": "2025-10-20T06:14:00.000Z",
        "transactionAmount": {
          "amount": "-138.93",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Kandji",
        "remittanceInformationUnstructuredArray": [
          "Kandji"
        ],
        "debtorName": "Kandji"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax4veshspjmy8ae028r6",
      "clustering": {
        "description": "Kandji",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Kandji' from the transaction description.",
        "updatedAt": "2025-09-27T10:41:48.169Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg74y3c2nyxd",
      "createdAt": "2025-10-19T15:18:00.000Z",
      "updatedAt": "2025-10-19T15:18:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 50000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2472e8pvk149z2tmrs96",
      "fspDate": "2025-10-19T14:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk149z2tmrs96",
        "bookingDate": "2025-10-19",
        "valueDate": "2025-10-19",
        "bookingDateTime": "2025-10-19T14:18:00.000Z",
        "valueDateTime": "2025-10-19T14:18:00.000Z",
        "transactionAmount": {
          "amount": "-50000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the currency conversion transaction with code 'EXCHANGE'.",
        "updatedAt": "2025-09-27T10:51:38.256Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mr4kwm55qdxb370bjw71gd64tn",
      "createdAt": "2025-10-19T14:30:00.000Z",
      "updatedAt": "2025-10-19T14:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.13,
      "currency": "USD",
      "description": "Payment to Notion: N-202510-5808",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mae7b6x93g79t0nm3f7r2m387c",
      "fspDate": "2025-10-19T13:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mae7b6x93g79t0nm3f7r2m387c",
        "bookingDate": "2025-10-19",
        "valueDate": "2025-10-19",
        "bookingDateTime": "2025-10-19T14:30:00.000Z",
        "valueDateTime": "2025-10-19T14:30:00.000Z",
        "transactionAmount": {
          "amount": "10.13",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Notion: N-202510-5808",
        "remittanceInformationUnstructuredArray": [
          "Payment to Notion",
          "N-202510-5808"
        ],
        "debtorName": "Notion"
      },
      "paymentId": null,
      "reference": "N-202510-5808",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtcyeshspk6y0e76tesb",
      "clustering": {
        "description": "Notion",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Notion' based on payment details",
        "updatedAt": "2025-10-19T14:30:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Notion",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm5n9ffnwyqv",
      "createdAt": "2025-10-19T12:24:00.000Z",
      "updatedAt": "2025-10-19T12:24:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 2050,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2fekr20fk7s42f5bdgbdz60",
      "fspDate": "2025-10-19T11:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2fekr20fk7s42f5bdgbdz60",
        "bookingDate": "2025-10-19",
        "valueDate": "2025-10-19",
        "bookingDateTime": "2025-10-19T11:24:00.000Z",
        "valueDateTime": "2025-10-19T11:24:00.000Z",
        "transactionAmount": {
          "amount": "2050.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.887Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5wn1a6fbvsxc7q3rrh65pa77vp",
      "createdAt": "2025-10-19T10:01:00.000Z",
      "updatedAt": "2025-10-19T10:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 16438.29,
      "currency": "GBP",
      "description": "Payment from Digital Ventures Group - INV-202510-2261",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wjavaf9a02ke4fk8gbwmqh2z47",
      "fspDate": "2025-10-19T09:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wjavaf9a02ke4fk8gbwmqh2z47",
        "bookingDate": "2025-10-19",
        "valueDate": "2025-10-19",
        "bookingDateTime": "2025-10-19T10:01:00.000Z",
        "valueDateTime": "2025-10-19T10:01:00.000Z",
        "transactionAmount": {
          "amount": "16438.29",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Digital Ventures Group - INV-202510-2261",
        "remittanceInformationUnstructuredArray": [
          "Payment from Digital Ventures Group",
          "INV-202510-2261"
        ],
        "creditorName": "Digital Ventures Group"
      },
      "paymentId": null,
      "reference": "INV-202510-2261",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_mj6n80che7b1rf41e9c0gtanqb",
      "clustering": {
        "description": "Digital Ventures Group",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Digital Ventures Group'",
        "updatedAt": "2025-10-19T10:01:00.000Z"
      },
      "payer": {
        "name": "Digital Ventures Group",
        "iban": null,
        "bic": null,
        "sortCode": "216555",
        "accountNumber": "46447710"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspeq9spwncy4h",
      "createdAt": "2025-10-19T09:33:00.000Z",
      "updatedAt": "2025-10-19T09:33:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 13.5,
      "currency": "EUR",
      "description": "Jarek's Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k38cnkeheh2szmp8mbvzr6nx",
      "fspDate": "2025-10-19T08:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k38cnkeheh2szmp8mbvzr6nx",
        "bookingDate": "2025-10-19",
        "valueDate": "2025-10-19",
        "bookingDateTime": "2025-10-19T08:33:00.000Z",
        "valueDateTime": "2025-10-19T08:33:00.000Z",
        "transactionAmount": {
          "amount": "-13.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Jarek's Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Jarek's Kitchen"
        ],
        "debtorName": "Jarek's Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9ynmeshspjjhrjb91rve",
      "clustering": {
        "description": "Jarek's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Jarek's Kitchen' from the transaction description.",
        "updatedAt": "2025-09-27T10:41:48.140Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf483emkqvm5",
      "createdAt": "2025-10-19T08:41:00.000Z",
      "updatedAt": "2025-10-19T08:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 34.55,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1wkxf1tena8nqvfg1ctfkd3",
      "fspDate": "2025-10-19T07:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1wkxf1tena8nqvfg1ctfkd3",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T08:00:00.000Z",
        "valueDateTime": "2026-01-05T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-34.55",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Cursor' from the transaction description, removing the ', Ai Powered Ide' suffix.",
        "updatedAt": "2025-09-27T10:43:55.520Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjmafmr8011rx",
      "createdAt": "2025-10-19T08:22:00.000Z",
      "updatedAt": "2025-10-19T08:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17104.51,
      "currency": "GBP",
      "description": "To Amwins Global Risks B.V.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk82whzetb6f3",
      "fspDate": "2025-10-19T07:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk82whzetb6f3",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T08:00:00.000Z",
        "valueDateTime": "2026-01-06T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-17104.51",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Amwins Global Risks B.V.",
        "remittanceInformationUnstructuredArray": [
          "To Amwins Global Risks B.V."
        ],
        "debtorName": "Modulr Finance B.V. EUR"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2bfvhrjnbz808baykh",
      "clustering": {
        "description": "Amwins Global Risks B.V.",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Amwins Global Risks B.V.' from 'To Amwins Global Risks B.V.'",
        "updatedAt": "2025-09-29T18:24:29.663Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspejz8bd4s7aq",
      "createdAt": "2025-10-19T07:26:00.000Z",
      "updatedAt": "2025-10-19T07:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 615,
      "currency": "EUR",
      "description": "Payment to Denis Breen & Co Ltd: INV-11134",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3jn5vbre8prs3vbznnpz7jc",
      "fspDate": "2025-10-19T06:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3jn5vbre8prs3vbznnpz7jc",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T10:00:00.000Z",
        "valueDateTime": "2026-01-02T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-615.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Denis Breen & Co Ltd: INV-11134",
        "remittanceInformationUnstructuredArray": [
          "Payment to Denis Breen & Co Ltd: INV-11134"
        ],
        "debtorName": "Denis Breen & Co Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zb1eshspj0854px1k2v",
      "clustering": {
        "description": "Denis Breen & Co",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Denis Breen & Co' from 'Payment to Denis Breen & Co Ltd: INV-11134'",
        "updatedAt": "2025-09-27T10:40:26.797Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspewyzskkpeb5",
      "createdAt": "2025-10-18T16:49:00.000Z",
      "updatedAt": "2025-10-18T16:49:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 69,
      "currency": "EUR",
      "description": "Financial Times",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2pbwp66fzwbe0xfesp3bb14",
      "fspDate": "2025-10-18T15:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2pbwp66fzwbe0xfesp3bb14",
        "bookingDate": "2025-10-18",
        "valueDate": "2025-10-18",
        "bookingDateTime": "2025-10-18T15:49:00.000Z",
        "valueDateTime": "2025-10-18T15:49:00.000Z",
        "transactionAmount": {
          "amount": "-69.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Financial Times",
        "remittanceInformationUnstructuredArray": [
          "Financial Times"
        ],
        "debtorName": "Financial Times"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gjeshspjygqrrg6sk5",
      "clustering": {
        "description": "Financial Times",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Financial Times' from 'Financial Times'",
        "updatedAt": "2025-09-27T10:42:40.346Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph0ekfk1wkqy",
      "createdAt": "2025-10-18T15:24:00.000Z",
      "updatedAt": "2025-10-18T15:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 450,
      "currency": "EUR",
      "description": "To Company Formations International Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1xyh5cg75k4",
      "fspDate": "2025-10-18T14:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1xyh5cg75k4",
        "bookingDate": "2025-10-18",
        "valueDate": "2025-10-18",
        "bookingDateTime": "2025-10-18T14:24:00.000Z",
        "valueDateTime": "2025-10-18T14:24:00.000Z",
        "transactionAmount": {
          "amount": "-450.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Company Formations International Limited",
        "remittanceInformationUnstructuredArray": [
          "To Company Formations International Limited"
        ],
        "debtorName": "Company Formations International Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cvstpeshspn39955xdf4m",
      "clustering": {
        "description": "Company Formations International",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Company Formations International' from 'To Company Formations International Limited', removing the 'Limited' suffix.",
        "updatedAt": "2025-09-27T10:54:12.569Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspeh5gf7z5f50",
      "createdAt": "2025-10-18T14:07:00.000Z",
      "updatedAt": "2025-10-18T14:07:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 10000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3n8n6ekeh2tcaqee732e7dw",
      "fspDate": "2025-10-18T13:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n6ekeh2tcaqee732e7dw",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T12:00:00.000Z",
        "valueDateTime": "2026-01-05T12:00:00.000Z",
        "transactionAmount": {
          "amount": "-10000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name due to the 'EXCHANGE' transaction code.",
        "updatedAt": "2025-09-27T10:39:39.714Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y8eshsph6hgst2z17s",
      "createdAt": "2025-10-18T11:40:00.000Z",
      "updatedAt": "2025-10-18T11:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6003.21,
      "currency": "EUR",
      "description": "To Lucia Moretti",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk249nj4npthy",
      "fspDate": "2025-10-18T10:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk249nj4npthy",
        "bookingDate": "2025-10-18",
        "valueDate": "2025-10-18",
        "bookingDateTime": "2025-10-18T10:40:00.000Z",
        "valueDateTime": "2025-10-18T10:40:00.000Z",
        "transactionAmount": {
          "amount": "-6003.21",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Lucia Moretti",
        "remittanceInformationUnstructuredArray": [
          "To Lucia Moretti"
        ],
        "debtorName": "Lucia Moretti"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsbeshspj7jp8q6rygp",
      "clustering": {
        "description": "Lucia Moretti",
        "confidenceScore": "0.95",
        "rationale": "Extracted core recipient name 'Lucia Moretti' from 'To Lucia Moretti'",
        "updatedAt": "2025-09-27T10:54:50.895Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9rww229fk1zckdbksy77k45tem",
      "createdAt": "2025-10-18T11:02:00.000Z",
      "updatedAt": "2025-10-18T11:02:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4.87,
      "currency": "EUR",
      "description": "Payment to Pinecone Coffee: PC-202510-7097",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_7ce8nmp31tbd0qrgcmgfzawzxw",
      "fspDate": "2025-10-18T10:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_7ce8nmp31tbd0qrgcmgfzawzxw",
        "bookingDate": "2025-10-18",
        "valueDate": "2025-10-18",
        "bookingDateTime": "2025-10-18T11:02:00.000Z",
        "valueDateTime": "2025-10-18T11:02:00.000Z",
        "transactionAmount": {
          "amount": "4.87",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pinecone Coffee: PC-202510-7097",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pinecone Coffee",
          "PC-202510-7097"
        ],
        "debtorName": "Pinecone Coffee"
      },
      "paymentId": null,
      "reference": "PC-202510-7097",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh31eshspkh23ahabkmn",
      "clustering": {
        "description": "Pinecone Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pinecone Coffee' based on payment details",
        "updatedAt": "2025-10-18T11:02:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pinecone Coffee",
        "iban": "DE16976959300604072",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspenm4ckma64x",
      "createdAt": "2025-10-18T07:30:00.000Z",
      "updatedAt": "2025-10-18T07:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4914.17,
      "currency": "EUR",
      "description": "Payment to Hugo Weber: Aug 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gc1mj7e8prm0802v5nn9gn",
      "fspDate": "2025-10-18T06:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc1mj7e8prm0802v5nn9gn",
        "bookingDate": "2025-10-18",
        "valueDate": "2025-10-18",
        "bookingDateTime": "2025-10-18T06:30:00.000Z",
        "valueDateTime": "2025-10-18T06:30:00.000Z",
        "transactionAmount": {
          "amount": "-4914.17",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Hugo Weber: Aug 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Hugo Weber: Aug 2025 Payroll"
        ],
        "debtorName": "Hugo Weber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtteshspj9hmeqmzmdw",
      "clustering": {
        "description": "Hugo Weber",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Hugo Weber' from 'Payment to Hugo Weber: Aug 2025 Payroll'",
        "updatedAt": "2025-09-27T10:40:26.888Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5bwrztt6sa5wcyr7g7jjk6we48",
      "createdAt": "2025-10-17T14:07:00.000Z",
      "updatedAt": "2025-10-17T14:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 52.47,
      "currency": "GBP",
      "description": "Payment to Pembroke Hall Limited: PHL-202510-1649",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_y1k0z6dx5kd7m24a6qqertdmht",
      "fspDate": "2025-10-17T13:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_y1k0z6dx5kd7m24a6qqertdmht",
        "bookingDate": "2025-10-17",
        "valueDate": "2025-10-17",
        "bookingDateTime": "2025-10-17T14:07:00.000Z",
        "valueDateTime": "2025-10-17T14:07:00.000Z",
        "transactionAmount": {
          "amount": "52.47",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pembroke Hall Limited: PHL-202510-1649",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pembroke Hall Limited",
          "PHL-202510-1649"
        ],
        "debtorName": "Pembroke Hall Limited"
      },
      "paymentId": null,
      "reference": "PHL-202510-1649",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fpgn1yfzz9aex3cr77xa32",
      "clustering": {
        "description": "Pembroke Hall Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pembroke Hall Limited' based on payment details",
        "updatedAt": "2025-10-17T14:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pembroke Hall Limited",
        "iban": null,
        "bic": null,
        "sortCode": "319744",
        "accountNumber": "32948536"
      }
    },
    {
      "id": "txn_2ek4xyb3qtgt2q0beyjj7hehp0",
      "createdAt": "2025-10-17T12:55:00.000Z",
      "updatedAt": "2025-10-17T12:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 44.17,
      "currency": "EUR",
      "description": "Payment to Mamma Mia Restaurant: MMR-202510-5901",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6dzj4phx69x3g7p36xjgy960z6",
      "fspDate": "2025-10-17T11:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6dzj4phx69x3g7p36xjgy960z6",
        "bookingDate": "2025-10-17",
        "valueDate": "2025-10-17",
        "bookingDateTime": "2025-10-17T12:55:00.000Z",
        "valueDateTime": "2025-10-17T12:55:00.000Z",
        "transactionAmount": {
          "amount": "44.17",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mamma Mia Restaurant: MMR-202510-5901",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mamma Mia Restaurant",
          "MMR-202510-5901"
        ],
        "debtorName": "Mamma Mia Restaurant"
      },
      "paymentId": null,
      "reference": "MMR-202510-5901",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj1yeshspngr1g523f6q",
      "clustering": {
        "description": "Mamma Mia Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mamma Mia Restaurant' based on payment details",
        "updatedAt": "2025-10-17T12:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mamma Mia Restaurant",
        "iban": "DE82965985060591170",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9byaxmx23bx3ymyzgzkfnymqpm",
      "createdAt": "2025-10-17T11:16:00.000Z",
      "updatedAt": "2025-10-17T11:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 28.31,
      "currency": "EUR",
      "description": "Payment to Anthony Moore: AM-202510-1692",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6v4a82k1rh9gqcd51ns6h4t7yt",
      "fspDate": "2025-10-17T10:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6v4a82k1rh9gqcd51ns6h4t7yt",
        "bookingDate": "2025-10-17",
        "valueDate": "2025-10-17",
        "bookingDateTime": "2025-10-17T11:16:00.000Z",
        "valueDateTime": "2025-10-17T11:16:00.000Z",
        "transactionAmount": {
          "amount": "28.31",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthony Moore: AM-202510-1692",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthony Moore",
          "AM-202510-1692"
        ],
        "debtorName": "Anthony Moore"
      },
      "paymentId": null,
      "reference": "AM-202510-1692",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a2keshspnzq7m9sbpn2",
      "clustering": {
        "description": "Anthony Moore",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthony Moore' based on payment details",
        "updatedAt": "2025-10-17T11:16:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthony Moore",
        "iban": "DE82856989614701140",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf5e2mfqmwrb",
      "createdAt": "2025-10-17T09:50:00.000Z",
      "updatedAt": "2025-10-17T09:50:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 101.65,
      "currency": "EUR",
      "description": "Linkedin Pre P48874935",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1qf3txaexy9c2ehhera1n6v",
      "fspDate": "2025-10-17T08:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1qf3txaexy9c2ehhera1n6v",
        "bookingDate": "2025-10-17",
        "valueDate": "2025-10-17",
        "bookingDateTime": "2025-10-17T08:50:00.000Z",
        "valueDateTime": "2025-10-17T08:50:00.000Z",
        "transactionAmount": {
          "amount": "-101.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin Pre P48874935",
        "remittanceInformationUnstructuredArray": [
          "Linkedin Pre P48874935"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'LinkedIn' from the transaction description, removing the 'Pre P48874935' suffix.",
        "updatedAt": "2025-09-27T10:43:55.555Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg5vv407kgq3",
      "createdAt": "2025-10-17T07:28:00.000Z",
      "updatedAt": "2025-10-17T07:28:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 39,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2472e8pvk13zbmg0p9qk",
      "fspDate": "2025-10-17T06:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk13zbmg0p9qk",
        "bookingDate": "2025-10-17",
        "valueDate": "2025-10-17",
        "bookingDateTime": "2025-10-17T06:28:00.000Z",
        "valueDateTime": "2025-10-17T06:28:00.000Z",
        "transactionAmount": {
          "amount": "-39.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'DocuSign' from 'Docusign'.",
        "updatedAt": "2025-09-27T10:51:38.216Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ra9nkz05atsmxyr2g486pr1z99",
      "createdAt": "2025-10-16T14:44:00.000Z",
      "updatedAt": "2025-10-16T14:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 26461.86,
      "currency": "EUR",
      "description": "Payment from Nordic Digital AB - INV-202510-2732",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_066gzqcsg55ct266sh0rz896xy",
      "fspDate": "2025-10-16T13:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_066gzqcsg55ct266sh0rz896xy",
        "bookingDate": "2025-10-16",
        "valueDate": "2025-10-16",
        "bookingDateTime": "2025-10-16T14:44:00.000Z",
        "valueDateTime": "2025-10-16T14:44:00.000Z",
        "transactionAmount": {
          "amount": "26461.86",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nordic Digital AB - INV-202510-2732",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nordic Digital AB",
          "INV-202510-2732"
        ],
        "creditorName": "Nordic Digital AB"
      },
      "paymentId": null,
      "reference": "INV-202510-2732",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_q7sgetg8gwgf23ac9gdqmk8cz4",
      "clustering": {
        "description": "Nordic Digital AB",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nordic Digital AB'",
        "updatedAt": "2025-10-16T14:44:00.000Z"
      },
      "payer": {
        "name": "Nordic Digital AB",
        "iban": "DE76053398027702320",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4z1v4g89ag671ascee183y4jjq",
      "createdAt": "2025-10-16T13:50:00.000Z",
      "updatedAt": "2025-10-16T13:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 19188.84,
      "currency": "EUR",
      "description": "Payment from Alpine Software SA - INV-202510-2250",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_15r0k9bh2mg940eq7tajvwa5k6",
      "fspDate": "2025-10-16T12:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_15r0k9bh2mg940eq7tajvwa5k6",
        "bookingDate": "2025-10-16",
        "valueDate": "2025-10-16",
        "bookingDateTime": "2025-10-16T13:50:00.000Z",
        "valueDateTime": "2025-10-16T13:50:00.000Z",
        "transactionAmount": {
          "amount": "19188.84",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Alpine Software SA - INV-202510-2250",
        "remittanceInformationUnstructuredArray": [
          "Payment from Alpine Software SA",
          "INV-202510-2250"
        ],
        "creditorName": "Alpine Software SA"
      },
      "paymentId": null,
      "reference": "INV-202510-2250",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_nk7g93a6fpe8ybm4hppdmmfgsw",
      "clustering": {
        "description": "Alpine Software SA",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Alpine Software SA'",
        "updatedAt": "2025-10-16T13:50:00.000Z"
      },
      "payer": {
        "name": "Alpine Software SA",
        "iban": "DE83758541847357060",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fzfkrvsk5by8hjzct4ryw1zq4w",
      "createdAt": "2025-10-16T13:48:00.000Z",
      "updatedAt": "2025-10-16T13:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 19.75,
      "currency": "USD",
      "description": "Payment to Claude.ai: C-202510-2239",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_njgqkzjgmgr9300zvc0xygz4gs",
      "fspDate": "2025-10-16T12:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_njgqkzjgmgr9300zvc0xygz4gs",
        "bookingDate": "2025-10-16",
        "valueDate": "2025-10-16",
        "bookingDateTime": "2025-10-16T13:48:00.000Z",
        "valueDateTime": "2025-10-16T13:48:00.000Z",
        "transactionAmount": {
          "amount": "19.75",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Claude.ai: C-202510-2239",
        "remittanceInformationUnstructuredArray": [
          "Payment to Claude.ai",
          "C-202510-2239"
        ],
        "debtorName": "Claude.ai"
      },
      "paymentId": null,
      "reference": "C-202510-2239",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5j1eshspjz017vq1wgn",
      "clustering": {
        "description": "Claude.ai",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Claude.ai' based on payment details",
        "updatedAt": "2025-10-16T13:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Claude.ai",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgndze6vtm08",
      "createdAt": "2025-10-16T11:11:00.000Z",
      "updatedAt": "2025-10-16T11:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3690,
      "currency": "EUR",
      "description": "Payment to PEMBROKEHALL LTD: 150660",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jy74dyj4ena8589xsxd6fgcy",
      "fspDate": "2025-10-16T10:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jy74dyj4ena8589xsxd6fgcy",
        "bookingDate": "2025-10-16",
        "valueDate": "2025-10-16",
        "bookingDateTime": "2025-10-16T10:11:00.000Z",
        "valueDateTime": "2025-10-16T10:11:00.000Z",
        "transactionAmount": {
          "amount": "-3690.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to PEMBROKEHALL LTD: 150660",
        "remittanceInformationUnstructuredArray": [
          "Payment to PEMBROKEHALL LTD: 150660"
        ],
        "debtorName": "PEMBROKEHALL LTD"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzdeshsphm46adfgbg7",
      "clustering": {
        "description": "PEMBROKEHALL LTD",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'PEMBROKEHALL LTD' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.117Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7m790x49kjvsxw6p2hs99hkb37",
      "createdAt": "2025-10-16T08:07:00.000Z",
      "updatedAt": "2025-10-16T08:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 23.21,
      "currency": "EUR",
      "description": "Payment to Muhammad Tashf: MT-202510-9997",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_tp7bpj7vz254jegbgbtheq3az5",
      "fspDate": "2025-10-16T07:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_tp7bpj7vz254jegbgbtheq3az5",
        "bookingDate": "2025-10-16",
        "valueDate": "2025-10-16",
        "bookingDateTime": "2025-10-16T08:07:00.000Z",
        "valueDateTime": "2025-10-16T08:07:00.000Z",
        "transactionAmount": {
          "amount": "23.21",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Muhammad Tashf: MT-202510-9997",
        "remittanceInformationUnstructuredArray": [
          "Payment to Muhammad Tashf",
          "MT-202510-9997"
        ],
        "debtorName": "Muhammad Tashf"
      },
      "paymentId": null,
      "reference": "MT-202510-9997",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkgjeshspnx4pqb9b6ze",
      "clustering": {
        "description": "Muhammad Tashf",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Muhammad Tashf' based on payment details",
        "updatedAt": "2025-10-16T08:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Muhammad Tashf",
        "iban": "DE57080486073091300",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspeyn2tx3d2bx",
      "createdAt": "2025-10-16T07:38:00.000Z",
      "updatedAt": "2025-10-16T07:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1800,
      "currency": "EUR",
      "description": "To Gocardless",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2feknczfk7s42amjkj967v7",
      "fspDate": "2025-10-16T06:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2feknczfk7s42amjkj967v7",
        "bookingDate": "2025-10-16",
        "valueDate": "2025-10-16",
        "bookingDateTime": "2025-10-16T06:38:00.000Z",
        "valueDateTime": "2025-10-16T06:38:00.000Z",
        "transactionAmount": {
          "amount": "-1800.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Gocardless",
        "remittanceInformationUnstructuredArray": [
          "To Gocardless"
        ],
        "debtorName": "GoCardless SAS"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5k6eshspjzd728cagsr",
      "clustering": {
        "description": "GoCardless",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'GoCardless' from 'To Gocardless'",
        "updatedAt": "2025-09-27T10:42:40.392Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_brjrkzf8fmnr6vh5bbya68qrj2",
      "createdAt": "2025-10-15T15:13:00.000Z",
      "updatedAt": "2025-10-15T15:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 26828.93,
      "currency": "GBP",
      "description": "Payment from DataDriven Analytics - INV-202510-7314",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_symghhjkqqtm9vyre0rz648d7b",
      "fspDate": "2025-10-15T14:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_symghhjkqqtm9vyre0rz648d7b",
        "bookingDate": "2025-10-15",
        "valueDate": "2025-10-15",
        "bookingDateTime": "2025-10-15T15:13:00.000Z",
        "valueDateTime": "2025-10-15T15:13:00.000Z",
        "transactionAmount": {
          "amount": "26828.93",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from DataDriven Analytics - INV-202510-7314",
        "remittanceInformationUnstructuredArray": [
          "Payment from DataDriven Analytics",
          "INV-202510-7314"
        ],
        "creditorName": "DataDriven Analytics"
      },
      "paymentId": null,
      "reference": "INV-202510-7314",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_jy64mwn8y868akxp0c6s337dms",
      "clustering": {
        "description": "DataDriven Analytics",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'DataDriven Analytics'",
        "updatedAt": "2025-10-15T15:13:00.000Z"
      },
      "payer": {
        "name": "DataDriven Analytics",
        "iban": null,
        "bic": null,
        "sortCode": "804455",
        "accountNumber": "97445400"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspet5tsztfxgr",
      "createdAt": "2025-10-15T10:29:00.000Z",
      "updatedAt": "2025-10-15T10:29:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 37.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k30nfe7xfzwbhvd11fzj0nah",
      "fspDate": "2025-10-15T09:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k30nfe7xfzwbhvd11fzj0nah",
        "bookingDate": "2025-10-15",
        "valueDate": "2025-10-15",
        "bookingDateTime": "2025-10-15T09:29:00.000Z",
        "valueDateTime": "2025-10-15T09:29:00.000Z",
        "transactionAmount": {
          "amount": "-37.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Zakura' from the transaction description.",
        "updatedAt": "2025-09-27T10:41:48.218Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmhqdpp1c0tv",
      "createdAt": "2025-10-15T09:25:00.000Z",
      "updatedAt": "2025-10-15T09:25:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "GBP",
      "description": "Linkedin P636751444",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8a2xt7vnk5h",
      "fspDate": "2025-10-15T08:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8a2xt7vnk5h",
        "bookingDate": "2025-10-15",
        "valueDate": "2025-10-15",
        "bookingDateTime": "2025-10-15T08:25:00.000Z",
        "valueDateTime": "2025-10-15T08:25:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin P636751444",
        "remittanceInformationUnstructuredArray": [
          "Linkedin P636751444"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'LinkedIn' from 'Linkedin P636751444'",
        "updatedAt": "2025-09-29T18:25:48.475Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgt3v0y0zjfm",
      "createdAt": "2025-10-15T08:20:00.000Z",
      "updatedAt": "2025-10-15T08:20:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 35,
      "currency": "EUR",
      "description": "Frn*hold.free-Now.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1pv5x1qghxq",
      "fspDate": "2025-10-15T07:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1pv5x1qghxq",
        "bookingDate": "2025-10-15",
        "valueDate": "2025-10-15",
        "bookingDateTime": "2025-10-15T07:20:00.000Z",
        "valueDateTime": "2025-10-15T07:20:00.000Z",
        "transactionAmount": {
          "amount": "-35.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Frn*hold.free-Now.com",
        "remittanceInformationUnstructuredArray": [
          "Frn*hold.free-Now.com"
        ],
        "debtorName": "Free Now"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj31eshspnh3qzqhcd5r",
      "clustering": {
        "description": "Free Now",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Free Now' from the raw transaction description, removing the 'Frn*hold.free-Now.com' prefix.",
        "updatedAt": "2025-09-27T10:53:55.662Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qa4ypmeysx4r49xxa3zyg79vg9",
      "createdAt": "2025-10-14T15:13:00.000Z",
      "updatedAt": "2025-10-14T15:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.14,
      "currency": "GBP",
      "description": "Payment to FCB Coffee: FC-202510-3627",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_aysft5hkvwa047fqfvcnswg1ww",
      "fspDate": "2025-10-14T14:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_aysft5hkvwa047fqfvcnswg1ww",
        "bookingDate": "2025-10-14",
        "valueDate": "2025-10-14",
        "bookingDateTime": "2025-10-14T15:13:00.000Z",
        "valueDateTime": "2025-10-14T15:13:00.000Z",
        "transactionAmount": {
          "amount": "3.14",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to FCB Coffee: FC-202510-3627",
        "remittanceInformationUnstructuredArray": [
          "Payment to FCB Coffee",
          "FC-202510-3627"
        ],
        "debtorName": "FCB Coffee"
      },
      "paymentId": null,
      "reference": "FC-202510-3627",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmmfvhrjp1d532dm1jy",
      "clustering": {
        "description": "FCB Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'FCB Coffee' based on payment details",
        "updatedAt": "2025-10-14T15:13:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "FCB Coffee",
        "iban": null,
        "bic": null,
        "sortCode": "772154",
        "accountNumber": "99553799"
      }
    },
    {
      "id": "txn_9mgh87gx8z3zqp615s8fkqc80n",
      "createdAt": "2025-10-14T14:42:00.000Z",
      "updatedAt": "2025-10-14T14:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3432.84,
      "currency": "USD",
      "description": "Payment to OpenAI, LLC: OL-202510-1745",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zzhn9arestx4b62rbbn1e1ymkv",
      "fspDate": "2025-10-14T13:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zzhn9arestx4b62rbbn1e1ymkv",
        "bookingDate": "2025-10-14",
        "valueDate": "2025-10-14",
        "bookingDateTime": "2025-10-14T14:42:00.000Z",
        "valueDateTime": "2025-10-14T14:42:00.000Z",
        "transactionAmount": {
          "amount": "3432.84",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to OpenAI, LLC: OL-202510-1745",
        "remittanceInformationUnstructuredArray": [
          "Payment to OpenAI, LLC",
          "OL-202510-1745"
        ],
        "debtorName": "OpenAI, LLC"
      },
      "paymentId": null,
      "reference": "OL-202510-1745",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1bss5kk7dqrqznncrn6c0w8y4p",
      "clustering": {
        "description": "OpenAI, LLC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'OpenAI, LLC' based on payment details",
        "updatedAt": "2025-10-14T14:42:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "OpenAI, LLC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf8qr0bmdj2n",
      "createdAt": "2025-10-14T10:43:00.000Z",
      "updatedAt": "2025-10-14T10:43:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.51,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1fpmbemeh1r152xnpv2rgw4",
      "fspDate": "2025-10-14T09:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1fpmbemeh1r152xnpv2rgw4",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T08:00:00.000Z",
        "valueDateTime": "2026-01-06T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-17.51",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Cursor' from 'Cursor, Ai Powered Ide'",
        "updatedAt": "2025-09-27T10:45:11.586Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgxydte4c7tz",
      "createdAt": "2025-10-14T10:43:00.000Z",
      "updatedAt": "2025-10-14T10:43:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 28,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1vw40pmwkqf",
      "fspDate": "2025-10-14T09:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1vw40pmwkqf",
        "bookingDate": "2025-10-14",
        "valueDate": "2025-10-14",
        "bookingDateTime": "2025-10-14T09:43:00.000Z",
        "valueDateTime": "2025-10-14T09:43:00.000Z",
        "transactionAmount": {
          "amount": "-28.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Burger Cartel' from 'Burger Cartel Limited', removing the 'Limited' suffix.",
        "updatedAt": "2025-09-27T10:54:12.508Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_40xh8bc8bv5f9fcns9rk0ek14n",
      "createdAt": "2025-10-14T10:21:00.000Z",
      "updatedAt": "2025-10-14T10:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 131.88,
      "currency": "EUR",
      "description": "Payment to Slack: S-202510-9639",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mshbva9ntgsr2fbz9rvkmqhc7p",
      "fspDate": "2025-10-14T09:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mshbva9ntgsr2fbz9rvkmqhc7p",
        "bookingDate": "2025-10-14",
        "valueDate": "2025-10-14",
        "bookingDateTime": "2025-10-14T10:21:00.000Z",
        "valueDateTime": "2025-10-14T10:21:00.000Z",
        "transactionAmount": {
          "amount": "131.88",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack: S-202510-9639",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack",
          "S-202510-9639"
        ],
        "debtorName": "Slack"
      },
      "paymentId": null,
      "reference": "S-202510-9639",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtb9eshspk6e4wt4npvh",
      "clustering": {
        "description": "Slack",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack' based on payment details",
        "updatedAt": "2025-10-14T10:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack",
        "iban": "DE30625866184519508",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfn0a0t51pte",
      "createdAt": "2025-10-13T15:08:00.000Z",
      "updatedAt": "2025-10-13T15:08:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0er6nb6fq9r55yh5cm4a9bx",
      "fspDate": "2025-10-13T14:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0er6nb6fq9r55yh5cm4a9bx",
        "bookingDate": "2025-10-13",
        "valueDate": "2025-10-13",
        "bookingDateTime": "2025-10-13T14:08:00.000Z",
        "valueDateTime": "2025-10-13T14:08:00.000Z",
        "transactionAmount": {
          "amount": "-14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Burger Cartel' from 'Burger Cartel Limited', removing 'Limited' suffix",
        "updatedAt": "2025-09-27T10:49:04.366Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspextghtsxsrs",
      "createdAt": "2025-10-13T14:36:00.000Z",
      "updatedAt": "2025-10-13T14:36:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25.1,
      "currency": "EUR",
      "description": "Tula Mexican Grill 02",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2ksftarfzwbd1na5qd27pxw",
      "fspDate": "2025-10-13T13:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ksftarfzwbd1na5qd27pxw",
        "bookingDate": "2025-10-13",
        "valueDate": "2025-10-13",
        "bookingDateTime": "2025-10-13T13:36:00.000Z",
        "valueDateTime": "2025-10-13T13:36:00.000Z",
        "transactionAmount": {
          "amount": "-25.10",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tula Mexican Grill 02",
        "remittanceInformationUnstructuredArray": [
          "Tula Mexican Grill 02"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Tula Mexican Grill' from 'Tula Mexican Grill 02', removing '02' suffix",
        "updatedAt": "2025-09-27T10:42:40.377Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_58vav6s3er9cwhbwqhzy6e0x3g",
      "createdAt": "2025-10-13T11:15:00.000Z",
      "updatedAt": "2025-10-13T11:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1.66,
      "currency": "EUR",
      "description": "Payment to Merrion Row Post Office: MRP-202510-7237",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6y0qmma57wqc0pnt74ah4eg0gz",
      "fspDate": "2025-10-13T10:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6y0qmma57wqc0pnt74ah4eg0gz",
        "bookingDate": "2025-10-13",
        "valueDate": "2025-10-13",
        "bookingDateTime": "2025-10-13T11:15:00.000Z",
        "valueDateTime": "2025-10-13T11:15:00.000Z",
        "transactionAmount": {
          "amount": "1.66",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Merrion Row Post Office: MRP-202510-7237",
        "remittanceInformationUnstructuredArray": [
          "Payment to Merrion Row Post Office",
          "MRP-202510-7237"
        ],
        "debtorName": "Merrion Row Post Office"
      },
      "paymentId": null,
      "reference": "MRP-202510-7237",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj0neshspngm4dw1pq8h",
      "clustering": {
        "description": "Merrion Row Post Office",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Merrion Row Post Office' based on payment details",
        "updatedAt": "2025-10-13T11:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Merrion Row Post Office",
        "iban": "DE70615104356134056",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgwqmh0wavmp",
      "createdAt": "2025-10-13T09:08:00.000Z",
      "updatedAt": "2025-10-13T09:08:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 48,
      "currency": "EUR",
      "description": "Calendly",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1t6nbsj4x77",
      "fspDate": "2025-10-13T08:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1t6nbsj4x77",
        "bookingDate": "2025-10-13",
        "valueDate": "2025-10-13",
        "bookingDateTime": "2025-10-13T08:08:00.000Z",
        "valueDateTime": "2025-10-13T08:08:00.000Z",
        "transactionAmount": {
          "amount": "-48.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Calendly",
        "remittanceInformationUnstructuredArray": [
          "Calendly"
        ],
        "debtorName": "Calendly"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtc5eshspk6kqa7yaywk",
      "clustering": {
        "description": "Calendly",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Calendly' from the raw transaction description.",
        "updatedAt": "2025-09-27T10:53:55.721Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjmbe6jg76jz5",
      "createdAt": "2025-10-12T16:13:00.000Z",
      "updatedAt": "2025-10-12T16:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 9454,
      "currency": "GBP",
      "description": "SEAPOINT FINANCE  LIMITED. From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk83pv869nt03",
      "fspDate": "2025-10-12T15:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk83pv869nt03",
        "bookingDate": "2025-10-12",
        "valueDate": "2025-10-12",
        "bookingDateTime": "2025-10-12T15:13:00.000Z",
        "valueDateTime": "2025-10-12T15:13:00.000Z",
        "transactionAmount": {
          "amount": "9454.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
        "remittanceInformationUnstructuredArray": [
          "From SEAPOINT FINANCE UK INVESTMENTS LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance Uk Investments Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Seapoint Finance Uk Investments Limited' from 'From SEAPOINT FINANCE UK INVESTMENTS LIMITED'",
        "updatedAt": "2025-09-29T18:24:29.682Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf7rmkj27v72",
      "createdAt": "2025-10-12T15:59:00.000Z",
      "updatedAt": "2025-10-12T15:59:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5090,
      "currency": "EUR",
      "description": "To Modulr Finance B.V EUR",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1frbg7wfk0vs7twykq00ehf",
      "fspDate": "2025-10-12T14:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1frbg7wfk0vs7twykq00ehf",
        "bookingDate": "2025-10-12",
        "valueDate": "2025-10-12",
        "bookingDateTime": "2025-10-12T14:59:00.000Z",
        "valueDateTime": "2025-10-12T14:59:00.000Z",
        "transactionAmount": {
          "amount": "-5090.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Modulr Finance B.V. EUR",
        "remittanceInformationUnstructuredArray": [
          "To Modulr Finance B.V",
          "EUR"
        ],
        "debtorName": "Modulr Finance B.V. EUR"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance B.V.",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Modulr Finance B.V.' from 'To Modulr Finance B.V. EUR'",
        "updatedAt": "2025-09-27T10:45:11.554Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph53nbatasa9",
      "createdAt": "2025-10-12T14:11:00.000Z",
      "updatedAt": "2025-10-12T14:11:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 18.25,
      "currency": "EUR",
      "description": "Tst-Tang-Cumberland-Pl",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk23ef2jqzy90",
      "fspDate": "2025-10-12T13:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk23ef2jqzy90",
        "bookingDate": "2025-10-12",
        "valueDate": "2025-10-12",
        "bookingDateTime": "2025-10-12T13:11:00.000Z",
        "valueDateTime": "2025-10-12T13:11:00.000Z",
        "transactionAmount": {
          "amount": "-18.25",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tst-Tang-Cumberland-Pl",
        "remittanceInformationUnstructuredArray": [
          "Tst-Tang-Cumberland-Pl"
        ],
        "debtorName": "Tang"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gseshspjyrwgx4ccwg",
      "clustering": {
        "description": "Tang",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Tang' from 'Tst-Tang-Cumberland-Pl'",
        "updatedAt": "2025-09-27T10:54:50.865Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gwhx60jq481rb9446vwvejxpqx",
      "createdAt": "2025-10-12T12:16:00.000Z",
      "updatedAt": "2025-10-12T12:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4350,
      "currency": "GBP",
      "description": "Salary - Alex Johnson - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_8kvhrh76x7pmssssxfwfq7gs7f",
      "fspDate": "2025-10-12T11:16:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_hfmef26cgrwcwykt2vg204d5sh",
        "bookingDate": "2025-10-12",
        "valueDate": "2025-10-12",
        "bookingDateTime": "2025-10-12T11:16:00.000Z",
        "valueDateTime": "2025-10-12T11:16:00.000Z",
        "transactionAmount": {
          "amount": "-4350.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Alex Johnson",
        "remittanceInformationUnstructuredArray": [
          "Salary - Alex Johnson"
        ]
      },
      "paymentId": "pmnt_0x9wgbm1f2j9mbydgrvs2jbnt5",
      "reference": "PAY-DEC-2025-JOHNSON",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Alex Johnson",
        "iban": null,
        "bic": null,
        "sortCode": "20-00-00",
        "accountNumber": "89012345"
      }
    },
    {
      "id": "txn_6dvfbg5kdw6pkhx4t65yhcyg3h",
      "createdAt": "2025-10-12T09:38:00.000Z",
      "updatedAt": "2025-10-12T09:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 831.99,
      "currency": "GBP",
      "description": "Payment to Charles Russell Speechlys: CRS-202510-9919",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ts2wsfzd845h7zms12p5vke7hp",
      "fspDate": "2025-10-12T08:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ts2wsfzd845h7zms12p5vke7hp",
        "bookingDate": "2025-10-12",
        "valueDate": "2025-10-12",
        "bookingDateTime": "2025-10-12T09:38:00.000Z",
        "valueDateTime": "2025-10-12T09:38:00.000Z",
        "transactionAmount": {
          "amount": "831.99",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Charles Russell Speechlys: CRS-202510-9919",
        "remittanceInformationUnstructuredArray": [
          "Payment to Charles Russell Speechlys",
          "CRS-202510-9919"
        ],
        "debtorName": "Charles Russell Speechlys"
      },
      "paymentId": null,
      "reference": "CRS-202510-9919",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgh1fvhrjp0n7wme8cae",
      "clustering": {
        "description": "Charles Russell Speechlys",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Charles Russell Speechlys' based on payment details",
        "updatedAt": "2025-10-12T09:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Charles Russell Speechlys",
        "iban": null,
        "bic": null,
        "sortCode": "843521",
        "accountNumber": "22798953"
      }
    },
    {
      "id": "txn_01k65c32xyeshspeh8nfmpe9c9",
      "createdAt": "2025-10-11T09:40:00.000Z",
      "updatedAt": "2025-10-11T09:40:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 20000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3n8n6ekeh2tcaqkf0kh6p0b",
      "fspDate": "2025-10-11T08:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n6ekeh2tcaqkf0kh6p0b",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T14:00:00.000Z",
        "valueDateTime": "2026-01-05T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-20000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name due to the 'EXCHANGE' transaction code.",
        "updatedAt": "2025-09-27T10:39:39.718Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ctgfw3nqs54mrnzpzjm1bdkjjw",
      "createdAt": "2025-10-11T08:38:00.000Z",
      "updatedAt": "2025-10-11T08:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 43.95,
      "currency": "GBP",
      "description": "Payment to Deliveroo: D-202510-9760",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_am0advnwfbbhdxh68q95s5d11s",
      "fspDate": "2025-10-11T07:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_am0advnwfbbhdxh68q95s5d11s",
        "bookingDate": "2025-10-11",
        "valueDate": "2025-10-11",
        "bookingDateTime": "2025-10-11T08:38:00.000Z",
        "valueDateTime": "2025-10-11T08:38:00.000Z",
        "transactionAmount": {
          "amount": "43.95",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Deliveroo: D-202510-9760",
        "remittanceInformationUnstructuredArray": [
          "Payment to Deliveroo",
          "D-202510-9760"
        ],
        "debtorName": "Deliveroo"
      },
      "paymentId": null,
      "reference": "D-202510-9760",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmcfvhrjp16bczghe88",
      "clustering": {
        "description": "Deliveroo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Deliveroo' based on payment details",
        "updatedAt": "2025-10-11T08:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Deliveroo",
        "iban": null,
        "bic": null,
        "sortCode": "840799",
        "accountNumber": "99671873"
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm4ap4911y04",
      "createdAt": "2025-10-11T07:00:00.000Z",
      "updatedAt": "2025-10-11T07:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 9454,
      "currency": "GBP",
      "description": "SEAPOINT FINANCE  LIMITED. From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k35t8vmbe8prf0pfa3d8n1fy",
      "fspDate": "2025-10-11T06:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k35t8vmbe8prf0pfa3d8n1fy",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T07:00:00.000Z",
        "valueDateTime": "2026-01-11T07:00:00.000Z",
        "transactionAmount": {
          "amount": "9454.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
        "remittanceInformationUnstructuredArray": [
          "From SEAPOINT FINANCE UK INVESTMENTS LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK Investments",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance UK Investments' from 'From SEAPOINT FINANCE UK INVESTMENTS LIMITED', removing 'From ' prefix and 'LIMITED' suffix",
        "updatedAt": "2025-09-29T18:23:50.845Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfz0wwbbr17c",
      "createdAt": "2025-10-10T15:58:00.000Z",
      "updatedAt": "2025-10-10T15:58:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0v71ajzq03b",
      "fspDate": "2025-10-10T14:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0v71ajzq03b",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T10:00:00.000Z",
        "valueDateTime": "2026-01-04T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing 'Sq *' prefix",
        "updatedAt": "2025-09-27T10:50:52.257Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgvz99pweanz",
      "createdAt": "2025-10-10T14:21:00.000Z",
      "updatedAt": "2025-10-10T14:21:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 62.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1sjytr3ct53",
      "fspDate": "2025-10-10T13:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1sjytr3ct53",
        "bookingDate": "2025-10-10",
        "valueDate": "2025-10-10",
        "bookingDateTime": "2025-10-10T13:21:00.000Z",
        "valueDateTime": "2025-10-10T13:21:00.000Z",
        "transactionAmount": {
          "amount": "-62.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Zakura' from the raw transaction description.",
        "updatedAt": "2025-09-27T10:53:55.700Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bxvt1czy7p52fwyf19txz9zse6",
      "createdAt": "2025-10-10T11:08:00.000Z",
      "updatedAt": "2025-10-10T11:08:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 97.81,
      "currency": "EUR",
      "description": "Payment to Attio: A-202510-4858",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_tfwvxs80b9yeym3ey86g3x1htc",
      "fspDate": "2025-10-10T10:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_tfwvxs80b9yeym3ey86g3x1htc",
        "bookingDate": "2025-10-10",
        "valueDate": "2025-10-10",
        "bookingDateTime": "2025-10-10T11:08:00.000Z",
        "valueDateTime": "2025-10-10T11:08:00.000Z",
        "transactionAmount": {
          "amount": "97.81",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Attio: A-202510-4858",
        "remittanceInformationUnstructuredArray": [
          "Payment to Attio",
          "A-202510-4858"
        ],
        "debtorName": "Attio"
      },
      "paymentId": null,
      "reference": "A-202510-4858",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspj5eshspmpcdfterchh",
      "clustering": {
        "description": "Attio",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Attio' based on payment details",
        "updatedAt": "2025-10-10T11:08:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Attio",
        "iban": "DE17210893220614104",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmfkb543hh39",
      "createdAt": "2025-10-10T10:53:00.000Z",
      "updatedAt": "2025-10-10T10:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4500,
      "currency": "GBP",
      "description": "To Wealthkernel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk880hc55k840",
      "fspDate": "2025-10-10T09:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk880hc55k840",
        "bookingDate": "2025-12-16",
        "valueDate": "2025-12-16",
        "bookingDateTime": "2025-12-16T14:35:00.000Z",
        "valueDateTime": "2025-12-16T14:35:00.000Z",
        "transactionAmount": {
          "amount": "-4500.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Wealthkernel Limited",
        "remittanceInformationUnstructuredArray": [
          "To Wealthkernel Limited"
        ],
        "debtorName": "Wealthkernel Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhng0fvhrjnk93frdx83x",
      "clustering": {
        "description": "Wealthkernel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Wealthkernel' from 'To Wealthkernel Limited'",
        "updatedAt": "2025-09-29T18:25:01.153Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_067gdcgqvrvfgzsned46yxxa86",
      "createdAt": "2025-10-10T09:37:00.000Z",
      "updatedAt": "2025-10-10T09:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 33.72,
      "currency": "EUR",
      "description": "Payment to Dracula's Kitchen: DK-202510-2280",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ykk1z84tyg6echdg4455sd423t",
      "fspDate": "2025-10-10T08:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ykk1z84tyg6echdg4455sd423t",
        "bookingDate": "2025-10-10",
        "valueDate": "2025-10-10",
        "bookingDateTime": "2025-10-10T09:37:00.000Z",
        "valueDateTime": "2025-10-10T09:37:00.000Z",
        "transactionAmount": {
          "amount": "33.72",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Dracula's Kitchen: DK-202510-2280",
        "remittanceInformationUnstructuredArray": [
          "Payment to Dracula's Kitchen",
          "DK-202510-2280"
        ],
        "debtorName": "Dracula's Kitchen"
      },
      "paymentId": null,
      "reference": "DK-202510-2280",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcgeshspn9xska0mg5b",
      "clustering": {
        "description": "Dracula's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Dracula's Kitchen' based on payment details",
        "updatedAt": "2025-10-10T09:37:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Dracula's Kitchen",
        "iban": "DE39371635978232670",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg6by1q1p7rz",
      "createdAt": "2025-10-09T15:45:00.000Z",
      "updatedAt": "2025-10-09T15:45:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 101.65,
      "currency": "EUR",
      "description": "Linkedin Pre P44594755",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2472e8pvk135b60b0wjv",
      "fspDate": "2025-10-09T14:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk135b60b0wjv",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T13:46:00.000Z",
        "valueDateTime": "2025-12-24T13:46:00.000Z",
        "transactionAmount": {
          "amount": "-101.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin Pre P44594755",
        "remittanceInformationUnstructuredArray": [
          "Linkedin Pre P44594755"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'LinkedIn' from 'Linkedin Pre P44594755', removing the 'Pre P44594755' suffix.",
        "updatedAt": "2025-09-27T10:51:38.235Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_388e2zy6bjqrkyzaj8tpen09tx",
      "createdAt": "2025-10-09T13:44:00.000Z",
      "updatedAt": "2025-10-09T13:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7.91,
      "currency": "USD",
      "description": "Payment to 1Password: 1-202510-4272",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_txp2p0tv9mjkmm7ryf9s2wx6xb",
      "fspDate": "2025-10-09T12:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_txp2p0tv9mjkmm7ryf9s2wx6xb",
        "bookingDate": "2025-10-09",
        "valueDate": "2025-10-09",
        "bookingDateTime": "2025-10-09T13:44:00.000Z",
        "valueDateTime": "2025-10-09T13:44:00.000Z",
        "transactionAmount": {
          "amount": "7.91",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to 1Password: 1-202510-4272",
        "remittanceInformationUnstructuredArray": [
          "Payment to 1Password",
          "1-202510-4272"
        ],
        "debtorName": "1Password"
      },
      "paymentId": null,
      "reference": "1-202510-4272",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxpeshspjghv7zy63at",
      "clustering": {
        "description": "1Password",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor '1Password' based on payment details",
        "updatedAt": "2025-10-09T13:44:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "1Password",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfckzmn50wtr",
      "createdAt": "2025-10-09T13:05:00.000Z",
      "updatedAt": "2025-10-09T13:05:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 21.99,
      "currency": "EUR",
      "description": "Google Play Apps",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k12vyakpe4dr6y0stet679pz",
      "fspDate": "2025-10-09T12:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k12vyakpe4dr6y0stet679pz",
        "bookingDate": "2025-10-09",
        "valueDate": "2025-10-09",
        "bookingDateTime": "2025-10-09T12:05:00.000Z",
        "valueDateTime": "2025-10-09T12:05:00.000Z",
        "transactionAmount": {
          "amount": "-21.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Google Play Apps",
        "remittanceInformationUnstructuredArray": [
          "Google Play Apps"
        ],
        "debtorName": "Google Play"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wjeeshsphy7nnkfq48b",
      "clustering": {
        "description": "Google Play",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Google Play' from 'Google Play Apps'",
        "updatedAt": "2025-09-27T10:48:02.647Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3y5rjprzn46h2wqtbv79txzv3j",
      "createdAt": "2025-10-09T12:31:00.000Z",
      "updatedAt": "2025-10-09T12:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2375.72,
      "currency": "EUR",
      "description": "Payment to Marta Kowalska Consulting: MKC-202510-8720",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1gfwfqwtta3hcbab5rxhref4wp",
      "fspDate": "2025-10-09T11:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1gfwfqwtta3hcbab5rxhref4wp",
        "bookingDate": "2025-10-09",
        "valueDate": "2025-10-09",
        "bookingDateTime": "2025-10-09T12:31:00.000Z",
        "valueDateTime": "2025-10-09T12:31:00.000Z",
        "transactionAmount": {
          "amount": "2375.72",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marta Kowalska Consulting: MKC-202510-8720",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marta Kowalska Consulting",
          "MKC-202510-8720"
        ],
        "debtorName": "Marta Kowalska Consulting"
      },
      "paymentId": null,
      "reference": "MKC-202510-8720",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj39eshspnh92mjbyz8s",
      "clustering": {
        "description": "Marta Kowalska Consulting",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marta Kowalska Consulting' based on payment details",
        "updatedAt": "2025-10-09T12:31:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marta Kowalska Consulting",
        "iban": "DE33243103223819024",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_k07r3kjn2a8q0w52wn08b2eba5",
      "createdAt": "2025-10-09T11:33:00.000Z",
      "updatedAt": "2025-10-09T11:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 31562.14,
      "currency": "EUR",
      "description": "Payment from Nexus Consulting GmbH - INV-202510-6154",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ec1e22ykp45jc1b6swfhk5yhnh",
      "fspDate": "2025-10-09T10:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ec1e22ykp45jc1b6swfhk5yhnh",
        "bookingDate": "2025-10-09",
        "valueDate": "2025-10-09",
        "bookingDateTime": "2025-10-09T11:33:00.000Z",
        "valueDateTime": "2025-10-09T11:33:00.000Z",
        "transactionAmount": {
          "amount": "31562.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nexus Consulting GmbH - INV-202510-6154",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nexus Consulting GmbH",
          "INV-202510-6154"
        ],
        "creditorName": "Nexus Consulting GmbH"
      },
      "paymentId": null,
      "reference": "INV-202510-6154",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_631832eta7hj1n2x0gedv5fm59",
      "clustering": {
        "description": "Nexus Consulting GmbH",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nexus Consulting GmbH'",
        "updatedAt": "2025-10-09T11:33:00.000Z"
      },
      "payer": {
        "name": "Nexus Consulting GmbH",
        "iban": "DE24476260231794230",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_af44sh0a9s536ayqap0bmqrges",
      "createdAt": "2025-10-09T11:14:00.000Z",
      "updatedAt": "2025-10-09T11:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 31.08,
      "currency": "EUR",
      "description": "Payment to Sentry: S-202510-1602",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_c7e6htmy9c5pq9fydbt7zk8smm",
      "fspDate": "2025-10-09T10:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_c7e6htmy9c5pq9fydbt7zk8smm",
        "bookingDate": "2025-10-09",
        "valueDate": "2025-10-09",
        "bookingDateTime": "2025-10-09T11:14:00.000Z",
        "valueDateTime": "2025-10-09T11:14:00.000Z",
        "transactionAmount": {
          "amount": "31.08",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sentry: S-202510-1602",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sentry",
          "S-202510-1602"
        ],
        "debtorName": "Sentry"
      },
      "paymentId": null,
      "reference": "S-202510-1602",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdn2eshspk97jdcm57ef",
      "clustering": {
        "description": "Sentry",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sentry' based on payment details",
        "updatedAt": "2025-10-09T11:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sentry",
        "iban": "DE75174585400951420",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmhckjw6v9h4",
      "createdAt": "2025-10-09T09:42:00.000Z",
      "updatedAt": "2025-10-09T09:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 48.68,
      "currency": "GBP",
      "description": "Linkedin Sn *644171954",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk89xdes3h3s4",
      "fspDate": "2025-10-09T08:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk89xdes3h3s4",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T09:39:00.000Z",
        "valueDateTime": "2025-12-27T09:39:00.000Z",
        "transactionAmount": {
          "amount": "-48.68",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin Sn *644171954",
        "remittanceInformationUnstructuredArray": [
          "Linkedin Sn *644171954"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'LinkedIn' from 'Linkedin Sn *644171954'",
        "updatedAt": "2025-09-29T18:25:48.439Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfnjsmytk5j1",
      "createdAt": "2025-10-09T09:39:00.000Z",
      "updatedAt": "2025-10-09T09:39:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 28,
      "currency": "EUR",
      "description": "Delhi2dublin",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0e8rfh5exraqe0vmg7ynndk",
      "fspDate": "2025-10-09T08:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0e8rfh5exraqe0vmg7ynndk",
        "bookingDate": "2025-10-09",
        "valueDate": "2025-10-09",
        "bookingDateTime": "2025-10-09T08:39:00.000Z",
        "valueDateTime": "2025-10-09T08:39:00.000Z",
        "transactionAmount": {
          "amount": "-28.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Delhi2dublin",
        "remittanceInformationUnstructuredArray": [
          "Delhi2dublin"
        ],
        "debtorName": "Delhi2Dublin"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0x5eshspjwbxzrhs5dn",
      "clustering": {
        "description": "Delhi2Dublin",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Delhi2Dublin' from 'Delhi2dublin'",
        "updatedAt": "2025-09-27T10:49:37.598Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf1778d2y5z9",
      "createdAt": "2025-10-09T09:36:00.000Z",
      "updatedAt": "2025-10-09T09:36:00.000Z",
      "status": "BOOKED",
      "type": "CARD_REFUND",
      "isCredit": true,
      "amount": 0.93,
      "currency": "EUR",
      "description": "Refund from Paddle.net* Geoguessr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k26xg786fk7s0pkptygbe5hm",
      "fspDate": "2025-10-09T08:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k26xg786fk7s0pkptygbe5hm",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T14:00:00.000Z",
        "valueDateTime": "2026-01-02T14:00:00.000Z",
        "transactionAmount": {
          "amount": "0.93",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_REFUND",
        "remittanceInformationUnstructured": "Refund from Paddle.net* Geoguessr",
        "remittanceInformationUnstructuredArray": [
          "Refund from Paddle.net* Geoguessr"
        ],
        "debtorName": "Paddle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax3veshspjmhphswafsq",
      "clustering": {
        "description": "Paddle",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Paddle' from 'Refund from Paddle.net* Geoguessr'",
        "updatedAt": "2025-09-27T10:42:40.445Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf1zb89s78xe",
      "createdAt": "2025-10-09T07:49:00.000Z",
      "updatedAt": "2025-10-09T07:49:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Sq *seoul Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k24b3f6jfakarfmdn266mv57",
      "fspDate": "2025-10-09T06:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k24b3f6jfakarfmdn266mv57",
        "bookingDate": "2025-10-09",
        "valueDate": "2025-10-09",
        "bookingDateTime": "2025-10-09T06:49:00.000Z",
        "valueDateTime": "2025-10-09T06:49:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *seoul Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Sq *seoul Kitchen"
        ],
        "debtorName": "Seoul Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pzaeshspjhkemvf76tx",
      "clustering": {
        "description": "Seoul Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Seoul Kitchen' from the transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:43:55.439Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7rhj9gbskqmv3r94adag5s9r9r",
      "createdAt": "2025-10-08T15:46:00.000Z",
      "updatedAt": "2025-10-08T15:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 46573.18,
      "currency": "GBP",
      "description": "Payment from Enterprise Systems Inc - INV-202510-5594",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9557v2jnqcqk8qxp8cypb2g9p7",
      "fspDate": "2025-10-08T14:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9557v2jnqcqk8qxp8cypb2g9p7",
        "bookingDate": "2025-10-08",
        "valueDate": "2025-10-08",
        "bookingDateTime": "2025-10-08T15:46:00.000Z",
        "valueDateTime": "2025-10-08T15:46:00.000Z",
        "transactionAmount": {
          "amount": "46573.18",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Enterprise Systems Inc - INV-202510-5594",
        "remittanceInformationUnstructuredArray": [
          "Payment from Enterprise Systems Inc",
          "INV-202510-5594"
        ],
        "creditorName": "Enterprise Systems Inc"
      },
      "paymentId": null,
      "reference": "INV-202510-5594",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1jqt0xq8p3az0ed45aqq7npx6w",
      "clustering": {
        "description": "Enterprise Systems Inc",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Enterprise Systems Inc'",
        "updatedAt": "2025-10-08T15:46:00.000Z"
      },
      "payer": {
        "name": "Enterprise Systems Inc",
        "iban": null,
        "bic": null,
        "sortCode": "542504",
        "accountNumber": "44192974"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfywhsvkzt4d",
      "createdAt": "2025-10-08T15:30:00.000Z",
      "updatedAt": "2025-10-08T15:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2053.1,
      "currency": "EUR",
      "description": "Payment to Patrick Walsh: INV006",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jzra842df25ttex79cnq7dg9",
      "fspDate": "2025-10-08T14:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jzra842df25ttex79cnq7dg9",
        "bookingDate": "2025-10-08",
        "valueDate": "2025-10-08",
        "bookingDateTime": "2025-10-08T14:30:00.000Z",
        "valueDateTime": "2025-10-08T14:30:00.000Z",
        "transactionAmount": {
          "amount": "-2053.10",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Patrick Walsh: INV006",
        "remittanceInformationUnstructuredArray": [
          "Payment to Patrick Walsh: INV006"
        ],
        "debtorName": "Patrick Walsh"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqmzweshspm8kq27v8562",
      "clustering": {
        "description": "Patrick Walsh",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Patrick Walsh' from 'Payment to Patrick Walsh: INV006'",
        "updatedAt": "2025-09-27T10:50:08.428Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0rtrmvt2rv5rjvd8ggryb95dt3",
      "createdAt": "2025-10-08T15:06:00.000Z",
      "updatedAt": "2025-10-08T15:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.09,
      "currency": "EUR",
      "description": "Payment to An Post: AP-202510-5006",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_00stn13c2hzhttwz4vry5nrfbb",
      "fspDate": "2025-10-08T14:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_00stn13c2hzhttwz4vry5nrfbb",
        "bookingDate": "2025-10-08",
        "valueDate": "2025-10-08",
        "bookingDateTime": "2025-10-08T15:06:00.000Z",
        "valueDateTime": "2025-10-08T15:06:00.000Z",
        "transactionAmount": {
          "amount": "3.09",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to An Post: AP-202510-5006",
        "remittanceInformationUnstructuredArray": [
          "Payment to An Post",
          "AP-202510-5006"
        ],
        "debtorName": "An Post"
      },
      "paymentId": null,
      "reference": "AP-202510-5006",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwdneshspna9pr7b1tc2",
      "clustering": {
        "description": "An Post",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'An Post' based on payment details",
        "updatedAt": "2025-10-08T15:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "An Post",
        "iban": "DE20088272254368532",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zvq059qf3vdsf7csdje17yj8e8",
      "createdAt": "2025-10-08T14:28:00.000Z",
      "updatedAt": "2025-10-08T14:28:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.96,
      "currency": "GBP",
      "description": "Payment to Uber: U-202510-8520",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_kv3t40ahmg6bx34qpy45x40yav",
      "fspDate": "2025-10-08T13:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_kv3t40ahmg6bx34qpy45x40yav",
        "bookingDate": "2025-10-08",
        "valueDate": "2025-10-08",
        "bookingDateTime": "2025-10-08T14:28:00.000Z",
        "valueDateTime": "2025-10-08T14:28:00.000Z",
        "transactionAmount": {
          "amount": "9.96",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Uber: U-202510-8520",
        "remittanceInformationUnstructuredArray": [
          "Payment to Uber",
          "U-202510-8520"
        ],
        "debtorName": "Uber"
      },
      "paymentId": null,
      "reference": "U-202510-8520",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Uber",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Uber' based on payment details",
        "updatedAt": "2025-10-08T14:28:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Uber",
        "iban": null,
        "bic": null,
        "sortCode": "450603",
        "accountNumber": "68988885"
      }
    },
    {
      "id": "txn_qw3fszy91h1rqfqmqf53wkdw2n",
      "createdAt": "2025-10-08T12:56:00.000Z",
      "updatedAt": "2025-10-08T12:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17.2,
      "currency": "EUR",
      "description": "Payment to Cafe And Noodle: CAN-202510-7672",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_3gs0djg3zg4hz8aafz7rqnx7g7",
      "fspDate": "2025-10-08T11:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_3gs0djg3zg4hz8aafz7rqnx7g7",
        "bookingDate": "2025-10-08",
        "valueDate": "2025-10-08",
        "bookingDateTime": "2025-10-08T12:56:00.000Z",
        "valueDateTime": "2025-10-08T12:56:00.000Z",
        "transactionAmount": {
          "amount": "17.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cafe And Noodle: CAN-202510-7672",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cafe And Noodle",
          "CAN-202510-7672"
        ],
        "debtorName": "Cafe And Noodle"
      },
      "paymentId": null,
      "reference": "CAN-202510-7672",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpd8eshspmwjjpzayxx2",
      "clustering": {
        "description": "Cafe And Noodle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cafe And Noodle' based on payment details",
        "updatedAt": "2025-10-08T12:56:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cafe And Noodle",
        "iban": "DE10249422368627884",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qp6rc7aq7c7a6bm975ycnsm9hw",
      "createdAt": "2025-10-08T12:16:00.000Z",
      "updatedAt": "2025-10-08T12:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.15,
      "currency": "USD",
      "description": "Payment to Reflect Software: RS-202510-5629",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2mtrx7mdn75e8pcrptyrf8rve6",
      "fspDate": "2025-10-08T11:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2mtrx7mdn75e8pcrptyrf8rve6",
        "bookingDate": "2025-10-08",
        "valueDate": "2025-10-08",
        "bookingDateTime": "2025-10-08T12:16:00.000Z",
        "valueDateTime": "2025-10-08T12:16:00.000Z",
        "transactionAmount": {
          "amount": "10.15",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Reflect Software: RS-202510-5629",
        "remittanceInformationUnstructuredArray": [
          "Payment to Reflect Software",
          "RS-202510-5629"
        ],
        "debtorName": "Reflect Software"
      },
      "paymentId": null,
      "reference": "RS-202510-5629",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wfmeshsphxg0s376ywm",
      "clustering": {
        "description": "Reflect Software",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Reflect Software' based on payment details",
        "updatedAt": "2025-10-08T12:16:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Reflect Software",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xxeshspeewqmtm8c0k",
      "createdAt": "2025-10-08T12:09:00.000Z",
      "updatedAt": "2025-10-08T12:09:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 5.75,
      "currency": "EUR",
      "description": "Spar Middle Baggot St",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3tden41esm9d0hwxap3kd6c",
      "fspDate": "2025-10-08T11:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3tden41esm9d0hwxap3kd6c",
        "bookingDate": "2025-12-06",
        "valueDate": "2025-12-06",
        "bookingDateTime": "2025-12-06T09:26:00.000Z",
        "valueDateTime": "2025-12-06T09:26:00.000Z",
        "transactionAmount": {
          "amount": "-5.75",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Spar Middle Baggot St",
        "remittanceInformationUnstructuredArray": [
          "Spar Middle Baggot St"
        ],
        "debtorName": "Spar"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g32eshsphp8z5k4nrvg",
      "clustering": {
        "description": "Spar",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Spar' from 'Spar Middle Baggot St', removing the location details.",
        "updatedAt": "2025-09-27T10:39:39.640Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_dv6xaa06nxcrsx8b9xpb083fa1",
      "createdAt": "2025-10-08T10:02:00.000Z",
      "updatedAt": "2025-10-08T10:02:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4284.6,
      "currency": "GBP",
      "description": "Payment to Amazon Web Services EMEA SARL: AWS-202510-2017",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wxxnjcjdxzasn2tdp0hhka9wnj",
      "fspDate": "2025-10-08T09:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wxxnjcjdxzasn2tdp0hhka9wnj",
        "bookingDate": "2025-10-08",
        "valueDate": "2025-10-08",
        "bookingDateTime": "2025-10-08T10:02:00.000Z",
        "valueDateTime": "2025-10-08T10:02:00.000Z",
        "transactionAmount": {
          "amount": "4284.60",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amazon Web Services EMEA SARL: AWS-202510-2017",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amazon Web Services EMEA SARL",
          "AWS-202510-2017"
        ],
        "debtorName": "Amazon Web Services EMEA SARL"
      },
      "paymentId": null,
      "reference": "AWS-202510-2017",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_zj7v3fq41pb9h3pwx6cbzwmfx4",
      "clustering": {
        "description": "Amazon Web Services EMEA SARL",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amazon Web Services EMEA SARL' based on payment details",
        "updatedAt": "2025-10-08T10:02:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amazon Web Services EMEA SARL",
        "iban": null,
        "bic": null,
        "sortCode": "780232",
        "accountNumber": "13365383"
      }
    },
    {
      "id": "txn_01k65c32y1eshspf42y6skw5p0",
      "createdAt": "2025-10-08T08:36:00.000Z",
      "updatedAt": "2025-10-08T08:36:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 81,
      "currency": "EUR",
      "description": "Retool",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1wkxf1tena8nqv3e65axwsn",
      "fspDate": "2025-10-08T07:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1wkxf1tena8nqv3e65axwsn",
        "bookingDate": "2025-10-08",
        "valueDate": "2025-10-08",
        "bookingDateTime": "2025-10-08T07:36:00.000Z",
        "valueDateTime": "2025-10-08T07:36:00.000Z",
        "transactionAmount": {
          "amount": "-81.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Retool",
        "remittanceInformationUnstructuredArray": [
          "Retool"
        ],
        "debtorName": "Retool"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdp6eshspk9a3b1e6677",
      "clustering": {
        "description": "Retool",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Retool' from the transaction description.",
        "updatedAt": "2025-09-27T10:43:55.508Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf3m0jncd5tn",
      "createdAt": "2025-10-07T15:54:00.000Z",
      "updatedAt": "2025-10-07T15:54:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 23,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1wkxf1tena8nqtha2bt8pw2",
      "fspDate": "2025-10-07T14:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1wkxf1tena8nqtha2bt8pw2",
        "bookingDate": "2025-10-07",
        "valueDate": "2025-10-07",
        "bookingDateTime": "2025-10-07T14:54:00.000Z",
        "valueDateTime": "2025-10-07T14:54:00.000Z",
        "transactionAmount": {
          "amount": "-23.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'OpenAI' from the transaction description, removing the '*chatgpt Subscr' suffix.",
        "updatedAt": "2025-09-27T10:43:55.497Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6dndbk68a3sw3p0sjbn8jdwjt7",
      "createdAt": "2025-10-07T13:53:00.000Z",
      "updatedAt": "2025-10-07T13:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 92.41,
      "currency": "EUR",
      "description": "Payment to Zapier: Z-202510-1642",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_tmbqc0dmcpfe83q2a6p5mm2122",
      "fspDate": "2025-10-07T12:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_tmbqc0dmcpfe83q2a6p5mm2122",
        "bookingDate": "2025-10-07",
        "valueDate": "2025-10-07",
        "bookingDateTime": "2025-10-07T13:53:00.000Z",
        "valueDateTime": "2025-10-07T13:53:00.000Z",
        "transactionAmount": {
          "amount": "92.41",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Zapier: Z-202510-1642",
        "remittanceInformationUnstructuredArray": [
          "Payment to Zapier",
          "Z-202510-1642"
        ],
        "debtorName": "Zapier"
      },
      "paymentId": null,
      "reference": "Z-202510-1642",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2aeshspkg92jdy8vh4",
      "clustering": {
        "description": "Zapier",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Zapier' based on payment details",
        "updatedAt": "2025-10-07T13:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Zapier",
        "iban": "DE44591184129451730",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmedb6vq5a8t",
      "createdAt": "2025-10-07T12:42:00.000Z",
      "updatedAt": "2025-10-07T12:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4690,
      "currency": "GBP",
      "description": "To Modulr Finance Limited GBP",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk86xf8c8na8w",
      "fspDate": "2025-10-07T11:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk86xf8c8na8w",
        "bookingDate": "2025-10-07",
        "valueDate": "2025-10-07",
        "bookingDateTime": "2025-10-07T11:42:00.000Z",
        "valueDateTime": "2025-10-07T11:42:00.000Z",
        "transactionAmount": {
          "amount": "-4690.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Modulr Finance Limited GBP",
        "remittanceInformationUnstructuredArray": [
          "To Modulr Finance Limited GBP"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Modulr Finance' from 'To Modulr Finance Limited GBP'",
        "updatedAt": "2025-09-29T18:25:01.133Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm3tt9dynpjg",
      "createdAt": "2025-10-07T11:42:00.000Z",
      "updatedAt": "2025-10-07T11:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 6150,
      "currency": "GBP",
      "description": "Nest",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3ga01qbeh2t3z89ffqyx9fg",
      "fspDate": "2025-10-07T10:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3ga01qbeh2t3z89ffqyx9fg",
        "bookingDate": "2025-10-07",
        "valueDate": "2025-10-07",
        "bookingDateTime": "2025-10-07T10:42:00.000Z",
        "valueDateTime": "2025-10-07T10:42:00.000Z",
        "transactionAmount": {
          "amount": "-6150.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Nest",
        "remittanceInformationUnstructuredArray": [
          "Nest"
        ],
        "debtorName": "Nest"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf96wfvhrjn5f3jx2wta0",
      "clustering": {
        "description": "Nest",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Nest' from 'Nest'",
        "updatedAt": "2025-09-29T18:23:50.823Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm5rbn6y2f5r",
      "createdAt": "2025-10-07T11:21:00.000Z",
      "updatedAt": "2025-10-07T11:21:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4667.69,
      "currency": "GBP",
      "description": "Nest",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k24b3fynfakarg3n38wbw0ct",
      "fspDate": "2025-10-07T10:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k24b3fynfakarg3n38wbw0ct",
        "bookingDate": "2025-10-07",
        "valueDate": "2025-10-07",
        "bookingDateTime": "2025-10-07T10:21:00.000Z",
        "valueDateTime": "2025-10-07T10:21:00.000Z",
        "transactionAmount": {
          "amount": "-4667.69",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Nest",
        "remittanceInformationUnstructuredArray": [
          "Nest"
        ],
        "debtorName": "Nest"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf96wfvhrjn5f3jx2wta0",
      "clustering": {
        "description": "Nest",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Nest' from 'Nest'",
        "updatedAt": "2025-09-29T18:23:50.897Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_q3vc45b028zpj793jn7v88wc07",
      "createdAt": "2025-10-07T11:00:00.000Z",
      "updatedAt": "2025-10-07T11:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 38.76,
      "currency": "EUR",
      "description": "Payment to Heathrow Express: HE-202510-8001",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w2acm9vqvkrrmp6qyvad9gga2h",
      "fspDate": "2025-10-07T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w2acm9vqvkrrmp6qyvad9gga2h",
        "bookingDate": "2025-10-07",
        "valueDate": "2025-10-07",
        "bookingDateTime": "2025-10-07T11:00:00.000Z",
        "valueDateTime": "2025-10-07T11:00:00.000Z",
        "transactionAmount": {
          "amount": "38.76",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Heathrow Express: HE-202510-8001",
        "remittanceInformationUnstructuredArray": [
          "Payment to Heathrow Express",
          "HE-202510-8001"
        ],
        "debtorName": "Heathrow Express"
      },
      "paymentId": null,
      "reference": "HE-202510-8001",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpg2eshspmf0nznfw91y",
      "clustering": {
        "description": "Heathrow Express",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Heathrow Express' based on payment details",
        "updatedAt": "2025-10-07T11:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Heathrow Express",
        "iban": "DE63158711746376620",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspev6ym6fnwx2",
      "createdAt": "2025-10-07T07:26:00.000Z",
      "updatedAt": "2025-10-07T07:26:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 20.71,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2ry974re009pf8ek1h16fpc",
      "fspDate": "2025-10-07T06:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ry974re009pf8ek1h16fpc",
        "bookingDate": "2025-12-06",
        "valueDate": "2025-12-06",
        "bookingDateTime": "2025-12-06T10:04:00.000Z",
        "valueDateTime": "2025-12-06T10:04:00.000Z",
        "transactionAmount": {
          "amount": "-20.71",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'OpenAI' from the 'Openai *chatgpt Subscr' transaction description, removing the 'Openai *' prefix.",
        "updatedAt": "2025-09-27T10:41:48.243Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspgagh5h0ar3f",
      "createdAt": "2025-10-06T14:27:00.000Z",
      "updatedAt": "2025-10-06T14:27:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 2100,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk17ttwtjxmq3",
      "fspDate": "2025-10-06T13:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk17ttwtjxmq3",
        "bookingDate": "2025-10-06",
        "valueDate": "2025-10-06",
        "bookingDateTime": "2025-10-06T13:27:00.000Z",
        "valueDateTime": "2025-10-06T13:27:00.000Z",
        "transactionAmount": {
          "amount": "-2100.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:52:09.988Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm40jzjpzys8",
      "createdAt": "2025-10-06T11:28:00.000Z",
      "updatedAt": "2025-10-06T11:28:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2150,
      "currency": "GBP",
      "description": "To Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k35t8vmae8prf0p3h7ykmx3t",
      "fspDate": "2025-10-06T10:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k35t8vmae8prf0p3h7ykmx3t",
        "bookingDate": "2025-10-06",
        "valueDate": "2025-10-06",
        "bookingDateTime": "2025-10-06T10:28:00.000Z",
        "valueDateTime": "2025-10-06T10:28:00.000Z",
        "transactionAmount": {
          "amount": "-2150.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance UK Ltd"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance UK' from 'To Seapoint Finance UK Ltd', removing 'To ' prefix and 'Ltd' suffix",
        "updatedAt": "2025-09-29T18:23:50.831Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspes4rgv9rc4f",
      "createdAt": "2025-10-06T07:58:00.000Z",
      "updatedAt": "2025-10-06T07:58:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 724.14,
      "currency": "EUR",
      "description": "Github, Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k35t8tvce8prf08yahxa8c4b",
      "fspDate": "2025-10-06T06:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k35t8tvce8prf08yahxa8c4b",
        "bookingDate": "2025-10-06",
        "valueDate": "2025-10-06",
        "bookingDateTime": "2025-10-06T06:58:00.000Z",
        "valueDateTime": "2025-10-06T06:58:00.000Z",
        "transactionAmount": {
          "amount": "-724.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Github, Inc.",
        "remittanceInformationUnstructuredArray": [
          "Github, Inc."
        ],
        "debtorName": "GitHub"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wd4eshsphxfd9s33j9t",
      "clustering": {
        "description": "Github",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Github' from the 'Github, Inc.' transaction description.",
        "updatedAt": "2025-09-27T10:41:48.185Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6m1sd77j9c1x3v36kdbc5x6hk5",
      "createdAt": "2025-10-05T14:24:00.000Z",
      "updatedAt": "2025-10-05T14:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 840.18,
      "currency": "USD",
      "description": "Payment to GitHub, Inc.: GI-202510-6308",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0a77f5w88ck3fahg9pbnrtzt3t",
      "fspDate": "2025-10-05T13:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0a77f5w88ck3fahg9pbnrtzt3t",
        "bookingDate": "2025-10-05",
        "valueDate": "2025-10-05",
        "bookingDateTime": "2025-10-05T14:24:00.000Z",
        "valueDateTime": "2025-10-05T14:24:00.000Z",
        "transactionAmount": {
          "amount": "840.18",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GitHub, Inc.: GI-202510-6308",
        "remittanceInformationUnstructuredArray": [
          "Payment to GitHub, Inc.",
          "GI-202510-6308"
        ],
        "debtorName": "GitHub, Inc."
      },
      "paymentId": null,
      "reference": "GI-202510-6308",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_xj643cpp5p1awyrrqgqpf67q4d",
      "clustering": {
        "description": "GitHub, Inc.",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'GitHub, Inc.' based on payment details",
        "updatedAt": "2025-10-05T14:24:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GitHub, Inc.",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfbdt0psvz0x",
      "createdAt": "2025-10-05T14:02:00.000Z",
      "updatedAt": "2025-10-05T14:02:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.24,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k180qw44esj88dqsgt1n407y",
      "fspDate": "2025-10-05T13:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k180qw44esj88dqsgt1n407y",
        "bookingDate": "2025-10-05",
        "valueDate": "2025-10-05",
        "bookingDateTime": "2025-10-05T13:02:00.000Z",
        "valueDateTime": "2025-10-05T13:02:00.000Z",
        "transactionAmount": {
          "amount": "-17.24",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Cursor' from 'Cursor, Ai Powered Ide'",
        "updatedAt": "2025-09-27T10:48:02.591Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgp86xsksvfh",
      "createdAt": "2025-10-05T13:34:00.000Z",
      "updatedAt": "2025-10-05T13:34:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 32.44,
      "currency": "EUR",
      "description": "Veremark",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1kak4m71nn5",
      "fspDate": "2025-10-05T12:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1kak4m71nn5",
        "bookingDate": "2025-10-05",
        "valueDate": "2025-10-05",
        "bookingDateTime": "2025-10-05T12:34:00.000Z",
        "valueDateTime": "2025-10-05T12:34:00.000Z",
        "transactionAmount": {
          "amount": "-32.44",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Veremark",
        "remittanceInformationUnstructuredArray": [
          "Veremark"
        ],
        "debtorName": "Veremark"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwc3eshspn9n53st1zft",
      "clustering": {
        "description": "Veremark",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Veremark' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.168Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8s2z8kashd3fcxqwc25qzprg44",
      "createdAt": "2025-10-05T13:01:00.000Z",
      "updatedAt": "2025-10-05T13:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3950,
      "currency": "GBP",
      "description": "Salary - Priya Sharma - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_5m2sq6aqp5n76xvspsp98zj9y9",
      "fspDate": "2025-10-05T12:01:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_ym57gwctrk18dm2nd00kyrmd2t",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T08:00:00.000Z",
        "valueDateTime": "2026-01-02T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-3950.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Priya Sharma",
        "remittanceInformationUnstructuredArray": [
          "Salary - Priya Sharma"
        ]
      },
      "paymentId": "pmnt_9as0h59mrv08jj8391v0a02gej",
      "reference": "PAY-DEC-2025-SHARMA",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Priya Sharma",
        "iban": null,
        "bic": null,
        "sortCode": "30-15-89",
        "accountNumber": "56789012"
      }
    },
    {
      "id": "txn_gcpfqa0pjh023msd59rg02skr8",
      "createdAt": "2025-10-05T12:16:00.000Z",
      "updatedAt": "2025-10-05T12:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 224.48,
      "currency": "GBP",
      "description": "Payment to Kiwi.com: K-202510-7548",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qb3988ejh6gg9gttded43mwdpq",
      "fspDate": "2025-10-05T11:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qb3988ejh6gg9gttded43mwdpq",
        "bookingDate": "2025-10-05",
        "valueDate": "2025-10-05",
        "bookingDateTime": "2025-10-05T12:16:00.000Z",
        "valueDateTime": "2025-10-05T12:16:00.000Z",
        "transactionAmount": {
          "amount": "224.48",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kiwi.com: K-202510-7548",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kiwi.com",
          "K-202510-7548"
        ],
        "debtorName": "Kiwi.com"
      },
      "paymentId": null,
      "reference": "K-202510-7548",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9q1fvhrjp371wrcstvr",
      "clustering": {
        "description": "Kiwi.com",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kiwi.com' based on payment details",
        "updatedAt": "2025-10-05T12:16:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kiwi.com",
        "iban": null,
        "bic": null,
        "sortCode": "542840",
        "accountNumber": "51357397"
      }
    },
    {
      "id": "txn_qzz3s4987gsyy3jmjxq3rkehxk",
      "createdAt": "2025-10-05T09:00:00.000Z",
      "updatedAt": "2025-10-05T09:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 21.7,
      "currency": "EUR",
      "description": "Payment to Taxi Service: TS-202510-5280",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_7b4jhddhe8xg99sa273z2t029z",
      "fspDate": "2025-10-05T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_7b4jhddhe8xg99sa273z2t029z",
        "bookingDate": "2025-10-05",
        "valueDate": "2025-10-05",
        "bookingDateTime": "2025-10-05T09:00:00.000Z",
        "valueDateTime": "2025-10-05T09:00:00.000Z",
        "transactionAmount": {
          "amount": "21.70",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Taxi Service: TS-202510-5280",
        "remittanceInformationUnstructuredArray": [
          "Payment to Taxi Service",
          "TS-202510-5280"
        ],
        "debtorName": "Taxi Service"
      },
      "paymentId": null,
      "reference": "TS-202510-5280",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqn02eshspm8y4jy7tt7k",
      "clustering": {
        "description": "Taxi Service",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Taxi Service' based on payment details",
        "updatedAt": "2025-10-05T09:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Taxi Service",
        "iban": "DE38186624451614490",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4dd1233gvyyycvwtm9d06dyz15",
      "createdAt": "2025-10-05T08:14:00.000Z",
      "updatedAt": "2025-10-05T08:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3488.82,
      "currency": "GBP",
      "description": "Payment to Grow Your Boat Ltd: GYB-202510-5181",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_a9wpvyf3jhvtv5p577s6xma91j",
      "fspDate": "2025-10-05T07:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_a9wpvyf3jhvtv5p577s6xma91j",
        "bookingDate": "2025-10-05",
        "valueDate": "2025-10-05",
        "bookingDateTime": "2025-10-05T08:14:00.000Z",
        "valueDateTime": "2025-10-05T08:14:00.000Z",
        "transactionAmount": {
          "amount": "3488.82",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Grow Your Boat Ltd: GYB-202510-5181",
        "remittanceInformationUnstructuredArray": [
          "Payment to Grow Your Boat Ltd",
          "GYB-202510-5181"
        ],
        "debtorName": "Grow Your Boat Ltd"
      },
      "paymentId": null,
      "reference": "GYB-202510-5181",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "clustering": {
        "description": "Grow Your Boat Ltd",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Grow Your Boat Ltd' based on payment details",
        "updatedAt": "2025-10-05T08:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Grow Your Boat Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "230293",
        "accountNumber": "17799897"
      }
    },
    {
      "id": "txn_01k65c32y6eshspgs52dbmwpax",
      "createdAt": "2025-10-04T16:05:00.000Z",
      "updatedAt": "2025-10-04T16:05:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.99,
      "currency": "EUR",
      "description": "Paddle.net* Geoguessr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1ndxzbcdawz",
      "fspDate": "2025-10-04T15:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1ndxzbcdawz",
        "bookingDate": "2025-10-04",
        "valueDate": "2025-10-04",
        "bookingDateTime": "2025-10-04T15:05:00.000Z",
        "valueDateTime": "2025-10-04T15:05:00.000Z",
        "transactionAmount": {
          "amount": "-4.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Paddle.net* Geoguessr",
        "remittanceInformationUnstructuredArray": [
          "Paddle.net* Geoguessr"
        ],
        "debtorName": "Paddle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax3veshspjmhphswafsq",
      "clustering": {
        "description": "Paddle",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Paddle' from the raw transaction description, removing the 'Paddle.net* ' prefix.",
        "updatedAt": "2025-09-27T10:53:55.636Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg4mckvkqa0c",
      "createdAt": "2025-10-04T16:01:00.000Z",
      "updatedAt": "2025-10-04T16:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Tortilla Latin Food 1",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk10rm1phrf3h",
      "fspDate": "2025-10-04T15:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk10rm1phrf3h",
        "bookingDate": "2025-12-27",
        "valueDate": "2025-12-27",
        "bookingDateTime": "2025-12-27T08:56:00.000Z",
        "valueDateTime": "2025-12-27T08:56:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tortilla Latin Food 1",
        "remittanceInformationUnstructuredArray": [
          "Tortilla Latin Food 1"
        ],
        "debtorName": "Tortilla Mexican Grill"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspgkeshspmp0mmzf2w0c",
      "clustering": {
        "description": "Tortilla Latin Food",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Tortilla Latin Food' from 'Tortilla Latin Food 1', removing the store number suffix.",
        "updatedAt": "2025-09-27T10:51:38.168Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_h2qv0pejghjea07f9d8hh3fhah",
      "createdAt": "2025-10-04T15:09:00.000Z",
      "updatedAt": "2025-10-04T15:09:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.21,
      "currency": "EUR",
      "description": "Payment to Mak Slim Foods: MSF-202510-6422",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_p9k2hkhmagqzescbe136pysj9z",
      "fspDate": "2025-10-04T14:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_p9k2hkhmagqzescbe136pysj9z",
        "bookingDate": "2025-10-04",
        "valueDate": "2025-10-04",
        "bookingDateTime": "2025-10-04T15:09:00.000Z",
        "valueDateTime": "2025-10-04T15:09:00.000Z",
        "transactionAmount": {
          "amount": "25.21",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mak Slim Foods: MSF-202510-6422",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mak Slim Foods",
          "MSF-202510-6422"
        ],
        "debtorName": "Mak Slim Foods"
      },
      "paymentId": null,
      "reference": "MSF-202510-6422",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2yeshspkgyzwx8hqrq",
      "clustering": {
        "description": "Mak Slim Foods",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mak Slim Foods' based on payment details",
        "updatedAt": "2025-10-04T15:09:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mak Slim Foods",
        "iban": "DE46678525841116370",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vz3fjeqakjf9ajpr2xnhy29r9t",
      "createdAt": "2025-10-04T14:41:00.000Z",
      "updatedAt": "2025-10-04T14:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7.47,
      "currency": "GBP",
      "description": "Payment to Pret A Manger: PAM-202510-4260",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ksxfvdryh8j2s8yd99kk7gwq0g",
      "fspDate": "2025-10-04T13:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ksxfvdryh8j2s8yd99kk7gwq0g",
        "bookingDate": "2025-10-04",
        "valueDate": "2025-10-04",
        "bookingDateTime": "2025-10-04T14:41:00.000Z",
        "valueDateTime": "2025-10-04T14:41:00.000Z",
        "transactionAmount": {
          "amount": "7.47",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pret A Manger: PAM-202510-4260",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pret A Manger",
          "PAM-202510-4260"
        ],
        "debtorName": "Pret A Manger"
      },
      "paymentId": null,
      "reference": "PAM-202510-4260",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crphqeshspmfftkxpt85b",
      "clustering": {
        "description": "Pret A Manger",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pret A Manger' based on payment details",
        "updatedAt": "2025-10-04T14:41:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pret A Manger",
        "iban": null,
        "bic": null,
        "sortCode": "882996",
        "accountNumber": "90998344"
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmd4z4mmn06v",
      "createdAt": "2025-10-04T14:19:00.000Z",
      "updatedAt": "2025-10-04T14:19:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 2000,
      "currency": "GBP",
      "description": "Exchanged to EUR Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk85gw2tmpese",
      "fspDate": "2025-10-04T13:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk85gw2tmpese",
        "bookingDate": "2025-10-04",
        "valueDate": "2025-10-04",
        "bookingDateTime": "2025-10-04T13:19:00.000Z",
        "valueDateTime": "2025-10-04T13:19:00.000Z",
        "transactionAmount": {
          "amount": "-2000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to EUR Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to EUR Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to EUR and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.110Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_aewa0759f17ta3b2t93q83bwqg",
      "createdAt": "2025-10-04T10:51:00.000Z",
      "updatedAt": "2025-10-04T10:51:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.77,
      "currency": "GBP",
      "description": "Payment to Transport for London: TFL-202510-8572",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bf273g4315v0fmg0myt13k3c84",
      "fspDate": "2025-10-04T09:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bf273g4315v0fmg0myt13k3c84",
        "bookingDate": "2025-10-04",
        "valueDate": "2025-10-04",
        "bookingDateTime": "2025-10-04T10:51:00.000Z",
        "valueDateTime": "2025-10-04T10:51:00.000Z",
        "transactionAmount": {
          "amount": "15.77",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Transport for London: TFL-202510-8572",
        "remittanceInformationUnstructuredArray": [
          "Payment to Transport for London",
          "TFL-202510-8572"
        ],
        "debtorName": "Transport for London"
      },
      "paymentId": null,
      "reference": "TFL-202510-8572",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgk7fvhrjp0v7hz9q786",
      "clustering": {
        "description": "Transport for London",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Transport for London' based on payment details",
        "updatedAt": "2025-10-04T10:51:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Transport for London",
        "iban": null,
        "bic": null,
        "sortCode": "240124",
        "accountNumber": "42654216"
      }
    },
    {
      "id": "txn_01k65c32y5eshspggbpa7mz9rp",
      "createdAt": "2025-10-04T08:48:00.000Z",
      "updatedAt": "2025-10-04T08:48:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 62.59,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1f08ytcwm1g",
      "fspDate": "2025-10-04T07:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1f08ytcwm1g",
        "bookingDate": "2025-10-04",
        "valueDate": "2025-10-04",
        "bookingDateTime": "2025-10-04T07:48:00.000Z",
        "valueDateTime": "2025-10-04T07:48:00.000Z",
        "transactionAmount": {
          "amount": "-62.59",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Zakura' from 'Zakura'.",
        "updatedAt": "2025-09-27T10:52:47.405Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfsdvzx34mds",
      "createdAt": "2025-10-03T14:27:00.000Z",
      "updatedAt": "2025-10-03T14:27:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 140,
      "currency": "EUR",
      "description": "Anthropic Claude Team",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0pjkg62et3z",
      "fspDate": "2025-10-03T13:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0pjkg62et3z",
        "bookingDate": "2025-10-03",
        "valueDate": "2025-10-03",
        "bookingDateTime": "2025-10-03T13:27:00.000Z",
        "valueDateTime": "2025-10-03T13:27:00.000Z",
        "transactionAmount": {
          "amount": "-140.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Anthropic Claude Team",
        "remittanceInformationUnstructuredArray": [
          "Anthropic Claude Team"
        ],
        "debtorName": "Anthropic"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0y2eshspjwh0d2fxb76",
      "clustering": {
        "description": "Anthropic",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Anthropic' from 'Anthropic Claude Team'",
        "updatedAt": "2025-09-27T10:49:37.740Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xxeshspeejatyb3jsv",
      "createdAt": "2025-10-03T12:07:00.000Z",
      "updatedAt": "2025-10-03T12:07:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Sq *amba",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3wzvbyze4btjekhhee2zmtg",
      "fspDate": "2025-10-03T11:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3wzvbyze4btjekhhee2zmtg",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T11:00:00.000Z",
        "valueDateTime": "2026-01-04T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *amba",
        "remittanceInformationUnstructuredArray": [
          "Sq *amba"
        ],
        "debtorName": "Amba"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g1aeshsphp662hfbd17",
      "clustering": {
        "description": "Amba",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Amba' from 'Sq *amba', removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:39:39.637Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yymyt1tparrh55qtw1nzs742kn",
      "createdAt": "2025-10-03T11:09:00.000Z",
      "updatedAt": "2025-10-03T11:09:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 21423.54,
      "currency": "EUR",
      "description": "Payment from EuroTech Innovations - INV-202510-7841",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_q53xnctxs1d9fqj1ayd3x6xy76",
      "fspDate": "2025-10-03T10:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_q53xnctxs1d9fqj1ayd3x6xy76",
        "bookingDate": "2025-10-03",
        "valueDate": "2025-10-03",
        "bookingDateTime": "2025-10-03T11:09:00.000Z",
        "valueDateTime": "2025-10-03T11:09:00.000Z",
        "transactionAmount": {
          "amount": "21423.54",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from EuroTech Innovations - INV-202510-7841",
        "remittanceInformationUnstructuredArray": [
          "Payment from EuroTech Innovations",
          "INV-202510-7841"
        ],
        "creditorName": "EuroTech Innovations"
      },
      "paymentId": null,
      "reference": "INV-202510-7841",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m17gcz62vyhqqefr5q41a31k5f",
      "clustering": {
        "description": "EuroTech Innovations",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'EuroTech Innovations'",
        "updatedAt": "2025-10-03T11:09:00.000Z"
      },
      "payer": {
        "name": "EuroTech Innovations",
        "iban": "DE88644383725048620",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf36jzpk63dt",
      "createdAt": "2025-10-03T09:19:00.000Z",
      "updatedAt": "2025-10-03T09:19:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 3214.25,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k21rq21jf2181cbh5fy3hya9",
      "fspDate": "2025-10-03T08:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k21rq21jf2181cbh5fy3hya9",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T10:00:00.000Z",
        "valueDateTime": "2026-01-03T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-3214.25",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the description for the currency conversion transaction.",
        "updatedAt": "2025-09-27T10:43:55.482Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg7fs1v8np4c",
      "createdAt": "2025-10-03T08:50:00.000Z",
      "updatedAt": "2025-10-03T08:50:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 62.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk160mw9v3eqx",
      "fspDate": "2025-10-03T07:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk160mw9v3eqx",
        "bookingDate": "2025-10-03",
        "valueDate": "2025-10-03",
        "bookingDateTime": "2025-10-03T07:50:00.000Z",
        "valueDateTime": "2025-10-03T07:50:00.000Z",
        "transactionAmount": {
          "amount": "-62.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'.",
        "updatedAt": "2025-09-27T10:51:38.263Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_krfj36da8x3gknx8vvm3brghxt",
      "createdAt": "2025-10-03T08:02:00.000Z",
      "updatedAt": "2025-10-03T08:02:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.45,
      "currency": "EUR",
      "description": "Payment to XAI: X-202510-5788",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_85jf05shegheh01r28h28d9acj",
      "fspDate": "2025-10-03T07:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_85jf05shegheh01r28h28d9acj",
        "bookingDate": "2025-10-03",
        "valueDate": "2025-10-03",
        "bookingDateTime": "2025-10-03T08:02:00.000Z",
        "valueDateTime": "2025-10-03T08:02:00.000Z",
        "transactionAmount": {
          "amount": "25.45",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to XAI: X-202510-5788",
        "remittanceInformationUnstructuredArray": [
          "Payment to XAI",
          "X-202510-5788"
        ],
        "debtorName": "XAI"
      },
      "paymentId": null,
      "reference": "X-202510-5788",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgt8yeshspk60ezf5bsne",
      "clustering": {
        "description": "XAI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'XAI' based on payment details",
        "updatedAt": "2025-10-03T08:02:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "XAI",
        "iban": "DE28171530116652950",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_khf1ha3an35dp65c29vyjpvzyq",
      "createdAt": "2025-10-02T13:38:00.000Z",
      "updatedAt": "2025-10-02T13:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.56,
      "currency": "EUR",
      "description": "Payment to The Pig And Heifer: TPA-202510-8602",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wq8mcz2v21x2mhvmyd0ark0tss",
      "fspDate": "2025-10-02T12:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wq8mcz2v21x2mhvmyd0ark0tss",
        "bookingDate": "2025-10-02",
        "valueDate": "2025-10-02",
        "bookingDateTime": "2025-10-02T13:38:00.000Z",
        "valueDateTime": "2025-10-02T13:38:00.000Z",
        "transactionAmount": {
          "amount": "15.56",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Pig And Heifer: TPA-202510-8602",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Pig And Heifer",
          "TPA-202510-8602"
        ],
        "debtorName": "The Pig And Heifer"
      },
      "paymentId": null,
      "reference": "TPA-202510-8602",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g5weshsphq7y8rf4z8z",
      "clustering": {
        "description": "The Pig And Heifer",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Pig And Heifer' based on payment details",
        "updatedAt": "2025-10-02T13:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Pig And Heifer",
        "iban": "DE45669885729989280",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4z0nbvgxte9hn6z7vchh21pwxx",
      "createdAt": "2025-10-02T12:30:00.000Z",
      "updatedAt": "2025-10-02T12:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 42.4,
      "currency": "GBP",
      "description": "Payment to Captain Nemo: CN-202510-5005",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pyg43dk609f7nagq53rp61c80w",
      "fspDate": "2025-10-02T11:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pyg43dk609f7nagq53rp61c80w",
        "bookingDate": "2025-10-02",
        "valueDate": "2025-10-02",
        "bookingDateTime": "2025-10-02T12:30:00.000Z",
        "valueDateTime": "2025-10-02T12:30:00.000Z",
        "transactionAmount": {
          "amount": "42.40",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Captain Nemo: CN-202510-5005",
        "remittanceInformationUnstructuredArray": [
          "Payment to Captain Nemo",
          "CN-202510-5005"
        ],
        "debtorName": "Captain Nemo"
      },
      "paymentId": null,
      "reference": "CN-202510-5005",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fm8nzsfzz9aen1pftqn9qr",
      "clustering": {
        "description": "Captain Nemo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Captain Nemo' based on payment details",
        "updatedAt": "2025-10-02T12:30:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Captain Nemo",
        "iban": null,
        "bic": null,
        "sortCode": "138606",
        "accountNumber": "12809415"
      }
    },
    {
      "id": "txn_paxbmvtwwp0j2yrz4gg6sz55bg",
      "createdAt": "2025-10-02T11:15:00.000Z",
      "updatedAt": "2025-10-02T11:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 49.37,
      "currency": "GBP",
      "description": "Payment to ICO: I-202510-2605",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hczb4kv9198xskna1th5wzk6pe",
      "fspDate": "2025-10-02T10:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hczb4kv9198xskna1th5wzk6pe",
        "bookingDate": "2025-10-02",
        "valueDate": "2025-10-02",
        "bookingDateTime": "2025-10-02T11:15:00.000Z",
        "valueDateTime": "2025-10-02T11:15:00.000Z",
        "transactionAmount": {
          "amount": "49.37",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to ICO: I-202510-2605",
        "remittanceInformationUnstructuredArray": [
          "Payment to ICO",
          "I-202510-2605"
        ],
        "debtorName": "ICO"
      },
      "paymentId": null,
      "reference": "I-202510-2605",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4gyfvhrjnsxtfs19v9b",
      "clustering": {
        "description": "ICO",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'ICO' based on payment details",
        "updatedAt": "2025-10-02T11:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "ICO",
        "iban": null,
        "bic": null,
        "sortCode": "613379",
        "accountNumber": "98228639"
      }
    },
    {
      "id": "txn_8z0wwxq92ahdejz6x2pn692a92",
      "createdAt": "2025-09-30T10:01:00.000Z",
      "updatedAt": "2025-09-30T10:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1.87,
      "currency": "GBP",
      "description": "Payment to Mylands: M-202509-5078",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1tfgbn3kdw79ydmwvj6x0kg9pn",
      "fspDate": "2025-09-30T09:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1tfgbn3kdw79ydmwvj6x0kg9pn",
        "bookingDate": "2025-09-30",
        "valueDate": "2025-09-30",
        "bookingDateTime": "2025-09-30T10:01:00.000Z",
        "valueDateTime": "2025-09-30T10:01:00.000Z",
        "transactionAmount": {
          "amount": "1.87",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mylands: M-202509-5078",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mylands",
          "M-202509-5078"
        ],
        "debtorName": "Mylands"
      },
      "paymentId": null,
      "reference": "M-202509-5078",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbnxzzfvhrjp5np8trhg47",
      "clustering": {
        "description": "Mylands",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mylands' based on payment details",
        "updatedAt": "2025-09-30T10:01:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mylands",
        "iban": null,
        "bic": null,
        "sortCode": "701113",
        "accountNumber": "87429671"
      }
    },
    {
      "id": "txn_pgys19kf3khwjkn1q7djqpnnn5",
      "createdAt": "2025-09-30T09:44:00.000Z",
      "updatedAt": "2025-09-30T09:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 18.23,
      "currency": "EUR",
      "description": "Payment to Salt Cellar Cafe: SCC-202509-2382",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xhzaapcg7jfpph63zwxx6txjg4",
      "fspDate": "2025-09-30T08:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xhzaapcg7jfpph63zwxx6txjg4",
        "bookingDate": "2025-09-30",
        "valueDate": "2025-09-30",
        "bookingDateTime": "2025-09-30T09:44:00.000Z",
        "valueDateTime": "2025-09-30T09:44:00.000Z",
        "transactionAmount": {
          "amount": "18.23",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Salt Cellar Cafe: SCC-202509-2382",
        "remittanceInformationUnstructuredArray": [
          "Payment to Salt Cellar Cafe",
          "SCC-202509-2382"
        ],
        "debtorName": "Salt Cellar Cafe"
      },
      "paymentId": null,
      "reference": "SCC-202509-2382",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0x9eshspkzthwr7rcm3",
      "clustering": {
        "description": "Salt Cellar Cafe",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Salt Cellar Cafe' based on payment details",
        "updatedAt": "2025-09-30T09:44:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Salt Cellar Cafe",
        "iban": "DE39353580587717100",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jg8hac53tgpmsvd2xf3whzp5dm",
      "createdAt": "2025-09-30T09:33:00.000Z",
      "updatedAt": "2025-09-30T09:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2.1,
      "currency": "EUR",
      "description": "Payment to Merrion Row Post Office: MRP-202509-1758",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_srg6dw4wnjvn5ys0sw76dbv88s",
      "fspDate": "2025-09-30T08:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_srg6dw4wnjvn5ys0sw76dbv88s",
        "bookingDate": "2025-09-30",
        "valueDate": "2025-09-30",
        "bookingDateTime": "2025-09-30T09:33:00.000Z",
        "valueDateTime": "2025-09-30T09:33:00.000Z",
        "transactionAmount": {
          "amount": "2.10",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Merrion Row Post Office: MRP-202509-1758",
        "remittanceInformationUnstructuredArray": [
          "Payment to Merrion Row Post Office",
          "MRP-202509-1758"
        ],
        "debtorName": "Merrion Row Post Office"
      },
      "paymentId": null,
      "reference": "MRP-202509-1758",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj0neshspngm4dw1pq8h",
      "clustering": {
        "description": "Merrion Row Post Office",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Merrion Row Post Office' based on payment details",
        "updatedAt": "2025-09-30T09:33:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Merrion Row Post Office",
        "iban": "DE42234841272723310",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_aywa508mcz3cqf0pgx2nwk03c7",
      "createdAt": "2025-09-30T09:15:00.000Z",
      "updatedAt": "2025-09-30T09:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 35.51,
      "currency": "EUR",
      "description": "Payment to Sweet Salt: SS-202509-4115",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2fj5mdyra8ec8k2t0c9cjtyhs6",
      "fspDate": "2025-09-30T08:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2fj5mdyra8ec8k2t0c9cjtyhs6",
        "bookingDate": "2025-09-30",
        "valueDate": "2025-09-30",
        "bookingDateTime": "2025-09-30T09:15:00.000Z",
        "valueDateTime": "2025-09-30T09:15:00.000Z",
        "transactionAmount": {
          "amount": "35.51",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sweet Salt: SS-202509-4115",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sweet Salt",
          "SS-202509-4115"
        ],
        "debtorName": "Sweet Salt"
      },
      "paymentId": null,
      "reference": "SS-202509-4115",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmad4eshspkk8z9xs58fk",
      "clustering": {
        "description": "Sweet Salt",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sweet Salt' based on payment details",
        "updatedAt": "2025-09-30T09:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sweet Salt",
        "iban": "DE76338992189896340",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_a5hxkm9s397ydr8z5k9kwv7t2j",
      "createdAt": "2025-09-29T15:02:00.000Z",
      "updatedAt": "2025-09-29T15:02:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 39.61,
      "currency": "GBP",
      "description": "Payment to Financial Times: FT-202509-8164",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qpb7ax94yb7whb21fw6ff9x323",
      "fspDate": "2025-09-29T14:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qpb7ax94yb7whb21fw6ff9x323",
        "bookingDate": "2025-09-29",
        "valueDate": "2025-09-29",
        "bookingDateTime": "2025-09-29T15:02:00.000Z",
        "valueDateTime": "2025-09-29T15:02:00.000Z",
        "transactionAmount": {
          "amount": "39.61",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Financial Times: FT-202509-8164",
        "remittanceInformationUnstructuredArray": [
          "Payment to Financial Times",
          "FT-202509-8164"
        ],
        "debtorName": "Financial Times"
      },
      "paymentId": null,
      "reference": "FT-202509-8164",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gjeshspjygqrrg6sk5",
      "clustering": {
        "description": "Financial Times",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Financial Times' based on payment details",
        "updatedAt": "2025-09-29T15:02:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Financial Times",
        "iban": null,
        "bic": null,
        "sortCode": "168416",
        "accountNumber": "56639431"
      }
    },
    {
      "id": "txn_5mz8v2vgejc2b89c9jfz0012vd",
      "createdAt": "2025-09-29T14:15:00.000Z",
      "updatedAt": "2025-09-29T14:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 53.53,
      "currency": "GBP",
      "description": "Payment to Deliveroo: D-202509-2045",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_n6ckaexvqdzd845e1w4ksy45f0",
      "fspDate": "2025-09-29T13:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_n6ckaexvqdzd845e1w4ksy45f0",
        "bookingDate": "2025-09-29",
        "valueDate": "2025-09-29",
        "bookingDateTime": "2025-09-29T14:15:00.000Z",
        "valueDateTime": "2025-09-29T14:15:00.000Z",
        "transactionAmount": {
          "amount": "53.53",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Deliveroo: D-202509-2045",
        "remittanceInformationUnstructuredArray": [
          "Payment to Deliveroo",
          "D-202509-2045"
        ],
        "debtorName": "Deliveroo"
      },
      "paymentId": null,
      "reference": "D-202509-2045",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmcfvhrjp16bczghe88",
      "clustering": {
        "description": "Deliveroo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Deliveroo' based on payment details",
        "updatedAt": "2025-09-29T14:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Deliveroo",
        "iban": null,
        "bic": null,
        "sortCode": "903039",
        "accountNumber": "50635289"
      }
    },
    {
      "id": "txn_jj7wgdnhx3f72wn2gpzrnana1k",
      "createdAt": "2025-09-29T13:42:00.000Z",
      "updatedAt": "2025-09-29T13:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1834.99,
      "currency": "EUR",
      "description": "Payment to Sophie Laurent: SL-202509-7238",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_254t6bc6e5bt12c6mjhhqnyhvs",
      "fspDate": "2025-09-29T12:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_254t6bc6e5bt12c6mjhhqnyhvs",
        "bookingDate": "2025-09-29",
        "valueDate": "2025-09-29",
        "bookingDateTime": "2025-09-29T13:42:00.000Z",
        "valueDateTime": "2025-09-29T13:42:00.000Z",
        "transactionAmount": {
          "amount": "1834.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sophie Laurent: SL-202509-7238",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sophie Laurent",
          "SL-202509-7238"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": "SL-202509-7238",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc5eshspj0rxb4j151x",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sophie Laurent' based on payment details",
        "updatedAt": "2025-09-29T13:42:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sophie Laurent",
        "iban": "DE86078117426497200",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_c3ykcxad5r1e60yq03jfn9gy0j",
      "createdAt": "2025-09-29T08:29:00.000Z",
      "updatedAt": "2025-09-29T08:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 22.94,
      "currency": "EUR",
      "description": "Payment to Muhammad Tashf: MT-202509-5509",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jr24dcww22vt8b2b2qewnxmk00",
      "fspDate": "2025-09-29T07:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jr24dcww22vt8b2b2qewnxmk00",
        "bookingDate": "2025-09-29",
        "valueDate": "2025-09-29",
        "bookingDateTime": "2025-09-29T08:29:00.000Z",
        "valueDateTime": "2025-09-29T08:29:00.000Z",
        "transactionAmount": {
          "amount": "22.94",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Muhammad Tashf: MT-202509-5509",
        "remittanceInformationUnstructuredArray": [
          "Payment to Muhammad Tashf",
          "MT-202509-5509"
        ],
        "debtorName": "Muhammad Tashf"
      },
      "paymentId": null,
      "reference": "MT-202509-5509",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkgjeshspnx4pqb9b6ze",
      "clustering": {
        "description": "Muhammad Tashf",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Muhammad Tashf' based on payment details",
        "updatedAt": "2025-09-29T08:29:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Muhammad Tashf",
        "iban": "DE81462022107864750",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_y2baxv3tbaaes3mg7p921nvk94",
      "createdAt": "2025-09-28T14:35:00.000Z",
      "updatedAt": "2025-09-28T14:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 33.84,
      "currency": "EUR",
      "description": "Payment to Delhi2Dublin: D-202509-4010",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_84qz4mw51s55qm5ry4m6zr5yhm",
      "fspDate": "2025-09-28T13:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_84qz4mw51s55qm5ry4m6zr5yhm",
        "bookingDate": "2025-09-28",
        "valueDate": "2025-09-28",
        "bookingDateTime": "2025-09-28T14:35:00.000Z",
        "valueDateTime": "2025-09-28T14:35:00.000Z",
        "transactionAmount": {
          "amount": "33.84",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Delhi2Dublin: D-202509-4010",
        "remittanceInformationUnstructuredArray": [
          "Payment to Delhi2Dublin",
          "D-202509-4010"
        ],
        "debtorName": "Delhi2Dublin"
      },
      "paymentId": null,
      "reference": "D-202509-4010",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0x5eshspjwbxzrhs5dn",
      "clustering": {
        "description": "Delhi2Dublin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Delhi2Dublin' based on payment details",
        "updatedAt": "2025-09-28T14:35:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Delhi2Dublin",
        "iban": "DE32726132759574756",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fv95dwbnxc4da7ak6xvjbvzqvh",
      "createdAt": "2025-09-28T12:36:00.000Z",
      "updatedAt": "2025-09-28T12:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 8.05,
      "currency": "USD",
      "description": "Payment to 1Password: 1-202509-7092",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_acxbr5jnre0pcfca8bz9tf4q32",
      "fspDate": "2025-09-28T11:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_acxbr5jnre0pcfca8bz9tf4q32",
        "bookingDate": "2025-09-28",
        "valueDate": "2025-09-28",
        "bookingDateTime": "2025-09-28T12:36:00.000Z",
        "valueDateTime": "2025-09-28T12:36:00.000Z",
        "transactionAmount": {
          "amount": "8.05",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to 1Password: 1-202509-7092",
        "remittanceInformationUnstructuredArray": [
          "Payment to 1Password",
          "1-202509-7092"
        ],
        "debtorName": "1Password"
      },
      "paymentId": null,
      "reference": "1-202509-7092",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxpeshspjghv7zy63at",
      "clustering": {
        "description": "1Password",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor '1Password' based on payment details",
        "updatedAt": "2025-09-28T12:36:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "1Password",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgf5g264bb5z",
      "createdAt": "2025-09-28T12:06:00.000Z",
      "updatedAt": "2025-09-28T12:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6003.19,
      "currency": "EUR",
      "description": "To Lucia Moretti",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1dmm5s4dyq3",
      "fspDate": "2025-09-28T11:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1dmm5s4dyq3",
        "bookingDate": "2025-09-28",
        "valueDate": "2025-09-28",
        "bookingDateTime": "2025-09-28T11:06:00.000Z",
        "valueDateTime": "2025-09-28T11:06:00.000Z",
        "transactionAmount": {
          "amount": "-6003.19",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Lucia Moretti",
        "remittanceInformationUnstructuredArray": [
          "To Lucia Moretti"
        ],
        "debtorName": "Lucia Moretti"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsbeshspj7jp8q6rygp",
      "clustering": {
        "description": "Lucia Moretti",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Lucia Moretti' from 'To Lucia Moretti'.",
        "updatedAt": "2025-09-27T10:52:47.347Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2z2pvrrh85p2re0ynbk0c0dsg3",
      "createdAt": "2025-09-28T11:00:00.000Z",
      "updatedAt": "2025-09-28T11:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 11.56,
      "currency": "EUR",
      "description": "Payment to A Taste of Thai: ATO-202509-8829",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_g3dwtxfk7hd15n2x7wwtyj2py6",
      "fspDate": "2025-09-28T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_g3dwtxfk7hd15n2x7wwtyj2py6",
        "bookingDate": "2025-09-28",
        "valueDate": "2025-09-28",
        "bookingDateTime": "2025-09-28T11:00:00.000Z",
        "valueDateTime": "2025-09-28T11:00:00.000Z",
        "transactionAmount": {
          "amount": "11.56",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to A Taste of Thai: ATO-202509-8829",
        "remittanceInformationUnstructuredArray": [
          "Payment to A Taste of Thai",
          "ATO-202509-8829"
        ],
        "debtorName": "A Taste of Thai"
      },
      "paymentId": null,
      "reference": "ATO-202509-8829",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1m2eshspm6a6wp0a9jq",
      "clustering": {
        "description": "A Taste of Thai",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'A Taste of Thai' based on payment details",
        "updatedAt": "2025-09-28T11:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "A Taste of Thai",
        "iban": "DE73439506167742430",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_80hb52nstn19mh9c3fsekffdrp",
      "createdAt": "2025-09-28T10:46:00.000Z",
      "updatedAt": "2025-09-28T10:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 16.61,
      "currency": "EUR",
      "description": "Payment to Seoul Kitchen: SK-202509-4048",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_3fewqe6xjfk3bx1gyznjb91d0q",
      "fspDate": "2025-09-28T09:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_3fewqe6xjfk3bx1gyznjb91d0q",
        "bookingDate": "2025-09-28",
        "valueDate": "2025-09-28",
        "bookingDateTime": "2025-09-28T10:46:00.000Z",
        "valueDateTime": "2025-09-28T10:46:00.000Z",
        "transactionAmount": {
          "amount": "16.61",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Seoul Kitchen: SK-202509-4048",
        "remittanceInformationUnstructuredArray": [
          "Payment to Seoul Kitchen",
          "SK-202509-4048"
        ],
        "debtorName": "Seoul Kitchen"
      },
      "paymentId": null,
      "reference": "SK-202509-4048",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pzaeshspjhkemvf76tx",
      "clustering": {
        "description": "Seoul Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Seoul Kitchen' based on payment details",
        "updatedAt": "2025-09-28T10:46:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Seoul Kitchen",
        "iban": "DE27245757750202820",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_654nhdfdjhh9bjrfwx4j4amsv9",
      "createdAt": "2025-09-28T10:36:00.000Z",
      "updatedAt": "2025-09-28T10:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.17,
      "currency": "USD",
      "description": "Payment to Linear: L-202509-2835",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wsjhr190yb8y75d8qddhqcvgps",
      "fspDate": "2025-09-28T09:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wsjhr190yb8y75d8qddhqcvgps",
        "bookingDate": "2025-09-28",
        "valueDate": "2025-09-28",
        "bookingDateTime": "2025-09-28T10:36:00.000Z",
        "valueDateTime": "2025-09-28T10:36:00.000Z",
        "transactionAmount": {
          "amount": "10.17",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Linear: L-202509-2835",
        "remittanceInformationUnstructuredArray": [
          "Payment to Linear",
          "L-202509-2835"
        ],
        "debtorName": "Linear"
      },
      "paymentId": null,
      "reference": "L-202509-2835",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc1eshspj0mxd2vh6zx",
      "clustering": {
        "description": "Linear",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Linear' based on payment details",
        "updatedAt": "2025-09-28T10:36:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Linear",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_f8m21ep1j9m3mcc7s68f81fv7h",
      "createdAt": "2025-09-28T10:19:00.000Z",
      "updatedAt": "2025-09-28T10:19:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 18.69,
      "currency": "EUR",
      "description": "Payment to Marquette: M-202509-2131",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bfftnfrn1beykds9998kv4myag",
      "fspDate": "2025-09-28T09:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bfftnfrn1beykds9998kv4myag",
        "bookingDate": "2025-09-28",
        "valueDate": "2025-09-28",
        "bookingDateTime": "2025-09-28T10:19:00.000Z",
        "valueDateTime": "2025-09-28T10:19:00.000Z",
        "transactionAmount": {
          "amount": "18.69",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marquette: M-202509-2131",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marquette",
          "M-202509-2131"
        ],
        "debtorName": "Marquette"
      },
      "paymentId": null,
      "reference": "M-202509-2131",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1npeshspm6wcf3gtsdh",
      "clustering": {
        "description": "Marquette",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marquette' based on payment details",
        "updatedAt": "2025-09-28T10:19:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marquette",
        "iban": "DE53786448133180140",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfw399qxgc94",
      "createdAt": "2025-09-28T09:55:00.000Z",
      "updatedAt": "2025-09-28T09:55:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 13,
      "currency": "EUR",
      "description": "Sumup *doncanizales",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0rzth9r2tmz",
      "fspDate": "2025-09-28T08:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0rzth9r2tmz",
        "bookingDate": "2025-12-15",
        "valueDate": "2025-12-15",
        "bookingDateTime": "2025-12-15T12:59:00.000Z",
        "valueDateTime": "2025-12-15T12:59:00.000Z",
        "transactionAmount": {
          "amount": "-13.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *doncanizales",
        "remittanceInformationUnstructuredArray": [
          "Sumup *doncanizales"
        ],
        "debtorName": "Don Canizales"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "clustering": {
        "description": "Don Canizales",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Don Canizales' from 'Sumup *doncanizales'",
        "updatedAt": "2025-09-27T10:50:08.349Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xxeshspee80a1ptm0a",
      "createdAt": "2025-09-28T09:44:00.000Z",
      "updatedAt": "2025-09-28T09:44:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.3,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3zj8ndsesm9eze46bvbgkpy",
      "fspDate": "2025-09-28T08:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3zj8ndsesm9eze46bvbgkpy",
        "bookingDate": "2025-09-28",
        "valueDate": "2025-09-28",
        "bookingDateTime": "2025-09-28T08:44:00.000Z",
        "valueDateTime": "2025-09-28T08:44:00.000Z",
        "transactionAmount": {
          "amount": "-17.30",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Cursor' from 'Cursor, Ai Powered Ide', removing any additional information.",
        "updatedAt": "2025-09-27T10:39:39.629Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_csg5phsbv5mb81mddx154zfx6f",
      "createdAt": "2025-09-28T09:28:00.000Z",
      "updatedAt": "2025-09-28T09:28:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 15227.74,
      "currency": "GBP",
      "description": "Payment from Digital Ventures Group - INV-202509-9092",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ygxxjfccmv63tddt9zpcky84xn",
      "fspDate": "2025-09-28T08:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ygxxjfccmv63tddt9zpcky84xn",
        "bookingDate": "2025-09-28",
        "valueDate": "2025-09-28",
        "bookingDateTime": "2025-09-28T09:28:00.000Z",
        "valueDateTime": "2025-09-28T09:28:00.000Z",
        "transactionAmount": {
          "amount": "15227.74",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Digital Ventures Group - INV-202509-9092",
        "remittanceInformationUnstructuredArray": [
          "Payment from Digital Ventures Group",
          "INV-202509-9092"
        ],
        "creditorName": "Digital Ventures Group"
      },
      "paymentId": null,
      "reference": "INV-202509-9092",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_mj6n80che7b1rf41e9c0gtanqb",
      "clustering": {
        "description": "Digital Ventures Group",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Digital Ventures Group'",
        "updatedAt": "2025-09-28T09:28:00.000Z"
      },
      "payer": {
        "name": "Digital Ventures Group",
        "iban": null,
        "bic": null,
        "sortCode": "514866",
        "accountNumber": "33257215"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm4g9cax41j5",
      "createdAt": "2025-09-28T07:07:00.000Z",
      "updatedAt": "2025-09-28T07:07:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 2589.88,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2ksfsfdfzwbd14ny6h98vq4",
      "fspDate": "2025-09-28T06:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ksfsfdfzwbd14ny6h98vq4",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T11:00:00.000Z",
        "valueDateTime": "2026-01-06T11:00:00.000Z",
        "transactionAmount": {
          "amount": "2589.88",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.851Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspga71mdt6sbq",
      "createdAt": "2025-09-27T16:51:00.000Z",
      "updatedAt": "2025-09-27T16:51:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk1888d5kkn9y",
      "fspDate": "2025-09-27T15:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk1888d5kkn9y",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T08:00:00.000Z",
        "valueDateTime": "2026-01-07T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-5.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration Office",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Companies Registration Office' from 'Companies Registration'",
        "updatedAt": "2025-09-27T10:52:09.969Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf8eh1wq8d3x",
      "createdAt": "2025-09-27T16:38:00.000Z",
      "updatedAt": "2025-09-27T16:38:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 136.5,
      "currency": "EUR",
      "description": "Sp Naomis Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1fpmbemeh1r153790437f20",
      "fspDate": "2025-09-27T15:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1fpmbemeh1r153790437f20",
        "bookingDate": "2025-09-27",
        "valueDate": "2025-09-27",
        "bookingDateTime": "2025-09-27T15:38:00.000Z",
        "valueDateTime": "2025-09-27T15:38:00.000Z",
        "transactionAmount": {
          "amount": "-136.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sp Naomis Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Sp Naomis Kitchen"
        ],
        "debtorName": "Naomis Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh3deshspkhegxj7z9nq",
      "clustering": {
        "description": "Naomis Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Naomis Kitchen' from 'Sp Naomis Kitchen', removing the Sp * prefix",
        "updatedAt": "2025-09-27T10:45:11.578Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph4hd0k60gz4",
      "createdAt": "2025-09-27T14:04:00.000Z",
      "updatedAt": "2025-09-27T14:04:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 36,
      "currency": "EUR",
      "description": "Draculas Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk22kybtga34w",
      "fspDate": "2025-09-27T13:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk22kybtga34w",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T15:00:00.000Z",
        "valueDateTime": "2026-01-04T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-36.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Draculas Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Draculas Kitchen"
        ],
        "debtorName": "Dracula's Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcgeshspn9xska0mg5b",
      "clustering": {
        "description": "Dracula's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Dracula's Kitchen' from 'Draculas Kitchen'",
        "updatedAt": "2025-09-27T10:54:50.857Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmdaj64wa5vb",
      "createdAt": "2025-09-27T13:34:00.000Z",
      "updatedAt": "2025-09-27T13:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5826.8,
      "currency": "GBP",
      "description": "To Emily Harrington",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk862826j6nxx",
      "fspDate": "2025-09-27T12:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk862826j6nxx",
        "bookingDate": "2025-09-27",
        "valueDate": "2025-09-27",
        "bookingDateTime": "2025-09-27T12:34:00.000Z",
        "valueDateTime": "2025-09-27T12:34:00.000Z",
        "transactionAmount": {
          "amount": "-5826.80",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Emily Harrington",
        "remittanceInformationUnstructuredArray": [
          "To Emily Harrington"
        ],
        "debtorName": "Emily Harrington"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnawfvhrjnjkdggymq9f",
      "clustering": {
        "description": "Emily Harrington",
        "confidenceScore": "0.95",
        "rationale": "Extracted the name 'Emily Harrington' from 'To Emily Harrington'",
        "updatedAt": "2025-09-29T18:25:01.114Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspeq711kbvphb",
      "createdAt": "2025-09-27T13:18:00.000Z",
      "updatedAt": "2025-09-27T13:18:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 18,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k38h61sqeh2t0debv966g0f5",
      "fspDate": "2025-09-27T12:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k38h61sqeh2t0debv966g0f5",
        "bookingDate": "2025-09-27",
        "valueDate": "2025-09-27",
        "bookingDateTime": "2025-09-27T12:18:00.000Z",
        "valueDateTime": "2025-09-27T12:18:00.000Z",
        "transactionAmount": {
          "amount": "-18.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Burger Cartel' from 'Burger Cartel Limited'",
        "updatedAt": "2025-09-27T10:40:26.912Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_23y06yzdv1q6w3dkmxprzsv63n",
      "createdAt": "2025-09-27T13:13:00.000Z",
      "updatedAt": "2025-09-27T13:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 28514.27,
      "currency": "GBP",
      "description": "Payment from Global Solutions Ltd - INV-202509-7030",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5ymsrmnh95bfxeg19pspw3dj13",
      "fspDate": "2025-09-27T12:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5ymsrmnh95bfxeg19pspw3dj13",
        "bookingDate": "2025-09-27",
        "valueDate": "2025-09-27",
        "bookingDateTime": "2025-09-27T13:13:00.000Z",
        "valueDateTime": "2025-09-27T13:13:00.000Z",
        "transactionAmount": {
          "amount": "28514.27",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Global Solutions Ltd - INV-202509-7030",
        "remittanceInformationUnstructuredArray": [
          "Payment from Global Solutions Ltd",
          "INV-202509-7030"
        ],
        "creditorName": "Global Solutions Ltd"
      },
      "paymentId": null,
      "reference": "INV-202509-7030",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_th3hfveyjxh2erds1n633s02yd",
      "clustering": {
        "description": "Global Solutions Ltd",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Global Solutions Ltd'",
        "updatedAt": "2025-09-27T13:13:00.000Z"
      },
      "payer": {
        "name": "Global Solutions Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "455886",
        "accountNumber": "38652463"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgpzt199pqqd",
      "createdAt": "2025-09-27T12:27:00.000Z",
      "updatedAt": "2025-09-27T12:27:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 6.45,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1mksd7rd917",
      "fspDate": "2025-09-27T11:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1mksd7rd917",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T13:00:00.000Z",
        "valueDateTime": "2026-01-04T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-6.45",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'DocuSign' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.224Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshspgznqw2dpbn1",
      "createdAt": "2025-09-27T11:58:00.000Z",
      "updatedAt": "2025-09-27T11:58:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 56,
      "currency": "EUR",
      "description": "Tula Mexican Grill 03",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1yk0ssbbgpr",
      "fspDate": "2025-09-27T10:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1yk0ssbbgpr",
        "bookingDate": "2025-09-27",
        "valueDate": "2025-09-27",
        "bookingDateTime": "2025-09-27T10:58:00.000Z",
        "valueDateTime": "2025-09-27T10:58:00.000Z",
        "transactionAmount": {
          "amount": "-56.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tula Mexican Grill 03",
        "remittanceInformationUnstructuredArray": [
          "Tula Mexican Grill 03"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Tula Mexican Grill' from 'Tula Mexican Grill 03', removing the '03' store number suffix.",
        "updatedAt": "2025-09-27T10:54:12.551Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n4f8s96v8nz0s8ay97yt6rq2kt",
      "createdAt": "2025-09-27T10:16:00.000Z",
      "updatedAt": "2025-09-27T10:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 510.04,
      "currency": "GBP",
      "description": "Payment to Slack Technologies Limited: STL-202509-4316",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_8dahre9wxy90fqkf98ahye7f4a",
      "fspDate": "2025-09-27T09:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_8dahre9wxy90fqkf98ahye7f4a",
        "bookingDate": "2025-09-27",
        "valueDate": "2025-09-27",
        "bookingDateTime": "2025-09-27T10:16:00.000Z",
        "valueDateTime": "2025-09-27T10:16:00.000Z",
        "transactionAmount": {
          "amount": "510.04",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack Technologies Limited: STL-202509-4316",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack Technologies Limited",
          "STL-202509-4316"
        ],
        "debtorName": "Slack Technologies Limited"
      },
      "paymentId": null,
      "reference": "STL-202509-4316",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_6m3t4s5pcz3g5997sxc586yj3f",
      "clustering": {
        "description": "Slack Technologies Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack Technologies Limited' based on payment details",
        "updatedAt": "2025-09-27T10:16:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack Technologies Limited",
        "iban": null,
        "bic": null,
        "sortCode": "605713",
        "accountNumber": "12535528"
      }
    },
    {
      "id": "txn_bh3yyny6pd21njgvs5jrntt6e7",
      "createdAt": "2025-09-27T09:12:00.000Z",
      "updatedAt": "2025-09-27T09:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 26.12,
      "currency": "EUR",
      "description": "Payment to Taxi Service: TS-202509-4383",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hxzhx5e92758e77spnex896kwf",
      "fspDate": "2025-09-27T08:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hxzhx5e92758e77spnex896kwf",
        "bookingDate": "2025-09-27",
        "valueDate": "2025-09-27",
        "bookingDateTime": "2025-09-27T09:12:00.000Z",
        "valueDateTime": "2025-09-27T09:12:00.000Z",
        "transactionAmount": {
          "amount": "26.12",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Taxi Service: TS-202509-4383",
        "remittanceInformationUnstructuredArray": [
          "Payment to Taxi Service",
          "TS-202509-4383"
        ],
        "debtorName": "Taxi Service"
      },
      "paymentId": null,
      "reference": "TS-202509-4383",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqn02eshspm8y4jy7tt7k",
      "clustering": {
        "description": "Taxi Service",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Taxi Service' based on payment details",
        "updatedAt": "2025-09-27T09:12:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Taxi Service",
        "iban": "DE89447293599863580",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgv0n38mbcd0",
      "createdAt": "2025-09-27T08:57:00.000Z",
      "updatedAt": "2025-09-27T08:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1800,
      "currency": "EUR",
      "description": "To Gocardless",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1r791p4fax3",
      "fspDate": "2025-09-27T07:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1r791p4fax3",
        "bookingDate": "2025-09-27",
        "valueDate": "2025-09-27",
        "bookingDateTime": "2025-09-27T07:57:00.000Z",
        "valueDateTime": "2025-09-27T07:57:00.000Z",
        "transactionAmount": {
          "amount": "-1800.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Gocardless",
        "remittanceInformationUnstructuredArray": [
          "To Gocardless"
        ],
        "debtorName": "GoCardless SAS"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5k6eshspjzd728cagsr",
      "clustering": {
        "description": "GoCardless",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'GoCardless' from the raw transaction description, removing the 'To ' prefix.",
        "updatedAt": "2025-09-27T10:53:55.691Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yvxcphmr3zjvdbf6zv88g5yzsq",
      "createdAt": "2025-09-27T08:30:00.000Z",
      "updatedAt": "2025-09-27T08:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3500,
      "currency": "USD",
      "description": "Payment to OpenAI, LLC: OAI-2025-12-4829",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_3b0ebk0t4kj6fcavkb39w8wkcr",
      "fspDate": "2025-09-27T07:30:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_z11net2h1f23s5xfthefp1b311",
        "bookingDate": "2025-09-27",
        "valueDate": "2025-09-27",
        "bookingDateTime": "2025-09-27T07:30:00.000Z",
        "valueDateTime": "2025-09-27T07:30:00.000Z",
        "transactionAmount": {
          "amount": "-3500.00",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to OpenAI, LLC: OAI-2025-12-4829",
        "remittanceInformationUnstructuredArray": [
          "Payment to OpenAI, LLC: OAI-2025-12-4829"
        ],
        "debtorName": "OpenAI, LLC"
      },
      "paymentId": null,
      "reference": "OAI-2025-12-4829",
      "beneficiaryId": "benf_bja9cdzr82eptdtwghfrd40ac5",
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1bss5kk7dqrqznncrn6c0w8y4p",
      "clustering": {
        "description": "OpenAI, LLC",
        "confidenceScore": "0.95",
        "rationale": "Identified as payment to OpenAI, LLC based on remittance information.",
        "updatedAt": "2025-12-20T10:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "OpenAI, LLC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": "3301234567"
      }
    },
    {
      "id": "txn_01k65c32y3eshspfy59wtkz8xr",
      "createdAt": "2025-09-26T16:46:00.000Z",
      "updatedAt": "2025-09-26T16:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 33,
      "currency": "EUR",
      "description": "The Woolshed",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0w5eb05z1x9",
      "fspDate": "2025-09-26T15:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0w5eb05z1x9",
        "bookingDate": "2025-09-26",
        "valueDate": "2025-09-26",
        "bookingDateTime": "2025-09-26T15:46:00.000Z",
        "valueDateTime": "2025-09-26T15:46:00.000Z",
        "transactionAmount": {
          "amount": "-33.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "The Woolshed",
        "remittanceInformationUnstructuredArray": [
          "The Woolshed"
        ],
        "debtorName": "The Woolshed"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1pkeshspm729w29ytag",
      "clustering": {
        "description": "The Woolshed",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'The Woolshed' from 'The Woolshed'",
        "updatedAt": "2025-09-27T10:50:08.406Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfdyv7wr04gm",
      "createdAt": "2025-09-26T15:05:00.000Z",
      "updatedAt": "2025-09-26T15:05:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k12vyakpe4dr6y192n42sczm",
      "fspDate": "2025-09-26T14:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k12vyakpe4dr6y192n42sczm",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T15:00:00.000Z",
        "valueDateTime": "2026-01-08T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Burger Cartel' from 'Burger Cartel Limited'",
        "updatedAt": "2025-09-27T10:48:02.702Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_h0q07sr35k4ssxbvcvxtf6f9m7",
      "createdAt": "2025-09-26T14:42:00.000Z",
      "updatedAt": "2025-09-26T14:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17.94,
      "currency": "EUR",
      "description": "Payment to Hotpot: H-202509-9194",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_94qp3a5nsnhjwbc527cjsas7s6",
      "fspDate": "2025-09-26T13:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_94qp3a5nsnhjwbc527cjsas7s6",
        "bookingDate": "2025-09-26",
        "valueDate": "2025-09-26",
        "bookingDateTime": "2025-09-26T14:42:00.000Z",
        "valueDateTime": "2025-09-26T14:42:00.000Z",
        "transactionAmount": {
          "amount": "17.94",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Hotpot: H-202509-9194",
        "remittanceInformationUnstructuredArray": [
          "Payment to Hotpot",
          "H-202509-9194"
        ],
        "debtorName": "Hotpot"
      },
      "paymentId": null,
      "reference": "H-202509-9194",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0wweshspkzqgyrcgqe7",
      "clustering": {
        "description": "Hotpot",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Hotpot' based on payment details",
        "updatedAt": "2025-09-26T14:42:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Hotpot",
        "iban": "DE28628870165915316",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgjpwv9pzmwd",
      "createdAt": "2025-09-26T14:41:00.000Z",
      "updatedAt": "2025-09-26T14:41:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 3000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1g3rkhek4nf",
      "fspDate": "2025-09-26T13:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1g3rkhek4nf",
        "bookingDate": "2025-09-26",
        "valueDate": "2025-09-26",
        "bookingDateTime": "2025-09-26T13:41:00.000Z",
        "valueDateTime": "2025-09-26T13:41:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name since the transaction is a currency exchange, and the description is 'Exchanged to GBP Main'.",
        "updatedAt": "2025-09-27T10:52:47.490Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mb7eqtcqrr80k335ytv1evm9cv",
      "createdAt": "2025-09-26T14:04:00.000Z",
      "updatedAt": "2025-09-26T14:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.49,
      "currency": "GBP",
      "description": "Payment to FCB Coffee: FC-202509-7926",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_cfw7bjj10nab7sdcdjdeczkwhn",
      "fspDate": "2025-09-26T13:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_cfw7bjj10nab7sdcdjdeczkwhn",
        "bookingDate": "2025-09-26",
        "valueDate": "2025-09-26",
        "bookingDateTime": "2025-09-26T14:04:00.000Z",
        "valueDateTime": "2025-09-26T14:04:00.000Z",
        "transactionAmount": {
          "amount": "3.49",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to FCB Coffee: FC-202509-7926",
        "remittanceInformationUnstructuredArray": [
          "Payment to FCB Coffee",
          "FC-202509-7926"
        ],
        "debtorName": "FCB Coffee"
      },
      "paymentId": null,
      "reference": "FC-202509-7926",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmmfvhrjp1d532dm1jy",
      "clustering": {
        "description": "FCB Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'FCB Coffee' based on payment details",
        "updatedAt": "2025-09-26T14:04:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "FCB Coffee",
        "iban": null,
        "bic": null,
        "sortCode": "932922",
        "accountNumber": "22723246"
      }
    },
    {
      "id": "txn_vw6dtwghp89dx1v9a5etxrwxzq",
      "createdAt": "2025-09-26T13:48:00.000Z",
      "updatedAt": "2025-09-26T13:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 89.88,
      "currency": "EUR",
      "description": "Payment to Giftmall.es: G-202509-4185",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_e7q4jwv0zcdt89yd6sv07gb2z8",
      "fspDate": "2025-09-26T12:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_e7q4jwv0zcdt89yd6sv07gb2z8",
        "bookingDate": "2025-09-26",
        "valueDate": "2025-09-26",
        "bookingDateTime": "2025-09-26T13:48:00.000Z",
        "valueDateTime": "2025-09-26T13:48:00.000Z",
        "transactionAmount": {
          "amount": "89.88",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Giftmall.es: G-202509-4185",
        "remittanceInformationUnstructuredArray": [
          "Payment to Giftmall.es",
          "G-202509-4185"
        ],
        "debtorName": "Giftmall.es"
      },
      "paymentId": null,
      "reference": "G-202509-4185",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpfaeshspmwtrg2tk9zk",
      "clustering": {
        "description": "Giftmall.es",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Giftmall.es' based on payment details",
        "updatedAt": "2025-09-26T13:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Giftmall.es",
        "iban": "DE60721956480585940",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf6rdenjtg4m",
      "createdAt": "2025-09-26T13:45:00.000Z",
      "updatedAt": "2025-09-26T13:45:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Sumup *doncanizales",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1jaadqbfk0vtsr7p9spxj07",
      "fspDate": "2025-09-26T12:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1jaadqbfk0vtsr7p9spxj07",
        "bookingDate": "2025-12-17",
        "valueDate": "2025-12-17",
        "bookingDateTime": "2025-12-17T11:01:00.000Z",
        "valueDateTime": "2025-12-17T11:01:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *doncanizales",
        "remittanceInformationUnstructuredArray": [
          "Sumup *doncanizales"
        ],
        "debtorName": "Don Canizales"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "clustering": {
        "description": "Sumup",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Sumup' from 'Sumup *doncanizales', removing the Sumup * prefix",
        "updatedAt": "2025-09-27T10:45:11.522Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_y32nkatjtr3mdq5h3tpb8hfsa6",
      "createdAt": "2025-09-26T12:38:00.000Z",
      "updatedAt": "2025-09-26T12:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 22593.69,
      "currency": "GBP",
      "description": "Payment from CloudFirst Technologies - INV-202509-9734",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xfjd5atd6sqch63ymp5nrdxfkk",
      "fspDate": "2025-09-26T11:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xfjd5atd6sqch63ymp5nrdxfkk",
        "bookingDate": "2025-09-26",
        "valueDate": "2025-09-26",
        "bookingDateTime": "2025-09-26T12:38:00.000Z",
        "valueDateTime": "2025-09-26T12:38:00.000Z",
        "transactionAmount": {
          "amount": "22593.69",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from CloudFirst Technologies - INV-202509-9734",
        "remittanceInformationUnstructuredArray": [
          "Payment from CloudFirst Technologies",
          "INV-202509-9734"
        ],
        "creditorName": "CloudFirst Technologies"
      },
      "paymentId": null,
      "reference": "INV-202509-9734",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_v3gga6hnqqf8p85ezhv67qxfkw",
      "clustering": {
        "description": "CloudFirst Technologies",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'CloudFirst Technologies'",
        "updatedAt": "2025-09-26T12:38:00.000Z"
      },
      "payer": {
        "name": "CloudFirst Technologies",
        "iban": null,
        "bic": null,
        "sortCode": "234652",
        "accountNumber": "21391113"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspftwsgng3sny",
      "createdAt": "2025-09-25T16:37:00.000Z",
      "updatedAt": "2025-09-25T16:37:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.42,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0qa4c08b8am",
      "fspDate": "2025-09-25T15:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0qa4c08b8am",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T10:00:00.000Z",
        "valueDateTime": "2026-01-11T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-17.42",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cursor' from 'Cursor, Ai Powered Ide'",
        "updatedAt": "2025-09-27T10:50:08.301Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm9khh03ptfz",
      "createdAt": "2025-09-25T15:31:00.000Z",
      "updatedAt": "2025-09-25T15:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3000,
      "currency": "GBP",
      "description": "To Grow Your Boat Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk821r6vq8v32",
      "fspDate": "2025-09-25T14:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk821r6vq8v32",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T13:00:00.000Z",
        "valueDateTime": "2026-01-04T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Grow Your Boat Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Grow Your Boat Ltd"
        ],
        "debtorName": "Grow Your Boat Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "clustering": {
        "description": "Grow Your Boat Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Grow Your Boat Ltd' from 'To Grow Your Boat Ltd'",
        "updatedAt": "2025-09-29T18:24:29.648Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspey43d1kxwq6",
      "createdAt": "2025-09-25T15:00:00.000Z",
      "updatedAt": "2025-09-25T15:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 3000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2ksftarfzwbd1n11nwke0dp",
      "fspDate": "2025-09-25T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ksftarfzwbd1n11nwke0dp",
        "bookingDate": "2025-09-25",
        "valueDate": "2025-09-25",
        "bookingDateTime": "2025-09-25T14:00:00.000Z",
        "valueDateTime": "2025-09-25T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the core description for a currency conversion transaction, based on the 'EXCHANGE' code",
        "updatedAt": "2025-09-27T10:42:40.381Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfjrg1fxmjag",
      "createdAt": "2025-09-25T14:33:00.000Z",
      "updatedAt": "2025-09-25T14:33:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1056.11,
      "currency": "EUR",
      "description": "Upwork -829308411ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0rjbcknfq9r7n2akx0qv16d",
      "fspDate": "2025-09-25T13:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0rjbcknfq9r7n2akx0qv16d",
        "bookingDate": "2025-09-25",
        "valueDate": "2025-09-25",
        "bookingDateTime": "2025-09-25T13:33:00.000Z",
        "valueDateTime": "2025-09-25T13:33:00.000Z",
        "transactionAmount": {
          "amount": "-1056.11",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -829308411ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -829308411ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Upwork' from 'Upwork -829308411ref', removing the -829308411ref suffix",
        "updatedAt": "2025-09-27T10:49:04.299Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph607y392wfj",
      "createdAt": "2025-09-25T11:16:00.000Z",
      "updatedAt": "2025-09-25T11:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7733.86,
      "currency": "EUR",
      "description": "To Cormac Byrne",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk23x9d8zp5dg",
      "fspDate": "2025-09-25T10:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk23x9d8zp5dg",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T08:33:00.000Z",
        "valueDateTime": "2025-12-04T08:33:00.000Z",
        "transactionAmount": {
          "amount": "-7733.86",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Cormac Byrne",
        "remittanceInformationUnstructuredArray": [
          "To Cormac Byrne"
        ],
        "debtorName": "Cormac Byrne"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zspeshspj7tfmtn8s05",
      "clustering": {
        "description": "Cormac Byrne",
        "confidenceScore": "0.95",
        "rationale": "Extracted core recipient name 'Cormac Byrne' from 'To Cormac Byrne'",
        "updatedAt": "2025-09-27T10:54:50.879Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfqz89agcg08",
      "createdAt": "2025-09-25T07:01:00.000Z",
      "updatedAt": "2025-09-25T07:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 20.87,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg246ze8pvk0mnw23mxbn2",
      "fspDate": "2025-09-25T06:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg246ze8pvk0mnw23mxbn2",
        "bookingDate": "2025-09-25",
        "valueDate": "2025-09-25",
        "bookingDateTime": "2025-09-25T06:01:00.000Z",
        "valueDateTime": "2025-09-25T06:01:00.000Z",
        "transactionAmount": {
          "amount": "-20.87",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'OpenAI' from 'Openai *chatgpt Subscr'",
        "updatedAt": "2025-09-27T10:49:37.696Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg6v0s2jpfgn",
      "createdAt": "2025-09-24T16:08:00.000Z",
      "updatedAt": "2025-09-24T16:08:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 90.18,
      "currency": "EUR",
      "description": "zapier.com/charge",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2472e8pvk13e4zy4837w",
      "fspDate": "2025-09-24T15:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk13e4zy4837w",
        "bookingDate": "2025-09-24",
        "valueDate": "2025-09-24",
        "bookingDateTime": "2025-09-24T15:08:00.000Z",
        "valueDateTime": "2025-09-24T15:08:00.000Z",
        "transactionAmount": {
          "amount": "-90.18",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "zapier.com/charge",
        "remittanceInformationUnstructuredArray": [
          "zapier.com/charge"
        ],
        "debtorName": "Zapier"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2aeshspkg92jdy8vh4",
      "clustering": {
        "description": "Zapier",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zapier' from 'zapier.com/charge'.",
        "updatedAt": "2025-09-27T10:51:38.253Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_kctm6jn6da7d13ffghp76r72dg",
      "createdAt": "2025-09-24T15:43:00.000Z",
      "updatedAt": "2025-09-24T15:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 33898.68,
      "currency": "GBP",
      "description": "Payment from TechCorp Industries - INV-202509-2966",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xzxn2sym3zs9b7rezx60pkvkh2",
      "fspDate": "2025-09-24T14:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xzxn2sym3zs9b7rezx60pkvkh2",
        "bookingDate": "2025-09-24",
        "valueDate": "2025-09-24",
        "bookingDateTime": "2025-09-24T15:43:00.000Z",
        "valueDateTime": "2025-09-24T15:43:00.000Z",
        "transactionAmount": {
          "amount": "33898.68",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from TechCorp Industries - INV-202509-2966",
        "remittanceInformationUnstructuredArray": [
          "Payment from TechCorp Industries",
          "INV-202509-2966"
        ],
        "creditorName": "TechCorp Industries"
      },
      "paymentId": null,
      "reference": "INV-202509-2966",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_hkz708jvra375hd19t65j65vvt",
      "clustering": {
        "description": "TechCorp Industries",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'TechCorp Industries'",
        "updatedAt": "2025-09-24T15:43:00.000Z"
      },
      "payer": {
        "name": "TechCorp Industries",
        "iban": null,
        "bic": null,
        "sortCode": "730399",
        "accountNumber": "79895173"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_hqs3jmsd2rv8bfcvv6hqcas3ma",
      "createdAt": "2025-09-24T11:15:00.000Z",
      "updatedAt": "2025-09-24T11:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17,
      "currency": "EUR",
      "description": "Payment to Cafe And Noodle: CAN-202509-7203",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_q62xzcbytwht285bkpkd7nrwv4",
      "fspDate": "2025-09-24T10:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_q62xzcbytwht285bkpkd7nrwv4",
        "bookingDate": "2025-09-24",
        "valueDate": "2025-09-24",
        "bookingDateTime": "2025-09-24T11:15:00.000Z",
        "valueDateTime": "2025-09-24T11:15:00.000Z",
        "transactionAmount": {
          "amount": "17.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cafe And Noodle: CAN-202509-7203",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cafe And Noodle",
          "CAN-202509-7203"
        ],
        "debtorName": "Cafe And Noodle"
      },
      "paymentId": null,
      "reference": "CAN-202509-7203",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpd8eshspmwjjpzayxx2",
      "clustering": {
        "description": "Cafe And Noodle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cafe And Noodle' based on payment details",
        "updatedAt": "2025-09-24T11:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cafe And Noodle",
        "iban": "DE21759027442321080",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspetjbx2j1km7",
      "createdAt": "2025-09-23T16:51:00.000Z",
      "updatedAt": "2025-09-23T16:51:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k30nfe7yfzwbhvda2808t8x5",
      "fspDate": "2025-09-23T15:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k30nfe7yfzwbhvda2808t8x5",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T14:16:00.000Z",
        "valueDateTime": "2025-12-04T14:16:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Coffee Angel' from the 'Sq *coffeeangel' transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:41:48.231Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0b88aka1pn0xe84scp4p0avn9p",
      "createdAt": "2025-09-23T15:27:00.000Z",
      "updatedAt": "2025-09-23T15:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 22.68,
      "currency": "EUR",
      "description": "Payment to Mak Slim Foods: MSF-202509-1113",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_h0z674g0edrgrv885vzbednge4",
      "fspDate": "2025-09-23T14:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_h0z674g0edrgrv885vzbednge4",
        "bookingDate": "2025-09-23",
        "valueDate": "2025-09-23",
        "bookingDateTime": "2025-09-23T15:27:00.000Z",
        "valueDateTime": "2025-09-23T15:27:00.000Z",
        "transactionAmount": {
          "amount": "22.68",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mak Slim Foods: MSF-202509-1113",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mak Slim Foods",
          "MSF-202509-1113"
        ],
        "debtorName": "Mak Slim Foods"
      },
      "paymentId": null,
      "reference": "MSF-202509-1113",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2yeshspkgyzwx8hqrq",
      "clustering": {
        "description": "Mak Slim Foods",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mak Slim Foods' based on payment details",
        "updatedAt": "2025-09-23T15:27:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mak Slim Foods",
        "iban": "DE39045358924788130",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmq6440g2j4s",
      "createdAt": "2025-09-23T12:42:00.000Z",
      "updatedAt": "2025-09-23T12:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 24,
      "currency": "GBP",
      "description": "Tfl Travel Charge",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8fj79zkb7e0",
      "fspDate": "2025-09-23T11:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8fj79zkb7e0",
        "bookingDate": "2025-09-23",
        "valueDate": "2025-09-23",
        "bookingDateTime": "2025-09-23T11:42:00.000Z",
        "valueDateTime": "2025-09-23T11:42:00.000Z",
        "transactionAmount": {
          "amount": "-24.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tfl Travel Charge",
        "remittanceInformationUnstructuredArray": [
          "Tfl Travel Charge"
        ],
        "debtorName": "Transport for London"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgk7fvhrjp0v7hz9q786",
      "clustering": {
        "description": "Transport for London",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Transport for London' from 'Tfl Travel Charge'",
        "updatedAt": "2025-09-29T18:26:40.947Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_85respe73ns1km4rcwhwk8fc39",
      "createdAt": "2025-09-23T11:56:00.000Z",
      "updatedAt": "2025-09-23T11:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17189.2,
      "currency": "GBP",
      "description": "Payment to Amwins Global Risks: AGR-202509-2695",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_e899tnccsb3exa4a1mktm995zy",
      "fspDate": "2025-09-23T10:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_e899tnccsb3exa4a1mktm995zy",
        "bookingDate": "2025-09-23",
        "valueDate": "2025-09-23",
        "bookingDateTime": "2025-09-23T11:56:00.000Z",
        "valueDateTime": "2025-09-23T11:56:00.000Z",
        "transactionAmount": {
          "amount": "17189.20",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amwins Global Risks: AGR-202509-2695",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amwins Global Risks",
          "AGR-202509-2695"
        ],
        "debtorName": "Amwins Global Risks"
      },
      "paymentId": null,
      "reference": "AGR-202509-2695",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2bfvhrjnbz808baykh",
      "clustering": {
        "description": "Amwins Global Risks",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amwins Global Risks' based on payment details",
        "updatedAt": "2025-09-23T11:56:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amwins Global Risks",
        "iban": null,
        "bic": null,
        "sortCode": "103309",
        "accountNumber": "84226987"
      }
    },
    {
      "id": "txn_fhmsr9q3k5q12ap31es1p91qf6",
      "createdAt": "2025-09-23T08:46:00.000Z",
      "updatedAt": "2025-09-23T08:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 23405.37,
      "currency": "EUR",
      "description": "Payment from Nordic Digital AB - INV-202509-3516",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_j73c460nwjprqpbnjw0nz9m15b",
      "fspDate": "2025-09-23T07:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_j73c460nwjprqpbnjw0nz9m15b",
        "bookingDate": "2025-09-23",
        "valueDate": "2025-09-23",
        "bookingDateTime": "2025-09-23T08:46:00.000Z",
        "valueDateTime": "2025-09-23T08:46:00.000Z",
        "transactionAmount": {
          "amount": "23405.37",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nordic Digital AB - INV-202509-3516",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nordic Digital AB",
          "INV-202509-3516"
        ],
        "creditorName": "Nordic Digital AB"
      },
      "paymentId": null,
      "reference": "INV-202509-3516",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_q7sgetg8gwgf23ac9gdqmk8cz4",
      "clustering": {
        "description": "Nordic Digital AB",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nordic Digital AB'",
        "updatedAt": "2025-09-23T08:46:00.000Z"
      },
      "payer": {
        "name": "Nordic Digital AB",
        "iban": "DE30582038561922040",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5c2kms7mz739jfdehy6dqtws6p",
      "createdAt": "2025-09-22T15:38:00.000Z",
      "updatedAt": "2025-09-22T15:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 323.86,
      "currency": "EUR",
      "description": "Payment to Bang Restaurant: BR-202509-4497",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rhgj3xy5xn8c4r0q1d3y5qnedb",
      "fspDate": "2025-09-22T14:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rhgj3xy5xn8c4r0q1d3y5qnedb",
        "bookingDate": "2025-09-22",
        "valueDate": "2025-09-22",
        "bookingDateTime": "2025-09-22T15:38:00.000Z",
        "valueDateTime": "2025-09-22T15:38:00.000Z",
        "transactionAmount": {
          "amount": "323.86",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bang Restaurant: BR-202509-4497",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bang Restaurant",
          "BR-202509-4497"
        ],
        "debtorName": "Bang Restaurant"
      },
      "paymentId": null,
      "reference": "BR-202509-4497",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpk3eshspmfgtm6vkpxj",
      "clustering": {
        "description": "Bang Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bang Restaurant' based on payment details",
        "updatedAt": "2025-09-22T15:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bang Restaurant",
        "iban": "DE59632031405243250",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmc1s0a60v93",
      "createdAt": "2025-09-22T12:34:00.000Z",
      "updatedAt": "2025-09-22T12:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 24000,
      "currency": "GBP",
      "description": "To SEAPOINT FINANCE UK INVESTMENTS LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk84gn6jfx2fb",
      "fspDate": "2025-09-22T11:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk84gn6jfx2fb",
        "bookingDate": "2025-09-22",
        "valueDate": "2025-09-22",
        "bookingDateTime": "2025-09-22T11:34:00.000Z",
        "valueDateTime": "2025-09-22T11:34:00.000Z",
        "transactionAmount": {
          "amount": "-24000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To SEAPOINT FINANCE UK INVESTMENTS LIMITED",
        "remittanceInformationUnstructuredArray": [
          "To SEAPOINT FINANCE UK INVESTMENTS LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK Investments",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Seapoint Finance UK Investments' from 'To SEAPOINT FINANCE UK INVESTMENTS LIMITED'",
        "updatedAt": "2025-09-29T18:25:01.082Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjmb24k3mcpp5",
      "createdAt": "2025-09-22T12:09:00.000Z",
      "updatedAt": "2025-09-22T12:09:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 209,
      "currency": "GBP",
      "description": "Linkedin Job P686312154",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk83sdxj25t46",
      "fspDate": "2025-09-22T11:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk83sdxj25t46",
        "bookingDate": "2025-09-22",
        "valueDate": "2025-09-22",
        "bookingDateTime": "2025-09-22T11:09:00.000Z",
        "valueDateTime": "2025-09-22T11:09:00.000Z",
        "transactionAmount": {
          "amount": "-209.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin Job P686312154",
        "remittanceInformationUnstructuredArray": [
          "Linkedin Job P686312154"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'LinkedIn' from 'Linkedin Job P686312154'",
        "updatedAt": "2025-09-29T18:24:29.674Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspersb47s1pa8",
      "createdAt": "2025-09-22T11:55:00.000Z",
      "updatedAt": "2025-09-22T11:55:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 19,
      "currency": "EUR",
      "description": "The Pig And Heifer",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k35t8tvce8prf09hbnds9za8",
      "fspDate": "2025-09-22T10:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k35t8tvce8prf09hbnds9za8",
        "bookingDate": "2025-09-22",
        "valueDate": "2025-09-22",
        "bookingDateTime": "2025-09-22T10:55:00.000Z",
        "valueDateTime": "2025-09-22T10:55:00.000Z",
        "transactionAmount": {
          "amount": "-19.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "The Pig And Heifer",
        "remittanceInformationUnstructuredArray": [
          "The Pig And Heifer"
        ],
        "debtorName": "The Pig And Heifer"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g5weshsphq7y8rf4z8z",
      "clustering": {
        "description": "The Pig And Heifer",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'The Pig And Heifer' from the transaction description.",
        "updatedAt": "2025-09-27T10:41:48.180Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zxs6w3j1ag24m4wvja2fsjtxgc",
      "createdAt": "2025-09-22T10:43:00.000Z",
      "updatedAt": "2025-09-22T10:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 148.33,
      "currency": "USD",
      "description": "Payment to Anthropic: A-202509-8328",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ged25a61vad6a989pf04hqwkdm",
      "fspDate": "2025-09-22T09:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ged25a61vad6a989pf04hqwkdm",
        "bookingDate": "2025-09-22",
        "valueDate": "2025-09-22",
        "bookingDateTime": "2025-09-22T10:43:00.000Z",
        "valueDateTime": "2025-09-22T10:43:00.000Z",
        "transactionAmount": {
          "amount": "148.33",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic: A-202509-8328",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic",
          "A-202509-8328"
        ],
        "debtorName": "Anthropic"
      },
      "paymentId": null,
      "reference": "A-202509-8328",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0y2eshspjwh0d2fxb76",
      "clustering": {
        "description": "Anthropic",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic' based on payment details",
        "updatedAt": "2025-09-22T10:43:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xxeshspef1d0awb6jh",
      "createdAt": "2025-09-22T10:19:00.000Z",
      "updatedAt": "2025-09-22T10:19:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3qv1xr6esm9bvx4h027jf3j",
      "fspDate": "2025-09-22T09:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3qv1xr6esm9bvx4h027jf3j",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T09:32:00.000Z",
        "valueDateTime": "2025-12-20T09:32:00.000Z",
        "transactionAmount": {
          "amount": "-17.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Shaka Poke' from 'Sq *shaka Poke', removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:39:39.643Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6vb77w5eze5afrfanqg4mkdsbe",
      "createdAt": "2025-09-22T08:46:00.000Z",
      "updatedAt": "2025-09-22T08:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 900.16,
      "currency": "GBP",
      "description": "Payment to Charles Russell Speechlys: CRS-202509-2409",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ypr7dnrbq19tynrevkwg5faf1w",
      "fspDate": "2025-09-22T07:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ypr7dnrbq19tynrevkwg5faf1w",
        "bookingDate": "2025-09-22",
        "valueDate": "2025-09-22",
        "bookingDateTime": "2025-09-22T08:46:00.000Z",
        "valueDateTime": "2025-09-22T08:46:00.000Z",
        "transactionAmount": {
          "amount": "900.16",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Charles Russell Speechlys: CRS-202509-2409",
        "remittanceInformationUnstructuredArray": [
          "Payment to Charles Russell Speechlys",
          "CRS-202509-2409"
        ],
        "debtorName": "Charles Russell Speechlys"
      },
      "paymentId": null,
      "reference": "CRS-202509-2409",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgh1fvhrjp0n7wme8cae",
      "clustering": {
        "description": "Charles Russell Speechlys",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Charles Russell Speechlys' based on payment details",
        "updatedAt": "2025-09-22T08:46:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Charles Russell Speechlys",
        "iban": null,
        "bic": null,
        "sortCode": "708470",
        "accountNumber": "25719349"
      }
    },
    {
      "id": "txn_01k65c32y0eshspesmtjrnckx8",
      "createdAt": "2025-09-22T07:00:00.000Z",
      "updatedAt": "2025-09-22T07:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25.1,
      "currency": "EUR",
      "description": "Tula Mexican Grill 02",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k35t8tvce8prf09vyvybj30n",
      "fspDate": "2025-09-22T06:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k35t8tvce8prf09vyvybj30n",
        "bookingDate": "2025-09-22",
        "valueDate": "2025-09-22",
        "bookingDateTime": "2025-09-22T06:00:00.000Z",
        "valueDateTime": "2025-09-22T06:00:00.000Z",
        "transactionAmount": {
          "amount": "-25.10",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tula Mexican Grill 02",
        "remittanceInformationUnstructuredArray": [
          "Tula Mexican Grill 02"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Tula Mexican Grill' from the 'Tula Mexican Grill 02' transaction description, removing the '02' suffix.",
        "updatedAt": "2025-09-27T10:41:48.201Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gtyq9zq8nbjvbkkvwx3f7qd0r6",
      "createdAt": "2025-09-21T15:48:00.000Z",
      "updatedAt": "2025-09-21T15:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 33.06,
      "currency": "EUR",
      "description": "Payment to Veremark: V-202509-5789",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ydvpfmqrf77bgmw7j4qm679kph",
      "fspDate": "2025-09-21T14:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ydvpfmqrf77bgmw7j4qm679kph",
        "bookingDate": "2025-09-21",
        "valueDate": "2025-09-21",
        "bookingDateTime": "2025-09-21T15:48:00.000Z",
        "valueDateTime": "2025-09-21T15:48:00.000Z",
        "transactionAmount": {
          "amount": "33.06",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Veremark: V-202509-5789",
        "remittanceInformationUnstructuredArray": [
          "Payment to Veremark",
          "V-202509-5789"
        ],
        "debtorName": "Veremark"
      },
      "paymentId": null,
      "reference": "V-202509-5789",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwc3eshspn9n53st1zft",
      "clustering": {
        "description": "Veremark",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Veremark' based on payment details",
        "updatedAt": "2025-09-21T15:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Veremark",
        "iban": "DE77499228944898640",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_59khv02mbnthtdckqg0e5fqmg4",
      "createdAt": "2025-09-21T12:36:00.000Z",
      "updatedAt": "2025-09-21T12:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 23.49,
      "currency": "EUR",
      "description": "Payment to Amba: A-202509-3903",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5narvqw1xeqxfqvx1zm69hjhze",
      "fspDate": "2025-09-21T11:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5narvqw1xeqxfqvx1zm69hjhze",
        "bookingDate": "2025-09-21",
        "valueDate": "2025-09-21",
        "bookingDateTime": "2025-09-21T12:36:00.000Z",
        "valueDateTime": "2025-09-21T12:36:00.000Z",
        "transactionAmount": {
          "amount": "23.49",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amba: A-202509-3903",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amba",
          "A-202509-3903"
        ],
        "debtorName": "Amba"
      },
      "paymentId": null,
      "reference": "A-202509-3903",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g1aeshsphp662hfbd17",
      "clustering": {
        "description": "Amba",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amba' based on payment details",
        "updatedAt": "2025-09-21T12:36:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amba",
        "iban": "DE38045698727823040",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7yzzqw01zadh1asa85f97zf4jt",
      "createdAt": "2025-09-21T08:01:00.000Z",
      "updatedAt": "2025-09-21T08:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 18162.88,
      "currency": "EUR",
      "description": "Payment from Alpine Software SA - INV-202509-8328",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_3467jsygqa0bmy0q9nc4jwa2s2",
      "fspDate": "2025-09-21T07:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_3467jsygqa0bmy0q9nc4jwa2s2",
        "bookingDate": "2025-09-21",
        "valueDate": "2025-09-21",
        "bookingDateTime": "2025-09-21T08:01:00.000Z",
        "valueDateTime": "2025-09-21T08:01:00.000Z",
        "transactionAmount": {
          "amount": "18162.88",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Alpine Software SA - INV-202509-8328",
        "remittanceInformationUnstructuredArray": [
          "Payment from Alpine Software SA",
          "INV-202509-8328"
        ],
        "creditorName": "Alpine Software SA"
      },
      "paymentId": null,
      "reference": "INV-202509-8328",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_nk7g93a6fpe8ybm4hppdmmfgsw",
      "clustering": {
        "description": "Alpine Software SA",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Alpine Software SA'",
        "updatedAt": "2025-09-21T08:01:00.000Z"
      },
      "payer": {
        "name": "Alpine Software SA",
        "iban": "DE84370624436289230",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfvgjj3aanqj",
      "createdAt": "2025-09-20T15:39:00.000Z",
      "updatedAt": "2025-09-20T15:39:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25.82,
      "currency": "EUR",
      "description": "Xai Llc",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0rc7vc55vtq",
      "fspDate": "2025-09-20T14:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0rc7vc55vtq",
        "bookingDate": "2025-09-20",
        "valueDate": "2025-09-20",
        "bookingDateTime": "2025-09-20T14:39:00.000Z",
        "valueDateTime": "2025-09-20T14:39:00.000Z",
        "transactionAmount": {
          "amount": "-25.82",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Xai Llc",
        "remittanceInformationUnstructuredArray": [
          "Xai Llc"
        ],
        "debtorName": "Xai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgt8yeshspk60ezf5bsne",
      "clustering": {
        "description": "Xai",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Xai' from 'Xai Llc'",
        "updatedAt": "2025-09-27T10:50:08.336Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_he5123g9r0ae38q1cyn3enrvd6",
      "createdAt": "2025-09-20T14:33:00.000Z",
      "updatedAt": "2025-09-20T14:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4242.18,
      "currency": "GBP",
      "description": "Payment to Amazon Web Services EMEA SARL: AWS-202509-7261",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xjjg3jnegxcjby3pkrt4dnvchv",
      "fspDate": "2025-09-20T13:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xjjg3jnegxcjby3pkrt4dnvchv",
        "bookingDate": "2025-09-20",
        "valueDate": "2025-09-20",
        "bookingDateTime": "2025-09-20T14:33:00.000Z",
        "valueDateTime": "2025-09-20T14:33:00.000Z",
        "transactionAmount": {
          "amount": "4242.18",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amazon Web Services EMEA SARL: AWS-202509-7261",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amazon Web Services EMEA SARL",
          "AWS-202509-7261"
        ],
        "debtorName": "Amazon Web Services EMEA SARL"
      },
      "paymentId": null,
      "reference": "AWS-202509-7261",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_zj7v3fq41pb9h3pwx6cbzwmfx4",
      "clustering": {
        "description": "Amazon Web Services EMEA SARL",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amazon Web Services EMEA SARL' based on payment details",
        "updatedAt": "2025-09-20T14:33:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amazon Web Services EMEA SARL",
        "iban": null,
        "bic": null,
        "sortCode": "207098",
        "accountNumber": "88062070"
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmjsxqe0vfbn",
      "createdAt": "2025-09-20T13:46:00.000Z",
      "updatedAt": "2025-09-20T13:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3000,
      "currency": "GBP",
      "description": "To Grow Your Boat Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8bc8g7gt1dn",
      "fspDate": "2025-09-20T12:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8bc8g7gt1dn",
        "bookingDate": "2025-09-20",
        "valueDate": "2025-09-20",
        "bookingDateTime": "2025-09-20T12:46:00.000Z",
        "valueDateTime": "2025-09-20T12:46:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Grow Your Boat Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Grow Your Boat Ltd"
        ],
        "debtorName": "Grow Your Boat Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "clustering": {
        "description": "Grow Your Boat Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Grow Your Boat Ltd' from 'To Grow Your Boat Ltd'",
        "updatedAt": "2025-09-29T18:25:48.545Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nb2xv4ajdr7heav06dkky9t3n6",
      "createdAt": "2025-09-20T13:11:00.000Z",
      "updatedAt": "2025-09-20T13:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 13.26,
      "currency": "EUR",
      "description": "Payment to Mama's Boy: MB-202509-3425",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jpn5wa87rdxhtry3wwnk9z2fya",
      "fspDate": "2025-09-20T12:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jpn5wa87rdxhtry3wwnk9z2fya",
        "bookingDate": "2025-09-20",
        "valueDate": "2025-09-20",
        "bookingDateTime": "2025-09-20T13:11:00.000Z",
        "valueDateTime": "2025-09-20T13:11:00.000Z",
        "transactionAmount": {
          "amount": "13.26",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mama's Boy: MB-202509-3425",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mama's Boy",
          "MB-202509-3425"
        ],
        "debtorName": "Mama's Boy"
      },
      "paymentId": null,
      "reference": "MB-202509-3425",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcneshspna4jnfvyh0c",
      "clustering": {
        "description": "Mama's Boy",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mama's Boy' based on payment details",
        "updatedAt": "2025-09-20T13:11:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mama's Boy",
        "iban": "DE30024098115816296",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_z29hjb4p09krtkcb8vkmrtdqjw",
      "createdAt": "2025-09-20T11:27:00.000Z",
      "updatedAt": "2025-09-20T11:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 27620.17,
      "currency": "EUR",
      "description": "Payment from Nexus Consulting GmbH - INV-202509-4481",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_8j4ty2wncqtjfvvjsn70e7m7pr",
      "fspDate": "2025-09-20T10:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_8j4ty2wncqtjfvvjsn70e7m7pr",
        "bookingDate": "2025-09-20",
        "valueDate": "2025-09-20",
        "bookingDateTime": "2025-09-20T11:27:00.000Z",
        "valueDateTime": "2025-09-20T11:27:00.000Z",
        "transactionAmount": {
          "amount": "27620.17",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nexus Consulting GmbH - INV-202509-4481",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nexus Consulting GmbH",
          "INV-202509-4481"
        ],
        "creditorName": "Nexus Consulting GmbH"
      },
      "paymentId": null,
      "reference": "INV-202509-4481",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_631832eta7hj1n2x0gedv5fm59",
      "clustering": {
        "description": "Nexus Consulting GmbH",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nexus Consulting GmbH'",
        "updatedAt": "2025-09-20T11:27:00.000Z"
      },
      "payer": {
        "name": "Nexus Consulting GmbH",
        "iban": "DE30584532405716640",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfmbkks6p3f4",
      "createdAt": "2025-09-20T07:57:00.000Z",
      "updatedAt": "2025-09-20T07:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 48.28,
      "currency": "EUR",
      "description": "Payment to Remote Europe Holding BV: 050IN25061862",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0pd9z4nfvqskesyxnde46kj",
      "fspDate": "2025-09-20T06:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0pd9z4nfvqskesyxnde46kj",
        "bookingDate": "2025-09-20",
        "valueDate": "2025-09-20",
        "bookingDateTime": "2025-09-20T06:57:00.000Z",
        "valueDateTime": "2025-09-20T06:57:00.000Z",
        "transactionAmount": {
          "amount": "-48.28",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Remote Europe Holding BV: 050IN25061862",
        "remittanceInformationUnstructuredArray": [
          "Payment to Remote Europe Holding BV: 050IN25061862"
        ],
        "debtorName": "Remote Europe Holding BV"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pz7eshspjhbnt16ttyt",
      "clustering": {
        "description": "Remote Europe Holding BV",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Remote Europe Holding BV' as the recipient name for the transfer transaction",
        "updatedAt": "2025-09-27T10:49:04.352Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_s5yg7gr8c54x2bg3gs73hj8jgc",
      "createdAt": "2025-09-19T15:52:00.000Z",
      "updatedAt": "2025-09-19T15:52:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 17446.71,
      "currency": "GBP",
      "description": "Payment from SmartScale Solutions - INV-202509-3192",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wjf531ajhrgfxabtcqbjnwrm7b",
      "fspDate": "2025-09-19T14:52:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wjf531ajhrgfxabtcqbjnwrm7b",
        "bookingDate": "2025-09-19",
        "valueDate": "2025-09-19",
        "bookingDateTime": "2025-09-19T15:52:00.000Z",
        "valueDateTime": "2025-09-19T15:52:00.000Z",
        "transactionAmount": {
          "amount": "17446.71",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from SmartScale Solutions - INV-202509-3192",
        "remittanceInformationUnstructuredArray": [
          "Payment from SmartScale Solutions",
          "INV-202509-3192"
        ],
        "creditorName": "SmartScale Solutions"
      },
      "paymentId": null,
      "reference": "INV-202509-3192",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_k9wmdwkshbazmh9e7aq4wj85ej",
      "clustering": {
        "description": "SmartScale Solutions",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'SmartScale Solutions'",
        "updatedAt": "2025-09-19T15:52:00.000Z"
      },
      "payer": {
        "name": "SmartScale Solutions",
        "iban": null,
        "bic": null,
        "sortCode": "302354",
        "accountNumber": "38681145"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_amkk5rv3r2en1vrjfkrnzzp7rq",
      "createdAt": "2025-09-19T15:15:00.000Z",
      "updatedAt": "2025-09-19T15:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 44195.1,
      "currency": "GBP",
      "description": "Payment from Enterprise Systems Inc - INV-202509-3554",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_dakypf6hrnkax4zvjp8kt7z59d",
      "fspDate": "2025-09-19T14:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_dakypf6hrnkax4zvjp8kt7z59d",
        "bookingDate": "2025-09-19",
        "valueDate": "2025-09-19",
        "bookingDateTime": "2025-09-19T15:15:00.000Z",
        "valueDateTime": "2025-09-19T15:15:00.000Z",
        "transactionAmount": {
          "amount": "44195.10",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Enterprise Systems Inc - INV-202509-3554",
        "remittanceInformationUnstructuredArray": [
          "Payment from Enterprise Systems Inc",
          "INV-202509-3554"
        ],
        "creditorName": "Enterprise Systems Inc"
      },
      "paymentId": null,
      "reference": "INV-202509-3554",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1jqt0xq8p3az0ed45aqq7npx6w",
      "clustering": {
        "description": "Enterprise Systems Inc",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Enterprise Systems Inc'",
        "updatedAt": "2025-09-19T15:15:00.000Z"
      },
      "payer": {
        "name": "Enterprise Systems Inc",
        "iban": null,
        "bic": null,
        "sortCode": "887529",
        "accountNumber": "47680264"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjms6yk6t83xp",
      "createdAt": "2025-09-19T14:46:00.000Z",
      "updatedAt": "2025-09-19T14:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 146.48,
      "currency": "GBP",
      "description": "Ryanair",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8j6kx2m6znp",
      "fspDate": "2025-09-19T13:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8j6kx2m6znp",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T11:00:00.000Z",
        "valueDateTime": "2026-01-02T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-146.48",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Ryanair",
        "remittanceInformationUnstructuredArray": [
          "Ryanair"
        ],
        "debtorName": "Ryanair"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctphbeshspmx6q13ktd74",
      "clustering": {
        "description": "Ryanair",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Ryanair' from 'Ryanair'",
        "updatedAt": "2025-09-29T18:26:40.982Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_h4p9wbjd9gs2k69kz0t3wj43t6",
      "createdAt": "2025-09-19T12:01:00.000Z",
      "updatedAt": "2025-09-19T12:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 53.94,
      "currency": "GBP",
      "description": "Payment to Captain Nemo: CN-202509-8274",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_j940r3wtpjd0m4yrxf6efhfshb",
      "fspDate": "2025-09-19T11:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_j940r3wtpjd0m4yrxf6efhfshb",
        "bookingDate": "2025-09-19",
        "valueDate": "2025-09-19",
        "bookingDateTime": "2025-09-19T12:01:00.000Z",
        "valueDateTime": "2025-09-19T12:01:00.000Z",
        "transactionAmount": {
          "amount": "53.94",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Captain Nemo: CN-202509-8274",
        "remittanceInformationUnstructuredArray": [
          "Payment to Captain Nemo",
          "CN-202509-8274"
        ],
        "debtorName": "Captain Nemo"
      },
      "paymentId": null,
      "reference": "CN-202509-8274",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fm8nzsfzz9aen1pftqn9qr",
      "clustering": {
        "description": "Captain Nemo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Captain Nemo' based on payment details",
        "updatedAt": "2025-09-19T12:01:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Captain Nemo",
        "iban": null,
        "bic": null,
        "sortCode": "291698",
        "accountNumber": "38270367"
      }
    },
    {
      "id": "txn_1w202yw36t9fv57pxxxvbxt3g1",
      "createdAt": "2025-09-19T09:58:00.000Z",
      "updatedAt": "2025-09-19T09:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.03,
      "currency": "USD",
      "description": "Payment to Wispr: W-202509-8146",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_cba12sqnmp3qar2kdaz2mkcg3w",
      "fspDate": "2025-09-19T08:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_cba12sqnmp3qar2kdaz2mkcg3w",
        "bookingDate": "2025-09-19",
        "valueDate": "2025-09-19",
        "bookingDateTime": "2025-09-19T09:58:00.000Z",
        "valueDateTime": "2025-09-19T09:58:00.000Z",
        "transactionAmount": {
          "amount": "9.03",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Wispr: W-202509-8146",
        "remittanceInformationUnstructuredArray": [
          "Payment to Wispr",
          "W-202509-8146"
        ],
        "debtorName": "Wispr"
      },
      "paymentId": null,
      "reference": "W-202509-8146",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax6ceshspjngxatk00nd",
      "clustering": {
        "description": "Wispr",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Wispr' based on payment details",
        "updatedAt": "2025-09-19T09:58:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Wispr",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspehhxvygdqtb",
      "createdAt": "2025-09-19T08:56:00.000Z",
      "updatedAt": "2025-09-19T08:56:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 51.4,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3jp8gs1e8prs7nysc2etzge",
      "fspDate": "2025-09-19T07:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3jp8gs1e8prs7nysc2etzge",
        "bookingDate": "2025-09-19",
        "valueDate": "2025-09-19",
        "bookingDateTime": "2025-09-19T07:56:00.000Z",
        "valueDateTime": "2025-09-19T07:56:00.000Z",
        "transactionAmount": {
          "amount": "-51.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Zakura' from 'Zakura'.",
        "updatedAt": "2025-09-27T10:39:39.725Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph1vbdmm99tc",
      "createdAt": "2025-09-18T16:05:00.000Z",
      "updatedAt": "2025-09-18T16:05:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1497.12,
      "currency": "EUR",
      "description": "Upwork -814131955ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1zsn6nt17f4",
      "fspDate": "2025-09-18T15:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1zsn6nt17f4",
        "bookingDate": "2025-09-18",
        "valueDate": "2025-09-18",
        "bookingDateTime": "2025-09-18T15:05:00.000Z",
        "valueDateTime": "2025-09-18T15:05:00.000Z",
        "transactionAmount": {
          "amount": "-1497.12",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -814131955ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -814131955ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Upwork' from 'Upwork -814131955ref', removing the '-814131955ref' reference.",
        "updatedAt": "2025-09-27T10:54:12.608Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmkdxm9s6je4",
      "createdAt": "2025-09-18T15:20:00.000Z",
      "updatedAt": "2025-09-18T15:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 47,
      "currency": "GBP",
      "description": "To Ico",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8bw24gskndm",
      "fspDate": "2025-09-18T14:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8bw24gskndm",
        "bookingDate": "2025-09-18",
        "valueDate": "2025-09-18",
        "bookingDateTime": "2025-09-18T14:20:00.000Z",
        "valueDateTime": "2025-09-18T14:20:00.000Z",
        "transactionAmount": {
          "amount": "-47.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Ico",
        "remittanceInformationUnstructuredArray": [
          "To Ico"
        ],
        "debtorName": "ICO"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4gyfvhrjnsxtfs19v9b",
      "clustering": {
        "description": "ICO",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'ICO' from 'To Ico'",
        "updatedAt": "2025-09-29T18:25:48.562Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfkvsfawktf3",
      "createdAt": "2025-09-18T15:02:00.000Z",
      "updatedAt": "2025-09-18T15:02:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 129.09,
      "currency": "EUR",
      "description": "Github, Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0nzyjtcfq9r6nnqamz9vbf6",
      "fspDate": "2025-09-18T14:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0nzyjtcfq9r6nnqamz9vbf6",
        "bookingDate": "2025-09-18",
        "valueDate": "2025-09-18",
        "bookingDateTime": "2025-09-18T14:02:00.000Z",
        "valueDateTime": "2025-09-18T14:02:00.000Z",
        "transactionAmount": {
          "amount": "-129.09",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Github, Inc.",
        "remittanceInformationUnstructuredArray": [
          "Github, Inc."
        ],
        "debtorName": "GitHub"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wd4eshsphxfd9s33j9t",
      "clustering": {
        "description": "GitHub",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'GitHub' from 'Github, Inc.'",
        "updatedAt": "2025-09-27T10:49:04.339Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmewwvgae2fg",
      "createdAt": "2025-09-18T13:37:00.000Z",
      "updatedAt": "2025-09-18T13:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2000,
      "currency": "GBP",
      "description": "To Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk87d3f5a2t68",
      "fspDate": "2025-09-18T12:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk87d3f5a2t68",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T13:00:00.000Z",
        "valueDateTime": "2026-01-09T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-2000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance UK Ltd"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Seapoint Finance UK' from 'To Seapoint Finance UK Ltd'",
        "updatedAt": "2025-09-29T18:25:01.143Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfd22hzrdr3x",
      "createdAt": "2025-09-18T13:35:00.000Z",
      "updatedAt": "2025-09-18T13:35:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 187.31,
      "currency": "EUR",
      "description": "Linkedin Job P721118264",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k12vyakpe4dr6y1wf9jhfq6f",
      "fspDate": "2025-09-18T12:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k12vyakpe4dr6y1wf9jhfq6f",
        "bookingDate": "2025-09-18",
        "valueDate": "2025-09-18",
        "bookingDateTime": "2025-09-18T12:35:00.000Z",
        "valueDateTime": "2025-09-18T12:35:00.000Z",
        "transactionAmount": {
          "amount": "-187.31",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin Job P721118264",
        "remittanceInformationUnstructuredArray": [
          "Linkedin Job P721118264"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'LinkedIn' from 'Linkedin Job P721118264'",
        "updatedAt": "2025-09-27T10:48:02.669Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg3a5kq61d61",
      "createdAt": "2025-09-18T12:18:00.000Z",
      "updatedAt": "2025-09-18T12:18:00.000Z",
      "status": "BOOKED",
      "type": "CARD_REFUND",
      "isCredit": true,
      "amount": 348,
      "currency": "EUR",
      "description": "Refund from Clayton Hotel Burlingt",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0zs5196fmr1",
      "fspDate": "2025-09-18T11:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0zs5196fmr1",
        "bookingDate": "2025-09-18",
        "valueDate": "2025-09-18",
        "bookingDateTime": "2025-09-18T11:18:00.000Z",
        "valueDateTime": "2025-09-18T11:18:00.000Z",
        "transactionAmount": {
          "amount": "348.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_REFUND",
        "remittanceInformationUnstructured": "Refund from Clayton Hotel Burlingt",
        "remittanceInformationUnstructuredArray": [
          "Refund from Clayton Hotel Burlingt"
        ],
        "debtorName": "Clayton Hotel Burlington"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crppkeshspmfw2e0m4xdm",
      "clustering": {
        "description": "Clayton Hotel Burlington",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Clayton Hotel Burlington' from 'Refund from Clayton Hotel Burlingt'",
        "updatedAt": "2025-09-27T10:50:52.467Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_f4272xfedg6pfm4qzjnyqdzq18",
      "createdAt": "2025-09-18T11:44:00.000Z",
      "updatedAt": "2025-09-18T11:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 40.73,
      "currency": "EUR",
      "description": "Payment to Mamma Mia Restaurant: MMR-202509-1193",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_d4b08ed7jhg6zz76e4tm9a3gnv",
      "fspDate": "2025-09-18T10:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_d4b08ed7jhg6zz76e4tm9a3gnv",
        "bookingDate": "2025-09-18",
        "valueDate": "2025-09-18",
        "bookingDateTime": "2025-09-18T11:44:00.000Z",
        "valueDateTime": "2025-09-18T11:44:00.000Z",
        "transactionAmount": {
          "amount": "40.73",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mamma Mia Restaurant: MMR-202509-1193",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mamma Mia Restaurant",
          "MMR-202509-1193"
        ],
        "debtorName": "Mamma Mia Restaurant"
      },
      "paymentId": null,
      "reference": "MMR-202509-1193",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj1yeshspngr1g523f6q",
      "clustering": {
        "description": "Mamma Mia Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mamma Mia Restaurant' based on payment details",
        "updatedAt": "2025-09-18T11:44:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mamma Mia Restaurant",
        "iban": "DE85390416590258130",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_x9dt47eacngr0czxqadwpzdcbk",
      "createdAt": "2025-09-18T10:56:00.000Z",
      "updatedAt": "2025-09-18T10:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 209.02,
      "currency": "EUR",
      "description": "Payment to Google Workspace: GW-202509-1679",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9f2pwdjpe2geqntphq890htvag",
      "fspDate": "2025-09-18T09:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9f2pwdjpe2geqntphq890htvag",
        "bookingDate": "2025-09-18",
        "valueDate": "2025-09-18",
        "bookingDateTime": "2025-09-18T10:56:00.000Z",
        "valueDateTime": "2025-09-18T10:56:00.000Z",
        "transactionAmount": {
          "amount": "209.02",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Google Workspace: GW-202509-1679",
        "remittanceInformationUnstructuredArray": [
          "Payment to Google Workspace",
          "GW-202509-1679"
        ],
        "debtorName": "Google Workspace"
      },
      "paymentId": null,
      "reference": "GW-202509-1679",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdrteshspka3qwhrnts0",
      "clustering": {
        "description": "Google Workspace",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Google Workspace' based on payment details",
        "updatedAt": "2025-09-18T10:56:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Google Workspace",
        "iban": "DE86644890034638380",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3dym8vgwyqtt7re29b4f46y550",
      "createdAt": "2025-09-18T10:28:00.000Z",
      "updatedAt": "2025-09-18T10:28:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 32.32,
      "currency": "EUR",
      "description": "Payment to Sentry: S-202509-9504",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_v8ftx358fp19z7z171qh6yzcb7",
      "fspDate": "2025-09-18T09:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_v8ftx358fp19z7z171qh6yzcb7",
        "bookingDate": "2025-09-18",
        "valueDate": "2025-09-18",
        "bookingDateTime": "2025-09-18T10:28:00.000Z",
        "valueDateTime": "2025-09-18T10:28:00.000Z",
        "transactionAmount": {
          "amount": "32.32",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sentry: S-202509-9504",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sentry",
          "S-202509-9504"
        ],
        "debtorName": "Sentry"
      },
      "paymentId": null,
      "reference": "S-202509-9504",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdn2eshspk97jdcm57ef",
      "clustering": {
        "description": "Sentry",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sentry' based on payment details",
        "updatedAt": "2025-09-18T10:28:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sentry",
        "iban": "DE69078451515090940",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg1w99q63z4n",
      "createdAt": "2025-09-18T10:24:00.000Z",
      "updatedAt": "2025-09-18T10:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 46.66,
      "currency": "EUR",
      "description": "www.heathrowexpress.co",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0ykzc3q8phr",
      "fspDate": "2025-09-18T09:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0ykzc3q8phr",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T14:00:00.000Z",
        "valueDateTime": "2026-01-06T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-46.66",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "www.heathrowexpress.co",
        "remittanceInformationUnstructuredArray": [
          "www.heathrowexpress.co"
        ],
        "debtorName": "Heathrow Express"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpg2eshspmf0nznfw91y",
      "clustering": {
        "description": "Heathrow Express",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Heathrow Express' from 'www.heathrowexpress.co'",
        "updatedAt": "2025-09-27T10:50:52.407Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgvbfq856ddv",
      "createdAt": "2025-09-18T08:00:00.000Z",
      "updatedAt": "2025-09-18T08:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 132.34,
      "currency": "EUR",
      "description": "Slack T075w3v1kdk",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1r9w87swh3g",
      "fspDate": "2025-09-18T07:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1r9w87swh3g",
        "bookingDate": "2025-09-18",
        "valueDate": "2025-09-18",
        "bookingDateTime": "2025-09-18T07:00:00.000Z",
        "valueDateTime": "2025-09-18T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-132.34",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Slack T075w3v1kdk",
        "remittanceInformationUnstructuredArray": [
          "Slack T075w3v1kdk"
        ],
        "debtorName": "Slack"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtb9eshspk6e4wt4npvh",
      "clustering": {
        "description": "Slack",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Slack' from the raw transaction description.",
        "updatedAt": "2025-09-27T10:53:55.696Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmm22ffg45dk",
      "createdAt": "2025-09-17T16:32:00.000Z",
      "updatedAt": "2025-09-17T16:32:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 100,
      "currency": "GBP",
      "description": "Clayton Belfast Recept",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8d2m3sw2k24",
      "fspDate": "2025-09-17T15:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8d2m3sw2k24",
        "bookingDate": "2025-09-17",
        "valueDate": "2025-09-17",
        "bookingDateTime": "2025-09-17T15:32:00.000Z",
        "valueDateTime": "2025-09-17T15:32:00.000Z",
        "transactionAmount": {
          "amount": "-100.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Clayton Belfast Recept",
        "remittanceInformationUnstructuredArray": [
          "Clayton Belfast Recept"
        ],
        "debtorName": "Clayton Belfast"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4hyfvhrjnt1zqpqqyns",
      "clustering": {
        "description": "Clayton Belfast",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Clayton Belfast' from 'Clayton Belfast Recept'",
        "updatedAt": "2025-09-29T18:25:48.586Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_t38h2p3ppgxwqp7axpkkspq3rq",
      "createdAt": "2025-09-17T15:08:00.000Z",
      "updatedAt": "2025-09-17T15:08:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.19,
      "currency": "USD",
      "description": "Payment to Notion: N-202509-8318",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_655m8mraacna2ea6we07c94jcq",
      "fspDate": "2025-09-17T14:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_655m8mraacna2ea6we07c94jcq",
        "bookingDate": "2025-09-17",
        "valueDate": "2025-09-17",
        "bookingDateTime": "2025-09-17T15:08:00.000Z",
        "valueDateTime": "2025-09-17T15:08:00.000Z",
        "transactionAmount": {
          "amount": "10.19",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Notion: N-202509-8318",
        "remittanceInformationUnstructuredArray": [
          "Payment to Notion",
          "N-202509-8318"
        ],
        "debtorName": "Notion"
      },
      "paymentId": null,
      "reference": "N-202509-8318",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtcyeshspk6y0e76tesb",
      "clustering": {
        "description": "Notion",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Notion' based on payment details",
        "updatedAt": "2025-09-17T15:08:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Notion",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf3swt35c4b5",
      "createdAt": "2025-09-17T13:35:00.000Z",
      "updatedAt": "2025-09-17T13:35:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1514.87,
      "currency": "EUR",
      "description": "Upwork -833661967ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1wkxf1tena8nqtxs325geab",
      "fspDate": "2025-09-17T12:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1wkxf1tena8nqtxs325geab",
        "bookingDate": "2025-09-17",
        "valueDate": "2025-09-17",
        "bookingDateTime": "2025-09-17T12:35:00.000Z",
        "valueDateTime": "2025-09-17T12:35:00.000Z",
        "transactionAmount": {
          "amount": "-1514.87",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -833661967ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -833661967ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Upwork' from the transaction description, removing the '-833661967ref' suffix.",
        "updatedAt": "2025-09-27T10:43:55.503Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmcnt85zrdp7",
      "createdAt": "2025-09-17T12:16:00.000Z",
      "updatedAt": "2025-09-17T12:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1000,
      "currency": "GBP",
      "description": "To SEAPOINT FINANCE UK INVESTMENTS LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk855pyrynys2",
      "fspDate": "2025-09-17T11:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk855pyrynys2",
        "bookingDate": "2025-09-17",
        "valueDate": "2025-09-17",
        "bookingDateTime": "2025-09-17T11:16:00.000Z",
        "valueDateTime": "2025-09-17T11:16:00.000Z",
        "transactionAmount": {
          "amount": "-1000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To SEAPOINT FINANCE UK INVESTMENTS LIMITED",
        "remittanceInformationUnstructuredArray": [
          "To SEAPOINT FINANCE UK INVESTMENTS LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK Investments",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Seapoint Finance UK Investments' from 'To SEAPOINT FINANCE UK INVESTMENTS LIMITED'",
        "updatedAt": "2025-09-29T18:25:01.093Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ve402jeaf9jfef2nyfxj662cbq",
      "createdAt": "2025-09-17T10:38:00.000Z",
      "updatedAt": "2025-09-17T10:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.06,
      "currency": "EUR",
      "description": "Payment to Beanhive: B-202509-4924",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9k6tsdtzc0tezrd8yjgtje4f0j",
      "fspDate": "2025-09-17T09:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9k6tsdtzc0tezrd8yjgtje4f0j",
        "bookingDate": "2025-09-17",
        "valueDate": "2025-09-17",
        "bookingDateTime": "2025-09-17T10:38:00.000Z",
        "valueDateTime": "2025-09-17T10:38:00.000Z",
        "transactionAmount": {
          "amount": "10.06",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Beanhive: B-202509-4924",
        "remittanceInformationUnstructuredArray": [
          "Payment to Beanhive",
          "B-202509-4924"
        ],
        "debtorName": "Beanhive"
      },
      "paymentId": null,
      "reference": "B-202509-4924",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmacweshspkk5mv2ktdq4",
      "clustering": {
        "description": "Beanhive",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Beanhive' based on payment details",
        "updatedAt": "2025-09-17T10:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Beanhive",
        "iban": "DE43319279701678610",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspexcv44b0cfz",
      "createdAt": "2025-09-17T09:18:00.000Z",
      "updatedAt": "2025-09-17T09:18:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2pbwp66fzwbe0xxt5xq60mn",
      "fspDate": "2025-09-17T08:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2pbwp66fzwbe0xxt5xq60mn",
        "bookingDate": "2025-09-17",
        "valueDate": "2025-09-17",
        "bookingDateTime": "2025-09-17T08:18:00.000Z",
        "valueDateTime": "2025-09-17T08:18:00.000Z",
        "transactionAmount": {
          "amount": "-2.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Companies Registration' from 'Companies Registration'",
        "updatedAt": "2025-09-27T10:42:40.363Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfzs1ct2gxjk",
      "createdAt": "2025-09-17T07:12:00.000Z",
      "updatedAt": "2025-09-17T07:12:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 46.59,
      "currency": "EUR",
      "description": "www.heathrowexpress.co",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0y3565nx9k4",
      "fspDate": "2025-09-17T06:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0y3565nx9k4",
        "bookingDate": "2026-01-04",
        "valueDate": "2026-01-04",
        "bookingDateTime": "2026-01-04T16:00:00.000Z",
        "valueDateTime": "2026-01-04T16:00:00.000Z",
        "transactionAmount": {
          "amount": "-46.59",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "www.heathrowexpress.co",
        "remittanceInformationUnstructuredArray": [
          "www.heathrowexpress.co"
        ],
        "debtorName": "Heathrow Express"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpg2eshspmf0nznfw91y",
      "clustering": {
        "description": "Heathrow Express",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Heathrow Express' from 'www.heathrowexpress.co'",
        "updatedAt": "2025-09-27T10:50:52.301Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3k0648wq6dycq9kgwv0e3qc7gg",
      "createdAt": "2025-09-16T13:25:00.000Z",
      "updatedAt": "2025-09-16T13:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.75,
      "currency": "GBP",
      "description": "Payment to Uber: U-202509-3021",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5gs7xx2nwa3sxqefzsfbhqjrh2",
      "fspDate": "2025-09-16T12:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5gs7xx2nwa3sxqefzsfbhqjrh2",
        "bookingDate": "2025-09-16",
        "valueDate": "2025-09-16",
        "bookingDateTime": "2025-09-16T13:25:00.000Z",
        "valueDateTime": "2025-09-16T13:25:00.000Z",
        "transactionAmount": {
          "amount": "9.75",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Uber: U-202509-3021",
        "remittanceInformationUnstructuredArray": [
          "Payment to Uber",
          "U-202509-3021"
        ],
        "debtorName": "Uber"
      },
      "paymentId": null,
      "reference": "U-202509-3021",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Uber",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Uber' based on payment details",
        "updatedAt": "2025-09-16T13:25:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Uber",
        "iban": null,
        "bic": null,
        "sortCode": "320059",
        "accountNumber": "94345252"
      }
    },
    {
      "id": "txn_01k65c32y0eshspeyavky4kfp7",
      "createdAt": "2025-09-16T12:25:00.000Z",
      "updatedAt": "2025-09-16T12:25:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 22.14,
      "currency": "EUR",
      "description": "Claude.ai Subscription",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2h731t1eskvntnbd0phzys7",
      "fspDate": "2025-09-16T11:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2h731t1eskvntnbd0phzys7",
        "bookingDate": "2025-09-16",
        "valueDate": "2025-09-16",
        "bookingDateTime": "2025-09-16T11:25:00.000Z",
        "valueDateTime": "2025-09-16T11:25:00.000Z",
        "transactionAmount": {
          "amount": "-22.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Claude.ai Subscription",
        "remittanceInformationUnstructuredArray": [
          "Claude.ai Subscription"
        ],
        "debtorName": "Claude.ai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5j1eshspjz017vq1wgn",
      "clustering": {
        "description": "Claude.ai",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Claude.ai' from 'Claude.ai Subscription'",
        "updatedAt": "2025-09-27T10:42:40.386Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebzafvhrjmt8c4faz4k3",
      "createdAt": "2025-09-16T11:08:00.000Z",
      "updatedAt": "2025-09-16T11:08:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1095,
      "currency": "GBP",
      "description": "To Modulr Finance Limited GBP",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8jzqtsxbw5e",
      "fspDate": "2025-09-16T10:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8jzqtsxbw5e",
        "bookingDate": "2025-09-16",
        "valueDate": "2025-09-16",
        "bookingDateTime": "2025-09-16T10:08:00.000Z",
        "valueDateTime": "2025-09-16T10:08:00.000Z",
        "transactionAmount": {
          "amount": "-1095.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Modulr Finance Limited GBP",
        "remittanceInformationUnstructuredArray": [
          "To Modulr Finance Limited GBP"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Modulr Finance Limited' from 'To Modulr Finance Limited GBP'",
        "updatedAt": "2025-09-29T18:26:41.001Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5zdas3ax7vxzx4n38698tts91j",
      "createdAt": "2025-09-16T09:27:00.000Z",
      "updatedAt": "2025-09-16T09:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 24785.13,
      "currency": "GBP",
      "description": "Payment from DataDriven Analytics - INV-202509-4515",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0b670xyjxmdaac0h7fnkype39t",
      "fspDate": "2025-09-16T08:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0b670xyjxmdaac0h7fnkype39t",
        "bookingDate": "2025-09-16",
        "valueDate": "2025-09-16",
        "bookingDateTime": "2025-09-16T09:27:00.000Z",
        "valueDateTime": "2025-09-16T09:27:00.000Z",
        "transactionAmount": {
          "amount": "24785.13",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from DataDriven Analytics - INV-202509-4515",
        "remittanceInformationUnstructuredArray": [
          "Payment from DataDriven Analytics",
          "INV-202509-4515"
        ],
        "creditorName": "DataDriven Analytics"
      },
      "paymentId": null,
      "reference": "INV-202509-4515",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_jy64mwn8y868akxp0c6s337dms",
      "clustering": {
        "description": "DataDriven Analytics",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'DataDriven Analytics'",
        "updatedAt": "2025-09-16T09:27:00.000Z"
      },
      "payer": {
        "name": "DataDriven Analytics",
        "iban": null,
        "bic": null,
        "sortCode": "202822",
        "accountNumber": "45007834"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgj8sv3nvs1e",
      "createdAt": "2025-09-16T08:14:00.000Z",
      "updatedAt": "2025-09-16T08:14:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 2000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1faphzkwhd2",
      "fspDate": "2025-09-16T07:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1faphzkwhd2",
        "bookingDate": "2025-09-16",
        "valueDate": "2025-09-16",
        "bookingDateTime": "2025-09-16T07:14:00.000Z",
        "valueDateTime": "2025-09-16T07:14:00.000Z",
        "transactionAmount": {
          "amount": "-2000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name since the transaction is a currency exchange, and the description is 'Exchanged to GBP Main'.",
        "updatedAt": "2025-09-27T10:52:47.479Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm2w31z9er6r",
      "createdAt": "2025-09-16T08:12:00.000Z",
      "updatedAt": "2025-09-16T08:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12000,
      "currency": "GBP",
      "description": "To Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3wzvcvhe4btjfaq1nrqw1r1",
      "fspDate": "2025-09-16T07:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3wzvcvhe4btjfaq1nrqw1r1",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T07:00:00.000Z",
        "valueDateTime": "2026-01-10T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-12000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance UK Ltd"
        ],
        "debtorName": "Seapoint Finance UK Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance UK' from 'To Seapoint Finance UK Ltd', removing 'To ' prefix and 'Ltd' suffix",
        "updatedAt": "2025-09-29T18:23:50.771Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfya6ys7yn3f",
      "createdAt": "2025-09-15T15:22:00.000Z",
      "updatedAt": "2025-09-15T15:22:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 133,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0tx5kfk4fct",
      "fspDate": "2025-09-15T14:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0tx5kfk4fct",
        "bookingDate": "2025-09-15",
        "valueDate": "2025-09-15",
        "bookingDateTime": "2025-09-15T14:22:00.000Z",
        "valueDateTime": "2025-09-15T14:22:00.000Z",
        "transactionAmount": {
          "amount": "-133.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Shaka Poke' from 'Sq *shaka Poke'",
        "updatedAt": "2025-09-27T10:50:08.416Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_g9jrgpkbt6spmh895r91nw5tav",
      "createdAt": "2025-09-15T15:15:00.000Z",
      "updatedAt": "2025-09-15T15:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6.28,
      "currency": "EUR",
      "description": "Payment to Spar: S-202509-8707",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_shgzmmcnrawh1qm6bcrsggkrqn",
      "fspDate": "2025-09-15T14:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_shgzmmcnrawh1qm6bcrsggkrqn",
        "bookingDate": "2025-09-15",
        "valueDate": "2025-09-15",
        "bookingDateTime": "2025-09-15T15:15:00.000Z",
        "valueDateTime": "2025-09-15T15:15:00.000Z",
        "transactionAmount": {
          "amount": "6.28",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Spar: S-202509-8707",
        "remittanceInformationUnstructuredArray": [
          "Payment to Spar",
          "S-202509-8707"
        ],
        "debtorName": "Spar"
      },
      "paymentId": null,
      "reference": "S-202509-8707",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g32eshsphp8z5k4nrvg",
      "clustering": {
        "description": "Spar",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Spar' based on payment details",
        "updatedAt": "2025-09-15T15:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Spar",
        "iban": "DE71100692353191370",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zb6a1dxt2me0pyhkq5xqfc88gb",
      "createdAt": "2025-09-15T13:35:00.000Z",
      "updatedAt": "2025-09-15T13:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 36.59,
      "currency": "EUR",
      "description": "Payment to FREE NOW: FN-202509-1823",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_cqjpj818ew80dg7s7mcf70d5vh",
      "fspDate": "2025-09-15T12:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_cqjpj818ew80dg7s7mcf70d5vh",
        "bookingDate": "2025-09-15",
        "valueDate": "2025-09-15",
        "bookingDateTime": "2025-09-15T13:35:00.000Z",
        "valueDateTime": "2025-09-15T13:35:00.000Z",
        "transactionAmount": {
          "amount": "36.59",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to FREE NOW: FN-202509-1823",
        "remittanceInformationUnstructuredArray": [
          "Payment to FREE NOW",
          "FN-202509-1823"
        ],
        "debtorName": "FREE NOW"
      },
      "paymentId": null,
      "reference": "FN-202509-1823",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj31eshspnh3qzqhcd5r",
      "clustering": {
        "description": "FREE NOW",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'FREE NOW' based on payment details",
        "updatedAt": "2025-09-15T13:35:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "FREE NOW",
        "iban": "DE31531252466668868",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ndd93a86exjjf9arxympn28x62",
      "createdAt": "2025-09-15T11:42:00.000Z",
      "updatedAt": "2025-09-15T11:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1775.15,
      "currency": "EUR",
      "description": "Payment to Patrick Walsh: PW-202509-5890",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mbg78sgbsxbfj4zpj9jgpkn4th",
      "fspDate": "2025-09-15T10:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mbg78sgbsxbfj4zpj9jgpkn4th",
        "bookingDate": "2025-09-15",
        "valueDate": "2025-09-15",
        "bookingDateTime": "2025-09-15T11:42:00.000Z",
        "valueDateTime": "2025-09-15T11:42:00.000Z",
        "transactionAmount": {
          "amount": "1775.15",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Patrick Walsh: PW-202509-5890",
        "remittanceInformationUnstructuredArray": [
          "Payment to Patrick Walsh",
          "PW-202509-5890"
        ],
        "debtorName": "Patrick Walsh"
      },
      "paymentId": null,
      "reference": "PW-202509-5890",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqmzweshspm8kq27v8562",
      "clustering": {
        "description": "Patrick Walsh",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Patrick Walsh' based on payment details",
        "updatedAt": "2025-09-15T11:42:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Patrick Walsh",
        "iban": "DE13952345053806538",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_krpywhz757x34enbz473d0s5y4",
      "createdAt": "2025-09-15T11:00:00.000Z",
      "updatedAt": "2025-09-15T11:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2533.53,
      "currency": "EUR",
      "description": "Payment to Marta Kowalska Consulting: MKC-202509-5791",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_smqr9e1734cqg8fp8mqqyhv6ms",
      "fspDate": "2025-09-15T10:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_smqr9e1734cqg8fp8mqqyhv6ms",
        "bookingDate": "2025-09-15",
        "valueDate": "2025-09-15",
        "bookingDateTime": "2025-09-15T11:00:00.000Z",
        "valueDateTime": "2025-09-15T11:00:00.000Z",
        "transactionAmount": {
          "amount": "2533.53",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marta Kowalska Consulting: MKC-202509-5791",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marta Kowalska Consulting",
          "MKC-202509-5791"
        ],
        "debtorName": "Marta Kowalska Consulting"
      },
      "paymentId": null,
      "reference": "MKC-202509-5791",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj39eshspnh92mjbyz8s",
      "clustering": {
        "description": "Marta Kowalska Consulting",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marta Kowalska Consulting' based on payment details",
        "updatedAt": "2025-09-15T11:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marta Kowalska Consulting",
        "iban": "DE24342254555810760",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfna19xpp4xq",
      "createdAt": "2025-09-14T16:10:00.000Z",
      "updatedAt": "2025-09-14T16:10:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Suhas Falafel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0er6nb6fq9r55yc03gn2cq2",
      "fspDate": "2025-09-14T15:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0er6nb6fq9r55yc03gn2cq2",
        "bookingDate": "2025-09-14",
        "valueDate": "2025-09-14",
        "bookingDateTime": "2025-09-14T15:10:00.000Z",
        "valueDateTime": "2025-09-14T15:10:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Suhas Falafel",
        "remittanceInformationUnstructuredArray": [
          "Suhas Falafel"
        ],
        "debtorName": "Suhas Falafel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmadbeshspkkgwerj0myb",
      "clustering": {
        "description": "Suhas Falafel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Suhas Falafel' from the transaction description",
        "updatedAt": "2025-09-27T10:49:04.370Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmg76je610rc",
      "createdAt": "2025-09-14T15:54:00.000Z",
      "updatedAt": "2025-09-14T15:54:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 5976.71,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk88gpxvsrkam",
      "fspDate": "2025-09-14T14:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk88gpxvsrkam",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T08:00:00.000Z",
        "valueDateTime": "2026-01-07T08:00:00.000Z",
        "transactionAmount": {
          "amount": "5976.71",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.166Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph3k1dw4a5sc",
      "createdAt": "2025-09-14T15:22:00.000Z",
      "updatedAt": "2025-09-14T15:22:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 229,
      "currency": "EUR",
      "description": "wttj.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk21m2n8vzdch",
      "fspDate": "2025-09-14T14:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk21m2n8vzdch",
        "bookingDate": "2025-12-26",
        "valueDate": "2025-12-26",
        "bookingDateTime": "2025-12-26T12:05:00.000Z",
        "valueDateTime": "2025-12-26T12:05:00.000Z",
        "transactionAmount": {
          "amount": "-229.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "wttj.com",
        "remittanceInformationUnstructuredArray": [
          "wttj.com"
        ],
        "debtorName": "Welcome to the Jungle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkfxeshspnwz7ebn2y1d",
      "clustering": {
        "description": "Welcome to the Jungle",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Welcome to the Jungle' from 'wttj.com'",
        "updatedAt": "2025-09-27T10:54:50.798Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n82p9gnepy3jrh5xbajs65kt7a",
      "createdAt": "2025-09-14T11:43:00.000Z",
      "updatedAt": "2025-09-14T11:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.98,
      "currency": "EUR",
      "description": "Payment to Anthony Moore: AM-202509-3489",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_t2ccrj9rcefnvhy377hvwkwznd",
      "fspDate": "2025-09-14T10:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_t2ccrj9rcefnvhy377hvwkwznd",
        "bookingDate": "2025-09-14",
        "valueDate": "2025-09-14",
        "bookingDateTime": "2025-09-14T11:43:00.000Z",
        "valueDateTime": "2025-09-14T11:43:00.000Z",
        "transactionAmount": {
          "amount": "20.98",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthony Moore: AM-202509-3489",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthony Moore",
          "AM-202509-3489"
        ],
        "debtorName": "Anthony Moore"
      },
      "paymentId": null,
      "reference": "AM-202509-3489",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a2keshspnzq7m9sbpn2",
      "clustering": {
        "description": "Anthony Moore",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthony Moore' based on payment details",
        "updatedAt": "2025-09-14T11:43:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthony Moore",
        "iban": "DE73322192461292830",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfb7zmszht1p",
      "createdAt": "2025-09-14T07:44:00.000Z",
      "updatedAt": "2025-09-14T07:44:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1ak4azgesj89g4t1vzkvvkf",
      "fspDate": "2025-09-14T06:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1ak4azgesj89g4t1vzkvvkf",
        "bookingDate": "2025-09-14",
        "valueDate": "2025-09-14",
        "bookingDateTime": "2025-09-14T06:44:00.000Z",
        "valueDateTime": "2025-09-14T06:44:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing the Sq * prefix",
        "updatedAt": "2025-09-27T10:45:11.656Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspf02xyvekxbe",
      "createdAt": "2025-09-13T16:16:00.000Z",
      "updatedAt": "2025-09-13T16:16:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25.77,
      "currency": "EUR",
      "description": "Tavily Ai",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2empapqfk7s2z1dqh6phwtk",
      "fspDate": "2025-09-13T15:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2empapqfk7s2z1dqh6phwtk",
        "bookingDate": "2025-09-13",
        "valueDate": "2025-09-13",
        "bookingDateTime": "2025-09-13T15:16:00.000Z",
        "valueDateTime": "2025-09-13T15:16:00.000Z",
        "transactionAmount": {
          "amount": "-25.77",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tavily Ai",
        "remittanceInformationUnstructuredArray": [
          "Tavily Ai"
        ],
        "debtorName": "Tavily AI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ceerteshspk5wmka0h0ee",
      "clustering": {
        "description": "Tavily AI",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Tavily AI' from 'Tavily Ai'",
        "updatedAt": "2025-09-27T10:42:40.427Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmcy9bexa7d9",
      "createdAt": "2025-09-13T12:37:00.000Z",
      "updatedAt": "2025-09-13T12:37:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 34305.2,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk85bez9rgyr1",
      "fspDate": "2025-09-13T11:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk85bez9rgyr1",
        "bookingDate": "2025-09-13",
        "valueDate": "2025-09-13",
        "bookingDateTime": "2025-09-13T11:37:00.000Z",
        "valueDateTime": "2025-09-13T11:37:00.000Z",
        "transactionAmount": {
          "amount": "34305.20",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.097Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg3zrx6zf07j",
      "createdAt": "2025-09-13T08:38:00.000Z",
      "updatedAt": "2025-09-13T08:38:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 34.23,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk10hkcxphbd6",
      "fspDate": "2025-09-13T07:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk10hkcxphbd6",
        "bookingDate": "2025-09-13",
        "valueDate": "2025-09-13",
        "bookingDateTime": "2025-09-13T07:38:00.000Z",
        "valueDateTime": "2025-09-13T07:38:00.000Z",
        "transactionAmount": {
          "amount": "-34.23",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cursor' from 'Cursor, Ai Powered Ide'",
        "updatedAt": "2025-09-27T10:50:52.487Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfswnd7t2293",
      "createdAt": "2025-09-13T07:04:00.000Z",
      "updatedAt": "2025-09-13T07:04:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "EUR",
      "description": "Finom",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0p20ajwpfr2",
      "fspDate": "2025-09-13T06:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0p20ajwpfr2",
        "bookingDate": "2025-09-13",
        "valueDate": "2025-09-13",
        "bookingDateTime": "2025-09-13T06:04:00.000Z",
        "valueDateTime": "2025-09-13T06:04:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Finom",
        "remittanceInformationUnstructuredArray": [
          "Finom"
        ],
        "debtorName": "Finom"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0yxeshspjws0xeeqa1k",
      "clustering": {
        "description": "Finom",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Finom' from 'Finom'",
        "updatedAt": "2025-09-27T10:50:08.267Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gr71820gnpzctafnt8tw3mta9k",
      "createdAt": "2025-09-12T15:36:00.000Z",
      "updatedAt": "2025-09-12T15:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6448.42,
      "currency": "EUR",
      "description": "Payment to Jonas Novak: JN-202509-6954",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5xrt91nejbxzcak5mvbhb6srja",
      "fspDate": "2025-09-12T14:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5xrt91nejbxzcak5mvbhb6srja",
        "bookingDate": "2025-09-12",
        "valueDate": "2025-09-12",
        "bookingDateTime": "2025-09-12T15:36:00.000Z",
        "valueDateTime": "2025-09-12T15:36:00.000Z",
        "transactionAmount": {
          "amount": "6448.42",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jonas Novak: JN-202509-6954",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jonas Novak",
          "JN-202509-6954"
        ],
        "debtorName": "Jonas Novak"
      },
      "paymentId": null,
      "reference": "JN-202509-6954",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x01eshsphmk5k2axdrt",
      "clustering": {
        "description": "Jonas Novak",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Jonas Novak' based on payment details",
        "updatedAt": "2025-09-12T15:36:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Jonas Novak",
        "iban": "DE25020576189797304",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmgzs12avpt8",
      "createdAt": "2025-09-12T09:44:00.000Z",
      "updatedAt": "2025-09-12T09:44:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 224.64,
      "currency": "GBP",
      "description": "Aer Lingus",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk89dzf6e2qvt",
      "fspDate": "2025-09-12T08:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk89dzf6e2qvt",
        "bookingDate": "2025-09-12",
        "valueDate": "2025-09-12",
        "bookingDateTime": "2025-09-12T08:44:00.000Z",
        "valueDateTime": "2025-09-12T08:44:00.000Z",
        "transactionAmount": {
          "amount": "-224.64",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Aer Lingus",
        "remittanceInformationUnstructuredArray": [
          "Aer Lingus"
        ],
        "debtorName": "Aer Lingus"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnekfvhrjnk2qd4ej2sf",
      "clustering": {
        "description": "Aer Lingus",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Aer Lingus' from 'Aer Lingus'",
        "updatedAt": "2025-09-29T18:25:48.425Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_z4mwtp9aacr3wh03y3yrdgnjd6",
      "createdAt": "2025-09-11T09:02:00.000Z",
      "updatedAt": "2025-09-11T09:02:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 28.13,
      "currency": "GBP",
      "description": "Payment to Argos: A-202509-8913",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_a4g55mhmm7v4pnpjjfh2z05psn",
      "fspDate": "2025-09-11T08:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_a4g55mhmm7v4pnpjjfh2z05psn",
        "bookingDate": "2025-09-11",
        "valueDate": "2025-09-11",
        "bookingDateTime": "2025-09-11T09:02:00.000Z",
        "valueDateTime": "2025-09-11T09:02:00.000Z",
        "transactionAmount": {
          "amount": "28.13",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Argos: A-202509-8913",
        "remittanceInformationUnstructuredArray": [
          "Payment to Argos",
          "A-202509-8913"
        ],
        "debtorName": "Argos"
      },
      "paymentId": null,
      "reference": "A-202509-8913",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgp9fvhrjp1ker17rwy0",
      "clustering": {
        "description": "Argos",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Argos' based on payment details",
        "updatedAt": "2025-09-11T09:02:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Argos",
        "iban": null,
        "bic": null,
        "sortCode": "260480",
        "accountNumber": "73994799"
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm7d222z7hk7",
      "createdAt": "2025-09-11T09:00:00.000Z",
      "updatedAt": "2025-09-11T09:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4690,
      "currency": "GBP",
      "description": "Payment to Modulr Finance Limited GBP",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1frctt0fk0vs81anbhcwfzz",
      "fspDate": "2025-09-11T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1frctt0fk0vs81anbhcwfzz",
        "bookingDate": "2025-09-11",
        "valueDate": "2025-09-11",
        "bookingDateTime": "2025-09-11T08:00:00.000Z",
        "valueDateTime": "2025-09-11T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-4690.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Modulr Finance Limited GBP",
        "remittanceInformationUnstructuredArray": [
          "Payment to Modulr Finance Limited GBP"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Modulr Finance Limited' from 'Payment to Modulr Finance Limited GBP', removing the prefix 'Payment to '",
        "updatedAt": "2025-09-29T18:24:29.601Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf7hbasz8s1p",
      "createdAt": "2025-09-10T16:27:00.000Z",
      "updatedAt": "2025-09-10T16:27:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.1,
      "currency": "EUR",
      "description": "Sq *pinecone Coffee Mo",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1jaadqbfk0vtsrst0zp5zsh",
      "fspDate": "2025-09-10T15:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1jaadqbfk0vtsrst0zp5zsh",
        "bookingDate": "2025-09-10",
        "valueDate": "2025-09-10",
        "bookingDateTime": "2025-09-10T15:27:00.000Z",
        "valueDateTime": "2025-09-10T15:27:00.000Z",
        "transactionAmount": {
          "amount": "-4.10",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *pinecone Coffee Mo",
        "remittanceInformationUnstructuredArray": [
          "Sq *pinecone Coffee Mo"
        ],
        "debtorName": "Pinecone Coffee"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh31eshspkh23ahabkmn",
      "clustering": {
        "description": "Pinecone Coffee",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Pinecone Coffee' from 'Sq *pinecone Coffee Mo', removing the Sq * prefix",
        "updatedAt": "2025-09-27T10:45:11.549Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fq4hhnx8he9antm58fge2xc2n5",
      "createdAt": "2025-09-10T12:43:00.000Z",
      "updatedAt": "2025-09-10T12:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 8500,
      "currency": "GBP",
      "description": "Salary - Sarah Mitchell - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_516b0pe0ctaxyr5qdvdtbfs1pb",
      "fspDate": "2025-09-10T11:43:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_t0mbgzgrv0xzz2ae7tnn09mt2v",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T16:00:00.000Z",
        "valueDateTime": "2026-01-08T16:00:00.000Z",
        "transactionAmount": {
          "amount": "-8500.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Sarah Mitchell",
        "remittanceInformationUnstructuredArray": [
          "Salary - Sarah Mitchell"
        ]
      },
      "paymentId": "pmnt_b1q1xwfrt9zw5y5hwvgy3qjk8g",
      "reference": "PAY-DEC-2025-MITCHELL",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sarah Mitchell",
        "iban": null,
        "bic": null,
        "sortCode": "20-00-00",
        "accountNumber": "12345601"
      }
    },
    {
      "id": "txn_sn6k6yyq538v5sxsw8fpqqp8t9",
      "createdAt": "2025-09-10T10:42:00.000Z",
      "updatedAt": "2025-09-10T10:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 826.73,
      "currency": "USD",
      "description": "Payment to GitHub, Inc.: GI-202509-6519",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_na5ndgmzfkkbyf5j3y9nnrg559",
      "fspDate": "2025-09-10T09:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_na5ndgmzfkkbyf5j3y9nnrg559",
        "bookingDate": "2025-09-10",
        "valueDate": "2025-09-10",
        "bookingDateTime": "2025-09-10T10:42:00.000Z",
        "valueDateTime": "2025-09-10T10:42:00.000Z",
        "transactionAmount": {
          "amount": "826.73",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GitHub, Inc.: GI-202509-6519",
        "remittanceInformationUnstructuredArray": [
          "Payment to GitHub, Inc.",
          "GI-202509-6519"
        ],
        "debtorName": "GitHub, Inc."
      },
      "paymentId": null,
      "reference": "GI-202509-6519",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_xj643cpp5p1awyrrqgqpf67q4d",
      "clustering": {
        "description": "GitHub, Inc.",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'GitHub, Inc.' based on payment details",
        "updatedAt": "2025-09-10T10:42:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GitHub, Inc.",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2atzrm187vxznsfphzrscnevck",
      "createdAt": "2025-09-10T08:56:00.000Z",
      "updatedAt": "2025-09-10T08:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 48.51,
      "currency": "EUR",
      "description": "Payment to Calendly: C-202509-3583",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jhnymcfs53eqdysxmrg416xezv",
      "fspDate": "2025-09-10T07:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jhnymcfs53eqdysxmrg416xezv",
        "bookingDate": "2025-09-10",
        "valueDate": "2025-09-10",
        "bookingDateTime": "2025-09-10T08:56:00.000Z",
        "valueDateTime": "2025-09-10T08:56:00.000Z",
        "transactionAmount": {
          "amount": "48.51",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Calendly: C-202509-3583",
        "remittanceInformationUnstructuredArray": [
          "Payment to Calendly",
          "C-202509-3583"
        ],
        "debtorName": "Calendly"
      },
      "paymentId": null,
      "reference": "C-202509-3583",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtc5eshspk6kqa7yaywk",
      "clustering": {
        "description": "Calendly",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Calendly' based on payment details",
        "updatedAt": "2025-09-10T08:56:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Calendly",
        "iban": "DE99529295539723790",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgbhs42znkm2",
      "createdAt": "2025-09-10T08:19:00.000Z",
      "updatedAt": "2025-09-10T08:19:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 180.9,
      "currency": "EUR",
      "description": "Reflect Software Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk19bf80cvvac",
      "fspDate": "2025-09-10T07:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk19bf80cvvac",
        "bookingDate": "2025-09-10",
        "valueDate": "2025-09-10",
        "bookingDateTime": "2025-09-10T07:19:00.000Z",
        "valueDateTime": "2025-09-10T07:19:00.000Z",
        "transactionAmount": {
          "amount": "-180.90",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Reflect Software Inc.",
        "remittanceInformationUnstructuredArray": [
          "Reflect Software Inc."
        ],
        "debtorName": "Reflect Software"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wfmeshsphxg0s376ywm",
      "clustering": {
        "description": "Reflect Software",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Reflect Software' from 'Reflect Software Inc.'",
        "updatedAt": "2025-09-27T10:52:10.030Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgttqsthqdmt",
      "createdAt": "2025-09-09T15:46:00.000Z",
      "updatedAt": "2025-09-09T15:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1qr800n2yb0",
      "fspDate": "2025-09-09T14:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1qr800n2yb0",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T14:46:00.000Z",
        "valueDateTime": "2025-09-09T14:46:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Coffee Angel' from the raw transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:53:55.688Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_19cx9nsfnz9fvwe6fg95fy0rbn",
      "createdAt": "2025-09-09T14:58:00.000Z",
      "updatedAt": "2025-09-09T14:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1107.77,
      "currency": "GBP",
      "description": "Payment to Adam Rankin: AR-202509-3375",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_79rhxgvm5t0ansnmv9bn27vay0",
      "fspDate": "2025-09-09T13:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_79rhxgvm5t0ansnmv9bn27vay0",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T14:58:00.000Z",
        "valueDateTime": "2025-09-09T14:58:00.000Z",
        "transactionAmount": {
          "amount": "1107.77",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Adam Rankin: AR-202509-3375",
        "remittanceInformationUnstructuredArray": [
          "Payment to Adam Rankin",
          "AR-202509-3375"
        ],
        "debtorName": "Adam Rankin"
      },
      "paymentId": null,
      "reference": "AR-202509-3375",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2zfvhrjnc124tr3b2s",
      "clustering": {
        "description": "Adam Rankin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Adam Rankin' based on payment details",
        "updatedAt": "2025-09-09T14:58:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Adam Rankin",
        "iban": null,
        "bic": null,
        "sortCode": "478741",
        "accountNumber": "58908853"
      }
    },
    {
      "id": "txn_n87avt3ychj19k11qyq0xn6a0m",
      "createdAt": "2025-09-09T13:49:00.000Z",
      "updatedAt": "2025-09-09T13:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.05,
      "currency": "EUR",
      "description": "Payment to Revolut: R-202509-9390",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1jw9ptvbg9y22ewgsaaz39fhaz",
      "fspDate": "2025-09-09T12:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1jw9ptvbg9y22ewgsaaz39fhaz",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T13:49:00.000Z",
        "valueDateTime": "2025-09-09T13:49:00.000Z",
        "transactionAmount": {
          "amount": "10.05",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Revolut: R-202509-9390",
        "remittanceInformationUnstructuredArray": [
          "Payment to Revolut",
          "R-202509-9390"
        ],
        "debtorName": "Revolut"
      },
      "paymentId": null,
      "reference": "R-202509-9390",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mvseshspja4gsxz03at",
      "clustering": {
        "description": "Revolut",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Revolut' based on payment details",
        "updatedAt": "2025-09-09T13:49:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Revolut",
        "iban": "DE29716639343230844",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wbdx29bt98khm7enpp7kxbfm4t",
      "createdAt": "2025-09-09T12:39:00.000Z",
      "updatedAt": "2025-09-09T12:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4372.47,
      "currency": "GBP",
      "description": "Payment to WealthKernel: W-202509-8525",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nn644j6z8nvrqzfc04pekbec2k",
      "fspDate": "2025-09-09T11:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nn644j6z8nvrqzfc04pekbec2k",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T12:39:00.000Z",
        "valueDateTime": "2025-09-09T12:39:00.000Z",
        "transactionAmount": {
          "amount": "4372.47",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to WealthKernel: W-202509-8525",
        "remittanceInformationUnstructuredArray": [
          "Payment to WealthKernel",
          "W-202509-8525"
        ],
        "debtorName": "WealthKernel"
      },
      "paymentId": null,
      "reference": "W-202509-8525",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhng0fvhrjnk93frdx83x",
      "clustering": {
        "description": "WealthKernel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'WealthKernel' based on payment details",
        "updatedAt": "2025-09-09T12:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "WealthKernel",
        "iban": null,
        "bic": null,
        "sortCode": "642275",
        "accountNumber": "87623036"
      }
    },
    {
      "id": "txn_y69mzzbztbz6nyjc9paq08njpq",
      "createdAt": "2025-09-09T12:06:00.000Z",
      "updatedAt": "2025-09-09T12:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 24.56,
      "currency": "EUR",
      "description": "Payment to Tang: T-202509-5058",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_17af5ev8383fekeqc6h4ynmpn9",
      "fspDate": "2025-09-09T11:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_17af5ev8383fekeqc6h4ynmpn9",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T12:06:00.000Z",
        "valueDateTime": "2025-09-09T12:06:00.000Z",
        "transactionAmount": {
          "amount": "24.56",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tang: T-202509-5058",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tang",
          "T-202509-5058"
        ],
        "debtorName": "Tang"
      },
      "paymentId": null,
      "reference": "T-202509-5058",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gseshspjyrwgx4ccwg",
      "clustering": {
        "description": "Tang",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tang' based on payment details",
        "updatedAt": "2025-09-09T12:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tang",
        "iban": "DE63358648076029736",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgmk8862vbm9",
      "createdAt": "2025-09-09T11:46:00.000Z",
      "updatedAt": "2025-09-09T11:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Jarek's Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1jbr01b0p2w",
      "fspDate": "2025-09-09T10:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1jbr01b0p2w",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T10:46:00.000Z",
        "valueDateTime": "2025-09-09T10:46:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Jarek's Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Jarek's Kitchen"
        ],
        "debtorName": "Jarek's Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9ynmeshspjjhrjb91rve",
      "clustering": {
        "description": "Jarek's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Jarek's Kitchen' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.102Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmngckzt772y",
      "createdAt": "2025-09-09T11:37:00.000Z",
      "updatedAt": "2025-09-09T11:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 0.01,
      "currency": "GBP",
      "description": "SEAPOINT FINANCE  LIMITED. Payment from Seapoint Finance Uk Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8e2kgf4tdz3",
      "fspDate": "2025-09-09T10:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8e2kgf4tdz3",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T10:37:00.000Z",
        "valueDateTime": "2025-09-09T10:37:00.000Z",
        "transactionAmount": {
          "amount": "0.01",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Seapoint Finance Uk Limited",
        "remittanceInformationUnstructuredArray": [
          "Payment from Seapoint Finance Uk Limited"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance Uk Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the sender name 'Seapoint Finance Uk Limited' from 'Payment from Seapoint Finance Uk Limited'",
        "updatedAt": "2025-09-29T18:25:48.639Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7s03xnv7nfwn75x8r7p82fv329",
      "createdAt": "2025-09-09T09:38:00.000Z",
      "updatedAt": "2025-09-09T09:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 684.66,
      "currency": "EUR",
      "description": "Payment to Denis Breen & Co: DB&-202509-8086",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_menfywbmwgk4w19ayt5kjsehem",
      "fspDate": "2025-09-09T08:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_menfywbmwgk4w19ayt5kjsehem",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T09:38:00.000Z",
        "valueDateTime": "2025-09-09T09:38:00.000Z",
        "transactionAmount": {
          "amount": "684.66",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Denis Breen & Co: DB&-202509-8086",
        "remittanceInformationUnstructuredArray": [
          "Payment to Denis Breen & Co",
          "DB&-202509-8086"
        ],
        "debtorName": "Denis Breen & Co"
      },
      "paymentId": null,
      "reference": "DB&-202509-8086",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zb1eshspj0854px1k2v",
      "clustering": {
        "description": "Denis Breen & Co",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Denis Breen & Co' based on payment details",
        "updatedAt": "2025-09-09T09:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Denis Breen & Co",
        "iban": "DE30579294626404388",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1tq7k78yjxyg2apcz0hyvqm93k",
      "createdAt": "2025-09-09T09:12:00.000Z",
      "updatedAt": "2025-09-09T09:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 228.61,
      "currency": "GBP",
      "description": "Payment to British Airways: BA-202509-5636",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_c6pq1xyp3vg7g4ycgfpkhf8f7q",
      "fspDate": "2025-09-09T08:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_c6pq1xyp3vg7g4ycgfpkhf8f7q",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T09:12:00.000Z",
        "valueDateTime": "2025-09-09T09:12:00.000Z",
        "transactionAmount": {
          "amount": "228.61",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to British Airways: BA-202509-5636",
        "remittanceInformationUnstructuredArray": [
          "Payment to British Airways",
          "BA-202509-5636"
        ],
        "debtorName": "British Airways"
      },
      "paymentId": null,
      "reference": "BA-202509-5636",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9m2fvhrjp2hhm5q9efq",
      "clustering": {
        "description": "British Airways",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'British Airways' based on payment details",
        "updatedAt": "2025-09-09T09:12:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "British Airways",
        "iban": null,
        "bic": null,
        "sortCode": "411938",
        "accountNumber": "58345760"
      }
    },
    {
      "id": "txn_swdgza523ekqtrc2fvhxwqnw37",
      "createdAt": "2025-09-09T08:49:00.000Z",
      "updatedAt": "2025-09-09T08:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5050,
      "currency": "GBP",
      "description": "Salary - Sophie O'Brien - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_qntyebvkxebg47chk6ek6phxbq",
      "fspDate": "2025-09-09T07:49:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_k794yye5n1gf468dk6phmap7yb",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T07:49:00.000Z",
        "valueDateTime": "2025-09-09T07:49:00.000Z",
        "transactionAmount": {
          "amount": "-5050.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Sophie O'Brien",
        "remittanceInformationUnstructuredArray": [
          "Salary - Sophie O'Brien"
        ]
      },
      "paymentId": "pmnt_5s6q4bd0m15kxpt8q6s69ma74t",
      "reference": "PAY-DEC-2025-O'BRIEN",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sophie O'Brien",
        "iban": null,
        "bic": null,
        "sortCode": "90-01-23",
        "accountNumber": "34567801"
      }
    },
    {
      "id": "txn_9ak4asncas1za2nydncde1h985",
      "createdAt": "2025-09-09T08:41:00.000Z",
      "updatedAt": "2025-09-09T08:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2846.3,
      "currency": "USD",
      "description": "Payment to Anthropic PBC: AP-202509-5352",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pvgt99ya36mf2488r4bryq5hd8",
      "fspDate": "2025-09-09T07:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pvgt99ya36mf2488r4bryq5hd8",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T08:41:00.000Z",
        "valueDateTime": "2025-09-09T08:41:00.000Z",
        "transactionAmount": {
          "amount": "2846.30",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic PBC: AP-202509-5352",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic PBC",
          "AP-202509-5352"
        ],
        "debtorName": "Anthropic PBC"
      },
      "paymentId": null,
      "reference": "AP-202509-5352",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_vnn6fxhm5daqv7bh39b88k2t9d",
      "clustering": {
        "description": "Anthropic PBC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic PBC' based on payment details",
        "updatedAt": "2025-09-09T08:41:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic PBC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6817q0nrrzhqmgqnxk0n7x9thg",
      "createdAt": "2025-09-09T08:07:00.000Z",
      "updatedAt": "2025-09-09T08:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.83,
      "currency": "EUR",
      "description": "Payment to Tortilla Latin Food: TLF-202509-4460",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vkfrxz6k7xp5h9y75dsg8y0fpm",
      "fspDate": "2025-09-09T07:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vkfrxz6k7xp5h9y75dsg8y0fpm",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T08:07:00.000Z",
        "valueDateTime": "2025-09-09T08:07:00.000Z",
        "transactionAmount": {
          "amount": "10.83",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tortilla Latin Food: TLF-202509-4460",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tortilla Latin Food",
          "TLF-202509-4460"
        ],
        "debtorName": "Tortilla Latin Food"
      },
      "paymentId": null,
      "reference": "TLF-202509-4460",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspgkeshspmp0mmzf2w0c",
      "clustering": {
        "description": "Tortilla Latin Food",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tortilla Latin Food' based on payment details",
        "updatedAt": "2025-09-09T08:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tortilla Latin Food",
        "iban": "DE99338037294154530",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgc3jzrp7any",
      "createdAt": "2025-09-09T08:06:00.000Z",
      "updatedAt": "2025-09-09T08:06:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.55,
      "currency": "EUR",
      "description": "Tula Mexican Grill 02",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk19z8dpqd3ce",
      "fspDate": "2025-09-09T07:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk19z8dpqd3ce",
        "bookingDate": "2025-09-09",
        "valueDate": "2025-09-09",
        "bookingDateTime": "2025-09-09T07:06:00.000Z",
        "valueDateTime": "2025-09-09T07:06:00.000Z",
        "transactionAmount": {
          "amount": "-12.55",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tula Mexican Grill 02",
        "remittanceInformationUnstructuredArray": [
          "Tula Mexican Grill 02"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Tula Mexican Grill' from 'Tula Mexican Grill 02', removing the location detail",
        "updatedAt": "2025-09-27T10:52:10.048Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspffjdjh3rzf4",
      "createdAt": "2025-09-08T12:03:00.000Z",
      "updatedAt": "2025-09-08T12:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4940.18,
      "currency": "EUR",
      "description": "Payment to Hugo Weber: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k10kr2bpe4dr6r1ezjtmjf98",
      "fspDate": "2025-09-08T11:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k10kr2bpe4dr6r1ezjtmjf98",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T13:59:00.000Z",
        "valueDateTime": "2025-12-04T13:59:00.000Z",
        "transactionAmount": {
          "amount": "-4940.18",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Hugo Weber: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Hugo Weber: July 2025 Payroll"
        ],
        "debtorName": "Hugo Weber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtteshspj9hmeqmzmdw",
      "clustering": {
        "description": "Hugo Weber",
        "confidenceScore": "0.95",
        "rationale": "Extracted employee name 'Hugo Weber' from 'Payment to Hugo Weber: July 2025 Payroll'",
        "updatedAt": "2025-09-27T10:48:02.770Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xexrxekyqed8pa4s7bj0q1eajj",
      "createdAt": "2025-09-08T10:17:00.000Z",
      "updatedAt": "2025-09-08T10:17:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5200,
      "currency": "GBP",
      "description": "Salary - David Kumar - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_9783kzj8qp2qme83nbrmzed00v",
      "fspDate": "2025-09-08T09:17:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_4etd8807ahv6ayzbzp8bbn9ds3",
        "bookingDate": "2025-09-08",
        "valueDate": "2025-09-08",
        "bookingDateTime": "2025-09-08T09:17:00.000Z",
        "valueDateTime": "2025-09-08T09:17:00.000Z",
        "transactionAmount": {
          "amount": "-5200.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - David Kumar",
        "remittanceInformationUnstructuredArray": [
          "Salary - David Kumar"
        ]
      },
      "paymentId": "pmnt_dh8tmh6k4tayn9q5mt83hftb79",
      "reference": "PAY-DEC-2025-KUMAR",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "David Kumar",
        "iban": null,
        "bic": null,
        "sortCode": "40-05-30",
        "accountNumber": "23456701"
      }
    },
    {
      "id": "txn_01k65c32y5eshspgdngaz4xwhd",
      "createdAt": "2025-09-08T08:55:00.000Z",
      "updatedAt": "2025-09-08T08:55:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1bnc8ged6yf",
      "fspDate": "2025-09-08T07:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1bnc8ged6yf",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T10:32:00.000Z",
        "valueDateTime": "2025-12-04T10:32:00.000Z",
        "transactionAmount": {
          "amount": "-25.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:52:10.121Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgj0f0bcqneb",
      "createdAt": "2025-09-08T07:28:00.000Z",
      "updatedAt": "2025-09-08T07:28:00.000Z",
      "status": "BOOKED",
      "type": "OTHER",
      "isCredit": false,
      "amount": 60,
      "currency": "EUR",
      "description": "Expenses app charges",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1eg6yhm4jmf",
      "fspDate": "2025-09-08T06:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1eg6yhm4jmf",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T15:00:00.000Z",
        "valueDateTime": "2026-01-10T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-60.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "OTHER",
        "remittanceInformationUnstructured": "Expenses app charges",
        "remittanceInformationUnstructuredArray": [
          "Expenses app charges"
        ],
        "debtorName": "Expenses App"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mw3eshspjaesn0nt38r",
      "clustering": {
        "description": "Expenses App",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Expenses App' from 'Expenses app charges'.",
        "updatedAt": "2025-09-27T10:52:47.463Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgcg1bw2a0v7",
      "createdAt": "2025-09-07T16:24:00.000Z",
      "updatedAt": "2025-09-07T16:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 21.99,
      "currency": "EUR",
      "description": "Google Play Apps",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1avrqzszejk",
      "fspDate": "2025-09-07T15:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1avrqzszejk",
        "bookingDate": "2025-09-07",
        "valueDate": "2025-09-07",
        "bookingDateTime": "2025-09-07T15:24:00.000Z",
        "valueDateTime": "2025-09-07T15:24:00.000Z",
        "transactionAmount": {
          "amount": "-21.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Google Play Apps",
        "remittanceInformationUnstructuredArray": [
          "Google Play Apps"
        ],
        "debtorName": "Google Play"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wjeeshsphy7nnkfq48b",
      "clustering": {
        "description": "Google Play",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Google Play' from 'Google Play Apps'",
        "updatedAt": "2025-09-27T10:52:10.089Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf4gft4wpw44",
      "createdAt": "2025-09-07T15:46:00.000Z",
      "updatedAt": "2025-09-07T15:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 132.12,
      "currency": "EUR",
      "description": "Figma",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1t1gjkcena8mn82235tqa6q",
      "fspDate": "2025-09-07T14:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1t1gjkcena8mn82235tqa6q",
        "bookingDate": "2025-12-28",
        "valueDate": "2025-12-28",
        "bookingDateTime": "2025-12-28T10:41:00.000Z",
        "valueDateTime": "2025-12-28T10:41:00.000Z",
        "transactionAmount": {
          "amount": "-132.12",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Figma",
        "remittanceInformationUnstructuredArray": [
          "Figma"
        ],
        "debtorName": "Figma"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdq3eshspk9qt2a4er00",
      "clustering": {
        "description": "Figma",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Figma' from the transaction description.",
        "updatedAt": "2025-09-27T10:43:55.534Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_g1wp9v5n7jaremvqkzx1xhx6wj",
      "createdAt": "2025-09-07T11:34:00.000Z",
      "updatedAt": "2025-09-07T11:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 455.55,
      "currency": "EUR",
      "description": "Payment to Company Formations International: CFI-202509-1921",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_aej9w97wadb1abzxx29z9k81dm",
      "fspDate": "2025-09-07T10:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_aej9w97wadb1abzxx29z9k81dm",
        "bookingDate": "2025-09-07",
        "valueDate": "2025-09-07",
        "bookingDateTime": "2025-09-07T11:34:00.000Z",
        "valueDateTime": "2025-09-07T11:34:00.000Z",
        "transactionAmount": {
          "amount": "455.55",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Company Formations International: CFI-202509-1921",
        "remittanceInformationUnstructuredArray": [
          "Payment to Company Formations International",
          "CFI-202509-1921"
        ],
        "debtorName": "Company Formations International"
      },
      "paymentId": null,
      "reference": "CFI-202509-1921",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cvstpeshspn39955xdf4m",
      "clustering": {
        "description": "Company Formations International",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Company Formations International' based on payment details",
        "updatedAt": "2025-09-07T11:34:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Company Formations International",
        "iban": "DE94506058245680050",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_eyp4n940kbr84jn97hb7wrx424",
      "createdAt": "2025-09-07T10:46:00.000Z",
      "updatedAt": "2025-09-07T10:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 99.15,
      "currency": "EUR",
      "description": "Payment to Attio: A-202509-2063",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2dtr1cm21mh7p0wgcwh7f458nh",
      "fspDate": "2025-09-07T09:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2dtr1cm21mh7p0wgcwh7f458nh",
        "bookingDate": "2025-09-07",
        "valueDate": "2025-09-07",
        "bookingDateTime": "2025-09-07T10:46:00.000Z",
        "valueDateTime": "2025-09-07T10:46:00.000Z",
        "transactionAmount": {
          "amount": "99.15",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Attio: A-202509-2063",
        "remittanceInformationUnstructuredArray": [
          "Payment to Attio",
          "A-202509-2063"
        ],
        "debtorName": "Attio"
      },
      "paymentId": null,
      "reference": "A-202509-2063",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspj5eshspmpcdfterchh",
      "clustering": {
        "description": "Attio",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Attio' based on payment details",
        "updatedAt": "2025-09-07T10:46:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Attio",
        "iban": "DE66658397744301960",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebzafvhrjmtygxcxxvc7",
      "createdAt": "2025-09-07T08:27:00.000Z",
      "updatedAt": "2025-09-07T08:27:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 206.71,
      "currency": "GBP",
      "description": "kiwi.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8kdn8yyjade",
      "fspDate": "2025-09-07T07:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8kdn8yyjade",
        "bookingDate": "2025-09-07",
        "valueDate": "2025-09-07",
        "bookingDateTime": "2025-09-07T07:27:00.000Z",
        "valueDateTime": "2025-09-07T07:27:00.000Z",
        "transactionAmount": {
          "amount": "-206.71",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "kiwi.com",
        "remittanceInformationUnstructuredArray": [
          "kiwi.com"
        ],
        "debtorName": "Kiwi.com"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9q1fvhrjp371wrcstvr",
      "clustering": {
        "description": "Kiwi.com",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Kiwi.com' from 'kiwi.com'",
        "updatedAt": "2025-09-29T18:26:41.010Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfv204fccebp",
      "createdAt": "2025-09-06T15:09:00.000Z",
      "updatedAt": "2025-09-06T15:09:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 103.3,
      "currency": "EUR",
      "description": "Superhuman",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0qsf7v3ferq",
      "fspDate": "2025-09-06T14:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0qsf7v3ferq",
        "bookingDate": "2025-09-06",
        "valueDate": "2025-09-06",
        "bookingDateTime": "2025-09-06T14:09:00.000Z",
        "valueDateTime": "2025-09-06T14:09:00.000Z",
        "transactionAmount": {
          "amount": "-103.30",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Superhuman",
        "remittanceInformationUnstructuredArray": [
          "Superhuman"
        ],
        "debtorName": "Superhuman"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5mceshspjzn83y9tqy1",
      "clustering": {
        "description": "Superhuman",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Superhuman' from 'Superhuman'",
        "updatedAt": "2025-09-27T10:50:08.330Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_tn52h44jxxndtpbk5g6jw3qkzx",
      "createdAt": "2025-09-06T11:31:00.000Z",
      "updatedAt": "2025-09-06T11:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 19565.29,
      "currency": "EUR",
      "description": "Payment from EuroTech Innovations - INV-202509-5433",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_v6k3knawc8vka3bekq6xtq36ha",
      "fspDate": "2025-09-06T10:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_v6k3knawc8vka3bekq6xtq36ha",
        "bookingDate": "2025-09-06",
        "valueDate": "2025-09-06",
        "bookingDateTime": "2025-09-06T11:31:00.000Z",
        "valueDateTime": "2025-09-06T11:31:00.000Z",
        "transactionAmount": {
          "amount": "19565.29",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from EuroTech Innovations - INV-202509-5433",
        "remittanceInformationUnstructuredArray": [
          "Payment from EuroTech Innovations",
          "INV-202509-5433"
        ],
        "creditorName": "EuroTech Innovations"
      },
      "paymentId": null,
      "reference": "INV-202509-5433",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m17gcz62vyhqqefr5q41a31k5f",
      "clustering": {
        "description": "EuroTech Innovations",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'EuroTech Innovations'",
        "updatedAt": "2025-09-06T11:31:00.000Z"
      },
      "payer": {
        "name": "EuroTech Innovations",
        "iban": "DE67841060074635580",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_43xz1pstkdhbn4g91vn7stq425",
      "createdAt": "2025-09-06T09:00:00.000Z",
      "updatedAt": "2025-09-06T09:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 75.42,
      "currency": "EUR",
      "description": "Payment to Retool: R-202509-2480",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zthrenecs89x2vy6h6ae2sfzqx",
      "fspDate": "2025-09-06T08:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zthrenecs89x2vy6h6ae2sfzqx",
        "bookingDate": "2025-09-06",
        "valueDate": "2025-09-06",
        "bookingDateTime": "2025-09-06T09:00:00.000Z",
        "valueDateTime": "2025-09-06T09:00:00.000Z",
        "transactionAmount": {
          "amount": "75.42",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Retool: R-202509-2480",
        "remittanceInformationUnstructuredArray": [
          "Payment to Retool",
          "R-202509-2480"
        ],
        "debtorName": "Retool"
      },
      "paymentId": null,
      "reference": "R-202509-2480",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdp6eshspk9a3b1e6677",
      "clustering": {
        "description": "Retool",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Retool' based on payment details",
        "updatedAt": "2025-09-06T09:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Retool",
        "iban": "DE15384589472287632",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspegs2vvtbwd3",
      "createdAt": "2025-09-05T16:28:00.000Z",
      "updatedAt": "2025-09-05T16:28:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 182.14,
      "currency": "EUR",
      "description": "Reflect Software Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3n8n6ekeh2tcar3twasxy4j",
      "fspDate": "2025-09-05T15:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n6ekeh2tcar3twasxy4j",
        "bookingDate": "2025-09-05",
        "valueDate": "2025-09-05",
        "bookingDateTime": "2025-09-05T15:28:00.000Z",
        "valueDateTime": "2025-09-05T15:28:00.000Z",
        "transactionAmount": {
          "amount": "-182.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Reflect Software Inc.",
        "remittanceInformationUnstructuredArray": [
          "Reflect Software Inc."
        ],
        "debtorName": "Reflect Software"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wfmeshsphxg0s376ywm",
      "clustering": {
        "description": "Reflect Software",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Reflect Software' from 'Reflect Software Inc.'.",
        "updatedAt": "2025-09-27T10:39:39.701Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph34wf9x80ak",
      "createdAt": "2025-09-05T15:49:00.000Z",
      "updatedAt": "2025-09-05T15:49:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk21641bm1z8p",
      "fspDate": "2025-09-05T14:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk21641bm1z8p",
        "bookingDate": "2025-09-05",
        "valueDate": "2025-09-05",
        "bookingDateTime": "2025-09-05T14:49:00.000Z",
        "valueDateTime": "2025-09-05T14:49:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:54:50.779Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfesk6k2e7zm",
      "createdAt": "2025-09-05T13:37:00.000Z",
      "updatedAt": "2025-09-05T13:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7733.85,
      "currency": "EUR",
      "description": "Payment to Cormac Byrne: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k10kr2cje4dr6r3ec7wap97x",
      "fspDate": "2025-09-05T12:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k10kr2cje4dr6r3ec7wap97x",
        "bookingDate": "2025-09-05",
        "valueDate": "2025-09-05",
        "bookingDateTime": "2025-09-05T12:37:00.000Z",
        "valueDateTime": "2025-09-05T12:37:00.000Z",
        "transactionAmount": {
          "amount": "-7733.85",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cormac Byrne: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cormac Byrne: July 2025 Payroll"
        ],
        "debtorName": "Cormac Byrne"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zspeshspj7tfmtn8s05",
      "clustering": {
        "description": "Cormac Byrne",
        "confidenceScore": "0.95",
        "rationale": "Extracted employee name 'Cormac Byrne' from 'Payment to Cormac Byrne: July 2025 Payroll'",
        "updatedAt": "2025-09-27T10:48:02.743Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfk11s9y7wmt",
      "createdAt": "2025-09-05T13:27:00.000Z",
      "updatedAt": "2025-09-05T13:27:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 141.79,
      "currency": "EUR",
      "description": "Kandji",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0rjbcknfq9r7n32cw42x5gd",
      "fspDate": "2025-09-05T12:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0rjbcknfq9r7n32cw42x5gd",
        "bookingDate": "2025-09-05",
        "valueDate": "2025-09-05",
        "bookingDateTime": "2025-09-05T12:27:00.000Z",
        "valueDateTime": "2025-09-05T12:27:00.000Z",
        "transactionAmount": {
          "amount": "-141.79",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Kandji",
        "remittanceInformationUnstructuredArray": [
          "Kandji"
        ],
        "debtorName": "Kandji"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax4veshspjmy8ae028r6",
      "clustering": {
        "description": "Kandji",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Kandji' from the transaction description",
        "updatedAt": "2025-09-27T10:49:04.311Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jftjhqv2237xxf1z013zgztaqe",
      "createdAt": "2025-09-05T10:38:00.000Z",
      "updatedAt": "2025-09-05T10:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 19564.69,
      "currency": "GBP",
      "description": "Payment from Innovation Partners - INV-202509-4056",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_afv5nyc46dgrjja7qx2vg07p9t",
      "fspDate": "2025-09-05T09:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_afv5nyc46dgrjja7qx2vg07p9t",
        "bookingDate": "2025-09-05",
        "valueDate": "2025-09-05",
        "bookingDateTime": "2025-09-05T10:38:00.000Z",
        "valueDateTime": "2025-09-05T10:38:00.000Z",
        "transactionAmount": {
          "amount": "19564.69",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Innovation Partners - INV-202509-4056",
        "remittanceInformationUnstructuredArray": [
          "Payment from Innovation Partners",
          "INV-202509-4056"
        ],
        "creditorName": "Innovation Partners"
      },
      "paymentId": null,
      "reference": "INV-202509-4056",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m4xtykg61y9kjq9cjdr8bewyz0",
      "clustering": {
        "description": "Innovation Partners",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Innovation Partners'",
        "updatedAt": "2025-09-05T10:38:00.000Z"
      },
      "payer": {
        "name": "Innovation Partners",
        "iban": null,
        "bic": null,
        "sortCode": "627537",
        "accountNumber": "89807465"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgqqhbavt0bt",
      "createdAt": "2025-09-05T09:16:00.000Z",
      "updatedAt": "2025-09-05T09:16:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.3,
      "currency": "EUR",
      "description": "An Post-Offices",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1nhf40be7q1",
      "fspDate": "2025-09-05T08:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1nhf40be7q1",
        "bookingDate": "2025-09-05",
        "valueDate": "2025-09-05",
        "bookingDateTime": "2025-09-05T08:16:00.000Z",
        "valueDateTime": "2025-09-05T08:16:00.000Z",
        "transactionAmount": {
          "amount": "-4.30",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "An Post-Offices",
        "remittanceInformationUnstructuredArray": [
          "An Post-Offices"
        ],
        "debtorName": "An Post"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwdneshspna9pr7b1tc2",
      "clustering": {
        "description": "An Post",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'An Post' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.247Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmn8wnjmbapv",
      "createdAt": "2025-09-04T16:07:00.000Z",
      "updatedAt": "2025-09-04T16:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1,
      "currency": "GBP",
      "description": "To Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8dsmjpg6bke",
      "fspDate": "2025-09-04T15:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8dsmjpg6bke",
        "bookingDate": "2025-09-04",
        "valueDate": "2025-09-04",
        "bookingDateTime": "2025-09-04T15:07:00.000Z",
        "valueDateTime": "2025-09-04T15:07:00.000Z",
        "transactionAmount": {
          "amount": "-1.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance UK Ltd"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Seapoint Finance UK Ltd' from 'To Seapoint Finance UK Ltd'",
        "updatedAt": "2025-09-29T18:25:48.629Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_cb1jyzyer28nhm6ya42gtg7t6q",
      "createdAt": "2025-09-04T13:32:00.000Z",
      "updatedAt": "2025-09-04T13:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 45.62,
      "currency": "GBP",
      "description": "Payment to Pembroke Hall Limited: PHL-202509-5085",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_za5pax3cvws0b9zd7dm982jvpq",
      "fspDate": "2025-09-04T12:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_za5pax3cvws0b9zd7dm982jvpq",
        "bookingDate": "2025-09-04",
        "valueDate": "2025-09-04",
        "bookingDateTime": "2025-09-04T13:32:00.000Z",
        "valueDateTime": "2025-09-04T13:32:00.000Z",
        "transactionAmount": {
          "amount": "45.62",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pembroke Hall Limited: PHL-202509-5085",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pembroke Hall Limited",
          "PHL-202509-5085"
        ],
        "debtorName": "Pembroke Hall Limited"
      },
      "paymentId": null,
      "reference": "PHL-202509-5085",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fpgn1yfzz9aex3cr77xa32",
      "clustering": {
        "description": "Pembroke Hall Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pembroke Hall Limited' based on payment details",
        "updatedAt": "2025-09-04T13:32:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pembroke Hall Limited",
        "iban": null,
        "bic": null,
        "sortCode": "622538",
        "accountNumber": "27970203"
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm35baxj3yz8",
      "createdAt": "2025-09-04T11:25:00.000Z",
      "updatedAt": "2025-09-04T11:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4690.75,
      "currency": "GBP",
      "description": "To Seapoint Finance Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3n8n7m0eh2tcb8y1pap2888",
      "fspDate": "2025-09-04T10:25:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n7m0eh2tcb8y1pap2888",
        "bookingDate": "2025-09-04",
        "valueDate": "2025-09-04",
        "bookingDateTime": "2025-09-04T10:25:00.000Z",
        "valueDateTime": "2025-09-04T10:25:00.000Z",
        "transactionAmount": {
          "amount": "-4690.75",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance Limited",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance Limited"
        ],
        "debtorName": "SEAPOINT FINANCE LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance' from 'To Seapoint Finance Limited', removing 'To ' prefix and 'Limited' suffix",
        "updatedAt": "2025-09-29T18:23:50.786Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pg1v62m8wkengdem0wbgzgsxdy",
      "createdAt": "2025-09-04T11:24:00.000Z",
      "updatedAt": "2025-09-04T11:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 91.56,
      "currency": "EUR",
      "description": "Payment to Irish Rail: IR-202509-5493",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_s45b7hpf9gm7rbfztfv43h5vwq",
      "fspDate": "2025-09-04T10:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_s45b7hpf9gm7rbfztfv43h5vwq",
        "bookingDate": "2025-09-04",
        "valueDate": "2025-09-04",
        "bookingDateTime": "2025-09-04T11:24:00.000Z",
        "valueDateTime": "2025-09-04T11:24:00.000Z",
        "transactionAmount": {
          "amount": "91.56",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Irish Rail: IR-202509-5493",
        "remittanceInformationUnstructuredArray": [
          "Payment to Irish Rail",
          "IR-202509-5493"
        ],
        "debtorName": "Irish Rail"
      },
      "paymentId": null,
      "reference": "IR-202509-5493",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax69eshspjn90xv3cz0y",
      "clustering": {
        "description": "Irish Rail",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Irish Rail' based on payment details",
        "updatedAt": "2025-09-04T11:24:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Irish Rail",
        "iban": "DE30854332887085224",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf2ecyzxwrvd",
      "createdAt": "2025-09-04T10:30:00.000Z",
      "updatedAt": "2025-09-04T10:30:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.55,
      "currency": "EUR",
      "description": "Tula Mexican Grill 02",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k24b3f6jfakarfmyz8nb1ybr",
      "fspDate": "2025-09-04T09:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k24b3f6jfakarfmyz8nb1ybr",
        "bookingDate": "2025-09-04",
        "valueDate": "2025-09-04",
        "bookingDateTime": "2025-09-04T09:30:00.000Z",
        "valueDateTime": "2025-09-04T09:30:00.000Z",
        "transactionAmount": {
          "amount": "-12.55",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tula Mexican Grill 02",
        "remittanceInformationUnstructuredArray": [
          "Tula Mexican Grill 02"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Tula Mexican Grill' from the transaction description, removing the '02' store number.",
        "updatedAt": "2025-09-27T10:43:55.461Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg7rgva8gkp6",
      "createdAt": "2025-09-03T15:30:00.000Z",
      "updatedAt": "2025-09-03T15:30:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1266.8,
      "currency": "EUR",
      "description": "Upwork -822800147ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk1527frv803t",
      "fspDate": "2025-09-03T14:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk1527frv803t",
        "bookingDate": "2025-09-03",
        "valueDate": "2025-09-03",
        "bookingDateTime": "2025-09-03T14:30:00.000Z",
        "valueDateTime": "2025-09-03T14:30:00.000Z",
        "transactionAmount": {
          "amount": "-1266.80",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -822800147ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -822800147ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Upwork' from 'Upwork -822800147ref', removing the '-822800147ref' suffix.",
        "updatedAt": "2025-09-27T10:51:38.271Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9c9yp2y06wepd7jke3zzm4pzeh",
      "createdAt": "2025-09-03T12:39:00.000Z",
      "updatedAt": "2025-09-03T12:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 543.2,
      "currency": "GBP",
      "description": "Payment to Ginger Bistro: GB-202509-8110",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_1dddegv269wshcbwvcsqmr49ne",
      "fspDate": "2025-09-03T11:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_1dddegv269wshcbwvcsqmr49ne",
        "bookingDate": "2025-09-03",
        "valueDate": "2025-09-03",
        "bookingDateTime": "2025-09-03T12:39:00.000Z",
        "valueDateTime": "2025-09-03T12:39:00.000Z",
        "transactionAmount": {
          "amount": "543.20",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Ginger Bistro: GB-202509-8110",
        "remittanceInformationUnstructuredArray": [
          "Payment to Ginger Bistro",
          "GB-202509-8110"
        ],
        "debtorName": "Ginger Bistro"
      },
      "paymentId": null,
      "reference": "GB-202509-8110",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk6skfvhrjntfdd23av1a",
      "clustering": {
        "description": "Ginger Bistro",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Ginger Bistro' based on payment details",
        "updatedAt": "2025-09-03T12:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Ginger Bistro",
        "iban": null,
        "bic": null,
        "sortCode": "378999",
        "accountNumber": "90053610"
      }
    },
    {
      "id": "txn_01k65c32y3eshspfvadecebprj",
      "createdAt": "2025-09-03T08:24:00.000Z",
      "updatedAt": "2025-09-03T08:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25.79,
      "currency": "EUR",
      "description": "Tavily Ai",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0r6gnwbvc1m",
      "fspDate": "2025-09-03T07:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0r6gnwbvc1m",
        "bookingDate": "2025-09-03",
        "valueDate": "2025-09-03",
        "bookingDateTime": "2025-09-03T07:24:00.000Z",
        "valueDateTime": "2025-09-03T07:24:00.000Z",
        "transactionAmount": {
          "amount": "-25.79",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tavily Ai",
        "remittanceInformationUnstructuredArray": [
          "Tavily Ai"
        ],
        "debtorName": "Tavily AI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ceerteshspk5wmka0h0ee",
      "clustering": {
        "description": "Tavily",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Tavily' from 'Tavily Ai'",
        "updatedAt": "2025-09-27T10:50:08.333Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1kpc93mpfp3wh9jb8wahqtbyc4",
      "createdAt": "2025-09-03T08:01:00.000Z",
      "updatedAt": "2025-09-03T08:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3452.2,
      "currency": "EUR",
      "description": "Payment to Pembroke Hall: PH-202509-3114",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0y4s1ezvk1ah25wwkrhbaravde",
      "fspDate": "2025-09-03T07:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0y4s1ezvk1ah25wwkrhbaravde",
        "bookingDate": "2025-09-03",
        "valueDate": "2025-09-03",
        "bookingDateTime": "2025-09-03T08:01:00.000Z",
        "valueDateTime": "2025-09-03T08:01:00.000Z",
        "transactionAmount": {
          "amount": "3452.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pembroke Hall: PH-202509-3114",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pembroke Hall",
          "PH-202509-3114"
        ],
        "debtorName": "Pembroke Hall"
      },
      "paymentId": null,
      "reference": "PH-202509-3114",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzdeshsphm46adfgbg7",
      "clustering": {
        "description": "Pembroke Hall",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pembroke Hall' based on payment details",
        "updatedAt": "2025-09-03T08:01:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pembroke Hall",
        "iban": "DE10379578815615562",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_634gjs3y4vbpq0ptvg52gn2754",
      "createdAt": "2025-09-02T15:17:00.000Z",
      "updatedAt": "2025-09-02T15:17:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6.73,
      "currency": "GBP",
      "description": "Payment to Pret A Manger: PAM-202509-8951",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_v599vkbwf08vkpes92anm70xcp",
      "fspDate": "2025-09-02T14:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_v599vkbwf08vkpes92anm70xcp",
        "bookingDate": "2025-09-02",
        "valueDate": "2025-09-02",
        "bookingDateTime": "2025-09-02T15:17:00.000Z",
        "valueDateTime": "2025-09-02T15:17:00.000Z",
        "transactionAmount": {
          "amount": "6.73",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pret A Manger: PAM-202509-8951",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pret A Manger",
          "PAM-202509-8951"
        ],
        "debtorName": "Pret A Manger"
      },
      "paymentId": null,
      "reference": "PAM-202509-8951",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crphqeshspmfftkxpt85b",
      "clustering": {
        "description": "Pret A Manger",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pret A Manger' based on payment details",
        "updatedAt": "2025-09-02T15:17:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pret A Manger",
        "iban": null,
        "bic": null,
        "sortCode": "207285",
        "accountNumber": "31208444"
      }
    },
    {
      "id": "txn_469jd57emwfvkwkpbhra99ts8t",
      "createdAt": "2025-09-02T11:26:00.000Z",
      "updatedAt": "2025-09-02T11:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3321.43,
      "currency": "GBP",
      "description": "Payment to Yapily: Y-202509-9957",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nznbz2y99jntjzvt6x6rzfwcba",
      "fspDate": "2025-09-02T10:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nznbz2y99jntjzvt6x6rzfwcba",
        "bookingDate": "2025-09-02",
        "valueDate": "2025-09-02",
        "bookingDateTime": "2025-09-02T11:26:00.000Z",
        "valueDateTime": "2025-09-02T11:26:00.000Z",
        "transactionAmount": {
          "amount": "3321.43",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Yapily: Y-202509-9957",
        "remittanceInformationUnstructuredArray": [
          "Payment to Yapily",
          "Y-202509-9957"
        ],
        "debtorName": "Yapily"
      },
      "paymentId": null,
      "reference": "Y-202509-9957",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf94qfvhrjn51jet0pt56",
      "clustering": {
        "description": "Yapily",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Yapily' based on payment details",
        "updatedAt": "2025-09-02T11:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Yapily",
        "iban": null,
        "bic": null,
        "sortCode": "867318",
        "accountNumber": "65880905"
      }
    },
    {
      "id": "txn_j0310vcrjzg237yk9ws2y4s40t",
      "createdAt": "2025-09-02T11:03:00.000Z",
      "updatedAt": "2025-09-02T11:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2137.55,
      "currency": "EUR",
      "description": "Payment to Bank of Ireland: BOI-202509-1194",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_aeey9ykvy4jz45tgc51ngy3p1p",
      "fspDate": "2025-09-02T10:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_aeey9ykvy4jz45tgc51ngy3p1p",
        "bookingDate": "2025-09-02",
        "valueDate": "2025-09-02",
        "bookingDateTime": "2025-09-02T11:03:00.000Z",
        "valueDateTime": "2025-09-02T11:03:00.000Z",
        "transactionAmount": {
          "amount": "2137.55",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bank of Ireland: BOI-202509-1194",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bank of Ireland",
          "BOI-202509-1194"
        ],
        "debtorName": "Bank of Ireland"
      },
      "paymentId": null,
      "reference": "BOI-202509-1194",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a24eshspnzbnpcam1v1",
      "clustering": {
        "description": "Bank of Ireland",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bank of Ireland' based on payment details",
        "updatedAt": "2025-09-02T11:03:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bank of Ireland",
        "iban": "DE81202312270260960",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6t0vn4cxkahxa2tfq0kcwvh3g4",
      "createdAt": "2025-09-01T11:30:00.000Z",
      "updatedAt": "2025-09-01T11:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 332.62,
      "currency": "GBP",
      "description": "Payment to Booking.com: B-202509-5488",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_92rx1gfq1sxr28x5nk8jdgr116",
      "fspDate": "2025-09-01T10:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_92rx1gfq1sxr28x5nk8jdgr116",
        "bookingDate": "2025-09-01",
        "valueDate": "2025-09-01",
        "bookingDateTime": "2025-09-01T11:30:00.000Z",
        "valueDateTime": "2025-09-01T11:30:00.000Z",
        "transactionAmount": {
          "amount": "332.62",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Booking.com: B-202509-5488",
        "remittanceInformationUnstructuredArray": [
          "Payment to Booking.com",
          "B-202509-5488"
        ],
        "debtorName": "Booking.com"
      },
      "paymentId": null,
      "reference": "B-202509-5488",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9p5fvhrjp2td9pd9rat",
      "clustering": {
        "description": "Booking.com",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Booking.com' based on payment details",
        "updatedAt": "2025-09-01T11:30:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Booking.com",
        "iban": null,
        "bic": null,
        "sortCode": "221405",
        "accountNumber": "54149114"
      }
    },
    {
      "id": "txn_k8rt5macwpbhq35k9s2gmfh5ht",
      "createdAt": "2025-08-31T15:20:00.000Z",
      "updatedAt": "2025-08-31T15:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 16269.82,
      "currency": "GBP",
      "description": "Payment from Innovation Partners - INV-202508-1433",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4hxfadnfw4k629wmhpgyf5sgzx",
      "fspDate": "2025-08-31T14:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4hxfadnfw4k629wmhpgyf5sgzx",
        "bookingDate": "2025-08-31",
        "valueDate": "2025-08-31",
        "bookingDateTime": "2025-08-31T15:20:00.000Z",
        "valueDateTime": "2025-08-31T15:20:00.000Z",
        "transactionAmount": {
          "amount": "16269.82",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Innovation Partners - INV-202508-1433",
        "remittanceInformationUnstructuredArray": [
          "Payment from Innovation Partners",
          "INV-202508-1433"
        ],
        "creditorName": "Innovation Partners"
      },
      "paymentId": null,
      "reference": "INV-202508-1433",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m4xtykg61y9kjq9cjdr8bewyz0",
      "clustering": {
        "description": "Innovation Partners",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Innovation Partners'",
        "updatedAt": "2025-08-31T15:20:00.000Z"
      },
      "payer": {
        "name": "Innovation Partners",
        "iban": null,
        "bic": null,
        "sortCode": "438037",
        "accountNumber": "58504718"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vd2err0ccxtmebd7q6y2b1qxze",
      "createdAt": "2025-08-31T14:05:00.000Z",
      "updatedAt": "2025-08-31T14:05:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 58.38,
      "currency": "GBP",
      "description": "Payment to Captain Nemo: CN-202508-5377",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_z2qftkmjp8b2efrnwft3s54ws9",
      "fspDate": "2025-08-31T13:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_z2qftkmjp8b2efrnwft3s54ws9",
        "bookingDate": "2025-08-31",
        "valueDate": "2025-08-31",
        "bookingDateTime": "2025-08-31T14:05:00.000Z",
        "valueDateTime": "2025-08-31T14:05:00.000Z",
        "transactionAmount": {
          "amount": "58.38",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Captain Nemo: CN-202508-5377",
        "remittanceInformationUnstructuredArray": [
          "Payment to Captain Nemo",
          "CN-202508-5377"
        ],
        "debtorName": "Captain Nemo"
      },
      "paymentId": null,
      "reference": "CN-202508-5377",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fm8nzsfzz9aen1pftqn9qr",
      "clustering": {
        "description": "Captain Nemo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Captain Nemo' based on payment details",
        "updatedAt": "2025-08-31T14:05:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Captain Nemo",
        "iban": null,
        "bic": null,
        "sortCode": "475954",
        "accountNumber": "76039212"
      }
    },
    {
      "id": "txn_c748zg261t1j1se0satw92b7wy",
      "createdAt": "2025-08-31T12:26:00.000Z",
      "updatedAt": "2025-08-31T12:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 11.91,
      "currency": "EUR",
      "description": "Payment to Mama's Boy: MB-202508-8921",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rhq8kh92bhe6gd97hyrewsnzmk",
      "fspDate": "2025-08-31T11:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rhq8kh92bhe6gd97hyrewsnzmk",
        "bookingDate": "2025-08-31",
        "valueDate": "2025-08-31",
        "bookingDateTime": "2025-08-31T12:26:00.000Z",
        "valueDateTime": "2025-08-31T12:26:00.000Z",
        "transactionAmount": {
          "amount": "11.91",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mama's Boy: MB-202508-8921",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mama's Boy",
          "MB-202508-8921"
        ],
        "debtorName": "Mama's Boy"
      },
      "paymentId": null,
      "reference": "MB-202508-8921",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcneshspna4jnfvyh0c",
      "clustering": {
        "description": "Mama's Boy",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mama's Boy' based on payment details",
        "updatedAt": "2025-08-31T12:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mama's Boy",
        "iban": "DE75386638089895070",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_j0cgg9qywstdc3vwacpextknqs",
      "createdAt": "2025-08-31T10:12:00.000Z",
      "updatedAt": "2025-08-31T10:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 96.99,
      "currency": "EUR",
      "description": "Payment to Attio: A-202508-4624",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_55qqftk6rxaccrrjngqng6f1wz",
      "fspDate": "2025-08-31T09:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_55qqftk6rxaccrrjngqng6f1wz",
        "bookingDate": "2025-08-31",
        "valueDate": "2025-08-31",
        "bookingDateTime": "2025-08-31T10:12:00.000Z",
        "valueDateTime": "2025-08-31T10:12:00.000Z",
        "transactionAmount": {
          "amount": "96.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Attio: A-202508-4624",
        "remittanceInformationUnstructuredArray": [
          "Payment to Attio",
          "A-202508-4624"
        ],
        "debtorName": "Attio"
      },
      "paymentId": null,
      "reference": "A-202508-4624",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspj5eshspmpcdfterchh",
      "clustering": {
        "description": "Attio",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Attio' based on payment details",
        "updatedAt": "2025-08-31T10:12:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Attio",
        "iban": "DE85966307461630980",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2zfvy9etj7qg8aknqbprnx76nf",
      "createdAt": "2025-08-30T13:55:00.000Z",
      "updatedAt": "2025-08-30T13:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.8,
      "currency": "USD",
      "description": "Payment to Reflect Software: RS-202508-4537",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wker1f5w0ge604g82amhdksrn2",
      "fspDate": "2025-08-30T12:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wker1f5w0ge604g82amhdksrn2",
        "bookingDate": "2025-08-30",
        "valueDate": "2025-08-30",
        "bookingDateTime": "2025-08-30T13:55:00.000Z",
        "valueDateTime": "2025-08-30T13:55:00.000Z",
        "transactionAmount": {
          "amount": "9.80",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Reflect Software: RS-202508-4537",
        "remittanceInformationUnstructuredArray": [
          "Payment to Reflect Software",
          "RS-202508-4537"
        ],
        "debtorName": "Reflect Software"
      },
      "paymentId": null,
      "reference": "RS-202508-4537",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wfmeshsphxg0s376ywm",
      "clustering": {
        "description": "Reflect Software",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Reflect Software' based on payment details",
        "updatedAt": "2025-08-30T13:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Reflect Software",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_rys4sg04gnr6ng3jec78gkpmsv",
      "createdAt": "2025-08-30T11:30:00.000Z",
      "updatedAt": "2025-08-30T11:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.07,
      "currency": "USD",
      "description": "Payment to Notion: N-202508-4303",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2z65r1r1bazkrtfz1sndkn1jn8",
      "fspDate": "2025-08-30T10:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2z65r1r1bazkrtfz1sndkn1jn8",
        "bookingDate": "2025-08-30",
        "valueDate": "2025-08-30",
        "bookingDateTime": "2025-08-30T11:30:00.000Z",
        "valueDateTime": "2025-08-30T11:30:00.000Z",
        "transactionAmount": {
          "amount": "10.07",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Notion: N-202508-4303",
        "remittanceInformationUnstructuredArray": [
          "Payment to Notion",
          "N-202508-4303"
        ],
        "debtorName": "Notion"
      },
      "paymentId": null,
      "reference": "N-202508-4303",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtcyeshspk6y0e76tesb",
      "clustering": {
        "description": "Notion",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Notion' based on payment details",
        "updatedAt": "2025-08-30T11:30:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Notion",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ypw50h8askrfq0vf5af371v0y4",
      "createdAt": "2025-08-30T10:55:00.000Z",
      "updatedAt": "2025-08-30T10:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5.03,
      "currency": "EUR",
      "description": "Payment to Expenses App: EA-202508-7949",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6c99fv0m9re3e3837h9c2c2tav",
      "fspDate": "2025-08-30T09:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6c99fv0m9re3e3837h9c2c2tav",
        "bookingDate": "2025-08-30",
        "valueDate": "2025-08-30",
        "bookingDateTime": "2025-08-30T10:55:00.000Z",
        "valueDateTime": "2025-08-30T10:55:00.000Z",
        "transactionAmount": {
          "amount": "5.03",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Expenses App: EA-202508-7949",
        "remittanceInformationUnstructuredArray": [
          "Payment to Expenses App",
          "EA-202508-7949"
        ],
        "debtorName": "Expenses App"
      },
      "paymentId": null,
      "reference": "EA-202508-7949",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mw3eshspjaesn0nt38r",
      "clustering": {
        "description": "Expenses App",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Expenses App' based on payment details",
        "updatedAt": "2025-08-30T10:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Expenses App",
        "iban": "DE39058032802201820",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_dhcmkmvaw5rcpt3wz65zzxn09t",
      "createdAt": "2025-08-29T14:45:00.000Z",
      "updatedAt": "2025-08-29T14:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.9,
      "currency": "EUR",
      "description": "Payment to Don Canizales: DC-202508-7160",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vrph9h6ysczkwyc8tvb8q6v75q",
      "fspDate": "2025-08-29T13:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vrph9h6ysczkwyc8tvb8q6v75q",
        "bookingDate": "2025-08-29",
        "valueDate": "2025-08-29",
        "bookingDateTime": "2025-08-29T14:45:00.000Z",
        "valueDateTime": "2025-08-29T14:45:00.000Z",
        "transactionAmount": {
          "amount": "14.90",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Don Canizales: DC-202508-7160",
        "remittanceInformationUnstructuredArray": [
          "Payment to Don Canizales",
          "DC-202508-7160"
        ],
        "debtorName": "Don Canizales"
      },
      "paymentId": null,
      "reference": "DC-202508-7160",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "clustering": {
        "description": "Don Canizales",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Don Canizales' based on payment details",
        "updatedAt": "2025-08-29T14:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Don Canizales",
        "iban": "DE98223237834022670",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgvm5j93ffh5",
      "createdAt": "2025-08-29T13:41:00.000Z",
      "updatedAt": "2025-08-29T13:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 48,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1rthbqt4n17",
      "fspDate": "2025-08-29T12:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1rthbqt4n17",
        "bookingDate": "2025-12-05",
        "valueDate": "2025-12-05",
        "bookingDateTime": "2025-12-05T13:32:00.000Z",
        "valueDateTime": "2025-12-05T13:32:00.000Z",
        "transactionAmount": {
          "amount": "-48.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Shaka Poke' from the raw transaction description, removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:53:55.698Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshspgy2w4m30411",
      "createdAt": "2025-08-29T13:15:00.000Z",
      "updatedAt": "2025-08-29T13:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2580.77,
      "currency": "EUR",
      "description": "To Marta Kowalska Consulting",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1v2hbpxq87y",
      "fspDate": "2025-08-29T12:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1v2hbpxq87y",
        "bookingDate": "2025-08-29",
        "valueDate": "2025-08-29",
        "bookingDateTime": "2025-08-29T12:15:00.000Z",
        "valueDateTime": "2025-08-29T12:15:00.000Z",
        "transactionAmount": {
          "amount": "-2580.77",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Marta Kowalska Consulting",
        "remittanceInformationUnstructuredArray": [
          "To Marta Kowalska Consulting"
        ],
        "debtorName": "Remote Europe Holding BV"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj39eshspnh92mjbyz8s",
      "clustering": {
        "description": "Marta Kowalska Consulting",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Marta Kowalska Consulting' from the raw transaction description, removing the 'To ' prefix.",
        "updatedAt": "2025-09-27T10:53:55.738Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qhd30ej29kz0n89bn0bq9zdqt8",
      "createdAt": "2025-08-29T12:55:00.000Z",
      "updatedAt": "2025-08-29T12:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3550,
      "currency": "GBP",
      "description": "Salary - Sean Kelly - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_p2vmhbkzjmrxyxjvh737pngtjq",
      "fspDate": "2025-08-29T11:55:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_tfvycpxnrskn0ddc46jv3azdrd",
        "bookingDate": "2025-08-29",
        "valueDate": "2025-08-29",
        "bookingDateTime": "2025-08-29T11:55:00.000Z",
        "valueDateTime": "2025-08-29T11:55:00.000Z",
        "transactionAmount": {
          "amount": "-3550.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Sean Kelly",
        "remittanceInformationUnstructuredArray": [
          "Salary - Sean Kelly"
        ]
      },
      "paymentId": "pmnt_frr7tbcj2nzag4wrqyzjy3q33v",
      "reference": "PAY-DEC-2025-KELLY",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sean Kelly",
        "iban": null,
        "bic": null,
        "sortCode": "90-01-23",
        "accountNumber": "21234567"
      }
    },
    {
      "id": "txn_01k65c32y3eshspfmrbctk7zqm",
      "createdAt": "2025-08-29T11:12:00.000Z",
      "updatedAt": "2025-08-29T11:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 5726,
      "currency": "EUR",
      "description": "REVENUE COMMISSION. Payment from Revenue Commission",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0gv54bwfq9r590ernf9qzxq",
      "fspDate": "2025-08-29T10:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0gv54bwfq9r590ernf9qzxq",
        "bookingDate": "2025-08-29",
        "valueDate": "2025-08-29",
        "bookingDateTime": "2025-08-29T10:12:00.000Z",
        "valueDateTime": "2025-08-29T10:12:00.000Z",
        "transactionAmount": {
          "amount": "5726.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Revenue Commission",
        "remittanceInformationUnstructuredArray": [
          "Payment from Revenue Commission"
        ],
        "debtorName": "REVENUE COMMISSION"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g53eshsphprhxzbraqp",
      "clustering": {
        "description": "Revenue Commission",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Revenue Commission' from 'Payment from Revenue Commission'",
        "updatedAt": "2025-09-27T10:49:37.588Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfgebp1jck0y",
      "createdAt": "2025-08-29T08:57:00.000Z",
      "updatedAt": "2025-08-29T08:57:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 37,
      "currency": "EUR",
      "description": "Sq *seoul Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k109hwkefk0b841hfedxzh6w",
      "fspDate": "2025-08-29T07:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k109hwkefk0b841hfedxzh6w",
        "bookingDate": "2025-08-29",
        "valueDate": "2025-08-29",
        "bookingDateTime": "2025-08-29T07:57:00.000Z",
        "valueDateTime": "2025-08-29T07:57:00.000Z",
        "transactionAmount": {
          "amount": "-37.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *seoul Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Sq *seoul Kitchen"
        ],
        "debtorName": "Seoul Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pzaeshspjhkemvf76tx",
      "clustering": {
        "description": "Seoul Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seoul Kitchen' from 'Sq *seoul Kitchen', removing Sq * prefix",
        "updatedAt": "2025-09-27T10:49:04.126Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspem9t97xsgc4",
      "createdAt": "2025-08-28T15:24:00.000Z",
      "updatedAt": "2025-08-28T15:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6585.52,
      "currency": "EUR",
      "description": "Payment to Leonie Schaffer: Aug 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3gc1m58e8prm029pgnpzpqz",
      "fspDate": "2025-08-28T14:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3gc1m58e8prm029pgnpzpqz",
        "bookingDate": "2025-08-28",
        "valueDate": "2025-08-28",
        "bookingDateTime": "2025-08-28T14:24:00.000Z",
        "valueDateTime": "2025-08-28T14:24:00.000Z",
        "transactionAmount": {
          "amount": "-6585.52",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Leonie Schaffer: Aug 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Leonie Schaffer: Aug 2025 Payroll"
        ],
        "debtorName": "Leonie Schaffer"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zs6eshspj7aqq6j2203",
      "clustering": {
        "description": "Leonie Schaffer",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Leonie Schaffer' from 'Payment to Leonie Schaffer: Aug 2025 Payroll'",
        "updatedAt": "2025-09-27T10:40:26.857Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmh179qe5zm3",
      "createdAt": "2025-08-28T12:39:00.000Z",
      "updatedAt": "2025-08-28T12:39:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 230.6,
      "currency": "GBP",
      "description": "Aer Lingus",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk89p656shgmc",
      "fspDate": "2025-08-28T11:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk89p656shgmc",
        "bookingDate": "2025-08-28",
        "valueDate": "2025-08-28",
        "bookingDateTime": "2025-08-28T11:39:00.000Z",
        "valueDateTime": "2025-08-28T11:39:00.000Z",
        "transactionAmount": {
          "amount": "-230.60",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Aer Lingus",
        "remittanceInformationUnstructuredArray": [
          "Aer Lingus"
        ],
        "debtorName": "Aer Lingus"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnekfvhrjnk2qd4ej2sf",
      "clustering": {
        "description": "Aer Lingus",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Aer Lingus' from the transaction description",
        "updatedAt": "2025-09-29T18:25:01.182Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2px4zmdhbnek8wccxsxfwbaawr",
      "createdAt": "2025-08-28T12:33:00.000Z",
      "updatedAt": "2025-08-28T12:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 828.82,
      "currency": "USD",
      "description": "Payment to GitHub, Inc.: GI-202508-9707",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_qc5mwn2gq62xh2w6s06bbf5vfv",
      "fspDate": "2025-08-28T11:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_qc5mwn2gq62xh2w6s06bbf5vfv",
        "bookingDate": "2025-08-28",
        "valueDate": "2025-08-28",
        "bookingDateTime": "2025-08-28T12:33:00.000Z",
        "valueDateTime": "2025-08-28T12:33:00.000Z",
        "transactionAmount": {
          "amount": "828.82",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GitHub, Inc.: GI-202508-9707",
        "remittanceInformationUnstructuredArray": [
          "Payment to GitHub, Inc.",
          "GI-202508-9707"
        ],
        "debtorName": "GitHub, Inc."
      },
      "paymentId": null,
      "reference": "GI-202508-9707",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_xj643cpp5p1awyrrqgqpf67q4d",
      "clustering": {
        "description": "GitHub, Inc.",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'GitHub, Inc.' based on payment details",
        "updatedAt": "2025-08-28T12:33:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GitHub, Inc.",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bjpnfy0b49z72r8qr02xgqkndh",
      "createdAt": "2025-08-28T10:55:00.000Z",
      "updatedAt": "2025-08-28T10:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6786.5,
      "currency": "EUR",
      "description": "Payment to Cormac Byrne: CB-202508-4259",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hcw1bkemnbrmheyvq4hpcqsat1",
      "fspDate": "2025-08-28T09:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hcw1bkemnbrmheyvq4hpcqsat1",
        "bookingDate": "2025-08-28",
        "valueDate": "2025-08-28",
        "bookingDateTime": "2025-08-28T10:55:00.000Z",
        "valueDateTime": "2025-08-28T10:55:00.000Z",
        "transactionAmount": {
          "amount": "6786.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cormac Byrne: CB-202508-4259",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cormac Byrne",
          "CB-202508-4259"
        ],
        "debtorName": "Cormac Byrne"
      },
      "paymentId": null,
      "reference": "CB-202508-4259",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zspeshspj7tfmtn8s05",
      "clustering": {
        "description": "Cormac Byrne",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cormac Byrne' based on payment details",
        "updatedAt": "2025-08-28T10:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cormac Byrne",
        "iban": "DE62110990072313064",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgegbwn23p8e",
      "createdAt": "2025-08-28T09:08:00.000Z",
      "updatedAt": "2025-08-28T09:08:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5314.9,
      "currency": "EUR",
      "description": "To Eoin Kelleher",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1cwq54g0g4z",
      "fspDate": "2025-08-28T08:08:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1cwq54g0g4z",
        "bookingDate": "2025-08-28",
        "valueDate": "2025-08-28",
        "bookingDateTime": "2025-08-28T08:08:00.000Z",
        "valueDateTime": "2025-08-28T08:08:00.000Z",
        "transactionAmount": {
          "amount": "-5314.90",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Eoin Kelleher",
        "remittanceInformationUnstructuredArray": [
          "To Eoin Kelleher"
        ],
        "debtorName": "Eoin Kelleher"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zrteshspj73enyj46qt",
      "clustering": {
        "description": "Eoin Kelleher",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Eoin Kelleher' from 'To Eoin Kelleher'.",
        "updatedAt": "2025-09-27T10:52:47.338Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zgcfzjzcz67qp1kg2kweq60kem",
      "createdAt": "2025-08-28T09:07:00.000Z",
      "updatedAt": "2025-08-28T09:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29.91,
      "currency": "EUR",
      "description": "Payment to Delhi2Dublin: D-202508-8644",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_8gmsq48yj6rczx9brtky8r3mhg",
      "fspDate": "2025-08-28T08:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_8gmsq48yj6rczx9brtky8r3mhg",
        "bookingDate": "2025-08-28",
        "valueDate": "2025-08-28",
        "bookingDateTime": "2025-08-28T09:07:00.000Z",
        "valueDateTime": "2025-08-28T09:07:00.000Z",
        "transactionAmount": {
          "amount": "29.91",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Delhi2Dublin: D-202508-8644",
        "remittanceInformationUnstructuredArray": [
          "Payment to Delhi2Dublin",
          "D-202508-8644"
        ],
        "debtorName": "Delhi2Dublin"
      },
      "paymentId": null,
      "reference": "D-202508-8644",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0x5eshspjwbxzrhs5dn",
      "clustering": {
        "description": "Delhi2Dublin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Delhi2Dublin' based on payment details",
        "updatedAt": "2025-08-28T09:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Delhi2Dublin",
        "iban": "DE89320974025927260",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph5m3wfnzfj9",
      "createdAt": "2025-08-28T08:27:00.000Z",
      "updatedAt": "2025-08-28T08:27:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk25wdavef969",
      "fspDate": "2025-08-28T07:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk25wdavef969",
        "bookingDate": "2025-08-28",
        "valueDate": "2025-08-28",
        "bookingDateTime": "2025-08-28T07:27:00.000Z",
        "valueDateTime": "2025-08-28T07:27:00.000Z",
        "transactionAmount": {
          "amount": "-2.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration Office",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Companies Registration Office' from 'Companies Registration'",
        "updatedAt": "2025-09-27T10:54:50.868Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgtqz31envgf",
      "createdAt": "2025-08-27T16:32:00.000Z",
      "updatedAt": "2025-08-27T16:32:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 27.25,
      "currency": "EUR",
      "description": "Tst-Tang-Cumberland-Pl",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1qhpzfgzzef",
      "fspDate": "2025-08-27T15:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1qhpzfgzzef",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T15:32:00.000Z",
        "valueDateTime": "2025-08-27T15:32:00.000Z",
        "transactionAmount": {
          "amount": "-27.25",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tst-Tang-Cumberland-Pl",
        "remittanceInformationUnstructuredArray": [
          "Tst-Tang-Cumberland-Pl"
        ],
        "debtorName": "Tang"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gseshspjyrwgx4ccwg",
      "clustering": {
        "description": "Tang",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Tang' from the raw transaction description, removing the 'Tst-Tang-Cumberland-Pl' suffix.",
        "updatedAt": "2025-09-27T10:53:55.681Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y8eshsph7ardmnjzhc",
      "createdAt": "2025-08-27T15:52:00.000Z",
      "updatedAt": "2025-08-27T15:52:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6585.53,
      "currency": "EUR",
      "description": "To Leonie Schaefer",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk256cqph3ycp",
      "fspDate": "2025-08-27T14:52:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk256cqph3ycp",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T14:52:00.000Z",
        "valueDateTime": "2025-08-27T14:52:00.000Z",
        "transactionAmount": {
          "amount": "-6585.53",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Leonie Schaefer",
        "remittanceInformationUnstructuredArray": [
          "To Leonie Schaefer"
        ],
        "debtorName": "Leonie Schaffer"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zs6eshspj7aqq6j2203",
      "clustering": {
        "description": "Leonie Schaefer",
        "confidenceScore": "0.95",
        "rationale": "Extracted core recipient name 'Leonie Schaefer' from 'To Leonie Schaefer'",
        "updatedAt": "2025-09-27T10:54:50.917Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9y1wkwwswr3fvw92hfkvyv0h2v",
      "createdAt": "2025-08-27T14:42:00.000Z",
      "updatedAt": "2025-08-27T14:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4250,
      "currency": "GBP",
      "description": "Payment to Amazon Web Services EMEA SARL: AWS-2025-847291",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_wnb606xqka2f0hqqdh2zq3k1b0",
      "fspDate": "2025-08-27T13:42:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_h71yz3x4mp2j0rhmd0jjrgq2px",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T15:00:00.000Z",
        "valueDateTime": "2026-01-10T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-4250.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amazon Web Services EMEA SARL: AWS-2025-847291",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amazon Web Services EMEA SARL: AWS-2025-847291"
        ],
        "debtorName": "Amazon Web Services EMEA SARL"
      },
      "paymentId": null,
      "reference": "AWS-2025-847291",
      "beneficiaryId": "benf_vy5tcadsq8hq6zp05dzeh2tatq",
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_zj7v3fq41pb9h3pwx6cbzwmfx4",
      "clustering": {
        "description": "Amazon Web Services EMEA SARL",
        "confidenceScore": "0.95",
        "rationale": "Identified as payment to Amazon Web Services EMEA SARL based on remittance information.",
        "updatedAt": "2025-12-15T10:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amazon Web Services EMEA SARL",
        "iban": "LU280000123456789012",
        "bic": "CITILULX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg32dg4ypeqs",
      "createdAt": "2025-08-27T12:48:00.000Z",
      "updatedAt": "2025-08-27T12:48:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 22.14,
      "currency": "EUR",
      "description": "Claude.ai Subscription",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0zc7bm7f03t",
      "fspDate": "2025-08-27T11:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0zc7bm7f03t",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T11:48:00.000Z",
        "valueDateTime": "2025-08-27T11:48:00.000Z",
        "transactionAmount": {
          "amount": "-22.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Claude.ai Subscription",
        "remittanceInformationUnstructuredArray": [
          "Claude.ai Subscription"
        ],
        "debtorName": "Claude.ai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5j1eshspjz017vq1wgn",
      "clustering": {
        "description": "Claude.ai",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Claude.ai' from 'Claude.ai Subscription'",
        "updatedAt": "2025-09-27T10:50:52.454Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_kxjbfjt9176vhmn0e8nq82dyz7",
      "createdAt": "2025-08-27T12:32:00.000Z",
      "updatedAt": "2025-08-27T12:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3456.92,
      "currency": "USD",
      "description": "Payment to OpenAI, LLC: OL-202508-3224",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nhrjnfttt5q414gb8pg06c99fx",
      "fspDate": "2025-08-27T11:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nhrjnfttt5q414gb8pg06c99fx",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T12:32:00.000Z",
        "valueDateTime": "2025-08-27T12:32:00.000Z",
        "transactionAmount": {
          "amount": "3456.92",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to OpenAI, LLC: OL-202508-3224",
        "remittanceInformationUnstructuredArray": [
          "Payment to OpenAI, LLC",
          "OL-202508-3224"
        ],
        "debtorName": "OpenAI, LLC"
      },
      "paymentId": null,
      "reference": "OL-202508-3224",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1bss5kk7dqrqznncrn6c0w8y4p",
      "clustering": {
        "description": "OpenAI, LLC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'OpenAI, LLC' based on payment details",
        "updatedAt": "2025-08-27T12:32:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "OpenAI, LLC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_j21jj1k3981wpr1htkmt7057ta",
      "createdAt": "2025-08-27T12:05:00.000Z",
      "updatedAt": "2025-08-27T12:05:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 587.33,
      "currency": "GBP",
      "description": "Payment to Ginger Bistro: GB-202508-6238",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ackkybpsvgq0shtz10dwwet7mw",
      "fspDate": "2025-08-27T11:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ackkybpsvgq0shtz10dwwet7mw",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T12:05:00.000Z",
        "valueDateTime": "2025-08-27T12:05:00.000Z",
        "transactionAmount": {
          "amount": "587.33",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Ginger Bistro: GB-202508-6238",
        "remittanceInformationUnstructuredArray": [
          "Payment to Ginger Bistro",
          "GB-202508-6238"
        ],
        "debtorName": "Ginger Bistro"
      },
      "paymentId": null,
      "reference": "GB-202508-6238",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk6skfvhrjntfdd23av1a",
      "clustering": {
        "description": "Ginger Bistro",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Ginger Bistro' based on payment details",
        "updatedAt": "2025-08-27T12:05:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Ginger Bistro",
        "iban": null,
        "bic": null,
        "sortCode": "666845",
        "accountNumber": "99373665"
      }
    },
    {
      "id": "txn_ytez56n7gkhhr46z2j748hfbjg",
      "createdAt": "2025-08-27T11:22:00.000Z",
      "updatedAt": "2025-08-27T11:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 48.51,
      "currency": "GBP",
      "description": "Payment to ICO: I-202508-5476",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ykyavf6msh4vek4z3d55wh1hc2",
      "fspDate": "2025-08-27T10:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ykyavf6msh4vek4z3d55wh1hc2",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T11:22:00.000Z",
        "valueDateTime": "2025-08-27T11:22:00.000Z",
        "transactionAmount": {
          "amount": "48.51",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to ICO: I-202508-5476",
        "remittanceInformationUnstructuredArray": [
          "Payment to ICO",
          "I-202508-5476"
        ],
        "debtorName": "ICO"
      },
      "paymentId": null,
      "reference": "I-202508-5476",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4gyfvhrjnsxtfs19v9b",
      "clustering": {
        "description": "ICO",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'ICO' based on payment details",
        "updatedAt": "2025-08-27T11:22:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "ICO",
        "iban": null,
        "bic": null,
        "sortCode": "214861",
        "accountNumber": "49615192"
      }
    },
    {
      "id": "txn_01k65c32y3eshspfwy6sv76tvx",
      "createdAt": "2025-08-27T10:17:00.000Z",
      "updatedAt": "2025-08-27T10:17:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Sumup *a Taste Of Tha",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0sgadyct1h5",
      "fspDate": "2025-08-27T09:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0sgadyct1h5",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T09:17:00.000Z",
        "valueDateTime": "2025-08-27T09:17:00.000Z",
        "transactionAmount": {
          "amount": "-14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *a Taste Of Tha",
        "remittanceInformationUnstructuredArray": [
          "Sumup *a Taste Of Tha"
        ],
        "debtorName": "A Taste of Thai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1m2eshspm6a6wp0a9jq",
      "clustering": {
        "description": "A Taste of Thai",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'A Taste of Thai' from 'Sumup *a Taste Of Tha'",
        "updatedAt": "2025-09-27T10:50:08.366Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_53dbb2tn23tnb0m7sj7xrpfe1j",
      "createdAt": "2025-08-27T09:37:00.000Z",
      "updatedAt": "2025-08-27T09:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 19380.01,
      "currency": "GBP",
      "description": "Payment from CloudFirst Technologies - INV-202508-3721",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w7p3dakkjnbn2yb4amb0m7fzgz",
      "fspDate": "2025-08-27T08:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w7p3dakkjnbn2yb4amb0m7fzgz",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T09:37:00.000Z",
        "valueDateTime": "2025-08-27T09:37:00.000Z",
        "transactionAmount": {
          "amount": "19380.01",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from CloudFirst Technologies - INV-202508-3721",
        "remittanceInformationUnstructuredArray": [
          "Payment from CloudFirst Technologies",
          "INV-202508-3721"
        ],
        "creditorName": "CloudFirst Technologies"
      },
      "paymentId": null,
      "reference": "INV-202508-3721",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_v3gga6hnqqf8p85ezhv67qxfkw",
      "clustering": {
        "description": "CloudFirst Technologies",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'CloudFirst Technologies'",
        "updatedAt": "2025-08-27T09:37:00.000Z"
      },
      "payer": {
        "name": "CloudFirst Technologies",
        "iban": null,
        "bic": null,
        "sortCode": "120204",
        "accountNumber": "24524565"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fq2szd9r367e83vcqrjpzefemh",
      "createdAt": "2025-08-27T09:28:00.000Z",
      "updatedAt": "2025-08-27T09:28:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.64,
      "currency": "EUR",
      "description": "Payment to XAI: X-202508-8978",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xnzvmp633e464t8f5hpp0v4e8h",
      "fspDate": "2025-08-27T08:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xnzvmp633e464t8f5hpp0v4e8h",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T09:28:00.000Z",
        "valueDateTime": "2025-08-27T09:28:00.000Z",
        "transactionAmount": {
          "amount": "25.64",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to XAI: X-202508-8978",
        "remittanceInformationUnstructuredArray": [
          "Payment to XAI",
          "X-202508-8978"
        ],
        "debtorName": "XAI"
      },
      "paymentId": null,
      "reference": "X-202508-8978",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgt8yeshspk60ezf5bsne",
      "clustering": {
        "description": "XAI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'XAI' based on payment details",
        "updatedAt": "2025-08-27T09:28:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "XAI",
        "iban": "DE94890263460618080",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgnt65swa56e",
      "createdAt": "2025-08-27T08:47:00.000Z",
      "updatedAt": "2025-08-27T08:47:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14.5,
      "currency": "EUR",
      "description": "Sumup *a Taste Of Tha",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1jwg698zmhq",
      "fspDate": "2025-08-27T07:47:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1jwg698zmhq",
        "bookingDate": "2025-12-12",
        "valueDate": "2025-12-12",
        "bookingDateTime": "2025-12-12T07:34:00.000Z",
        "valueDateTime": "2025-12-12T07:34:00.000Z",
        "transactionAmount": {
          "amount": "-14.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *a Taste Of Tha",
        "remittanceInformationUnstructuredArray": [
          "Sumup *a Taste Of Tha"
        ],
        "debtorName": "A Taste of Thai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1m2eshspm6a6wp0a9jq",
      "clustering": {
        "description": "A Taste of Thai",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'A Taste of Thai' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.151Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspewp88sywm05",
      "createdAt": "2025-08-27T07:42:00.000Z",
      "updatedAt": "2025-08-27T07:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 8.6,
      "currency": "EUR",
      "description": "Finom",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2pbwp66fzwbe0wg82p0apmr",
      "fspDate": "2025-08-27T06:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2pbwp66fzwbe0wg82p0apmr",
        "bookingDate": "2025-08-27",
        "valueDate": "2025-08-27",
        "bookingDateTime": "2025-08-27T06:42:00.000Z",
        "valueDateTime": "2025-08-27T06:42:00.000Z",
        "transactionAmount": {
          "amount": "-8.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Finom",
        "remittanceInformationUnstructuredArray": [
          "Finom"
        ],
        "debtorName": "Finom"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0yxeshspjws0xeeqa1k",
      "clustering": {
        "description": "Finom",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Finom' from 'Finom'",
        "updatedAt": "2025-09-27T10:42:40.334Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmk0cry0zfwj",
      "createdAt": "2025-08-26T13:48:00.000Z",
      "updatedAt": "2025-08-26T13:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4690,
      "currency": "GBP",
      "description": "To Modulr Finance Limited GBP",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8bmcdy9skwb",
      "fspDate": "2025-08-26T12:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8bmcdy9skwb",
        "bookingDate": "2025-08-26",
        "valueDate": "2025-08-26",
        "bookingDateTime": "2025-08-26T12:48:00.000Z",
        "valueDateTime": "2025-08-26T12:48:00.000Z",
        "transactionAmount": {
          "amount": "-4690.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Modulr Finance Limited GBP",
        "remittanceInformationUnstructuredArray": [
          "To Modulr Finance Limited GBP"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Modulr Finance Limited' from 'To Modulr Finance Limited GBP'",
        "updatedAt": "2025-09-29T18:25:48.551Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3r90exf9j8f7trvc0jrjf86d6z",
      "createdAt": "2025-08-26T13:03:00.000Z",
      "updatedAt": "2025-08-26T13:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6403.99,
      "currency": "EUR",
      "description": "Payment to Jonas Novak: JN-202508-8679",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5bx5e7cytkc1bx3sj8x56gjeyh",
      "fspDate": "2025-08-26T12:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5bx5e7cytkc1bx3sj8x56gjeyh",
        "bookingDate": "2025-08-26",
        "valueDate": "2025-08-26",
        "bookingDateTime": "2025-08-26T13:03:00.000Z",
        "valueDateTime": "2025-08-26T13:03:00.000Z",
        "transactionAmount": {
          "amount": "6403.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jonas Novak: JN-202508-8679",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jonas Novak",
          "JN-202508-8679"
        ],
        "debtorName": "Jonas Novak"
      },
      "paymentId": null,
      "reference": "JN-202508-8679",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x01eshsphmk5k2axdrt",
      "clustering": {
        "description": "Jonas Novak",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Jonas Novak' based on payment details",
        "updatedAt": "2025-08-26T13:03:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Jonas Novak",
        "iban": "DE89571031025050240",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_72s9t36m65yg0t6p5bw24qy6je",
      "createdAt": "2025-08-26T10:14:00.000Z",
      "updatedAt": "2025-08-26T10:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6.03,
      "currency": "EUR",
      "description": "Payment to Spar: S-202508-6108",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_30tkp4g3jhn4zj6r15j5vp4nnb",
      "fspDate": "2025-08-26T09:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_30tkp4g3jhn4zj6r15j5vp4nnb",
        "bookingDate": "2025-08-26",
        "valueDate": "2025-08-26",
        "bookingDateTime": "2025-08-26T10:14:00.000Z",
        "valueDateTime": "2025-08-26T10:14:00.000Z",
        "transactionAmount": {
          "amount": "6.03",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Spar: S-202508-6108",
        "remittanceInformationUnstructuredArray": [
          "Payment to Spar",
          "S-202508-6108"
        ],
        "debtorName": "Spar"
      },
      "paymentId": null,
      "reference": "S-202508-6108",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g32eshsphp8z5k4nrvg",
      "clustering": {
        "description": "Spar",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Spar' based on payment details",
        "updatedAt": "2025-08-26T10:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Spar",
        "iban": "DE38361967941187200",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph47c1e9q65z",
      "createdAt": "2025-08-26T09:34:00.000Z",
      "updatedAt": "2025-08-26T09:34:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 15470.12,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk21a3xnkqc3v",
      "fspDate": "2025-08-26T08:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk21a3xnkqc3v",
        "bookingDate": "2025-12-14",
        "valueDate": "2025-12-14",
        "bookingDateTime": "2025-12-14T09:38:00.000Z",
        "valueDateTime": "2025-12-14T09:38:00.000Z",
        "transactionAmount": {
          "amount": "-15470.12",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange as the merchant name for the currency conversion transaction based on the 'EXCHANGE' code",
        "updatedAt": "2025-09-27T10:54:50.816Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjmaje80cy1mk",
      "createdAt": "2025-08-26T08:24:00.000Z",
      "updatedAt": "2025-08-26T08:24:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 8306.17,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk835r86ww0wd",
      "fspDate": "2025-08-26T07:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk835r86ww0wd",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T13:00:00.000Z",
        "valueDateTime": "2026-01-13T13:00:00.000Z",
        "transactionAmount": {
          "amount": "8306.17",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code and extracted 'Currency Exchange' as the description",
        "updatedAt": "2025-09-29T18:24:29.667Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfr24zjymv19",
      "createdAt": "2025-08-25T14:59:00.000Z",
      "updatedAt": "2025-08-25T14:59:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 7000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg246ze8pvk0m5earjsbk4",
      "fspDate": "2025-08-25T13:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg246ze8pvk0m5earjsbk4",
        "bookingDate": "2025-08-25",
        "valueDate": "2025-08-25",
        "bookingDateTime": "2025-08-25T13:59:00.000Z",
        "valueDateTime": "2025-08-25T13:59:00.000Z",
        "transactionAmount": {
          "amount": "-7000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the description for a currency conversion transaction with code 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:49:37.704Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm8kh2kngr90",
      "createdAt": "2025-08-25T11:16:00.000Z",
      "updatedAt": "2025-08-25T11:16:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 4667.7,
      "currency": "GBP",
      "description": "SEAPOINT FINANCE  LIMITED. Payment from Seapoint Finance Uk Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0xwbp37fq9r9arxbch1f4d7",
      "fspDate": "2025-08-25T10:16:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xwbp37fq9r9arxbch1f4d7",
        "bookingDate": "2025-08-25",
        "valueDate": "2025-08-25",
        "bookingDateTime": "2025-08-25T10:16:00.000Z",
        "valueDateTime": "2025-08-25T10:16:00.000Z",
        "transactionAmount": {
          "amount": "4667.70",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Seapoint Finance Uk Limited",
        "remittanceInformationUnstructuredArray": [
          "Payment from Seapoint Finance Uk Limited"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance Uk Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Seapoint Finance Uk Limited' from 'Payment from Seapoint Finance Uk Limited'",
        "updatedAt": "2025-09-29T18:24:29.627Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgka1d47ng98",
      "createdAt": "2025-08-25T09:14:00.000Z",
      "updatedAt": "2025-08-25T09:14:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1hd3esc5t6k",
      "fspDate": "2025-08-25T08:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1hd3esc5t6k",
        "bookingDate": "2025-08-25",
        "valueDate": "2025-08-25",
        "bookingDateTime": "2025-08-25T08:14:00.000Z",
        "valueDateTime": "2025-08-25T08:14:00.000Z",
        "transactionAmount": {
          "amount": "-2.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Companies Registration' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.030Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph2n1zwz0c1v",
      "createdAt": "2025-08-24T15:44:00.000Z",
      "updatedAt": "2025-08-24T15:44:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 93.6,
      "currency": "EUR",
      "description": "zapier.com/charge",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk20ahxec4e0t",
      "fspDate": "2025-08-24T14:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk20ahxec4e0t",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T08:00:00.000Z",
        "valueDateTime": "2026-01-05T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-93.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "zapier.com/charge",
        "remittanceInformationUnstructuredArray": [
          "zapier.com/charge"
        ],
        "debtorName": "Zapier"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2aeshspkg92jdy8vh4",
      "clustering": {
        "description": "Zapier",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zapier' from 'zapier.com/charge'",
        "updatedAt": "2025-09-27T10:54:50.772Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_b7k8fhw4b3zfxckx893hq2dt43",
      "createdAt": "2025-08-24T11:09:00.000Z",
      "updatedAt": "2025-08-24T11:09:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 256.38,
      "currency": "EUR",
      "description": "Payment to Bang Restaurant: BR-202508-4129",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_r7b9cvtvhqexn4512k08bqapqn",
      "fspDate": "2025-08-24T10:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_r7b9cvtvhqexn4512k08bqapqn",
        "bookingDate": "2025-08-24",
        "valueDate": "2025-08-24",
        "bookingDateTime": "2025-08-24T11:09:00.000Z",
        "valueDateTime": "2025-08-24T11:09:00.000Z",
        "transactionAmount": {
          "amount": "256.38",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bang Restaurant: BR-202508-4129",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bang Restaurant",
          "BR-202508-4129"
        ],
        "debtorName": "Bang Restaurant"
      },
      "paymentId": null,
      "reference": "BR-202508-4129",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpk3eshspmfgtm6vkpxj",
      "clustering": {
        "description": "Bang Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bang Restaurant' based on payment details",
        "updatedAt": "2025-08-24T11:09:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bang Restaurant",
        "iban": "DE74405697618980080",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_75hefegk205ffqf8xh5dft9847",
      "createdAt": "2025-08-24T10:48:00.000Z",
      "updatedAt": "2025-08-24T10:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 15702.11,
      "currency": "EUR",
      "description": "Payment from Alpine Software SA - INV-202508-8864",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_e0hnqje2ks97d4ba5rtmj1xphp",
      "fspDate": "2025-08-24T09:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_e0hnqje2ks97d4ba5rtmj1xphp",
        "bookingDate": "2025-08-24",
        "valueDate": "2025-08-24",
        "bookingDateTime": "2025-08-24T10:48:00.000Z",
        "valueDateTime": "2025-08-24T10:48:00.000Z",
        "transactionAmount": {
          "amount": "15702.11",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Alpine Software SA - INV-202508-8864",
        "remittanceInformationUnstructuredArray": [
          "Payment from Alpine Software SA",
          "INV-202508-8864"
        ],
        "creditorName": "Alpine Software SA"
      },
      "paymentId": null,
      "reference": "INV-202508-8864",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_nk7g93a6fpe8ybm4hppdmmfgsw",
      "clustering": {
        "description": "Alpine Software SA",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Alpine Software SA'",
        "updatedAt": "2025-08-24T10:48:00.000Z"
      },
      "payer": {
        "name": "Alpine Software SA",
        "iban": "DE78780466485406560",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspezmndmhpgmg",
      "createdAt": "2025-08-23T14:47:00.000Z",
      "updatedAt": "2025-08-23T14:47:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1510.38,
      "currency": "EUR",
      "description": "Upwork -835837986ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2empapqfk7s2z0pv73wwmkp",
      "fspDate": "2025-08-23T13:47:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2empapqfk7s2z0pv73wwmkp",
        "bookingDate": "2025-08-23",
        "valueDate": "2025-08-23",
        "bookingDateTime": "2025-08-23T13:47:00.000Z",
        "valueDateTime": "2025-08-23T13:47:00.000Z",
        "transactionAmount": {
          "amount": "-1510.38",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -835837986ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -835837986ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Upwork' from 'Upwork -835837986ref'",
        "updatedAt": "2025-09-27T10:42:40.415Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph3asms0db50",
      "createdAt": "2025-08-23T14:20:00.000Z",
      "updatedAt": "2025-08-23T14:20:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk21xjz5e5mka",
      "fspDate": "2025-08-23T13:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk21xjz5e5mka",
        "bookingDate": "2025-08-23",
        "valueDate": "2025-08-23",
        "bookingDateTime": "2025-08-23T13:20:00.000Z",
        "valueDateTime": "2025-08-23T13:20:00.000Z",
        "transactionAmount": {
          "amount": "-2.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration Office",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Companies Registration Office' from 'Companies Registration'",
        "updatedAt": "2025-09-27T10:54:50.792Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf7fwc5krj00",
      "createdAt": "2025-08-23T13:55:00.000Z",
      "updatedAt": "2025-08-23T13:55:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 24,
      "currency": "EUR",
      "description": "Sq *seoul Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1jaadqbfk0vtsrqazn3fqgt",
      "fspDate": "2025-08-23T12:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1jaadqbfk0vtsrqazn3fqgt",
        "bookingDate": "2025-08-23",
        "valueDate": "2025-08-23",
        "bookingDateTime": "2025-08-23T12:55:00.000Z",
        "valueDateTime": "2025-08-23T12:55:00.000Z",
        "transactionAmount": {
          "amount": "-24.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *seoul Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Sq *seoul Kitchen"
        ],
        "debtorName": "Seoul Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pzaeshspjhkemvf76tx",
      "clustering": {
        "description": "Seoul Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Seoul Kitchen' from 'Sq *seoul Kitchen', removing the Sq * prefix",
        "updatedAt": "2025-09-27T10:45:11.536Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_dt0y3dfwcn0q1hgkcpfr29ttez",
      "createdAt": "2025-08-23T13:13:00.000Z",
      "updatedAt": "2025-08-23T13:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5700,
      "currency": "GBP",
      "description": "Salary - Rebecca Williams - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_kvp5jhpw6m8hz7vnss4w4ce5zw",
      "fspDate": "2025-08-23T12:13:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_z43p7rv02wvwa1erwvnqmzrpqw",
        "bookingDate": "2025-12-05",
        "valueDate": "2025-12-05",
        "bookingDateTime": "2025-12-05T13:35:00.000Z",
        "valueDateTime": "2025-12-05T13:35:00.000Z",
        "transactionAmount": {
          "amount": "-5700.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Rebecca Williams",
        "remittanceInformationUnstructuredArray": [
          "Salary - Rebecca Williams"
        ]
      },
      "paymentId": "pmnt_9jmbpvrjbyhnnfayk15f8q2r8t",
      "reference": "PAY-DEC-2025-WILLIAMS",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Rebecca Williams",
        "iban": null,
        "bic": null,
        "sortCode": "40-05-30",
        "accountNumber": "78901234"
      }
    },
    {
      "id": "txn_w54bgkckw1eydsb498gdwtrq0x",
      "createdAt": "2025-08-23T12:20:00.000Z",
      "updatedAt": "2025-08-23T12:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 31.96,
      "currency": "EUR",
      "description": "Payment to Sentry: S-202508-2824",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ef1qgfv4b7j4e7799s0v0rncaa",
      "fspDate": "2025-08-23T11:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ef1qgfv4b7j4e7799s0v0rncaa",
        "bookingDate": "2025-08-23",
        "valueDate": "2025-08-23",
        "bookingDateTime": "2025-08-23T12:20:00.000Z",
        "valueDateTime": "2025-08-23T12:20:00.000Z",
        "transactionAmount": {
          "amount": "31.96",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sentry: S-202508-2824",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sentry",
          "S-202508-2824"
        ],
        "debtorName": "Sentry"
      },
      "paymentId": null,
      "reference": "S-202508-2824",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdn2eshspk97jdcm57ef",
      "clustering": {
        "description": "Sentry",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sentry' based on payment details",
        "updatedAt": "2025-08-23T12:20:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sentry",
        "iban": "DE61152043020569230",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_snmpknk72e17sb9apstanzwaav",
      "createdAt": "2025-08-23T10:58:00.000Z",
      "updatedAt": "2025-08-23T10:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 32423.51,
      "currency": "GBP",
      "description": "Payment from TechCorp Industries - INV-202508-2903",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_v08j6xvrhnj6td14swr5g747zd",
      "fspDate": "2025-08-23T09:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_v08j6xvrhnj6td14swr5g747zd",
        "bookingDate": "2025-08-23",
        "valueDate": "2025-08-23",
        "bookingDateTime": "2025-08-23T10:58:00.000Z",
        "valueDateTime": "2025-08-23T10:58:00.000Z",
        "transactionAmount": {
          "amount": "32423.51",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from TechCorp Industries - INV-202508-2903",
        "remittanceInformationUnstructuredArray": [
          "Payment from TechCorp Industries",
          "INV-202508-2903"
        ],
        "creditorName": "TechCorp Industries"
      },
      "paymentId": null,
      "reference": "INV-202508-2903",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_hkz708jvra375hd19t65j65vvt",
      "clustering": {
        "description": "TechCorp Industries",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'TechCorp Industries'",
        "updatedAt": "2025-08-23T10:58:00.000Z"
      },
      "payer": {
        "name": "TechCorp Industries",
        "iban": null,
        "bic": null,
        "sortCode": "498495",
        "accountNumber": "60800064"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmr5707t1xt9",
      "createdAt": "2025-08-22T15:32:00.000Z",
      "updatedAt": "2025-08-22T15:32:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25,
      "currency": "GBP",
      "description": "www.heathrowexpress.co",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8gytstk83gn",
      "fspDate": "2025-08-22T14:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8gytstk83gn",
        "bookingDate": "2025-08-22",
        "valueDate": "2025-08-22",
        "bookingDateTime": "2025-08-22T14:32:00.000Z",
        "valueDateTime": "2025-08-22T14:32:00.000Z",
        "transactionAmount": {
          "amount": "-25.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "www.heathrowexpress.co",
        "remittanceInformationUnstructuredArray": [
          "www.heathrowexpress.co"
        ],
        "debtorName": "Heathrow Express"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpg2eshspmf0nznfw91y",
      "clustering": {
        "description": "Heathrow Express",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Heathrow Express' from 'www.heathrowexpress.co'",
        "updatedAt": "2025-09-29T18:26:40.965Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zctre8w7f3af9edh0vrqvxsmyx",
      "createdAt": "2025-08-22T15:31:00.000Z",
      "updatedAt": "2025-08-22T15:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 8.9,
      "currency": "EUR",
      "description": "Payment to Beanhive: B-202508-7553",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_44aw7pea209a6xd98sfrcefzbv",
      "fspDate": "2025-08-22T14:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_44aw7pea209a6xd98sfrcefzbv",
        "bookingDate": "2025-08-22",
        "valueDate": "2025-08-22",
        "bookingDateTime": "2025-08-22T15:31:00.000Z",
        "valueDateTime": "2025-08-22T15:31:00.000Z",
        "transactionAmount": {
          "amount": "8.90",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Beanhive: B-202508-7553",
        "remittanceInformationUnstructuredArray": [
          "Payment to Beanhive",
          "B-202508-7553"
        ],
        "debtorName": "Beanhive"
      },
      "paymentId": null,
      "reference": "B-202508-7553",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmacweshspkk5mv2ktdq4",
      "clustering": {
        "description": "Beanhive",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Beanhive' based on payment details",
        "updatedAt": "2025-08-22T15:31:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Beanhive",
        "iban": "DE11975668559257084",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_j4dmqv725cp7exq629brtghm09",
      "createdAt": "2025-08-22T12:51:00.000Z",
      "updatedAt": "2025-08-22T12:51:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2280.48,
      "currency": "EUR",
      "description": "Payment to Bank of Ireland: BOI-202508-8460",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_q3qhvz1d3r6x4zmyb4seys3xh1",
      "fspDate": "2025-08-22T11:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_q3qhvz1d3r6x4zmyb4seys3xh1",
        "bookingDate": "2025-08-22",
        "valueDate": "2025-08-22",
        "bookingDateTime": "2025-08-22T12:51:00.000Z",
        "valueDateTime": "2025-08-22T12:51:00.000Z",
        "transactionAmount": {
          "amount": "2280.48",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bank of Ireland: BOI-202508-8460",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bank of Ireland",
          "BOI-202508-8460"
        ],
        "debtorName": "Bank of Ireland"
      },
      "paymentId": null,
      "reference": "BOI-202508-8460",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a24eshspnzbnpcam1v1",
      "clustering": {
        "description": "Bank of Ireland",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bank of Ireland' based on payment details",
        "updatedAt": "2025-08-22T12:51:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bank of Ireland",
        "iban": "DE36487058830843540",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgtexka2ct04",
      "createdAt": "2025-08-22T10:58:00.000Z",
      "updatedAt": "2025-08-22T10:58:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 28,
      "currency": "EUR",
      "description": "Frn*hold.free-Now.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1q2e5ysgnej",
      "fspDate": "2025-08-22T09:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1q2e5ysgnej",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T07:00:00.000Z",
        "valueDateTime": "2026-01-09T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-28.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Frn*hold.free-Now.com",
        "remittanceInformationUnstructuredArray": [
          "Frn*hold.free-Now.com"
        ],
        "debtorName": "Free Now"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj31eshspnh3qzqhcd5r",
      "clustering": {
        "description": "Free Now",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Free Now' from the raw transaction description, removing the 'Frn*hold.free-Now.com' prefix.",
        "updatedAt": "2025-09-27T10:53:55.673Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgcdcmaqw21d",
      "createdAt": "2025-08-22T10:29:00.000Z",
      "updatedAt": "2025-08-22T10:29:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 103,
      "currency": "EUR",
      "description": "giftmall.es",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1a1dkbx7qsd",
      "fspDate": "2025-08-22T09:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1a1dkbx7qsd",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T12:00:00.000Z",
        "valueDateTime": "2026-01-07T12:00:00.000Z",
        "transactionAmount": {
          "amount": "-103.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "giftmall.es",
        "remittanceInformationUnstructuredArray": [
          "giftmall.es"
        ],
        "debtorName": "GiftMall"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpfaeshspmwtrg2tk9zk",
      "clustering": {
        "description": "GiftMall",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'GiftMall' from 'giftmall.es'",
        "updatedAt": "2025-09-27T10:52:10.068Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_h82db6v1v2ad1r0gps1vp1an5q",
      "createdAt": "2025-08-22T08:53:00.000Z",
      "updatedAt": "2025-08-22T08:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 231.77,
      "currency": "EUR",
      "description": "Payment to Welcome to the Jungle: WTT-202508-8768",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_j8x2zp3pp1f2442hg6q29r4bqa",
      "fspDate": "2025-08-22T07:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_j8x2zp3pp1f2442hg6q29r4bqa",
        "bookingDate": "2025-08-22",
        "valueDate": "2025-08-22",
        "bookingDateTime": "2025-08-22T08:53:00.000Z",
        "valueDateTime": "2025-08-22T08:53:00.000Z",
        "transactionAmount": {
          "amount": "231.77",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Welcome to the Jungle: WTT-202508-8768",
        "remittanceInformationUnstructuredArray": [
          "Payment to Welcome to the Jungle",
          "WTT-202508-8768"
        ],
        "debtorName": "Welcome to the Jungle"
      },
      "paymentId": null,
      "reference": "WTT-202508-8768",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkfxeshspnwz7ebn2y1d",
      "clustering": {
        "description": "Welcome to the Jungle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Welcome to the Jungle' based on payment details",
        "updatedAt": "2025-08-22T08:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Welcome to the Jungle",
        "iban": "DE31852645287477244",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jxe4gxhmp5vg5pdefr6anvjre5",
      "createdAt": "2025-08-22T08:27:00.000Z",
      "updatedAt": "2025-08-22T08:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 44.41,
      "currency": "EUR",
      "description": "Payment to Mamma Mia Restaurant: MMR-202508-2604",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jps2expjxqptmtk2xee3zhb7hw",
      "fspDate": "2025-08-22T07:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jps2expjxqptmtk2xee3zhb7hw",
        "bookingDate": "2025-08-22",
        "valueDate": "2025-08-22",
        "bookingDateTime": "2025-08-22T08:27:00.000Z",
        "valueDateTime": "2025-08-22T08:27:00.000Z",
        "transactionAmount": {
          "amount": "44.41",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mamma Mia Restaurant: MMR-202508-2604",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mamma Mia Restaurant",
          "MMR-202508-2604"
        ],
        "debtorName": "Mamma Mia Restaurant"
      },
      "paymentId": null,
      "reference": "MMR-202508-2604",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj1yeshspngr1g523f6q",
      "clustering": {
        "description": "Mamma Mia Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mamma Mia Restaurant' based on payment details",
        "updatedAt": "2025-08-22T08:27:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mamma Mia Restaurant",
        "iban": "DE87678177726766260",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmpdsme4q3hx",
      "createdAt": "2025-08-21T16:39:00.000Z",
      "updatedAt": "2025-08-21T16:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 954.71,
      "currency": "GBP",
      "description": "To Charles Russell Speechlys LLP",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8ev03b782fx",
      "fspDate": "2025-08-21T15:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8ev03b782fx",
        "bookingDate": "2025-08-21",
        "valueDate": "2025-08-21",
        "bookingDateTime": "2025-08-21T15:39:00.000Z",
        "valueDateTime": "2025-08-21T15:39:00.000Z",
        "transactionAmount": {
          "amount": "-954.71",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Charles Russell Speechlys LLP",
        "remittanceInformationUnstructuredArray": [
          "To Charles Russell Speechlys LLP"
        ],
        "debtorName": "Charles Russell Speechlys LLP"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgh1fvhrjp0n7wme8cae",
      "clustering": {
        "description": "Charles Russell Speechlys LLP",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Charles Russell Speechlys LLP' from 'To Charles Russell Speechlys LLP'",
        "updatedAt": "2025-09-29T18:26:40.937Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_x058v6fg3gwn3tseag59qm20e3",
      "createdAt": "2025-08-21T15:48:00.000Z",
      "updatedAt": "2025-08-21T15:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.6,
      "currency": "GBP",
      "description": "Payment to FCB Coffee: FC-202508-9490",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_f8ap1w9vsgvrbbgmn3kxhhxxn9",
      "fspDate": "2025-08-21T14:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_f8ap1w9vsgvrbbgmn3kxhhxxn9",
        "bookingDate": "2025-08-21",
        "valueDate": "2025-08-21",
        "bookingDateTime": "2025-08-21T15:48:00.000Z",
        "valueDateTime": "2025-08-21T15:48:00.000Z",
        "transactionAmount": {
          "amount": "3.60",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to FCB Coffee: FC-202508-9490",
        "remittanceInformationUnstructuredArray": [
          "Payment to FCB Coffee",
          "FC-202508-9490"
        ],
        "debtorName": "FCB Coffee"
      },
      "paymentId": null,
      "reference": "FC-202508-9490",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmmfvhrjp1d532dm1jy",
      "clustering": {
        "description": "FCB Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'FCB Coffee' based on payment details",
        "updatedAt": "2025-08-21T15:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "FCB Coffee",
        "iban": null,
        "bic": null,
        "sortCode": "125919",
        "accountNumber": "22624279"
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm8zrsrne8cc",
      "createdAt": "2025-08-21T12:40:00.000Z",
      "updatedAt": "2025-08-21T12:40:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 9200,
      "currency": "GBP",
      "description": "Exchanged to EUR Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0xwbp37fq9r9as1xmtgzwew",
      "fspDate": "2025-08-21T11:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xwbp37fq9r9as1xmtgzwew",
        "bookingDate": "2025-08-21",
        "valueDate": "2025-08-21",
        "bookingDateTime": "2025-08-21T11:40:00.000Z",
        "valueDateTime": "2025-08-21T11:40:00.000Z",
        "transactionAmount": {
          "amount": "-9200.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to EUR Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to EUR Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code and extracted 'Currency Exchange' as the description",
        "updatedAt": "2025-09-29T18:24:29.631Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfbq6w5r0pxw",
      "createdAt": "2025-08-21T07:52:00.000Z",
      "updatedAt": "2025-08-21T07:52:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 37.74,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k180qw44esj88dr2jdh114v3",
      "fspDate": "2025-08-21T06:52:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k180qw44esj88dr2jdh114v3",
        "bookingDate": "2025-08-21",
        "valueDate": "2025-08-21",
        "bookingDateTime": "2025-08-21T06:52:00.000Z",
        "valueDateTime": "2025-08-21T06:52:00.000Z",
        "transactionAmount": {
          "amount": "-37.74",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'DocuSign' from 'Docusign'",
        "updatedAt": "2025-09-27T10:48:02.608Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebzafvhrjmt7sgsj3kvt",
      "createdAt": "2025-08-20T12:45:00.000Z",
      "updatedAt": "2025-08-20T12:45:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 6.91,
      "currency": "GBP",
      "description": "Uber * Pending",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8jjzvpfzmve",
      "fspDate": "2025-08-20T11:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8jjzvpfzmve",
        "bookingDate": "2025-08-20",
        "valueDate": "2025-08-20",
        "bookingDateTime": "2025-08-20T11:45:00.000Z",
        "valueDateTime": "2025-08-20T11:45:00.000Z",
        "transactionAmount": {
          "amount": "-6.91",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Uber * Pending",
        "remittanceInformationUnstructuredArray": [
          "Uber * Pending"
        ],
        "debtorName": "Uber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Uber",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Uber' from 'Uber * Pending'",
        "updatedAt": "2025-09-29T18:26:40.997Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfgyrwbmvj95",
      "createdAt": "2025-08-20T12:35:00.000Z",
      "updatedAt": "2025-08-20T12:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 0.01,
      "currency": "EUR",
      "description": "Payment to Emma Fitzgerald: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0yd8drmencb0ddcqc1qfnr9",
      "fspDate": "2025-08-20T11:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0yd8drmencb0ddcqc1qfnr9",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T14:00:00.000Z",
        "valueDateTime": "2026-01-13T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-0.01",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Emma Fitzgerald: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Emma Fitzgerald: July 2025 Payroll"
        ],
        "debtorName": "Emma Fitzgerald"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtceshspj98ga0ebagk",
      "clustering": {
        "description": "Emma Fitzgerald",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Emma Fitzgerald' as the recipient name for the payroll transaction",
        "updatedAt": "2025-09-27T10:49:04.203Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfdmgbvmz0sn",
      "createdAt": "2025-08-20T11:09:00.000Z",
      "updatedAt": "2025-08-20T11:09:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29493.79,
      "currency": "EUR",
      "description": "To Revenue Commissioners",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k12vyakne4dr6y0d7vjfe5hj",
      "fspDate": "2025-08-20T10:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k12vyakne4dr6y0d7vjfe5hj",
        "bookingDate": "2025-08-20",
        "valueDate": "2025-08-20",
        "bookingDateTime": "2025-08-20T10:09:00.000Z",
        "valueDateTime": "2025-08-20T10:09:00.000Z",
        "transactionAmount": {
          "amount": "-29493.79",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Revenue Commissioners",
        "remittanceInformationUnstructuredArray": [
          "To Revenue Commissioners"
        ],
        "debtorName": "REVENUE COMMISSION"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g53eshsphprhxzbraqp",
      "clustering": {
        "description": "Revenue Commissioners",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Revenue Commissioners' from 'To Revenue Commissioners'",
        "updatedAt": "2025-09-27T10:48:02.695Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph6bdb12ts3t",
      "createdAt": "2025-08-20T10:58:00.000Z",
      "updatedAt": "2025-08-20T10:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4909.86,
      "currency": "EUR",
      "description": "To Hugo Weber",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk2424ht2fthx",
      "fspDate": "2025-08-20T09:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk2424ht2fthx",
        "bookingDate": "2025-08-20",
        "valueDate": "2025-08-20",
        "bookingDateTime": "2025-08-20T09:58:00.000Z",
        "valueDateTime": "2025-08-20T09:58:00.000Z",
        "transactionAmount": {
          "amount": "-4909.86",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Hugo Weber",
        "remittanceInformationUnstructuredArray": [
          "To Hugo Weber"
        ],
        "debtorName": "Hugo Weber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtteshspj9hmeqmzmdw",
      "clustering": {
        "description": "Hugo Weber",
        "confidenceScore": "0.95",
        "rationale": "Extracted core recipient name 'Hugo Weber' from 'To Hugo Weber'",
        "updatedAt": "2025-09-27T10:54:50.884Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmrjt0bybdxm",
      "createdAt": "2025-08-20T10:36:00.000Z",
      "updatedAt": "2025-08-20T10:36:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "GBP",
      "description": "Tfl Travel Charge",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8h0n90wyzfe",
      "fspDate": "2025-08-20T09:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8h0n90wyzfe",
        "bookingDate": "2025-08-20",
        "valueDate": "2025-08-20",
        "bookingDateTime": "2025-08-20T09:36:00.000Z",
        "valueDateTime": "2025-08-20T09:36:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tfl Travel Charge",
        "remittanceInformationUnstructuredArray": [
          "Tfl Travel Charge"
        ],
        "debtorName": "Transport for London"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgk7fvhrjp0v7hz9q786",
      "clustering": {
        "description": "Transport for London",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Transport for London' from 'Tfl Travel Charge'",
        "updatedAt": "2025-09-29T18:26:40.975Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_x8r0c01y3bsvp4v4gd99hg31zr",
      "createdAt": "2025-08-20T10:26:00.000Z",
      "updatedAt": "2025-08-20T10:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 35.24,
      "currency": "EUR",
      "description": "Payment to The Woolshed: TW-202508-3433",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pecpcd9swnhm7dqvkbpx7aq8xx",
      "fspDate": "2025-08-20T09:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pecpcd9swnhm7dqvkbpx7aq8xx",
        "bookingDate": "2025-08-20",
        "valueDate": "2025-08-20",
        "bookingDateTime": "2025-08-20T10:26:00.000Z",
        "valueDateTime": "2025-08-20T10:26:00.000Z",
        "transactionAmount": {
          "amount": "35.24",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Woolshed: TW-202508-3433",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Woolshed",
          "TW-202508-3433"
        ],
        "debtorName": "The Woolshed"
      },
      "paymentId": null,
      "reference": "TW-202508-3433",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1pkeshspm729w29ytag",
      "clustering": {
        "description": "The Woolshed",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Woolshed' based on payment details",
        "updatedAt": "2025-08-20T10:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Woolshed",
        "iban": "DE82019221949482220",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_seabxgar1q5ppx0rmv8as24n94",
      "createdAt": "2025-08-20T09:03:00.000Z",
      "updatedAt": "2025-08-20T09:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4950,
      "currency": "GBP",
      "description": "Salary - Thomas Brown - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_q732gv475xcaxswv4gv0zqtbng",
      "fspDate": "2025-08-20T08:03:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_nxw7h2j4g2v0q1yprdvac32tqq",
        "bookingDate": "2025-08-20",
        "valueDate": "2025-08-20",
        "bookingDateTime": "2025-08-20T08:03:00.000Z",
        "valueDateTime": "2025-08-20T08:03:00.000Z",
        "transactionAmount": {
          "amount": "-4950.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Thomas Brown",
        "remittanceInformationUnstructuredArray": [
          "Salary - Thomas Brown"
        ]
      },
      "paymentId": "pmnt_a6czazny63d85f674fg9j41y31",
      "reference": "PAY-DEC-2025-BROWN",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Thomas Brown",
        "iban": null,
        "bic": null,
        "sortCode": "30-15-89",
        "accountNumber": "01234567"
      }
    },
    {
      "id": "txn_y1256jpzc2bchd9d4z2v16qf8a",
      "createdAt": "2025-08-19T13:20:00.000Z",
      "updatedAt": "2025-08-19T13:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7.84,
      "currency": "USD",
      "description": "Payment to 1Password: 1-202508-8554",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5s6mmf4804jn6xaxm5d3ayebdv",
      "fspDate": "2025-08-19T12:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5s6mmf4804jn6xaxm5d3ayebdv",
        "bookingDate": "2025-08-19",
        "valueDate": "2025-08-19",
        "bookingDateTime": "2025-08-19T13:20:00.000Z",
        "valueDateTime": "2025-08-19T13:20:00.000Z",
        "transactionAmount": {
          "amount": "7.84",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to 1Password: 1-202508-8554",
        "remittanceInformationUnstructuredArray": [
          "Payment to 1Password",
          "1-202508-8554"
        ],
        "debtorName": "1Password"
      },
      "paymentId": null,
      "reference": "1-202508-8554",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxpeshspjghv7zy63at",
      "clustering": {
        "description": "1Password",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor '1Password' based on payment details",
        "updatedAt": "2025-08-19T13:20:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "1Password",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_akyx4nd9s8cvkznbs8c4cnwyrk",
      "createdAt": "2025-08-19T09:51:00.000Z",
      "updatedAt": "2025-08-19T09:51:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 183.73,
      "currency": "GBP",
      "description": "Payment to Kiwi.com: K-202508-8357",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5ed608deet9ykgde924cqg8gen",
      "fspDate": "2025-08-19T08:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5ed608deet9ykgde924cqg8gen",
        "bookingDate": "2025-08-19",
        "valueDate": "2025-08-19",
        "bookingDateTime": "2025-08-19T09:51:00.000Z",
        "valueDateTime": "2025-08-19T09:51:00.000Z",
        "transactionAmount": {
          "amount": "183.73",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kiwi.com: K-202508-8357",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kiwi.com",
          "K-202508-8357"
        ],
        "debtorName": "Kiwi.com"
      },
      "paymentId": null,
      "reference": "K-202508-8357",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9q1fvhrjp371wrcstvr",
      "clustering": {
        "description": "Kiwi.com",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kiwi.com' based on payment details",
        "updatedAt": "2025-08-19T09:51:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kiwi.com",
        "iban": null,
        "bic": null,
        "sortCode": "467789",
        "accountNumber": "19185251"
      }
    },
    {
      "id": "txn_jg2az1bwvncyx2k9afk6jtmzj5",
      "createdAt": "2025-08-19T09:41:00.000Z",
      "updatedAt": "2025-08-19T09:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4.33,
      "currency": "EUR",
      "description": "Payment to Pinecone Coffee: PC-202508-9949",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bcfvqccyz09yvf7t6cmse4w0cd",
      "fspDate": "2025-08-19T08:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bcfvqccyz09yvf7t6cmse4w0cd",
        "bookingDate": "2025-08-19",
        "valueDate": "2025-08-19",
        "bookingDateTime": "2025-08-19T09:41:00.000Z",
        "valueDateTime": "2025-08-19T09:41:00.000Z",
        "transactionAmount": {
          "amount": "4.33",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pinecone Coffee: PC-202508-9949",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pinecone Coffee",
          "PC-202508-9949"
        ],
        "debtorName": "Pinecone Coffee"
      },
      "paymentId": null,
      "reference": "PC-202508-9949",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh31eshspkh23ahabkmn",
      "clustering": {
        "description": "Pinecone Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pinecone Coffee' based on payment details",
        "updatedAt": "2025-08-19T09:41:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pinecone Coffee",
        "iban": "DE90753365412896660",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7b7v9we55aqtn7jww8j0wss18d",
      "createdAt": "2025-08-19T09:07:00.000Z",
      "updatedAt": "2025-08-19T09:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.38,
      "currency": "EUR",
      "description": "Payment to Anthony Moore: AM-202508-2111",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0tz8g7233gynrvb7b9fv2yky0q",
      "fspDate": "2025-08-19T08:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0tz8g7233gynrvb7b9fv2yky0q",
        "bookingDate": "2025-08-19",
        "valueDate": "2025-08-19",
        "bookingDateTime": "2025-08-19T09:07:00.000Z",
        "valueDateTime": "2025-08-19T09:07:00.000Z",
        "transactionAmount": {
          "amount": "25.38",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthony Moore: AM-202508-2111",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthony Moore",
          "AM-202508-2111"
        ],
        "debtorName": "Anthony Moore"
      },
      "paymentId": null,
      "reference": "AM-202508-2111",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a2keshspnzq7m9sbpn2",
      "clustering": {
        "description": "Anthony Moore",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthony Moore' based on payment details",
        "updatedAt": "2025-08-19T09:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthony Moore",
        "iban": "DE86624458270982740",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3awm7h33j5t9zyk32ww5z1z0k4",
      "createdAt": "2025-08-18T14:49:00.000Z",
      "updatedAt": "2025-08-18T14:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.7,
      "currency": "EUR",
      "description": "Payment to Tavily AI: TA-202508-8592",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rtrymtgr1re8c06q3z1xprtfdz",
      "fspDate": "2025-08-18T13:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rtrymtgr1re8c06q3z1xprtfdz",
        "bookingDate": "2025-08-18",
        "valueDate": "2025-08-18",
        "bookingDateTime": "2025-08-18T14:49:00.000Z",
        "valueDateTime": "2025-08-18T14:49:00.000Z",
        "transactionAmount": {
          "amount": "25.70",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tavily AI: TA-202508-8592",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tavily AI",
          "TA-202508-8592"
        ],
        "debtorName": "Tavily AI"
      },
      "paymentId": null,
      "reference": "TA-202508-8592",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ceerteshspk5wmka0h0ee",
      "clustering": {
        "description": "Tavily AI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tavily AI' based on payment details",
        "updatedAt": "2025-08-18T14:49:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tavily AI",
        "iban": "DE62552077251138390",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y8eshsph7zxh0ywzkf",
      "createdAt": "2025-08-18T13:54:00.000Z",
      "updatedAt": "2025-08-18T13:54:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 15.6,
      "currency": "EUR",
      "description": "Sumup *taxi Paul Barr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg247ae8pvk26khggjqtwb",
      "fspDate": "2025-08-18T12:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg247ae8pvk26khggjqtwb",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T10:00:00.000Z",
        "valueDateTime": "2026-01-03T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-15.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *taxi Paul Barr",
        "remittanceInformationUnstructuredArray": [
          "Sumup *taxi Paul Barr"
        ],
        "debtorName": "Paul Barr"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Taxi",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Taxi' from 'Sumup *taxi Paul Barr', removing the 'Sumup *' prefix and 'Paul Barr' location details",
        "updatedAt": "2025-09-27T10:55:13.243Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xqhst0p3j72nww7hbw04k75xb6",
      "createdAt": "2025-08-18T12:01:00.000Z",
      "updatedAt": "2025-08-18T12:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.06,
      "currency": "EUR",
      "description": "Payment to Cafe And Noodle: CAN-202508-6638",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pkcp8agmge6w2spb43dx485t9g",
      "fspDate": "2025-08-18T11:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pkcp8agmge6w2spb43dx485t9g",
        "bookingDate": "2025-08-18",
        "valueDate": "2025-08-18",
        "bookingDateTime": "2025-08-18T12:01:00.000Z",
        "valueDateTime": "2025-08-18T12:01:00.000Z",
        "transactionAmount": {
          "amount": "15.06",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cafe And Noodle: CAN-202508-6638",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cafe And Noodle",
          "CAN-202508-6638"
        ],
        "debtorName": "Cafe And Noodle"
      },
      "paymentId": null,
      "reference": "CAN-202508-6638",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpd8eshspmwjjpzayxx2",
      "clustering": {
        "description": "Cafe And Noodle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cafe And Noodle' based on payment details",
        "updatedAt": "2025-08-18T12:01:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cafe And Noodle",
        "iban": "DE66783737328359880",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm83gdd0aszx",
      "createdAt": "2025-08-18T11:01:00.000Z",
      "updatedAt": "2025-08-18T11:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3300,
      "currency": "GBP",
      "description": "Payment to Yapily Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1dzvfx9eh1r0ckae20spwhg",
      "fspDate": "2025-08-18T10:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1dzvfx9eh1r0ckae20spwhg",
        "bookingDate": "2025-08-18",
        "valueDate": "2025-08-18",
        "bookingDateTime": "2025-08-18T10:01:00.000Z",
        "valueDateTime": "2025-08-18T10:01:00.000Z",
        "transactionAmount": {
          "amount": "-3300.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Yapily Limited",
        "remittanceInformationUnstructuredArray": [
          "Payment to Yapily Limited"
        ],
        "debtorName": "Yapily Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf94qfvhrjn51jet0pt56",
      "clustering": {
        "description": "Yapily Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Yapily Limited' from 'Payment to Yapily Limited'",
        "updatedAt": "2025-09-29T18:24:29.619Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspexkhkt3jyc7",
      "createdAt": "2025-08-18T10:36:00.000Z",
      "updatedAt": "2025-08-18T10:36:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 18.5,
      "currency": "EUR",
      "description": "Tst-Tang-Cumberland-Pl",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2ksftarfzwbd1msq33yq0wm",
      "fspDate": "2025-08-18T09:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ksftarfzwbd1msq33yq0wm",
        "bookingDate": "2025-08-18",
        "valueDate": "2025-08-18",
        "bookingDateTime": "2025-08-18T09:36:00.000Z",
        "valueDateTime": "2025-08-18T09:36:00.000Z",
        "transactionAmount": {
          "amount": "-18.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tst-Tang-Cumberland-Pl",
        "remittanceInformationUnstructuredArray": [
          "Tst-Tang-Cumberland-Pl"
        ],
        "debtorName": "Tang"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gseshspjyrwgx4ccwg",
      "clustering": {
        "description": "Tang",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Tang' from 'Tst-Tang-Cumberland-Pl', removing 'Tst-' prefix and '-Cumberland-Pl' suffix",
        "updatedAt": "2025-09-27T10:42:40.368Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmcdg9h0x66k",
      "createdAt": "2025-08-18T09:04:00.000Z",
      "updatedAt": "2025-08-18T09:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10000,
      "currency": "GBP",
      "description": "To SEAPOINT FINANCE UK INVESTMENTS LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk84vtvc501h7",
      "fspDate": "2025-08-18T08:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk84vtvc501h7",
        "bookingDate": "2025-08-18",
        "valueDate": "2025-08-18",
        "bookingDateTime": "2025-08-18T08:04:00.000Z",
        "valueDateTime": "2025-08-18T08:04:00.000Z",
        "transactionAmount": {
          "amount": "-10000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To SEAPOINT FINANCE UK INVESTMENTS LIMITED",
        "remittanceInformationUnstructuredArray": [
          "To SEAPOINT FINANCE UK INVESTMENTS LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK Investments",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Seapoint Finance UK Investments' from 'To SEAPOINT FINANCE UK INVESTMENTS LIMITED'",
        "updatedAt": "2025-09-29T18:25:01.088Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_er91bzrpjrxsksecpdzkcn7e6n",
      "createdAt": "2025-08-18T08:31:00.000Z",
      "updatedAt": "2025-08-18T08:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 13710.11,
      "currency": "GBP",
      "description": "Payment from Digital Ventures Group - INV-202508-2810",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wzvq573gk8tdperrvx41zn4dwe",
      "fspDate": "2025-08-18T07:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wzvq573gk8tdperrvx41zn4dwe",
        "bookingDate": "2025-08-18",
        "valueDate": "2025-08-18",
        "bookingDateTime": "2025-08-18T08:31:00.000Z",
        "valueDateTime": "2025-08-18T08:31:00.000Z",
        "transactionAmount": {
          "amount": "13710.11",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Digital Ventures Group - INV-202508-2810",
        "remittanceInformationUnstructuredArray": [
          "Payment from Digital Ventures Group",
          "INV-202508-2810"
        ],
        "creditorName": "Digital Ventures Group"
      },
      "paymentId": null,
      "reference": "INV-202508-2810",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_mj6n80che7b1rf41e9c0gtanqb",
      "clustering": {
        "description": "Digital Ventures Group",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Digital Ventures Group'",
        "updatedAt": "2025-08-18T08:31:00.000Z"
      },
      "payer": {
        "name": "Digital Ventures Group",
        "iban": null,
        "bic": null,
        "sortCode": "585955",
        "accountNumber": "91429080"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgg0z6bpzn6y",
      "createdAt": "2025-08-18T08:11:00.000Z",
      "updatedAt": "2025-08-18T08:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6585.5,
      "currency": "EUR",
      "description": "To Leonie Schaefer",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1d76k5ssyga",
      "fspDate": "2025-08-18T07:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1d76k5ssyga",
        "bookingDate": "2026-01-07",
        "valueDate": "2026-01-07",
        "bookingDateTime": "2026-01-07T13:00:00.000Z",
        "valueDateTime": "2026-01-07T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-6585.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Leonie Schaefer",
        "remittanceInformationUnstructuredArray": [
          "To Leonie Schaefer"
        ],
        "debtorName": "Leonie Schaffer"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zs6eshspj7aqq6j2203",
      "clustering": {
        "description": "Leonie Schaefer",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Leonie Schaefer' from 'To Leonie Schaefer'.",
        "updatedAt": "2025-09-27T10:52:47.391Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfpsf3weacn0",
      "createdAt": "2025-08-17T16:31:00.000Z",
      "updatedAt": "2025-08-17T16:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3690,
      "currency": "EUR",
      "description": "Payment to PEMBROKEHALL LTD: 150895",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0f8571wfvqsgxc1va4bj5f8",
      "fspDate": "2025-08-17T15:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0f8571wfvqsgxc1va4bj5f8",
        "bookingDate": "2025-12-17",
        "valueDate": "2025-12-17",
        "bookingDateTime": "2025-12-17T09:27:00.000Z",
        "valueDateTime": "2025-12-17T09:27:00.000Z",
        "transactionAmount": {
          "amount": "-3690.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to PEMBROKEHALL LTD: 150895",
        "remittanceInformationUnstructuredArray": [
          "Payment to PEMBROKEHALL LTD: 150895"
        ],
        "debtorName": "PEMBROKEHALL LTD"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzdeshsphm46adfgbg7",
      "clustering": {
        "description": "PEMBROKEHALL LTD",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'PEMBROKEHALL LTD' from 'Payment to PEMBROKEHALL LTD: 150895'",
        "updatedAt": "2025-09-27T10:49:37.665Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfrk9ymea5x1",
      "createdAt": "2025-08-17T15:09:00.000Z",
      "updatedAt": "2025-08-17T15:09:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6777.2,
      "currency": "EUR",
      "description": "To Denis Breen & Co Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg246ze8pvk0n4c91d3v1t",
      "fspDate": "2025-08-17T14:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg246ze8pvk0n4c91d3v1t",
        "bookingDate": "2025-08-17",
        "valueDate": "2025-08-17",
        "bookingDateTime": "2025-08-17T14:09:00.000Z",
        "valueDateTime": "2025-08-17T14:09:00.000Z",
        "transactionAmount": {
          "amount": "-6777.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Denis Breen & Co Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Denis Breen & Co Ltd"
        ],
        "debtorName": "Denis Breen & Co Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zb1eshspj0854px1k2v",
      "clustering": {
        "description": "Denis Breen & Co Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Denis Breen & Co Ltd' from 'To Denis Breen & Co Ltd'",
        "updatedAt": "2025-09-27T10:49:37.720Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xxeshspefcdq4mwxs9",
      "createdAt": "2025-08-17T14:39:00.000Z",
      "updatedAt": "2025-08-17T14:39:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 16.5,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3qv1xr7esm9bvxq9pqmddqr",
      "fspDate": "2025-08-17T13:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3qv1xr7esm9bvxq9pqmddqr",
        "bookingDate": "2025-12-19",
        "valueDate": "2025-12-19",
        "bookingDateTime": "2025-12-19T10:07:00.000Z",
        "valueDateTime": "2025-12-19T10:07:00.000Z",
        "transactionAmount": {
          "amount": "-16.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Shaka Poke' from 'Sq *shaka Poke', removing the 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:39:39.648Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjmbz3ptf6rr1",
      "createdAt": "2025-08-17T14:32:00.000Z",
      "updatedAt": "2025-08-17T14:32:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 42613.56,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk84djq864nkz",
      "fspDate": "2025-08-17T13:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk84djq864nkz",
        "bookingDate": "2025-12-22",
        "valueDate": "2025-12-22",
        "bookingDateTime": "2025-12-22T09:29:00.000Z",
        "valueDateTime": "2025-12-22T09:29:00.000Z",
        "transactionAmount": {
          "amount": "42613.56",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code and extracted 'Currency Exchange' as the description",
        "updatedAt": "2025-09-29T18:24:29.691Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qm76v86xwxjrxssd4yajgk2rgh",
      "createdAt": "2025-08-17T14:11:00.000Z",
      "updatedAt": "2025-08-17T14:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1714.6,
      "currency": "EUR",
      "description": "Payment to Sophie Laurent: SL-202508-2034",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_t63vax10gabsrr0p24e16ds3nh",
      "fspDate": "2025-08-17T13:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_t63vax10gabsrr0p24e16ds3nh",
        "bookingDate": "2025-08-17",
        "valueDate": "2025-08-17",
        "bookingDateTime": "2025-08-17T14:11:00.000Z",
        "valueDateTime": "2025-08-17T14:11:00.000Z",
        "transactionAmount": {
          "amount": "1714.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sophie Laurent: SL-202508-2034",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sophie Laurent",
          "SL-202508-2034"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": "SL-202508-2034",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc5eshspj0rxb4j151x",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sophie Laurent' based on payment details",
        "updatedAt": "2025-08-17T14:11:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sophie Laurent",
        "iban": "DE75867600587591920",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspgads0rx518x",
      "createdAt": "2025-08-17T10:35:00.000Z",
      "updatedAt": "2025-08-17T10:35:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 14000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk17a80ag8h80",
      "fspDate": "2025-08-17T09:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk17a80ag8h80",
        "bookingDate": "2025-08-17",
        "valueDate": "2025-08-17",
        "bookingDateTime": "2025-08-17T09:35:00.000Z",
        "valueDateTime": "2025-08-17T09:35:00.000Z",
        "transactionAmount": {
          "amount": "-14000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:52:09.973Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_13z1favcgg4fqby03a2e0qga32",
      "createdAt": "2025-08-17T09:46:00.000Z",
      "updatedAt": "2025-08-17T09:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2828.99,
      "currency": "USD",
      "description": "Payment to Anthropic PBC: AP-202508-8467",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_m111dhnr38pb10jnryb6ygxd7f",
      "fspDate": "2025-08-17T08:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_m111dhnr38pb10jnryb6ygxd7f",
        "bookingDate": "2025-08-17",
        "valueDate": "2025-08-17",
        "bookingDateTime": "2025-08-17T09:46:00.000Z",
        "valueDateTime": "2025-08-17T09:46:00.000Z",
        "transactionAmount": {
          "amount": "2828.99",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic PBC: AP-202508-8467",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic PBC",
          "AP-202508-8467"
        ],
        "debtorName": "Anthropic PBC"
      },
      "paymentId": null,
      "reference": "AP-202508-8467",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_vnn6fxhm5daqv7bh39b88k2t9d",
      "clustering": {
        "description": "Anthropic PBC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic PBC' based on payment details",
        "updatedAt": "2025-08-17T09:46:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic PBC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspez3z04ncq4s",
      "createdAt": "2025-08-16T16:33:00.000Z",
      "updatedAt": "2025-08-16T16:33:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 2377.26,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2feknczfk7s42a875c4bpkj",
      "fspDate": "2025-08-16T15:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2feknczfk7s42a875c4bpkj",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T09:00:00.000Z",
        "valueDateTime": "2026-01-13T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-2377.26",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the core description for a currency conversion transaction, based on the 'EXCHANGE' code",
        "updatedAt": "2025-09-27T10:42:40.403Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmfyhtv2j7xx",
      "createdAt": "2025-08-16T13:37:00.000Z",
      "updatedAt": "2025-08-16T13:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2800,
      "currency": "GBP",
      "description": "To Seapoint Finance Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk88cg89c75tm",
      "fspDate": "2025-08-16T12:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk88cg89c75tm",
        "bookingDate": "2025-08-16",
        "valueDate": "2025-08-16",
        "bookingDateTime": "2025-08-16T12:37:00.000Z",
        "valueDateTime": "2025-08-16T12:37:00.000Z",
        "transactionAmount": {
          "amount": "-2800.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Seapoint Finance Limited",
        "remittanceInformationUnstructuredArray": [
          "To Seapoint Finance Limited"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'Seapoint Finance' from 'To Seapoint Finance Limited'",
        "updatedAt": "2025-09-29T18:25:01.161Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6h13zgww719cqzbht7bx899keg",
      "createdAt": "2025-08-16T11:51:00.000Z",
      "updatedAt": "2025-08-16T11:51:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 38963.55,
      "currency": "GBP",
      "description": "Payment from Enterprise Systems Inc - INV-202508-6689",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0s8sgxdh5by7bn4487efzakdn2",
      "fspDate": "2025-08-16T10:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0s8sgxdh5by7bn4487efzakdn2",
        "bookingDate": "2025-08-16",
        "valueDate": "2025-08-16",
        "bookingDateTime": "2025-08-16T11:51:00.000Z",
        "valueDateTime": "2025-08-16T11:51:00.000Z",
        "transactionAmount": {
          "amount": "38963.55",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Enterprise Systems Inc - INV-202508-6689",
        "remittanceInformationUnstructuredArray": [
          "Payment from Enterprise Systems Inc",
          "INV-202508-6689"
        ],
        "creditorName": "Enterprise Systems Inc"
      },
      "paymentId": null,
      "reference": "INV-202508-6689",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1jqt0xq8p3az0ed45aqq7npx6w",
      "clustering": {
        "description": "Enterprise Systems Inc",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Enterprise Systems Inc'",
        "updatedAt": "2025-08-16T11:51:00.000Z"
      },
      "payer": {
        "name": "Enterprise Systems Inc",
        "iban": null,
        "bic": null,
        "sortCode": "177202",
        "accountNumber": "60131993"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgb7pzqgj62y",
      "createdAt": "2025-08-16T11:30:00.000Z",
      "updatedAt": "2025-08-16T11:30:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Suhas Falafel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk18zyjrw39d9",
      "fspDate": "2025-08-16T10:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk18zyjrw39d9",
        "bookingDate": "2025-08-16",
        "valueDate": "2025-08-16",
        "bookingDateTime": "2025-08-16T10:30:00.000Z",
        "valueDateTime": "2025-08-16T10:30:00.000Z",
        "transactionAmount": {
          "amount": "-14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Suhas Falafel",
        "remittanceInformationUnstructuredArray": [
          "Suhas Falafel"
        ],
        "debtorName": "Suhas Falafel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmadbeshspkkgwerj0myb",
      "clustering": {
        "description": "Suhas Falafel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Suhas Falafel' from 'Suhas Falafel'",
        "updatedAt": "2025-09-27T10:52:10.009Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_cg65cz7rmvfjdyq5vfv73aq7ky",
      "createdAt": "2025-08-16T11:24:00.000Z",
      "updatedAt": "2025-08-16T11:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 454.47,
      "currency": "USD",
      "description": "Payment to Kandji: K-202508-7012",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0sc74fx6246j1h697fehk1pk2a",
      "fspDate": "2025-08-16T10:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0sc74fx6246j1h697fehk1pk2a",
        "bookingDate": "2025-08-16",
        "valueDate": "2025-08-16",
        "bookingDateTime": "2025-08-16T11:24:00.000Z",
        "valueDateTime": "2025-08-16T11:24:00.000Z",
        "transactionAmount": {
          "amount": "454.47",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kandji: K-202508-7012",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kandji",
          "K-202508-7012"
        ],
        "debtorName": "Kandji"
      },
      "paymentId": null,
      "reference": "K-202508-7012",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax4veshspjmy8ae028r6",
      "clustering": {
        "description": "Kandji",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kandji' based on payment details",
        "updatedAt": "2025-08-16T11:24:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kandji",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_r2w8vm707rt0fhtfms4atqthpa",
      "createdAt": "2025-08-16T11:20:00.000Z",
      "updatedAt": "2025-08-16T11:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 21323.89,
      "currency": "EUR",
      "description": "Payment from Nordic Digital AB - INV-202508-6388",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_t4ya4tz02hv1f8vqq8mm9255jv",
      "fspDate": "2025-08-16T10:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_t4ya4tz02hv1f8vqq8mm9255jv",
        "bookingDate": "2025-08-16",
        "valueDate": "2025-08-16",
        "bookingDateTime": "2025-08-16T11:20:00.000Z",
        "valueDateTime": "2025-08-16T11:20:00.000Z",
        "transactionAmount": {
          "amount": "21323.89",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nordic Digital AB - INV-202508-6388",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nordic Digital AB",
          "INV-202508-6388"
        ],
        "creditorName": "Nordic Digital AB"
      },
      "paymentId": null,
      "reference": "INV-202508-6388",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_q7sgetg8gwgf23ac9gdqmk8cz4",
      "clustering": {
        "description": "Nordic Digital AB",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nordic Digital AB'",
        "updatedAt": "2025-08-16T11:20:00.000Z"
      },
      "payer": {
        "name": "Nordic Digital AB",
        "iban": "DE83986021714966780",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_etc4habgmmmyeya3nsjxpcd80s",
      "createdAt": "2025-08-16T10:39:00.000Z",
      "updatedAt": "2025-08-16T10:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 23,
      "currency": "EUR",
      "description": "Payment to Muhammad Tashf: MT-202508-9538",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_7b94w9knmcz9kpt49c6qk98qnk",
      "fspDate": "2025-08-16T09:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_7b94w9knmcz9kpt49c6qk98qnk",
        "bookingDate": "2025-08-16",
        "valueDate": "2025-08-16",
        "bookingDateTime": "2025-08-16T10:39:00.000Z",
        "valueDateTime": "2025-08-16T10:39:00.000Z",
        "transactionAmount": {
          "amount": "23.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Muhammad Tashf: MT-202508-9538",
        "remittanceInformationUnstructuredArray": [
          "Payment to Muhammad Tashf",
          "MT-202508-9538"
        ],
        "debtorName": "Muhammad Tashf"
      },
      "paymentId": null,
      "reference": "MT-202508-9538",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkgjeshspnx4pqb9b6ze",
      "clustering": {
        "description": "Muhammad Tashf",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Muhammad Tashf' based on payment details",
        "updatedAt": "2025-08-16T10:39:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Muhammad Tashf",
        "iban": "DE47993615532360584",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm5anmpp7k92",
      "createdAt": "2025-08-16T09:30:00.000Z",
      "updatedAt": "2025-08-16T09:30:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 77.6,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2fekr20fk7s42evr7fdsvtv",
      "fspDate": "2025-08-16T08:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2fekr20fk7s42evr7fdsvtv",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T15:55:00.000Z",
        "valueDateTime": "2025-12-03T15:55:00.000Z",
        "transactionAmount": {
          "amount": "77.60",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.880Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfpefag74cyh",
      "createdAt": "2025-08-15T16:17:00.000Z",
      "updatedAt": "2025-08-15T16:17:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 232.16,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0e8rfh4exraqe0kkrzm2v9t",
      "fspDate": "2025-08-15T15:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0e8rfh4exraqe0kkrzm2v9t",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T07:01:00.000Z",
        "valueDateTime": "2025-12-20T07:01:00.000Z",
        "transactionAmount": {
          "amount": "-232.16",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'OpenAI' from 'Openai *chatgpt Subscr'",
        "updatedAt": "2025-09-27T10:49:37.646Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg249skwbn9m",
      "createdAt": "2025-08-15T14:34:00.000Z",
      "updatedAt": "2025-08-15T14:34:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "EUR",
      "description": "Google *temporary Hold",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0wtxx3qbcr1",
      "fspDate": "2025-08-15T13:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0wtxx3qbcr1",
        "bookingDate": "2025-08-15",
        "valueDate": "2025-08-15",
        "bookingDateTime": "2025-08-15T13:34:00.000Z",
        "valueDateTime": "2025-08-15T13:34:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Google *temporary Hold",
        "remittanceInformationUnstructuredArray": [
          "Google *temporary Hold"
        ],
        "debtorName": "Google"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdrteshspka3qwhrnts0",
      "clustering": {
        "description": "Google",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Google' from 'Google *temporary Hold', removing 'Google *' prefix",
        "updatedAt": "2025-09-27T10:50:52.417Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfzg6fcr1jw8",
      "createdAt": "2025-08-15T11:20:00.000Z",
      "updatedAt": "2025-08-15T11:20:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 15.44,
      "currency": "EUR",
      "description": "Pret A Manger",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0xt4mwx7x2x",
      "fspDate": "2025-08-15T10:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0xt4mwx7x2x",
        "bookingDate": "2025-08-15",
        "valueDate": "2025-08-15",
        "bookingDateTime": "2025-08-15T10:20:00.000Z",
        "valueDateTime": "2025-08-15T10:20:00.000Z",
        "transactionAmount": {
          "amount": "-15.44",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Pret A Manger",
        "remittanceInformationUnstructuredArray": [
          "Pret A Manger"
        ],
        "debtorName": "Pret A Manger"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crphqeshspmfftkxpt85b",
      "clustering": {
        "description": "Pret A Manger",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Pret A Manger' from 'Pret A Manger'",
        "updatedAt": "2025-09-27T10:50:52.286Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qpvtkk7ry414vvwjsvhwadgkwt",
      "createdAt": "2025-08-15T08:13:00.000Z",
      "updatedAt": "2025-08-15T08:13:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17.82,
      "currency": "EUR",
      "description": "Payment to Amba: A-202508-9593",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_7c7aee1kv6r5p0tvrmzmj49w2s",
      "fspDate": "2025-08-15T07:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_7c7aee1kv6r5p0tvrmzmj49w2s",
        "bookingDate": "2025-08-15",
        "valueDate": "2025-08-15",
        "bookingDateTime": "2025-08-15T08:13:00.000Z",
        "valueDateTime": "2025-08-15T08:13:00.000Z",
        "transactionAmount": {
          "amount": "17.82",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amba: A-202508-9593",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amba",
          "A-202508-9593"
        ],
        "debtorName": "Amba"
      },
      "paymentId": null,
      "reference": "A-202508-9593",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g1aeshsphp662hfbd17",
      "clustering": {
        "description": "Amba",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amba' based on payment details",
        "updatedAt": "2025-08-15T08:13:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amba",
        "iban": "DE94799044489385060",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ny9n2stv8mffcs10vmk5h27fgz",
      "createdAt": "2025-08-14T13:06:00.000Z",
      "updatedAt": "2025-08-14T13:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 18.78,
      "currency": "EUR",
      "description": "Payment to Salt Cellar Cafe: SCC-202508-1435",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_43a0k73fwtexnashjrd26982he",
      "fspDate": "2025-08-14T12:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_43a0k73fwtexnashjrd26982he",
        "bookingDate": "2025-08-14",
        "valueDate": "2025-08-14",
        "bookingDateTime": "2025-08-14T13:06:00.000Z",
        "valueDateTime": "2025-08-14T13:06:00.000Z",
        "transactionAmount": {
          "amount": "18.78",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Salt Cellar Cafe: SCC-202508-1435",
        "remittanceInformationUnstructuredArray": [
          "Payment to Salt Cellar Cafe",
          "SCC-202508-1435"
        ],
        "debtorName": "Salt Cellar Cafe"
      },
      "paymentId": null,
      "reference": "SCC-202508-1435",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0x9eshspkzthwr7rcm3",
      "clustering": {
        "description": "Salt Cellar Cafe",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Salt Cellar Cafe' based on payment details",
        "updatedAt": "2025-08-14T13:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Salt Cellar Cafe",
        "iban": "DE28861179002044796",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mk67kp5my909bkh5gece2krrmj",
      "createdAt": "2025-08-14T10:12:00.000Z",
      "updatedAt": "2025-08-14T10:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3746.29,
      "currency": "GBP",
      "description": "Payment to WealthKernel: W-202508-4750",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_stxcc9n7rpms4575w1npzkr432",
      "fspDate": "2025-08-14T09:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_stxcc9n7rpms4575w1npzkr432",
        "bookingDate": "2025-08-14",
        "valueDate": "2025-08-14",
        "bookingDateTime": "2025-08-14T10:12:00.000Z",
        "valueDateTime": "2025-08-14T10:12:00.000Z",
        "transactionAmount": {
          "amount": "3746.29",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to WealthKernel: W-202508-4750",
        "remittanceInformationUnstructuredArray": [
          "Payment to WealthKernel",
          "W-202508-4750"
        ],
        "debtorName": "WealthKernel"
      },
      "paymentId": null,
      "reference": "W-202508-4750",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhng0fvhrjnk93frdx83x",
      "clustering": {
        "description": "WealthKernel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'WealthKernel' based on payment details",
        "updatedAt": "2025-08-14T10:12:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "WealthKernel",
        "iban": null,
        "bic": null,
        "sortCode": "766433",
        "accountNumber": "12430581"
      }
    },
    {
      "id": "txn_2zb4wp8j5hyszmgsp3aqt52459",
      "createdAt": "2025-08-14T09:45:00.000Z",
      "updatedAt": "2025-08-14T09:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 23916.65,
      "currency": "EUR",
      "description": "Payment from Nexus Consulting GmbH - INV-202508-9956",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hpbgr5tqp9r8787vqqtjsr4h26",
      "fspDate": "2025-08-14T08:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hpbgr5tqp9r8787vqqtjsr4h26",
        "bookingDate": "2025-08-14",
        "valueDate": "2025-08-14",
        "bookingDateTime": "2025-08-14T09:45:00.000Z",
        "valueDateTime": "2025-08-14T09:45:00.000Z",
        "transactionAmount": {
          "amount": "23916.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nexus Consulting GmbH - INV-202508-9956",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nexus Consulting GmbH",
          "INV-202508-9956"
        ],
        "creditorName": "Nexus Consulting GmbH"
      },
      "paymentId": null,
      "reference": "INV-202508-9956",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_631832eta7hj1n2x0gedv5fm59",
      "clustering": {
        "description": "Nexus Consulting GmbH",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nexus Consulting GmbH'",
        "updatedAt": "2025-08-14T09:45:00.000Z"
      },
      "payer": {
        "name": "Nexus Consulting GmbH",
        "iban": "DE22253808752206172",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshspgymm6jkecas",
      "createdAt": "2025-08-13T13:29:00.000Z",
      "updatedAt": "2025-08-13T13:29:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 39.5,
      "currency": "EUR",
      "description": "Mak Slim Foods",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1vjs12rt35s",
      "fspDate": "2025-08-13T12:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1vjs12rt35s",
        "bookingDate": "2025-08-13",
        "valueDate": "2025-08-13",
        "bookingDateTime": "2025-08-13T12:29:00.000Z",
        "valueDateTime": "2025-08-13T12:29:00.000Z",
        "transactionAmount": {
          "amount": "-39.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Mak Slim Foods",
        "remittanceInformationUnstructuredArray": [
          "Mak Slim Foods"
        ],
        "debtorName": "Mak Slim Foods"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2yeshspkgyzwx8hqrq",
      "clustering": {
        "description": "Mak Slim Foods",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Mak Slim Foods' from 'Mak Slim Foods'.",
        "updatedAt": "2025-09-27T10:54:12.528Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspetve81zeq4j",
      "createdAt": "2025-08-13T11:22:00.000Z",
      "updatedAt": "2025-08-13T11:22:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 41.66,
      "currency": "EUR",
      "description": "Wispr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2y32qp1e009rppzyd1zebh4",
      "fspDate": "2025-08-13T10:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2y32qp1e009rppzyd1zebh4",
        "bookingDate": "2025-12-21",
        "valueDate": "2025-12-21",
        "bookingDateTime": "2025-12-21T07:22:00.000Z",
        "valueDateTime": "2025-12-21T07:22:00.000Z",
        "transactionAmount": {
          "amount": "-41.66",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Wispr",
        "remittanceInformationUnstructuredArray": [
          "Wispr"
        ],
        "debtorName": "Wispr"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax6ceshspjngxatk00nd",
      "clustering": {
        "description": "Wispr",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Wispr' from the transaction description.",
        "updatedAt": "2025-09-27T10:41:48.239Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fzvs10z8gmf9z8rbxbsrafx360",
      "createdAt": "2025-08-13T10:53:00.000Z",
      "updatedAt": "2025-08-13T10:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 347.36,
      "currency": "GBP",
      "description": "Payment to Booking.com: B-202508-8511",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_793xesk65xvayhgpkwsaxp60d4",
      "fspDate": "2025-08-13T09:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_793xesk65xvayhgpkwsaxp60d4",
        "bookingDate": "2025-08-13",
        "valueDate": "2025-08-13",
        "bookingDateTime": "2025-08-13T10:53:00.000Z",
        "valueDateTime": "2025-08-13T10:53:00.000Z",
        "transactionAmount": {
          "amount": "347.36",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Booking.com: B-202508-8511",
        "remittanceInformationUnstructuredArray": [
          "Payment to Booking.com",
          "B-202508-8511"
        ],
        "debtorName": "Booking.com"
      },
      "paymentId": null,
      "reference": "B-202508-8511",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9p5fvhrjp2td9pd9rat",
      "clustering": {
        "description": "Booking.com",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Booking.com' based on payment details",
        "updatedAt": "2025-08-13T10:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Booking.com",
        "iban": null,
        "bic": null,
        "sortCode": "113631",
        "accountNumber": "25515628"
      }
    },
    {
      "id": "txn_g8qs96xssehzghtq9p0femdkam",
      "createdAt": "2025-08-13T08:55:00.000Z",
      "updatedAt": "2025-08-13T08:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 87.5,
      "currency": "GBP",
      "description": "Payment to Clayton Hotel Belfast: CHB-202508-8116",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_8ja3hjk6p9ya62vv0sb7661bfp",
      "fspDate": "2025-08-13T07:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_8ja3hjk6p9ya62vv0sb7661bfp",
        "bookingDate": "2025-08-13",
        "valueDate": "2025-08-13",
        "bookingDateTime": "2025-08-13T08:55:00.000Z",
        "valueDateTime": "2025-08-13T08:55:00.000Z",
        "transactionAmount": {
          "amount": "87.50",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Belfast: CHB-202508-8116",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Belfast",
          "CHB-202508-8116"
        ],
        "debtorName": "Clayton Hotel Belfast"
      },
      "paymentId": null,
      "reference": "CHB-202508-8116",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4hyfvhrjnt1zqpqqyns",
      "clustering": {
        "description": "Clayton Hotel Belfast",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Belfast' based on payment details",
        "updatedAt": "2025-08-13T08:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Belfast",
        "iban": null,
        "bic": null,
        "sortCode": "582460",
        "accountNumber": "49668467"
      }
    },
    {
      "id": "txn_qpw5zfe1wy2r4yg0whpppz45zy",
      "createdAt": "2025-08-13T08:20:00.000Z",
      "updatedAt": "2025-08-13T08:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 18073.2,
      "currency": "EUR",
      "description": "Payment from EuroTech Innovations - INV-202508-5447",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hcpqgm4esz2g8d85ck2w3b69d7",
      "fspDate": "2025-08-13T07:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hcpqgm4esz2g8d85ck2w3b69d7",
        "bookingDate": "2025-08-13",
        "valueDate": "2025-08-13",
        "bookingDateTime": "2025-08-13T08:20:00.000Z",
        "valueDateTime": "2025-08-13T08:20:00.000Z",
        "transactionAmount": {
          "amount": "18073.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from EuroTech Innovations - INV-202508-5447",
        "remittanceInformationUnstructuredArray": [
          "Payment from EuroTech Innovations",
          "INV-202508-5447"
        ],
        "creditorName": "EuroTech Innovations"
      },
      "paymentId": null,
      "reference": "INV-202508-5447",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m17gcz62vyhqqefr5q41a31k5f",
      "clustering": {
        "description": "EuroTech Innovations",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'EuroTech Innovations'",
        "updatedAt": "2025-08-13T08:20:00.000Z"
      },
      "payer": {
        "name": "EuroTech Innovations",
        "iban": "DE15873357651750192",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfgp10x249pn",
      "createdAt": "2025-08-13T07:07:00.000Z",
      "updatedAt": "2025-08-13T07:07:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 10604.81,
      "currency": "EUR",
      "description": "Exchanged to EUR Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0xwbm7vfq9r9am5pebqh6j4",
      "fspDate": "2025-08-13T06:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xwbm7vfq9r9am5pebqh6j4",
        "bookingDate": "2025-08-13",
        "valueDate": "2025-08-13",
        "bookingDateTime": "2025-08-13T06:07:00.000Z",
        "valueDateTime": "2025-08-13T06:07:00.000Z",
        "transactionAmount": {
          "amount": "10604.81",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to EUR Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to EUR Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' name as the merchant name for exchange to EUR and code: 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:49:04.186Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph2djvsganfc",
      "createdAt": "2025-08-12T12:36:00.000Z",
      "updatedAt": "2025-08-12T12:36:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 101.65,
      "currency": "EUR",
      "description": "Linkedin Pre P40372009",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk2062zxzwf4c",
      "fspDate": "2025-08-12T11:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk2062zxzwf4c",
        "bookingDate": "2025-08-12",
        "valueDate": "2025-08-12",
        "bookingDateTime": "2025-08-12T11:36:00.000Z",
        "valueDateTime": "2025-08-12T11:36:00.000Z",
        "transactionAmount": {
          "amount": "-101.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Linkedin Pre P40372009",
        "remittanceInformationUnstructuredArray": [
          "Linkedin Pre P40372009"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'LinkedIn' from 'Linkedin Pre P40372009', removing the 'Pre' suffix",
        "updatedAt": "2025-09-27T10:54:50.755Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspewf6h89vszn",
      "createdAt": "2025-08-12T09:42:00.000Z",
      "updatedAt": "2025-08-12T09:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 165.7,
      "currency": "EUR",
      "description": "Anthropic Claude Team",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2pbwp66fzwbe0wteek752ra",
      "fspDate": "2025-08-12T08:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2pbwp66fzwbe0wteek752ra",
        "bookingDate": "2025-08-12",
        "valueDate": "2025-08-12",
        "bookingDateTime": "2025-08-12T08:42:00.000Z",
        "valueDateTime": "2025-08-12T08:42:00.000Z",
        "transactionAmount": {
          "amount": "-165.70",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Anthropic Claude Team",
        "remittanceInformationUnstructuredArray": [
          "Anthropic Claude Team"
        ],
        "debtorName": "Anthropic"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0y2eshspjwh0d2fxb76",
      "clustering": {
        "description": "Anthropic",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Anthropic' from the 'Anthropic Claude Team' transaction description.",
        "updatedAt": "2025-09-27T10:41:48.270Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspghp0dqe58gn",
      "createdAt": "2025-08-12T07:56:00.000Z",
      "updatedAt": "2025-08-12T07:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 65,
      "currency": "EUR",
      "description": "Payment to Company Formations International Limited: 139524",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jygq5aqkfew8jfdhssxrbe0y",
      "fspDate": "2025-08-12T06:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jygq5aqkfew8jfdhssxrbe0y",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T14:00:00.000Z",
        "valueDateTime": "2026-01-03T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-65.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Company Formations International Limited: 139524",
        "remittanceInformationUnstructuredArray": [
          "Payment to Company Formations International Limited: 139524"
        ],
        "debtorName": "Company Formations International Limited"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cvstpeshspn39955xdf4m",
      "clustering": {
        "description": "Company Formations International Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Company Formations International Limited' from 'Payment to Company Formations International Limited: 139524'.",
        "updatedAt": "2025-09-27T10:52:47.446Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_95y6dr7h3b7cxzmq7wdae4hs3g",
      "createdAt": "2025-08-11T14:26:00.000Z",
      "updatedAt": "2025-08-11T14:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 22.12,
      "currency": "EUR",
      "description": "Payment to Tula Mexican Grill: TMG-202508-9013",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0ae1gfmvrryk8cv0yvqncps68q",
      "fspDate": "2025-08-11T13:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0ae1gfmvrryk8cv0yvqncps68q",
        "bookingDate": "2025-08-11",
        "valueDate": "2025-08-11",
        "bookingDateTime": "2025-08-11T14:26:00.000Z",
        "valueDateTime": "2025-08-11T14:26:00.000Z",
        "transactionAmount": {
          "amount": "22.12",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tula Mexican Grill: TMG-202508-9013",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tula Mexican Grill",
          "TMG-202508-9013"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": "TMG-202508-9013",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tula Mexican Grill' based on payment details",
        "updatedAt": "2025-08-11T14:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tula Mexican Grill",
        "iban": "DE96013024564123070",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vzjjs9f3atqfz68m8dbeyc0gpn",
      "createdAt": "2025-08-11T11:42:00.000Z",
      "updatedAt": "2025-08-11T11:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 641.94,
      "currency": "EUR",
      "description": "Payment to Clayton Hotel Burlington: CHB-202508-1136",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_a0t9xqqxq82ya7mbxd6qtg16tp",
      "fspDate": "2025-08-11T10:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_a0t9xqqxq82ya7mbxd6qtg16tp",
        "bookingDate": "2025-08-11",
        "valueDate": "2025-08-11",
        "bookingDateTime": "2025-08-11T11:42:00.000Z",
        "valueDateTime": "2025-08-11T11:42:00.000Z",
        "transactionAmount": {
          "amount": "641.94",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Burlington: CHB-202508-1136",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Burlington",
          "CHB-202508-1136"
        ],
        "debtorName": "Clayton Hotel Burlington"
      },
      "paymentId": null,
      "reference": "CHB-202508-1136",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crppkeshspmfw2e0m4xdm",
      "clustering": {
        "description": "Clayton Hotel Burlington",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Burlington' based on payment details",
        "updatedAt": "2025-08-11T11:42:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Burlington",
        "iban": "DE44258415734952584",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9z2fkvxshgxfpnazwz87tctzpj",
      "createdAt": "2025-08-11T10:03:00.000Z",
      "updatedAt": "2025-08-11T10:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 44.19,
      "currency": "GBP",
      "description": "Payment to Pembroke Hall Limited: PHL-202508-9724",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xsjk34rqmjevn17b6aye1j7m2h",
      "fspDate": "2025-08-11T09:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xsjk34rqmjevn17b6aye1j7m2h",
        "bookingDate": "2025-08-11",
        "valueDate": "2025-08-11",
        "bookingDateTime": "2025-08-11T10:03:00.000Z",
        "valueDateTime": "2025-08-11T10:03:00.000Z",
        "transactionAmount": {
          "amount": "44.19",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pembroke Hall Limited: PHL-202508-9724",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pembroke Hall Limited",
          "PHL-202508-9724"
        ],
        "debtorName": "Pembroke Hall Limited"
      },
      "paymentId": null,
      "reference": "PHL-202508-9724",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fpgn1yfzz9aex3cr77xa32",
      "clustering": {
        "description": "Pembroke Hall Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pembroke Hall Limited' based on payment details",
        "updatedAt": "2025-08-11T10:03:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pembroke Hall Limited",
        "iban": null,
        "bic": null,
        "sortCode": "925646",
        "accountNumber": "61311496"
      }
    },
    {
      "id": "txn_zvr67vev0m4tt7kkhbazyqpjgt",
      "createdAt": "2025-08-11T09:37:00.000Z",
      "updatedAt": "2025-08-11T09:37:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 18.93,
      "currency": "EUR",
      "description": "Payment to The Pig And Heifer: TPA-202508-1346",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6mj80q29mf57t6wy8swt3hkch6",
      "fspDate": "2025-08-11T08:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6mj80q29mf57t6wy8swt3hkch6",
        "bookingDate": "2025-08-11",
        "valueDate": "2025-08-11",
        "bookingDateTime": "2025-08-11T09:37:00.000Z",
        "valueDateTime": "2025-08-11T09:37:00.000Z",
        "transactionAmount": {
          "amount": "18.93",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Pig And Heifer: TPA-202508-1346",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Pig And Heifer",
          "TPA-202508-1346"
        ],
        "debtorName": "The Pig And Heifer"
      },
      "paymentId": null,
      "reference": "TPA-202508-1346",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g5weshsphq7y8rf4z8z",
      "clustering": {
        "description": "The Pig And Heifer",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Pig And Heifer' based on payment details",
        "updatedAt": "2025-08-11T09:37:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Pig And Heifer",
        "iban": "DE21816652933906256",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bzgajatt3ntn04w99njrzdm9ps",
      "createdAt": "2025-08-11T07:44:00.000Z",
      "updatedAt": "2025-08-11T07:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 519.9,
      "currency": "GBP",
      "description": "Payment to Slack Technologies Limited: SLK-UK-2026-0105",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_fpg0zjyddv7r1mtwh5qg34aq4g",
      "fspDate": "2025-08-11T06:44:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_e4p3vqn5k5pn95g9znmem1zxpm",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T10:00:00.000Z",
        "valueDateTime": "2026-01-09T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-519.90",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack Technologies Limited: SLK-UK-2026-0105",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack Technologies Limited: SLK-UK-2026-0105"
        ],
        "debtorName": "Slack Technologies Limited"
      },
      "paymentId": null,
      "reference": "SLK-UK-2026-0105",
      "beneficiaryId": "benf_423n0p675xecav56xpy6rxhv9m",
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_6m3t4s5pcz3g5997sxc586yj3f",
      "clustering": {
        "description": "Slack Technologies Limited",
        "confidenceScore": "0.95",
        "rationale": "Identified as payment to Slack Technologies Limited based on remittance information.",
        "updatedAt": "2026-01-10T10:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack Technologies Limited",
        "iban": null,
        "bic": null,
        "sortCode": "20-00-00",
        "accountNumber": "73849201"
      }
    },
    {
      "id": "txn_005csvdbq107c1mc3x92e4nscx",
      "createdAt": "2025-08-10T15:15:00.000Z",
      "updatedAt": "2025-08-10T15:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 255.12,
      "currency": "GBP",
      "description": "Payment to British Airways: BA-202508-7178",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_d40pmsztc2jp8x9m88ms2dsckt",
      "fspDate": "2025-08-10T14:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_d40pmsztc2jp8x9m88ms2dsckt",
        "bookingDate": "2025-08-10",
        "valueDate": "2025-08-10",
        "bookingDateTime": "2025-08-10T15:15:00.000Z",
        "valueDateTime": "2025-08-10T15:15:00.000Z",
        "transactionAmount": {
          "amount": "255.12",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to British Airways: BA-202508-7178",
        "remittanceInformationUnstructuredArray": [
          "Payment to British Airways",
          "BA-202508-7178"
        ],
        "debtorName": "British Airways"
      },
      "paymentId": null,
      "reference": "BA-202508-7178",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9m2fvhrjp2hhm5q9efq",
      "clustering": {
        "description": "British Airways",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'British Airways' based on payment details",
        "updatedAt": "2025-08-10T15:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "British Airways",
        "iban": null,
        "bic": null,
        "sortCode": "155669",
        "accountNumber": "16800377"
      }
    },
    {
      "id": "txn_01k65c32y2eshspfafm7y6sq1q",
      "createdAt": "2025-08-10T15:02:00.000Z",
      "updatedAt": "2025-08-10T15:02:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1d5gytnesj8a91phd5yr09w",
      "fspDate": "2025-08-10T14:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1d5gytnesj8a91phd5yr09w",
        "bookingDate": "2025-08-10",
        "valueDate": "2025-08-10",
        "bookingDateTime": "2025-08-10T14:02:00.000Z",
        "valueDateTime": "2025-08-10T14:02:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing the Sq * prefix",
        "updatedAt": "2025-09-27T10:45:11.636Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2g13cqt15mtakp08szgprsvbg8",
      "createdAt": "2025-08-10T13:29:00.000Z",
      "updatedAt": "2025-08-10T13:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 24844.7,
      "currency": "GBP",
      "description": "Payment from Global Solutions Ltd - INV-202508-8358",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9sp1d50rznwgafzna483wn7a6h",
      "fspDate": "2025-08-10T12:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9sp1d50rznwgafzna483wn7a6h",
        "bookingDate": "2025-08-10",
        "valueDate": "2025-08-10",
        "bookingDateTime": "2025-08-10T13:29:00.000Z",
        "valueDateTime": "2025-08-10T13:29:00.000Z",
        "transactionAmount": {
          "amount": "24844.70",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Global Solutions Ltd - INV-202508-8358",
        "remittanceInformationUnstructuredArray": [
          "Payment from Global Solutions Ltd",
          "INV-202508-8358"
        ],
        "creditorName": "Global Solutions Ltd"
      },
      "paymentId": null,
      "reference": "INV-202508-8358",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_th3hfveyjxh2erds1n633s02yd",
      "clustering": {
        "description": "Global Solutions Ltd",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Global Solutions Ltd'",
        "updatedAt": "2025-08-10T13:29:00.000Z"
      },
      "payer": {
        "name": "Global Solutions Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "359682",
        "accountNumber": "16701284"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgpq3arvxmkv",
      "createdAt": "2025-08-10T13:20:00.000Z",
      "updatedAt": "2025-08-10T13:20:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 135.99,
      "currency": "EUR",
      "description": "Openai *chatgpt Subscr",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1kygt9jrpst",
      "fspDate": "2025-08-10T12:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1kygt9jrpst",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T15:00:00.000Z",
        "valueDateTime": "2026-01-08T15:00:00.000Z",
        "transactionAmount": {
          "amount": "-135.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Openai *chatgpt Subscr",
        "remittanceInformationUnstructuredArray": [
          "Openai *chatgpt Subscr"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'OpenAI' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.217Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm75enxt6ymj",
      "createdAt": "2025-08-10T12:30:00.000Z",
      "updatedAt": "2025-08-10T12:30:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 3000,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1jbe5t3fk0vv2z44khc3x70",
      "fspDate": "2025-08-10T11:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1jbe5t3fk0vv2z44khc3x70",
        "bookingDate": "2025-08-10",
        "valueDate": "2025-08-10",
        "bookingDateTime": "2025-08-10T11:30:00.000Z",
        "valueDateTime": "2025-08-10T11:30:00.000Z",
        "transactionAmount": {
          "amount": "3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.925Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspegkqdqe3t6f",
      "createdAt": "2025-08-10T10:48:00.000Z",
      "updatedAt": "2025-08-10T10:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 7979,
      "currency": "EUR",
      "description": "REVENUE COMMISSION. Payment from Revenue Commission",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3n8n6ekeh2tcaq102xd6crr",
      "fspDate": "2025-08-10T09:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n6ekeh2tcaq102xd6crr",
        "bookingDate": "2025-08-10",
        "valueDate": "2025-08-10",
        "bookingDateTime": "2025-08-10T09:48:00.000Z",
        "valueDateTime": "2025-08-10T09:48:00.000Z",
        "transactionAmount": {
          "amount": "7979.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Revenue Commission",
        "remittanceInformationUnstructuredArray": [
          "Payment from Revenue Commission"
        ],
        "debtorName": "REVENUE COMMISSION"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g53eshsphprhxzbraqp",
      "clustering": {
        "description": "Revenue Commission",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Revenue Commission' from 'Payment from Revenue Commission'.",
        "updatedAt": "2025-09-27T10:39:39.695Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mmawfhrq1xx87vhphc4bt23fy5",
      "createdAt": "2025-08-10T10:32:00.000Z",
      "updatedAt": "2025-08-10T10:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 72.91,
      "currency": "EUR",
      "description": "Payment to Retool: R-202508-5898",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_hq599csd610s5zbf0fab80sjj2",
      "fspDate": "2025-08-10T09:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_hq599csd610s5zbf0fab80sjj2",
        "bookingDate": "2025-08-10",
        "valueDate": "2025-08-10",
        "bookingDateTime": "2025-08-10T10:32:00.000Z",
        "valueDateTime": "2025-08-10T10:32:00.000Z",
        "transactionAmount": {
          "amount": "72.91",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Retool: R-202508-5898",
        "remittanceInformationUnstructuredArray": [
          "Payment to Retool",
          "R-202508-5898"
        ],
        "debtorName": "Retool"
      },
      "paymentId": null,
      "reference": "R-202508-5898",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdp6eshspk9a3b1e6677",
      "clustering": {
        "description": "Retool",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Retool' based on payment details",
        "updatedAt": "2025-08-10T10:32:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Retool",
        "iban": "DE10525585978935716",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf1nqfx1wsr9",
      "createdAt": "2025-08-10T07:24:00.000Z",
      "updatedAt": "2025-08-10T07:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k26xg786fk7s0pkvpqf8x0sx",
      "fspDate": "2025-08-10T06:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k26xg786fk7s0pkvpqf8x0sx",
        "bookingDate": "2026-01-10",
        "valueDate": "2026-01-10",
        "bookingDateTime": "2026-01-10T07:00:00.000Z",
        "valueDateTime": "2026-01-10T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-5.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Companies Registration' from the transaction description, removing the 'Companies Registration Office' details.",
        "updatedAt": "2025-09-27T10:43:55.425Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspff2e3vh2xch",
      "createdAt": "2025-08-09T16:18:00.000Z",
      "updatedAt": "2025-08-09T16:18:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6585.51,
      "currency": "EUR",
      "description": "Payment to Leonie Schaffer: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k10kr2bje4dr6r11q27yfa14",
      "fspDate": "2025-08-09T15:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k10kr2bje4dr6r11q27yfa14",
        "bookingDate": "2025-08-09",
        "valueDate": "2025-08-09",
        "bookingDateTime": "2025-08-09T15:18:00.000Z",
        "valueDateTime": "2025-08-09T15:18:00.000Z",
        "transactionAmount": {
          "amount": "-6585.51",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Leonie Schaffer: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Leonie Schaffer: July 2025 Payroll"
        ],
        "debtorName": "Leonie Schaffer"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zs6eshspj7aqq6j2203",
      "clustering": {
        "description": "Leonie Schaffer",
        "confidenceScore": "0.95",
        "rationale": "Extracted employee name 'Leonie Schaffer' from 'Payment to Leonie Schaffer: July 2025 Payroll'",
        "updatedAt": "2025-09-27T10:48:02.754Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ey9awv6mbng67r9er1sd6jy4bd",
      "createdAt": "2025-08-09T15:53:00.000Z",
      "updatedAt": "2025-08-09T15:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.96,
      "currency": "EUR",
      "description": "Payment to Revolut: R-202508-2972",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_e1fj0tbcaa9ntxtr1et0pgkf9w",
      "fspDate": "2025-08-09T14:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_e1fj0tbcaa9ntxtr1et0pgkf9w",
        "bookingDate": "2025-08-09",
        "valueDate": "2025-08-09",
        "bookingDateTime": "2025-08-09T15:53:00.000Z",
        "valueDateTime": "2025-08-09T15:53:00.000Z",
        "transactionAmount": {
          "amount": "9.96",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Revolut: R-202508-2972",
        "remittanceInformationUnstructuredArray": [
          "Payment to Revolut",
          "R-202508-2972"
        ],
        "debtorName": "Revolut"
      },
      "paymentId": null,
      "reference": "R-202508-2972",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mvseshspja4gsxz03at",
      "clustering": {
        "description": "Revolut",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Revolut' based on payment details",
        "updatedAt": "2025-08-09T15:53:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Revolut",
        "iban": "DE20033671775921504",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebx5fvhrjm05xkxmv1a8",
      "createdAt": "2025-08-09T15:30:00.000Z",
      "updatedAt": "2025-08-09T15:30:00.000Z",
      "status": "PENDING",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k424mt19e4btmpfzarmfx2hd",
      "fspDate": "2025-08-09T14:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k424mt19e4btmpfzarmfx2hd",
        "bookingDate": "2025-08-09",
        "valueDate": "2025-08-09",
        "bookingDateTime": "2025-08-09T14:30:00.000Z",
        "valueDateTime": "2025-08-09T14:30:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing 'Sq *' prefix",
        "updatedAt": "2025-09-29T18:23:50.724Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshspgz0cds8j1sy",
      "createdAt": "2025-08-09T14:32:00.000Z",
      "updatedAt": "2025-08-09T14:32:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 3.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1x6vm04nxxr",
      "fspDate": "2025-08-09T13:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1x6vm04nxxr",
        "bookingDate": "2026-01-02",
        "valueDate": "2026-01-02",
        "bookingDateTime": "2026-01-02T07:00:00.000Z",
        "valueDateTime": "2026-01-02T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-3.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Companies Registration' from 'Companies Registration'.",
        "updatedAt": "2025-09-27T10:54:12.539Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgxftz1pgpxv",
      "createdAt": "2025-08-09T12:02:00.000Z",
      "updatedAt": "2025-08-09T12:02:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 147.22,
      "currency": "EUR",
      "description": "Ryanair Uk Domestic",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1v9enj65a8j",
      "fspDate": "2025-08-09T11:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1v9enj65a8j",
        "bookingDate": "2025-08-09",
        "valueDate": "2025-08-09",
        "bookingDateTime": "2025-08-09T11:02:00.000Z",
        "valueDateTime": "2025-08-09T11:02:00.000Z",
        "transactionAmount": {
          "amount": "-147.22",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Ryanair Uk Domestic",
        "remittanceInformationUnstructuredArray": [
          "Ryanair Uk Domestic"
        ],
        "debtorName": "Ryanair"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctphbeshspmx6q13ktd74",
      "clustering": {
        "description": "Ryanair",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Ryanair' from 'Ryanair Uk Domestic', removing the 'Uk Domestic' suffix.",
        "updatedAt": "2025-09-27T10:54:12.481Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4e8bhq0zg1c8cba32qassbqgsj",
      "createdAt": "2025-08-09T11:45:00.000Z",
      "updatedAt": "2025-08-09T11:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.46,
      "currency": "EUR",
      "description": "Payment to An Post: AP-202508-9927",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_09pchkrq236xnamtv9n5q4k59x",
      "fspDate": "2025-08-09T10:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_09pchkrq236xnamtv9n5q4k59x",
        "bookingDate": "2025-08-09",
        "valueDate": "2025-08-09",
        "bookingDateTime": "2025-08-09T11:45:00.000Z",
        "valueDateTime": "2025-08-09T11:45:00.000Z",
        "transactionAmount": {
          "amount": "3.46",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to An Post: AP-202508-9927",
        "remittanceInformationUnstructuredArray": [
          "Payment to An Post",
          "AP-202508-9927"
        ],
        "debtorName": "An Post"
      },
      "paymentId": null,
      "reference": "AP-202508-9927",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwdneshspna9pr7b1tc2",
      "clustering": {
        "description": "An Post",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'An Post' based on payment details",
        "updatedAt": "2025-08-09T11:45:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "An Post",
        "iban": "DE51898926819970750",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ejbg6txty7p0t12k2s5sctw1af",
      "createdAt": "2025-08-09T10:35:00.000Z",
      "updatedAt": "2025-08-09T10:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 21928.1,
      "currency": "GBP",
      "description": "Payment from DataDriven Analytics - INV-202508-9903",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ntrh1jejq8yescga2y2tzkh1xx",
      "fspDate": "2025-08-09T09:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ntrh1jejq8yescga2y2tzkh1xx",
        "bookingDate": "2025-08-09",
        "valueDate": "2025-08-09",
        "bookingDateTime": "2025-08-09T10:35:00.000Z",
        "valueDateTime": "2025-08-09T10:35:00.000Z",
        "transactionAmount": {
          "amount": "21928.10",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from DataDriven Analytics - INV-202508-9903",
        "remittanceInformationUnstructuredArray": [
          "Payment from DataDriven Analytics",
          "INV-202508-9903"
        ],
        "creditorName": "DataDriven Analytics"
      },
      "paymentId": null,
      "reference": "INV-202508-9903",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_jy64mwn8y868akxp0c6s337dms",
      "clustering": {
        "description": "DataDriven Analytics",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'DataDriven Analytics'",
        "updatedAt": "2025-08-09T10:35:00.000Z"
      },
      "payer": {
        "name": "DataDriven Analytics",
        "iban": null,
        "bic": null,
        "sortCode": "372201",
        "accountNumber": "89157505"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfec8heskpk0",
      "createdAt": "2025-08-08T14:41:00.000Z",
      "updatedAt": "2025-08-08T14:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 165.65,
      "currency": "EUR",
      "description": "linear.app",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k109hwkefk0b841f8rcv1wv4",
      "fspDate": "2025-08-08T13:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k109hwkefk0b841f8rcv1wv4",
        "bookingDate": "2025-08-08",
        "valueDate": "2025-08-08",
        "bookingDateTime": "2025-08-08T13:41:00.000Z",
        "valueDateTime": "2025-08-08T13:41:00.000Z",
        "transactionAmount": {
          "amount": "-165.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "linear.app",
        "remittanceInformationUnstructuredArray": [
          "linear.app"
        ],
        "debtorName": "Linear"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc1eshspj0mxd2vh6zx",
      "clustering": {
        "description": "Linear",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Linear' from 'linear.app'",
        "updatedAt": "2025-09-27T10:48:02.723Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gcpzh8pbxnyc8qds1hmakksamy",
      "createdAt": "2025-08-08T13:50:00.000Z",
      "updatedAt": "2025-08-08T13:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 36.07,
      "currency": "EUR",
      "description": "Payment to Sweet Salt: SS-202508-6979",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_kp4qkmdak4wwh4kd1e0m78q002",
      "fspDate": "2025-08-08T12:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_kp4qkmdak4wwh4kd1e0m78q002",
        "bookingDate": "2025-08-08",
        "valueDate": "2025-08-08",
        "bookingDateTime": "2025-08-08T13:50:00.000Z",
        "valueDateTime": "2025-08-08T13:50:00.000Z",
        "transactionAmount": {
          "amount": "36.07",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sweet Salt: SS-202508-6979",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sweet Salt",
          "SS-202508-6979"
        ],
        "debtorName": "Sweet Salt"
      },
      "paymentId": null,
      "reference": "SS-202508-6979",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmad4eshspkk8z9xs58fk",
      "clustering": {
        "description": "Sweet Salt",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sweet Salt' based on payment details",
        "updatedAt": "2025-08-08T13:50:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sweet Salt",
        "iban": "DE22890477221115776",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmg8vwc2mxgs",
      "createdAt": "2025-08-08T11:34:00.000Z",
      "updatedAt": "2025-08-08T11:34:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 148,
      "currency": "GBP",
      "description": "Aer Lingus",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk88w27b7sa0x",
      "fspDate": "2025-08-08T10:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk88w27b7sa0x",
        "bookingDate": "2025-08-08",
        "valueDate": "2025-08-08",
        "bookingDateTime": "2025-08-08T10:34:00.000Z",
        "valueDateTime": "2025-08-08T10:34:00.000Z",
        "transactionAmount": {
          "amount": "-148.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Aer Lingus",
        "remittanceInformationUnstructuredArray": [
          "Aer Lingus"
        ],
        "debtorName": "Aer Lingus"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnekfvhrjnk2qd4ej2sf",
      "clustering": {
        "description": "Aer Lingus",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Aer Lingus' from the transaction description",
        "updatedAt": "2025-09-29T18:25:01.170Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_44bq4bmmh7hc5h60zpkehybgaq",
      "createdAt": "2025-08-08T10:14:00.000Z",
      "updatedAt": "2025-08-08T10:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 91.13,
      "currency": "EUR",
      "description": "Payment to Irish Rail: IR-202508-7384",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nd3z7cm03cbdwdr4sp6q6wzpr5",
      "fspDate": "2025-08-08T09:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nd3z7cm03cbdwdr4sp6q6wzpr5",
        "bookingDate": "2025-08-08",
        "valueDate": "2025-08-08",
        "bookingDateTime": "2025-08-08T10:14:00.000Z",
        "valueDateTime": "2025-08-08T10:14:00.000Z",
        "transactionAmount": {
          "amount": "91.13",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Irish Rail: IR-202508-7384",
        "remittanceInformationUnstructuredArray": [
          "Payment to Irish Rail",
          "IR-202508-7384"
        ],
        "debtorName": "Irish Rail"
      },
      "paymentId": null,
      "reference": "IR-202508-7384",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax69eshspjn90xv3cz0y",
      "clustering": {
        "description": "Irish Rail",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Irish Rail' based on payment details",
        "updatedAt": "2025-08-08T10:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Irish Rail",
        "iban": "DE31103149891754108",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qjvfdt4vq6m68arxj2sq7kvzne",
      "createdAt": "2025-08-08T09:48:00.000Z",
      "updatedAt": "2025-08-08T09:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 20.1,
      "currency": "USD",
      "description": "Payment to Cursor: C-202508-5770",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_g2f7qn2swrnx3898qsenk6q5rm",
      "fspDate": "2025-08-08T08:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_g2f7qn2swrnx3898qsenk6q5rm",
        "bookingDate": "2025-08-08",
        "valueDate": "2025-08-08",
        "bookingDateTime": "2025-08-08T09:48:00.000Z",
        "valueDateTime": "2025-08-08T09:48:00.000Z",
        "transactionAmount": {
          "amount": "20.10",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cursor: C-202508-5770",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cursor",
          "C-202508-5770"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": "C-202508-5770",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cursor' based on payment details",
        "updatedAt": "2025-08-08T09:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cursor",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mr6ba9kevc29esss5q3g5h42z4",
      "createdAt": "2025-08-07T15:21:00.000Z",
      "updatedAt": "2025-08-07T15:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17151.37,
      "currency": "GBP",
      "description": "Payment to Amwins Global Risks: AGR-202508-6613",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_btb0wmzbtpgn5bgm5hq0mrz9a6",
      "fspDate": "2025-08-07T14:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_btb0wmzbtpgn5bgm5hq0mrz9a6",
        "bookingDate": "2025-08-07",
        "valueDate": "2025-08-07",
        "bookingDateTime": "2025-08-07T15:21:00.000Z",
        "valueDateTime": "2025-08-07T15:21:00.000Z",
        "transactionAmount": {
          "amount": "17151.37",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amwins Global Risks: AGR-202508-6613",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amwins Global Risks",
          "AGR-202508-6613"
        ],
        "debtorName": "Amwins Global Risks"
      },
      "paymentId": null,
      "reference": "AGR-202508-6613",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2bfvhrjnbz808baykh",
      "clustering": {
        "description": "Amwins Global Risks",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amwins Global Risks' based on payment details",
        "updatedAt": "2025-08-07T15:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amwins Global Risks",
        "iban": null,
        "bic": null,
        "sortCode": "905426",
        "accountNumber": "33641291"
      }
    },
    {
      "id": "txn_01k65c32y4eshspg0gbyde1cqr",
      "createdAt": "2025-08-07T14:38:00.000Z",
      "updatedAt": "2025-08-07T14:38:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1506.71,
      "currency": "EUR",
      "description": "Upwork -824982385ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0vsmrxy1x28",
      "fspDate": "2025-08-07T13:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0vsmrxy1x28",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T14:00:00.000Z",
        "valueDateTime": "2026-01-08T14:00:00.000Z",
        "transactionAmount": {
          "amount": "-1506.71",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -824982385ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -824982385ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Upwork' from 'Upwork -824982385ref', removing '-824982385ref' suffix",
        "updatedAt": "2025-09-27T10:50:52.343Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_k951768b6qfadcwkvzt8qd52jv",
      "createdAt": "2025-08-07T12:11:00.000Z",
      "updatedAt": "2025-08-07T12:11:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2.96,
      "currency": "USD",
      "description": "Payment to Google Play: GP-202508-3602",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0wpmx441tggwd9gmh9vkc2twsg",
      "fspDate": "2025-08-07T11:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0wpmx441tggwd9gmh9vkc2twsg",
        "bookingDate": "2025-08-07",
        "valueDate": "2025-08-07",
        "bookingDateTime": "2025-08-07T12:11:00.000Z",
        "valueDateTime": "2025-08-07T12:11:00.000Z",
        "transactionAmount": {
          "amount": "2.96",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Google Play: GP-202508-3602",
        "remittanceInformationUnstructuredArray": [
          "Payment to Google Play",
          "GP-202508-3602"
        ],
        "debtorName": "Google Play"
      },
      "paymentId": null,
      "reference": "GP-202508-3602",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wjeeshsphy7nnkfq48b",
      "clustering": {
        "description": "Google Play",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Google Play' based on payment details",
        "updatedAt": "2025-08-07T12:11:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Google Play",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjmayhw6gmk74",
      "createdAt": "2025-08-07T11:53:00.000Z",
      "updatedAt": "2025-08-07T11:53:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1250.08,
      "currency": "GBP",
      "description": "To Adam Rankin",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk83a2fn9z1ed",
      "fspDate": "2025-08-07T10:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk83a2fn9z1ed",
        "bookingDate": "2025-08-07",
        "valueDate": "2025-08-07",
        "bookingDateTime": "2025-08-07T10:53:00.000Z",
        "valueDateTime": "2025-08-07T10:53:00.000Z",
        "transactionAmount": {
          "amount": "-1250.08",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Adam Rankin",
        "remittanceInformationUnstructuredArray": [
          "To Adam Rankin"
        ],
        "debtorName": "Adam Rankin"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2zfvhrjnc124tr3b2s",
      "clustering": {
        "description": "Adam Rankin",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core name 'Adam Rankin' from 'To Adam Rankin'",
        "updatedAt": "2025-09-29T18:24:29.670Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspeje66vftvcv",
      "createdAt": "2025-08-07T07:24:00.000Z",
      "updatedAt": "2025-08-07T07:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 39,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3jp8gs1e8prs7pdxntbn0m3",
      "fspDate": "2025-08-07T06:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3jp8gs1e8prs7pdxntbn0m3",
        "bookingDate": "2025-08-07",
        "valueDate": "2025-08-07",
        "bookingDateTime": "2025-08-07T06:24:00.000Z",
        "valueDateTime": "2025-08-07T06:24:00.000Z",
        "transactionAmount": {
          "amount": "-39.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'DocuSign' from 'Docusign'",
        "updatedAt": "2025-09-27T10:40:26.763Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgh3dnke61q1",
      "createdAt": "2025-08-06T14:27:00.000Z",
      "updatedAt": "2025-08-06T14:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 132.25,
      "currency": "EUR",
      "description": "Payment to GoCardless SAS: INV-SAS-59699",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jyh5tdcxfew8jfnwy7170dm9",
      "fspDate": "2025-08-06T13:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jyh5tdcxfew8jfnwy7170dm9",
        "bookingDate": "2025-08-06",
        "valueDate": "2025-08-06",
        "bookingDateTime": "2025-08-06T13:27:00.000Z",
        "valueDateTime": "2025-08-06T13:27:00.000Z",
        "transactionAmount": {
          "amount": "-132.25",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GoCardless SAS: INV-SAS-59699",
        "remittanceInformationUnstructuredArray": [
          "Payment to GoCardless SAS: INV-SAS-59699"
        ],
        "debtorName": "GoCardless SAS"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5k6eshspjzd728cagsr",
      "clustering": {
        "description": "GoCardless SAS",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'GoCardless SAS' from 'Payment to GoCardless SAS: INV-SAS-59699'.",
        "updatedAt": "2025-09-27T10:52:47.436Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspffd44t24zpm",
      "createdAt": "2025-08-06T13:54:00.000Z",
      "updatedAt": "2025-08-06T13:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4988.85,
      "currency": "EUR",
      "description": "Payment to Eoin Kelleher: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k10kr2d6e4dr6r44ravj4v8p",
      "fspDate": "2025-08-06T12:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k10kr2d6e4dr6r44ravj4v8p",
        "bookingDate": "2025-08-06",
        "valueDate": "2025-08-06",
        "bookingDateTime": "2025-08-06T12:54:00.000Z",
        "valueDateTime": "2025-08-06T12:54:00.000Z",
        "transactionAmount": {
          "amount": "-4988.85",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Eoin Kelleher: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Eoin Kelleher: July 2025 Payroll"
        ],
        "debtorName": "Eoin Kelleher"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zrteshspj73enyj46qt",
      "clustering": {
        "description": "Eoin Kelleher",
        "confidenceScore": "0.95",
        "rationale": "Extracted employee name 'Eoin Kelleher' from 'Payment to Eoin Kelleher: July 2025 Payroll'",
        "updatedAt": "2025-09-27T10:48:02.759Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1dsrvxyk8qmbdx9hc6jh6dd2nk",
      "createdAt": "2025-08-06T11:52:00.000Z",
      "updatedAt": "2025-08-06T11:52:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 15415.89,
      "currency": "GBP",
      "description": "Payment from SmartScale Solutions - INV-202508-3241",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4cyrk0cfdqdf9aqxk9dhja6h2z",
      "fspDate": "2025-08-06T10:52:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4cyrk0cfdqdf9aqxk9dhja6h2z",
        "bookingDate": "2025-08-06",
        "valueDate": "2025-08-06",
        "bookingDateTime": "2025-08-06T11:52:00.000Z",
        "valueDateTime": "2025-08-06T11:52:00.000Z",
        "transactionAmount": {
          "amount": "15415.89",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from SmartScale Solutions - INV-202508-3241",
        "remittanceInformationUnstructuredArray": [
          "Payment from SmartScale Solutions",
          "INV-202508-3241"
        ],
        "creditorName": "SmartScale Solutions"
      },
      "paymentId": null,
      "reference": "INV-202508-3241",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_k9wmdwkshbazmh9e7aq4wj85ej",
      "clustering": {
        "description": "SmartScale Solutions",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'SmartScale Solutions'",
        "updatedAt": "2025-08-06T11:52:00.000Z"
      },
      "payer": {
        "name": "SmartScale Solutions",
        "iban": null,
        "bic": null,
        "sortCode": "618445",
        "accountNumber": "28808510"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm9egdyq57gp",
      "createdAt": "2025-08-05T14:50:00.000Z",
      "updatedAt": "2025-08-05T14:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3000,
      "currency": "GBP",
      "description": "To Grow Your Boat Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hpe8pvk81t1jr8g8j5",
      "fspDate": "2025-08-05T13:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hpe8pvk81t1jr8g8j5",
        "bookingDate": "2026-01-13",
        "valueDate": "2026-01-13",
        "bookingDateTime": "2026-01-13T09:00:00.000Z",
        "valueDateTime": "2026-01-13T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Grow Your Boat Ltd",
        "remittanceInformationUnstructuredArray": [
          "To Grow Your Boat Ltd"
        ],
        "debtorName": "Grow Your Boat Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "clustering": {
        "description": "Grow Your Boat Ltd",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Grow Your Boat Ltd' from 'To Grow Your Boat Ltd'",
        "updatedAt": "2025-09-29T18:24:29.644Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfxxxk7j5zfa",
      "createdAt": "2025-08-05T13:49:00.000Z",
      "updatedAt": "2025-08-05T13:49:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.9,
      "currency": "EUR",
      "description": "Marquette",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0td003n221m",
      "fspDate": "2025-08-05T12:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0td003n221m",
        "bookingDate": "2025-08-05",
        "valueDate": "2025-08-05",
        "bookingDateTime": "2025-08-05T12:49:00.000Z",
        "valueDateTime": "2025-08-05T12:49:00.000Z",
        "transactionAmount": {
          "amount": "-17.90",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Marquette",
        "remittanceInformationUnstructuredArray": [
          "Marquette"
        ],
        "debtorName": "Marquette"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1npeshspm6wcf3gtsdh",
      "clustering": {
        "description": "Marquette",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Marquette' from 'Marquette'",
        "updatedAt": "2025-09-27T10:50:08.392Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_h73j6hr7y20e986jnqv20725s9",
      "createdAt": "2025-08-05T12:55:00.000Z",
      "updatedAt": "2025-08-05T12:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 131.12,
      "currency": "EUR",
      "description": "Payment to Slack: S-202508-9127",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_wedn6e1vns8mnjczkhmb6zsd75",
      "fspDate": "2025-08-05T11:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_wedn6e1vns8mnjczkhmb6zsd75",
        "bookingDate": "2025-08-05",
        "valueDate": "2025-08-05",
        "bookingDateTime": "2025-08-05T12:55:00.000Z",
        "valueDateTime": "2025-08-05T12:55:00.000Z",
        "transactionAmount": {
          "amount": "131.12",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack: S-202508-9127",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack",
          "S-202508-9127"
        ],
        "debtorName": "Slack"
      },
      "paymentId": null,
      "reference": "S-202508-9127",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtb9eshspk6e4wt4npvh",
      "clustering": {
        "description": "Slack",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack' based on payment details",
        "updatedAt": "2025-08-05T12:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack",
        "iban": "DE31510211612821916",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_w5twjgm78wr2gc5vcfccse4xhj",
      "createdAt": "2025-08-05T10:03:00.000Z",
      "updatedAt": "2025-08-05T10:03:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 27.14,
      "currency": "EUR",
      "description": "Payment to Dracula's Kitchen: DK-202508-4353",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_s8jvrmj5bfn7zbpjqmpvd1pbfm",
      "fspDate": "2025-08-05T09:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_s8jvrmj5bfn7zbpjqmpvd1pbfm",
        "bookingDate": "2025-08-05",
        "valueDate": "2025-08-05",
        "bookingDateTime": "2025-08-05T10:03:00.000Z",
        "valueDateTime": "2025-08-05T10:03:00.000Z",
        "transactionAmount": {
          "amount": "27.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Dracula's Kitchen: DK-202508-4353",
        "remittanceInformationUnstructuredArray": [
          "Payment to Dracula's Kitchen",
          "DK-202508-4353"
        ],
        "debtorName": "Dracula's Kitchen"
      },
      "paymentId": null,
      "reference": "DK-202508-4353",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcgeshspn9xska0mg5b",
      "clustering": {
        "description": "Dracula's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Dracula's Kitchen' based on payment details",
        "updatedAt": "2025-08-05T10:03:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Dracula's Kitchen",
        "iban": "DE78285611793610660",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfzbhwfdjw0f",
      "createdAt": "2025-08-05T07:13:00.000Z",
      "updatedAt": "2025-08-05T07:13:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 24.4,
      "currency": "EUR",
      "description": "Sumup *taxi Mffmppv7",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0veybwvjzt1",
      "fspDate": "2025-08-05T06:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0veybwvjzt1",
        "bookingDate": "2026-01-12",
        "valueDate": "2026-01-12",
        "bookingDateTime": "2026-01-12T07:00:00.000Z",
        "valueDateTime": "2026-01-12T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-24.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *taxi Mffmppv7",
        "remittanceInformationUnstructuredArray": [
          "Sumup *taxi Mffmppv7"
        ],
        "debtorName": "Taxi Service"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqn02eshspm8y4jy7tt7k",
      "clustering": {
        "description": "Taxi Service",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Taxi Service' from 'Sumup *taxi Mffmppv7'",
        "updatedAt": "2025-09-27T10:50:08.438Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebzafvhrjmvm860czz6q",
      "createdAt": "2025-08-04T15:13:00.000Z",
      "updatedAt": "2025-08-04T15:13:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2,
      "currency": "GBP",
      "description": "Sp Mylands",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8m2machmapf",
      "fspDate": "2025-08-04T14:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8m2machmapf",
        "bookingDate": "2025-08-04",
        "valueDate": "2025-08-04",
        "bookingDateTime": "2025-08-04T14:13:00.000Z",
        "valueDateTime": "2025-08-04T14:13:00.000Z",
        "transactionAmount": {
          "amount": "-2.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sp Mylands",
        "remittanceInformationUnstructuredArray": [
          "Sp Mylands"
        ],
        "debtorName": "Mylands"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbnxzzfvhrjp5np8trhg47",
      "clustering": {
        "description": "Mylands",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Mylands' from 'Sp Mylands'",
        "updatedAt": "2025-09-29T18:27:23.751Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg110g2m4n0k",
      "createdAt": "2025-08-04T14:55:00.000Z",
      "updatedAt": "2025-08-04T14:55:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 48,
      "currency": "EUR",
      "description": "Calendly",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0xe86j572rh",
      "fspDate": "2025-08-04T13:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0xe86j572rh",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T13:00:00.000Z",
        "valueDateTime": "2026-01-03T13:00:00.000Z",
        "transactionAmount": {
          "amount": "-48.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Calendly",
        "remittanceInformationUnstructuredArray": [
          "Calendly"
        ],
        "debtorName": "Calendly"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtc5eshspk6kqa7yaywk",
      "clustering": {
        "description": "Calendly",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Calendly' from 'Calendly'",
        "updatedAt": "2025-09-27T10:50:52.375Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vk8d22pfyq1h908722cya3acqw",
      "createdAt": "2025-08-04T13:19:00.000Z",
      "updatedAt": "2025-08-04T13:19:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 21,
      "currency": "EUR",
      "description": "Payment to Hotpot: H-202508-3738",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_n9wkazx5tsvwvtas8ytjgzh3ay",
      "fspDate": "2025-08-04T12:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_n9wkazx5tsvwvtas8ytjgzh3ay",
        "bookingDate": "2025-08-04",
        "valueDate": "2025-08-04",
        "bookingDateTime": "2025-08-04T13:19:00.000Z",
        "valueDateTime": "2025-08-04T13:19:00.000Z",
        "transactionAmount": {
          "amount": "21.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Hotpot: H-202508-3738",
        "remittanceInformationUnstructuredArray": [
          "Payment to Hotpot",
          "H-202508-3738"
        ],
        "debtorName": "Hotpot"
      },
      "paymentId": null,
      "reference": "H-202508-3738",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0wweshspkzqgyrcgqe7",
      "clustering": {
        "description": "Hotpot",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Hotpot' based on payment details",
        "updatedAt": "2025-08-04T13:19:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Hotpot",
        "iban": "DE46290491080022570",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_k06gmcp9m2vzsqcxcj02k8wjgx",
      "createdAt": "2025-08-04T11:44:00.000Z",
      "updatedAt": "2025-08-04T11:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.25,
      "currency": "GBP",
      "description": "Payment to Argos: A-202508-8936",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_g0jjc03rbkwsed2y5djt4tmy2m",
      "fspDate": "2025-08-04T10:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_g0jjc03rbkwsed2y5djt4tmy2m",
        "bookingDate": "2025-08-04",
        "valueDate": "2025-08-04",
        "bookingDateTime": "2025-08-04T11:44:00.000Z",
        "valueDateTime": "2025-08-04T11:44:00.000Z",
        "transactionAmount": {
          "amount": "25.25",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Argos: A-202508-8936",
        "remittanceInformationUnstructuredArray": [
          "Payment to Argos",
          "A-202508-8936"
        ],
        "debtorName": "Argos"
      },
      "paymentId": null,
      "reference": "A-202508-8936",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgp9fvhrjp1ker17rwy0",
      "clustering": {
        "description": "Argos",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Argos' based on payment details",
        "updatedAt": "2025-08-04T11:44:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Argos",
        "iban": null,
        "bic": null,
        "sortCode": "880289",
        "accountNumber": "48614945"
      }
    },
    {
      "id": "txn_01k65c32xzeshsper57dvsyxt6",
      "createdAt": "2025-08-04T10:53:00.000Z",
      "updatedAt": "2025-08-04T10:53:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 83.3,
      "currency": "EUR",
      "description": "Paddle.net* Open Excha",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k38cnkeheh2szmpramaq7ym1",
      "fspDate": "2025-08-04T09:53:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k38cnkeheh2szmpramaq7ym1",
        "bookingDate": "2025-08-04",
        "valueDate": "2025-08-04",
        "bookingDateTime": "2025-08-04T09:53:00.000Z",
        "valueDateTime": "2025-08-04T09:53:00.000Z",
        "transactionAmount": {
          "amount": "-83.30",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Paddle.net* Open Excha",
        "remittanceInformationUnstructuredArray": [
          "Paddle.net* Open Excha"
        ],
        "debtorName": "Paddle"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax3veshspjmhphswafsq",
      "clustering": {
        "description": "Paddle",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Paddle' from the 'Paddle.net* Open Excha' transaction description, removing the 'Paddle.net* ' prefix.",
        "updatedAt": "2025-09-27T10:41:48.163Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_c5062g9az8yv8581m04eyg07xf",
      "createdAt": "2025-08-04T10:31:00.000Z",
      "updatedAt": "2025-08-04T10:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 32.59,
      "currency": "EUR",
      "description": "Payment to Veremark: V-202508-4190",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bxk63pr3sa0smjf0ysg6m5ce45",
      "fspDate": "2025-08-04T09:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bxk63pr3sa0smjf0ysg6m5ce45",
        "bookingDate": "2025-08-04",
        "valueDate": "2025-08-04",
        "bookingDateTime": "2025-08-04T10:31:00.000Z",
        "valueDateTime": "2025-08-04T10:31:00.000Z",
        "transactionAmount": {
          "amount": "32.59",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Veremark: V-202508-4190",
        "remittanceInformationUnstructuredArray": [
          "Payment to Veremark",
          "V-202508-4190"
        ],
        "debtorName": "Veremark"
      },
      "paymentId": null,
      "reference": "V-202508-4190",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwc3eshspn9n53st1zft",
      "clustering": {
        "description": "Veremark",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Veremark' based on payment details",
        "updatedAt": "2025-08-04T10:31:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Veremark",
        "iban": "DE38233521581304160",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_w8kpha76dpg02bmfq8ne04byq0",
      "createdAt": "2025-08-04T09:56:00.000Z",
      "updatedAt": "2025-08-04T09:56:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1699.27,
      "currency": "EUR",
      "description": "Payment to Patrick Walsh: PW-202508-8856",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_dj6r2t3aeh6qqfng1pfv25bm4d",
      "fspDate": "2025-08-04T08:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_dj6r2t3aeh6qqfng1pfv25bm4d",
        "bookingDate": "2025-08-04",
        "valueDate": "2025-08-04",
        "bookingDateTime": "2025-08-04T09:56:00.000Z",
        "valueDateTime": "2025-08-04T09:56:00.000Z",
        "transactionAmount": {
          "amount": "1699.27",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Patrick Walsh: PW-202508-8856",
        "remittanceInformationUnstructuredArray": [
          "Payment to Patrick Walsh",
          "PW-202508-8856"
        ],
        "debtorName": "Patrick Walsh"
      },
      "paymentId": null,
      "reference": "PW-202508-8856",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqmzweshspm8kq27v8562",
      "clustering": {
        "description": "Patrick Walsh",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Patrick Walsh' based on payment details",
        "updatedAt": "2025-08-04T09:56:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Patrick Walsh",
        "iban": "DE19517557040725704",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg433qhft2e6",
      "createdAt": "2025-08-04T08:37:00.000Z",
      "updatedAt": "2025-08-04T08:37:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 98.4,
      "currency": "EUR",
      "description": "Figma",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk11g9dkzn3mr",
      "fspDate": "2025-08-04T07:37:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk11g9dkzn3mr",
        "bookingDate": "2025-08-04",
        "valueDate": "2025-08-04",
        "bookingDateTime": "2025-08-04T07:37:00.000Z",
        "valueDateTime": "2025-08-04T07:37:00.000Z",
        "transactionAmount": {
          "amount": "-98.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Figma",
        "remittanceInformationUnstructuredArray": [
          "Figma"
        ],
        "debtorName": "Figma"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdq3eshspk9qt2a4er00",
      "clustering": {
        "description": "Figma",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Figma' from 'Figma', removing all prefixes and suffixes.",
        "updatedAt": "2025-09-27T10:51:38.155Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfh3zbvsvhbd",
      "createdAt": "2025-08-04T07:45:00.000Z",
      "updatedAt": "2025-08-04T07:45:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 0.01,
      "currency": "EUR",
      "description": "Payment to Emma Fitzgerald: Penny test - payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0xvewqdfvqsnjbtk72jzm0h",
      "fspDate": "2025-08-04T06:45:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xvewqdfvqsnjbtk72jzm0h",
        "bookingDate": "2025-12-03",
        "valueDate": "2025-12-03",
        "bookingDateTime": "2025-12-03T15:27:00.000Z",
        "valueDateTime": "2025-12-03T15:27:00.000Z",
        "transactionAmount": {
          "amount": "-0.01",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Emma Fitzgerald: Penny test - payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Emma Fitzgerald: Penny test - payroll"
        ],
        "debtorName": "Emma Fitzgerald"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtceshspj98ga0ebagk",
      "clustering": {
        "description": "Payment to Emma Fitzgerald",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core description 'Payment to Emma Fitzgerald' from the raw transaction record, removing the 'Penny test - payroll' suffix.",
        "updatedAt": "2025-09-27T10:49:12.155Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph3r3tgdsbs8",
      "createdAt": "2025-08-03T13:54:00.000Z",
      "updatedAt": "2025-08-03T13:54:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk228cvqqmyw6",
      "fspDate": "2025-08-03T12:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk228cvqqmyw6",
        "bookingDate": "2026-01-03",
        "valueDate": "2026-01-03",
        "bookingDateTime": "2026-01-03T10:00:00.000Z",
        "valueDateTime": "2026-01-03T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Burger Cartel' from 'Burger Cartel Limited'",
        "updatedAt": "2025-09-27T10:54:50.809Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_j06fns6d9m95t4tg35c1qv3a5f",
      "createdAt": "2025-08-03T13:42:00.000Z",
      "updatedAt": "2025-08-03T13:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12.2,
      "currency": "EUR",
      "description": "Payment to Jarek's Kitchen: JK-202508-8223",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_bx1jnpyphn4sf6myqhbz876p61",
      "fspDate": "2025-08-03T12:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_bx1jnpyphn4sf6myqhbz876p61",
        "bookingDate": "2025-08-03",
        "valueDate": "2025-08-03",
        "bookingDateTime": "2025-08-03T13:42:00.000Z",
        "valueDateTime": "2025-08-03T13:42:00.000Z",
        "transactionAmount": {
          "amount": "12.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jarek's Kitchen: JK-202508-8223",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jarek's Kitchen",
          "JK-202508-8223"
        ],
        "debtorName": "Jarek's Kitchen"
      },
      "paymentId": null,
      "reference": "JK-202508-8223",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9ynmeshspjjhrjb91rve",
      "clustering": {
        "description": "Jarek's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Jarek's Kitchen' based on payment details",
        "updatedAt": "2025-08-03T13:42:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Jarek's Kitchen",
        "iban": "DE36858039909154110",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspeqkqc613gcg",
      "createdAt": "2025-08-03T11:34:00.000Z",
      "updatedAt": "2025-08-03T11:34:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 12372.49,
      "currency": "EUR",
      "description": "Payment to Remote Europe Holding BV: 050IN25070798",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k38vp6n8eh2t0e6m1sghygnm",
      "fspDate": "2025-08-03T10:34:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k38vp6n8eh2t0e6m1sghygnm",
        "bookingDate": "2025-08-03",
        "valueDate": "2025-08-03",
        "bookingDateTime": "2025-08-03T10:34:00.000Z",
        "valueDateTime": "2025-08-03T10:34:00.000Z",
        "transactionAmount": {
          "amount": "-12372.49",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Remote Europe Holding BV: 050IN25070798",
        "remittanceInformationUnstructuredArray": [
          "Payment to Remote Europe Holding BV: 050IN25070798"
        ],
        "debtorName": "Remote Europe Holding BV"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pz7eshspjhbnt16ttyt",
      "clustering": {
        "description": "Remote Europe Holding BV",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Remote Europe Holding BV' from the transaction description.",
        "updatedAt": "2025-09-27T10:41:48.147Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8e0qj7aatjk96fz6bf33cjh8a7",
      "createdAt": "2025-08-03T09:40:00.000Z",
      "updatedAt": "2025-08-03T09:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 130.87,
      "currency": "EUR",
      "description": "Payment to Naomi's Kitchen: NK-202508-1899",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nkw70y0a5dfzpwvw71gr4zw65n",
      "fspDate": "2025-08-03T08:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nkw70y0a5dfzpwvw71gr4zw65n",
        "bookingDate": "2025-08-03",
        "valueDate": "2025-08-03",
        "bookingDateTime": "2025-08-03T09:40:00.000Z",
        "valueDateTime": "2025-08-03T09:40:00.000Z",
        "transactionAmount": {
          "amount": "130.87",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Naomi's Kitchen: NK-202508-1899",
        "remittanceInformationUnstructuredArray": [
          "Payment to Naomi's Kitchen",
          "NK-202508-1899"
        ],
        "debtorName": "Naomi's Kitchen"
      },
      "paymentId": null,
      "reference": "NK-202508-1899",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh3deshspkhegxj7z9nq",
      "clustering": {
        "description": "Naomi's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Naomi's Kitchen' based on payment details",
        "updatedAt": "2025-08-03T09:40:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Naomi's Kitchen",
        "iban": "DE93565570327055800",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspegc469zxcky",
      "createdAt": "2025-08-03T07:41:00.000Z",
      "updatedAt": "2025-08-03T07:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 8.6,
      "currency": "EUR",
      "description": "Github, Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3n8n6ekeh2tcapws3ywav36",
      "fspDate": "2025-08-03T06:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n6ekeh2tcapws3ywav36",
        "bookingDate": "2025-08-03",
        "valueDate": "2025-08-03",
        "bookingDateTime": "2025-08-03T06:41:00.000Z",
        "valueDateTime": "2025-08-03T06:41:00.000Z",
        "transactionAmount": {
          "amount": "-8.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Github, Inc.",
        "remittanceInformationUnstructuredArray": [
          "Github, Inc."
        ],
        "debtorName": "GitHub"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wd4eshsphxfd9s33j9t",
      "clustering": {
        "description": "Github",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Github' from 'Github, Inc.'.",
        "updatedAt": "2025-09-27T10:39:39.684Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bkqcq35k9qcav2hy4mdgbt3pny",
      "createdAt": "2025-08-02T15:48:00.000Z",
      "updatedAt": "2025-08-02T15:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 47.91,
      "currency": "GBP",
      "description": "Payment to Deliveroo: D-202508-7471",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ptjrt9vkzx5ynt3ar0zykf31q8",
      "fspDate": "2025-08-02T14:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ptjrt9vkzx5ynt3ar0zykf31q8",
        "bookingDate": "2025-08-02",
        "valueDate": "2025-08-02",
        "bookingDateTime": "2025-08-02T15:48:00.000Z",
        "valueDateTime": "2025-08-02T15:48:00.000Z",
        "transactionAmount": {
          "amount": "47.91",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Deliveroo: D-202508-7471",
        "remittanceInformationUnstructuredArray": [
          "Payment to Deliveroo",
          "D-202508-7471"
        ],
        "debtorName": "Deliveroo"
      },
      "paymentId": null,
      "reference": "D-202508-7471",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmcfvhrjp16bczghe88",
      "clustering": {
        "description": "Deliveroo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Deliveroo' based on payment details",
        "updatedAt": "2025-08-02T15:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Deliveroo",
        "iban": null,
        "bic": null,
        "sortCode": "185240",
        "accountNumber": "58592287"
      }
    },
    {
      "id": "txn_rdtbyem6922gmj1ccgwrjagx7d",
      "createdAt": "2025-08-02T14:12:00.000Z",
      "updatedAt": "2025-08-02T14:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 30.18,
      "currency": "USD",
      "description": "Payment to Superhuman: S-202508-9192",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xywg5affxbx9895en2yg9kw3d2",
      "fspDate": "2025-08-02T13:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xywg5affxbx9895en2yg9kw3d2",
        "bookingDate": "2025-08-02",
        "valueDate": "2025-08-02",
        "bookingDateTime": "2025-08-02T14:12:00.000Z",
        "valueDateTime": "2025-08-02T14:12:00.000Z",
        "transactionAmount": {
          "amount": "30.18",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Superhuman: S-202508-9192",
        "remittanceInformationUnstructuredArray": [
          "Payment to Superhuman",
          "S-202508-9192"
        ],
        "debtorName": "Superhuman"
      },
      "paymentId": null,
      "reference": "S-202508-9192",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5mceshspjzn83y9tqy1",
      "clustering": {
        "description": "Superhuman",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Superhuman' based on payment details",
        "updatedAt": "2025-08-02T14:12:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Superhuman",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_j0z78dagqwbj7e8r689azd2za4",
      "createdAt": "2025-08-02T13:14:00.000Z",
      "updatedAt": "2025-08-02T13:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.78,
      "currency": "EUR",
      "description": "Payment to Tortilla Latin Food: TLF-202508-6197",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_x5cr37ks13y97qr04wc5mn5pb4",
      "fspDate": "2025-08-02T12:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_x5cr37ks13y97qr04wc5mn5pb4",
        "bookingDate": "2025-08-02",
        "valueDate": "2025-08-02",
        "bookingDateTime": "2025-08-02T13:14:00.000Z",
        "valueDateTime": "2025-08-02T13:14:00.000Z",
        "transactionAmount": {
          "amount": "10.78",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tortilla Latin Food: TLF-202508-6197",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tortilla Latin Food",
          "TLF-202508-6197"
        ],
        "debtorName": "Tortilla Latin Food"
      },
      "paymentId": null,
      "reference": "TLF-202508-6197",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspgkeshspmp0mmzf2w0c",
      "clustering": {
        "description": "Tortilla Latin Food",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tortilla Latin Food' based on payment details",
        "updatedAt": "2025-08-02T13:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tortilla Latin Food",
        "iban": "DE71238556164220400",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ccmvca2yjwt50j824n3cgq03e4",
      "createdAt": "2025-08-01T11:46:00.000Z",
      "updatedAt": "2025-08-01T11:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1.91,
      "currency": "EUR",
      "description": "Payment to Merrion Row Post Office: MRP-202508-5216",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_sb8ntg95cka5sst23sthq4pwcx",
      "fspDate": "2025-08-01T10:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_sb8ntg95cka5sst23sthq4pwcx",
        "bookingDate": "2025-08-01",
        "valueDate": "2025-08-01",
        "bookingDateTime": "2025-08-01T11:46:00.000Z",
        "valueDateTime": "2025-08-01T11:46:00.000Z",
        "transactionAmount": {
          "amount": "1.91",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Merrion Row Post Office: MRP-202508-5216",
        "remittanceInformationUnstructuredArray": [
          "Payment to Merrion Row Post Office",
          "MRP-202508-5216"
        ],
        "debtorName": "Merrion Row Post Office"
      },
      "paymentId": null,
      "reference": "MRP-202508-5216",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj0neshspngm4dw1pq8h",
      "clustering": {
        "description": "Merrion Row Post Office",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Merrion Row Post Office' based on payment details",
        "updatedAt": "2025-08-01T11:46:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Merrion Row Post Office",
        "iban": "DE20522052583714840",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_s3982fhkj3pmj9q3q7tnr4jdzq",
      "createdAt": "2025-08-01T09:14:00.000Z",
      "updatedAt": "2025-08-01T09:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 41.19,
      "currency": "EUR",
      "description": "Payment to Zakura: Z-202508-6062",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_n88zb4mhyk7rjjvcqjwmzrfws1",
      "fspDate": "2025-08-01T08:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_n88zb4mhyk7rjjvcqjwmzrfws1",
        "bookingDate": "2025-08-01",
        "valueDate": "2025-08-01",
        "bookingDateTime": "2025-08-01T09:14:00.000Z",
        "valueDateTime": "2025-08-01T09:14:00.000Z",
        "transactionAmount": {
          "amount": "41.19",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Zakura: Z-202508-6062",
        "remittanceInformationUnstructuredArray": [
          "Payment to Zakura",
          "Z-202508-6062"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": "Z-202508-6062",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Zakura' based on payment details",
        "updatedAt": "2025-08-01T09:14:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Zakura",
        "iban": "DE14241648546823960",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_1d4bgf5twz6apqy3267s476h30",
      "createdAt": "2025-08-01T08:49:00.000Z",
      "updatedAt": "2025-08-01T08:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 39.31,
      "currency": "GBP",
      "description": "Payment to Financial Times: FT-202508-5849",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_yc58wac8d8xm8hytwry25aw6m1",
      "fspDate": "2025-08-01T07:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_yc58wac8d8xm8hytwry25aw6m1",
        "bookingDate": "2025-08-01",
        "valueDate": "2025-08-01",
        "bookingDateTime": "2025-08-01T08:49:00.000Z",
        "valueDateTime": "2025-08-01T08:49:00.000Z",
        "transactionAmount": {
          "amount": "39.31",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Financial Times: FT-202508-5849",
        "remittanceInformationUnstructuredArray": [
          "Payment to Financial Times",
          "FT-202508-5849"
        ],
        "debtorName": "Financial Times"
      },
      "paymentId": null,
      "reference": "FT-202508-5849",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gjeshspjygqrrg6sk5",
      "clustering": {
        "description": "Financial Times",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Financial Times' based on payment details",
        "updatedAt": "2025-08-01T08:49:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Financial Times",
        "iban": null,
        "bic": null,
        "sortCode": "845097",
        "accountNumber": "91880761"
      }
    },
    {
      "id": "txn_c2gg7enpqecmf9632f8381v324",
      "createdAt": "2025-07-31T15:57:00.000Z",
      "updatedAt": "2025-07-31T15:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.95,
      "currency": "USD",
      "description": "Payment to Figma: F-202507-6459",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ayv1ewj4rwqnxm7rbmfgpr8r0c",
      "fspDate": "2025-07-31T14:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ayv1ewj4rwqnxm7rbmfgpr8r0c",
        "bookingDate": "2025-07-31",
        "valueDate": "2025-07-31",
        "bookingDateTime": "2025-07-31T15:57:00.000Z",
        "valueDateTime": "2025-07-31T15:57:00.000Z",
        "transactionAmount": {
          "amount": "14.95",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Figma: F-202507-6459",
        "remittanceInformationUnstructuredArray": [
          "Payment to Figma",
          "F-202507-6459"
        ],
        "debtorName": "Figma"
      },
      "paymentId": null,
      "reference": "F-202507-6459",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdq3eshspk9qt2a4er00",
      "clustering": {
        "description": "Figma",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Figma' based on payment details",
        "updatedAt": "2025-07-31T15:57:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Figma",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_hjd1jkv9dds134vnrnf9cmqcs0",
      "createdAt": "2025-07-31T15:01:00.000Z",
      "updatedAt": "2025-07-31T15:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3087.72,
      "currency": "EUR",
      "description": "Payment to Marta Kowalska Consulting: MKC-202507-6328",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_22c22q77t8pactfvxtt9dka8vz",
      "fspDate": "2025-07-31T14:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_22c22q77t8pactfvxtt9dka8vz",
        "bookingDate": "2025-07-31",
        "valueDate": "2025-07-31",
        "bookingDateTime": "2025-07-31T15:01:00.000Z",
        "valueDateTime": "2025-07-31T15:01:00.000Z",
        "transactionAmount": {
          "amount": "3087.72",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marta Kowalska Consulting: MKC-202507-6328",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marta Kowalska Consulting",
          "MKC-202507-6328"
        ],
        "debtorName": "Marta Kowalska Consulting"
      },
      "paymentId": null,
      "reference": "MKC-202507-6328",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj39eshspnh92mjbyz8s",
      "clustering": {
        "description": "Marta Kowalska Consulting",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marta Kowalska Consulting' based on payment details",
        "updatedAt": "2025-07-31T15:01:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marta Kowalska Consulting",
        "iban": "DE56753600531710950",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nybnzj93gtjnn933c7fb0zn0ze",
      "createdAt": "2025-07-31T13:43:00.000Z",
      "updatedAt": "2025-07-31T13:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5.24,
      "currency": "GBP",
      "description": "Payment to Pret A Manger: PAM-202507-6098",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_md8fk91rdsbnqc1nptyh15yz70",
      "fspDate": "2025-07-31T12:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_md8fk91rdsbnqc1nptyh15yz70",
        "bookingDate": "2025-07-31",
        "valueDate": "2025-07-31",
        "bookingDateTime": "2025-07-31T13:43:00.000Z",
        "valueDateTime": "2025-07-31T13:43:00.000Z",
        "transactionAmount": {
          "amount": "5.24",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pret A Manger: PAM-202507-6098",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pret A Manger",
          "PAM-202507-6098"
        ],
        "debtorName": "Pret A Manger"
      },
      "paymentId": null,
      "reference": "PAM-202507-6098",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crphqeshspmfftkxpt85b",
      "clustering": {
        "description": "Pret A Manger",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pret A Manger' based on payment details",
        "updatedAt": "2025-07-31T13:43:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pret A Manger",
        "iban": null,
        "bic": null,
        "sortCode": "348797",
        "accountNumber": "30056601"
      }
    },
    {
      "id": "txn_e923f41x732zfn2r30xy69qd5a",
      "createdAt": "2025-07-31T12:50:00.000Z",
      "updatedAt": "2025-07-31T12:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 122.49,
      "currency": "EUR",
      "description": "Payment to Naomi's Kitchen: NK-202507-6861",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zemgdqe4mc4ze5q5fcp5yhjcqp",
      "fspDate": "2025-07-31T11:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zemgdqe4mc4ze5q5fcp5yhjcqp",
        "bookingDate": "2025-07-31",
        "valueDate": "2025-07-31",
        "bookingDateTime": "2025-07-31T12:50:00.000Z",
        "valueDateTime": "2025-07-31T12:50:00.000Z",
        "transactionAmount": {
          "amount": "122.49",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Naomi's Kitchen: NK-202507-6861",
        "remittanceInformationUnstructuredArray": [
          "Payment to Naomi's Kitchen",
          "NK-202507-6861"
        ],
        "debtorName": "Naomi's Kitchen"
      },
      "paymentId": null,
      "reference": "NK-202507-6861",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh3deshspkhegxj7z9nq",
      "clustering": {
        "description": "Naomi's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Naomi's Kitchen' based on payment details",
        "updatedAt": "2025-07-31T12:50:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Naomi's Kitchen",
        "iban": "DE11363553618167704",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jcjavgamqpdeywnz6hbv65sbg9",
      "createdAt": "2025-07-31T11:51:00.000Z",
      "updatedAt": "2025-07-31T11:51:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 864.66,
      "currency": "EUR",
      "description": "Payment to Denis Breen & Co: DB&-202507-6261",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w2a3t1j7jkw6y7wn7m1pskcmst",
      "fspDate": "2025-07-31T10:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w2a3t1j7jkw6y7wn7m1pskcmst",
        "bookingDate": "2025-07-31",
        "valueDate": "2025-07-31",
        "bookingDateTime": "2025-07-31T11:51:00.000Z",
        "valueDateTime": "2025-07-31T11:51:00.000Z",
        "transactionAmount": {
          "amount": "864.66",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Denis Breen & Co: DB&-202507-6261",
        "remittanceInformationUnstructuredArray": [
          "Payment to Denis Breen & Co",
          "DB&-202507-6261"
        ],
        "debtorName": "Denis Breen & Co"
      },
      "paymentId": null,
      "reference": "DB&-202507-6261",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zb1eshspj0854px1k2v",
      "clustering": {
        "description": "Denis Breen & Co",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Denis Breen & Co' based on payment details",
        "updatedAt": "2025-07-31T11:51:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Denis Breen & Co",
        "iban": "DE31779696494157470",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_n7wwfsmen701snpz3wj7pbrysv",
      "createdAt": "2025-07-31T10:48:00.000Z",
      "updatedAt": "2025-07-31T10:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 18.61,
      "currency": "EUR",
      "description": "Payment to Tang: T-202507-1384",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zz3r57bqtdy738p6dybeetjcqg",
      "fspDate": "2025-07-31T09:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zz3r57bqtdy738p6dybeetjcqg",
        "bookingDate": "2025-07-31",
        "valueDate": "2025-07-31",
        "bookingDateTime": "2025-07-31T10:48:00.000Z",
        "valueDateTime": "2025-07-31T10:48:00.000Z",
        "transactionAmount": {
          "amount": "18.61",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tang: T-202507-1384",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tang",
          "T-202507-1384"
        ],
        "debtorName": "Tang"
      },
      "paymentId": null,
      "reference": "T-202507-1384",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gseshspjyrwgx4ccwg",
      "clustering": {
        "description": "Tang",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tang' based on payment details",
        "updatedAt": "2025-07-31T10:48:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tang",
        "iban": "DE78986318513183570",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8h60ba16f05npjtd977px7mhpf",
      "createdAt": "2025-07-31T09:52:00.000Z",
      "updatedAt": "2025-07-31T09:52:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 21.63,
      "currency": "EUR",
      "description": "Payment to Mak Slim Foods: MSF-202507-8829",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_g2hkj9kyjz9gbwvdjf3dawkzp7",
      "fspDate": "2025-07-31T08:52:00.000Z",
      "fspRecord": {
        "transactionId": "txn_g2hkj9kyjz9gbwvdjf3dawkzp7",
        "bookingDate": "2025-07-31",
        "valueDate": "2025-07-31",
        "bookingDateTime": "2025-07-31T09:52:00.000Z",
        "valueDateTime": "2025-07-31T09:52:00.000Z",
        "transactionAmount": {
          "amount": "21.63",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mak Slim Foods: MSF-202507-8829",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mak Slim Foods",
          "MSF-202507-8829"
        ],
        "debtorName": "Mak Slim Foods"
      },
      "paymentId": null,
      "reference": "MSF-202507-8829",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2yeshspkgyzwx8hqrq",
      "clustering": {
        "description": "Mak Slim Foods",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mak Slim Foods' based on payment details",
        "updatedAt": "2025-07-31T09:52:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mak Slim Foods",
        "iban": "DE12523146927729656",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2fnk393sqj0779qwyrq22ha55j",
      "createdAt": "2025-07-31T08:54:00.000Z",
      "updatedAt": "2025-07-31T08:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.16,
      "currency": "USD",
      "description": "Payment to Reflect Software: RS-202507-9196",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_48vk9brd75fk9ecrrngzjjjykn",
      "fspDate": "2025-07-31T07:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_48vk9brd75fk9ecrrngzjjjykn",
        "bookingDate": "2025-07-31",
        "valueDate": "2025-07-31",
        "bookingDateTime": "2025-07-31T08:54:00.000Z",
        "valueDateTime": "2025-07-31T08:54:00.000Z",
        "transactionAmount": {
          "amount": "10.16",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Reflect Software: RS-202507-9196",
        "remittanceInformationUnstructuredArray": [
          "Payment to Reflect Software",
          "RS-202507-9196"
        ],
        "debtorName": "Reflect Software"
      },
      "paymentId": null,
      "reference": "RS-202507-9196",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wfmeshsphxg0s376ywm",
      "clustering": {
        "description": "Reflect Software",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Reflect Software' based on payment details",
        "updatedAt": "2025-07-31T08:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Reflect Software",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pr492dbzpc853c6jmm0zc55v1m",
      "createdAt": "2025-07-30T14:46:00.000Z",
      "updatedAt": "2025-07-30T14:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 17381.86,
      "currency": "GBP",
      "description": "Payment to Amwins Global Risks: AGR-202507-9819",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_ncqeyff9ma3n5kf6h43jpq55x6",
      "fspDate": "2025-07-30T13:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_ncqeyff9ma3n5kf6h43jpq55x6",
        "bookingDate": "2025-07-30",
        "valueDate": "2025-07-30",
        "bookingDateTime": "2025-07-30T14:46:00.000Z",
        "valueDateTime": "2025-07-30T14:46:00.000Z",
        "transactionAmount": {
          "amount": "17381.86",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amwins Global Risks: AGR-202507-9819",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amwins Global Risks",
          "AGR-202507-9819"
        ],
        "debtorName": "Amwins Global Risks"
      },
      "paymentId": null,
      "reference": "AGR-202507-9819",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2bfvhrjnbz808baykh",
      "clustering": {
        "description": "Amwins Global Risks",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amwins Global Risks' based on payment details",
        "updatedAt": "2025-07-30T14:46:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amwins Global Risks",
        "iban": null,
        "bic": null,
        "sortCode": "732320",
        "accountNumber": "22092570"
      }
    },
    {
      "id": "txn_629yhda1en9hq93zb66gw69bhj",
      "createdAt": "2025-07-30T12:36:00.000Z",
      "updatedAt": "2025-07-30T12:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 36076.72,
      "currency": "GBP",
      "description": "Payment from Enterprise Systems Inc - INV-202507-8191",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vkv2bsnfxz7q0asvzj12vkvdcp",
      "fspDate": "2025-07-30T11:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vkv2bsnfxz7q0asvzj12vkvdcp",
        "bookingDate": "2025-07-30",
        "valueDate": "2025-07-30",
        "bookingDateTime": "2025-07-30T12:36:00.000Z",
        "valueDateTime": "2025-07-30T12:36:00.000Z",
        "transactionAmount": {
          "amount": "36076.72",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Enterprise Systems Inc - INV-202507-8191",
        "remittanceInformationUnstructuredArray": [
          "Payment from Enterprise Systems Inc",
          "INV-202507-8191"
        ],
        "creditorName": "Enterprise Systems Inc"
      },
      "paymentId": null,
      "reference": "INV-202507-8191",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1jqt0xq8p3az0ed45aqq7npx6w",
      "clustering": {
        "description": "Enterprise Systems Inc",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Enterprise Systems Inc'",
        "updatedAt": "2025-07-30T12:36:00.000Z"
      },
      "payer": {
        "name": "Enterprise Systems Inc",
        "iban": null,
        "bic": null,
        "sortCode": "810675",
        "accountNumber": "61425399"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nfkt78k2ep1xcwydjdh30pggpe",
      "createdAt": "2025-07-30T11:38:00.000Z",
      "updatedAt": "2025-07-30T11:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.37,
      "currency": "EUR",
      "description": "Payment to An Post: AP-202507-4112",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5831d76k1wt435skhn90pggdp0",
      "fspDate": "2025-07-30T10:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5831d76k1wt435skhn90pggdp0",
        "bookingDate": "2025-07-30",
        "valueDate": "2025-07-30",
        "bookingDateTime": "2025-07-30T11:38:00.000Z",
        "valueDateTime": "2025-07-30T11:38:00.000Z",
        "transactionAmount": {
          "amount": "3.37",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to An Post: AP-202507-4112",
        "remittanceInformationUnstructuredArray": [
          "Payment to An Post",
          "AP-202507-4112"
        ],
        "debtorName": "An Post"
      },
      "paymentId": null,
      "reference": "AP-202507-4112",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwdneshspna9pr7b1tc2",
      "clustering": {
        "description": "An Post",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'An Post' based on payment details",
        "updatedAt": "2025-07-30T11:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "An Post",
        "iban": "DE76877723964468270",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_kyhspjxzshtxdz8t5nhkxjxc9s",
      "createdAt": "2025-07-29T13:07:00.000Z",
      "updatedAt": "2025-07-29T13:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 13.29,
      "currency": "EUR",
      "description": "Payment to Mama's Boy: MB-202507-4838",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_gjc2ate5hv4h5k21sea1m80f2v",
      "fspDate": "2025-07-29T12:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_gjc2ate5hv4h5k21sea1m80f2v",
        "bookingDate": "2025-07-29",
        "valueDate": "2025-07-29",
        "bookingDateTime": "2025-07-29T13:07:00.000Z",
        "valueDateTime": "2025-07-29T13:07:00.000Z",
        "transactionAmount": {
          "amount": "13.29",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mama's Boy: MB-202507-4838",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mama's Boy",
          "MB-202507-4838"
        ],
        "debtorName": "Mama's Boy"
      },
      "paymentId": null,
      "reference": "MB-202507-4838",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcneshspna4jnfvyh0c",
      "clustering": {
        "description": "Mama's Boy",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mama's Boy' based on payment details",
        "updatedAt": "2025-07-29T13:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mama's Boy",
        "iban": "DE98637936096061500",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmekz51wa1rz",
      "createdAt": "2025-07-29T12:00:00.000Z",
      "updatedAt": "2025-07-29T12:00:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 1792.04,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk874z4h1xjv3",
      "fspDate": "2025-07-29T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk874z4h1xjv3",
        "bookingDate": "2025-07-29",
        "valueDate": "2025-07-29",
        "bookingDateTime": "2025-07-29T11:00:00.000Z",
        "valueDateTime": "2025-07-29T11:00:00.000Z",
        "transactionAmount": {
          "amount": "1792.04",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.139Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_77xqnwvw3e2h3f53mq27p7nhn2",
      "createdAt": "2025-07-29T11:44:00.000Z",
      "updatedAt": "2025-07-29T11:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 26.44,
      "currency": "EUR",
      "description": "Payment to XAI: X-202507-6340",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4kb5cmwdvpk5mbmg3gemyma7v4",
      "fspDate": "2025-07-29T10:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4kb5cmwdvpk5mbmg3gemyma7v4",
        "bookingDate": "2025-07-29",
        "valueDate": "2025-07-29",
        "bookingDateTime": "2025-07-29T11:44:00.000Z",
        "valueDateTime": "2025-07-29T11:44:00.000Z",
        "transactionAmount": {
          "amount": "26.44",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to XAI: X-202507-6340",
        "remittanceInformationUnstructuredArray": [
          "Payment to XAI",
          "X-202507-6340"
        ],
        "debtorName": "XAI"
      },
      "paymentId": null,
      "reference": "X-202507-6340",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgt8yeshspk60ezf5bsne",
      "clustering": {
        "description": "XAI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'XAI' based on payment details",
        "updatedAt": "2025-07-29T11:44:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "XAI",
        "iban": "DE30277257996434480",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm95391azv3p",
      "createdAt": "2025-07-29T11:29:00.000Z",
      "updatedAt": "2025-07-29T11:29:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 9454,
      "currency": "GBP",
      "description": "SEAPOINT FINANCE  LIMITED. From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0xwbp37fq9r9ascwgdz6hnb",
      "fspDate": "2025-07-29T10:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xwbp37fq9r9ascwgdz6hnb",
        "bookingDate": "2025-12-07",
        "valueDate": "2025-12-07",
        "bookingDateTime": "2025-12-07T10:46:00.000Z",
        "valueDateTime": "2025-12-07T10:46:00.000Z",
        "transactionAmount": {
          "amount": "9454.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "From SEAPOINT FINANCE UK INVESTMENTS LIMITED",
        "remittanceInformationUnstructuredArray": [
          "From SEAPOINT FINANCE UK INVESTMENTS LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance Uk Investments Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Seapoint Finance Uk Investments Limited' from 'From SEAPOINT FINANCE UK INVESTMENTS LIMITED'",
        "updatedAt": "2025-09-29T18:24:29.635Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshsperj87rgkja7",
      "createdAt": "2025-07-28T16:46:00.000Z",
      "updatedAt": "2025-07-28T16:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.17,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k35t8tvce8prf08qankg2533",
      "fspDate": "2025-07-28T15:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k35t8tvce8prf08qankg2533",
        "bookingDate": "2025-07-28",
        "valueDate": "2025-07-28",
        "bookingDateTime": "2025-07-28T15:46:00.000Z",
        "valueDateTime": "2025-07-28T15:46:00.000Z",
        "transactionAmount": {
          "amount": "-17.17",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Cursor' from the 'Cursor, Ai Powered Ide' transaction description.",
        "updatedAt": "2025-09-27T10:41:48.173Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf2kr5tmmgpn",
      "createdAt": "2025-07-28T16:39:00.000Z",
      "updatedAt": "2025-07-28T16:39:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 209.72,
      "currency": "EUR",
      "description": "Notion Labs, Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k21rq21jf2181cbffqm7ge68",
      "fspDate": "2025-07-28T15:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k21rq21jf2181cbffqm7ge68",
        "bookingDate": "2025-07-28",
        "valueDate": "2025-07-28",
        "bookingDateTime": "2025-07-28T15:39:00.000Z",
        "valueDateTime": "2025-07-28T15:39:00.000Z",
        "transactionAmount": {
          "amount": "-209.72",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Notion Labs, Inc.",
        "remittanceInformationUnstructuredArray": [
          "Notion Labs, Inc."
        ],
        "debtorName": "Notion"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtcyeshspk6y0e76tesb",
      "clustering": {
        "description": "Notion",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Notion' from the transaction description, removing the 'Labs, Inc.' details.",
        "updatedAt": "2025-09-27T10:43:55.467Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3qp3mxfvcbkxywcfx2h9bhgszx",
      "createdAt": "2025-07-28T14:40:00.000Z",
      "updatedAt": "2025-07-28T14:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 14.25,
      "currency": "EUR",
      "description": "Payment to Cafe And Noodle: CAN-202507-6230",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mcs01dg66d8k5pqdxsnrr81kjq",
      "fspDate": "2025-07-28T13:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mcs01dg66d8k5pqdxsnrr81kjq",
        "bookingDate": "2025-07-28",
        "valueDate": "2025-07-28",
        "bookingDateTime": "2025-07-28T14:40:00.000Z",
        "valueDateTime": "2025-07-28T14:40:00.000Z",
        "transactionAmount": {
          "amount": "14.25",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cafe And Noodle: CAN-202507-6230",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cafe And Noodle",
          "CAN-202507-6230"
        ],
        "debtorName": "Cafe And Noodle"
      },
      "paymentId": null,
      "reference": "CAN-202507-6230",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpd8eshspmwjjpzayxx2",
      "clustering": {
        "description": "Cafe And Noodle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cafe And Noodle' based on payment details",
        "updatedAt": "2025-07-28T14:40:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cafe And Noodle",
        "iban": "DE10726080753775116",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_6yvqsbh29txr9xm968xkppxa5f",
      "createdAt": "2025-07-28T14:31:00.000Z",
      "updatedAt": "2025-07-28T14:31:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 42.56,
      "currency": "GBP",
      "description": "Payment to Captain Nemo: CN-202507-9239",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9jgvrk90cwrq51m1a8em9p8vay",
      "fspDate": "2025-07-28T13:31:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9jgvrk90cwrq51m1a8em9p8vay",
        "bookingDate": "2025-07-28",
        "valueDate": "2025-07-28",
        "bookingDateTime": "2025-07-28T14:31:00.000Z",
        "valueDateTime": "2025-07-28T14:31:00.000Z",
        "transactionAmount": {
          "amount": "42.56",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Captain Nemo: CN-202507-9239",
        "remittanceInformationUnstructuredArray": [
          "Payment to Captain Nemo",
          "CN-202507-9239"
        ],
        "debtorName": "Captain Nemo"
      },
      "paymentId": null,
      "reference": "CN-202507-9239",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fm8nzsfzz9aen1pftqn9qr",
      "clustering": {
        "description": "Captain Nemo",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Captain Nemo' based on payment details",
        "updatedAt": "2025-07-28T14:31:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Captain Nemo",
        "iban": null,
        "bic": null,
        "sortCode": "384503",
        "accountNumber": "51279599"
      }
    },
    {
      "id": "txn_enyq526f97nv84j5h6ycv7m0g0",
      "createdAt": "2025-07-28T11:54:00.000Z",
      "updatedAt": "2025-07-28T11:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 13309.93,
      "currency": "GBP",
      "description": "Payment from SmartScale Solutions - INV-202507-7502",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_46pbxf1rkfb61r5ssxyxmedgjq",
      "fspDate": "2025-07-28T10:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_46pbxf1rkfb61r5ssxyxmedgjq",
        "bookingDate": "2025-07-28",
        "valueDate": "2025-07-28",
        "bookingDateTime": "2025-07-28T11:54:00.000Z",
        "valueDateTime": "2025-07-28T11:54:00.000Z",
        "transactionAmount": {
          "amount": "13309.93",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from SmartScale Solutions - INV-202507-7502",
        "remittanceInformationUnstructuredArray": [
          "Payment from SmartScale Solutions",
          "INV-202507-7502"
        ],
        "creditorName": "SmartScale Solutions"
      },
      "paymentId": null,
      "reference": "INV-202507-7502",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_k9wmdwkshbazmh9e7aq4wj85ej",
      "clustering": {
        "description": "SmartScale Solutions",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'SmartScale Solutions'",
        "updatedAt": "2025-07-28T11:54:00.000Z"
      },
      "payer": {
        "name": "SmartScale Solutions",
        "iban": null,
        "bic": null,
        "sortCode": "312694",
        "accountNumber": "49605863"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9fk4e8mmy4njkxh28n9m9jferf",
      "createdAt": "2025-07-28T08:23:00.000Z",
      "updatedAt": "2025-07-28T08:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3530.21,
      "currency": "USD",
      "description": "Payment to OpenAI, LLC: OL-202507-8375",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_yscngaj7xdxt7khr3j1wrf5abw",
      "fspDate": "2025-07-28T07:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_yscngaj7xdxt7khr3j1wrf5abw",
        "bookingDate": "2025-07-28",
        "valueDate": "2025-07-28",
        "bookingDateTime": "2025-07-28T08:23:00.000Z",
        "valueDateTime": "2025-07-28T08:23:00.000Z",
        "transactionAmount": {
          "amount": "3530.21",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to OpenAI, LLC: OL-202507-8375",
        "remittanceInformationUnstructuredArray": [
          "Payment to OpenAI, LLC",
          "OL-202507-8375"
        ],
        "debtorName": "OpenAI, LLC"
      },
      "paymentId": null,
      "reference": "OL-202507-8375",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_1bss5kk7dqrqznncrn6c0w8y4p",
      "clustering": {
        "description": "OpenAI, LLC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'OpenAI, LLC' based on payment details",
        "updatedAt": "2025-07-28T08:23:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "OpenAI, LLC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph4r5jtz3d9r",
      "createdAt": "2025-07-27T16:52:00.000Z",
      "updatedAt": "2025-07-27T16:52:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 23.2,
      "currency": "EUR",
      "description": "Sumup *muhammad Tashf",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk22tp5b5pkf7",
      "fspDate": "2025-07-27T15:52:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk22tp5b5pkf7",
        "bookingDate": "2025-12-09",
        "valueDate": "2025-12-09",
        "bookingDateTime": "2025-12-09T16:49:00.000Z",
        "valueDateTime": "2025-12-09T16:49:00.000Z",
        "transactionAmount": {
          "amount": "-23.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *muhammad Tashf",
        "remittanceInformationUnstructuredArray": [
          "Sumup *muhammad Tashf"
        ],
        "debtorName": "Muhammad Tashf"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkgjeshspnx4pqb9b6ze",
      "clustering": {
        "description": "Muhammad Tashf",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Muhammad Tashf' from 'Sumup *muhammad Tashf', removing the 'Sumup *' prefix",
        "updatedAt": "2025-09-27T10:54:50.860Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspeyvymt9aj8a",
      "createdAt": "2025-07-27T16:13:00.000Z",
      "updatedAt": "2025-07-27T16:13:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 90,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2feknczfk7s42a6b1fs0vbm",
      "fspDate": "2025-07-27T15:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2feknczfk7s42a6b1fs0vbm",
        "bookingDate": "2025-12-20",
        "valueDate": "2025-12-20",
        "bookingDateTime": "2025-12-20T09:46:00.000Z",
        "valueDateTime": "2025-12-20T09:46:00.000Z",
        "transactionAmount": {
          "amount": "-90.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the core description for a currency conversion transaction, based on the 'EXCHANGE' code",
        "updatedAt": "2025-09-27T10:42:40.399Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfbzcbpddanm",
      "createdAt": "2025-07-27T13:20:00.000Z",
      "updatedAt": "2025-07-27T13:20:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 37.4,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k180qw44esj88dr89fkmdbwx",
      "fspDate": "2025-07-27T12:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k180qw44esj88dr89fkmdbwx",
        "bookingDate": "2025-07-27",
        "valueDate": "2025-07-27",
        "bookingDateTime": "2025-07-27T12:20:00.000Z",
        "valueDateTime": "2025-07-27T12:20:00.000Z",
        "transactionAmount": {
          "amount": "-37.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'DocuSign' from 'Docusign'",
        "updatedAt": "2025-09-27T10:48:02.620Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2fxhgvyn9wm88a3d6wx7pt9rt1",
      "createdAt": "2025-07-27T12:26:00.000Z",
      "updatedAt": "2025-07-27T12:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 38.65,
      "currency": "EUR",
      "description": "Payment to The Woolshed: TW-202507-4932",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_km4jmnj1kx7189gkxqn8na230a",
      "fspDate": "2025-07-27T11:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_km4jmnj1kx7189gkxqn8na230a",
        "bookingDate": "2025-07-27",
        "valueDate": "2025-07-27",
        "bookingDateTime": "2025-07-27T12:26:00.000Z",
        "valueDateTime": "2025-07-27T12:26:00.000Z",
        "transactionAmount": {
          "amount": "38.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to The Woolshed: TW-202507-4932",
        "remittanceInformationUnstructuredArray": [
          "Payment to The Woolshed",
          "TW-202507-4932"
        ],
        "debtorName": "The Woolshed"
      },
      "paymentId": null,
      "reference": "TW-202507-4932",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1pkeshspm729w29ytag",
      "clustering": {
        "description": "The Woolshed",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'The Woolshed' based on payment details",
        "updatedAt": "2025-07-27T12:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "The Woolshed",
        "iban": "DE80466951832369730",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfhx9w1y3bt9",
      "createdAt": "2025-07-27T12:07:00.000Z",
      "updatedAt": "2025-07-27T12:07:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14.5,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0xq4wv1fvqsn5ydgt1j02nm",
      "fspDate": "2025-07-27T11:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0xq4wv1fvqsn5ydgt1j02nm",
        "bookingDate": "2025-07-27",
        "valueDate": "2025-07-27",
        "bookingDateTime": "2025-07-27T11:07:00.000Z",
        "valueDateTime": "2025-07-27T11:07:00.000Z",
        "transactionAmount": {
          "amount": "-14.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Shaka Poke' from 'Sq *shaka Poke', removing Sq * prefix",
        "updatedAt": "2025-09-27T10:49:04.262Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_abw9kce7n4374s6c1ca9jj146f",
      "createdAt": "2025-07-27T12:02:00.000Z",
      "updatedAt": "2025-07-27T12:02:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1295.63,
      "currency": "GBP",
      "description": "Payment to Adam Rankin: AR-202507-5719",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_a2ym7hr1z2gs32jqm3pqcp9qkf",
      "fspDate": "2025-07-27T11:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_a2ym7hr1z2gs32jqm3pqcp9qkf",
        "bookingDate": "2025-07-27",
        "valueDate": "2025-07-27",
        "bookingDateTime": "2025-07-27T12:02:00.000Z",
        "valueDateTime": "2025-07-27T12:02:00.000Z",
        "transactionAmount": {
          "amount": "1295.63",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Adam Rankin: AR-202507-5719",
        "remittanceInformationUnstructuredArray": [
          "Payment to Adam Rankin",
          "AR-202507-5719"
        ],
        "debtorName": "Adam Rankin"
      },
      "paymentId": null,
      "reference": "AR-202507-5719",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd2zfvhrjnc124tr3b2s",
      "clustering": {
        "description": "Adam Rankin",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Adam Rankin' based on payment details",
        "updatedAt": "2025-07-27T12:02:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Adam Rankin",
        "iban": null,
        "bic": null,
        "sortCode": "613786",
        "accountNumber": "14865174"
      }
    },
    {
      "id": "txn_q0nw4fa87a6rx8v4z5w9ggk13w",
      "createdAt": "2025-07-27T11:10:00.000Z",
      "updatedAt": "2025-07-27T11:10:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2819.97,
      "currency": "USD",
      "description": "Payment to Anthropic PBC: AP-202507-4892",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_k49fy211edd8mfwz0ynav31h0d",
      "fspDate": "2025-07-27T10:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_k49fy211edd8mfwz0ynav31h0d",
        "bookingDate": "2025-07-27",
        "valueDate": "2025-07-27",
        "bookingDateTime": "2025-07-27T11:10:00.000Z",
        "valueDateTime": "2025-07-27T11:10:00.000Z",
        "transactionAmount": {
          "amount": "2819.97",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic PBC: AP-202507-4892",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic PBC",
          "AP-202507-4892"
        ],
        "debtorName": "Anthropic PBC"
      },
      "paymentId": null,
      "reference": "AP-202507-4892",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_vnn6fxhm5daqv7bh39b88k2t9d",
      "clustering": {
        "description": "Anthropic PBC",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic PBC' based on payment details",
        "updatedAt": "2025-07-27T11:10:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic PBC",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4n40avkyc41a3ac2yfd35y13mx",
      "createdAt": "2025-07-27T09:58:00.000Z",
      "updatedAt": "2025-07-27T09:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 574.48,
      "currency": "GBP",
      "description": "Payment to Ginger Bistro: GB-202507-3449",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6rznex5pen373jztf086x2ngez",
      "fspDate": "2025-07-27T08:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6rznex5pen373jztf086x2ngez",
        "bookingDate": "2025-07-27",
        "valueDate": "2025-07-27",
        "bookingDateTime": "2025-07-27T09:58:00.000Z",
        "valueDateTime": "2025-07-27T09:58:00.000Z",
        "transactionAmount": {
          "amount": "574.48",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Ginger Bistro: GB-202507-3449",
        "remittanceInformationUnstructuredArray": [
          "Payment to Ginger Bistro",
          "GB-202507-3449"
        ],
        "debtorName": "Ginger Bistro"
      },
      "paymentId": null,
      "reference": "GB-202507-3449",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk6skfvhrjntfdd23av1a",
      "clustering": {
        "description": "Ginger Bistro",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Ginger Bistro' based on payment details",
        "updatedAt": "2025-07-27T09:58:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Ginger Bistro",
        "iban": null,
        "bic": null,
        "sortCode": "812192",
        "accountNumber": "63786406"
      }
    },
    {
      "id": "txn_01k65c32y2eshspfj8hnjfc4rt",
      "createdAt": "2025-07-27T09:54:00.000Z",
      "updatedAt": "2025-07-27T09:54:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 20.85,
      "currency": "EUR",
      "description": "1password",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0v4ra3afvqsmk2ks4vvy8rk",
      "fspDate": "2025-07-27T08:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0v4ra3afvqsmk2ks4vvy8rk",
        "bookingDate": "2025-07-27",
        "valueDate": "2025-07-27",
        "bookingDateTime": "2025-07-27T08:54:00.000Z",
        "valueDateTime": "2025-07-27T08:54:00.000Z",
        "transactionAmount": {
          "amount": "-20.85",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "1password",
        "remittanceInformationUnstructuredArray": [
          "1password"
        ],
        "debtorName": "1Password"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxpeshspjghv7zy63at",
      "clustering": {
        "description": "1Password",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name '1Password' from the transaction description",
        "updatedAt": "2025-09-27T10:49:04.279Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bbftrvtce8qdj59cmpr8bkse5p",
      "createdAt": "2025-07-27T09:32:00.000Z",
      "updatedAt": "2025-07-27T09:32:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 518.36,
      "currency": "EUR",
      "description": "Payment to Clayton Hotel Burlington: CHB-202507-5490",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_rp4k8dbtyytvj8q9m49pw5waa7",
      "fspDate": "2025-07-27T08:32:00.000Z",
      "fspRecord": {
        "transactionId": "txn_rp4k8dbtyytvj8q9m49pw5waa7",
        "bookingDate": "2025-07-27",
        "valueDate": "2025-07-27",
        "bookingDateTime": "2025-07-27T09:32:00.000Z",
        "valueDateTime": "2025-07-27T09:32:00.000Z",
        "transactionAmount": {
          "amount": "518.36",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Burlington: CHB-202507-5490",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Burlington",
          "CHB-202507-5490"
        ],
        "debtorName": "Clayton Hotel Burlington"
      },
      "paymentId": null,
      "reference": "CHB-202507-5490",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crppkeshspmfw2e0m4xdm",
      "clustering": {
        "description": "Clayton Hotel Burlington",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Burlington' based on payment details",
        "updatedAt": "2025-07-27T09:32:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Burlington",
        "iban": "DE19613223114562990",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz7fvhrjm28ggmdba7n",
      "createdAt": "2025-07-27T08:54:00.000Z",
      "updatedAt": "2025-07-27T08:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3000,
      "currency": "GBP",
      "description": "Payment to Seapoint Finance UK Ltd",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k42ejeghe4btnetr0gwzyaax",
      "fspDate": "2025-07-27T07:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k42ejeghe4btnetr0gwzyaax",
        "bookingDate": "2025-07-27",
        "valueDate": "2025-07-27",
        "bookingDateTime": "2025-07-27T07:54:00.000Z",
        "valueDateTime": "2025-07-27T07:54:00.000Z",
        "transactionAmount": {
          "amount": "-3000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Seapoint Finance UK Ltd",
        "remittanceInformationUnstructuredArray": [
          "Payment to Seapoint Finance UK Ltd"
        ],
        "debtorName": "Seapoint Finance UK Ltd"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance UK",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Seapoint Finance UK' from 'Payment to Seapoint Finance UK Ltd', removing 'Payment to ' prefix and 'Ltd' suffix",
        "updatedAt": "2025-09-29T18:23:50.738Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmsehmhqg0fg",
      "createdAt": "2025-07-26T15:41:00.000Z",
      "updatedAt": "2025-07-26T15:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 233.61,
      "currency": "GBP",
      "description": "British Airways Plc",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8hre65ddjnv",
      "fspDate": "2025-07-26T14:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8hre65ddjnv",
        "bookingDate": "2025-07-26",
        "valueDate": "2025-07-26",
        "bookingDateTime": "2025-07-26T14:41:00.000Z",
        "valueDateTime": "2025-07-26T14:41:00.000Z",
        "transactionAmount": {
          "amount": "-233.61",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "British Airways Plc",
        "remittanceInformationUnstructuredArray": [
          "British Airways Plc"
        ],
        "debtorName": "British Airways"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9m2fvhrjp2hhm5q9efq",
      "clustering": {
        "description": "British Airways",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'British Airways' from 'British Airways Plc'",
        "updatedAt": "2025-09-29T18:26:40.985Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9f7kfgt70fjh1agws97876ecwe",
      "createdAt": "2025-07-26T15:15:00.000Z",
      "updatedAt": "2025-07-26T15:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7200,
      "currency": "GBP",
      "description": "Salary - Emily Chen - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_tbyg6hgc7skqx1kvkncq8gyvyz",
      "fspDate": "2025-07-26T14:15:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_61stk3te9nq5vp3zjnvwzcb0nk",
        "bookingDate": "2025-07-26",
        "valueDate": "2025-07-26",
        "bookingDateTime": "2025-07-26T14:15:00.000Z",
        "valueDateTime": "2025-07-26T14:15:00.000Z",
        "transactionAmount": {
          "amount": "-7200.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Emily Chen",
        "remittanceInformationUnstructuredArray": [
          "Salary - Emily Chen"
        ]
      },
      "paymentId": "pmnt_06asj0g5mwck761jcf34pz6847",
      "reference": "PAY-DEC-2025-CHEN",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Emily Chen",
        "iban": null,
        "bic": null,
        "sortCode": "30-15-89",
        "accountNumber": "87654301"
      }
    },
    {
      "id": "txn_6rqz2cdvn9j99vjk3nzqqnyqnn",
      "createdAt": "2025-07-26T13:41:00.000Z",
      "updatedAt": "2025-07-26T13:41:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 521.16,
      "currency": "GBP",
      "description": "Payment to Slack Technologies Limited: STL-202507-3453",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6ptw6623fhm3s45hww6nsfs700",
      "fspDate": "2025-07-26T12:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6ptw6623fhm3s45hww6nsfs700",
        "bookingDate": "2025-07-26",
        "valueDate": "2025-07-26",
        "bookingDateTime": "2025-07-26T13:41:00.000Z",
        "valueDateTime": "2025-07-26T13:41:00.000Z",
        "transactionAmount": {
          "amount": "521.16",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Slack Technologies Limited: STL-202507-3453",
        "remittanceInformationUnstructuredArray": [
          "Payment to Slack Technologies Limited",
          "STL-202507-3453"
        ],
        "debtorName": "Slack Technologies Limited"
      },
      "paymentId": null,
      "reference": "STL-202507-3453",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_6m3t4s5pcz3g5997sxc586yj3f",
      "clustering": {
        "description": "Slack Technologies Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Slack Technologies Limited' based on payment details",
        "updatedAt": "2025-07-26T13:41:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Slack Technologies Limited",
        "iban": null,
        "bic": null,
        "sortCode": "598662",
        "accountNumber": "34589335"
      }
    },
    {
      "id": "txn_01k65c32y4eshspg8y55wqn9v7",
      "createdAt": "2025-07-26T13:30:00.000Z",
      "updatedAt": "2025-07-26T13:30:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 3300,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk16sznbn4cpc",
      "fspDate": "2025-07-26T12:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk16sznbn4cpc",
        "bookingDate": "2025-07-26",
        "valueDate": "2025-07-26",
        "bookingDateTime": "2025-07-26T12:30:00.000Z",
        "valueDateTime": "2025-07-26T12:30:00.000Z",
        "transactionAmount": {
          "amount": "-3300.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the currency conversion transaction with code 'EXCHANGE'.",
        "updatedAt": "2025-09-27T10:51:38.290Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_cqbfnpbvpybw97mjw8480v3pqf",
      "createdAt": "2025-07-26T12:00:00.000Z",
      "updatedAt": "2025-07-26T12:00:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 15.11,
      "currency": "EUR",
      "description": "Payment to Seoul Kitchen: SK-202507-5002",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4vjty63dv4y2zkxagqxwass6sv",
      "fspDate": "2025-07-26T11:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4vjty63dv4y2zkxagqxwass6sv",
        "bookingDate": "2025-07-26",
        "valueDate": "2025-07-26",
        "bookingDateTime": "2025-07-26T12:00:00.000Z",
        "valueDateTime": "2025-07-26T12:00:00.000Z",
        "transactionAmount": {
          "amount": "15.11",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Seoul Kitchen: SK-202507-5002",
        "remittanceInformationUnstructuredArray": [
          "Payment to Seoul Kitchen",
          "SK-202507-5002"
        ],
        "debtorName": "Seoul Kitchen"
      },
      "paymentId": null,
      "reference": "SK-202507-5002",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pzaeshspjhkemvf76tx",
      "clustering": {
        "description": "Seoul Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Seoul Kitchen' based on payment details",
        "updatedAt": "2025-07-26T12:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Seoul Kitchen",
        "iban": "DE10796661477521306",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_rxhnz1fcmhfdm1t1wzbhfh18rv",
      "createdAt": "2025-07-26T11:50:00.000Z",
      "updatedAt": "2025-07-26T11:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.01,
      "currency": "USD",
      "description": "Payment to Google Play: GP-202507-6965",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6vmtvy2d5k6e0mxmrqezrnkp07",
      "fspDate": "2025-07-26T10:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6vmtvy2d5k6e0mxmrqezrnkp07",
        "bookingDate": "2025-07-26",
        "valueDate": "2025-07-26",
        "bookingDateTime": "2025-07-26T11:50:00.000Z",
        "valueDateTime": "2025-07-26T11:50:00.000Z",
        "transactionAmount": {
          "amount": "3.01",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Google Play: GP-202507-6965",
        "remittanceInformationUnstructuredArray": [
          "Payment to Google Play",
          "GP-202507-6965"
        ],
        "debtorName": "Google Play"
      },
      "paymentId": null,
      "reference": "GP-202507-6965",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wjeeshsphy7nnkfq48b",
      "clustering": {
        "description": "Google Play",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Google Play' based on payment details",
        "updatedAt": "2025-07-26T11:50:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Google Play",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgn3q9jx7ttb",
      "createdAt": "2025-07-26T10:49:00.000Z",
      "updatedAt": "2025-07-26T10:49:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 24,
      "currency": "EUR",
      "description": "Draculas Kitchen",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1jqaampzdcv",
      "fspDate": "2025-07-26T09:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1jqaampzdcv",
        "bookingDate": "2025-07-26",
        "valueDate": "2025-07-26",
        "bookingDateTime": "2025-07-26T09:49:00.000Z",
        "valueDateTime": "2025-07-26T09:49:00.000Z",
        "transactionAmount": {
          "amount": "-24.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Draculas Kitchen",
        "remittanceInformationUnstructuredArray": [
          "Draculas Kitchen"
        ],
        "debtorName": "Dracula's Kitchen"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwcgeshspn9xska0mg5b",
      "clustering": {
        "description": "Dracula's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Dracula's Kitchen' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.114Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xn1pdf6bcw4jrvddf1f6g2kpek",
      "createdAt": "2025-07-26T10:30:00.000Z",
      "updatedAt": "2025-07-26T10:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 8.87,
      "currency": "USD",
      "description": "Payment to Wispr: W-202507-9942",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vwgbe671x6jwqqx4dhtwdjnr93",
      "fspDate": "2025-07-26T09:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vwgbe671x6jwqqx4dhtwdjnr93",
        "bookingDate": "2025-07-26",
        "valueDate": "2025-07-26",
        "bookingDateTime": "2025-07-26T10:30:00.000Z",
        "valueDateTime": "2025-07-26T10:30:00.000Z",
        "transactionAmount": {
          "amount": "8.87",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Wispr: W-202507-9942",
        "remittanceInformationUnstructuredArray": [
          "Payment to Wispr",
          "W-202507-9942"
        ],
        "debtorName": "Wispr"
      },
      "paymentId": null,
      "reference": "W-202507-9942",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax6ceshspjngxatk00nd",
      "clustering": {
        "description": "Wispr",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Wispr' based on payment details",
        "updatedAt": "2025-07-26T10:30:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Wispr",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_e8y1s8nf5xjcj70epwvy0g7zem",
      "createdAt": "2025-07-25T16:33:00.000Z",
      "updatedAt": "2025-07-25T16:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 840,
      "currency": "USD",
      "description": "Payment to GitHub, Inc.: GH-2026-01-78234",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_y3axa1sc4pq5gand9fz78ftqrc",
      "fspDate": "2025-07-25T15:33:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_q0rzd7mebsha04ga18hb3xxkw9",
        "bookingDate": "2025-07-25",
        "valueDate": "2025-07-25",
        "bookingDateTime": "2025-07-25T15:33:00.000Z",
        "valueDateTime": "2025-07-25T15:33:00.000Z",
        "transactionAmount": {
          "amount": "-840.00",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GitHub, Inc.: GH-2026-01-78234",
        "remittanceInformationUnstructuredArray": [
          "Payment to GitHub, Inc.: GH-2026-01-78234"
        ],
        "debtorName": "GitHub, Inc."
      },
      "paymentId": null,
      "reference": "GH-2026-01-78234",
      "beneficiaryId": "benf_4pppc1h3qy34jt2h3pygnfsexm",
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_xj643cpp5p1awyrrqgqpf67q4d",
      "clustering": {
        "description": "GitHub, Inc.",
        "confidenceScore": "0.95",
        "rationale": "Identified as payment to GitHub, Inc. based on remittance information.",
        "updatedAt": "2026-01-12T10:00:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "GitHub, Inc.",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": "9901234567"
      }
    },
    {
      "id": "txn_wt0s5pv1588yc8njz9cnesy1e4",
      "createdAt": "2025-07-25T13:20:00.000Z",
      "updatedAt": "2025-07-25T13:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.62,
      "currency": "GBP",
      "description": "Payment to FCB Coffee: FC-202507-1510",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_b1fn9zeyxp7c20tvdbxky1q3j3",
      "fspDate": "2025-07-25T12:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_b1fn9zeyxp7c20tvdbxky1q3j3",
        "bookingDate": "2025-07-25",
        "valueDate": "2025-07-25",
        "bookingDateTime": "2025-07-25T13:20:00.000Z",
        "valueDateTime": "2025-07-25T13:20:00.000Z",
        "transactionAmount": {
          "amount": "3.62",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to FCB Coffee: FC-202507-1510",
        "remittanceInformationUnstructuredArray": [
          "Payment to FCB Coffee",
          "FC-202507-1510"
        ],
        "debtorName": "FCB Coffee"
      },
      "paymentId": null,
      "reference": "FC-202507-1510",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmmfvhrjp1d532dm1jy",
      "clustering": {
        "description": "FCB Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'FCB Coffee' based on payment details",
        "updatedAt": "2025-07-25T13:20:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "FCB Coffee",
        "iban": null,
        "bic": null,
        "sortCode": "358246",
        "accountNumber": "26575423"
      }
    },
    {
      "id": "txn_01k65c32y2eshspfe3t38amvak",
      "createdAt": "2025-07-25T11:35:00.000Z",
      "updatedAt": "2025-07-25T11:35:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Suhas Falafel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k12vyakpe4dr6y1h8hwrsbet",
      "fspDate": "2025-07-25T10:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k12vyakpe4dr6y1h8hwrsbet",
        "bookingDate": "2025-07-25",
        "valueDate": "2025-07-25",
        "bookingDateTime": "2025-07-25T10:35:00.000Z",
        "valueDateTime": "2025-07-25T10:35:00.000Z",
        "transactionAmount": {
          "amount": "-14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Suhas Falafel",
        "remittanceInformationUnstructuredArray": [
          "Suhas Falafel"
        ],
        "debtorName": "Suhas Falafel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmadbeshspkkgwerj0myb",
      "clustering": {
        "description": "Suhas Falafel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Suhas Falafel' from 'Suhas Falafel'",
        "updatedAt": "2025-09-27T10:48:02.715Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgrzhbmhea49",
      "createdAt": "2025-07-25T10:50:00.000Z",
      "updatedAt": "2025-07-25T10:50:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12,
      "currency": "EUR",
      "description": "Salt Cellar Cafe",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1p5exf95g62",
      "fspDate": "2025-07-25T09:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1p5exf95g62",
        "bookingDate": "2025-07-25",
        "valueDate": "2025-07-25",
        "bookingDateTime": "2025-07-25T09:50:00.000Z",
        "valueDateTime": "2025-07-25T09:50:00.000Z",
        "transactionAmount": {
          "amount": "-12.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Salt Cellar Cafe",
        "remittanceInformationUnstructuredArray": [
          "Salt Cellar Cafe"
        ],
        "debtorName": "Salt Cellar Cafe"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0x9eshspkzthwr7rcm3",
      "clustering": {
        "description": "Salt Cellar Cafe",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Salt Cellar Cafe' from the raw transaction description.",
        "updatedAt": "2025-09-27T10:53:55.631Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0etc9m523hvjxhrb6x4stejw9r",
      "createdAt": "2025-07-25T09:42:00.000Z",
      "updatedAt": "2025-07-25T09:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 15494.75,
      "currency": "GBP",
      "description": "Payment from Innovation Partners - INV-202507-6270",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xf4p82g1eb7g9pszhj1ctg1vrv",
      "fspDate": "2025-07-25T08:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xf4p82g1eb7g9pszhj1ctg1vrv",
        "bookingDate": "2025-07-25",
        "valueDate": "2025-07-25",
        "bookingDateTime": "2025-07-25T09:42:00.000Z",
        "valueDateTime": "2025-07-25T09:42:00.000Z",
        "transactionAmount": {
          "amount": "15494.75",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Innovation Partners - INV-202507-6270",
        "remittanceInformationUnstructuredArray": [
          "Payment from Innovation Partners",
          "INV-202507-6270"
        ],
        "creditorName": "Innovation Partners"
      },
      "paymentId": null,
      "reference": "INV-202507-6270",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m4xtykg61y9kjq9cjdr8bewyz0",
      "clustering": {
        "description": "Innovation Partners",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Innovation Partners'",
        "updatedAt": "2025-07-25T09:42:00.000Z"
      },
      "payer": {
        "name": "Innovation Partners",
        "iban": null,
        "bic": null,
        "sortCode": "995346",
        "accountNumber": "97420311"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_3xk17sffahq3yze62zkvzvasvr",
      "createdAt": "2025-07-25T08:06:00.000Z",
      "updatedAt": "2025-07-25T08:06:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3.67,
      "currency": "EUR",
      "description": "Payment to Pinecone Coffee: PC-202507-4585",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9ehw2755ypmd60yr9nk8w5qrjp",
      "fspDate": "2025-07-25T07:06:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9ehw2755ypmd60yr9nk8w5qrjp",
        "bookingDate": "2025-07-25",
        "valueDate": "2025-07-25",
        "bookingDateTime": "2025-07-25T08:06:00.000Z",
        "valueDateTime": "2025-07-25T08:06:00.000Z",
        "transactionAmount": {
          "amount": "3.67",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pinecone Coffee: PC-202507-4585",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pinecone Coffee",
          "PC-202507-4585"
        ],
        "debtorName": "Pinecone Coffee"
      },
      "paymentId": null,
      "reference": "PC-202507-4585",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh31eshspkh23ahabkmn",
      "clustering": {
        "description": "Pinecone Coffee",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pinecone Coffee' based on payment details",
        "updatedAt": "2025-07-25T08:06:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pinecone Coffee",
        "iban": "DE85376046232585620",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4s4zbxw57a6ed56cb0ks8wz95x",
      "createdAt": "2025-07-24T15:35:00.000Z",
      "updatedAt": "2025-07-24T15:35:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3335.57,
      "currency": "GBP",
      "description": "Payment to Yapily: Y-202507-2732",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4rzkczrvs584bc6nj53rz8jdk5",
      "fspDate": "2025-07-24T14:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4rzkczrvs584bc6nj53rz8jdk5",
        "bookingDate": "2025-07-24",
        "valueDate": "2025-07-24",
        "bookingDateTime": "2025-07-24T15:35:00.000Z",
        "valueDateTime": "2025-07-24T15:35:00.000Z",
        "transactionAmount": {
          "amount": "3335.57",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Yapily: Y-202507-2732",
        "remittanceInformationUnstructuredArray": [
          "Payment to Yapily",
          "Y-202507-2732"
        ],
        "debtorName": "Yapily"
      },
      "paymentId": null,
      "reference": "Y-202507-2732",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf94qfvhrjn51jet0pt56",
      "clustering": {
        "description": "Yapily",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Yapily' based on payment details",
        "updatedAt": "2025-07-24T15:35:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Yapily",
        "iban": null,
        "bic": null,
        "sortCode": "499648",
        "accountNumber": "42254731"
      }
    },
    {
      "id": "txn_kshpxphv7abp007y7e4g4cepdj",
      "createdAt": "2025-07-24T14:12:00.000Z",
      "updatedAt": "2025-07-24T14:12:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 45.23,
      "currency": "EUR",
      "description": "Payment to Heathrow Express: HE-202507-4632",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_yxvdx28e54k15ypjppn87bwhfd",
      "fspDate": "2025-07-24T13:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_yxvdx28e54k15ypjppn87bwhfd",
        "bookingDate": "2025-07-24",
        "valueDate": "2025-07-24",
        "bookingDateTime": "2025-07-24T14:12:00.000Z",
        "valueDateTime": "2025-07-24T14:12:00.000Z",
        "transactionAmount": {
          "amount": "45.23",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Heathrow Express: HE-202507-4632",
        "remittanceInformationUnstructuredArray": [
          "Payment to Heathrow Express",
          "HE-202507-4632"
        ],
        "debtorName": "Heathrow Express"
      },
      "paymentId": null,
      "reference": "HE-202507-4632",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpg2eshspmf0nznfw91y",
      "clustering": {
        "description": "Heathrow Express",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Heathrow Express' based on payment details",
        "updatedAt": "2025-07-24T14:12:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Heathrow Express",
        "iban": "DE52973605753273960",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_gtbvxmyh9czmbjdrefvfx4dpcd",
      "createdAt": "2025-07-24T13:23:00.000Z",
      "updatedAt": "2025-07-24T13:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 297.77,
      "currency": "EUR",
      "description": "Payment to Bang Restaurant: BR-202507-9237",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w3424sgqxmfkxqv8f8ay4x9vrq",
      "fspDate": "2025-07-24T12:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w3424sgqxmfkxqv8f8ay4x9vrq",
        "bookingDate": "2025-07-24",
        "valueDate": "2025-07-24",
        "bookingDateTime": "2025-07-24T13:23:00.000Z",
        "valueDateTime": "2025-07-24T13:23:00.000Z",
        "transactionAmount": {
          "amount": "297.77",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Bang Restaurant: BR-202507-9237",
        "remittanceInformationUnstructuredArray": [
          "Payment to Bang Restaurant",
          "BR-202507-9237"
        ],
        "debtorName": "Bang Restaurant"
      },
      "paymentId": null,
      "reference": "BR-202507-9237",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65crpk3eshspmfgtm6vkpxj",
      "clustering": {
        "description": "Bang Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Bang Restaurant' based on payment details",
        "updatedAt": "2025-07-24T13:23:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Bang Restaurant",
        "iban": "DE86270459343287650",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf50spd9c74a",
      "createdAt": "2025-07-24T13:11:00.000Z",
      "updatedAt": "2025-07-24T13:11:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.57,
      "currency": "EUR",
      "description": "Cursor, Ai Powered Ide",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1t1gjkbena8mn7vtz9bzqk3",
      "fspDate": "2025-07-24T12:11:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1t1gjkbena8mn7vtz9bzqk3",
        "bookingDate": "2025-12-24",
        "valueDate": "2025-12-24",
        "bookingDateTime": "2025-12-24T12:02:00.000Z",
        "valueDateTime": "2025-12-24T12:02:00.000Z",
        "transactionAmount": {
          "amount": "-17.57",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor, Ai Powered Ide",
        "remittanceInformationUnstructuredArray": [
          "Cursor, Ai Powered Ide"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Cursor' from the transaction description, removing the ', Ai Powered Ide' suffix.",
        "updatedAt": "2025-09-27T10:43:55.549Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfegftg4s7mx",
      "createdAt": "2025-07-24T12:48:00.000Z",
      "updatedAt": "2025-07-24T12:48:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5314.93,
      "currency": "EUR",
      "description": "Payment to Sophie Laurent: July 2025 Payroll",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k10kr2bse4dr6r1g035hf6sh",
      "fspDate": "2025-07-24T11:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k10kr2bse4dr6r1g035hf6sh",
        "bookingDate": "2025-07-24",
        "valueDate": "2025-07-24",
        "bookingDateTime": "2025-07-24T11:48:00.000Z",
        "valueDateTime": "2025-07-24T11:48:00.000Z",
        "transactionAmount": {
          "amount": "-5314.93",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sophie Laurent: July 2025 Payroll",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sophie Laurent: July 2025 Payroll"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsseshspj86qckgs7na",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Extracted employee name 'Sophie Laurent' from 'Payment to Sophie Laurent: July 2025 Payroll'",
        "updatedAt": "2025-09-27T10:48:02.735Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfc1hzz5yj87",
      "createdAt": "2025-07-24T10:09:00.000Z",
      "updatedAt": "2025-07-24T10:09:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 8.62,
      "currency": "EUR",
      "description": "Github, Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k15eb0nme4dr76a0398abw6j",
      "fspDate": "2025-07-24T09:09:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k15eb0nme4dr76a0398abw6j",
        "bookingDate": "2025-12-04",
        "valueDate": "2025-12-04",
        "bookingDateTime": "2025-12-04T07:22:00.000Z",
        "valueDateTime": "2025-12-04T07:22:00.000Z",
        "transactionAmount": {
          "amount": "-8.62",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Github, Inc.",
        "remittanceInformationUnstructuredArray": [
          "Github, Inc."
        ],
        "debtorName": "GitHub"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wd4eshsphxfd9s33j9t",
      "clustering": {
        "description": "Github",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Github' from 'Github, Inc.'",
        "updatedAt": "2025-09-27T10:48:02.627Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8yfzpnn7qj6vm3d3n7mw4v9y7s",
      "createdAt": "2025-07-23T13:54:00.000Z",
      "updatedAt": "2025-07-23T13:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 26.43,
      "currency": "EUR",
      "description": "Payment to Taxi Service: TS-202507-3626",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_a63d8drx4b7vvh025qqct18k0g",
      "fspDate": "2025-07-23T12:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_a63d8drx4b7vvh025qqct18k0g",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T13:54:00.000Z",
        "valueDateTime": "2025-07-23T13:54:00.000Z",
        "transactionAmount": {
          "amount": "26.43",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Taxi Service: TS-202507-3626",
        "remittanceInformationUnstructuredArray": [
          "Payment to Taxi Service",
          "TS-202507-3626"
        ],
        "debtorName": "Taxi Service"
      },
      "paymentId": null,
      "reference": "TS-202507-3626",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqn02eshspm8y4jy7tt7k",
      "clustering": {
        "description": "Taxi Service",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Taxi Service' based on payment details",
        "updatedAt": "2025-07-23T13:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Taxi Service",
        "iban": "DE53686780396908240",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_80tgfm7y1kxj0c2539g0hm67xv",
      "createdAt": "2025-07-23T13:26:00.000Z",
      "updatedAt": "2025-07-23T13:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 22855.58,
      "currency": "GBP",
      "description": "Payment from Global Solutions Ltd - INV-202507-5965",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_8r3p37y1sznq7q92k1wpg3k93z",
      "fspDate": "2025-07-23T12:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_8r3p37y1sznq7q92k1wpg3k93z",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T13:26:00.000Z",
        "valueDateTime": "2025-07-23T13:26:00.000Z",
        "transactionAmount": {
          "amount": "22855.58",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Global Solutions Ltd - INV-202507-5965",
        "remittanceInformationUnstructuredArray": [
          "Payment from Global Solutions Ltd",
          "INV-202507-5965"
        ],
        "creditorName": "Global Solutions Ltd"
      },
      "paymentId": null,
      "reference": "INV-202507-5965",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_th3hfveyjxh2erds1n633s02yd",
      "clustering": {
        "description": "Global Solutions Ltd",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Global Solutions Ltd'",
        "updatedAt": "2025-07-23T13:26:00.000Z"
      },
      "payer": {
        "name": "Global Solutions Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "549976",
        "accountNumber": "73852014"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm8d9vxj6ne7",
      "createdAt": "2025-07-23T12:28:00.000Z",
      "updatedAt": "2025-07-23T12:28:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 12000,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1dt4yssfewaj959v7wcgrp2",
      "fspDate": "2025-07-23T11:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1dt4yssfewaj959v7wcgrp2",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T11:28:00.000Z",
        "valueDateTime": "2025-07-23T11:28:00.000Z",
        "transactionAmount": {
          "amount": "12000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code and extracted 'Currency Exchange' as the description",
        "updatedAt": "2025-09-29T18:24:29.622Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_wsa790rrxq86wec6f7tsxfj4nj",
      "createdAt": "2025-07-23T12:22:00.000Z",
      "updatedAt": "2025-07-23T12:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 894.73,
      "currency": "GBP",
      "description": "Payment to Charles Russell Speechlys: CRS-202507-4449",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_chramw5pw7e3fnxjwxdbez4w0e",
      "fspDate": "2025-07-23T11:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_chramw5pw7e3fnxjwxdbez4w0e",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T12:22:00.000Z",
        "valueDateTime": "2025-07-23T12:22:00.000Z",
        "transactionAmount": {
          "amount": "894.73",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Charles Russell Speechlys: CRS-202507-4449",
        "remittanceInformationUnstructuredArray": [
          "Payment to Charles Russell Speechlys",
          "CRS-202507-4449"
        ],
        "debtorName": "Charles Russell Speechlys"
      },
      "paymentId": null,
      "reference": "CRS-202507-4449",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgh1fvhrjp0n7wme8cae",
      "clustering": {
        "description": "Charles Russell Speechlys",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Charles Russell Speechlys' based on payment details",
        "updatedAt": "2025-07-23T12:22:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Charles Russell Speechlys",
        "iban": null,
        "bic": null,
        "sortCode": "918137",
        "accountNumber": "46146443"
      }
    },
    {
      "id": "txn_na0rxv0hyfnrqab72962tbknm6",
      "createdAt": "2025-07-23T11:26:00.000Z",
      "updatedAt": "2025-07-23T11:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 29.93,
      "currency": "USD",
      "description": "Payment to Superhuman: S-202507-4410",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_tmatd1g1ms5k72wg5s84vx30pw",
      "fspDate": "2025-07-23T10:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_tmatd1g1ms5k72wg5s84vx30pw",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T11:26:00.000Z",
        "valueDateTime": "2025-07-23T11:26:00.000Z",
        "transactionAmount": {
          "amount": "29.93",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Superhuman: S-202507-4410",
        "remittanceInformationUnstructuredArray": [
          "Payment to Superhuman",
          "S-202507-4410"
        ],
        "debtorName": "Superhuman"
      },
      "paymentId": null,
      "reference": "S-202507-4410",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5mceshspjzn83y9tqy1",
      "clustering": {
        "description": "Superhuman",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Superhuman' based on payment details",
        "updatedAt": "2025-07-23T11:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Superhuman",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jmzk9rcpfk17nz0hcf17mafy7v",
      "createdAt": "2025-07-23T11:07:00.000Z",
      "updatedAt": "2025-07-23T11:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 106.28,
      "currency": "GBP",
      "description": "Payment to Clayton Hotel Belfast: CHB-202507-3150",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nq7by69bepvjffy1kd1b4ass9s",
      "fspDate": "2025-07-23T10:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nq7by69bepvjffy1kd1b4ass9s",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T11:07:00.000Z",
        "valueDateTime": "2025-07-23T11:07:00.000Z",
        "transactionAmount": {
          "amount": "106.28",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Clayton Hotel Belfast: CHB-202507-3150",
        "remittanceInformationUnstructuredArray": [
          "Payment to Clayton Hotel Belfast",
          "CHB-202507-3150"
        ],
        "debtorName": "Clayton Hotel Belfast"
      },
      "paymentId": null,
      "reference": "CHB-202507-3150",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4hyfvhrjnt1zqpqqyns",
      "clustering": {
        "description": "Clayton Hotel Belfast",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Clayton Hotel Belfast' based on payment details",
        "updatedAt": "2025-07-23T11:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Clayton Hotel Belfast",
        "iban": null,
        "bic": null,
        "sortCode": "990834",
        "accountNumber": "76866758"
      }
    },
    {
      "id": "txn_39we7j4ahhv1fb0278h82hs5sg",
      "createdAt": "2025-07-23T10:21:00.000Z",
      "updatedAt": "2025-07-23T10:21:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 9.96,
      "currency": "EUR",
      "description": "Payment to Revolut: R-202507-5338",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_nt5zk67wa95k403y6cxm8yfz76",
      "fspDate": "2025-07-23T09:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_nt5zk67wa95k403y6cxm8yfz76",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T10:21:00.000Z",
        "valueDateTime": "2025-07-23T10:21:00.000Z",
        "transactionAmount": {
          "amount": "9.96",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Revolut: R-202507-5338",
        "remittanceInformationUnstructuredArray": [
          "Payment to Revolut",
          "R-202507-5338"
        ],
        "debtorName": "Revolut"
      },
      "paymentId": null,
      "reference": "R-202507-5338",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mvseshspja4gsxz03at",
      "clustering": {
        "description": "Revolut",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Revolut' based on payment details",
        "updatedAt": "2025-07-23T10:21:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Revolut",
        "iban": "DE93244578242703950",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmqnfjfsevx5",
      "createdAt": "2025-07-23T10:02:00.000Z",
      "updatedAt": "2025-07-23T10:02:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 5000,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8g2sqvmf27d",
      "fspDate": "2025-07-23T09:02:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8g2sqvmf27d",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T09:02:00.000Z",
        "valueDateTime": "2025-07-23T09:02:00.000Z",
        "transactionAmount": {
          "amount": "5000.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the core business name for the currency conversion transaction",
        "updatedAt": "2025-09-29T18:26:40.960Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf39q662ys9s",
      "createdAt": "2025-07-23T09:56:00.000Z",
      "updatedAt": "2025-07-23T09:56:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1z6a4stexy9fyfvcjpah275",
      "fspDate": "2025-07-23T08:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1z6a4stexy9fyfvcjpah275",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T08:56:00.000Z",
        "valueDateTime": "2025-07-23T08:56:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Zakura' from the transaction description.",
        "updatedAt": "2025-09-27T10:43:55.487Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfrznamp0q2c",
      "createdAt": "2025-07-23T08:58:00.000Z",
      "updatedAt": "2025-07-23T08:58:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 8.6,
      "currency": "EUR",
      "description": "Finom",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0nwpn9c1m4t",
      "fspDate": "2025-07-23T07:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0nwpn9c1m4t",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T07:58:00.000Z",
        "valueDateTime": "2025-07-23T07:58:00.000Z",
        "transactionAmount": {
          "amount": "-8.60",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Finom",
        "remittanceInformationUnstructuredArray": [
          "Finom"
        ],
        "debtorName": "Finom"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0yxeshspjws0xeeqa1k",
      "clustering": {
        "description": "Finom",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Finom' from 'Finom'",
        "updatedAt": "2025-09-27T10:49:37.730Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_73dh66smgztb6zgmn3rw6303m3",
      "createdAt": "2025-07-23T08:49:00.000Z",
      "updatedAt": "2025-07-23T08:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 103.37,
      "currency": "EUR",
      "description": "Payment to Giftmall.es: G-202507-7508",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pd6982q4dnkq734pj55xsnf07e",
      "fspDate": "2025-07-23T07:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pd6982q4dnkq734pj55xsnf07e",
        "bookingDate": "2025-07-23",
        "valueDate": "2025-07-23",
        "bookingDateTime": "2025-07-23T08:49:00.000Z",
        "valueDateTime": "2025-07-23T08:49:00.000Z",
        "transactionAmount": {
          "amount": "103.37",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Giftmall.es: G-202507-7508",
        "remittanceInformationUnstructuredArray": [
          "Payment to Giftmall.es",
          "G-202507-7508"
        ],
        "debtorName": "Giftmall.es"
      },
      "paymentId": null,
      "reference": "G-202507-7508",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctpfaeshspmwtrg2tk9zk",
      "clustering": {
        "description": "Giftmall.es",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Giftmall.es' based on payment details",
        "updatedAt": "2025-07-23T08:49:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Giftmall.es",
        "iban": "DE40627427389989064",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_vgsyp28kves4tvdadn0nbrgbh1",
      "createdAt": "2025-07-22T14:54:00.000Z",
      "updatedAt": "2025-07-22T14:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 215.34,
      "currency": "GBP",
      "description": "Payment to Kiwi.com: K-202507-8832",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mkp4bh777fnt55e1y8576b8jfc",
      "fspDate": "2025-07-22T13:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mkp4bh777fnt55e1y8576b8jfc",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T14:54:00.000Z",
        "valueDateTime": "2025-07-22T14:54:00.000Z",
        "transactionAmount": {
          "amount": "215.34",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kiwi.com: K-202507-8832",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kiwi.com",
          "K-202507-8832"
        ],
        "debtorName": "Kiwi.com"
      },
      "paymentId": null,
      "reference": "K-202507-8832",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9q1fvhrjp371wrcstvr",
      "clustering": {
        "description": "Kiwi.com",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kiwi.com' based on payment details",
        "updatedAt": "2025-07-22T14:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kiwi.com",
        "iban": null,
        "bic": null,
        "sortCode": "488960",
        "accountNumber": "54247558"
      }
    },
    {
      "id": "txn_zsa5cx6yqq13hvqbyw8dxev1gy",
      "createdAt": "2025-07-22T14:42:00.000Z",
      "updatedAt": "2025-07-22T14:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 26.79,
      "currency": "EUR",
      "description": "Payment to Anthony Moore: AM-202507-8858",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_y86bh1fdb1av8z9fcr0s6wrpb6",
      "fspDate": "2025-07-22T13:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_y86bh1fdb1av8z9fcr0s6wrpb6",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T14:42:00.000Z",
        "valueDateTime": "2025-07-22T14:42:00.000Z",
        "transactionAmount": {
          "amount": "26.79",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthony Moore: AM-202507-8858",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthony Moore",
          "AM-202507-8858"
        ],
        "debtorName": "Anthony Moore"
      },
      "paymentId": null,
      "reference": "AM-202507-8858",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a2keshspnzq7m9sbpn2",
      "clustering": {
        "description": "Anthony Moore",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthony Moore' based on payment details",
        "updatedAt": "2025-07-22T14:42:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthony Moore",
        "iban": "DE95918257525177150",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmgqcsmajhq9",
      "createdAt": "2025-07-22T14:24:00.000Z",
      "updatedAt": "2025-07-22T14:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 131,
      "currency": "GBP",
      "description": "Aer Lingus",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk895bsar153j",
      "fspDate": "2025-07-22T13:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk895bsar153j",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T13:24:00.000Z",
        "valueDateTime": "2025-07-22T13:24:00.000Z",
        "transactionAmount": {
          "amount": "-131.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Aer Lingus",
        "remittanceInformationUnstructuredArray": [
          "Aer Lingus"
        ],
        "debtorName": "Aer Lingus"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnekfvhrjnk2qd4ej2sf",
      "clustering": {
        "description": "Aer Lingus",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Aer Lingus' from the transaction description",
        "updatedAt": "2025-09-29T18:25:01.178Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_zd7fzx2g10kb8rgbct75ary4xk",
      "createdAt": "2025-07-22T12:26:00.000Z",
      "updatedAt": "2025-07-22T12:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 96.07,
      "currency": "EUR",
      "description": "Payment to Attio: A-202507-9755",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_95vej9fj4f5svsa6hr8eqc05jh",
      "fspDate": "2025-07-22T11:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_95vej9fj4f5svsa6hr8eqc05jh",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T12:26:00.000Z",
        "valueDateTime": "2025-07-22T12:26:00.000Z",
        "transactionAmount": {
          "amount": "96.07",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Attio: A-202507-9755",
        "remittanceInformationUnstructuredArray": [
          "Payment to Attio",
          "A-202507-9755"
        ],
        "debtorName": "Attio"
      },
      "paymentId": null,
      "reference": "A-202507-9755",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspj5eshspmpcdfterchh",
      "clustering": {
        "description": "Attio",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Attio' based on payment details",
        "updatedAt": "2025-07-22T12:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Attio",
        "iban": "DE63740410071965700",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgk52skfbjzf",
      "createdAt": "2025-07-22T12:04:00.000Z",
      "updatedAt": "2025-07-22T12:04:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5090,
      "currency": "EUR",
      "description": "Payment to Modulr Finance B.V EUR: SEA001-505BV",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jyeew1y1few8j2axqw8tf4t2",
      "fspDate": "2025-07-22T11:04:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jyeew1y1few8j2axqw8tf4t2",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T11:04:00.000Z",
        "valueDateTime": "2025-07-22T11:04:00.000Z",
        "transactionAmount": {
          "amount": "-5090.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Modulr Finance B.V. EUR: SEA001-505BV",
        "remittanceInformationUnstructuredArray": [
          "Payment to Modulr Finance B.V",
          "EUR: SEA001-505BV"
        ],
        "debtorName": "Modulr Finance B.V. EUR"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wy4eshspj04w7g0ffft",
      "clustering": {
        "description": "Modulr Finance B.V.",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Modulr Finance B.V.' from 'Payment to Modulr Finance B.V. EUR: SEA001-505BV'.",
        "updatedAt": "2025-09-27T10:52:47.510Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_kfhef4g11rqkp97t39s16ac61p",
      "createdAt": "2025-07-22T11:43:00.000Z",
      "updatedAt": "2025-07-22T11:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 18297.75,
      "currency": "EUR",
      "description": "Payment from Nordic Digital AB - INV-202507-6925",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_vemas245cq5nrac0e5r6kxnee2",
      "fspDate": "2025-07-22T10:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_vemas245cq5nrac0e5r6kxnee2",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T11:43:00.000Z",
        "valueDateTime": "2025-07-22T11:43:00.000Z",
        "transactionAmount": {
          "amount": "18297.75",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nordic Digital AB - INV-202507-6925",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nordic Digital AB",
          "INV-202507-6925"
        ],
        "creditorName": "Nordic Digital AB"
      },
      "paymentId": null,
      "reference": "INV-202507-6925",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_q7sgetg8gwgf23ac9gdqmk8cz4",
      "clustering": {
        "description": "Nordic Digital AB",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nordic Digital AB'",
        "updatedAt": "2025-07-22T11:43:00.000Z"
      },
      "payer": {
        "name": "Nordic Digital AB",
        "iban": "DE96884016819874220",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspf0zhhck86gw",
      "createdAt": "2025-07-22T10:26:00.000Z",
      "updatedAt": "2025-07-22T10:26:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 221.4,
      "currency": "EUR",
      "description": "Claude.ai Subscription",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2c29mndeskvka2mctd4rxw2",
      "fspDate": "2025-07-22T09:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2c29mndeskvka2mctd4rxw2",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T09:26:00.000Z",
        "valueDateTime": "2025-07-22T09:26:00.000Z",
        "transactionAmount": {
          "amount": "-221.40",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Claude.ai Subscription",
        "remittanceInformationUnstructuredArray": [
          "Claude.ai Subscription"
        ],
        "debtorName": "Claude.ai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5j1eshspjz017vq1wgn",
      "clustering": {
        "description": "Claude.ai",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Claude.ai' from 'Claude.ai Subscription'",
        "updatedAt": "2025-09-27T10:42:40.442Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspf0jn0pbr4wx",
      "createdAt": "2025-07-22T09:42:00.000Z",
      "updatedAt": "2025-07-22T09:42:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 127.67,
      "currency": "EUR",
      "description": "Slack T075w3v1kdk",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2c29mndeskvka29xwmb5a9g",
      "fspDate": "2025-07-22T08:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2c29mndeskvka29xwmb5a9g",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T08:42:00.000Z",
        "valueDateTime": "2025-07-22T08:42:00.000Z",
        "transactionAmount": {
          "amount": "-127.67",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Slack T075w3v1kdk",
        "remittanceInformationUnstructuredArray": [
          "Slack T075w3v1kdk"
        ],
        "debtorName": "Slack"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtb9eshspk6e4wt4npvh",
      "clustering": {
        "description": "Slack",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Slack' from 'Slack T075w3v1kdk'",
        "updatedAt": "2025-09-27T10:42:40.436Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspepdzn6f1kqr",
      "createdAt": "2025-07-22T09:35:00.000Z",
      "updatedAt": "2025-07-22T09:35:00.000Z",
      "status": "BOOKED",
      "type": "OTHER",
      "isCredit": false,
      "amount": 60,
      "currency": "EUR",
      "description": "Expenses app charges",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3dhf0y7eh2t1cyq96bfwx56",
      "fspDate": "2025-07-22T08:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3dhf0y7eh2t1cyq96bfwx56",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T08:35:00.000Z",
        "valueDateTime": "2025-07-22T08:35:00.000Z",
        "transactionAmount": {
          "amount": "-60.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "OTHER",
        "remittanceInformationUnstructured": "Expenses app charges",
        "remittanceInformationUnstructuredArray": [
          "Expenses app charges"
        ],
        "debtorName": "Expenses App"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mw3eshspjaesn0nt38r",
      "clustering": {
        "description": "Expenses App",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Expenses App' from 'Expenses app charges'",
        "updatedAt": "2025-09-27T10:40:26.899Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5mts77ahymwcztzgxzym1csd6r",
      "createdAt": "2025-07-22T08:33:00.000Z",
      "updatedAt": "2025-07-22T08:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 14485.59,
      "currency": "EUR",
      "description": "Payment from Alpine Software SA - INV-202507-9057",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4bnv99054s88h8decqx7tck19g",
      "fspDate": "2025-07-22T07:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4bnv99054s88h8decqx7tck19g",
        "bookingDate": "2025-07-22",
        "valueDate": "2025-07-22",
        "bookingDateTime": "2025-07-22T08:33:00.000Z",
        "valueDateTime": "2025-07-22T08:33:00.000Z",
        "transactionAmount": {
          "amount": "14485.59",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Alpine Software SA - INV-202507-9057",
        "remittanceInformationUnstructuredArray": [
          "Payment from Alpine Software SA",
          "INV-202507-9057"
        ],
        "creditorName": "Alpine Software SA"
      },
      "paymentId": null,
      "reference": "INV-202507-9057",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_nk7g93a6fpe8ybm4hppdmmfgsw",
      "clustering": {
        "description": "Alpine Software SA",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Alpine Software SA'",
        "updatedAt": "2025-07-22T08:33:00.000Z"
      },
      "payer": {
        "name": "Alpine Software SA",
        "iban": "DE22361507135246252",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjm3axp5sjjen",
      "createdAt": "2025-07-21T15:24:00.000Z",
      "updatedAt": "2025-07-21T15:24:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 8644.16,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3n8n7m0eh2tcb93xkdzj2t1",
      "fspDate": "2025-07-21T14:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n7m0eh2tcb93xkdzj2t1",
        "bookingDate": "2025-07-21",
        "valueDate": "2025-07-21",
        "bookingDateTime": "2025-07-21T14:24:00.000Z",
        "valueDateTime": "2025-07-21T14:24:00.000Z",
        "transactionAmount": {
          "amount": "8644.16",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the merchant name for the exchange to GBP transaction with code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:23:50.803Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_fcvknh43x67vrw71vjv37ttee8",
      "createdAt": "2025-07-21T12:50:00.000Z",
      "updatedAt": "2025-07-21T12:50:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 13.05,
      "currency": "EUR",
      "description": "Payment to A Taste of Thai: ATO-202507-3202",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_sn0bf3fst2vr4tdtssa7qqamvd",
      "fspDate": "2025-07-21T11:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_sn0bf3fst2vr4tdtssa7qqamvd",
        "bookingDate": "2025-07-21",
        "valueDate": "2025-07-21",
        "bookingDateTime": "2025-07-21T12:50:00.000Z",
        "valueDateTime": "2025-07-21T12:50:00.000Z",
        "transactionAmount": {
          "amount": "13.05",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to A Taste of Thai: ATO-202507-3202",
        "remittanceInformationUnstructuredArray": [
          "Payment to A Taste of Thai",
          "ATO-202507-3202"
        ],
        "debtorName": "A Taste of Thai"
      },
      "paymentId": null,
      "reference": "ATO-202507-3202",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1m2eshspm6a6wp0a9jq",
      "clustering": {
        "description": "A Taste of Thai",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'A Taste of Thai' based on payment details",
        "updatedAt": "2025-07-21T12:50:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "A Taste of Thai",
        "iban": "DE93399749170527090",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg5431pa4hnp",
      "createdAt": "2025-07-21T12:41:00.000Z",
      "updatedAt": "2025-07-21T12:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 37.5,
      "currency": "EUR",
      "description": "Sumup *doncanizales",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk115j6pr52sb",
      "fspDate": "2025-07-21T11:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk115j6pr52sb",
        "bookingDate": "2025-07-21",
        "valueDate": "2025-07-21",
        "bookingDateTime": "2025-07-21T11:41:00.000Z",
        "valueDateTime": "2025-07-21T11:41:00.000Z",
        "transactionAmount": {
          "amount": "-37.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sumup *doncanizales",
        "remittanceInformationUnstructuredArray": [
          "Sumup *doncanizales"
        ],
        "debtorName": "Don Canizales"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "clustering": {
        "description": "Don Canizales",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Don Canizales' from 'Sumup *doncanizales', removing the 'Sumup *' prefix.",
        "updatedAt": "2025-09-27T10:51:38.197Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_8ftc10qje0cvj3rb0gtgsevqdh",
      "createdAt": "2025-07-21T11:26:00.000Z",
      "updatedAt": "2025-07-21T11:26:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 18.15,
      "currency": "EUR",
      "description": "Payment to Marquette: M-202507-5069",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4hxnnw9jc22hyqxmtydff2tf8b",
      "fspDate": "2025-07-21T10:26:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4hxnnw9jc22hyqxmtydff2tf8b",
        "bookingDate": "2025-07-21",
        "valueDate": "2025-07-21",
        "bookingDateTime": "2025-07-21T11:26:00.000Z",
        "valueDateTime": "2025-07-21T11:26:00.000Z",
        "transactionAmount": {
          "amount": "18.15",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Marquette: M-202507-5069",
        "remittanceInformationUnstructuredArray": [
          "Payment to Marquette",
          "M-202507-5069"
        ],
        "debtorName": "Marquette"
      },
      "paymentId": null,
      "reference": "M-202507-5069",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1npeshspm6wcf3gtsdh",
      "clustering": {
        "description": "Marquette",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Marquette' based on payment details",
        "updatedAt": "2025-07-21T11:26:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Marquette",
        "iban": "DE70026863203873940",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_hwts1ddrsk9tp7h0ed3rqth4s5",
      "createdAt": "2025-07-21T10:19:00.000Z",
      "updatedAt": "2025-07-21T10:19:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4.78,
      "currency": "EUR",
      "description": "Payment to Spar: S-202507-3863",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5c0s13jfz81xdwvghycbdtmxk5",
      "fspDate": "2025-07-21T09:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5c0s13jfz81xdwvghycbdtmxk5",
        "bookingDate": "2025-07-21",
        "valueDate": "2025-07-21",
        "bookingDateTime": "2025-07-21T10:19:00.000Z",
        "valueDateTime": "2025-07-21T10:19:00.000Z",
        "transactionAmount": {
          "amount": "4.78",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Spar: S-202507-3863",
        "remittanceInformationUnstructuredArray": [
          "Payment to Spar",
          "S-202507-3863"
        ],
        "debtorName": "Spar"
      },
      "paymentId": null,
      "reference": "S-202507-3863",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g32eshsphp8z5k4nrvg",
      "clustering": {
        "description": "Spar",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Spar' based on payment details",
        "updatedAt": "2025-07-21T10:19:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Spar",
        "iban": "DE66765414292713040",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_kpxq6yja1h1h00c2ct12bgvym1",
      "createdAt": "2025-07-21T09:49:00.000Z",
      "updatedAt": "2025-07-21T09:49:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3556.78,
      "currency": "EUR",
      "description": "Payment to Pembroke Hall: PH-202507-5319",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_pc2af796w7hc88365yegcacsck",
      "fspDate": "2025-07-21T08:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_pc2af796w7hc88365yegcacsck",
        "bookingDate": "2025-07-21",
        "valueDate": "2025-07-21",
        "bookingDateTime": "2025-07-21T09:49:00.000Z",
        "valueDateTime": "2025-07-21T09:49:00.000Z",
        "transactionAmount": {
          "amount": "3556.78",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pembroke Hall: PH-202507-5319",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pembroke Hall",
          "PH-202507-5319"
        ],
        "debtorName": "Pembroke Hall"
      },
      "paymentId": null,
      "reference": "PH-202507-5319",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzdeshsphm46adfgbg7",
      "clustering": {
        "description": "Pembroke Hall",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pembroke Hall' based on payment details",
        "updatedAt": "2025-07-21T09:49:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pembroke Hall",
        "iban": "DE25288216825969184",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgm5ajqkfpzy",
      "createdAt": "2025-07-21T09:40:00.000Z",
      "updatedAt": "2025-07-21T09:40:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 32.43,
      "currency": "EUR",
      "description": "Veremark",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1hps78e483e",
      "fspDate": "2025-07-21T08:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1hps78e483e",
        "bookingDate": "2025-07-21",
        "valueDate": "2025-07-21",
        "bookingDateTime": "2025-07-21T08:40:00.000Z",
        "valueDateTime": "2025-07-21T08:40:00.000Z",
        "transactionAmount": {
          "amount": "-32.43",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Veremark",
        "remittanceInformationUnstructuredArray": [
          "Veremark"
        ],
        "debtorName": "Veremark"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cwwc3eshspn9n53st1zft",
      "clustering": {
        "description": "Veremark",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Veremark' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.081Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_s5b6jgkfc2pat30tvyctpkv9hv",
      "createdAt": "2025-07-21T09:15:00.000Z",
      "updatedAt": "2025-07-21T09:15:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 72.9,
      "currency": "EUR",
      "description": "Payment to Retool: R-202507-5575",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_0g1gjbvcc5mjd91qvqhpy1gw6h",
      "fspDate": "2025-07-21T08:15:00.000Z",
      "fspRecord": {
        "transactionId": "txn_0g1gjbvcc5mjd91qvqhpy1gw6h",
        "bookingDate": "2025-07-21",
        "valueDate": "2025-07-21",
        "bookingDateTime": "2025-07-21T09:15:00.000Z",
        "valueDateTime": "2025-07-21T09:15:00.000Z",
        "transactionAmount": {
          "amount": "72.90",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Retool: R-202507-5575",
        "remittanceInformationUnstructuredArray": [
          "Payment to Retool",
          "R-202507-5575"
        ],
        "debtorName": "Retool"
      },
      "paymentId": null,
      "reference": "R-202507-5575",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdp6eshspk9a3b1e6677",
      "clustering": {
        "description": "Retool",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Retool' based on payment details",
        "updatedAt": "2025-07-21T09:15:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Retool",
        "iban": "DE24476194643793524",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_pdsfkgjcr030sj2gqt760mzc68",
      "createdAt": "2025-07-20T13:43:00.000Z",
      "updatedAt": "2025-07-20T13:43:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 24.53,
      "currency": "GBP",
      "description": "Payment to Argos: A-202507-8326",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_eeyb4m1gfb7a0qmk3xy6pbpq60",
      "fspDate": "2025-07-20T12:43:00.000Z",
      "fspRecord": {
        "transactionId": "txn_eeyb4m1gfb7a0qmk3xy6pbpq60",
        "bookingDate": "2025-07-20",
        "valueDate": "2025-07-20",
        "bookingDateTime": "2025-07-20T13:43:00.000Z",
        "valueDateTime": "2025-07-20T13:43:00.000Z",
        "transactionAmount": {
          "amount": "24.53",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Argos: A-202507-8326",
        "remittanceInformationUnstructuredArray": [
          "Payment to Argos",
          "A-202507-8326"
        ],
        "debtorName": "Argos"
      },
      "paymentId": null,
      "reference": "A-202507-8326",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgp9fvhrjp1ker17rwy0",
      "clustering": {
        "description": "Argos",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Argos' based on payment details",
        "updatedAt": "2025-07-20T13:43:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Argos",
        "iban": null,
        "bic": null,
        "sortCode": "680238",
        "accountNumber": "40280721"
      }
    },
    {
      "id": "txn_01k65c32y3eshspfwdx2bfvxmx",
      "createdAt": "2025-07-20T13:10:00.000Z",
      "updatedAt": "2025-07-20T13:10:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 131.15,
      "currency": "EUR",
      "description": "Slack T075w3v1kdk",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0rh7ngajvqs",
      "fspDate": "2025-07-20T12:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0rh7ngajvqs",
        "bookingDate": "2025-07-20",
        "valueDate": "2025-07-20",
        "bookingDateTime": "2025-07-20T12:10:00.000Z",
        "valueDateTime": "2025-07-20T12:10:00.000Z",
        "transactionAmount": {
          "amount": "-131.15",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Slack T075w3v1kdk",
        "remittanceInformationUnstructuredArray": [
          "Slack T075w3v1kdk"
        ],
        "debtorName": "Slack"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtb9eshspk6e4wt4npvh",
      "clustering": {
        "description": "Slack",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Slack' from 'Slack T075w3v1kdk'",
        "updatedAt": "2025-09-27T10:50:08.352Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_k4xafwpcqt75smd6xhrpx1tarn",
      "createdAt": "2025-07-20T10:27:00.000Z",
      "updatedAt": "2025-07-20T10:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 8958.29,
      "currency": "EUR",
      "description": "Payment to Cormac Byrne: CB-202507-6843",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_yv60vty1n964zaj54f6wrbm2s9",
      "fspDate": "2025-07-20T09:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_yv60vty1n964zaj54f6wrbm2s9",
        "bookingDate": "2025-07-20",
        "valueDate": "2025-07-20",
        "bookingDateTime": "2025-07-20T10:27:00.000Z",
        "valueDateTime": "2025-07-20T10:27:00.000Z",
        "transactionAmount": {
          "amount": "8958.29",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Cormac Byrne: CB-202507-6843",
        "remittanceInformationUnstructuredArray": [
          "Payment to Cormac Byrne",
          "CB-202507-6843"
        ],
        "debtorName": "Cormac Byrne"
      },
      "paymentId": null,
      "reference": "CB-202507-6843",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zspeshspj7tfmtn8s05",
      "clustering": {
        "description": "Cormac Byrne",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Cormac Byrne' based on payment details",
        "updatedAt": "2025-07-20T10:27:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Cormac Byrne",
        "iban": "DE57011933174489690",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_76za33411axd5w9wm1xg7xztj1",
      "createdAt": "2025-07-20T10:14:00.000Z",
      "updatedAt": "2025-07-20T10:14:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 22388.92,
      "currency": "EUR",
      "description": "Payment from Nexus Consulting GmbH - INV-202507-7903",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_kvh53031d4td1n887qj5jmt9hx",
      "fspDate": "2025-07-20T09:14:00.000Z",
      "fspRecord": {
        "transactionId": "txn_kvh53031d4td1n887qj5jmt9hx",
        "bookingDate": "2025-07-20",
        "valueDate": "2025-07-20",
        "bookingDateTime": "2025-07-20T10:14:00.000Z",
        "valueDateTime": "2025-07-20T10:14:00.000Z",
        "transactionAmount": {
          "amount": "22388.92",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Nexus Consulting GmbH - INV-202507-7903",
        "remittanceInformationUnstructuredArray": [
          "Payment from Nexus Consulting GmbH",
          "INV-202507-7903"
        ],
        "creditorName": "Nexus Consulting GmbH"
      },
      "paymentId": null,
      "reference": "INV-202507-7903",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_631832eta7hj1n2x0gedv5fm59",
      "clustering": {
        "description": "Nexus Consulting GmbH",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Nexus Consulting GmbH'",
        "updatedAt": "2025-07-20T10:14:00.000Z"
      },
      "payer": {
        "name": "Nexus Consulting GmbH",
        "iban": "DE55653360252949460",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5eyx29wkb0n57ccwv1sa77ad9c",
      "createdAt": "2025-07-20T09:22:00.000Z",
      "updatedAt": "2025-07-20T09:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 201.99,
      "currency": "USD",
      "description": "Payment to OpenAI: O-202507-7633",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_cn9rgvc268k3xdftn6przd4k32",
      "fspDate": "2025-07-20T08:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_cn9rgvc268k3xdftn6przd4k32",
        "bookingDate": "2025-07-20",
        "valueDate": "2025-07-20",
        "bookingDateTime": "2025-07-20T09:22:00.000Z",
        "valueDateTime": "2025-07-20T09:22:00.000Z",
        "transactionAmount": {
          "amount": "201.99",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to OpenAI: O-202507-7633",
        "remittanceInformationUnstructuredArray": [
          "Payment to OpenAI",
          "O-202507-7633"
        ],
        "debtorName": "OpenAI"
      },
      "paymentId": null,
      "reference": "O-202507-7633",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "clustering": {
        "description": "OpenAI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'OpenAI' based on payment details",
        "updatedAt": "2025-07-20T09:22:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "OpenAI",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_9zbt9ark6xwp08tw7h1vc675j9",
      "createdAt": "2025-07-20T09:18:00.000Z",
      "updatedAt": "2025-07-20T09:18:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 169.2,
      "currency": "GBP",
      "description": "Payment to Ryanair: R-202507-1077",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_4e463v6v3kkns9e92j4nwqbsmh",
      "fspDate": "2025-07-20T08:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_4e463v6v3kkns9e92j4nwqbsmh",
        "bookingDate": "2025-07-20",
        "valueDate": "2025-07-20",
        "bookingDateTime": "2025-07-20T09:18:00.000Z",
        "valueDateTime": "2025-07-20T09:18:00.000Z",
        "transactionAmount": {
          "amount": "169.20",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Ryanair: R-202507-1077",
        "remittanceInformationUnstructuredArray": [
          "Payment to Ryanair",
          "R-202507-1077"
        ],
        "debtorName": "Ryanair"
      },
      "paymentId": null,
      "reference": "R-202507-1077",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ctphbeshspmx6q13ktd74",
      "clustering": {
        "description": "Ryanair",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Ryanair' based on payment details",
        "updatedAt": "2025-07-20T09:18:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Ryanair",
        "iban": null,
        "bic": null,
        "sortCode": "545901",
        "accountNumber": "11156020"
      }
    },
    {
      "id": "txn_r69k55p2fbj565e2dfskyytqdr",
      "createdAt": "2025-07-20T08:55:00.000Z",
      "updatedAt": "2025-07-20T08:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.87,
      "currency": "EUR",
      "description": "Payment to Tortilla Latin Food: TLF-202507-1577",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_fsnzm2h0n34mgb9zaz7j5d847y",
      "fspDate": "2025-07-20T07:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_fsnzm2h0n34mgb9zaz7j5d847y",
        "bookingDate": "2025-07-20",
        "valueDate": "2025-07-20",
        "bookingDateTime": "2025-07-20T08:55:00.000Z",
        "valueDateTime": "2025-07-20T08:55:00.000Z",
        "transactionAmount": {
          "amount": "10.87",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tortilla Latin Food: TLF-202507-1577",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tortilla Latin Food",
          "TLF-202507-1577"
        ],
        "debtorName": "Tortilla Latin Food"
      },
      "paymentId": null,
      "reference": "TLF-202507-1577",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cspgkeshspmp0mmzf2w0c",
      "clustering": {
        "description": "Tortilla Latin Food",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tortilla Latin Food' based on payment details",
        "updatedAt": "2025-07-20T08:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tortilla Latin Food",
        "iban": "DE89935669595211410",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_x0e6jtm98nh6455e0zfteebeya",
      "createdAt": "2025-07-19T15:46:00.000Z",
      "updatedAt": "2025-07-19T15:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2350.59,
      "currency": "EUR",
      "description": "Payment to Sophie Laurent: SL-202507-7779",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_a3erf5y2hjysdkjspmfxvjy7av",
      "fspDate": "2025-07-19T14:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_a3erf5y2hjysdkjspmfxvjy7av",
        "bookingDate": "2025-07-19",
        "valueDate": "2025-07-19",
        "bookingDateTime": "2025-07-19T15:46:00.000Z",
        "valueDateTime": "2025-07-19T15:46:00.000Z",
        "transactionAmount": {
          "amount": "2350.59",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sophie Laurent: SL-202507-7779",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sophie Laurent",
          "SL-202507-7779"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": "SL-202507-7779",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc5eshspj0rxb4j151x",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sophie Laurent' based on payment details",
        "updatedAt": "2025-07-19T15:46:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sophie Laurent",
        "iban": "DE13098801385025352",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph21dfaaecw9",
      "createdAt": "2025-07-19T15:39:00.000Z",
      "updatedAt": "2025-07-19T15:39:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 39,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk20s14x7sqf0",
      "fspDate": "2025-07-19T14:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk20s14x7sqf0",
        "bookingDate": "2025-07-19",
        "valueDate": "2025-07-19",
        "bookingDateTime": "2025-07-19T14:39:00.000Z",
        "valueDateTime": "2025-07-19T14:39:00.000Z",
        "transactionAmount": {
          "amount": "-39.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'DocuSign' from 'Docusign'.",
        "updatedAt": "2025-09-27T10:54:12.617Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_51evqzfdwck7ed51bs3tbxtw22",
      "createdAt": "2025-07-19T14:58:00.000Z",
      "updatedAt": "2025-07-19T14:58:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1897.98,
      "currency": "EUR",
      "description": "Payment to Patrick Walsh: PW-202507-9382",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mt5567hccq64tw459srcc6vjne",
      "fspDate": "2025-07-19T13:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mt5567hccq64tw459srcc6vjne",
        "bookingDate": "2025-07-19",
        "valueDate": "2025-07-19",
        "bookingDateTime": "2025-07-19T14:58:00.000Z",
        "valueDateTime": "2025-07-19T14:58:00.000Z",
        "transactionAmount": {
          "amount": "1897.98",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Patrick Walsh: PW-202507-9382",
        "remittanceInformationUnstructuredArray": [
          "Payment to Patrick Walsh",
          "PW-202507-9382"
        ],
        "debtorName": "Patrick Walsh"
      },
      "paymentId": null,
      "reference": "PW-202507-9382",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cqmzweshspm8kq27v8562",
      "clustering": {
        "description": "Patrick Walsh",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Patrick Walsh' based on payment details",
        "updatedAt": "2025-07-19T14:58:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Patrick Walsh",
        "iban": "DE85011467688463940",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_m4thmbxfx9h963a7zr3g7t0sy1",
      "createdAt": "2025-07-19T14:01:00.000Z",
      "updatedAt": "2025-07-19T14:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 59.95,
      "currency": "GBP",
      "description": "Payment to LinkedIn: L-202507-6820",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zaf9cymwgwcv6xmx05pveb4g4x",
      "fspDate": "2025-07-19T13:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zaf9cymwgwcv6xmx05pveb4g4x",
        "bookingDate": "2025-07-19",
        "valueDate": "2025-07-19",
        "bookingDateTime": "2025-07-19T14:01:00.000Z",
        "valueDateTime": "2025-07-19T14:01:00.000Z",
        "transactionAmount": {
          "amount": "59.95",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to LinkedIn: L-202507-6820",
        "remittanceInformationUnstructuredArray": [
          "Payment to LinkedIn",
          "L-202507-6820"
        ],
        "debtorName": "LinkedIn"
      },
      "paymentId": null,
      "reference": "L-202507-6820",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "clustering": {
        "description": "LinkedIn",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'LinkedIn' based on payment details",
        "updatedAt": "2025-07-19T14:01:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "LinkedIn",
        "iban": null,
        "bic": null,
        "sortCode": "834690",
        "accountNumber": "35974912"
      }
    },
    {
      "id": "txn_5gnc9566mcz1s2snvnshy8dayb",
      "createdAt": "2025-07-19T12:54:00.000Z",
      "updatedAt": "2025-07-19T12:54:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 10.02,
      "currency": "EUR",
      "description": "Payment to Beanhive: B-202507-2684",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_zhsycwvybv9z9y4xt7q5rqz0rh",
      "fspDate": "2025-07-19T11:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_zhsycwvybv9z9y4xt7q5rqz0rh",
        "bookingDate": "2025-07-19",
        "valueDate": "2025-07-19",
        "bookingDateTime": "2025-07-19T12:54:00.000Z",
        "valueDateTime": "2025-07-19T12:54:00.000Z",
        "transactionAmount": {
          "amount": "10.02",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Beanhive: B-202507-2684",
        "remittanceInformationUnstructuredArray": [
          "Payment to Beanhive",
          "B-202507-2684"
        ],
        "debtorName": "Beanhive"
      },
      "paymentId": null,
      "reference": "B-202507-2684",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmacweshspkk5mv2ktdq4",
      "clustering": {
        "description": "Beanhive",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Beanhive' based on payment details",
        "updatedAt": "2025-07-19T12:54:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Beanhive",
        "iban": "DE55825844811761630",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgkyqn0vwh0y",
      "createdAt": "2025-07-19T12:46:00.000Z",
      "updatedAt": "2025-07-19T12:46:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 23,
      "currency": "EUR",
      "description": "Sq *amba",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1h5b9bkanz0",
      "fspDate": "2025-07-19T11:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1h5b9bkanz0",
        "bookingDate": "2025-07-19",
        "valueDate": "2025-07-19",
        "bookingDateTime": "2025-07-19T11:46:00.000Z",
        "valueDateTime": "2025-07-19T11:46:00.000Z",
        "transactionAmount": {
          "amount": "-23.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *amba",
        "remittanceInformationUnstructuredArray": [
          "Sq *amba"
        ],
        "debtorName": "Amba"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g1aeshsphp662hfbd17",
      "clustering": {
        "description": "Amba",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Amba' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.077Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgas3b2ewpb6",
      "createdAt": "2025-07-19T08:41:00.000Z",
      "updatedAt": "2025-07-19T08:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 50,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk193b286005t",
      "fspDate": "2025-07-19T07:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk193b286005t",
        "bookingDate": "2025-07-19",
        "valueDate": "2025-07-19",
        "bookingDateTime": "2025-07-19T07:41:00.000Z",
        "valueDateTime": "2025-07-19T07:41:00.000Z",
        "transactionAmount": {
          "amount": "-50.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Burger Cartel' from 'Burger Cartel Limited'",
        "updatedAt": "2025-09-27T10:52:10.003Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgctgrpyrfhq",
      "createdAt": "2025-07-19T08:03:00.000Z",
      "updatedAt": "2025-07-19T08:03:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 39,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1b5ygzhnf4d",
      "fspDate": "2025-07-19T07:03:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1b5ygzhnf4d",
        "bookingDate": "2025-07-19",
        "valueDate": "2025-07-19",
        "bookingDateTime": "2025-07-19T07:03:00.000Z",
        "valueDateTime": "2025-07-19T07:03:00.000Z",
        "transactionAmount": {
          "amount": "-39.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'DocuSign' from 'Docusign'",
        "updatedAt": "2025-09-27T10:52:10.103Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nfwk0d5kv5e2e7a3av80s97sr8",
      "createdAt": "2025-07-18T15:24:00.000Z",
      "updatedAt": "2025-07-18T15:24:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 329.94,
      "currency": "EUR",
      "description": "Payment to Company Formations International: CFI-202507-7917",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_azjmzjvp4hz65g14tbaxjdp8gp",
      "fspDate": "2025-07-18T14:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_azjmzjvp4hz65g14tbaxjdp8gp",
        "bookingDate": "2025-07-18",
        "valueDate": "2025-07-18",
        "bookingDateTime": "2025-07-18T15:24:00.000Z",
        "valueDateTime": "2025-07-18T15:24:00.000Z",
        "transactionAmount": {
          "amount": "329.94",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Company Formations International: CFI-202507-7917",
        "remittanceInformationUnstructuredArray": [
          "Payment to Company Formations International",
          "CFI-202507-7917"
        ],
        "debtorName": "Company Formations International"
      },
      "paymentId": null,
      "reference": "CFI-202507-7917",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cvstpeshspn39955xdf4m",
      "clustering": {
        "description": "Company Formations International",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Company Formations International' based on payment details",
        "updatedAt": "2025-07-18T15:24:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Company Formations International",
        "iban": "DE68026218917807630",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_57wv9qce4ecrrr9m3kmtq5wm67",
      "createdAt": "2025-07-18T15:23:00.000Z",
      "updatedAt": "2025-07-18T15:23:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 16114,
      "currency": "EUR",
      "description": "Payment from EuroTech Innovations - INV-202507-6856",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_sdkhg4z8qzggvs82trtjy19wxf",
      "fspDate": "2025-07-18T14:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_sdkhg4z8qzggvs82trtjy19wxf",
        "bookingDate": "2025-07-18",
        "valueDate": "2025-07-18",
        "bookingDateTime": "2025-07-18T15:23:00.000Z",
        "valueDateTime": "2025-07-18T15:23:00.000Z",
        "transactionAmount": {
          "amount": "16114.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from EuroTech Innovations - INV-202507-6856",
        "remittanceInformationUnstructuredArray": [
          "Payment from EuroTech Innovations",
          "INV-202507-6856"
        ],
        "creditorName": "EuroTech Innovations"
      },
      "paymentId": null,
      "reference": "INV-202507-6856",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_m17gcz62vyhqqefr5q41a31k5f",
      "clustering": {
        "description": "EuroTech Innovations",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'EuroTech Innovations'",
        "updatedAt": "2025-07-18T15:23:00.000Z"
      },
      "payer": {
        "name": "EuroTech Innovations",
        "iban": "DE64264359910286560",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_m5saex626psk4e7k5ca7r3yzhx",
      "createdAt": "2025-07-18T15:07:00.000Z",
      "updatedAt": "2025-07-18T15:07:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 226.98,
      "currency": "EUR",
      "description": "Payment to Welcome to the Jungle: WTT-202507-2815",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_syy9187pkz4gw8jczfqc62ep80",
      "fspDate": "2025-07-18T14:07:00.000Z",
      "fspRecord": {
        "transactionId": "txn_syy9187pkz4gw8jczfqc62ep80",
        "bookingDate": "2025-07-18",
        "valueDate": "2025-07-18",
        "bookingDateTime": "2025-07-18T15:07:00.000Z",
        "valueDateTime": "2025-07-18T15:07:00.000Z",
        "transactionAmount": {
          "amount": "226.98",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Welcome to the Jungle: WTT-202507-2815",
        "remittanceInformationUnstructuredArray": [
          "Payment to Welcome to the Jungle",
          "WTT-202507-2815"
        ],
        "debtorName": "Welcome to the Jungle"
      },
      "paymentId": null,
      "reference": "WTT-202507-2815",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65czkfxeshspnwz7ebn2y1d",
      "clustering": {
        "description": "Welcome to the Jungle",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Welcome to the Jungle' based on payment details",
        "updatedAt": "2025-07-18T15:07:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Welcome to the Jungle",
        "iban": "DE35309746402613070",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf92gr1xhmvm",
      "createdAt": "2025-07-18T14:23:00.000Z",
      "updatedAt": "2025-07-18T14:23:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 13912.44,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1dt4xzzfewaj92s3n22w75c",
      "fspDate": "2025-07-18T13:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1dt4xzzfewaj92s3n22w75c",
        "bookingDate": "2025-07-18",
        "valueDate": "2025-07-18",
        "bookingDateTime": "2025-07-18T13:23:00.000Z",
        "valueDateTime": "2025-07-18T13:23:00.000Z",
        "transactionAmount": {
          "amount": "-13912.44",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:45:11.601Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspet9wz591zts",
      "createdAt": "2025-07-18T13:59:00.000Z",
      "updatedAt": "2025-07-18T13:59:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1503.01,
      "currency": "EUR",
      "description": "Upwork -837969856ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k30nfe7xfzwbhvcz4t1sc5cj",
      "fspDate": "2025-07-18T12:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k30nfe7xfzwbhvcz4t1sc5cj",
        "bookingDate": "2025-07-18",
        "valueDate": "2025-07-18",
        "bookingDateTime": "2025-07-18T12:59:00.000Z",
        "valueDateTime": "2025-07-18T12:59:00.000Z",
        "transactionAmount": {
          "amount": "-1503.01",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -837969856ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -837969856ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Upwork' from the 'Upwork -837969856ref' transaction description.",
        "updatedAt": "2025-09-27T10:41:48.223Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_yvz9fpy9ra32sz8dbsqzrm2ccs",
      "createdAt": "2025-07-18T11:36:00.000Z",
      "updatedAt": "2025-07-18T11:36:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 25.34,
      "currency": "EUR",
      "description": "Payment to Tavily AI: TA-202507-6160",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_d58z9yb1qvfdh1vgmk5k9xqtet",
      "fspDate": "2025-07-18T10:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_d58z9yb1qvfdh1vgmk5k9xqtet",
        "bookingDate": "2025-07-18",
        "valueDate": "2025-07-18",
        "bookingDateTime": "2025-07-18T11:36:00.000Z",
        "valueDateTime": "2025-07-18T11:36:00.000Z",
        "transactionAmount": {
          "amount": "25.34",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Tavily AI: TA-202507-6160",
        "remittanceInformationUnstructuredArray": [
          "Payment to Tavily AI",
          "TA-202507-6160"
        ],
        "debtorName": "Tavily AI"
      },
      "paymentId": null,
      "reference": "TA-202507-6160",
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ceerteshspk5wmka0h0ee",
      "clustering": {
        "description": "Tavily AI",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Tavily AI' based on payment details",
        "updatedAt": "2025-07-18T11:36:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Tavily AI",
        "iban": "DE12235531647066914",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_qm98v2e4n5j13vq4qkmchnf5w6",
      "createdAt": "2025-07-18T10:40:00.000Z",
      "updatedAt": "2025-07-18T10:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 44.62,
      "currency": "EUR",
      "description": "Payment to Mamma Mia Restaurant: MMR-202507-4724",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_jps5y4vr3ypam9qanxh4wfhh98",
      "fspDate": "2025-07-18T09:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_jps5y4vr3ypam9qanxh4wfhh98",
        "bookingDate": "2025-07-18",
        "valueDate": "2025-07-18",
        "bookingDateTime": "2025-07-18T10:40:00.000Z",
        "valueDateTime": "2025-07-18T10:40:00.000Z",
        "transactionAmount": {
          "amount": "44.62",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mamma Mia Restaurant: MMR-202507-4724",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mamma Mia Restaurant",
          "MMR-202507-4724"
        ],
        "debtorName": "Mamma Mia Restaurant"
      },
      "paymentId": null,
      "reference": "MMR-202507-4724",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj1yeshspngr1g523f6q",
      "clustering": {
        "description": "Mamma Mia Restaurant",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mamma Mia Restaurant' based on payment details",
        "updatedAt": "2025-07-18T10:40:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mamma Mia Restaurant",
        "iban": "DE12643531978527638",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_nkas3gt2pd179h137zrk32zc1w",
      "createdAt": "2025-07-17T15:40:00.000Z",
      "updatedAt": "2025-07-17T15:40:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 150.57,
      "currency": "USD",
      "description": "Payment to Anthropic: A-202507-9731",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_66vsxr6tczd6hdye86781hvd9n",
      "fspDate": "2025-07-17T14:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_66vsxr6tczd6hdye86781hvd9n",
        "bookingDate": "2025-07-17",
        "valueDate": "2025-07-17",
        "bookingDateTime": "2025-07-17T15:40:00.000Z",
        "valueDateTime": "2025-07-17T15:40:00.000Z",
        "transactionAmount": {
          "amount": "150.57",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Anthropic: A-202507-9731",
        "remittanceInformationUnstructuredArray": [
          "Payment to Anthropic",
          "A-202507-9731"
        ],
        "debtorName": "Anthropic"
      },
      "paymentId": null,
      "reference": "A-202507-9731",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0y2eshspjwh0d2fxb76",
      "clustering": {
        "description": "Anthropic",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Anthropic' based on payment details",
        "updatedAt": "2025-07-17T15:40:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Anthropic",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5ybpje5j71pfkdv5nrn9f4zch1",
      "createdAt": "2025-07-17T15:30:00.000Z",
      "updatedAt": "2025-07-17T15:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 49.74,
      "currency": "GBP",
      "description": "Payment to ICO: I-202507-1105",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_2devw76rp9k0y951cxq242n8ne",
      "fspDate": "2025-07-17T14:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_2devw76rp9k0y951cxq242n8ne",
        "bookingDate": "2025-07-17",
        "valueDate": "2025-07-17",
        "bookingDateTime": "2025-07-17T15:30:00.000Z",
        "valueDateTime": "2025-07-17T15:30:00.000Z",
        "transactionAmount": {
          "amount": "49.74",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to ICO: I-202507-1105",
        "remittanceInformationUnstructuredArray": [
          "Payment to ICO",
          "I-202507-1105"
        ],
        "debtorName": "ICO"
      },
      "paymentId": null,
      "reference": "I-202507-1105",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbk4gyfvhrjnsxtfs19v9b",
      "clustering": {
        "description": "ICO",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'ICO' based on payment details",
        "updatedAt": "2025-07-17T15:30:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "ICO",
        "iban": null,
        "bic": null,
        "sortCode": "142123",
        "accountNumber": "70348109"
      }
    },
    {
      "id": "txn_897vt6yerqjr1s0k1vypqemb7w",
      "createdAt": "2025-07-17T13:20:00.000Z",
      "updatedAt": "2025-07-17T13:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 448.2,
      "currency": "USD",
      "description": "Payment to Kandji: K-202507-7646",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_s98gdh0t4jmtmk27st26sf5vrw",
      "fspDate": "2025-07-17T12:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_s98gdh0t4jmtmk27st26sf5vrw",
        "bookingDate": "2025-07-17",
        "valueDate": "2025-07-17",
        "bookingDateTime": "2025-07-17T13:20:00.000Z",
        "valueDateTime": "2025-07-17T13:20:00.000Z",
        "transactionAmount": {
          "amount": "448.20",
          "currency": "USD"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Kandji: K-202507-7646",
        "remittanceInformationUnstructuredArray": [
          "Payment to Kandji",
          "K-202507-7646"
        ],
        "debtorName": "Kandji"
      },
      "paymentId": null,
      "reference": "K-202507-7646",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax4veshspjmy8ae028r6",
      "clustering": {
        "description": "Kandji",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Kandji' based on payment details",
        "updatedAt": "2025-07-17T13:20:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Kandji",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_bvnmv5yqbnvp0r5w5044j65f00",
      "createdAt": "2025-07-17T13:19:00.000Z",
      "updatedAt": "2025-07-17T13:19:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 39.48,
      "currency": "GBP",
      "description": "Payment to Financial Times: FT-202507-4336",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mk88t9vpdawf9912q028gjmn5t",
      "fspDate": "2025-07-17T12:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mk88t9vpdawf9912q028gjmn5t",
        "bookingDate": "2025-07-17",
        "valueDate": "2025-07-17",
        "bookingDateTime": "2025-07-17T13:19:00.000Z",
        "valueDateTime": "2025-07-17T13:19:00.000Z",
        "transactionAmount": {
          "amount": "39.48",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Financial Times: FT-202507-4336",
        "remittanceInformationUnstructuredArray": [
          "Payment to Financial Times",
          "FT-202507-4336"
        ],
        "debtorName": "Financial Times"
      },
      "paymentId": null,
      "reference": "FT-202507-4336",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5gjeshspjygqrrg6sk5",
      "clustering": {
        "description": "Financial Times",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Financial Times' based on payment details",
        "updatedAt": "2025-07-17T13:19:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Financial Times",
        "iban": null,
        "bic": null,
        "sortCode": "244782",
        "accountNumber": "33028593"
      }
    },
    {
      "id": "txn_0753jhs5e58bjvapw1w879pshk",
      "createdAt": "2025-07-17T12:46:00.000Z",
      "updatedAt": "2025-07-17T12:46:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 20518.67,
      "currency": "GBP",
      "description": "Payment from DataDriven Analytics - INV-202507-4450",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xfjpsc65cdybt3b6qe6kgvfxwr",
      "fspDate": "2025-07-17T11:46:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xfjpsc65cdybt3b6qe6kgvfxwr",
        "bookingDate": "2025-07-17",
        "valueDate": "2025-07-17",
        "bookingDateTime": "2025-07-17T12:46:00.000Z",
        "valueDateTime": "2025-07-17T12:46:00.000Z",
        "transactionAmount": {
          "amount": "20518.67",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from DataDriven Analytics - INV-202507-4450",
        "remittanceInformationUnstructuredArray": [
          "Payment from DataDriven Analytics",
          "INV-202507-4450"
        ],
        "creditorName": "DataDriven Analytics"
      },
      "paymentId": null,
      "reference": "INV-202507-4450",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_jy64mwn8y868akxp0c6s337dms",
      "clustering": {
        "description": "DataDriven Analytics",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'DataDriven Analytics'",
        "updatedAt": "2025-07-17T12:46:00.000Z"
      },
      "payer": {
        "name": "DataDriven Analytics",
        "iban": null,
        "bic": null,
        "sortCode": "210772",
        "accountNumber": "76246149"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_5tmcvqyv7xv5xw1d1njprwqe1w",
      "createdAt": "2025-07-17T10:59:00.000Z",
      "updatedAt": "2025-07-17T10:59:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2926,
      "currency": "GBP",
      "description": "Payment to Grow Your Boat Ltd: GYB-202507-5605",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_xhnrm97a0tszqc5rknyxh1nad9",
      "fspDate": "2025-07-17T09:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_xhnrm97a0tszqc5rknyxh1nad9",
        "bookingDate": "2025-07-17",
        "valueDate": "2025-07-17",
        "bookingDateTime": "2025-07-17T10:59:00.000Z",
        "valueDateTime": "2025-07-17T10:59:00.000Z",
        "transactionAmount": {
          "amount": "2926.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Grow Your Boat Ltd: GYB-202507-5605",
        "remittanceInformationUnstructuredArray": [
          "Payment to Grow Your Boat Ltd",
          "GYB-202507-5605"
        ],
        "debtorName": "Grow Your Boat Ltd"
      },
      "paymentId": null,
      "reference": "GYB-202507-5605",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "clustering": {
        "description": "Grow Your Boat Ltd",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Grow Your Boat Ltd' based on payment details",
        "updatedAt": "2025-07-17T10:59:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Grow Your Boat Ltd",
        "iban": null,
        "bic": null,
        "sortCode": "844926",
        "accountNumber": "22145230"
      }
    },
    {
      "id": "txn_01k65c32y6eshspgwrt5zhnrxp",
      "createdAt": "2025-07-17T10:54:00.000Z",
      "updatedAt": "2025-07-17T10:54:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 25,
      "currency": "EUR",
      "description": "Frn*hold.free-Now.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1tyydzypt20",
      "fspDate": "2025-07-17T09:54:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1tyydzypt20",
        "bookingDate": "2025-07-17",
        "valueDate": "2025-07-17",
        "bookingDateTime": "2025-07-17T09:54:00.000Z",
        "valueDateTime": "2025-07-17T09:54:00.000Z",
        "transactionAmount": {
          "amount": "-25.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Frn*hold.free-Now.com",
        "remittanceInformationUnstructuredArray": [
          "Frn*hold.free-Now.com"
        ],
        "debtorName": "Free Now"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj31eshspnh3qzqhcd5r",
      "clustering": {
        "description": "Free Now",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Free Now' from the raw transaction description, removing the 'Frn*hold.free-Now.com' prefix.",
        "updatedAt": "2025-09-27T10:53:55.733Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_sw37pj2kpv8jz8zhd2ppjfywws",
      "createdAt": "2025-07-17T10:44:00.000Z",
      "updatedAt": "2025-07-17T10:44:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4225.03,
      "currency": "GBP",
      "description": "Payment to Amazon Web Services EMEA SARL: AWS-202507-4772",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_7cgrevxvsvt201ra7p53d5fy5q",
      "fspDate": "2025-07-17T09:44:00.000Z",
      "fspRecord": {
        "transactionId": "txn_7cgrevxvsvt201ra7p53d5fy5q",
        "bookingDate": "2025-07-17",
        "valueDate": "2025-07-17",
        "bookingDateTime": "2025-07-17T10:44:00.000Z",
        "valueDateTime": "2025-07-17T10:44:00.000Z",
        "transactionAmount": {
          "amount": "4225.03",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Amazon Web Services EMEA SARL: AWS-202507-4772",
        "remittanceInformationUnstructuredArray": [
          "Payment to Amazon Web Services EMEA SARL",
          "AWS-202507-4772"
        ],
        "debtorName": "Amazon Web Services EMEA SARL"
      },
      "paymentId": null,
      "reference": "AWS-202507-4772",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_zj7v3fq41pb9h3pwx6cbzwmfx4",
      "clustering": {
        "description": "Amazon Web Services EMEA SARL",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Amazon Web Services EMEA SARL' based on payment details",
        "updatedAt": "2025-07-17T10:44:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Amazon Web Services EMEA SARL",
        "iban": null,
        "bic": null,
        "sortCode": "323996",
        "accountNumber": "46842464"
      }
    },
    {
      "id": "txn_01k65c32y4eshspg2cenjxj41a",
      "createdAt": "2025-07-17T10:19:00.000Z",
      "updatedAt": "2025-07-17T10:19:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "EUR",
      "description": "Google *temporary Hold",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0x0zqbws36m",
      "fspDate": "2025-07-17T09:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0x0zqbws36m",
        "bookingDate": "2026-01-08",
        "valueDate": "2026-01-08",
        "bookingDateTime": "2026-01-08T09:00:00.000Z",
        "valueDateTime": "2026-01-08T09:00:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Google *temporary Hold",
        "remittanceInformationUnstructuredArray": [
          "Google *temporary Hold"
        ],
        "debtorName": "Google"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdrteshspka3qwhrnts0",
      "clustering": {
        "description": "Google",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Google' from 'Google *temporary Hold', removing 'Google *' prefix",
        "updatedAt": "2025-09-27T10:50:52.431Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg4x4n7dregs",
      "createdAt": "2025-07-17T08:56:00.000Z",
      "updatedAt": "2025-07-17T08:56:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk1185hwhmt22",
      "fspDate": "2025-07-17T07:56:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk1185hwhmt22",
        "bookingDate": "2025-07-17",
        "valueDate": "2025-07-17",
        "bookingDateTime": "2025-07-17T07:56:00.000Z",
        "valueDateTime": "2025-07-17T07:56:00.000Z",
        "transactionAmount": {
          "amount": "-14.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Burger Cartel' from 'Burger Cartel Limited', removing the 'Limited' suffix.",
        "updatedAt": "2025-09-27T10:51:38.193Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspekn1717a2gk",
      "createdAt": "2025-07-16T16:52:00.000Z",
      "updatedAt": "2025-07-16T16:52:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 168.21,
      "currency": "EUR",
      "description": "linear.app",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3g3aetweh2t29hvsb6w592t",
      "fspDate": "2025-07-16T15:52:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3g3aetweh2t29hvsb6w592t",
        "bookingDate": "2025-07-16",
        "valueDate": "2025-07-16",
        "bookingDateTime": "2025-07-16T15:52:00.000Z",
        "valueDateTime": "2025-07-16T15:52:00.000Z",
        "transactionAmount": {
          "amount": "-168.21",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "linear.app",
        "remittanceInformationUnstructuredArray": [
          "linear.app"
        ],
        "debtorName": "Linear"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6zc1eshspj0mxd2vh6zx",
      "clustering": {
        "description": "Linear",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Linear' from 'linear.app'",
        "updatedAt": "2025-09-27T10:40:26.841Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_0qtqpsz07egk02thxhb8ns6nb3",
      "createdAt": "2025-07-16T15:55:00.000Z",
      "updatedAt": "2025-07-16T15:55:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 31.65,
      "currency": "EUR",
      "description": "Payment to Sentry: S-202507-6992",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_w1s076mp6pfdskwfdg0h8g52ks",
      "fspDate": "2025-07-16T14:55:00.000Z",
      "fspRecord": {
        "transactionId": "txn_w1s076mp6pfdskwfdg0h8g52ks",
        "bookingDate": "2025-07-16",
        "valueDate": "2025-07-16",
        "bookingDateTime": "2025-07-16T15:55:00.000Z",
        "valueDateTime": "2025-07-16T15:55:00.000Z",
        "transactionAmount": {
          "amount": "31.65",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sentry: S-202507-6992",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sentry",
          "S-202507-6992"
        ],
        "debtorName": "Sentry"
      },
      "paymentId": null,
      "reference": "S-202507-6992",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cjdn2eshspk97jdcm57ef",
      "clustering": {
        "description": "Sentry",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sentry' based on payment details",
        "updatedAt": "2025-07-16T15:55:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sentry",
        "iban": "DE29411069028516828",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_stp2m1fracvzpazz9xfw9y4zct",
      "createdAt": "2025-07-16T15:05:00.000Z",
      "updatedAt": "2025-07-16T15:05:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3991.59,
      "currency": "GBP",
      "description": "Payment to WealthKernel: W-202507-6208",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_n5c52v870mhh75pfdk2m6xy82g",
      "fspDate": "2025-07-16T14:05:00.000Z",
      "fspRecord": {
        "transactionId": "txn_n5c52v870mhh75pfdk2m6xy82g",
        "bookingDate": "2025-07-16",
        "valueDate": "2025-07-16",
        "bookingDateTime": "2025-07-16T15:05:00.000Z",
        "valueDateTime": "2025-07-16T15:05:00.000Z",
        "transactionAmount": {
          "amount": "3991.59",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to WealthKernel: W-202507-6208",
        "remittanceInformationUnstructuredArray": [
          "Payment to WealthKernel",
          "W-202507-6208"
        ],
        "debtorName": "WealthKernel"
      },
      "paymentId": null,
      "reference": "W-202507-6208",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhng0fvhrjnk93frdx83x",
      "clustering": {
        "description": "WealthKernel",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'WealthKernel' based on payment details",
        "updatedAt": "2025-07-16T15:05:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "WealthKernel",
        "iban": null,
        "bic": null,
        "sortCode": "465190",
        "accountNumber": "73663735"
      }
    },
    {
      "id": "txn_w9pwt99t7tks52r8yns9zw90fd",
      "createdAt": "2025-07-16T13:57:00.000Z",
      "updatedAt": "2025-07-16T13:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 11463.71,
      "currency": "GBP",
      "description": "Payment from Digital Ventures Group - INV-202507-4703",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6rfrnwcv5rm5k4yr05523xq3ym",
      "fspDate": "2025-07-16T12:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6rfrnwcv5rm5k4yr05523xq3ym",
        "bookingDate": "2025-07-16",
        "valueDate": "2025-07-16",
        "bookingDateTime": "2025-07-16T13:57:00.000Z",
        "valueDateTime": "2025-07-16T13:57:00.000Z",
        "transactionAmount": {
          "amount": "11463.71",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from Digital Ventures Group - INV-202507-4703",
        "remittanceInformationUnstructuredArray": [
          "Payment from Digital Ventures Group",
          "INV-202507-4703"
        ],
        "creditorName": "Digital Ventures Group"
      },
      "paymentId": null,
      "reference": "INV-202507-4703",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_mj6n80che7b1rf41e9c0gtanqb",
      "clustering": {
        "description": "Digital Ventures Group",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'Digital Ventures Group'",
        "updatedAt": "2025-07-16T13:57:00.000Z"
      },
      "payer": {
        "name": "Digital Ventures Group",
        "iban": null,
        "bic": null,
        "sortCode": "803538",
        "accountNumber": "63577012"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_4dedk8dk4dms2b2y9yv9zbx9yg",
      "createdAt": "2025-07-16T10:39:00.000Z",
      "updatedAt": "2025-07-16T10:39:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 28788.97,
      "currency": "GBP",
      "description": "Payment from TechCorp Industries - INV-202507-7725",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_b6tbkkb89a4sh4ac95n6t4eg80",
      "fspDate": "2025-07-16T09:39:00.000Z",
      "fspRecord": {
        "transactionId": "txn_b6tbkkb89a4sh4ac95n6t4eg80",
        "bookingDate": "2025-07-16",
        "valueDate": "2025-07-16",
        "bookingDateTime": "2025-07-16T10:39:00.000Z",
        "valueDateTime": "2025-07-16T10:39:00.000Z",
        "transactionAmount": {
          "amount": "28788.97",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from TechCorp Industries - INV-202507-7725",
        "remittanceInformationUnstructuredArray": [
          "Payment from TechCorp Industries",
          "INV-202507-7725"
        ],
        "creditorName": "TechCorp Industries"
      },
      "paymentId": null,
      "reference": "INV-202507-7725",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_hkz708jvra375hd19t65j65vvt",
      "clustering": {
        "description": "TechCorp Industries",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'TechCorp Industries'",
        "updatedAt": "2025-07-16T10:39:00.000Z"
      },
      "payer": {
        "name": "TechCorp Industries",
        "iban": null,
        "bic": null,
        "sortCode": "815577",
        "accountNumber": "99791330"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_mv3q744295ghb4cd11jy46wy6s",
      "createdAt": "2025-07-16T09:28:00.000Z",
      "updatedAt": "2025-07-16T09:28:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2.3,
      "currency": "GBP",
      "description": "Payment to Mylands: M-202507-1956",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_370c2erntv2e2vt9pata6cqtyf",
      "fspDate": "2025-07-16T08:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_370c2erntv2e2vt9pata6cqtyf",
        "bookingDate": "2025-07-16",
        "valueDate": "2025-07-16",
        "bookingDateTime": "2025-07-16T09:28:00.000Z",
        "valueDateTime": "2025-07-16T09:28:00.000Z",
        "transactionAmount": {
          "amount": "2.30",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Mylands: M-202507-1956",
        "remittanceInformationUnstructuredArray": [
          "Payment to Mylands",
          "M-202507-1956"
        ],
        "debtorName": "Mylands"
      },
      "paymentId": null,
      "reference": "M-202507-1956",
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbnxzzfvhrjp5np8trhg47",
      "clustering": {
        "description": "Mylands",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Mylands' based on payment details",
        "updatedAt": "2025-07-16T09:28:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Mylands",
        "iban": null,
        "bic": null,
        "sortCode": "213014",
        "accountNumber": "83548751"
      }
    },
    {
      "id": "txn_cpyzhzfa01v5w55cgk58zyf3en",
      "createdAt": "2025-07-16T08:38:00.000Z",
      "updatedAt": "2025-07-16T08:38:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 11.73,
      "currency": "EUR",
      "description": "Payment to Jarek's Kitchen: JK-202507-2446",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_6jcperv7kjjvgq3rb4jqeegnws",
      "fspDate": "2025-07-16T07:38:00.000Z",
      "fspRecord": {
        "transactionId": "txn_6jcperv7kjjvgq3rb4jqeegnws",
        "bookingDate": "2025-07-16",
        "valueDate": "2025-07-16",
        "bookingDateTime": "2025-07-16T08:38:00.000Z",
        "valueDateTime": "2025-07-16T08:38:00.000Z",
        "transactionAmount": {
          "amount": "11.73",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jarek's Kitchen: JK-202507-2446",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jarek's Kitchen",
          "JK-202507-2446"
        ],
        "debtorName": "Jarek's Kitchen"
      },
      "paymentId": null,
      "reference": "JK-202507-2446",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9ynmeshspjjhrjb91rve",
      "clustering": {
        "description": "Jarek's Kitchen",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Jarek's Kitchen' based on payment details",
        "updatedAt": "2025-07-16T08:38:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Jarek's Kitchen",
        "iban": "DE79742632369421470",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_2sqw1gzq3j25hv1zkgde7a1kna",
      "createdAt": "2025-07-15T15:33:00.000Z",
      "updatedAt": "2025-07-15T15:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 52.54,
      "currency": "GBP",
      "description": "Payment to Pembroke Hall Limited: PHL-202507-7999",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9yv3nxz4c7h1vwq5mntc3156tr",
      "fspDate": "2025-07-15T14:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9yv3nxz4c7h1vwq5mntc3156tr",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T15:33:00.000Z",
        "valueDateTime": "2025-07-15T15:33:00.000Z",
        "transactionAmount": {
          "amount": "52.54",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Pembroke Hall Limited: PHL-202507-7999",
        "remittanceInformationUnstructuredArray": [
          "Payment to Pembroke Hall Limited",
          "PHL-202507-7999"
        ],
        "debtorName": "Pembroke Hall Limited"
      },
      "paymentId": null,
      "reference": "PHL-202507-7999",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6fpgn1yfzz9aex3cr77xa32",
      "clustering": {
        "description": "Pembroke Hall Limited",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Pembroke Hall Limited' based on payment details",
        "updatedAt": "2025-07-15T15:33:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Pembroke Hall Limited",
        "iban": null,
        "bic": null,
        "sortCode": "495807",
        "accountNumber": "83541634"
      }
    },
    {
      "id": "txn_01k65c32y0eshspesseppzf6b6",
      "createdAt": "2025-07-15T14:50:00.000Z",
      "updatedAt": "2025-07-15T14:50:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 105.98,
      "currency": "EUR",
      "description": "Irish Rail",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k30nfe7yfzwbhvdhq3080fmb",
      "fspDate": "2025-07-15T13:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k30nfe7yfzwbhvdhq3080fmb",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T13:50:00.000Z",
        "valueDateTime": "2025-07-15T13:50:00.000Z",
        "transactionAmount": {
          "amount": "-105.98",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Irish Rail",
        "remittanceInformationUnstructuredArray": [
          "Irish Rail"
        ],
        "debtorName": "Irish Rail"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax69eshspjn90xv3cz0y",
      "clustering": {
        "description": "Irish Rail",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Irish Rail' from the transaction description.",
        "updatedAt": "2025-09-27T10:41:48.208Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph5zwqvk24zq",
      "createdAt": "2025-07-15T14:22:00.000Z",
      "updatedAt": "2025-07-15T14:22:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4939.76,
      "currency": "EUR",
      "description": "To Emma Fitzgerald",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk23hy69vdtqz",
      "fspDate": "2025-07-15T13:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk23hy69vdtqz",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T13:22:00.000Z",
        "valueDateTime": "2025-07-15T13:22:00.000Z",
        "transactionAmount": {
          "amount": "-4939.76",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Emma Fitzgerald",
        "remittanceInformationUnstructuredArray": [
          "To Emma Fitzgerald"
        ],
        "debtorName": "Emma Fitzgerald"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c8mtceshspj98ga0ebagk",
      "clustering": {
        "description": "Emma Fitzgerald",
        "confidenceScore": "0.95",
        "rationale": "Extracted core recipient name 'Emma Fitzgerald' from 'To Emma Fitzgerald'",
        "updatedAt": "2025-09-27T10:54:50.875Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjma2h0segdmh",
      "createdAt": "2025-07-15T13:36:00.000Z",
      "updatedAt": "2025-07-15T13:36:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 14.92,
      "currency": "GBP",
      "description": "Uber * Pending",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk82h0nb369ew",
      "fspDate": "2025-07-15T12:36:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk82h0nb369ew",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T07:00:00.000Z",
        "valueDateTime": "2026-01-05T07:00:00.000Z",
        "transactionAmount": {
          "amount": "-14.92",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Uber * Pending",
        "remittanceInformationUnstructuredArray": [
          "Uber * Pending"
        ],
        "debtorName": "Uber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Uber",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Uber' from 'Uber * Pending'",
        "updatedAt": "2025-09-29T18:24:29.655Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph5b9350w1my",
      "createdAt": "2025-07-15T13:30:00.000Z",
      "updatedAt": "2025-07-15T13:30:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 2000,
      "currency": "EUR",
      "description": "To BOI 2 COLLEGE GREEN, Davy",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk234nn47d8by",
      "fspDate": "2025-07-15T12:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk234nn47d8by",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T12:30:00.000Z",
        "valueDateTime": "2025-07-15T12:30:00.000Z",
        "transactionAmount": {
          "amount": "-2000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To BOI 2 COLLEGE GREEN, Davy",
        "remittanceInformationUnstructuredArray": [
          "To BOI 2 COLLEGE GREEN, Davy"
        ],
        "debtorName": "BOI 2 COLLEGE GREEN, Davy"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65d0a24eshspnzbnpcam1v1",
      "clustering": {
        "description": "BOI",
        "confidenceScore": "0.95",
        "rationale": "Extracted core institution name 'BOI' from 'To BOI 2 COLLEGE GREEN, Davy'",
        "updatedAt": "2025-09-27T10:55:13.231Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmqs043yw1ee",
      "createdAt": "2025-07-15T13:23:00.000Z",
      "updatedAt": "2025-07-15T13:23:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 24,
      "currency": "GBP",
      "description": "Tfl Travel Charge",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8g9q09tr8tj",
      "fspDate": "2025-07-15T12:23:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8g9q09tr8tj",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T12:23:00.000Z",
        "valueDateTime": "2025-07-15T12:23:00.000Z",
        "transactionAmount": {
          "amount": "-24.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tfl Travel Charge",
        "remittanceInformationUnstructuredArray": [
          "Tfl Travel Charge"
        ],
        "debtorName": "Transport for London"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgk7fvhrjp0v7hz9q786",
      "clustering": {
        "description": "Transport for London",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Transport for London' from 'Tfl Travel Charge'",
        "updatedAt": "2025-09-29T18:26:40.963Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_7seg2n5v7c6c3q4a3jek03cszw",
      "createdAt": "2025-07-15T13:01:00.000Z",
      "updatedAt": "2025-07-15T13:01:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": true,
      "amount": 17517.45,
      "currency": "GBP",
      "description": "Payment from CloudFirst Technologies - INV-202507-7159",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_mbespgggmhp2d9pfmqadnbfsxk",
      "fspDate": "2025-07-15T12:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_mbespgggmhp2d9pfmqadnbfsxk",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T13:01:00.000Z",
        "valueDateTime": "2025-07-15T13:01:00.000Z",
        "transactionAmount": {
          "amount": "17517.45",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment from CloudFirst Technologies - INV-202507-7159",
        "remittanceInformationUnstructuredArray": [
          "Payment from CloudFirst Technologies",
          "INV-202507-7159"
        ],
        "creditorName": "CloudFirst Technologies"
      },
      "paymentId": null,
      "reference": "INV-202507-7159",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_v3gga6hnqqf8p85ezhv67qxfkw",
      "clustering": {
        "description": "CloudFirst Technologies",
        "confidenceScore": "0.98",
        "rationale": "Identified recurring payment from customer 'CloudFirst Technologies'",
        "updatedAt": "2025-07-15T13:01:00.000Z"
      },
      "payer": {
        "name": "CloudFirst Technologies",
        "iban": null,
        "bic": null,
        "sortCode": "719545",
        "accountNumber": "83878059"
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_ftmzjf2xn7ww66715w3492nskt",
      "createdAt": "2025-07-15T11:59:00.000Z",
      "updatedAt": "2025-07-15T11:59:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 33.32,
      "currency": "EUR",
      "description": "Payment to Sweet Salt: SS-202507-9406",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_9h8htjhhw175qhnp3s6r3sr2ya",
      "fspDate": "2025-07-15T10:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_9h8htjhhw175qhnp3s6r3sr2ya",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T11:59:00.000Z",
        "valueDateTime": "2025-07-15T11:59:00.000Z",
        "transactionAmount": {
          "amount": "33.32",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Sweet Salt: SS-202507-9406",
        "remittanceInformationUnstructuredArray": [
          "Payment to Sweet Salt",
          "SS-202507-9406"
        ],
        "debtorName": "Sweet Salt"
      },
      "paymentId": null,
      "reference": "SS-202507-9406",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cmad4eshspkk8z9xs58fk",
      "clustering": {
        "description": "Sweet Salt",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Sweet Salt' based on payment details",
        "updatedAt": "2025-07-15T11:59:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Sweet Salt",
        "iban": "DE31508087793850616",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshsph1268ast812",
      "createdAt": "2025-07-15T11:58:00.000Z",
      "updatedAt": "2025-07-15T11:58:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 75,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2478e8pvk1z2hc7450cq",
      "fspDate": "2025-07-15T10:58:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2478e8pvk1z2hc7450cq",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T10:58:00.000Z",
        "valueDateTime": "2025-07-15T10:58:00.000Z",
        "transactionAmount": {
          "amount": "-75.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'.",
        "updatedAt": "2025-09-27T10:54:12.588Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_a12k8ngb8jexym0qgsg1ne85w0",
      "createdAt": "2025-07-15T09:27:00.000Z",
      "updatedAt": "2025-07-15T09:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 21.06,
      "currency": "EUR",
      "description": "Payment to Hotpot: H-202507-2108",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_5dsfrqbx61q8nyt5yzw402x134",
      "fspDate": "2025-07-15T08:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_5dsfrqbx61q8nyt5yzw402x134",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T09:27:00.000Z",
        "valueDateTime": "2025-07-15T09:27:00.000Z",
        "transactionAmount": {
          "amount": "21.06",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Hotpot: H-202507-2108",
        "remittanceInformationUnstructuredArray": [
          "Payment to Hotpot",
          "H-202507-2108"
        ],
        "debtorName": "Hotpot"
      },
      "paymentId": null,
      "reference": "H-202507-2108",
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cp0wweshspkzqgyrcgqe7",
      "clustering": {
        "description": "Hotpot",
        "confidenceScore": "0.95",
        "rationale": "Matched to vendor 'Hotpot' based on payment details",
        "updatedAt": "2025-07-15T09:27:00.000Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Hotpot",
        "iban": "DE32738517742086852",
        "bic": "DEUTDEFFXXX",
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebzafvhrjmthq1f52rvc",
      "createdAt": "2025-07-15T09:13:00.000Z",
      "updatedAt": "2025-07-15T09:13:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "GBP",
      "description": "Uber Uk Rides",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8k7b2qsvg3x",
      "fspDate": "2025-07-15T08:13:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8k7b2qsvg3x",
        "bookingDate": "2025-07-15",
        "valueDate": "2025-07-15",
        "bookingDateTime": "2025-07-15T08:13:00.000Z",
        "valueDateTime": "2025-07-15T08:13:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Uber Uk Rides",
        "remittanceInformationUnstructuredArray": [
          "Uber Uk Rides"
        ],
        "debtorName": "Uber"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cq1n9eshspm6hq58rwha1",
      "clustering": {
        "description": "Uber",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Uber' from 'Uber Uk Rides'",
        "updatedAt": "2025-09-29T18:26:41.005Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspggqjmkwm4n9",
      "createdAt": "2025-07-14T13:49:00.000Z",
      "updatedAt": "2025-07-14T13:49:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1515.19,
      "currency": "EUR",
      "description": "Upwork -820590618ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1este0fana5",
      "fspDate": "2025-07-14T12:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1este0fana5",
        "bookingDate": "2025-07-14",
        "valueDate": "2025-07-14",
        "bookingDateTime": "2025-07-14T12:49:00.000Z",
        "valueDateTime": "2025-07-14T12:49:00.000Z",
        "transactionAmount": {
          "amount": "-1515.19",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -820590618ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -820590618ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Upwork' from 'Upwork -820590618ref', removing the '-820590618ref' suffix.",
        "updatedAt": "2025-09-27T10:52:47.410Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmf6ejhkjzxe",
      "createdAt": "2025-07-14T09:19:00.000Z",
      "updatedAt": "2025-07-14T09:19:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 1710.68,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk87jf561kxj1",
      "fspDate": "2025-07-14T08:19:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk87jf561kxj1",
        "bookingDate": "2026-01-09",
        "valueDate": "2026-01-09",
        "bookingDateTime": "2026-01-09T14:00:00.000Z",
        "valueDateTime": "2026-01-09T14:00:00.000Z",
        "transactionAmount": {
          "amount": "1710.68",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.145Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmjjgq6598m2",
      "createdAt": "2025-07-13T15:57:00.000Z",
      "updatedAt": "2025-07-13T15:57:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 13003.32,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8b11gxzwp0c",
      "fspDate": "2025-07-13T14:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8b11gxzwp0c",
        "bookingDate": "2025-07-13",
        "valueDate": "2025-07-13",
        "bookingDateTime": "2025-07-13T14:57:00.000Z",
        "valueDateTime": "2025-07-13T14:57:00.000Z",
        "transactionAmount": {
          "amount": "13003.32",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted 'Currency Exchange' as the description for the currency conversion transaction",
        "updatedAt": "2025-09-29T18:25:48.533Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg0fzpw3v0nq",
      "createdAt": "2025-07-13T14:41:00.000Z",
      "updatedAt": "2025-07-13T14:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 112.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0wd9wvcy01w",
      "fspDate": "2025-07-13T13:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0wd9wvcy01w",
        "bookingDate": "2025-07-13",
        "valueDate": "2025-07-13",
        "bookingDateTime": "2025-07-13T13:41:00.000Z",
        "valueDateTime": "2025-07-13T13:41:00.000Z",
        "transactionAmount": {
          "amount": "-112.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:50:52.338Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspej7kfked7tn",
      "createdAt": "2025-07-13T10:30:00.000Z",
      "updatedAt": "2025-07-13T10:30:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1618.43,
      "currency": "EUR",
      "description": "Upwork -840140155ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3jp8gs1e8prs7ngtka6p473",
      "fspDate": "2025-07-13T09:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3jp8gs1e8prs7ngtka6p473",
        "bookingDate": "2025-07-13",
        "valueDate": "2025-07-13",
        "bookingDateTime": "2025-07-13T09:30:00.000Z",
        "valueDateTime": "2025-07-13T09:30:00.000Z",
        "transactionAmount": {
          "amount": "-1618.43",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -840140155ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -840140155ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Upwork' from 'Upwork -840140155ref', removing the reference number.",
        "updatedAt": "2025-09-27T10:39:39.732Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgmrrahf5rre",
      "createdAt": "2025-07-13T09:51:00.000Z",
      "updatedAt": "2025-07-13T09:51:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 18,
      "currency": "EUR",
      "description": "Burger Cartel Limited",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1hrcx1wz5gp",
      "fspDate": "2025-07-13T08:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1hrcx1wz5gp",
        "bookingDate": "2025-07-13",
        "valueDate": "2025-07-13",
        "bookingDateTime": "2025-07-13T08:51:00.000Z",
        "valueDateTime": "2025-07-13T08:51:00.000Z",
        "transactionAmount": {
          "amount": "-18.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Burger Cartel Limited",
        "remittanceInformationUnstructuredArray": [
          "Burger Cartel Limited"
        ],
        "debtorName": "Burger Cartel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxveshspjgx3rn20feh",
      "clustering": {
        "description": "Burger Cartel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Burger Cartel' from the transaction description.",
        "updatedAt": "2025-09-27T10:53:18.111Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y8eshsph6sfcy0pw0m",
      "createdAt": "2025-07-13T09:33:00.000Z",
      "updatedAt": "2025-07-13T09:33:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 4988.87,
      "currency": "EUR",
      "description": "To Sophie Laurent",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2479e8pvk24jtb2z1g8q",
      "fspDate": "2025-07-13T08:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2479e8pvk24jtb2z1g8q",
        "bookingDate": "2025-07-13",
        "valueDate": "2025-07-13",
        "bookingDateTime": "2025-07-13T08:33:00.000Z",
        "valueDateTime": "2025-07-13T08:33:00.000Z",
        "transactionAmount": {
          "amount": "-4988.87",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Sophie Laurent",
        "remittanceInformationUnstructuredArray": [
          "To Sophie Laurent"
        ],
        "debtorName": "Sophie Laurent"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c7zsseshspj86qckgs7na",
      "clustering": {
        "description": "Sophie Laurent",
        "confidenceScore": "0.95",
        "rationale": "Extracted core recipient name 'Sophie Laurent' from 'To Sophie Laurent'",
        "updatedAt": "2025-09-27T10:54:50.902Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspevas1pz8vcv",
      "createdAt": "2025-07-12T09:30:00.000Z",
      "updatedAt": "2025-07-12T09:30:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 7.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2ry974re009pf8sfzt2xwhr",
      "fspDate": "2025-07-12T08:30:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2ry974re009pf8sfzt2xwhr",
        "bookingDate": "2025-07-12",
        "valueDate": "2025-07-12",
        "bookingDateTime": "2025-07-12T08:30:00.000Z",
        "valueDateTime": "2025-07-12T08:30:00.000Z",
        "transactionAmount": {
          "amount": "-7.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Companies Registration' from 'Companies Registration'",
        "updatedAt": "2025-09-27T10:42:40.327Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y7eshspgz9ck3ybcbt",
      "createdAt": "2025-07-12T08:27:00.000Z",
      "updatedAt": "2025-07-12T08:27:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2.5,
      "currency": "EUR",
      "description": "Companies Registration",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2477e8pvk1whw18v2f5k",
      "fspDate": "2025-07-12T07:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2477e8pvk1whw18v2f5k",
        "bookingDate": "2025-07-12",
        "valueDate": "2025-07-12",
        "bookingDateTime": "2025-07-12T07:27:00.000Z",
        "valueDateTime": "2025-07-12T07:27:00.000Z",
        "transactionAmount": {
          "amount": "-2.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Companies Registration",
        "remittanceInformationUnstructuredArray": [
          "Companies Registration"
        ],
        "debtorName": "Companies Registration Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "clustering": {
        "description": "Companies Registration",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Companies Registration' from 'Companies Registration'.",
        "updatedAt": "2025-09-27T10:54:12.545Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf8zgdga3sx0",
      "createdAt": "2025-07-11T16:22:00.000Z",
      "updatedAt": "2025-07-11T16:22:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 17.75,
      "currency": "EUR",
      "description": "The Pig And Heifer",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1fpmbemeh1r1539s8pmzv39",
      "fspDate": "2025-07-11T15:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1fpmbemeh1r1539s8pmzv39",
        "bookingDate": "2025-07-11",
        "valueDate": "2025-07-11",
        "bookingDateTime": "2025-07-11T15:22:00.000Z",
        "valueDateTime": "2025-07-11T15:22:00.000Z",
        "transactionAmount": {
          "amount": "-17.75",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "The Pig And Heifer",
        "remittanceInformationUnstructuredArray": [
          "The Pig And Heifer"
        ],
        "debtorName": "The Pig And Heifer"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g5weshsphq7y8rf4z8z",
      "clustering": {
        "description": "The Pig And Heifer",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'The Pig And Heifer' from the transaction description",
        "updatedAt": "2025-09-27T10:45:11.596Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf829854s7mj",
      "createdAt": "2025-07-10T15:57:00.000Z",
      "updatedAt": "2025-07-10T15:57:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 3474.35,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1fr6f60fk0vs7bwt2vakry5",
      "fspDate": "2025-07-10T14:57:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1fr6f60fk0vs7bwt2vakry5",
        "bookingDate": "2025-07-10",
        "valueDate": "2025-07-10",
        "bookingDateTime": "2025-07-10T14:57:00.000Z",
        "valueDateTime": "2025-07-10T14:57:00.000Z",
        "transactionAmount": {
          "amount": "-3474.35",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-27T10:45:11.568Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmsnnem7n00e",
      "createdAt": "2025-07-10T15:00:00.000Z",
      "updatedAt": "2025-07-10T15:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 323.8,
      "currency": "GBP",
      "description": "Hotel At Booking.com",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hve8pvk8hh1xthrzsv",
      "fspDate": "2025-07-10T14:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hve8pvk8hh1xthrzsv",
        "bookingDate": "2026-01-06",
        "valueDate": "2026-01-06",
        "bookingDateTime": "2026-01-06T11:00:00.000Z",
        "valueDateTime": "2026-01-06T11:00:00.000Z",
        "transactionAmount": {
          "amount": "-323.80",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Hotel At Booking.com",
        "remittanceInformationUnstructuredArray": [
          "Hotel At Booking.com"
        ],
        "debtorName": "Booking.com"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbn9p5fvhrjp2td9pd9rat",
      "clustering": {
        "description": "Booking.com",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Booking.com' from 'Hotel At Booking.com'",
        "updatedAt": "2025-09-29T18:26:40.988Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xzeshspepvct54j861",
      "createdAt": "2025-07-10T11:35:00.000Z",
      "updatedAt": "2025-07-10T11:35:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 20.85,
      "currency": "EUR",
      "description": "1password",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3az28h4eh2t0hd5xz84d7rz",
      "fspDate": "2025-07-10T10:35:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3az28h4eh2t0hd5xz84d7rz",
        "bookingDate": "2026-01-05",
        "valueDate": "2026-01-05",
        "bookingDateTime": "2026-01-05T10:00:00.000Z",
        "valueDateTime": "2026-01-05T10:00:00.000Z",
        "transactionAmount": {
          "amount": "-20.85",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "1password",
        "remittanceInformationUnstructuredArray": [
          "1password"
        ],
        "debtorName": "1Password"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pxpeshspjghv7zy63at",
      "clustering": {
        "description": "1Password",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name '1Password' from '1password'",
        "updatedAt": "2025-09-27T10:40:26.908Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_jmesdy6sh6kptp9dnmc34nwk8p",
      "createdAt": "2025-07-10T10:57:00.000Z",
      "updatedAt": "2025-07-10T10:57:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 3750,
      "currency": "GBP",
      "description": "Salary - Niamh Fitzgerald - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_76et2a0g0j2bsj34fcr2dj59vz",
      "fspDate": "2025-07-10T09:57:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_f1qfk7ba9dw1z487h4gvvsaqm8",
        "bookingDate": "2025-07-10",
        "valueDate": "2025-07-10",
        "bookingDateTime": "2025-07-10T09:57:00.000Z",
        "valueDateTime": "2025-07-10T09:57:00.000Z",
        "transactionAmount": {
          "amount": "-3750.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - Niamh Fitzgerald",
        "remittanceInformationUnstructuredArray": [
          "Salary - Niamh Fitzgerald"
        ]
      },
      "paymentId": "pmnt_csev4dpyfc4q00kmn3zd57j3ma",
      "reference": "PAY-DEC-2025-FITZGERALD",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "Niamh Fitzgerald",
        "iban": null,
        "bic": null,
        "sortCode": "90-01-23",
        "accountNumber": "90123456"
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmf9jxcq4w2c",
      "createdAt": "2025-07-10T09:18:00.000Z",
      "updatedAt": "2025-07-10T09:18:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": true,
      "amount": 2566.49,
      "currency": "GBP",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hre8pvk87y8vy4h1er",
      "fspDate": "2025-07-10T08:18:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hre8pvk87y8vy4h1er",
        "bookingDate": "2025-07-10",
        "valueDate": "2025-07-10",
        "bookingDateTime": "2025-07-10T08:18:00.000Z",
        "valueDateTime": "2025-07-10T08:18:00.000Z",
        "transactionAmount": {
          "amount": "2566.49",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Extracted Currency Exchange name as the merchant name for exchange to GBP and code: 'EXCHANGE'",
        "updatedAt": "2025-09-29T18:25:01.149Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfxf07y5gg3y",
      "createdAt": "2025-07-10T07:24:00.000Z",
      "updatedAt": "2025-07-10T07:24:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 201.83,
      "currency": "EUR",
      "description": "Claude.ai Subscription",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0swekerxakv",
      "fspDate": "2025-07-10T06:24:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0swekerxakv",
        "bookingDate": "2025-07-10",
        "valueDate": "2025-07-10",
        "bookingDateTime": "2025-07-10T06:24:00.000Z",
        "valueDateTime": "2025-07-10T06:24:00.000Z",
        "transactionAmount": {
          "amount": "-201.83",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Claude.ai Subscription",
        "remittanceInformationUnstructuredArray": [
          "Claude.ai Subscription"
        ],
        "debtorName": "Claude.ai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5j1eshspjz017vq1wgn",
      "clustering": {
        "description": "Claude.ai",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Claude.ai' from 'Claude.ai Subscription'",
        "updatedAt": "2025-09-27T10:50:08.373Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgm9tae0qjbk",
      "createdAt": "2025-07-09T11:33:00.000Z",
      "updatedAt": "2025-07-09T11:33:00.000Z",
      "status": "BOOKED",
      "type": "EXCHANGE",
      "isCredit": false,
      "amount": 7000,
      "currency": "EUR",
      "description": "Exchanged to GBP Main",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2475e8pvk1gsbj6k8v7x",
      "fspDate": "2025-07-09T10:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2475e8pvk1gsbj6k8v7x",
        "bookingDate": "2025-07-09",
        "valueDate": "2025-07-09",
        "bookingDateTime": "2025-07-09T10:33:00.000Z",
        "valueDateTime": "2025-07-09T10:33:00.000Z",
        "transactionAmount": {
          "amount": "-7000.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "EXCHANGE",
        "remittanceInformationUnstructured": "Exchanged to GBP Main",
        "remittanceInformationUnstructuredArray": [
          "Exchanged to GBP Main"
        ],
        "debtorName": "Currency Exchange"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "clustering": {
        "description": "Currency Exchange",
        "confidenceScore": "0.95",
        "rationale": "Identified the transaction as a currency exchange based on the 'EXCHANGE' code.",
        "updatedAt": "2025-09-27T10:53:18.091Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg2h8d8xcttb",
      "createdAt": "2025-07-08T15:50:00.000Z",
      "updatedAt": "2025-07-08T15:50:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 212.06,
      "currency": "EUR",
      "description": "Notion Labs, Inc.",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0ys4crrjpkk",
      "fspDate": "2025-07-08T14:50:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0ys4crrjpkk",
        "bookingDate": "2025-12-06",
        "valueDate": "2025-12-06",
        "bookingDateTime": "2025-12-06T07:03:00.000Z",
        "valueDateTime": "2025-12-06T07:03:00.000Z",
        "transactionAmount": {
          "amount": "-212.06",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Notion Labs, Inc.",
        "remittanceInformationUnstructuredArray": [
          "Notion Labs, Inc."
        ],
        "debtorName": "Notion"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtcyeshspk6y0e76tesb",
      "clustering": {
        "description": "Notion",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Notion' from 'Notion Labs, Inc.'",
        "updatedAt": "2025-09-27T10:50:52.435Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y6eshspgr83cmq37g8",
      "createdAt": "2025-07-08T15:29:00.000Z",
      "updatedAt": "2025-07-08T15:29:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 2,
      "currency": "EUR",
      "description": "Merrion Row Post Offic",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2476e8pvk1nvma35y0xs",
      "fspDate": "2025-07-08T14:29:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2476e8pvk1nvma35y0xs",
        "bookingDate": "2025-07-08",
        "valueDate": "2025-07-08",
        "bookingDateTime": "2025-07-08T14:29:00.000Z",
        "valueDateTime": "2025-07-08T14:29:00.000Z",
        "transactionAmount": {
          "amount": "-2.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Merrion Row Post Offic",
        "remittanceInformationUnstructuredArray": [
          "Merrion Row Post Offic"
        ],
        "debtorName": "Merrion Row Post Office"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cyj0neshspngm4dw1pq8h",
      "clustering": {
        "description": "Merrion Row Post Office",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Merrion Row Post Office' from the raw transaction description.",
        "updatedAt": "2025-09-27T10:53:55.605Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y2eshspfay9wyjw06x",
      "createdAt": "2025-07-08T14:49:00.000Z",
      "updatedAt": "2025-07-08T14:49:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 1513.01,
      "currency": "EUR",
      "description": "Upwork -831451189ref",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1ak4azgesj89g4bt50pry3b",
      "fspDate": "2025-07-08T13:49:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1ak4azgesj89g4bt50pry3b",
        "bookingDate": "2025-07-08",
        "valueDate": "2025-07-08",
        "bookingDateTime": "2025-07-08T13:49:00.000Z",
        "valueDateTime": "2025-07-08T13:49:00.000Z",
        "transactionAmount": {
          "amount": "-1513.01",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Upwork -831451189ref",
        "remittanceInformationUnstructuredArray": [
          "Upwork -831451189ref"
        ],
        "debtorName": "Upwork"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wkheshsphyb0230evrk",
      "clustering": {
        "description": "Upwork",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Upwork' from 'Upwork -831451189ref'",
        "updatedAt": "2025-09-27T10:45:11.651Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf4xmaymyn3e",
      "createdAt": "2025-07-08T13:22:00.000Z",
      "updatedAt": "2025-07-08T13:22:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 39,
      "currency": "EUR",
      "description": "Docusign",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1t1gjkcena8mn88353dm1mh",
      "fspDate": "2025-07-08T12:22:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1t1gjkcena8mn88353dm1mh",
        "bookingDate": "2025-07-08",
        "valueDate": "2025-07-08",
        "bookingDateTime": "2025-07-08T12:22:00.000Z",
        "valueDateTime": "2025-07-08T12:22:00.000Z",
        "transactionAmount": {
          "amount": "-39.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Docusign",
        "remittanceInformationUnstructuredArray": [
          "Docusign"
        ],
        "debtorName": "DocuSign"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "clustering": {
        "description": "DocuSign",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'DocuSign' from the transaction description.",
        "updatedAt": "2025-09-27T10:43:55.539Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg1jahhwap18",
      "createdAt": "2025-07-08T10:00:00.000Z",
      "updatedAt": "2025-07-08T10:00:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 10.99,
      "currency": "EUR",
      "description": "Cursor Usage Jun",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2471e8pvk0y8bevag5c3",
      "fspDate": "2025-07-08T09:00:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2471e8pvk0y8bevag5c3",
        "bookingDate": "2025-07-08",
        "valueDate": "2025-07-08",
        "bookingDateTime": "2025-07-08T09:00:00.000Z",
        "valueDateTime": "2025-07-08T09:00:00.000Z",
        "transactionAmount": {
          "amount": "-10.99",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor Usage Jun",
        "remittanceInformationUnstructuredArray": [
          "Cursor Usage Jun"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cursor' from 'Cursor Usage Jun'",
        "updatedAt": "2025-09-27T10:50:52.393Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf20dv1bxyjn",
      "createdAt": "2025-07-08T08:33:00.000Z",
      "updatedAt": "2025-07-08T08:33:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 48,
      "currency": "EUR",
      "description": "Calendly",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k24b3f6jfakarfmp072yjd71",
      "fspDate": "2025-07-08T07:33:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k24b3f6jfakarfmp072yjd71",
        "bookingDate": "2025-07-08",
        "valueDate": "2025-07-08",
        "bookingDateTime": "2025-07-08T07:33:00.000Z",
        "valueDateTime": "2025-07-08T07:33:00.000Z",
        "transactionAmount": {
          "amount": "-48.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Calendly",
        "remittanceInformationUnstructuredArray": [
          "Calendly"
        ],
        "debtorName": "Calendly"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cgtc5eshspk6kqa7yaywk",
      "clustering": {
        "description": "Calendly",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Calendly' from the transaction description.",
        "updatedAt": "2025-09-27T10:43:55.448Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg62mzxa7m6y",
      "createdAt": "2025-07-08T07:28:00.000Z",
      "updatedAt": "2025-07-08T07:28:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 24.7,
      "currency": "EUR",
      "description": "Tula Mexican Grill 03",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2472e8pvk141vz7fd4an",
      "fspDate": "2025-07-08T06:28:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2472e8pvk141vz7fd4an",
        "bookingDate": "2025-07-08",
        "valueDate": "2025-07-08",
        "bookingDateTime": "2025-07-08T06:28:00.000Z",
        "valueDateTime": "2025-07-08T06:28:00.000Z",
        "transactionAmount": {
          "amount": "-24.70",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Tula Mexican Grill 03",
        "remittanceInformationUnstructuredArray": [
          "Tula Mexican Grill 03"
        ],
        "debtorName": "Tula Mexican Grill"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cax5aeshspjn0tkppm3b4",
      "clustering": {
        "description": "Tula Mexican Grill",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Tula Mexican Grill' from 'Tula Mexican Grill 03', removing the store number suffix.",
        "updatedAt": "2025-09-27T10:51:38.221Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf65v5xf99xy",
      "createdAt": "2025-07-07T15:20:00.000Z",
      "updatedAt": "2025-07-07T15:20:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 90.18,
      "currency": "EUR",
      "description": "zapier.com/charge",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1mwq45xexy9b7q2ymxenwvk",
      "fspDate": "2025-07-07T14:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1mwq45xexy9b7q2ymxenwvk",
        "bookingDate": "2025-07-07",
        "valueDate": "2025-07-07",
        "bookingDateTime": "2025-07-07T14:20:00.000Z",
        "valueDateTime": "2025-07-07T14:20:00.000Z",
        "transactionAmount": {
          "amount": "-90.18",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "zapier.com/charge",
        "remittanceInformationUnstructuredArray": [
          "zapier.com/charge"
        ],
        "debtorName": "Zapier"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65ckh2aeshspkg92jdy8vh4",
      "clustering": {
        "description": "Zapier",
        "confidenceScore": "0.95",
        "rationale": "Extracted the main business name 'Zapier' from the transaction description, removing the '.com/charge' suffix.",
        "updatedAt": "2025-09-27T10:43:55.588Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspfteckj3rf2h",
      "createdAt": "2025-07-07T13:20:00.000Z",
      "updatedAt": "2025-07-07T13:20:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 107,
      "currency": "EUR",
      "description": "Payment to GoCardless SAS: INV-SAS-64446",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k04avk8bexramth7bq222epc",
      "fspDate": "2025-07-07T12:20:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k04avk8bexramth7bq222epc",
        "bookingDate": "2025-07-07",
        "valueDate": "2025-07-07",
        "bookingDateTime": "2025-07-07T12:20:00.000Z",
        "valueDateTime": "2025-07-07T12:20:00.000Z",
        "transactionAmount": {
          "amount": "-107.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to GoCardless SAS: INV-SAS-64446",
        "remittanceInformationUnstructuredArray": [
          "Payment to GoCardless SAS: INV-SAS-64446"
        ],
        "debtorName": "GoCardless SAS"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5k6eshspjzd728cagsr",
      "clustering": {
        "description": "GoCardless SAS",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'GoCardless SAS' from 'Payment to GoCardless SAS: INV-SAS-64446'",
        "updatedAt": "2025-09-27T10:49:37.774Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y1eshspf9qqnv0tsx5",
      "createdAt": "2025-07-07T11:12:00.000Z",
      "updatedAt": "2025-07-07T11:12:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 4.2,
      "currency": "EUR",
      "description": "Sq *coffeeangel",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k1d5gytmesj8a90mcss3v53m",
      "fspDate": "2025-07-07T10:12:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k1d5gytmesj8a90mcss3v53m",
        "bookingDate": "2025-07-07",
        "valueDate": "2025-07-07",
        "bookingDateTime": "2025-07-07T10:12:00.000Z",
        "valueDateTime": "2025-07-07T10:12:00.000Z",
        "transactionAmount": {
          "amount": "-4.20",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *coffeeangel",
        "remittanceInformationUnstructuredArray": [
          "Sq *coffeeangel"
        ],
        "debtorName": "Coffee Angel"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x27eshsphmv20gzbhw9",
      "clustering": {
        "description": "Coffee Angel",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Coffee Angel' from 'Sq *coffeeangel', removing the Sq * prefix",
        "updatedAt": "2025-09-27T10:45:11.613Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg9q42b2sfgq",
      "createdAt": "2025-07-07T09:21:00.000Z",
      "updatedAt": "2025-07-07T09:21:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 51.8,
      "currency": "EUR",
      "description": "Cursor Usage Mid Jun",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk175b57gy8yx",
      "fspDate": "2025-07-07T08:21:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk175b57gy8yx",
        "bookingDate": "2025-07-07",
        "valueDate": "2025-07-07",
        "bookingDateTime": "2025-07-07T08:21:00.000Z",
        "valueDateTime": "2025-07-07T08:21:00.000Z",
        "transactionAmount": {
          "amount": "-51.80",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Cursor Usage Mid Jun",
        "remittanceInformationUnstructuredArray": [
          "Cursor Usage Mid Jun"
        ],
        "debtorName": "Cursor"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "clustering": {
        "description": "Cursor",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Cursor' from 'Cursor Usage Mid Jun'",
        "updatedAt": "2025-09-27T10:52:09.932Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg91bjq0r3ah",
      "createdAt": "2025-07-07T08:51:00.000Z",
      "updatedAt": "2025-07-07T08:51:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 6667,
      "currency": "EUR",
      "description": "Payment to Jonas Novak: 2025-00001",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jz0e17d8eh28k64e9qajfrqs",
      "fspDate": "2025-07-07T07:51:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jz0e17d8eh28k64e9qajfrqs",
        "bookingDate": "2025-07-07",
        "valueDate": "2025-07-07",
        "bookingDateTime": "2025-07-07T07:51:00.000Z",
        "valueDateTime": "2025-07-07T07:51:00.000Z",
        "transactionAmount": {
          "amount": "-6667.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Jonas Novak: 2025-00001",
        "remittanceInformationUnstructuredArray": [
          "Payment to Jonas Novak: 2025-00001"
        ],
        "debtorName": "Jonas Novak"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c3x01eshsphmk5k2axdrt",
      "clustering": {
        "description": "Jonas Novak",
        "confidenceScore": "0.95",
        "rationale": "Extracted the name 'Jonas Novak' from the transaction description 'Payment to Jonas Novak: 2025-00001'.",
        "updatedAt": "2025-09-27T10:51:38.293Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y3eshspftq7jqfyx6g",
      "createdAt": "2025-07-07T07:48:00.000Z",
      "updatedAt": "2025-07-07T07:48:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 22.14,
      "currency": "EUR",
      "description": "Claude.ai Subscription",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2470e8pvk0q1ehw165ma",
      "fspDate": "2025-07-07T06:48:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2470e8pvk0q1ehw165ma",
        "bookingDate": "2025-07-07",
        "valueDate": "2025-07-07",
        "bookingDateTime": "2025-07-07T06:48:00.000Z",
        "valueDateTime": "2025-07-07T06:48:00.000Z",
        "transactionAmount": {
          "amount": "-22.14",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Claude.ai Subscription",
        "remittanceInformationUnstructuredArray": [
          "Claude.ai Subscription"
        ],
        "debtorName": "Claude.ai"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cd5j1eshspjz017vq1wgn",
      "clustering": {
        "description": "Claude.ai",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Claude.ai' from 'Claude.ai Subscription'",
        "updatedAt": "2025-09-27T10:50:08.293Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_xyv526q3g5w9xsnk443e64cy6m",
      "createdAt": "2025-07-06T10:25:00.000Z",
      "updatedAt": "2025-07-06T10:25:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 7500,
      "currency": "GBP",
      "description": "Salary - James Anderson - 2025-12",
      "merchantCategoryCode": null,
      "fspIdentifier": "fsp_8q7c6mb9fa9sn61tt03zf14449",
      "fspDate": "2025-07-06T09:25:00.000Z",
      "fspRecord": {
        "transactionId": "fsp_ntbjg5czgt91veacpr0yjh31zp",
        "bookingDate": "2025-07-06",
        "valueDate": "2025-07-06",
        "bookingDateTime": "2025-07-06T09:25:00.000Z",
        "valueDateTime": "2025-07-06T09:25:00.000Z",
        "transactionAmount": {
          "amount": "-7500.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "SALARY",
        "remittanceInformationUnstructured": "Salary - James Anderson",
        "remittanceInformationUnstructuredArray": [
          "Salary - James Anderson"
        ]
      },
      "paymentId": "pmnt_x0gfyk80m4h3xtcy7kf9gj27my",
      "reference": "PAY-DEC-2025-ANDERSON",
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": null,
      "clustering": null,
      "payer": {
        "name": "Acme Tech Ltd",
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": "James Anderson",
        "iban": null,
        "bic": null,
        "sortCode": "20-00-00",
        "accountNumber": "12345602"
      }
    },
    {
      "id": "txn_01k65c32y5eshspggy5vgspt0d",
      "createdAt": "2025-07-05T10:27:00.000Z",
      "updatedAt": "2025-07-05T10:27:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 1235.48,
      "currency": "EUR",
      "description": "Payment to Remote Europe Holding BV: 050IN25055332",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01jyhhc6j1f20bmpk1r6a6a5km",
      "fspDate": "2025-07-05T09:27:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01jyhhc6j1f20bmpk1r6a6a5km",
        "bookingDate": "2025-07-05",
        "valueDate": "2025-07-05",
        "bookingDateTime": "2025-07-05T09:27:00.000Z",
        "valueDateTime": "2025-07-05T09:27:00.000Z",
        "transactionAmount": {
          "amount": "-1235.48",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "Payment to Remote Europe Holding BV: 050IN25055332",
        "remittanceInformationUnstructuredArray": [
          "Payment to Remote Europe Holding BV: 050IN25055332"
        ],
        "debtorName": "Remote Europe Holding BV"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c9pz7eshspjhbnt16ttyt",
      "clustering": {
        "description": "Remote Europe Holding BV",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Remote Europe Holding BV' from 'Payment to Remote Europe Holding BV: 050IN25055332'.",
        "updatedAt": "2025-09-27T10:52:47.424Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmjcgjckn9fs",
      "createdAt": "2025-07-04T16:17:00.000Z",
      "updatedAt": "2025-07-04T16:17:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 5826.35,
      "currency": "GBP",
      "description": "To Emily Harrington",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hse8pvk8aw244k790z",
      "fspDate": "2025-07-04T15:17:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hse8pvk8aw244k790z",
        "bookingDate": "2025-07-04",
        "valueDate": "2025-07-04",
        "bookingDateTime": "2025-07-04T15:17:00.000Z",
        "valueDateTime": "2025-07-04T15:17:00.000Z",
        "transactionAmount": {
          "amount": "-5826.35",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To Emily Harrington",
        "remittanceInformationUnstructuredArray": [
          "To Emily Harrington"
        ],
        "debtorName": "Emily Harrington"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbhnawfvhrjnjkdggymq9f",
      "clustering": {
        "description": "Emily Harrington",
        "confidenceScore": "0.95",
        "rationale": "Extracted the recipient name 'Emily Harrington' from 'To Emily Harrington'",
        "updatedAt": "2025-09-29T18:25:48.526Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y5eshspgdvpse2ex6n",
      "createdAt": "2025-07-04T14:41:00.000Z",
      "updatedAt": "2025-07-04T14:41:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 16.5,
      "currency": "EUR",
      "description": "Sq *shaka Poke",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2474e8pvk1bd7kq4x3y0",
      "fspDate": "2025-07-04T13:41:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2474e8pvk1bd7kq4x3y0",
        "bookingDate": "2025-07-04",
        "valueDate": "2025-07-04",
        "bookingDateTime": "2025-07-04T13:41:00.000Z",
        "valueDateTime": "2025-07-04T13:41:00.000Z",
        "transactionAmount": {
          "amount": "-16.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Sq *shaka Poke",
        "remittanceInformationUnstructuredArray": [
          "Sq *shaka Poke"
        ],
        "debtorName": "Shaka Poke"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k65c32gpeshspec6cv4wps2p",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g42eshsphpk5p8hryxp",
      "clustering": {
        "description": "Shaka Poke",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Shaka Poke' from 'Sq *shaka Poke', removing 'Sq *' prefix.",
        "updatedAt": "2025-09-27T10:52:47.330Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32xyeshspeg03kzqce6n",
      "createdAt": "2025-07-04T13:10:00.000Z",
      "updatedAt": "2025-07-04T13:10:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 29.45,
      "currency": "EUR",
      "description": "The Pig And Heifer",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k3n8n6ekeh2tcaqrwakea2st",
      "fspDate": "2025-07-04T12:10:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k3n8n6ekeh2tcaqrwakea2st",
        "bookingDate": "2025-07-04",
        "valueDate": "2025-07-04",
        "bookingDateTime": "2025-07-04T12:10:00.000Z",
        "valueDateTime": "2025-07-04T12:10:00.000Z",
        "transactionAmount": {
          "amount": "-29.45",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "The Pig And Heifer",
        "remittanceInformationUnstructuredArray": [
          "The Pig And Heifer"
        ],
        "debtorName": "The Pig And Heifer"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c4g5weshsphq7y8rf4z8z",
      "clustering": {
        "description": "The Pig And Heifer",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'The Pig And Heifer' from 'The Pig And Heifer'.",
        "updatedAt": "2025-09-27T10:39:39.678Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspezdmg9mbmdc",
      "createdAt": "2025-07-04T12:59:00.000Z",
      "updatedAt": "2025-07-04T12:59:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 37.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2empapqfk7s2z0y7vg5s004",
      "fspDate": "2025-07-04T11:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2empapqfk7s2z0y7vg5s004",
        "bookingDate": "2026-01-11",
        "valueDate": "2026-01-11",
        "bookingDateTime": "2026-01-11T08:00:00.000Z",
        "valueDateTime": "2026-01-11T08:00:00.000Z",
        "transactionAmount": {
          "amount": "-37.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:42:40.408Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y0eshspew3w5k5jekf",
      "createdAt": "2025-07-04T10:59:00.000Z",
      "updatedAt": "2025-07-04T10:59:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 42,
      "currency": "EUR",
      "description": "Delhi2dublin",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k2pbwp66fzwbe0x7chxczdcn",
      "fspDate": "2025-07-04T09:59:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k2pbwp66fzwbe0x7chxczdcn",
        "bookingDate": "2025-07-04",
        "valueDate": "2025-07-04",
        "bookingDateTime": "2025-07-04T09:59:00.000Z",
        "valueDateTime": "2025-07-04T09:59:00.000Z",
        "transactionAmount": {
          "amount": "-42.00",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Delhi2dublin",
        "remittanceInformationUnstructuredArray": [
          "Delhi2dublin"
        ],
        "debtorName": "Delhi2Dublin"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65cc0x5eshspjwbxzrhs5dn",
      "clustering": {
        "description": "Delhi2Dublin",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core merchant name 'Delhi2Dublin' from the transaction description.",
        "updatedAt": "2025-09-27T10:41:48.261Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz9fvhrjmqbs470da46",
      "createdAt": "2025-07-04T08:01:00.000Z",
      "updatedAt": "2025-07-04T08:01:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 0,
      "currency": "GBP",
      "description": "Deliveroo",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hte8pvk8fymxdvze1k",
      "fspDate": "2025-07-04T07:01:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hte8pvk8fymxdvze1k",
        "bookingDate": "2025-07-04",
        "valueDate": "2025-07-04",
        "bookingDateTime": "2025-07-04T07:01:00.000Z",
        "valueDateTime": "2025-07-04T07:01:00.000Z",
        "transactionAmount": {
          "amount": "0.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Deliveroo",
        "remittanceInformationUnstructuredArray": [
          "Deliveroo"
        ],
        "debtorName": "Deliveroo"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbmgmcfvhrjp16bczghe88",
      "clustering": {
        "description": "Deliveroo",
        "confidenceScore": "0.95",
        "rationale": "Extracted core business name 'Deliveroo' from 'Deliveroo'",
        "updatedAt": "2025-09-29T18:26:40.956Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k6bbebz8fvhrjmbhhh0bseeb",
      "createdAt": "2025-07-03T16:42:00.000Z",
      "updatedAt": "2025-07-03T16:42:00.000Z",
      "status": "BOOKED",
      "type": "TRANSFER",
      "isCredit": false,
      "amount": 42010,
      "currency": "GBP",
      "description": "To SEAPOINT FINANCE UK INVESTMENTS LIMITED",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg26hqe8pvk846jq9agvrp",
      "fspDate": "2025-07-03T15:42:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg26hqe8pvk846jq9agvrp",
        "bookingDate": "2025-07-03",
        "valueDate": "2025-07-03",
        "bookingDateTime": "2025-07-03T15:42:00.000Z",
        "valueDateTime": "2025-07-03T15:42:00.000Z",
        "transactionAmount": {
          "amount": "-42010.00",
          "currency": "GBP"
        },
        "proprietaryBankTransactionCode": "TRANSFER",
        "remittanceInformationUnstructured": "To SEAPOINT FINANCE UK INVESTMENTS LIMITED",
        "remittanceInformationUnstructuredArray": [
          "To SEAPOINT FINANCE UK INVESTMENTS LIMITED"
        ],
        "debtorName": "SEAPOINT FINANCE  LIMITED"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "clustering": {
        "description": "Seapoint Finance Uk Investments Limited",
        "confidenceScore": "0.95",
        "rationale": "Extracted the core business name 'Seapoint Finance Uk Investments Limited' from 'To SEAPOINT FINANCE UK INVESTMENTS LIMITED'",
        "updatedAt": "2025-09-29T18:24:29.687Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    },
    {
      "id": "txn_01k65c32y4eshspg9s3pm0e9d8",
      "createdAt": "2025-07-03T14:40:00.000Z",
      "updatedAt": "2025-07-03T14:40:00.000Z",
      "status": "BOOKED",
      "type": "CARD_PAYMENT",
      "isCredit": false,
      "amount": 12.5,
      "currency": "EUR",
      "description": "Zakura",
      "merchantCategoryCode": null,
      "fspIdentifier": "txn_01k0cg2473e8pvk186wbjrs4s7",
      "fspDate": "2025-07-03T13:40:00.000Z",
      "fspRecord": {
        "transactionId": "txn_01k0cg2473e8pvk186wbjrs4s7",
        "bookingDate": "2025-07-03",
        "valueDate": "2025-07-03",
        "bookingDateTime": "2025-07-03T13:40:00.000Z",
        "valueDateTime": "2025-07-03T13:40:00.000Z",
        "transactionAmount": {
          "amount": "-12.50",
          "currency": "EUR"
        },
        "proprietaryBankTransactionCode": "CARD_PAYMENT",
        "remittanceInformationUnstructured": "Zakura",
        "remittanceInformationUnstructuredArray": [
          "Zakura"
        ],
        "debtorName": "Zakura"
      },
      "paymentId": null,
      "reference": null,
      "beneficiaryId": null,
      "accountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "vendorId": "ven_01k65c5wheeshsphxs0k63554k",
      "clustering": {
        "description": "Zakura",
        "confidenceScore": "0.95",
        "rationale": "Extracted core merchant name 'Zakura' from 'Zakura'",
        "updatedAt": "2025-09-27T10:52:09.953Z"
      },
      "payer": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      },
      "payee": {
        "name": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null
      }
    }
  ],
  "evidence": [
    {
      "id": "evi_01k6fp0bb3fzz9aeqfxd6y4tf4",
      "createdAt": "2025-10-01T11:45:04.481Z",
      "updatedAt": "2025-10-01T11:53:58.327Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "85.00",
      "summary": "Invoice #150660 from Pembroke Hall Limited for €3,690.00 (including VAT) for office services (JULY 25 LF)",
      "rationale": "Perfect match found - exact amount (€3,690), vendor name (PEMBROKEHALL LTD), and invoice reference (150660) all match. Payment timing of 14 days after invoice date is reasonable.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_01k6fp0badfzz9aeq5pjjv3961",
      "transactionId": "txn_01k6fpge54fzz9aetcq6n3km30",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": true,
      "isPaidConfidenceScore": 98,
      "isPaidUpdatedByType": "PAYMENT",
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 3000,
          "description": "JULY 25 LF",
          "totalAmount": 3690,
          "preTaxAmount": 3000,
          "salesTaxRate": 23,
          "salesTaxAmount": 690
        }
      ],
      "paymentInformation": {
        "bic": "BOFIIE2D",
        "iban": "IE15BOFI99999999999901",
        "bankName": "BANK OF IRELAND",
        "sortCode": null,
        "accountNo": null,
        "bankAddress": "UNIVERSITY BRANCH, MONTROSE, DUBLIN 4",
        "bankCountry": "IE"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": "99003355",
        "vendorNumber": null,
        "vendorAddress": "38/39 Fitzwilliam Square, Dublin 2",
        "vendorCountry": "IE",
        "vendorWebsite": null,
        "vendorCompanyName": "Pembroke Hall Limited",
        "vendorCompanyNumber": "426611",
        "vendorTradingOrProductName": "Pembr Flexible Office Solutions"
      },
      "billingDates": {
        "dueDate": null,
        "invoiceDate": "2025-06-06",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "EUR",
        "netAmount": 3000,
        "totalAmount": 3690,
        "salesTaxRate": 23,
        "salesTaxAmount": 690,
        "invoiceReference": "150660"
      },
      "parsedDocument": {
        "tables": [
          [
            [
              "Invoice No.",
              "150660"
            ],
            [
              "Invoice / Tax Date",
              "06/06/2025"
            ],
            [
              "Customer Order No.",
              "JULY 25 LF"
            ],
            [
              "Account No.",
              "SEAPFINA"
            ]
          ],
          [
            [
              "Quantity Details",
              "Unit Price",
              "Disc Amt",
              "Net Amt",
              "VAT %",
              "VAT"
            ],
            [
              "1.00 JULY 25 LF",
              "3,000.00",
              "0.00",
              "3,000.00",
              "23.00",
              "690.00"
            ]
          ],
          [
            [
              "Total Net Amount",
              "3,000.00"
            ],
            [
              "Total VAT Amount",
              "690.00"
            ],
            [
              "Euro Total",
              "3,690.00"
            ]
          ]
        ],
        "rawText": "Invoice From: Pembroke Hall Limited 38/39 Fitzwilliam Square Dublin 2 Pembr Flexible Office Solutions VAT Reg No: 99003355 To: SEAPOINT FINANCE LIMITED Invoice No. 150660 6 MOUNT STREET UPPER D02VF44 Invoice / Tax Date 06/06/2025 DUBLIN Customer Order No. JULY 25 LF VAT Reg No: Account No. SEAPFINA Quantity Details Unit Price Disc Amt Net Amt VAT % VAT 1.00 JULY 25 LF 3,000.00 0.00 3,000.00 23.00 690.00 All Worklogs Available Through Reception on Request Total Net Amount 3,000.00 Please Remit Payment To: PEMBROKEHALL LTD Total VAT Amount 690.00 BANK NAME: BANK OF IRELAND BANK ADDRESS: UNIVERSITY BRANCH, MONTROSE, DUBLIN 4 Euro Total 3,690.00 BIC: BOFIIE2D IBAN: IE15 BOFI 9013 5180 5179 81 Company Registration No: 426611 VAT No: 99003355 Directors: T. Lenehan, R. Manson",
        "keyValuePairs": {
          "To:": "SEAPOINT FINANCE LIMITED 6 MOUNT STREET UPPER D02VF44 DUBLIN",
          "VAT": "690.00",
          "BIC:": "BOFIIE2D",
          "From:": "Pembroke Hall Limited 38/39 Fitzwilliam Square Dublin 2",
          "IBAN:": "IE15 BOFI 9013 5180 5179 81",
          "VAT %": "23.00",
          "Please": "PEMBROKEHALL LTD",
          "Details": "JULY 25 LF",
          "Net Amt": "3,000.00",
          "VAT No:": "99003355",
          "Disc Amt": "0.00",
          "Quantity": "1.00",
          "BANK NAME:": "OF IRELAND",
          "Directors:": "T. Lenehan, R. Manson",
          "Euro Total": "3,690.00",
          "Unit Price": "3,000.00",
          "Account No.": "SEAPFINA",
          "Invoice No.": "150660",
          "VAT Reg No:": "",
          "BANK ADDRESS:": "UNIVERSITY BRANCH, MONTROSE, DUBLIN 4",
          "Total Net Amount": "3,000.00",
          "Total VAT Amount": "690.00",
          "Customer Order No.": "JULY 25 LF",
          "Invoice / Tax Date": "06/06/2025",
          "Company Registration No:": "426611"
        }
      },
      "suggestedBeneficiaryId": "benf_01k6da2eq9enabvr1mt32wrpx6",
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_swg7a66ndv1m6ydrhsebj70a4w",
      "createdAt": "2025-12-01T12:00:00.000Z",
      "updatedAt": "2025-12-01T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "95.00",
      "summary": "Invoice #AWS-2025-847291 from Amazon Web Services EMEA SARL for £4,250.00 for AWS Cloud Services - November 2025",
      "rationale": "Perfect match found - exact amount (GBP 4250), vendor name (Amazon Web Services EMEA SARL), and invoice reference (AWS-2025-847291) all match.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_4bdmzgx9s2ce75y4jskt3yxwpv",
      "transactionId": "txn_9y1wkwwswr3fvw92hfkvyv0h2v",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": true,
      "isPaidConfidenceScore": 95,
      "isPaidUpdatedByType": "SYSTEM",
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 3541.67,
          "description": "AWS Cloud Services - November 2025",
          "totalAmount": 4250,
          "preTaxAmount": 3541.67,
          "salesTaxRate": 20,
          "salesTaxAmount": 708.33
        }
      ],
      "paymentInformation": {
        "bic": "CITILULX",
        "iban": "LU280000123456789012",
        "bankName": null,
        "sortCode": null,
        "accountNo": null,
        "bankAddress": null,
        "bankCountry": "LU"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": "LU26888617",
        "vendorNumber": null,
        "vendorAddress": "38 Avenue John F. Kennedy, L-1855 Luxembourg",
        "vendorCountry": "LU",
        "vendorWebsite": null,
        "vendorCompanyName": "Amazon Web Services EMEA SARL",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2025-12-31",
        "invoiceDate": "2025-12-01",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "GBP",
        "netAmount": 3541.67,
        "totalAmount": 4250,
        "salesTaxRate": 20,
        "salesTaxAmount": 708.33,
        "invoiceReference": "AWS-2025-847291"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from Amazon Web Services EMEA SARL for AWS Cloud Services - November 2025. Amount: 4250",
        "keyValuePairs": {
          "Invoice No.": "AWS-2025-847291",
          "Invoice Date": "2025-12-01",
          "Due Date": "2025-12-31",
          "Total": "4250"
        }
      },
      "suggestedBeneficiaryId": "benf_vy5tcadsq8hq6zp05dzeh2tatq",
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_xn2kg6cne51b9fw57cehrwg6pc",
      "createdAt": "2025-12-15T12:00:00.000Z",
      "updatedAt": "2025-12-15T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "95.00",
      "summary": "Invoice #OAI-2025-12-4829 from OpenAI, LLC for $3,500.00 for OpenAI API Usage - December 2025",
      "rationale": "Perfect match found - exact amount (USD 3500), vendor name (OpenAI, LLC), and invoice reference (OAI-2025-12-4829) all match.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_hhy39amf2vs5pbmzs72a7h3akf",
      "transactionId": "txn_yvxcphmr3zjvdbf6zv88g5yzsq",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": true,
      "isPaidConfidenceScore": 95,
      "isPaidUpdatedByType": "SYSTEM",
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 3500,
          "description": "OpenAI API Usage - December 2025",
          "totalAmount": 3500,
          "preTaxAmount": 3500,
          "salesTaxRate": 0,
          "salesTaxAmount": 0
        }
      ],
      "paymentInformation": {
        "bic": null,
        "iban": null,
        "bankName": null,
        "sortCode": null,
        "accountNo": "3301234567",
        "bankAddress": null,
        "bankCountry": "US"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": null,
        "vendorNumber": null,
        "vendorAddress": "3180 18th Street, San Francisco, CA 94110, United States",
        "vendorCountry": "US",
        "vendorWebsite": null,
        "vendorCompanyName": "OpenAI, LLC",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2026-01-14",
        "invoiceDate": "2025-12-15",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "USD",
        "netAmount": 3500,
        "totalAmount": 3500,
        "salesTaxRate": 0,
        "salesTaxAmount": 0,
        "invoiceReference": "OAI-2025-12-4829"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from OpenAI, LLC for OpenAI API Usage - December 2025. Amount: 3500",
        "keyValuePairs": {
          "Invoice No.": "OAI-2025-12-4829",
          "Invoice Date": "2025-12-15",
          "Due Date": "2026-01-14",
          "Total": "3500"
        }
      },
      "suggestedBeneficiaryId": "benf_bja9cdzr82eptdtwghfrd40ac5",
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_ned8wqdfg42vddvmgmy38nfbns",
      "createdAt": "2025-12-20T12:00:00.000Z",
      "updatedAt": "2025-12-20T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "95.00",
      "summary": "Invoice #ANT-2025-38291 from Anthropic PBC for $2,800.00 for Anthropic Claude API - December 2025",
      "rationale": "Perfect match found - exact amount (USD 2800), vendor name (Anthropic PBC), and invoice reference (ANT-2025-38291) all match.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_w6wky2wc3mh97pn69hmjxk8p9p",
      "transactionId": "txn_676xmbhyq8ptwpf147xr1tqpcm",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": true,
      "isPaidConfidenceScore": 95,
      "isPaidUpdatedByType": "SYSTEM",
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 2800,
          "description": "Anthropic Claude API - December 2025",
          "totalAmount": 2800,
          "preTaxAmount": 2800,
          "salesTaxRate": 0,
          "salesTaxAmount": 0
        }
      ],
      "paymentInformation": {
        "bic": null,
        "iban": null,
        "bankName": null,
        "sortCode": null,
        "accountNo": "8801234567",
        "bankAddress": null,
        "bankCountry": "US"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": null,
        "vendorNumber": null,
        "vendorAddress": "548 Market Street, San Francisco, CA 94104, United States",
        "vendorCountry": "US",
        "vendorWebsite": null,
        "vendorCompanyName": "Anthropic PBC",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2026-01-19",
        "invoiceDate": "2025-12-20",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "USD",
        "netAmount": 2800,
        "totalAmount": 2800,
        "salesTaxRate": 0,
        "salesTaxAmount": 0,
        "invoiceReference": "ANT-2025-38291"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from Anthropic PBC for Anthropic Claude API - December 2025. Amount: 2800",
        "keyValuePairs": {
          "Invoice No.": "ANT-2025-38291",
          "Invoice Date": "2025-12-20",
          "Due Date": "2026-01-19",
          "Total": "2800"
        }
      },
      "suggestedBeneficiaryId": "benf_xka3kqs02tx2re7za71wbk3yjd",
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_wftz74gw44j67068dw6p385yw4",
      "createdAt": "2026-01-05T12:00:00.000Z",
      "updatedAt": "2026-01-05T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "88.00",
      "summary": "Invoice #SLK-UK-2026-0105 from Slack Technologies Limited for £519.90 for Slack Business+ - January 2026",
      "rationale": "Potential match found - amount and vendor appear to match a recent transaction. User review recommended.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_yc31tmzqjfr01cgyqsdx498q1v",
      "transactionId": "txn_bzgajatt3ntn04w99njrzdm9ps",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": false,
      "isPaidConfidenceScore": 0,
      "isPaidUpdatedByType": null,
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 433.25,
          "description": "Slack Business+ - January 2026",
          "totalAmount": 519.9,
          "preTaxAmount": 433.25,
          "salesTaxRate": 20,
          "salesTaxAmount": 86.65
        }
      ],
      "paymentInformation": {
        "bic": null,
        "iban": null,
        "bankName": null,
        "sortCode": "20-00-00",
        "accountNo": "73849201",
        "bankAddress": null,
        "bankCountry": "GB"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": "GB283641392",
        "vendorNumber": null,
        "vendorAddress": "Salesforce Tower, 110 Bishopsgate, London EC2N 4AY",
        "vendorCountry": "GB",
        "vendorWebsite": null,
        "vendorCompanyName": "Slack Technologies Limited",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2026-02-04",
        "invoiceDate": "2026-01-05",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "GBP",
        "netAmount": 433.25,
        "totalAmount": 519.9,
        "salesTaxRate": 20,
        "salesTaxAmount": 86.65,
        "invoiceReference": "SLK-UK-2026-0105"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from Slack Technologies Limited for Slack Business+ - January 2026. Amount: 519.9",
        "keyValuePairs": {
          "Invoice No.": "SLK-UK-2026-0105",
          "Invoice Date": "2026-01-05",
          "Due Date": "2026-02-04",
          "Total": "519.9"
        }
      },
      "suggestedBeneficiaryId": "benf_423n0p675xecav56xpy6rxhv9m",
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_5zqv1bt2fkfj99xajx8qgwdpax",
      "createdAt": "2026-01-08T12:00:00.000Z",
      "updatedAt": "2026-01-08T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "88.00",
      "summary": "Invoice #GH-2026-01-78234 from GitHub, Inc. for $840.00 for GitHub Enterprise Cloud - January 2026",
      "rationale": "Potential match found - amount and vendor appear to match a recent transaction. User review recommended.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_1y4ea0rag431sn6watgtj750ef",
      "transactionId": "txn_e8y1s8nf5xjcj70epwvy0g7zem",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": false,
      "isPaidConfidenceScore": 0,
      "isPaidUpdatedByType": null,
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 840,
          "description": "GitHub Enterprise Cloud - January 2026",
          "totalAmount": 840,
          "preTaxAmount": 840,
          "salesTaxRate": 0,
          "salesTaxAmount": 0
        }
      ],
      "paymentInformation": {
        "bic": null,
        "iban": null,
        "bankName": null,
        "sortCode": null,
        "accountNo": "9901234567",
        "bankAddress": null,
        "bankCountry": "US"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": null,
        "vendorNumber": null,
        "vendorAddress": "88 Colin P Kelly Jr Street, San Francisco, CA 94107",
        "vendorCountry": "US",
        "vendorWebsite": null,
        "vendorCompanyName": "GitHub, Inc.",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2026-02-07",
        "invoiceDate": "2026-01-08",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "USD",
        "netAmount": 840,
        "totalAmount": 840,
        "salesTaxRate": 0,
        "salesTaxAmount": 0,
        "invoiceReference": "GH-2026-01-78234"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from GitHub, Inc. for GitHub Enterprise Cloud - January 2026. Amount: 840",
        "keyValuePairs": {
          "Invoice No.": "GH-2026-01-78234",
          "Invoice Date": "2026-01-08",
          "Due Date": "2026-02-07",
          "Total": "840"
        }
      },
      "suggestedBeneficiaryId": "benf_4pppc1h3qy34jt2h3pygnfsexm",
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_m1tj9z0rnv36by95vj6fg0zmz5",
      "createdAt": "2026-01-10T12:00:00.000Z",
      "updatedAt": "2026-01-10T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "85.00",
      "summary": "Invoice #WW-UK-2026-01892 from WeWork International Ltd for £4,200.00 for WeWork Office - February 2026",
      "rationale": "Invoice processed successfully. No matching transaction found yet.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_sn85hj00rnez04rk7z9pd9bhdh",
      "transactionId": null,
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": false,
      "isPaidConfidenceScore": 0,
      "isPaidUpdatedByType": null,
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 3500,
          "description": "WeWork Office - February 2026",
          "totalAmount": 4200,
          "preTaxAmount": 3500,
          "salesTaxRate": 20,
          "salesTaxAmount": 700
        }
      ],
      "paymentInformation": {
        "bic": null,
        "iban": null,
        "bankName": null,
        "sortCode": "40-05-30",
        "accountNo": "12847391",
        "bankAddress": null,
        "bankCountry": "GB"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": "GB238471923",
        "vendorNumber": null,
        "vendorAddress": "115 Mare Street, London E8 4RU",
        "vendorCountry": "GB",
        "vendorWebsite": null,
        "vendorCompanyName": "WeWork International Ltd",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2026-01-25",
        "invoiceDate": "2026-01-10",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "GBP",
        "netAmount": 3500,
        "totalAmount": 4200,
        "salesTaxRate": 20,
        "salesTaxAmount": 700,
        "invoiceReference": "WW-UK-2026-01892"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from WeWork International Ltd for WeWork Office - February 2026. Amount: 4200",
        "keyValuePairs": {
          "Invoice No.": "WW-UK-2026-01892",
          "Invoice Date": "2026-01-10",
          "Due Date": "2026-01-25",
          "Total": "4200"
        }
      },
      "suggestedBeneficiaryId": "benf_egv1gm096d42br09c3enxwr6h5",
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_g7c6f5286jbn4wnwwk3msntv8d",
      "createdAt": "2026-01-12T12:00:00.000Z",
      "updatedAt": "2026-01-12T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "85.00",
      "summary": "Invoice #NOT-2026-91823 from Notion Labs, Inc. for $192.00 for Notion Team Plan - January 2026",
      "rationale": "Invoice processed successfully. No matching transaction found yet.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_4ssdtfbn9c0rambp391xm9q4ty",
      "transactionId": null,
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": false,
      "isPaidConfidenceScore": 0,
      "isPaidUpdatedByType": null,
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 192,
          "description": "Notion Team Plan - January 2026",
          "totalAmount": 192,
          "preTaxAmount": 192,
          "salesTaxRate": 0,
          "salesTaxAmount": 0
        }
      ],
      "paymentInformation": {
        "bic": null,
        "iban": null,
        "bankName": null,
        "sortCode": null,
        "accountNo": "1234567890",
        "bankAddress": null,
        "bankCountry": "US"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": null,
        "vendorNumber": null,
        "vendorAddress": "2300 Harrison Street, San Francisco, CA 94110",
        "vendorCountry": "US",
        "vendorWebsite": null,
        "vendorCompanyName": "Notion Labs, Inc.",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2026-02-11",
        "invoiceDate": "2026-01-12",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "USD",
        "netAmount": 192,
        "totalAmount": 192,
        "salesTaxRate": 0,
        "salesTaxAmount": 0,
        "invoiceReference": "NOT-2026-91823"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from Notion Labs, Inc. for Notion Team Plan - January 2026. Amount: 192",
        "keyValuePairs": {
          "Invoice No.": "NOT-2026-91823",
          "Invoice Date": "2026-01-12",
          "Due Date": "2026-02-11",
          "Total": "192"
        }
      },
      "suggestedBeneficiaryId": "benf_5v1gpcvhcb83ysp8eyw9r5arr8",
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_gx1c9j6js35psfz33h7aykrrtz",
      "createdAt": "2026-01-13T12:00:00.000Z",
      "updatedAt": "2026-01-13T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "85.00",
      "summary": "Invoice #OSC-2026-4821 from Office Supplies Co Ltd for £1,098.00 for Office Equipment - January 2026",
      "rationale": "Invoice processed successfully. No matching transaction found yet.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_94y07yawjhr572jrab5atb50w0",
      "transactionId": null,
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": false,
      "isPaidConfidenceScore": 0,
      "isPaidUpdatedByType": null,
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 915,
          "description": "Office Equipment - January 2026",
          "totalAmount": 1098,
          "preTaxAmount": 915,
          "salesTaxRate": 20,
          "salesTaxAmount": 183
        }
      ],
      "paymentInformation": {
        "bic": null,
        "iban": null,
        "bankName": null,
        "sortCode": "60-12-34",
        "accountNo": "48291034",
        "bankAddress": null,
        "bankCountry": "GB"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": "GB987654321",
        "vendorNumber": null,
        "vendorAddress": "45 High Street, Manchester M1 4BT",
        "vendorCountry": "GB",
        "vendorWebsite": null,
        "vendorCompanyName": "Office Supplies Co Ltd",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2026-01-27",
        "invoiceDate": "2026-01-13",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "GBP",
        "netAmount": 915,
        "totalAmount": 1098,
        "salesTaxRate": 20,
        "salesTaxAmount": 183,
        "invoiceReference": "OSC-2026-4821"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from Office Supplies Co Ltd for Office Equipment - January 2026. Amount: 1098",
        "keyValuePairs": {
          "Invoice No.": "OSC-2026-4821",
          "Invoice Date": "2026-01-13",
          "Due Date": "2026-01-27",
          "Total": "1098"
        }
      },
      "suggestedBeneficiaryId": null,
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_s5w2656k6caxdgq8vtdcerphak",
      "createdAt": "2026-01-14T12:00:00.000Z",
      "updatedAt": "2026-01-14T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "85.00",
      "summary": "Invoice #VCL-2026-01-3928 from Vercel Inc. for $450.00 for Vercel Pro - January 2026",
      "rationale": "Invoice processed successfully. No matching transaction found yet.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_yexykmt2cxcj9j0a3at0bws13v",
      "transactionId": null,
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": false,
      "isPaidConfidenceScore": 0,
      "isPaidUpdatedByType": null,
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 450,
          "description": "Vercel Pro - January 2026",
          "totalAmount": 450,
          "preTaxAmount": 450,
          "salesTaxRate": 0,
          "salesTaxAmount": 0
        }
      ],
      "paymentInformation": {
        "bic": null,
        "iban": null,
        "bankName": null,
        "sortCode": null,
        "accountNo": "9876543210",
        "bankAddress": null,
        "bankCountry": "US"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": null,
        "vendorNumber": null,
        "vendorAddress": "340 S Lemon Ave #4133, Walnut, CA 91789",
        "vendorCountry": "US",
        "vendorWebsite": null,
        "vendorCompanyName": "Vercel Inc.",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2026-02-13",
        "invoiceDate": "2026-01-14",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "USD",
        "netAmount": 450,
        "totalAmount": 450,
        "salesTaxRate": 0,
        "salesTaxAmount": 0,
        "invoiceReference": "VCL-2026-01-3928"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from Vercel Inc. for Vercel Pro - January 2026. Amount: 450",
        "keyValuePairs": {
          "Invoice No.": "VCL-2026-01-3928",
          "Invoice Date": "2026-01-14",
          "Due Date": "2026-02-13",
          "Total": "450"
        }
      },
      "suggestedBeneficiaryId": null,
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    },
    {
      "id": "evi_g76v30am1a255qbhqkz9zf20ze",
      "createdAt": "2026-01-06T12:00:00.000Z",
      "updatedAt": "2026-01-06T12:30:00.000Z",
      "source": "UPLOAD",
      "type": "invoice",
      "status": "COMPLETED",
      "confidenceScore": "85.00",
      "summary": "Invoice #150780 from Pembroke Hall Limited for €3,690.00 for Office Services - February 2026",
      "rationale": "Invoice processed successfully. No matching transaction found yet.",
      "metadata": null,
      "emailInformation": null,
      "documentId": "doc_hm0sj0xb2qw7dqet0cg4r1nhem",
      "transactionId": null,
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "isPaid": false,
      "isPaidConfidenceScore": 0,
      "isPaidUpdatedByType": null,
      "isPaidUpdatedByUserId": null,
      "lineItems": [
        {
          "quantity": 1,
          "unitPrice": 3000,
          "description": "Office Services - February 2026",
          "totalAmount": 3690,
          "preTaxAmount": 3000,
          "salesTaxRate": 23,
          "salesTaxAmount": 690
        }
      ],
      "paymentInformation": {
        "bic": "BOFIIE2D",
        "iban": "IE15BOFI99999999999901",
        "bankName": null,
        "sortCode": null,
        "accountNo": null,
        "bankAddress": null,
        "bankCountry": "IE"
      },
      "vendorInformation": {
        "vendorEmail": null,
        "vendorVatNo": "IE99003355",
        "vendorNumber": null,
        "vendorAddress": "38/39 Fitzwilliam Square, Dublin 2, Ireland",
        "vendorCountry": "IE",
        "vendorWebsite": null,
        "vendorCompanyName": "Pembroke Hall Limited",
        "vendorCompanyNumber": null,
        "vendorTradingOrProductName": null
      },
      "billingDates": {
        "dueDate": "2026-01-20",
        "invoiceDate": "2026-01-06",
        "billingPeriodEnd": null,
        "billingPeriodStart": null
      },
      "invoiceDetails": {
        "currency": "EUR",
        "netAmount": 3000,
        "totalAmount": 3690,
        "salesTaxRate": 23,
        "salesTaxAmount": 690,
        "invoiceReference": "150780"
      },
      "parsedDocument": {
        "tables": [],
        "rawText": "Invoice from Pembroke Hall Limited for Office Services - February 2026. Amount: 3690",
        "keyValuePairs": {
          "Invoice No.": "150780",
          "Invoice Date": "2026-01-06",
          "Due Date": "2026-01-20",
          "Total": "3690"
        }
      },
      "suggestedBeneficiaryId": "benf_01k6da2eq9enabvr1mt32wrpx6",
      "deletedByType": null,
      "deletionReason": null,
      "deletedAt": null,
      "suggestedTransactions": []
    }
  ],
  "employee": [
    {
      "id": "emp_zq3md5qpz0r532nqdyznhjpkgc",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00001",
      "firstName": "Sarah",
      "lastName": "Mitchell",
      "emailAddress": "sarah.mitchell@acmetech.co.uk",
      "taxId": null,
      "role": "CEO",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 150000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "12345601",
        "sortCode": "20-00-00",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_m0gdmee0j4kcevsjhbqzx5f7tc",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00002",
      "firstName": "James",
      "lastName": "Anderson",
      "emailAddress": "james.anderson@acmetech.co.uk",
      "taxId": null,
      "role": "CTO",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 130000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "12345602",
        "sortCode": "20-00-00",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_vfcnttyse3amrgevzk930dqnz3",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00003",
      "firstName": "Emily",
      "lastName": "Chen",
      "emailAddress": "emily.chen@acmetech.co.uk",
      "taxId": null,
      "role": "CFO",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 125000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "87654301",
        "sortCode": "30-15-89",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_7hpe8spyagpaja1rkkmfdc05x4",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00004",
      "firstName": "David",
      "lastName": "Kumar",
      "emailAddress": "david.kumar@acmetech.co.uk",
      "taxId": null,
      "role": "Senior Software Engineer",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 85000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "23456701",
        "sortCode": "40-05-30",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_8fenvh4xjzer5s14vyzj7yxn2q",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00005",
      "firstName": "Sophie",
      "lastName": "O'Brien",
      "emailAddress": "sophie.obrien@acmetech.co.uk",
      "taxId": null,
      "role": "Senior Software Engineer",
      "status": "Active",
      "country": "IE",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 82000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "34567801",
        "sortCode": "90-01-23",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_kdf5p201675t6z7f8j4dvdm1xs",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00006",
      "firstName": "Michael",
      "lastName": "Taylor",
      "emailAddress": "michael.taylor@acmetech.co.uk",
      "taxId": null,
      "role": "Software Engineer",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 65000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "45678901",
        "sortCode": "20-00-00",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_jhf30xfk1pnt2x0csdkbgffce8",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00007",
      "firstName": "Priya",
      "lastName": "Sharma",
      "emailAddress": "priya.sharma@acmetech.co.uk",
      "taxId": null,
      "role": "Software Engineer",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 62000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "56789012",
        "sortCode": "30-15-89",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_v84e4dkk0a108gmgyxddrex18x",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00008",
      "firstName": "Conor",
      "lastName": "Murphy",
      "emailAddress": "conor.murphy@acmetech.co.uk",
      "taxId": null,
      "role": "Junior Software Engineer",
      "status": "Active",
      "country": "IE",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 45000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "67890123",
        "sortCode": "90-01-23",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_0m3h0ystzhdkv089qtpxgymy0p",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00009",
      "firstName": "Rebecca",
      "lastName": "Williams",
      "emailAddress": "rebecca.williams@acmetech.co.uk",
      "taxId": null,
      "role": "Head of Product",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 95000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "78901234",
        "sortCode": "40-05-30",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_bqney2sngj9ht0vw439pk4s511",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00010",
      "firstName": "Alex",
      "lastName": "Johnson",
      "emailAddress": "alex.johnson@acmetech.co.uk",
      "taxId": null,
      "role": "Product Manager",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 70000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "89012345",
        "sortCode": "20-00-00",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_x6438kwbvw2mmzq5d8r2ay8ngh",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00011",
      "firstName": "Niamh",
      "lastName": "Fitzgerald",
      "emailAddress": "niamh.fitzgerald@acmetech.co.uk",
      "taxId": null,
      "role": "UX Designer",
      "status": "Active",
      "country": "IE",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 58000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "90123456",
        "sortCode": "90-01-23",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_5dpt32a2e7pkakyx43wq731mxb",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00012",
      "firstName": "Thomas",
      "lastName": "Brown",
      "emailAddress": "thomas.brown@acmetech.co.uk",
      "taxId": null,
      "role": "Head of Sales",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 80000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "01234567",
        "sortCode": "30-15-89",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_jvrzahwp2f269f98adpnxzyhkr",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00013",
      "firstName": "Hannah",
      "lastName": "Davies",
      "emailAddress": "hannah.davies@acmetech.co.uk",
      "taxId": null,
      "role": "Account Executive",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 52000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "11234567",
        "sortCode": "40-05-30",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_p6mwbj7ht9st1k0nq5q8b37z5p",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00014",
      "firstName": "Sean",
      "lastName": "Kelly",
      "emailAddress": "sean.kelly@acmetech.co.uk",
      "taxId": null,
      "role": "Operations Manager",
      "status": "Active",
      "country": "IE",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 55000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "21234567",
        "sortCode": "90-01-23",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    },
    {
      "id": "emp_3srkf2v3egerrjbg157ssedxb8",
      "createdAt": "2025-08-15T10:00:00.000Z",
      "updatedAt": "2025-12-01T10:00:00.000Z",
      "employeeId": "00015",
      "firstName": "Emma",
      "lastName": "Wilson",
      "emailAddress": "emma.wilson@acmetech.co.uk",
      "taxId": null,
      "role": "Office Manager",
      "status": "Active",
      "country": "GB",
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "salary": 42000,
      "destination": {
        "type": "SCAN",
        "accountType": "PERSONAL",
        "currency": "GBP",
        "accountNumber": "31234567",
        "sortCode": "20-00-00",
        "iban": null,
        "bic": null
      },
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "deletedByType": null,
      "deletedAt": null
    }
  ],
  "organisation": [
    {
      "id": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-10-07T23:17:37.386Z",
      "name": "Acme Tech Ltd",
      "auth0OrgId": "org_afqL8bt2jeTR2446",
      "logoUrl": null
    }
  ],
  "agreed_terms_and_conditions": [
    {
      "id": "agts_01k1y1ypa6fqfbnca1f3zvqweb",
      "createdAt": "2025-08-05T22:24:46.014Z",
      "updatedAt": "2025-08-05T22:24:46.014Z",
      "acceptedBy": "dago+1@seapoint.co",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "termsAndConditionsId": "tcs-1"
    }
  ],
  "invoice_suggested_transaction": [
    {
      "id": "ist_rbhnd8sqqwyjm7jx1mh0v0apkk",
      "createdAt": "2025-12-01T12:30:00.000Z",
      "updatedAt": "2025-12-01T12:30:00.000Z",
      "confidenceScore": 95,
      "amountScore": 100,
      "dateProximityScore": 90,
      "referenceScore": 95,
      "vendorScore": 90,
      "evidenceId": "evi_swg7a66ndv1m6ydrhsebj70a4w",
      "transactionId": "txn_9y1wkwwswr3fvw92hfkvyv0h2v",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "ist_ec20jpsgjwvr36wy8zan0q8s94",
      "createdAt": "2025-12-15T12:30:00.000Z",
      "updatedAt": "2025-12-15T12:30:00.000Z",
      "confidenceScore": 95,
      "amountScore": 100,
      "dateProximityScore": 90,
      "referenceScore": 95,
      "vendorScore": 90,
      "evidenceId": "evi_xn2kg6cne51b9fw57cehrwg6pc",
      "transactionId": "txn_yvxcphmr3zjvdbf6zv88g5yzsq",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "ist_wgsh4wgxr6xp2w8dytfbsrysmt",
      "createdAt": "2025-12-20T12:30:00.000Z",
      "updatedAt": "2025-12-20T12:30:00.000Z",
      "confidenceScore": 95,
      "amountScore": 100,
      "dateProximityScore": 90,
      "referenceScore": 95,
      "vendorScore": 90,
      "evidenceId": "evi_ned8wqdfg42vddvmgmy38nfbns",
      "transactionId": "txn_676xmbhyq8ptwpf147xr1tqpcm",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "ist_wk9tkv2ev97fwn5xn12er2q7db",
      "createdAt": "2026-01-05T12:30:00.000Z",
      "updatedAt": "2026-01-05T12:30:00.000Z",
      "confidenceScore": 85,
      "amountScore": 100,
      "dateProximityScore": 80,
      "referenceScore": 70,
      "vendorScore": 90,
      "evidenceId": "evi_wftz74gw44j67068dw6p385yw4",
      "transactionId": "txn_bzgajatt3ntn04w99njrzdm9ps",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "ist_r5pq5mh5e518ntb9h1gybeky5p",
      "createdAt": "2026-01-08T12:30:00.000Z",
      "updatedAt": "2026-01-08T12:30:00.000Z",
      "confidenceScore": 85,
      "amountScore": 100,
      "dateProximityScore": 80,
      "referenceScore": 70,
      "vendorScore": 90,
      "evidenceId": "evi_5zqv1bt2fkfj99xajx8qgwdpax",
      "transactionId": "txn_e8y1s8nf5xjcj70epwvy0g7zem",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    }
  ],
  "company": [
    {
      "authorisationReferences": [
        {
          "internalReferenceId": "conn_01k65c324keshspebagxy5dwy5",
          "fspAdapter": "GOCARDLESS_DEMO_DATA",
          "institutionId": "REVOLUT_REVOLT21",
          "externalReferenceId": "27a1d0ae-02bf-459d-9e75-e4b6ec458ef9"
        },
        {
          "internalReferenceId": "conn_01k6bbe6nrfvhrjkxwpmrmbwq6",
          "fspAdapter": "GOCARDLESS_DEMO_DATA",
          "institutionId": "HSBC_NET_HSBCIE2D",
          "externalReferenceId": "11111111-2222-3333-4444-555555555555"
        },
        {
          "internalReferenceId": "conn_01k6bef5yafvq949t2gk14wf0s",
          "externalReferenceId": "79a1d0b2-ebfc-4365-ab17-bd3c56aa64e6",
          "fspAdapter": "YAPILY",
          "institutionId": "aibbusiness",
          "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
        },
        {
          "internalReferenceId": "conn_01k6befzm7fvq949tdz29gnm4x",
          "externalReferenceId": "0b905d6f-6abc-4d76-82aa-a758a472a907",
          "fspAdapter": "YAPILY",
          "institutionId": "wise-live",
          "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
        },
        {
          "internalReferenceId": "conn_01k6beggm0fvq949tp5t9x4wmy",
          "externalReferenceId": "292fdd73-0f7c-470c-9ffb-dd647b6b53f6",
          "fspAdapter": "YAPILY",
          "institutionId": "permanent-tsb",
          "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
        },
        {
          "internalReferenceId": "conn_01k6beh9mzfvq949tz540vjv00",
          "externalReferenceId": "a2252609-aa40-4a6e-adf4-3075f73a5153",
          "fspAdapter": "YAPILY",
          "institutionId": "ing",
          "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
        },
        {
          "internalReferenceId": "conn_01k6behc6hfvq949v7b5j7xs4b",
          "externalReferenceId": "627fb60a-b00e-4295-aea0-7fa9e5686ada",
          "fspAdapter": "YAPILY",
          "institutionId": "hsbccorporate_eu",
          "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
        },
        {
          "internalReferenceId": "conn_01k6bf9sbze06ahjehh3fqeqbf",
          "externalReferenceId": "6e823814-9733-4178-8399-293bfdfe2d22",
          "fspAdapter": "YAPILY",
          "institutionId": "permanent-tsb",
          "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
        },
        {
          "internalReferenceId": "conn_01k6bft31xe8gbpwwcs025mc5z",
          "externalReferenceId": "eae1d334-7a66-4adf-87a0-2df191571632",
          "fspAdapter": "YAPILY",
          "institutionId": "ing",
          "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
        },
        {
          "internalReferenceId": "conn_01k6bh8g7keh5vq8wcj2574r9n",
          "externalReferenceId": "3a4a4df9-60ca-461d-b359-495f8a777cc1",
          "fspAdapter": "YAPILY",
          "institutionId": "permanent-tsb",
          "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
        }
      ],
      "id": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "createdAt": "2025-08-05T22:24:46.014Z",
      "updatedAt": "2025-09-29T21:05:11.929Z",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "legalEntity": {
        "name": "Acme Tech Ltd",
        "type": "LTD - Private Company Limited by Shares",
        "country": "GB",
        "registrationNo": "14523897"
      },
      "registeredAddress": {
        "street": "45 Innovation Way",
        "city": "London",
        "county": "Greater London",
        "postalCode": "EC2A 4NE",
        "country": "United Kingdom"
      }
    }
  ],
  "vendor": [
    {
      "id": "ven_01k65c3x5jeshsphn7n8w9g1h0",
      "createdAt": "2025-09-27T11:39:50.957Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "Cursor",
      "description": "AI-powered IDE (Integrated Development Environment) subscription service for developers.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://cursor.sh",
      "logo": "https://www.google.com/s2/favicons?domain=cursor.sh&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65c3x27eshsphmv20gzbhw9",
      "createdAt": "2025-09-27T11:39:50.854Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "Coffee Angel",
      "description": "Coffee shop that provides beverages and refreshments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://coffeeangel.com",
      "logo": "https://www.google.com/s2/favicons?domain=coffeeangel.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc7b4s08k94h"
    },
    {
      "id": "ven_01k65c3x01eshsphmk5k2axdrt",
      "createdAt": "2025-09-27T11:39:50.784Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "Jonas Novak",
      "description": "Contractor providing services to the business with invoice reference 2025-00003.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc70gm9hyfkj"
    },
    {
      "id": "ven_01k65c3wzqeshsphmc1epbt5m1",
      "createdAt": "2025-09-27T11:39:50.775Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "Manu Mahajan",
      "description": "Internal currency exchanges between different currency accounts within the company.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vzfqfbnc93rmq5argt"
    },
    {
      "id": "ven_01k65c3wzdeshsphm46adfgbg7",
      "createdAt": "2025-09-27T11:39:50.765Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "Pembroke Hall",
      "description": "Property management or real estate company that provides services to the business.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://pembrokehall.ie",
      "logo": "https://www.google.com/s2/favicons?domain=pembrokehall.ie&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc5npxt1ag4k"
    },
    {
      "id": "ven_01k65c4g42eshsphpk5p8hryxp",
      "createdAt": "2025-09-27T11:40:10.370Z",
      "updatedAt": "2025-09-27T11:40:34.380Z",
      "name": "Shaka Poke",
      "description": "Hawaiian poke bowl restaurant that uses Square payment processing",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.shakapoke.ie",
      "logo": "https://www.google.com/s2/favicons?domain=www.shakapoke.ie&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65c4g5weshsphq7y8rf4z8z",
      "createdAt": "2025-09-27T11:40:10.426Z",
      "updatedAt": "2025-09-27T11:40:34.380Z",
      "name": "The Pig And Heifer",
      "description": "Deli or restaurant in Dublin offering food services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.pigandheifer.ie",
      "logo": "https://www.google.com/s2/favicons?domain=www.pigandheifer.ie&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65c4g1aeshsphp662hfbd17",
      "createdAt": "2025-09-27T11:40:10.281Z",
      "updatedAt": "2025-09-27T11:40:34.380Z",
      "name": "Amba",
      "description": "Restaurant or food service provider that uses Square payment processing",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.amba.ie",
      "logo": "https://www.google.com/s2/favicons?domain=www.amba.ie&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65c4g32eshsphp8z5k4nrvg",
      "createdAt": "2025-09-27T11:40:10.335Z",
      "updatedAt": "2025-09-27T11:40:34.380Z",
      "name": "Spar",
      "description": "Convenience store chain with location on Baggot Street",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.spar.ie",
      "logo": "https://www.google.com/s2/favicons?domain=www.spar.ie&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc5z91f605yh"
    },
    {
      "id": "ven_01k65c4g53eshsphprhxzbraqp",
      "createdAt": "2025-09-27T11:40:10.403Z",
      "updatedAt": "2025-09-27T11:40:34.380Z",
      "name": "Revenue Commissioners",
      "description": "Irish government tax authority responsible for collecting taxes and duties",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": "https://www.revenue.ie",
      "logo": "https://www.google.com/s2/favicons?domain=www.revenue.ie&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vzfqfbnc7xsxbf7xfj"
    },
    {
      "id": "ven_01k65c5wfmeshsphxg0s376ywm",
      "createdAt": "2025-09-27T11:40:55.796Z",
      "updatedAt": "2025-09-27T11:41:11.941Z",
      "name": "Reflect Software",
      "description": "Reflect Software is a productivity software company that provides note-taking and knowledge management tools.",
      "longDescription": "Reflect Software Inc. develops note-taking and knowledge management software designed to help individuals and teams organize their thoughts, manage information, and improve productivity. Their main product, Reflect, is a connected note-taking app that helps users build a personal knowledge base through networked thinking. The platform emphasizes speed, simplicity, and powerful linking capabilities to connect ideas and information.",
      "email": null,
      "country": null,
      "website": "https://reflect.app",
      "logo": "https://www.google.com/s2/favicons?domain=reflect.app&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65c5wjeeshsphy7nnkfq48b",
      "createdAt": "2025-09-27T11:40:55.885Z",
      "updatedAt": "2025-09-27T11:41:11.941Z",
      "name": "Google Play",
      "description": "Google Play is Google's digital distribution service for mobile apps, games, books, and other digital content.",
      "longDescription": "Google Play, formerly known as the Android Market, is a digital distribution service operated and developed by Google. It serves as the official app store for certified devices running on the Android operating system and Chrome OS, allowing users to browse and download applications developed with the Android software development kit (SDK). Google Play also serves as a digital media store, offering music, books, movies, and television programs. The service provides both free and paid applications and content, with purchases typically processed through the Google payments system.",
      "email": null,
      "country": null,
      "website": "https://play.google.com",
      "logo": "https://www.google.com/s2/favicons?domain=play.google.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65c5wheeshsphxs0k63554k",
      "createdAt": "2025-09-27T11:40:55.854Z",
      "updatedAt": "2025-09-27T11:41:02.771Z",
      "name": "Zakura",
      "description": "Zakura is a restaurant in Ireland specializing in Asian cuisine.",
      "longDescription": "Zakura is a popular restaurant in Ireland that specializes in Asian cuisine, particularly Japanese food. They offer a variety of dishes including sushi, noodles, and other Asian specialties in a contemporary dining environment. The restaurant has gained popularity for its quality food and service, catering to both casual dining and takeaway customers across multiple locations in Ireland.",
      "email": null,
      "country": null,
      "website": "https://zakura.ie",
      "logo": "https://www.google.com/s2/favicons?domain=zakura.ie&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65c5wkheshsphyb0230evrk",
      "createdAt": "2025-09-27T11:40:55.913Z",
      "updatedAt": "2025-09-27T11:41:02.771Z",
      "name": "Upwork",
      "description": "Upwork is a global freelancing platform where businesses and independent professionals connect and collaborate remotely.",
      "longDescription": "Upwork, formerly Elance-oDesk, is a global freelancing platform where businesses and independent professionals connect and collaborate remotely. Founded in 2015, Upwork enables businesses to interview, hire, and work with freelancers and agencies through its platform. The service hosts a wide range of talent categories including web and mobile development, design, writing, sales and marketing, customer support, and administrative services. Upwork handles all aspects of the client-freelancer relationship, from contracts to payments, providing escrow services and dispute resolution. The platform charges fees based on the total amount billed to clients.",
      "email": null,
      "country": null,
      "website": "https://www.upwork.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.upwork.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc70gm9hyfkj"
    },
    {
      "id": "ven_01k65c5wd4eshsphxfd9s33j9t",
      "createdAt": "2025-09-27T11:40:55.712Z",
      "updatedAt": "2025-09-27T11:41:11.941Z",
      "name": "GitHub",
      "description": "GitHub is a web-based platform for version control and collaboration that allows developers to store, manage, and track changes to their code.",
      "longDescription": "GitHub is a code hosting platform for version control and collaboration. It lets developers work together on projects from anywhere. Founded in 2008 and acquired by Microsoft in 2018, GitHub provides hosting for software development and version control using Git. It offers the distributed version control and source code management functionality of Git, plus its own features like access control, bug tracking, feature requests, task management, continuous integration, and wikis for every project. GitHub is widely used by individual developers, open source projects, and businesses of all sizes.",
      "email": null,
      "country": null,
      "website": "https://github.com",
      "logo": "https://www.google.com/s2/favicons?domain=github.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65c6zc1eshspj0mxd2vh6zx",
      "createdAt": "2025-09-27T11:41:31.521Z",
      "updatedAt": "2025-09-27T11:41:55.817Z",
      "name": "Linear",
      "description": "Project management and issue tracking software for modern software development teams.",
      "longDescription": "Linear is a streamlined issue tracking and project management tool designed specifically for high-performance software development teams. The platform offers a clean, intuitive interface with powerful keyboard shortcuts, real-time updates, and automation features to help teams manage projects efficiently. Linear helps development teams track bugs, plan sprints, manage product roadmaps, and coordinate work across engineering organizations. Its design philosophy focuses on speed and efficiency, making it popular among startups and technology companies looking to streamline their development workflows.",
      "email": null,
      "country": null,
      "website": "https://linear.app",
      "logo": "https://www.google.com/s2/favicons?domain=linear.app&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65c6zc5eshspj0rxb4j151x",
      "createdAt": "2025-09-27T11:41:31.525Z",
      "updatedAt": "2025-09-27T11:41:55.817Z",
      "name": "Sophie Laurent",
      "description": "Individual recipient of bank transfer payments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc70gm9hyfkj"
    },
    {
      "id": "ven_01k65c6wwxeshsphzxcq02kz6y",
      "createdAt": "2025-09-27T11:41:28.988Z",
      "updatedAt": "2025-09-27T11:41:55.817Z",
      "name": "DocuSign",
      "description": "Electronic signature and digital transaction management service provider.",
      "longDescription": "DocuSign is a global leader in electronic signature technology and digital transaction management services. It enables businesses and individuals to sign, send and manage documents electronically in an easy, efficient, and secure manner. The platform offers a wide range of solutions including eSignature, CLM (Contract Lifecycle Management), and identity verification services. DocuSign eliminates the need for paper-based processes, accelerating business transactions while maintaining compliance with various regulatory requirements.",
      "email": null,
      "country": null,
      "website": "https://www.docusign.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.docusign.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65c6zb1eshspj0854px1k2v",
      "createdAt": "2025-09-27T11:41:31.488Z",
      "updatedAt": "2025-09-27T11:41:55.817Z",
      "name": "Denis Breen & Co",
      "description": "Irish accounting and financial advisory firm providing professional services.",
      "longDescription": "Denis Breen & Co Ltd is an accounting practice based in Ireland offering a range of professional financial services including accounting, audit, tax planning, business advisory, and compliance services. The firm works with businesses of various sizes, from startups to established companies, providing expertise in financial management, regulatory compliance, and business growth strategies. They help clients navigate complex financial regulations and optimize their tax positions while ensuring compliance with Irish tax laws and accounting standards.",
      "email": null,
      "country": "IE",
      "website": "https://www.denisbreen.ie",
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc6c079de8y4"
    },
    {
      "id": "ven_01k65c6wy4eshspj04w7g0ffft",
      "createdAt": "2025-09-27T11:41:29.028Z",
      "updatedAt": "2025-09-27T11:41:55.817Z",
      "name": "Modulr Finance",
      "description": "Financial technology company providing payment and digital banking solutions.",
      "longDescription": "Modulr Finance is a payments as a service platform that provides businesses with a digital alternative to traditional banking. They offer services such as payment processing, digital account issuance, and API-driven financial infrastructure. Modulr specializes in automating payment flows, managing digital money and enabling businesses to build innovative financial products. They are regulated as an Electronic Money Institution and serve various industries including financial services, travel, accounting, and more.",
      "email": null,
      "country": "NL",
      "website": "https://www.modulrfinance.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.modulrfinance.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc6j8ndjvetp"
    },
    {
      "id": "ven_01k65c9ynmeshspjjhrjb91rve",
      "createdAt": "2025-09-27T11:43:09.107Z",
      "updatedAt": "2025-09-27T11:43:16.366Z",
      "name": "Jarek's Kitchen",
      "description": "A food establishment providing meal services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cax6ceshspjngxatk00nd",
      "createdAt": "2025-09-27T11:43:40.364Z",
      "updatedAt": "2025-09-27T11:44:02.161Z",
      "name": "Wispr",
      "description": "Software or subscription service provider",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cax3veshspjmhphswafsq",
      "createdAt": "2025-09-27T11:43:40.279Z",
      "updatedAt": "2025-09-27T11:44:02.161Z",
      "name": "Paddle",
      "description": "Online payment processing platform for software and digital products",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://paddle.com",
      "logo": "https://www.google.com/s2/favicons?domain=paddle.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cax4veshspjmy8ae028r6",
      "createdAt": "2025-09-27T11:43:40.315Z",
      "updatedAt": "2025-09-27T11:44:02.161Z",
      "name": "Kandji",
      "description": "Mobile device management (MDM) platform for Apple devices",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://kandji.io",
      "logo": "https://www.google.com/s2/favicons?domain=kandji.io&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cax5aeshspjn0tkppm3b4",
      "createdAt": "2025-09-27T11:43:40.330Z",
      "updatedAt": "2025-09-27T11:44:02.161Z",
      "name": "Tula Mexican Grill",
      "description": "Mexican restaurant offering food services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cax69eshspjn90xv3cz0y",
      "createdAt": "2025-09-27T11:43:40.361Z",
      "updatedAt": "2025-09-27T11:44:02.161Z",
      "name": "Irish Rail",
      "description": "Ireland's national railway service provider",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.irishrail.ie",
      "logo": "https://www.google.com/s2/favicons?domain=www.irishrail.ie&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k65c7zrteshspj73enyj46qt",
      "createdAt": "2025-09-27T11:42:04.698Z",
      "updatedAt": "2025-09-27T11:42:10.394Z",
      "name": "Eoin Kelleher",
      "description": "Employee of RUCHI RESTAURANT LIMITED receiving regular payroll payments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k65c7zs6eshspj7aqq6j2203",
      "createdAt": "2025-09-27T11:42:04.710Z",
      "updatedAt": "2025-09-27T11:42:10.394Z",
      "name": "Leonie Schaffer",
      "description": "Employee of RUCHI RESTAURANT LIMITED receiving regular payroll payments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k65c7zsbeshspj7jp8q6rygp",
      "createdAt": "2025-09-27T11:42:04.715Z",
      "updatedAt": "2025-09-27T11:42:10.394Z",
      "name": "Luca Moretti",
      "description": "Employee of RUCHI RESTAURANT LIMITED receiving regular payroll payments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k65c7zsseshspj86qckgs7na",
      "createdAt": "2025-09-27T11:42:04.729Z",
      "updatedAt": "2025-09-27T11:42:10.394Z",
      "name": "Sophie Laurent",
      "description": "Employee of RUCHI RESTAURANT LIMITED receiving regular payroll payments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k65c8mtweshspj9z7hdr9t0r",
      "createdAt": "2025-09-27T11:42:26.268Z",
      "updatedAt": "2025-09-27T11:42:48.683Z",
      "name": "Aditi Gupta",
      "description": "Employee of RUCHI RESTAURANT LIMITED receiving regular payroll payments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k65c8mtteshspj9hmeqmzmdw",
      "createdAt": "2025-09-27T11:42:26.266Z",
      "updatedAt": "2025-09-27T11:42:48.683Z",
      "name": "Hugo Weber",
      "description": "Employee of RUCHI RESTAURANT LIMITED receiving regular payroll payments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k65c8mtceshspj98ga0ebagk",
      "createdAt": "2025-09-27T11:42:26.251Z",
      "updatedAt": "2025-09-27T11:42:48.683Z",
      "name": "Emma Fitzgerald",
      "description": "Employee of RUCHI RESTAURANT LIMITED receiving regular payroll payments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k65c8mvseshspja4gsxz03at",
      "createdAt": "2025-09-27T11:42:26.297Z",
      "updatedAt": "2025-09-27T11:42:48.683Z",
      "name": "Revolut",
      "description": "Financial technology company offering banking services including business accounts with subscription plans.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.revolut.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.revolut.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc6j8ndjvetp"
    },
    {
      "id": "ven_01k65c8mw3eshspjaesn0nt38r",
      "createdAt": "2025-09-27T11:42:26.302Z",
      "updatedAt": "2025-09-27T11:42:48.683Z",
      "name": "Expenses App",
      "description": "Software service for tracking and managing business expenses.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65c9pxpeshspjghv7zy63at",
      "createdAt": "2025-09-27T11:43:01.174Z",
      "updatedAt": "2025-09-27T11:43:16.366Z",
      "name": "1Password",
      "description": "Password management and secure digital vault software service",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://1password.com",
      "logo": "https://www.google.com/s2/favicons?domain=1password.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65c9pxveshspjgx3rn20feh",
      "createdAt": "2025-09-27T11:43:01.179Z",
      "updatedAt": "2025-09-27T11:43:16.366Z",
      "name": "Burger Cartel",
      "description": "Fast food restaurant specializing in burgers",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65c9pzaeshspjhkemvf76tx",
      "createdAt": "2025-09-27T11:43:01.226Z",
      "updatedAt": "2025-09-27T11:43:16.366Z",
      "name": "Seoul Kitchen",
      "description": "Korean restaurant or food establishment processing payments through Square",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65c9pz7eshspjhbnt16ttyt",
      "createdAt": "2025-09-27T11:43:01.218Z",
      "updatedAt": "2025-09-27T11:43:25.275Z",
      "name": "Remote Europe Holding BV",
      "description": "Global HR solution provider for international payroll, benefits, and compliance services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://remote.com",
      "logo": "https://www.google.com/s2/favicons?domain=remote.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k65c7zspeshspj7tfmtn8s05",
      "createdAt": "2025-09-27T11:42:04.726Z",
      "updatedAt": "2025-09-29T15:31:27.996Z",
      "name": "Cormac Byrne",
      "description": "Employee of RUCHI RESTAURANT LIMITED receiving regular payroll payments.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc70gm9hyfkj"
    },
    {
      "id": "ven_01k65cc0nfeshspjvyrnxdehzf",
      "createdAt": "2025-09-27T11:44:16.687Z",
      "updatedAt": "2025-09-27T11:44:24.931Z",
      "name": "OpenAI",
      "description": "AI research and deployment company providing ChatGPT subscription services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://openai.com",
      "logo": "https://www.google.com/s2/favicons?domain=openai.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cc0y2eshspjwh0d2fxb76",
      "createdAt": "2025-09-27T11:44:16.959Z",
      "updatedAt": "2025-09-27T11:44:24.931Z",
      "name": "Anthropic",
      "description": "AI safety company providing Claude AI assistant services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.anthropic.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.anthropic.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cc0x5eshspjwbxzrhs5dn",
      "createdAt": "2025-09-27T11:44:16.933Z",
      "updatedAt": "2025-09-27T11:44:24.931Z",
      "name": "Delhi2Dublin",
      "description": "Music group or event service provider",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k65cc0wqeshspjw4xx9d2f8x",
      "createdAt": "2025-09-27T11:44:16.919Z",
      "updatedAt": "2025-09-27T11:44:24.931Z",
      "name": "Companies Registration Office",
      "description": "Irish government agency responsible for business registrations and filings",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": "https://www.cro.ie",
      "logo": "https://cro.ie/wp-content/uploads/2024/03/CROlogo-2.svg",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vzfqfbnc7xsxbf7xfj"
    },
    {
      "id": "ven_01k65cc0yxeshspjws0xeeqa1k",
      "createdAt": "2025-09-27T11:44:16.988Z",
      "updatedAt": "2025-09-27T11:44:24.931Z",
      "name": "Finom",
      "description": "Financial services platform for businesses offering banking and accounting solutions",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://finom.co",
      "logo": "https://www.google.com/s2/favicons?domain=finom.co&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc6j8ndjvetp"
    },
    {
      "id": "ven_01k65cd5gseshspjyrwgx4ccwg",
      "createdAt": "2025-09-27T11:44:54.425Z",
      "updatedAt": "2025-09-27T11:45:18.837Z",
      "name": "Tang",
      "description": "Restaurant located on Cumberland Place.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cd5k6eshspjzd728cagsr",
      "createdAt": "2025-09-27T11:44:54.497Z",
      "updatedAt": "2025-09-27T11:45:18.837Z",
      "name": "GoCardless",
      "description": "Online payment processing service specializing in direct debit solutions.",
      "longDescription": "GoCardless is a global payments company that helps businesses collect recurring and one-off payments through various direct debit schemes. Founded in 2011, the platform simplifies the collection process for businesses of all sizes. GoCardless offers solutions for invoice payments, subscription billing, and installment payments, with integrations to major accounting and billing software.",
      "email": null,
      "country": null,
      "website": "https://gocardless.com",
      "logo": "https://www.google.com/s2/favicons?domain=gocardless.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc6j8ndjvetp"
    },
    {
      "id": "ven_01k65cd5j1eshspjz017vq1wgn",
      "createdAt": "2025-09-27T11:44:54.459Z",
      "updatedAt": "2025-09-27T11:47:00.120Z",
      "name": "Claude.ai",
      "description": "AI assistant and large language model service by Anthropic.",
      "longDescription": "Claude.ai is an AI assistant created by Anthropic, offering conversational AI capabilities through a large language model. The service provides both free and subscription tiers for users, with the paid subscription offering expanded capabilities, higher usage limits, and priority access to new features. Claude is known for its helpful, harmless, and honest approach to AI interactions.",
      "email": null,
      "country": null,
      "website": "https://claude.ai",
      "logo": "https://www.google.com/s2/favicons?domain=claude.ai&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cd5mceshspjzn83y9tqy1",
      "createdAt": "2025-09-27T11:44:54.535Z",
      "updatedAt": "2025-09-27T11:47:00.120Z",
      "name": "Superhuman",
      "description": "Premium email client designed for speed and productivity.",
      "longDescription": "Superhuman is a premium email client that promises the fastest email experience ever made. Founded by Rahul Vohra, the service is designed for professionals who spend hours daily in their inbox. It offers features like keyboard shortcuts, AI-powered triage, undo send, insights from social networks, follow-up reminders, and scheduled messages. Superhuman is known for its minimalist design and focus on speed and productivity.",
      "email": null,
      "country": null,
      "website": "https://superhuman.com",
      "logo": "https://www.google.com/s2/favicons?domain=superhuman.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cd5gjeshspjygqrrg6sk5",
      "createdAt": "2025-09-27T11:44:54.412Z",
      "updatedAt": "2025-09-27T11:47:15.654Z",
      "name": "Financial Times",
      "description": "British daily newspaper focusing on business and economic news.",
      "longDescription": "The Financial Times is an international daily newspaper printed in broadsheet and published digitally. It focuses on business and economic current affairs. Founded in 1888, the Financial Times has been owned by the Japanese holding company Nikkei since 2015. The newspaper offers comprehensive coverage of global business news, financial markets, economic analysis, and comment.",
      "email": null,
      "country": null,
      "website": "https://www.ft.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.ft.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65ceerteshspk5wmka0h0ee",
      "createdAt": "2025-09-27T11:45:36.665Z",
      "updatedAt": "2025-09-27T11:47:06.968Z",
      "name": "Tavily AI",
      "description": "AI-powered search API provider for developers and businesses.",
      "longDescription": "Tavily AI offers a specialized search API that uses artificial intelligence to provide relevant search results for developers and applications. Their service allows businesses to integrate advanced search capabilities into their products without having to build the infrastructure themselves. Tavily AI focuses on delivering contextually relevant search results with high accuracy and speed.",
      "email": null,
      "country": null,
      "website": "https://tavily.com",
      "logo": "https://www.google.com/s2/favicons?domain=tavily.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cgt8yeshspk60ezf5bsne",
      "createdAt": "2025-09-27T11:46:53.977Z",
      "updatedAt": "2025-09-27T11:47:06.968Z",
      "name": "XAI",
      "description": "AI research company focused on explainable artificial intelligence solutions.",
      "longDescription": "XAI (Explainable AI) LLC develops artificial intelligence tools and platforms with a focus on making AI systems more transparent and understandable. Their products help businesses implement AI solutions that can be trusted and explained, addressing the 'black box' problem often associated with complex machine learning models. They offer APIs and services for developers to integrate explainable AI capabilities into their applications.",
      "email": null,
      "country": null,
      "website": "https://xai.org",
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cgtb9eshspk6e4wt4npvh",
      "createdAt": "2025-09-27T11:46:54.057Z",
      "updatedAt": "2025-09-27T11:47:06.968Z",
      "name": "Slack",
      "description": "Business communication platform offering team messaging and collaboration tools.",
      "longDescription": "Slack is a channel-based messaging platform that helps businesses organize conversations, share files, and streamline workflows. The service integrates with hundreds of other business applications to create a unified workplace communication hub. Companies use Slack to reduce email, improve transparency, and foster collaboration among teams. The platform offers various pricing tiers including free, standard, plus, and enterprise grid options to accommodate businesses of different sizes and needs.",
      "email": null,
      "country": null,
      "website": "https://slack.com",
      "logo": "https://www.google.com/s2/favicons?domain=slack.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cjdqxeshspk9wb8f7c72r",
      "createdAt": "2025-09-27T11:47:46.685Z",
      "updatedAt": "2025-09-27T11:48:10.661Z",
      "name": "LinkedIn",
      "description": "Professional networking platform offering recruitment services and premium business features.",
      "longDescription": "LinkedIn is a professional networking platform that allows businesses to connect with industry professionals, recruit talent, and market their products/services. Their premium services include LinkedIn Recruiter for hiring teams, Sales Navigator for sales professionals, and various advertising solutions. The platform hosts over 700 million professionals worldwide and serves as both a recruitment tool and a business-to-business marketing channel.",
      "email": null,
      "country": null,
      "website": "https://www.linkedin.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.linkedin.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc4kbv22w5yd"
    },
    {
      "id": "ven_01k65cjdn2eshspk97jdcm57ef",
      "createdAt": "2025-09-27T11:47:46.594Z",
      "updatedAt": "2025-09-27T11:48:10.661Z",
      "name": "Sentry",
      "description": "Error monitoring and application performance management platform.",
      "longDescription": "Sentry is a developer-first error tracking and performance monitoring platform that helps developers see what matters, solve quicker, and learn continuously about their applications. It provides real-time error tracking, giving development teams the tools needed to monitor and fix crashes in real time. Sentry is used by many Fortune 500 companies and is designed to be both powerful and easy to use.",
      "email": null,
      "country": null,
      "website": "https://sentry.io",
      "logo": "https://www.google.com/s2/favicons?domain=sentry.io&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65ckh2aeshspkg92jdy8vh4",
      "createdAt": "2025-09-27T11:48:22.844Z",
      "updatedAt": "2025-09-27T11:48:30.292Z",
      "name": "Zapier",
      "description": "Automation tool that connects apps and services to automate workflows and tasks.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://zapier.com",
      "logo": "https://www.google.com/s2/favicons?domain=zapier.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65ckh2yeshspkgyzwx8hqrq",
      "createdAt": "2025-09-27T11:48:22.878Z",
      "updatedAt": "2025-09-27T11:48:30.292Z",
      "name": "Mak Slim Foods",
      "description": "Food vendor providing meal services.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65ckh3deshspkhegxj7z9nq",
      "createdAt": "2025-09-27T11:48:22.892Z",
      "updatedAt": "2025-09-27T11:48:30.292Z",
      "name": "Naomi's Kitchen",
      "description": "Food service or catering company providing meal services.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65ckh31eshspkh23ahabkmn",
      "createdAt": "2025-09-27T11:48:22.881Z",
      "updatedAt": "2025-09-27T11:48:30.292Z",
      "name": "Pinecone Coffee",
      "description": "Coffee shop that processes payments through Square.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65ckh2teshspkgqd9jk5vg8",
      "createdAt": "2025-09-27T11:48:22.874Z",
      "updatedAt": "2025-09-27T11:48:30.292Z",
      "name": "Don Canizales",
      "description": "Individual payment recipient.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k65cmad4eshspkk8z9xs58fk",
      "createdAt": "2025-09-27T11:48:48.804Z",
      "updatedAt": "2025-09-27T11:49:10.154Z",
      "name": "Sweet Salt",
      "description": "Sweet Salt is a restaurant or food establishment offering dining services.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cmadbeshspkkgwerj0myb",
      "createdAt": "2025-09-27T11:48:48.811Z",
      "updatedAt": "2025-09-27T11:49:10.154Z",
      "name": "Suhas Falafel",
      "description": "Suhas Falafel is a food vendor specializing in falafel and potentially other Middle Eastern cuisine.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cmacweshspkk5mv2ktdq4",
      "createdAt": "2025-09-27T11:48:48.796Z",
      "updatedAt": "2025-09-27T11:49:10.154Z",
      "name": "Beanhive",
      "description": "Beanhive is a cafe or coffee shop providing food and beverage services.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cgtc5eshspk6kqa7yaywk",
      "createdAt": "2025-09-27T11:46:54.085Z",
      "updatedAt": "2025-09-27T11:47:06.968Z",
      "name": "Calendly",
      "description": "Automated scheduling software that eliminates the back-and-forth of booking meetings.",
      "longDescription": "Calendly is a scheduling automation platform that helps businesses and professionals easily schedule meetings without the back-and-forth emails. The platform allows users to share their availability preferences and lets invitees choose suitable time slots, automatically adding meetings to connected calendars. Calendly offers features like automated reminders, buffer times between meetings, round-robin scheduling for teams, and integrations with various video conferencing and productivity tools. Their pricing model includes free and premium tiers with additional features for businesses and enterprises.",
      "email": null,
      "country": null,
      "website": "https://calendly.com",
      "logo": "https://www.google.com/s2/favicons?domain=calendly.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cgtcyeshspk6y0e76tesb",
      "createdAt": "2025-09-27T11:46:54.110Z",
      "updatedAt": "2025-09-27T11:47:06.968Z",
      "name": "Notion",
      "description": "All-in-one workspace for notes, documents, wikis, projects, and team collaboration.",
      "longDescription": "Notion Labs, Inc. develops and maintains Notion, a comprehensive productivity and knowledge management platform that combines notes, documents, wikis, and project management tools into a single unified workspace. The platform allows teams to create custom workflows, organize information with databases, and collaborate seamlessly. Notion has become popular among startups and established companies alike for its flexibility and customizable structure. The company offers tiered pricing including personal, personal pro, team, and enterprise plans to accommodate different user needs and organization sizes.",
      "email": null,
      "country": null,
      "website": "https://notion.so",
      "logo": "https://www.google.com/s2/favicons?domain=notion.so&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cjdq3eshspk9qt2a4er00",
      "createdAt": "2025-09-27T11:47:46.659Z",
      "updatedAt": "2025-09-27T11:48:10.661Z",
      "name": "Figma",
      "description": "Cloud-based design and prototyping tool for collaborative interface design.",
      "longDescription": "Figma is a cloud-based design platform that enables collaborative interface design. It allows multiple designers to work simultaneously on the same project, providing real-time collaboration features. Figma offers tools for UI/UX design, prototyping, and design systems management, all within a web browser. Its collaborative approach has made it popular among design teams looking to streamline their workflows and improve communication between designers and developers.",
      "email": null,
      "country": null,
      "website": "https://www.figma.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.figma.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cjdp6eshspk9a3b1e6677",
      "createdAt": "2025-09-27T11:47:46.630Z",
      "updatedAt": "2025-09-27T11:48:10.661Z",
      "name": "Retool",
      "description": "Low-code platform for building internal tools and business applications.",
      "longDescription": "Retool is a development platform that helps businesses quickly build internal tools and custom applications with less code. It provides a library of pre-built UI components that can be combined with custom code and integrated with various data sources. Companies use Retool to build dashboards, admin panels, CRUD apps, and other internal tools much faster than building from scratch.",
      "email": null,
      "country": null,
      "website": "https://retool.com",
      "logo": "https://www.google.com/s2/favicons?domain=retool.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cjdrteshspka3qwhrnts0",
      "createdAt": "2025-09-27T11:47:46.713Z",
      "updatedAt": "2025-09-27T11:48:10.661Z",
      "name": "Google Workspace",
      "description": "Suite of cloud computing, productivity and collaboration tools for businesses.",
      "longDescription": "Google Workspace (formerly G Suite) is a collection of cloud computing, productivity and collaboration tools developed by Google. It includes Gmail for business email, Google Drive for cloud storage, Google Docs, Sheets and Slides for document creation and collaboration, Google Meet for video conferencing, and many other apps designed for business use. The service offers various subscription plans for businesses of different sizes, with features like custom business email, increased storage, advanced security controls, and administrative tools.",
      "email": null,
      "country": null,
      "website": "https://workspace.google.com",
      "logo": "https://www.google.com/s2/favicons?domain=workspace.google.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65cp0wweshspkzqgyrcgqe7",
      "createdAt": "2025-09-27T11:49:44.602Z",
      "updatedAt": "2025-09-27T11:49:50.071Z",
      "name": "Hotpot",
      "description": "A restaurant specializing in hotpot cuisine, offering communal dining where customers cook meats and vegetables in simmering broth at their table.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cp0x9eshspkzthwr7rcm3",
      "createdAt": "2025-09-27T11:49:44.616Z",
      "updatedAt": "2025-09-27T11:49:50.071Z",
      "name": "Salt Cellar Cafe",
      "description": "A cafe offering food and beverages, likely located in Ireland.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cq1m2eshspm6a6wp0a9jq",
      "createdAt": "2025-09-27T11:50:18.114Z",
      "updatedAt": "2025-09-27T11:50:26.301Z",
      "name": "A Taste of Thai",
      "description": "A Thai restaurant in Ireland serving authentic Thai cuisine.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cq1pkeshspm729w29ytag",
      "createdAt": "2025-09-27T11:50:18.191Z",
      "updatedAt": "2025-09-27T11:50:26.301Z",
      "name": "The Woolshed",
      "description": "A pub or restaurant in Ireland, likely known for sports or casual dining.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.woolshedbaa.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.woolshedbaa.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cq1npeshspm6wcf3gtsdh",
      "createdAt": "2025-09-27T11:50:18.166Z",
      "updatedAt": "2025-09-27T11:50:26.301Z",
      "name": "Marquette",
      "description": "A restaurant or café establishment in Ireland.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cq1n9eshspm6hq58rwha1",
      "createdAt": "2025-09-27T11:50:18.152Z",
      "updatedAt": "2025-09-27T11:50:26.301Z",
      "name": "Uber",
      "description": "A ride-sharing and transportation service company.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.uber.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.uber.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k65cqmzweshspm8kq27v8562",
      "createdAt": "2025-09-27T11:50:37.944Z",
      "updatedAt": "2025-09-27T11:50:58.200Z",
      "name": "Patrick Walsh",
      "description": "Independent contractor providing professional services to the company",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc70gm9hyfkj"
    },
    {
      "id": "ven_01k65cqn02eshspm8y4jy7tt7k",
      "createdAt": "2025-09-27T11:50:37.954Z",
      "updatedAt": "2025-09-27T11:50:58.200Z",
      "name": "Taxi Service",
      "description": "Local taxi transportation service",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k65crphqeshspmfftkxpt85b",
      "createdAt": "2025-09-27T11:51:12.304Z",
      "updatedAt": "2025-09-27T11:51:20.169Z",
      "name": "Pret A Manger",
      "description": "International sandwich shop chain offering freshly made food and organic coffee.",
      "longDescription": null,
      "email": null,
      "country": "UK",
      "website": "www.pret.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.pret.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65crpk3eshspmfgtm6vkpxj",
      "createdAt": "2025-09-27T11:51:12.355Z",
      "updatedAt": "2025-09-27T11:51:20.169Z",
      "name": "Bang Restaurant",
      "description": "Restaurant offering dining services, likely for business meals or client entertainment.",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": "www.bangrestaurant.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.bangrestaurant.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65crpg2eshspmf0nznfw91y",
      "createdAt": "2025-09-27T11:51:12.258Z",
      "updatedAt": "2025-09-27T11:51:20.169Z",
      "name": "Heathrow Express",
      "description": "Train service connecting London Heathrow Airport with Paddington Station in central London.",
      "longDescription": null,
      "email": null,
      "country": "UK",
      "website": "www.heathrowexpress.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.heathrowexpress.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k65crppkeshspmfw2e0m4xdm",
      "createdAt": "2025-09-27T11:51:12.455Z",
      "updatedAt": "2025-09-27T11:51:20.169Z",
      "name": "Clayton Hotel Burlington",
      "description": "Hotel providing accommodation services with refund transaction recorded.",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": "www.claytonhotelburlingtonroad.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.claytonhotelburlingtonroad.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k65cspgkeshspmp0mmzf2w0c",
      "createdAt": "2025-09-27T11:51:45.043Z",
      "updatedAt": "2025-09-27T11:51:51.386Z",
      "name": "Tortilla Latin Food",
      "description": "Tortilla Latin Food is a restaurant or food vendor that specializes in Latin American cuisine.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cspj5eshspmpcdfterchh",
      "createdAt": "2025-09-27T11:51:45.081Z",
      "updatedAt": "2025-09-27T11:51:51.386Z",
      "name": "Attio",
      "description": "Attio is a B2B SaaS company that provides customer relationship management (CRM) solutions.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://attio.com",
      "logo": "https://www.google.com/s2/favicons?domain=attio.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_01k65ctpd8eshspmwjjpzayxx2",
      "createdAt": "2025-09-27T11:52:17.704Z",
      "updatedAt": "2025-09-27T11:52:26.579Z",
      "name": "Cafe And Noodle",
      "description": "A cafe and restaurant specializing in noodle dishes and casual dining.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65ctpfaeshspmwtrg2tk9zk",
      "createdAt": "2025-09-27T11:52:17.770Z",
      "updatedAt": "2025-09-27T11:52:26.579Z",
      "name": "Giftmall.es",
      "description": "An online gift retailer based in Spain that offers various gift items and merchandise.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://giftmall.es",
      "logo": "https://www.google.com/s2/favicons?domain=giftmall.es&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc5z91f605yh"
    },
    {
      "id": "ven_01k65ctphbeshspmx6q13ktd74",
      "createdAt": "2025-09-27T11:52:17.828Z",
      "updatedAt": "2025-09-27T11:52:26.579Z",
      "name": "Ryanair",
      "description": "A low-cost Irish airline that provides domestic and international flight services.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.ryanair.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.ryanair.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k65cvstpeshspn39955xdf4m",
      "createdAt": "2025-09-27T11:52:53.973Z",
      "updatedAt": "2025-09-27T11:52:58.773Z",
      "name": "Company Formations International",
      "description": "Company formation and registration service provider in Ireland",
      "longDescription": "Company Formations International Limited provides company registration services, including company incorporation, registered office services, and other corporate compliance services in Ireland. They help businesses establish their legal entities and comply with Irish company law requirements.",
      "email": null,
      "country": "IE",
      "website": "https://www.companyformations.ie",
      "logo": "https://www.google.com/s2/favicons?domain=www.companyformations.ie&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc65nns560jv"
    },
    {
      "id": "ven_01k65cwwc3eshspn9n53st1zft",
      "createdAt": "2025-09-27T11:53:29.341Z",
      "updatedAt": "2025-09-27T11:53:35.916Z",
      "name": "Veremark",
      "description": "Veremark is a background checking and verification platform for businesses.",
      "longDescription": "Veremark provides background screening and verification services for businesses hiring new employees. They offer a digital platform that helps companies verify employment history, education, professional qualifications, and other credentials of potential hires. Their service helps reduce hiring risks and improve compliance with employment regulations.",
      "email": null,
      "country": null,
      "website": "https://www.veremark.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.veremark.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc65nns560jv"
    },
    {
      "id": "ven_01k65cwwcgeshspn9xska0mg5b",
      "createdAt": "2025-09-27T11:53:29.359Z",
      "updatedAt": "2025-09-27T11:53:35.916Z",
      "name": "Dracula's Kitchen",
      "description": "Dracula's Kitchen is a restaurant or food service establishment in Ireland.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cwwcneshspna4jnfvyh0c",
      "createdAt": "2025-09-27T11:53:29.365Z",
      "updatedAt": "2025-09-27T11:53:35.916Z",
      "name": "Mama's Boy",
      "description": "Mama's Boy is a food vendor or restaurant that processes payments through Square.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cwwdneshspna9pr7b1tc2",
      "createdAt": "2025-09-27T11:53:29.396Z",
      "updatedAt": "2025-09-27T11:53:35.916Z",
      "name": "An Post",
      "description": "An Post is Ireland's national postal service provider.",
      "longDescription": "An Post is the state-owned provider of postal services in Ireland. The company offers a wide range of services including mail collection and delivery, parcel services, banking services, bill payment, and retail services through its network of post offices across Ireland.",
      "email": null,
      "country": "IE",
      "website": "https://www.anpost.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.anpost.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc5z91f605yh"
    },
    {
      "id": "ven_01k65cyj0neshspngm4dw1pq8h",
      "createdAt": "2025-09-27T11:54:24.275Z",
      "updatedAt": "2025-09-27T11:54:32.835Z",
      "name": "Merrion Row Post Office",
      "description": "Local post office providing postal and related services in Dublin.",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": "https://www.anpost.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.anpost.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc5z91f605yh"
    },
    {
      "id": "ven_01k65cyj1yeshspngr1g523f6q",
      "createdAt": "2025-09-27T11:54:24.318Z",
      "updatedAt": "2025-09-27T11:54:32.835Z",
      "name": "Mamma Mia Restaurant",
      "description": "Italian restaurant offering dining services.",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k65cyj31eshspnh3qzqhcd5r",
      "createdAt": "2025-09-27T11:54:24.353Z",
      "updatedAt": "2025-09-27T11:54:32.835Z",
      "name": "FREE NOW",
      "description": "Ride-hailing and mobility service app offering taxi and private hire vehicles.",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": "https://free-now.com",
      "logo": "https://www.google.com/s2/favicons?domain=free-now.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k65cyj39eshspnh92mjbyz8s",
      "createdAt": "2025-09-27T11:54:24.361Z",
      "updatedAt": "2025-09-27T11:54:32.835Z",
      "name": "Marta Kowalska Consulting",
      "description": "Independent consultant providing professional services.",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc6sarv8xknq"
    },
    {
      "id": "ven_01k65czkfxeshspnwz7ebn2y1d",
      "createdAt": "2025-09-27T11:54:58.557Z",
      "updatedAt": "2025-09-27T11:55:05.119Z",
      "name": "Welcome to the Jungle",
      "description": "A recruitment and employer branding platform that helps companies showcase their culture and connect with talent.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.wttj.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.wttj.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc4kbv22w5yd"
    },
    {
      "id": "ven_01k65czkgjeshspnx4pqb9b6ze",
      "createdAt": "2025-09-27T11:54:58.577Z",
      "updatedAt": "2025-09-27T11:55:05.119Z",
      "name": "Muhammad Tashf",
      "description": "Individual service provider or contractor who received a small payment from the company.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc7ghb9eae2d"
    },
    {
      "id": "ven_01k65d0a24eshspnzbnpcam1v1",
      "createdAt": "2025-09-27T11:55:21.668Z",
      "updatedAt": "2025-09-27T11:55:28.038Z",
      "name": "Bank of Ireland",
      "description": "Bank of Ireland is one of Ireland's traditional banking providers offering personal, business and corporate banking services.",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": "https://www.bankofireland.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.bankofireland.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc6j8ndjvetp"
    },
    {
      "id": "ven_01k65d0a2keshspnzq7m9sbpn2",
      "createdAt": "2025-09-27T11:55:21.683Z",
      "updatedAt": "2025-09-27T11:55:28.038Z",
      "name": "Anthony Moore",
      "description": "Individual who received a small payment, likely for personal services or reimbursement.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc7b4s08k94h"
    },
    {
      "id": "ven_01k6bbf96wfvhrjn5f3jx2wta0",
      "createdAt": "2025-09-29T19:24:01.751Z",
      "updatedAt": "2025-09-29T19:24:08.337Z",
      "name": "Nest",
      "description": "UK workplace pension provider that helps companies manage employee pension contributions and compliance.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.nestpensions.org.uk",
      "logo": "https://www.google.com/s2/favicons?domain=www.nestpensions.org.uk&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k6bbf8y9fvhrjn4r1s7wh1q2",
      "createdAt": "2025-09-29T19:24:01.481Z",
      "updatedAt": "2025-09-29T19:24:08.337Z",
      "name": "Seapoint Finance Limited",
      "description": "Internal finance transfers between company accounts. This represents movement of funds within the organization's financial structure.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vzfqfbnc93rmq5argt"
    },
    {
      "id": "ven_01k6bbf94qfvhrjn51jet0pt56",
      "createdAt": "2025-09-29T19:24:01.687Z",
      "updatedAt": "2025-09-29T19:24:08.337Z",
      "name": "Yapily",
      "description": "Financial API platform providing open banking connectivity and services for businesses.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.yapily.com",
      "logo": "https://www.yapily.com/favicon.ico",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3vw8ac23hc"
    },
    {
      "id": "ven_01k6bbgd16fvhrjnbhzs3xdnpz",
      "createdAt": "2025-09-29T19:24:38.438Z",
      "updatedAt": "2025-09-29T19:25:06.385Z",
      "name": "Grow Your Boat Ltd",
      "description": "Business consulting or growth services provider specializing in business development.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc6sarv8xknq"
    },
    {
      "id": "ven_01k6bbgd2zfvhrjnc124tr3b2s",
      "createdAt": "2025-09-29T19:24:38.492Z",
      "updatedAt": "2025-09-29T19:24:45.134Z",
      "name": "Adam Rankin",
      "description": "Independent contractor providing professional services to the company.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc70gm9hyfkj"
    },
    {
      "id": "ven_01k6bbgd2bfvhrjnbz808baykh",
      "createdAt": "2025-09-29T19:24:38.475Z",
      "updatedAt": "2025-09-29T19:24:45.134Z",
      "name": "Amwins Global Risks",
      "description": "Insurance and risk management services provider specializing in global insurance solutions.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.amwins.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.amwins.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc7ghb9eae2d"
    },
    {
      "id": "ven_01k6bbhnekfvhrjnk2qd4ej2sf",
      "createdAt": "2025-09-29T19:25:19.822Z",
      "updatedAt": "2025-09-29T19:25:28.969Z",
      "name": "Aer Lingus",
      "description": "Irish airline providing flight services for business travel.",
      "longDescription": null,
      "email": null,
      "country": "IE",
      "website": "https://www.aerlingus.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.aerlingus.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k6bbhnawfvhrjnjkdggymq9f",
      "createdAt": "2025-09-29T19:25:19.684Z",
      "updatedAt": "2025-09-29T19:25:55.010Z",
      "name": "Emily Harrington",
      "description": "Individual who receives payments from the company, likely an employee or contractor.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k6bbhncmfvhrjnjwn2hxwm55",
      "createdAt": "2025-09-29T19:25:19.764Z",
      "updatedAt": "2025-09-29T19:25:55.010Z",
      "name": "Adrian Keller",
      "description": "Individual who receives payments from the company, likely an employee or contractor.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": false,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc49gmfg6y22"
    },
    {
      "id": "ven_01k6bbhng0fvhrjnk93frdx83x",
      "createdAt": "2025-09-29T19:25:19.865Z",
      "updatedAt": "2025-09-29T19:25:28.969Z",
      "name": "WealthKernel",
      "description": "Digital wealth management and investment infrastructure provider offering B2B financial services.",
      "longDescription": null,
      "email": null,
      "country": "GB",
      "website": "https://wealthkernel.com",
      "logo": "https://www.google.com/s2/favicons?domain=wealthkernel.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc65nns560jv"
    },
    {
      "id": "ven_01k6bbk6skfvhrjntfdd23av1a",
      "createdAt": "2025-09-29T19:26:10.355Z",
      "updatedAt": "2025-09-29T19:26:17.613Z",
      "name": "Ginger Bistro",
      "description": "A restaurant in Belfast offering dining services with a focus on ginger-infused cuisine and contemporary dishes.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.gingerbistrobelfast.com",
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k6bbk4gyfvhrjnsxtfs19v9b",
      "createdAt": "2025-09-29T19:26:08.029Z",
      "updatedAt": "2025-09-29T19:26:17.613Z",
      "name": "ICO",
      "description": "Information Commissioner's Office (ICO), the UK's independent authority set up to uphold information rights and data privacy for individuals and businesses.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://ico.org.uk",
      "logo": "https://www.google.com/s2/favicons?domain=ico.org.uk&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vzfqfbnc7xsxbf7xfj"
    },
    {
      "id": "ven_01k6bbk4hyfvhrjnt1zqpqqyns",
      "createdAt": "2025-09-29T19:26:08.059Z",
      "updatedAt": "2025-09-29T19:26:17.613Z",
      "name": "Clayton Hotel Belfast",
      "description": "A hotel in Belfast offering accommodation and reception services for business and leisure travelers.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://www.claytonhotelbelfast.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.claytonhotelbelfast.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k6bbmgh1fvhrjp0n7wme8cae",
      "createdAt": "2025-09-29T19:26:53.087Z",
      "updatedAt": "2025-09-29T19:27:01.975Z",
      "name": "Charles Russell Speechlys",
      "description": "A full-service law firm providing legal advice to businesses and individuals.",
      "longDescription": null,
      "email": null,
      "country": "GB",
      "website": "https://www.charlesrussellspeechlys.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.charlesrussellspeechlys.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vzfqfbnc8cetyx8vdd"
    },
    {
      "id": "ven_01k6bbmgmmfvhrjp1d532dm1jy",
      "createdAt": "2025-09-29T19:26:53.202Z",
      "updatedAt": "2025-09-29T19:27:01.975Z",
      "name": "FCB Coffee",
      "description": "Coffee shop located in Paddington, London offering beverages and light refreshments.",
      "longDescription": null,
      "email": null,
      "country": "GB",
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k6bbmgmcfvhrjp16bczghe88",
      "createdAt": "2025-09-29T19:26:53.194Z",
      "updatedAt": "2025-09-29T19:27:01.975Z",
      "name": "Deliveroo",
      "description": "Online food delivery company operating in multiple countries.",
      "longDescription": null,
      "email": null,
      "country": "GB",
      "website": "https://deliveroo.co.uk",
      "logo": "https://www.google.com/s2/favicons?domain=deliveroo.co.uk&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc4xx59bytg3"
    },
    {
      "id": "ven_01k6bbmgk7fvhrjp0v7hz9q786",
      "createdAt": "2025-09-29T19:26:53.153Z",
      "updatedAt": "2025-09-29T19:27:01.975Z",
      "name": "Transport for London",
      "description": "London's integrated transport authority, responsible for running the city's public transportation network.",
      "longDescription": null,
      "email": null,
      "country": "GB",
      "website": "https://tfl.gov.uk",
      "logo": "https://www.google.com/s2/favicons?domain=tfl.gov.uk&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vzfqfbnc8h0aw1f003"
    },
    {
      "id": "ven_01k6bbmgp9fvhrjp1ker17rwy0",
      "createdAt": "2025-09-29T19:26:53.257Z",
      "updatedAt": "2025-09-29T19:27:01.975Z",
      "name": "Argos",
      "description": "British catalogue retailer operating both in-store and online, selling a wide range of products including electronics, toys, home and garden items.",
      "longDescription": null,
      "email": null,
      "country": "GB",
      "website": "https://www.argos.co.uk",
      "logo": "https://www.google.com/s2/favicons?domain=www.argos.co.uk&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc5z91f605yh"
    },
    {
      "id": "ven_01k6bbn9m2fvhrjp2hhm5q9efq",
      "createdAt": "2025-09-29T19:27:18.786Z",
      "updatedAt": "2025-09-29T19:27:29.552Z",
      "name": "British Airways",
      "description": "British Airways is the UK's national airline providing passenger flights and cargo services.",
      "longDescription": "British Airways is the flag carrier airline of the United Kingdom, headquartered in London, England. The airline is the second largest UK-based carrier, based on fleet size and passengers carried, behind easyJet. It operates a large international scheduled airline route network, flying to destinations around the world including North America, South America, Europe, Africa, Asia and Australia. British Airways is a founding member of the Oneworld airline alliance, along with American Airlines, Cathay Pacific, and Qantas.",
      "email": null,
      "country": null,
      "website": "https://www.britishairways.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.britishairways.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k6bbnxzzfvhrjp5np8trhg47",
      "createdAt": "2025-09-29T19:27:39.608Z",
      "updatedAt": "2025-09-29T19:27:45.788Z",
      "name": "Mylands",
      "description": "Mylands is a premium paint manufacturer based in the UK, specializing in high-quality paints and finishes.",
      "longDescription": null,
      "email": null,
      "country": "UK",
      "website": "https://www.mylands.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.mylands.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vzfqfbnc83dyq7vn0b"
    },
    {
      "id": "ven_01k6bbn9p5fvhrjp2td9pd9rat",
      "createdAt": "2025-09-29T19:27:18.846Z",
      "updatedAt": "2025-09-29T19:27:29.552Z",
      "name": "Booking.com",
      "description": "Booking.com is an online travel agency for lodging reservations and other travel products.",
      "longDescription": "Booking.com is a Dutch online travel agency for lodging reservations and other travel products, and a subsidiary of Booking Holdings. It is headquartered in Amsterdam. The website lists over 28 million accommodation listings worldwide, including hotels, apartments, hostels, vacation rentals, and other unique places to stay. The site is available in 43 languages and offers over 28 million reported listings.",
      "email": null,
      "country": null,
      "website": "https://www.booking.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.booking.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k6bbn9q1fvhrjp371wrcstvr",
      "createdAt": "2025-09-29T19:27:18.881Z",
      "updatedAt": "2025-09-29T19:27:29.552Z",
      "name": "Kiwi.com",
      "description": "Kiwi.com is an online travel tech company providing flight booking and trip planning services.",
      "longDescription": "Kiwi.com is a Czech online travel tech company that allows users to combine flights from non-cooperating airlines into a single itinerary. The company was founded in 2012 and is headquartered in Brno, Czech Republic. Kiwi.com's algorithm finds combinations of flights that traditional travel agencies and search engines don't offer. The company provides a guarantee that covers flight delays, cancellations, and schedule changes, offering an alternative flight or a refund if needed.",
      "email": null,
      "country": null,
      "website": "https://www.kiwi.com",
      "logo": "https://www.google.com/s2/favicons?domain=www.kiwi.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc59pk2rkvyw"
    },
    {
      "id": "ven_01k6fm8nzsfzz9aen1pftqn9qr",
      "createdAt": "2025-10-01T11:14:40.352Z",
      "updatedAt": "2025-10-01T11:14:52.361Z",
      "name": "Captain Nemo",
      "description": "Major business partner or investor that provides significant financial transactions to Ruchi Restaurant Limited.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": null,
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "BENEFICIARY",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vzfqfbnc8yqdcazbqv"
    },
    {
      "id": "ven_01k6fpgn1yfzz9aex3cr77xa32",
      "createdAt": "2025-10-01T11:53:58.700Z",
      "updatedAt": "2025-10-01T11:54:12.534Z",
      "name": "Pembroke Hall Limited",
      "description": "Pembroke Hall Limited is an Irish business that provides commercial services to businesses in Ireland.",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://pembrokehall.ie",
      "logo": null,
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": false,
      "type": "BENEFICIARY",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc6sarv8xknq"
    },
    {
      "id": "ven_zj7v3fq41pb9h3pwx6cbzwmfx4",
      "createdAt": "2025-09-27T11:39:50.957Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "Amazon Web Services EMEA SARL",
      "description": "Cloud computing and infrastructure services provider for hosting and development.",
      "longDescription": null,
      "email": null,
      "country": "LU",
      "website": "https://aws.amazon.com",
      "logo": "https://www.google.com/s2/favicons?domain=aws.amazon.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3vw8ac23hc"
    },
    {
      "id": "ven_6m3t4s5pcz3g5997sxc586yj3f",
      "createdAt": "2025-09-27T11:39:50.957Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "Slack Technologies Limited",
      "description": "Business communication and collaboration platform subscription service.",
      "longDescription": null,
      "email": null,
      "country": "GB",
      "website": "https://slack.com",
      "logo": "https://www.google.com/s2/favicons?domain=slack.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_vnn6fxhm5daqv7bh39b88k2t9d",
      "createdAt": "2025-09-27T11:39:50.957Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "Anthropic PBC",
      "description": "AI safety company providing Claude API services for natural language processing.",
      "longDescription": null,
      "email": null,
      "country": "US",
      "website": "https://anthropic.com",
      "logo": "https://www.google.com/s2/favicons?domain=anthropic.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_1bss5kk7dqrqznncrn6c0w8y4p",
      "createdAt": "2025-09-27T11:39:50.957Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "OpenAI, LLC",
      "description": "AI research company providing GPT API services for natural language processing.",
      "longDescription": null,
      "email": null,
      "country": "US",
      "website": "https://openai.com",
      "logo": "https://www.google.com/s2/favicons?domain=openai.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_xj643cpp5p1awyrrqgqpf67q4d",
      "createdAt": "2025-09-27T11:39:50.957Z",
      "updatedAt": "2025-09-27T11:39:59.353Z",
      "name": "GitHub, Inc.",
      "description": "Code hosting and version control platform subscription for software development.",
      "longDescription": null,
      "email": null,
      "country": "US",
      "website": "https://github.com",
      "logo": "https://www.google.com/s2/favicons?domain=github.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vyfqfbnc57amdf3sm0"
    },
    {
      "id": "ven_hkz708jvra375hd19t65j65vvt",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "TechCorp Industries",
      "description": "Enterprise software client for SaaS platform services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://techcorp-industries.com",
      "logo": "https://www.google.com/s2/favicons?domain=techcorp-industries.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_th3hfveyjxh2erds1n633s02yd",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "Global Solutions Ltd",
      "description": "Business consulting firm using our analytics platform",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://globalsolutions.co.uk",
      "logo": "https://www.google.com/s2/favicons?domain=globalsolutions.co.uk&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_m4xtykg61y9kjq9cjdr8bewyz0",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "Innovation Partners",
      "description": "Technology accelerator utilizing our cloud services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://innovationpartners.io",
      "logo": "https://www.google.com/s2/favicons?domain=innovationpartners.io&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_1jqt0xq8p3az0ed45aqq7npx6w",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "Enterprise Systems Inc",
      "description": "Large enterprise client for platform integration services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://enterprise-systems.com",
      "logo": "https://www.google.com/s2/favicons?domain=enterprise-systems.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_mj6n80che7b1rf41e9c0gtanqb",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "Digital Ventures Group",
      "description": "Venture capital firm using our portfolio management tools",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://digitalventures.group",
      "logo": "https://www.google.com/s2/favicons?domain=digitalventures.group&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_v3gga6hnqqf8p85ezhv67qxfkw",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "CloudFirst Technologies",
      "description": "Cloud infrastructure company partnering on services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://cloudfirst.tech",
      "logo": "https://www.google.com/s2/favicons?domain=cloudfirst.tech&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_jy64mwn8y868akxp0c6s337dms",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "DataDriven Analytics",
      "description": "Data analytics firm using our API services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://datadriven-analytics.com",
      "logo": "https://www.google.com/s2/favicons?domain=datadriven-analytics.com&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_k9wmdwkshbazmh9e7aq4wj85ej",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "SmartScale Solutions",
      "description": "Scaling consultancy using our automation platform",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://smartscale.solutions",
      "logo": "https://www.google.com/s2/favicons?domain=smartscale.solutions&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_631832eta7hj1n2x0gedv5fm59",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "Nexus Consulting GmbH",
      "description": "German consulting firm for enterprise services",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://nexus-consulting.de",
      "logo": "https://www.google.com/s2/favicons?domain=nexus-consulting.de&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_m17gcz62vyhqqefr5q41a31k5f",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "EuroTech Innovations",
      "description": "European technology company using our platform",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://eurotech-innovations.eu",
      "logo": "https://www.google.com/s2/favicons?domain=eurotech-innovations.eu&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_q7sgetg8gwgf23ac9gdqmk8cz4",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "Nordic Digital AB",
      "description": "Swedish digital agency for SaaS subscriptions",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://nordicdigital.se",
      "logo": "https://www.google.com/s2/favicons?domain=nordicdigital.se&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    },
    {
      "id": "ven_nk7g93a6fpe8ybm4hppdmmfgsw",
      "createdAt": "2025-07-01T10:00:00.000Z",
      "updatedAt": "2025-07-01T10:00:00.000Z",
      "name": "Alpine Software SA",
      "description": "Swiss software company using our development tools",
      "longDescription": null,
      "email": null,
      "country": null,
      "website": "https://alpinesoftware.ch",
      "logo": "https://www.google.com/s2/favicons?domain=alpinesoftware.ch&sz=128",
      "salesTaxRate": null,
      "isBusiness": true,
      "isSubscription": true,
      "type": "VENDOR",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "categoryId": "cat_01k1y1x3vxfqfbnc3g0c26f170"
    }
  ],
  "terms_and_conditions": [
    {
      "id": "tcs-1",
      "createdAt": "2025-06-20T17:04:09.933Z",
      "updatedAt": "2025-06-20T17:04:09.933Z",
      "country": "EU",
      "version": "1",
      "changeSummary": null,
      "modulrTermsAndConditionsVersion": 1
    },
    {
      "id": "tcs-2",
      "createdAt": "2025-06-20T17:04:25.210Z",
      "updatedAt": "2025-06-20T17:04:25.210Z",
      "country": "GB",
      "version": "1",
      "changeSummary": null,
      "modulrTermsAndConditionsVersion": 1
    },
    {
      "id": "tcs-4",
      "createdAt": "2025-07-11T11:12:49.424Z",
      "updatedAt": "2025-07-11T11:12:49.424Z",
      "country": "ES",
      "version": "1",
      "changeSummary": null,
      "modulrTermsAndConditionsVersion": 1
    }
  ],
  "modulr_customer_onboarding": [
    {
      "id": "mcusto_01k6fjzza0fzz9aahe2a2jkq9k",
      "createdAt": "2025-10-01T10:52:26.430Z",
      "updatedAt": "2025-10-01T11:05:56.219Z",
      "status": "sent",
      "sentToApprovalAt": "2025-10-01T10:05:56.201Z",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "name": "name_01jnggpbwvfk68mjphwrydty5b",
      "companyRegNumber": "reg_dago_1",
      "registeredAddress": {
        "addressLine1": "123 Test Street",
        "addressLine2": "Suite 100",
        "postTown": "Dublin",
        "postCode": "D04 AK85",
        "country": "IE"
      },
      "tradingAddress": {
        "addressLine1": "123 Test Street",
        "addressLine2": "Suite 100",
        "postTown": "Dublin",
        "postCode": "D04 AK85",
        "country": "IE"
      },
      "industryCode": "K",
      "tcsVersion": 1,
      "type": "LLC",
      "expectedMonthlySpend": 10000,
      "associates": [
        {
          "type": "DIRECTOR",
          "firstName": "TestDirector",
          "lastName": "TestDirector",
          "dateOfBirth": "1980-01-01",
          "homeAddress": {
            "addressLine1": "456 Test Avenue",
            "addressLine2": "Apt 200",
            "postTown": "Dublin",
            "postCode": "D04 AK85",
            "country": "IE"
          },
          "phone": "+(353)123456789",
          "email": "director_01jnggpbwvfk68mjq7vpcqwrz8@example.com",
          "applicant": true
        },
        {
          "type": "BENE_OWNER",
          "firstName": "TestOwner",
          "lastName": "TestOwner",
          "dateOfBirth": "1980-01-01",
          "homeAddress": {
            "addressLine1": "456 Test Avenue",
            "addressLine2": "Apt 200",
            "postTown": "Dublin",
            "postCode": "D04 AK85",
            "country": "IE"
          },
          "email": "owner_01jnggpbwvfk68mjqdj9hrecpb@example.com",
          "phone": "+(353)123456789",
          "ownership": 100,
          "applicant": false
        }
      ],
      "documentInfo": [],
      "legalEntity": "NL"
    }
  ],
  "sync_result": [
    {
      "id": "syncres_01jy41hs42e8hbcmmj5svhjccz",
      "createdAt": "2025-06-19T13:10:22.210Z",
      "updatedAt": "2025-06-19T15:53:32.718Z",
      "entityId": "acc_01jy41hs3ve8hbcmm88yk8a341",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-19T14:53:32.716Z",
      "nextSyncAt": "2025-06-19T12:10:22.209Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": "The institution rejected the call due to insufficient rights. Please re-authorise. We can help you on https://docs.yapily.com/support"
      },
      "syncStats": null
    },
    {
      "id": "syncres_01k4tp1dp9e8prz2zx4t6x4tta",
      "createdAt": "2025-09-10T21:45:54.756Z",
      "updatedAt": "2025-09-10T22:18:18.595Z",
      "entityId": "acc_01k4tp1dnte8prz2zqsfb9dqg1",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T21:18:18.594Z",
      "nextSyncAt": "2025-09-10T20:45:54.755Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1
      }
    },
    {
      "id": "syncres_01jy4b83b5fk2b6mppsz5x9v0b",
      "createdAt": "2025-06-19T15:59:50.756Z",
      "updatedAt": "2025-06-19T16:00:51.549Z",
      "entityId": "acc_01jy4b83b0fk2b6mpc22hmz98m",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-19T15:00:51.547Z",
      "nextSyncAt": "2025-06-19T14:59:50.756Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": ""
      },
      "syncStats": null
    },
    {
      "id": "syncres_01k4tqwqahfzssq914d1g8jw7n",
      "createdAt": "2025-09-10T22:18:17.924Z",
      "updatedAt": "2025-09-10T22:18:18.962Z",
      "entityId": "acc_01k4tqwq9rfzssq90xc7fyzr19",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T21:18:18.961Z",
      "nextSyncAt": "2025-09-10T21:18:17.923Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 104
      }
    },
    {
      "id": "syncres_01jy79ssdhe8kr2s70x3y40gzx",
      "createdAt": "2025-06-20T19:32:16.560Z",
      "updatedAt": "2025-06-22T09:11:40.864Z",
      "entityId": "acc_01jy79ssd3e8kr2s6xdks1ptgd",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-06-22T08:11:40.863Z",
      "nextSyncAt": "2025-06-20T18:32:16.560Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 6
      }
    },
    {
      "id": "syncres_01jy66xt64ecv9x3z5fbj3b88p",
      "createdAt": "2025-06-20T09:22:48.260Z",
      "updatedAt": "2025-06-20T12:55:54.381Z",
      "entityId": "acc_01jy66xt62ecv9x3yxdjttft51",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-06-20T11:55:54.381Z",
      "nextSyncAt": "2025-06-20T08:22:48.260Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 6
      }
    },
    {
      "id": "syncres_01jy4br4p4ecssp86nc5vxb3xc",
      "createdAt": "2025-06-19T16:08:36.419Z",
      "updatedAt": "2025-06-19T16:09:37.535Z",
      "entityId": "acc_01jy4br4nqecssp8696kb9entz",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-19T15:09:37.533Z",
      "nextSyncAt": "2025-06-19T15:08:36.419Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": ""
      },
      "syncStats": null
    },
    {
      "id": "syncres_01jy4dh3k9fagv2xedczr1pvgg",
      "createdAt": "2025-06-19T16:39:43.081Z",
      "updatedAt": "2025-06-19T16:40:44.160Z",
      "entityId": "acc_01jy4dh3k7fagv2xe7wd3sd89j",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-19T15:40:44.159Z",
      "nextSyncAt": "2025-06-19T15:39:43.081Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": ""
      },
      "syncStats": null
    },
    {
      "id": "syncres_01k4tt2bxvfeyrqwt0mwgzhxy7",
      "createdAt": "2025-09-10T22:56:20.021Z",
      "updatedAt": "2025-09-10T22:56:20.920Z",
      "entityId": "acc_01k4tt2bx5feyrqwsvcrz7qdtr",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T21:56:20.920Z",
      "nextSyncAt": "2025-09-10T21:56:20.020Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01jyep9yh1fqaaw9qyqcshw32d",
      "createdAt": "2025-06-23T16:25:30.017Z",
      "updatedAt": "2025-06-23T16:25:35.100Z",
      "entityId": "acc_01jyep9ygzfqaaw9qjtx8rv6ky",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-06-23T15:25:35.099Z",
      "nextSyncAt": "2025-06-23T15:25:30.017Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1000
      }
    },
    {
      "id": "syncres_01jy4e15f7e07r72dqqzcxzwaa",
      "createdAt": "2025-06-19T16:48:29.287Z",
      "updatedAt": "2025-06-19T16:49:50.155Z",
      "entityId": "acc_01jy4e15ere07r72dcc25s0w5n",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-19T15:49:50.153Z",
      "nextSyncAt": "2025-06-19T15:48:29.286Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": ""
      },
      "syncStats": null
    },
    {
      "id": "syncres_01jy71fcpdfvpap9p2pzjnj5kb",
      "createdAt": "2025-06-20T17:06:47.244Z",
      "updatedAt": "2025-06-20T17:07:47.393Z",
      "entityId": "acc_01jy71fcnrfvpap9nr27hrf5my",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-20T16:07:47.391Z",
      "nextSyncAt": "2025-06-20T16:06:47.244Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": ""
      },
      "syncStats": null
    },
    {
      "id": "syncres_01jy4f5x2qfqfte16hgar99ab5",
      "createdAt": "2025-06-19T17:08:33.110Z",
      "updatedAt": "2025-06-19T17:09:54.119Z",
      "entityId": "acc_01jy4f5x2jfqfte168rzd53bqt",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-19T16:09:54.117Z",
      "nextSyncAt": "2025-06-19T16:08:33.110Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": ""
      },
      "syncStats": null
    },
    {
      "id": "syncres_01k4trgrh1exxsg34gkyt2gybd",
      "createdAt": "2025-09-10T22:29:14.517Z",
      "updatedAt": "2025-09-10T22:29:15.440Z",
      "entityId": "acc_01k4trgrgbexxsg34ebfm8ksxm",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T21:29:15.439Z",
      "nextSyncAt": "2025-09-10T21:29:14.517Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01jwe7yrkafzzvgx7y88f07ad8",
      "createdAt": "2025-05-29T15:43:19.785Z",
      "updatedAt": "2025-06-19T17:22:53.569Z",
      "entityId": "acc_01jwe7yrjnfzzvgx7mbvmvjsf1",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-06-19T16:22:53.568Z",
      "nextSyncAt": "2025-05-29T14:43:19.784Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 0
      }
    },
    {
      "id": "syncres_01jy72852dfk7870aqaadp94k2",
      "createdAt": "2025-06-20T17:20:18.637Z",
      "updatedAt": "2025-06-20T17:21:18.801Z",
      "entityId": "acc_01jy72851xfk7870ab3bzsqz7b",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-20T16:21:18.798Z",
      "nextSyncAt": "2025-06-20T16:20:18.636Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": ""
      },
      "syncStats": null
    },
    {
      "id": "syncres_01jy4g04ycf22vedxdsgwc41d8",
      "createdAt": "2025-06-19T17:22:53.132Z",
      "updatedAt": "2025-06-19T17:22:56.349Z",
      "entityId": "acc_01jy4g04xtf22vedx6jtk440am",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-06-19T16:22:56.348Z",
      "nextSyncAt": "2025-06-19T16:22:53.131Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 42
      }
    },
    {
      "id": "syncres_01jy4jnjx2fq8s6mg018fs067b",
      "createdAt": "2025-06-19T18:09:32.706Z",
      "updatedAt": "2025-06-19T18:09:35.382Z",
      "entityId": "acc_01jy4jnjwmfq8s6mfw1nmajgg8",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-06-19T17:09:35.382Z",
      "nextSyncAt": "2025-06-19T17:09:32.705Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 42
      }
    },
    {
      "id": "syncres_01jy6kh01fencv1s0wp9rz041q",
      "createdAt": "2025-06-20T13:02:59.759Z",
      "updatedAt": "2025-06-25T09:20:58.221Z",
      "entityId": "acc_01jy6kh015encv1s0pe4bzcdsv",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-25T08:20:58.044Z",
      "nextSyncAt": "2025-06-20T12:02:59.758Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": ""
      },
      "syncStats": {
        "transactionsSynced": 6
      }
    },
    {
      "id": "syncres_01k4trvmtffvmam0rx2bk4sytd",
      "createdAt": "2025-09-10T22:35:11.179Z",
      "updatedAt": "2025-09-10T22:35:11.896Z",
      "entityId": "acc_01k4trvmt0fvmam0rgbfnd64nb",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T21:35:11.895Z",
      "nextSyncAt": "2025-09-10T21:35:11.179Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01jy76g1gxe8m9drs37nx6g8r9",
      "createdAt": "2025-06-20T18:34:31.447Z",
      "updatedAt": "2025-06-20T18:46:19.063Z",
      "entityId": "acc_01jy76g1fye8m9drrv2n5cqjvv",
      "entityType": "ACCOUNT",
      "syncStatus": "FAILED",
      "lastSyncAttemptAt": "2025-06-20T17:46:19.062Z",
      "nextSyncAt": "2025-06-20T17:34:31.445Z",
      "syncError": {
        "code": "TRANSACTION_SYNC_FAILED",
        "message": "The institution rejected the call due to insufficient rights. Please re-authorise. We can help you on https://docs.yapily.com/support"
      },
      "syncStats": null
    },
    {
      "id": "syncres_01jygpkrc1exxthk80hk5f43kd",
      "createdAt": "2025-06-24T11:09:20.246Z",
      "updatedAt": "2025-06-25T09:21:09.473Z",
      "entityId": "acc_01jygpkrbjexxthk7wezd5j5za",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-06-25T08:21:09.389Z",
      "nextSyncAt": "2025-06-24T10:09:20.245Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 2
      }
    },
    {
      "id": "syncres_01k59krqfkfk5t95f159xf3jda",
      "createdAt": "2025-09-16T16:54:49.197Z",
      "updatedAt": "2025-09-16T16:54:49.634Z",
      "entityId": "acc_01k59krqf1fk5t95etemxhh131",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-16T15:54:49.633Z",
      "nextSyncAt": "2025-09-16T15:54:49.197Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 104
      }
    },
    {
      "id": "syncres_01k4tspn7kect9kckrajz9spw4",
      "createdAt": "2025-09-10T22:49:56.332Z",
      "updatedAt": "2025-09-10T22:49:57.154Z",
      "entityId": "acc_01k4tspn73ect9kckn8ekbqsky",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T21:49:57.153Z",
      "nextSyncAt": "2025-09-10T21:49:56.331Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01k1y21djcfqfbncb8q832vefp",
      "createdAt": "2025-08-05T22:26:15.372Z",
      "updatedAt": "2025-08-05T22:26:20.561Z",
      "entityId": "acc_01k1y21dhzfqfbncb0vr1fbyf7",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-08-05T21:26:20.560Z",
      "nextSyncAt": "2025-08-05T21:26:15.371Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1000
      }
    },
    {
      "id": "syncres_01k4tt7w8sf6arrtbfgqzkptdc",
      "createdAt": "2025-09-10T22:59:20.598Z",
      "updatedAt": "2025-09-10T22:59:21.300Z",
      "entityId": "acc_01k4tt7w8cf6arrtb3d5mk9e9g",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T21:59:21.300Z",
      "nextSyncAt": "2025-09-10T21:59:20.597Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01k4tssnpsf20b37rc00crwjca",
      "createdAt": "2025-09-10T22:51:35.125Z",
      "updatedAt": "2025-09-10T22:51:35.812Z",
      "entityId": "acc_01k4tssnpbf20b37r4mkxanqk6",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T21:51:35.811Z",
      "nextSyncAt": "2025-09-10T21:51:35.125Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01k4tszcsnfvjv60drv6g6z8x3",
      "createdAt": "2025-09-10T22:54:42.607Z",
      "updatedAt": "2025-09-10T22:54:43.421Z",
      "entityId": "acc_01k4tszcs3fvjv60dhns8jx1zk",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T21:54:43.420Z",
      "nextSyncAt": "2025-09-10T21:54:42.606Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01k4ttbt70e8msths3kyhkacep",
      "createdAt": "2025-09-10T23:01:29.563Z",
      "updatedAt": "2025-09-10T23:01:30.261Z",
      "entityId": "acc_01k4ttbt6he8msthrvmcandb8s",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T22:01:30.260Z",
      "nextSyncAt": "2025-09-10T22:01:29.562Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01k59q9080fap911pkz3tc11wg",
      "createdAt": "2025-09-16T17:56:08.184Z",
      "updatedAt": "2025-09-16T17:56:08.723Z",
      "entityId": "acc_01k59q907hfap911pedm7skq50",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-16T16:56:08.722Z",
      "nextSyncAt": "2025-09-16T16:56:08.184Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 458
      }
    },
    {
      "id": "syncres_01k4txcnt1fewa0t32rvhn8rdt",
      "createdAt": "2025-09-10T23:54:23.546Z",
      "updatedAt": "2025-09-10T23:54:24.335Z",
      "entityId": "acc_01k4txcnsefewa0t2xcx58smrw",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-10T22:54:24.334Z",
      "nextSyncAt": "2025-09-10T22:54:23.546Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01k59kw8y8fagazkaan009ekvw",
      "createdAt": "2025-09-16T16:56:45.380Z",
      "updatedAt": "2025-09-16T16:56:45.789Z",
      "entityId": "acc_01k59kw8xtfagazka4vqp8a3ae",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-16T15:56:45.789Z",
      "nextSyncAt": "2025-09-16T15:56:45.380Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 104
      }
    },
    {
      "id": "syncres_01k59ky8jben8svkazwm8ynw5k",
      "createdAt": "2025-09-16T16:57:50.535Z",
      "updatedAt": "2025-09-16T16:57:50.984Z",
      "entityId": "acc_01k59ky8hxen8svkamq9ecg5v2",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-16T15:57:50.984Z",
      "nextSyncAt": "2025-09-16T15:57:50.535Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 301
      }
    },
    {
      "id": "syncres_01k59kx2wpfagazndh3qf6trws",
      "createdAt": "2025-09-16T16:57:11.950Z",
      "updatedAt": "2025-09-16T16:57:12.814Z",
      "entityId": "acc_01k59kx2w2fagazndc6yyrqk1h",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-16T15:57:12.813Z",
      "nextSyncAt": "2025-09-16T15:57:11.950Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1150
      }
    },
    {
      "id": "syncres_01k65c32gxeshspecajfyn8w08",
      "createdAt": "2025-09-27T11:39:23.676Z",
      "updatedAt": "2025-09-29T19:23:31.756Z",
      "entityId": "acc_01k65c32gpeshspec6cv4wps2p",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-29T18:23:31.756Z",
      "nextSyncAt": "2025-09-27T10:39:23.675Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 1
      }
    },
    {
      "id": "syncres_01k6da0fffenabvr0fg49krfmy",
      "createdAt": "2025-09-30T13:36:56.942Z",
      "updatedAt": "2025-09-30T13:36:56.942Z",
      "entityId": "evi_01k6da0fdeenabvr0401cshk3s",
      "entityType": "INVOICE_EVIDENCE",
      "syncStatus": "PENDING",
      "lastSyncAttemptAt": null,
      "nextSyncAt": "2025-09-30T12:36:56.942Z",
      "syncError": null,
      "syncStats": null
    },
    {
      "id": "syncres_01k6bbebrhfvhrjkyvdftv1d58",
      "createdAt": "2025-09-29T19:23:31.601Z",
      "updatedAt": "2025-09-29T19:23:31.867Z",
      "entityId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2025-09-29T18:23:31.866Z",
      "nextSyncAt": "2025-09-29T18:23:31.601Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 104
      }
    },
    {
      "id": "syncres_01k6fkxs9wfzz9aek0wfbs0n01",
      "createdAt": "2025-10-01T11:08:43.318Z",
      "updatedAt": "2025-10-01T11:08:43.318Z",
      "entityId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "entityType": "ACCOUNT",
      "syncStatus": "PENDING",
      "lastSyncAttemptAt": null,
      "nextSyncAt": "2025-10-01T10:08:43.318Z",
      "syncError": null,
      "syncStats": null
    },
    {
      "id": "syncres_01k6fp0bbqfzz9aeqhnrtsy8pw",
      "createdAt": "2025-10-01T11:45:04.503Z",
      "updatedAt": "2025-10-01T11:45:04.503Z",
      "entityId": "evi_01k6fp0bb3fzz9aeqfxd6y4tf4",
      "entityType": "INVOICE_EVIDENCE",
      "syncStatus": "PENDING",
      "lastSyncAttemptAt": null,
      "nextSyncAt": "2025-10-01T10:45:04.503Z",
      "syncError": null,
      "syncStats": null
    },
    {
      "id": "syncres_01k7gbp3qwfzz9aentk8bs1n02",
      "createdAt": "2025-10-01T11:08:43.318Z",
      "updatedAt": "2026-01-15T14:22:18.318Z",
      "entityId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "entityType": "ACCOUNT",
      "syncStatus": "COMPLETE",
      "lastSyncAttemptAt": "2026-01-15T14:22:18.318Z",
      "nextSyncAt": "2026-01-15T15:22:18.318Z",
      "syncError": null,
      "syncStats": {
        "transactionsSynced": 0
      }
    }
  ],
  "modulr_customer": [
    {
      "id": "mcust_01k6fkrp2wfzz9aahjyqvmmcgy",
      "createdAt": "2025-10-01T11:05:56.187Z",
      "updatedAt": "2025-10-01T11:05:56.187Z",
      "modulrCustomerId": "C213MQMA",
      "verificationStatus": "VERIFIED",
      "status": "ACTIVE",
      "legalEntity": "NL",
      "onboardingId": "mcusto_01k6fjzza0fzz9aahe2a2jkq9k",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    }
  ],
  "bulk_payment": [
    {
      "id": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "createdAt": "2025-12-22T14:30:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "status": "SUCCEEDED",
      "type": "PAYROLL",
      "totalAmount": 73050,
      "currency": "GBP",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "bp_fpymtas7cz76sdeffzyrxksfh4",
      "createdAt": "2026-01-13T11:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "status": "CREATED",
      "type": "PAYROLL",
      "totalAmount": 73050,
      "currency": "GBP",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    }
  ],
  "institutions": [
    {
      "id": "01jy41hs3ke8hbcmm2g8xywswg",
      "createdAt": "2025-06-19T13:10:22.195Z",
      "updatedAt": "2025-06-19T13:10:22.195Z",
      "externalId": "permanent-tsb",
      "name": "Permanent TSB",
      "bic": null,
      "transactionTotalDays": 0,
      "countries": [
        "IE"
      ],
      "logo": "https://images.yapily.com/image/bfbbe90f-d264-42ed-a476-44775a7c0fce",
      "maxAccessValidForDays": 0
    },
    {
      "id": "01jwe7yrj6fzzvgx7cgph27arb",
      "createdAt": "2025-05-29T15:43:19.749Z",
      "updatedAt": "2025-06-26T15:12:00.365Z",
      "externalId": "revolut_eu",
      "name": "Revolut EU",
      "bic": null,
      "transactionTotalDays": 0,
      "countries": [
        "BG",
        "FI",
        "ES",
        "LI",
        "MT",
        "DE",
        "NL",
        "DK",
        "CZ",
        "HU",
        "SE",
        "EE",
        "FR",
        "AT",
        "BE",
        "LT",
        "GR",
        "LV",
        "IT",
        "RO",
        "PT",
        "IE",
        "IS",
        "NO"
      ],
      "logo": "https://images.yapily.com/image/fdd1045e-daa8-485c-9315-87fcc2e06e6c",
      "maxAccessValidForDays": 0
    },
    {
      "id": "01k4tp1dmhe8prz2zbjcsqwbsg",
      "createdAt": "2025-09-10T21:45:54.694Z",
      "updatedAt": "2025-09-10T21:45:54.694Z",
      "externalId": "REVOLUT_REVOLT21",
      "name": "Revolut",
      "bic": "REVOLT21XXX",
      "transactionTotalDays": 730,
      "countries": [
        "FI",
        "GB",
        "GR",
        "LU",
        "SE",
        "BE",
        "LI",
        "IT",
        "CY",
        "SK",
        "MT",
        "FR",
        "IE",
        "EE",
        "PL",
        "RO",
        "LT",
        "IS",
        "HR",
        "CZ",
        "DK",
        "NO",
        "AT",
        "DE",
        "PT",
        "BG",
        "HU",
        "LV",
        "SI",
        "ES",
        "NL"
      ],
      "logo": "https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/revolut.png",
      "maxAccessValidForDays": 180
    },
    {
      "id": "01k4tqwq8cfzssq90gxxgq963v",
      "createdAt": "2025-09-10T22:18:17.853Z",
      "updatedAt": "2025-09-10T22:18:17.853Z",
      "externalId": "HSBC_NET_HSBCIE2D",
      "name": "HSBC Net",
      "bic": "HSBCIE2DXXX",
      "transactionTotalDays": 730,
      "countries": [
        "IE",
        "GB"
      ],
      "logo": "https://images.yapily.com/image/fc734d3c-4480-471e-94ee-500f83ae3bae",
      "maxAccessValidForDays": 180
    }
  ],
  "beneficiary": [
    {
      "id": "benf_01k6da2eq9enabvr1mt32wrpx6",
      "createdAt": "2025-09-30T13:38:01.705Z",
      "updatedAt": "2025-09-30T13:38:01.705Z",
      "name": "Pembroke Hall Limited",
      "country": "IE",
      "emailAddress": null,
      "defaultReference": null,
      "createdByType": "USER",
      "createdByUserId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "yapilyBeneficiaryId": null,
      "yapilyUserId": null,
      "address": {
        "line1": null,
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "destination": {
        "type": "IBAN",
        "accountType": "BUSINESS",
        "currency": "EUR",
        "accountNumber": null,
        "sortCode": null,
        "iban": "IE15BOFI99999999999901",
        "bic": null
      }
    },
    {
      "id": "benf_vy5tcadsq8hq6zp05dzeh2tatq",
      "createdAt": "2025-09-15T10:00:00.000Z",
      "updatedAt": "2025-09-15T10:00:00.000Z",
      "name": "Amazon Web Services EMEA SARL",
      "country": "LU",
      "emailAddress": null,
      "defaultReference": "AWS-2025-847291",
      "createdByType": "USER",
      "createdByUserId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "yapilyBeneficiaryId": null,
      "yapilyUserId": null,
      "address": {
        "line1": "38 Avenue John F. Kennedy",
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "destination": {
        "type": "IBAN",
        "accountType": "BUSINESS",
        "currency": "GBP",
        "accountNumber": null,
        "sortCode": null,
        "iban": "LU280000123456789012",
        "bic": "CITILULX"
      }
    },
    {
      "id": "benf_bja9cdzr82eptdtwghfrd40ac5",
      "createdAt": "2025-09-15T10:00:00.000Z",
      "updatedAt": "2025-09-15T10:00:00.000Z",
      "name": "OpenAI, LLC",
      "country": "US",
      "emailAddress": null,
      "defaultReference": "OAI-2025-12-4829",
      "createdByType": "USER",
      "createdByUserId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "yapilyBeneficiaryId": null,
      "yapilyUserId": null,
      "address": {
        "line1": "3180 18th Street",
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "destination": {
        "type": "SCAN",
        "accountType": "BUSINESS",
        "currency": "USD",
        "accountNumber": "3301234567",
        "sortCode": null,
        "iban": null,
        "bic": null
      }
    },
    {
      "id": "benf_xka3kqs02tx2re7za71wbk3yjd",
      "createdAt": "2025-09-15T10:00:00.000Z",
      "updatedAt": "2025-09-15T10:00:00.000Z",
      "name": "Anthropic PBC",
      "country": "US",
      "emailAddress": null,
      "defaultReference": "ANT-2025-38291",
      "createdByType": "USER",
      "createdByUserId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "yapilyBeneficiaryId": null,
      "yapilyUserId": null,
      "address": {
        "line1": "548 Market Street",
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "destination": {
        "type": "SCAN",
        "accountType": "BUSINESS",
        "currency": "USD",
        "accountNumber": "8801234567",
        "sortCode": null,
        "iban": null,
        "bic": null
      }
    },
    {
      "id": "benf_423n0p675xecav56xpy6rxhv9m",
      "createdAt": "2025-09-15T10:00:00.000Z",
      "updatedAt": "2025-09-15T10:00:00.000Z",
      "name": "Slack Technologies Limited",
      "country": "GB",
      "emailAddress": null,
      "defaultReference": "SLK-UK-2026-0105",
      "createdByType": "USER",
      "createdByUserId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "yapilyBeneficiaryId": null,
      "yapilyUserId": null,
      "address": {
        "line1": "Salesforce Tower",
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "destination": {
        "type": "SCAN",
        "accountType": "BUSINESS",
        "currency": "GBP",
        "accountNumber": "73849201",
        "sortCode": "20-00-00",
        "iban": null,
        "bic": null
      }
    },
    {
      "id": "benf_4pppc1h3qy34jt2h3pygnfsexm",
      "createdAt": "2025-09-15T10:00:00.000Z",
      "updatedAt": "2025-09-15T10:00:00.000Z",
      "name": "GitHub, Inc.",
      "country": "US",
      "emailAddress": null,
      "defaultReference": "GH-2026-01-78234",
      "createdByType": "USER",
      "createdByUserId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "yapilyBeneficiaryId": null,
      "yapilyUserId": null,
      "address": {
        "line1": "88 Colin P Kelly Jr Street",
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "destination": {
        "type": "SCAN",
        "accountType": "BUSINESS",
        "currency": "USD",
        "accountNumber": "9901234567",
        "sortCode": null,
        "iban": null,
        "bic": null
      }
    },
    {
      "id": "benf_egv1gm096d42br09c3enxwr6h5",
      "createdAt": "2025-09-15T10:00:00.000Z",
      "updatedAt": "2025-09-15T10:00:00.000Z",
      "name": "WeWork International Ltd",
      "country": "GB",
      "emailAddress": null,
      "defaultReference": "WW-UK-2026-01892",
      "createdByType": "USER",
      "createdByUserId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "yapilyBeneficiaryId": null,
      "yapilyUserId": null,
      "address": {
        "line1": "115 Mare Street",
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "destination": {
        "type": "SCAN",
        "accountType": "BUSINESS",
        "currency": "GBP",
        "accountNumber": "12847391",
        "sortCode": "40-05-30",
        "iban": null,
        "bic": null
      }
    },
    {
      "id": "benf_5v1gpcvhcb83ysp8eyw9r5arr8",
      "createdAt": "2025-09-15T10:00:00.000Z",
      "updatedAt": "2025-09-15T10:00:00.000Z",
      "name": "Notion Labs, Inc.",
      "country": "US",
      "emailAddress": null,
      "defaultReference": "NOT-2026-91823",
      "createdByType": "USER",
      "createdByUserId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "latestPayeeCheckId": null,
      "yapilyBeneficiaryId": null,
      "yapilyUserId": null,
      "address": {
        "line1": "2300 Harrison Street",
        "line2": null,
        "postTown": null,
        "postCode": null,
        "countrySubDivision": null
      },
      "destination": {
        "type": "SCAN",
        "accountType": "BUSINESS",
        "currency": "USD",
        "accountNumber": "1234567890",
        "sortCode": null,
        "iban": null,
        "bic": null
      }
    }
  ],
  "baseaccount": [
    {
      "transitions": [
        {
          "fromState": "UNLINKED",
          "event": "LINK_START",
          "toState": "LINKING"
        },
        {
          "fromState": "LINKING",
          "event": "LINK_END",
          "toState": "LINKED"
        },
        {
          "fromState": "LINKED",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKING",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKED",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNCING",
          "event": "SYNC_END",
          "toState": "SYNCED"
        },
        {
          "fromState": "SYNCING",
          "event": "SYNC_ERROR",
          "toState": "SYNC_ERROR"
        },
        {
          "fromState": "SYNCED",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCED",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNC_ERROR",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNC_ERROR",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKED",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCED",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCING",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKING",
          "event": "UNLINK",
          "toState": "UNLINKED"
        }
      ],
      "state": "SYNCED",
      "id": "acc_01k65c32gpeshspec6cv4wps2p",
      "createdAt": "2025-09-27T11:39:23.665Z",
      "updatedAt": "2025-09-29T19:23:31.774Z",
      "type": "BANKING",
      "fspIdentifier": "33c43c4a-04cf-4d21-867a-ff3eb6666690",
      "displayName": "Main Account (EUR)",
      "currency": "EUR",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "name": "Manu  Mahajan",
      "status": "ACTIVE",
      "interimAvailableBalance": null,
      "expectedBalance": 124819,
      "closingBookedBalance": null,
      "institutionId": "REVOLUT_REVOLT21",
      "fspAdapter": "GOCARDLESS_DEMO_DATA",
      "fspRecord": {
        "metadata": {
          "id": "33c43c4a-04cf-4d21-867a-ff3eb6666690",
          "created": "2024-11-14T17:01:37.532756Z",
          "last_accessed": "2024-11-18T17:29:47.837589Z",
          "iban": "IE29REVL99130406570738",
          "institution_id": "REVOLUT_REVOLT21",
          "status": "READY",
          "owner_name": "Seapoint Limited"
        },
        "details": {
          "account": {
            "resourceId": "0312f65a-365d-4dd5-80d0-655ff0892a77",
            "iban": "DE65100110012345678901",
            "currency": "EUR",
            "ownerName": "Manu  Mahajan",
            "name": "Main Account",
            "product": "Main Account",
            "cashAccountType": "CACC",
            "status": "enabled",
            "bic": "NTSBDEB1XXX",
            "usage": "PRIV"
          }
        }
      },
      "fspConnectionRecord": {
        "id": "27a1d0ae-02bf-459d-9e75-e4b6ec458ef9",
        "created": "2024-11-28T15:48:39.322990Z",
        "redirect": "https://seapoint.local:3000/api/gocardless/auth/com_01jdavax3cen9vrggbvcngfg8v",
        "status": "LN",
        "institution_id": "REVOLUT_REVOLT21",
        "agreement": "ffc9d2e9-8bd1-4786-a70b-c3b1607aa620",
        "reference": "10842564-cb84-4024-9032-9edd31c0e3b3",
        "accounts": [
          "33c43c4a-04cf-4d21-867a-ff3eb6666690"
        ],
        "user_language": "en",
        "link": "https://ob.gocardless.com/ob-psd2/start/a9c1053b-96af-4887-9a2c-86606c4baea9/REVOLUT_REVOLT21",
        "ssn": null,
        "account_selection": false,
        "redirect_immediate": false
      },
      "accountInformation": {
        "iban": "IE29REVL99130406570738",
        "bic": null,
        "accountNo": null,
        "sortCode": null
      },
      "company": {
        "authorisationReferences": [
          {
            "internalReferenceId": "conn_01k65c324keshspebagxy5dwy5",
            "fspAdapter": "GOCARDLESS_DEMO_DATA",
            "institutionId": "REVOLUT_REVOLT21",
            "externalReferenceId": "27a1d0ae-02bf-459d-9e75-e4b6ec458ef9"
          },
          {
            "internalReferenceId": "conn_01k6bbe6nrfvhrjkxwpmrmbwq6",
            "fspAdapter": "GOCARDLESS_DEMO_DATA",
            "institutionId": "HSBC_NET_HSBCIE2D",
            "externalReferenceId": "11111111-2222-3333-4444-555555555555"
          },
          {
            "internalReferenceId": "conn_01k6bef5yafvq949t2gk14wf0s",
            "externalReferenceId": "79a1d0b2-ebfc-4365-ab17-bd3c56aa64e6",
            "fspAdapter": "YAPILY",
            "institutionId": "aibbusiness",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6befzm7fvq949tdz29gnm4x",
            "externalReferenceId": "0b905d6f-6abc-4d76-82aa-a758a472a907",
            "fspAdapter": "YAPILY",
            "institutionId": "wise-live",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6beggm0fvq949tp5t9x4wmy",
            "externalReferenceId": "292fdd73-0f7c-470c-9ffb-dd647b6b53f6",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6beh9mzfvq949tz540vjv00",
            "externalReferenceId": "a2252609-aa40-4a6e-adf4-3075f73a5153",
            "fspAdapter": "YAPILY",
            "institutionId": "ing",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6behc6hfvq949v7b5j7xs4b",
            "externalReferenceId": "627fb60a-b00e-4295-aea0-7fa9e5686ada",
            "fspAdapter": "YAPILY",
            "institutionId": "hsbccorporate_eu",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6bf9sbze06ahjehh3fqeqbf",
            "externalReferenceId": "6e823814-9733-4178-8399-293bfdfe2d22",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          },
          {
            "internalReferenceId": "conn_01k6bft31xe8gbpwwcs025mc5z",
            "externalReferenceId": "eae1d334-7a66-4adf-87a0-2df191571632",
            "fspAdapter": "YAPILY",
            "institutionId": "ing",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          },
          {
            "internalReferenceId": "conn_01k6bh8g7keh5vq8wcj2574r9n",
            "externalReferenceId": "3a4a4df9-60ca-461d-b359-495f8a777cc1",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          }
        ],
        "id": "com_01k1y1ypa1fqfbnc9xn5secx0d",
        "createdAt": "2025-08-05T22:24:46.014Z",
        "updatedAt": "2025-09-29T21:05:11.929Z",
        "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
        "legalEntity": {
          "name": "RUCHI RESTAURANT LIMITED",
          "type": "LTD - Private Company Limited by Shares",
          "country": "IE",
          "registrationNo": "719039"
        },
        "registeredAddress": {
          "street": "TIM LOOBY ACCOUNTANTS",
          "city": "3 BANK PLACE",
          "county": "SLIEVENAMON ROAD",
          "postalCode": "E41 D430",
          "country": "Ireland"
        }
      },
      "institution": {
        "id": "01k4tp1dmhe8prz2zbjcsqwbsg",
        "createdAt": "2025-09-10T21:45:54.694Z",
        "updatedAt": "2025-09-10T21:45:54.694Z",
        "externalId": "REVOLUT_REVOLT21",
        "name": "Revolut",
        "bic": "REVOLT21XXX",
        "transactionTotalDays": 730,
        "countries": [
          "FI",
          "GB",
          "GR",
          "LU",
          "SE",
          "BE",
          "LI",
          "IT",
          "CY",
          "SK",
          "MT",
          "FR",
          "IE",
          "EE",
          "PL",
          "RO",
          "LT",
          "IS",
          "HR",
          "CZ",
          "DK",
          "NO",
          "AT",
          "DE",
          "PT",
          "BG",
          "HU",
          "LV",
          "SI",
          "ES",
          "NL"
        ],
        "logo": "https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/revolut.png",
        "maxAccessValidForDays": 180
      },
      "syncResult": {
        "id": "syncres_01k65c32gxeshspecajfyn8w08",
        "createdAt": "2025-09-27T11:39:23.676Z",
        "updatedAt": "2025-09-29T19:23:31.756Z",
        "entityId": "acc_01k65c32gpeshspec6cv4wps2p",
        "entityType": "ACCOUNT",
        "syncStatus": "COMPLETE",
        "lastSyncAttemptAt": "2026-01-15T14:22:18.318Z",
        "nextSyncAt": "2025-09-27T10:39:23.675Z",
        "syncError": null,
        "syncStats": {
          "transactionsSynced": 1
        }
      }
    },
    {
      "transitions": [
        {
          "fromState": "UNLINKED",
          "event": "LINK_START",
          "toState": "LINKING"
        },
        {
          "fromState": "LINKING",
          "event": "LINK_END",
          "toState": "LINKED"
        },
        {
          "fromState": "LINKED",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKING",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKED",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNCING",
          "event": "SYNC_END",
          "toState": "SYNCED"
        },
        {
          "fromState": "SYNCING",
          "event": "SYNC_ERROR",
          "toState": "SYNC_ERROR"
        },
        {
          "fromState": "SYNCED",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCED",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNC_ERROR",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNC_ERROR",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKED",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCED",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCING",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKING",
          "event": "UNLINK",
          "toState": "UNLINKED"
        }
      ],
      "state": "SYNCED",
      "id": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "createdAt": "2025-09-29T19:23:31.598Z",
      "updatedAt": "2025-09-29T19:23:31.882Z",
      "type": "BANKING",
      "fspIdentifier": "99999999-aaaa-bbbb-cccc-dddddddddddd",
      "displayName": "Main Account (GBP)",
      "currency": "GBP",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "name": "Seapoint Finance Limited",
      "status": "ACTIVE",
      "interimAvailableBalance": null,
      "expectedBalance": 489809.72,
      "closingBookedBalance": null,
      "institutionId": "HSBC_NET_HSBCIE2D",
      "fspAdapter": "GOCARDLESS_DEMO_DATA",
      "fspRecord": {
        "metadata": {
          "id": "99999999-aaaa-bbbb-cccc-dddddddddddd",
          "created": "2025-09-05T16:15:48.752Z",
          "last_accessed": "2025-09-05T16:15:48.752Z",
          "iban": "GB00HBUK00000000000000",
          "institution_id": "HSBC_NET_HSBCIE2D",
          "status": "READY",
          "owner_name": "Seapoint Finance Limited"
        },
        "details": {
          "account": {
            "resourceId": "99999999-aaaa-bbbb-cccc-dddddddddddd",
            "iban": "GB00HBUK00000000000000",
            "currency": "GBP",
            "ownerName": "Seapoint Finance Limited",
            "name": "Main Account",
            "product": "Main Account",
            "cashAccountType": "CACC",
            "status": "enabled",
            "bic": "HSBCIE2DXXX",
            "usage": "PRIV"
          }
        }
      },
      "fspConnectionRecord": {
        "id": "11111111-2222-3333-4444-555555555555",
        "created": "2025-09-05T16:15:48.752Z",
        "redirect": "https://seapoint.local:3000/api/gocardless/auth/com_demo",
        "status": "LN",
        "institution_id": "HSBC_NET_HSBCIE2D",
        "agreement": "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee",
        "reference": "demo-reference",
        "accounts": [
          "99999999-aaaa-bbbb-cccc-dddddddddddd"
        ],
        "user_language": "en",
        "link": "https://ob.gocardless.com/ob-psd2/start/demo/HSBC_NET_HSBCIE2D",
        "ssn": null,
        "account_selection": false,
        "redirect_immediate": false
      },
      "accountInformation": {
        "iban": "GB00HBUK00000000000000",
        "bic": null,
        "accountNo": null,
        "sortCode": null
      },
      "company": {
        "authorisationReferences": [
          {
            "internalReferenceId": "conn_01k65c324keshspebagxy5dwy5",
            "fspAdapter": "GOCARDLESS_DEMO_DATA",
            "institutionId": "REVOLUT_REVOLT21",
            "externalReferenceId": "27a1d0ae-02bf-459d-9e75-e4b6ec458ef9"
          },
          {
            "internalReferenceId": "conn_01k6bbe6nrfvhrjkxwpmrmbwq6",
            "fspAdapter": "GOCARDLESS_DEMO_DATA",
            "institutionId": "HSBC_NET_HSBCIE2D",
            "externalReferenceId": "11111111-2222-3333-4444-555555555555"
          },
          {
            "internalReferenceId": "conn_01k6bef5yafvq949t2gk14wf0s",
            "externalReferenceId": "79a1d0b2-ebfc-4365-ab17-bd3c56aa64e6",
            "fspAdapter": "YAPILY",
            "institutionId": "aibbusiness",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6befzm7fvq949tdz29gnm4x",
            "externalReferenceId": "0b905d6f-6abc-4d76-82aa-a758a472a907",
            "fspAdapter": "YAPILY",
            "institutionId": "wise-live",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6beggm0fvq949tp5t9x4wmy",
            "externalReferenceId": "292fdd73-0f7c-470c-9ffb-dd647b6b53f6",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6beh9mzfvq949tz540vjv00",
            "externalReferenceId": "a2252609-aa40-4a6e-adf4-3075f73a5153",
            "fspAdapter": "YAPILY",
            "institutionId": "ing",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6behc6hfvq949v7b5j7xs4b",
            "externalReferenceId": "627fb60a-b00e-4295-aea0-7fa9e5686ada",
            "fspAdapter": "YAPILY",
            "institutionId": "hsbccorporate_eu",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6bf9sbze06ahjehh3fqeqbf",
            "externalReferenceId": "6e823814-9733-4178-8399-293bfdfe2d22",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          },
          {
            "internalReferenceId": "conn_01k6bft31xe8gbpwwcs025mc5z",
            "externalReferenceId": "eae1d334-7a66-4adf-87a0-2df191571632",
            "fspAdapter": "YAPILY",
            "institutionId": "ing",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          },
          {
            "internalReferenceId": "conn_01k6bh8g7keh5vq8wcj2574r9n",
            "externalReferenceId": "3a4a4df9-60ca-461d-b359-495f8a777cc1",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          }
        ],
        "id": "com_01k1y1ypa1fqfbnc9xn5secx0d",
        "createdAt": "2025-08-05T22:24:46.014Z",
        "updatedAt": "2025-09-29T21:05:11.929Z",
        "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
        "legalEntity": {
          "name": "RUCHI RESTAURANT LIMITED",
          "type": "LTD - Private Company Limited by Shares",
          "country": "IE",
          "registrationNo": "719039"
        },
        "registeredAddress": {
          "street": "TIM LOOBY ACCOUNTANTS",
          "city": "3 BANK PLACE",
          "county": "SLIEVENAMON ROAD",
          "postalCode": "E41 D430",
          "country": "Ireland"
        }
      },
      "institution": {
        "id": "01k4tqwq8cfzssq90gxxgq963v",
        "createdAt": "2025-09-10T22:18:17.853Z",
        "updatedAt": "2025-09-10T22:18:17.853Z",
        "externalId": "HSBC_NET_HSBCIE2D",
        "name": "HSBC Net",
        "bic": "HSBCIE2DXXX",
        "transactionTotalDays": 730,
        "countries": [
          "IE",
          "GB"
        ],
        "logo": "https://images.yapily.com/image/fc734d3c-4480-471e-94ee-500f83ae3bae",
        "maxAccessValidForDays": 180
      },
      "syncResult": {
        "id": "syncres_01k6bbebrhfvhrjkyvdftv1d58",
        "createdAt": "2026-01-15T11:23:31.601Z",
        "updatedAt": "2026-01-15T11:23:31.867Z",
        "entityId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
        "entityType": "ACCOUNT",
        "syncStatus": "COMPLETE",
        "lastSyncAttemptAt": "2026-01-15T14:22:18.318Z",
        "nextSyncAt": "2026-01-15T12:23:31.601Z",
        "syncError": null,
        "syncStats": {
          "transactionsSynced": 104
        }
      }
    },
    {
      "transitions": [
        {
          "fromState": "UNLINKED",
          "event": "LINK_START",
          "toState": "LINKING"
        },
        {
          "fromState": "LINKING",
          "event": "LINK_END",
          "toState": "LINKED"
        },
        {
          "fromState": "LINKED",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKING",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKED",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNCING",
          "event": "SYNC_END",
          "toState": "SYNCED"
        },
        {
          "fromState": "SYNCING",
          "event": "SYNC_ERROR",
          "toState": "SYNC_ERROR"
        },
        {
          "fromState": "SYNCED",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCED",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNC_ERROR",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNC_ERROR",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKED",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCED",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCING",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKING",
          "event": "UNLINK",
          "toState": "UNLINKED"
        }
      ],
      "state": "LINKED",
      "id": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "createdAt": "2025-10-01T11:08:43.301Z",
      "updatedAt": "2025-10-01T11:53:58.096Z",
      "type": "BANKING",
      "fspIdentifier": "A2100FVFV2",
      "displayName": "Seapoint Current Account",
      "currency": "EUR",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "name": "RUCHI RESTAURANT LIMITED",
      "status": "ACTIVE",
      "interimAvailableBalance": 3137902.65,
      "expectedBalance": 3137902.65,
      "closingBookedBalance": 3137902.65,
      "institutionId": null,
      "fspAdapter": "MODULR",
      "fspRecord": null,
      "fspConnectionRecord": null,
      "accountInformation": {
        "iban": "GB93MOCK00000005223150",
        "bic": "MOCKGB21",
        "accountNo": null,
        "sortCode": null
      },
      "company": {
        "authorisationReferences": [
          {
            "internalReferenceId": "conn_01k65c324keshspebagxy5dwy5",
            "fspAdapter": "GOCARDLESS_DEMO_DATA",
            "institutionId": "REVOLUT_REVOLT21",
            "externalReferenceId": "27a1d0ae-02bf-459d-9e75-e4b6ec458ef9"
          },
          {
            "internalReferenceId": "conn_01k6bbe6nrfvhrjkxwpmrmbwq6",
            "fspAdapter": "GOCARDLESS_DEMO_DATA",
            "institutionId": "HSBC_NET_HSBCIE2D",
            "externalReferenceId": "11111111-2222-3333-4444-555555555555"
          },
          {
            "internalReferenceId": "conn_01k6bef5yafvq949t2gk14wf0s",
            "externalReferenceId": "79a1d0b2-ebfc-4365-ab17-bd3c56aa64e6",
            "fspAdapter": "YAPILY",
            "institutionId": "aibbusiness",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6befzm7fvq949tdz29gnm4x",
            "externalReferenceId": "0b905d6f-6abc-4d76-82aa-a758a472a907",
            "fspAdapter": "YAPILY",
            "institutionId": "wise-live",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6beggm0fvq949tp5t9x4wmy",
            "externalReferenceId": "292fdd73-0f7c-470c-9ffb-dd647b6b53f6",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6beh9mzfvq949tz540vjv00",
            "externalReferenceId": "a2252609-aa40-4a6e-adf4-3075f73a5153",
            "fspAdapter": "YAPILY",
            "institutionId": "ing",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6behc6hfvq949v7b5j7xs4b",
            "externalReferenceId": "627fb60a-b00e-4295-aea0-7fa9e5686ada",
            "fspAdapter": "YAPILY",
            "institutionId": "hsbccorporate_eu",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6bf9sbze06ahjehh3fqeqbf",
            "externalReferenceId": "6e823814-9733-4178-8399-293bfdfe2d22",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          },
          {
            "internalReferenceId": "conn_01k6bft31xe8gbpwwcs025mc5z",
            "externalReferenceId": "eae1d334-7a66-4adf-87a0-2df191571632",
            "fspAdapter": "YAPILY",
            "institutionId": "ing",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          },
          {
            "internalReferenceId": "conn_01k6bh8g7keh5vq8wcj2574r9n",
            "externalReferenceId": "3a4a4df9-60ca-461d-b359-495f8a777cc1",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          }
        ],
        "id": "com_01k1y1ypa1fqfbnc9xn5secx0d",
        "createdAt": "2025-08-05T22:24:46.014Z",
        "updatedAt": "2025-09-29T21:05:11.929Z",
        "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
        "legalEntity": {
          "name": "RUCHI RESTAURANT LIMITED",
          "type": "LTD - Private Company Limited by Shares",
          "country": "IE",
          "registrationNo": "719039"
        },
        "registeredAddress": {
          "street": "TIM LOOBY ACCOUNTANTS",
          "city": "3 BANK PLACE",
          "county": "SLIEVENAMON ROAD",
          "postalCode": "E41 D430",
          "country": "Ireland"
        }
      },
      "institution": null,
      "syncResult": {
        "id": "syncres_01k6fkxs9wfzz9aek0wfbs0n01",
        "createdAt": "2025-10-01T11:08:43.318Z",
        "updatedAt": "2025-10-01T11:08:43.318Z",
        "entityId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
        "entityType": "ACCOUNT",
        "syncStatus": "PENDING",
        "lastSyncAttemptAt": null,
        "nextSyncAt": "2025-10-01T10:08:43.318Z",
        "syncError": null,
        "syncStats": null
      }
    },
    {
      "transitions": [
        {
          "fromState": "UNLINKED",
          "event": "LINK_START",
          "toState": "LINKING"
        },
        {
          "fromState": "LINKING",
          "event": "LINK_END",
          "toState": "LINKED"
        },
        {
          "fromState": "LINKED",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKING",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKED",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNCING",
          "event": "SYNC_END",
          "toState": "SYNCED"
        },
        {
          "fromState": "SYNCING",
          "event": "SYNC_ERROR",
          "toState": "SYNC_ERROR"
        },
        {
          "fromState": "SYNCED",
          "event": "LINK_ERROR",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCED",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNC_ERROR",
          "event": "SYNC_START",
          "toState": "SYNCING"
        },
        {
          "fromState": "SYNC_ERROR",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKED",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCED",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "SYNCING",
          "event": "UNLINK",
          "toState": "UNLINKED"
        },
        {
          "fromState": "LINKING",
          "event": "UNLINK",
          "toState": "UNLINKED"
        }
      ],
      "state": "LINKED",
      "id": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
      "createdAt": "2025-10-01T11:08:43.301Z",
      "updatedAt": "2026-01-15T14:22:18.096Z",
      "type": "BANKING",
      "fspIdentifier": "A2100GBPW1",
      "displayName": "Seapoint GBP Wallet",
      "currency": "GBP",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "name": "RUCHI RESTAURANT LIMITED",
      "status": "ACTIVE",
      "interimAvailableBalance": 847532.18,
      "expectedBalance": 847532.18,
      "closingBookedBalance": 847532.18,
      "institutionId": null,
      "fspAdapter": "MODULR",
      "fspRecord": null,
      "fspConnectionRecord": null,
      "accountInformation": {
        "iban": null,
        "bic": null,
        "accountNo": "31926847",
        "sortCode": "040075"
      },
      "company": {
        "authorisationReferences": [
          {
            "internalReferenceId": "conn_01k65c324keshspebagxy5dwy5",
            "fspAdapter": "GOCARDLESS_DEMO_DATA",
            "institutionId": "REVOLUT_REVOLT21",
            "externalReferenceId": "27a1d0ae-02bf-459d-9e75-e4b6ec458ef9"
          },
          {
            "internalReferenceId": "conn_01k6bbe6nrfvhrjkxwpmrmbwq6",
            "fspAdapter": "GOCARDLESS_DEMO_DATA",
            "institutionId": "HSBC_NET_HSBCIE2D",
            "externalReferenceId": "11111111-2222-3333-4444-555555555555"
          },
          {
            "internalReferenceId": "conn_01k6bef5yafvq949t2gk14wf0s",
            "externalReferenceId": "79a1d0b2-ebfc-4365-ab17-bd3c56aa64e6",
            "fspAdapter": "YAPILY",
            "institutionId": "aibbusiness",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6befzm7fvq949tdz29gnm4x",
            "externalReferenceId": "0b905d6f-6abc-4d76-82aa-a758a472a907",
            "fspAdapter": "YAPILY",
            "institutionId": "wise-live",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6beggm0fvq949tp5t9x4wmy",
            "externalReferenceId": "292fdd73-0f7c-470c-9ffb-dd647b6b53f6",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6beh9mzfvq949tz540vjv00",
            "externalReferenceId": "a2252609-aa40-4a6e-adf4-3075f73a5153",
            "fspAdapter": "YAPILY",
            "institutionId": "ing",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6behc6hfvq949v7b5j7xs4b",
            "externalReferenceId": "627fb60a-b00e-4295-aea0-7fa9e5686ada",
            "fspAdapter": "YAPILY",
            "institutionId": "hsbccorporate_eu",
            "externalUserReferenceId": "6086ab7d-2f1f-4429-ae09-a7d6c8ba16e6"
          },
          {
            "internalReferenceId": "conn_01k6bf9sbze06ahjehh3fqeqbf",
            "externalReferenceId": "6e823814-9733-4178-8399-293bfdfe2d22",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          },
          {
            "internalReferenceId": "conn_01k6bft31xe8gbpwwcs025mc5z",
            "externalReferenceId": "eae1d334-7a66-4adf-87a0-2df191571632",
            "fspAdapter": "YAPILY",
            "institutionId": "ing",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          },
          {
            "internalReferenceId": "conn_01k6bh8g7keh5vq8wcj2574r9n",
            "externalReferenceId": "3a4a4df9-60ca-461d-b359-495f8a777cc1",
            "fspAdapter": "YAPILY",
            "institutionId": "permanent-tsb",
            "externalUserReferenceId": "e93d2f88-b413-4b6b-bd8f-24ad6adacda1"
          }
        ],
        "id": "com_01k1y1ypa1fqfbnc9xn5secx0d",
        "createdAt": "2025-08-05T22:24:46.014Z",
        "updatedAt": "2025-09-29T21:05:11.929Z",
        "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
        "legalEntity": {
          "name": "RUCHI RESTAURANT LIMITED",
          "type": "LTD - Private Company Limited by Shares",
          "country": "IE",
          "registrationNo": "719039"
        },
        "registeredAddress": {
          "street": "TIM LOOBY ACCOUNTANTS",
          "city": "3 BANK PLACE",
          "county": "SLIEVENAMON ROAD",
          "postalCode": "E41 D430",
          "country": "Ireland"
        }
      },
      "institution": null,
      "syncResult": {
        "id": "syncres_01k7gbp3qwfzz9aentk8bs1n02",
        "createdAt": "2025-10-01T11:08:43.318Z",
        "updatedAt": "2026-01-15T14:22:18.318Z",
        "entityId": "acc_01k7gbp3q6fzz9aemtjkr5h2wp",
        "entityType": "ACCOUNT",
        "syncStatus": "COMPLETE",
        "lastSyncAttemptAt": "2026-01-15T14:22:18.318Z",
        "nextSyncAt": "2026-01-15T15:22:18.318Z",
        "syncError": null,
        "syncStats": {
          "transactionsSynced": 0
        }
      }
    }
  ],
  "payroll": [
    {
      "id": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "name": "December 2025 Payroll",
      "status": "SUCCEEDED",
      "period": "2025-12",
      "country": "GB",
      "currency": "GBP",
      "reference": "PAY-DEC-2025",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "copiedFromPayrollId": null,
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "createdById": "usr_01jwvb5j4he06aqw6yspcywgds",
      "approvedById": "usr_01jwvb5j4he06aqw6yspcywgds",
      "approvedAt": "2025-12-22T14:30:00.000Z",
      "paidById": "usr_01jwvb5j4he06aqw6yspcywgds",
      "paidAt": "2025-12-24T10:00:00.000Z"
    },
    {
      "id": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "name": "January 2026 Payroll",
      "status": "APPROVED",
      "period": "2026-01",
      "country": "GB",
      "currency": "GBP",
      "reference": "PAY-JAN-2026",
      "bulkPaymentId": "bp_fpymtas7cz76sdeffzyrxksfh4",
      "copiedFromPayrollId": null,
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "createdById": "usr_01jwvb5j4he06aqw6yspcywgds",
      "approvedById": "usr_01jwvb5j4he06aqw6yspcywgds",
      "approvedAt": "2026-01-13T11:00:00.000Z",
      "paidById": null,
      "paidAt": null
    },
    {
      "id": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "name": "February 2026 Payroll",
      "status": "IN_DRAFT",
      "period": "2026-02",
      "country": "GB",
      "currency": "GBP",
      "reference": "PAY-FEB-2026",
      "bulkPaymentId": null,
      "copiedFromPayrollId": null,
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "createdById": "usr_01jwvb5j4he06aqw6yspcywgds",
      "approvedById": null,
      "approvedAt": null,
      "paidById": null,
      "paidAt": null
    }
  ],
  "user": [
    {
      "id": "usr_01jwvb5j4he06aqw6yspcywgds",
      "createdAt": "2025-06-03T17:49:35.832Z",
      "updatedAt": "2025-06-03T17:49:35.832Z",
      "authenticationId": "auth0|6835fa3f6b5212ca7c77d014",
      "emailAddress": "dago+1@seapoint.co",
      "emailVerified": true,
      "pictureUrl": "https://s.gravatar.com/avatar/ab08bddf23287c4b639f71a352515b95?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fda.png",
      "firstName": null,
      "lastName": null,
      "organisations": [
        {
          "id": "org_01k1y1x3vmfqfbnc337k9crvrg",
          "createdAt": "2025-08-05T22:23:54.296Z",
          "updatedAt": "2025-10-07T23:17:37.386Z",
          "name": "Acme Tech Ltd",
          "auth0OrgId": "org_afqL8bt2jeTR2446",
          "logoUrl": null
        }
      ]
    },
    {
      "id": "usr_01jwe7pbysfzzvgx5yxa50bzxb",
      "createdAt": "2025-05-29T15:38:44.573Z",
      "updatedAt": "2025-05-29T15:38:44.573Z",
      "authenticationId": "google-oauth2|115422967839592778187",
      "emailAddress": "dago@seapoint.co",
      "emailVerified": true,
      "pictureUrl": "https://lh3.googleusercontent.com/a/ACg8ocJmBfyq5Z2otoBqIY_AVj7r_tC5OecMU68o7TFt6l7jqhp-dg=s96-c",
      "firstName": "Dagoberto",
      "lastName": "Vaquedano Garrido",
      "organisations": []
    }
  ],
  "category": [
    {
      "id": "cat_01k1y1x3vvfqfbnc3c242j24mh",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 1,
      "level1": "Revenue",
      "level2": "Product Revenue",
      "icon": "fa-box",
      "description": "Revenue from product sales",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vxfqfbnc3g0c26f170",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 2,
      "level1": "Revenue",
      "level2": "Service Revenue",
      "icon": "fa-handshake",
      "description": "Revenue from service offerings",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vxfqfbnc3vw8ac23hc",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 3,
      "level1": "Cost of Goods Sold",
      "level2": "Hosting & Infrastructure",
      "icon": "fa-server",
      "description": "Hosting and infrastructure costs",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vxfqfbnc45pqdr3dej",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 4,
      "level1": "Cost of Goods Sold",
      "level2": "Direct Product Costs",
      "icon": "fa-tags",
      "description": "Direct costs associated with products",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vxfqfbnc49gmfg6y22",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 5,
      "level1": "Operating Expenses",
      "level2": "Payroll & Benefits",
      "icon": "fa-users",
      "description": "Employee compensation and benefits",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vxfqfbnc4kbv22w5yd",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 6,
      "level1": "Operating Expenses",
      "level2": "Marketing & Advertising",
      "icon": "fa-bullhorn",
      "description": "Marketing and advertising expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc4xx59bytg3",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 7,
      "level1": "Operating Expenses",
      "level2": "Food & Dining",
      "icon": "fa-utensils",
      "description": "Food and dining expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc57amdf3sm0",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 8,
      "level1": "Operating Expenses",
      "level2": "Subscriptions",
      "icon": "fa-credit-card",
      "description": "Subscription service expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc59pk2rkvyw",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 9,
      "level1": "Operating Expenses",
      "level2": "Travel & Entertainment",
      "icon": "fa-plane",
      "description": "Travel and entertainment expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc5npxt1ag4k",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 10,
      "level1": "Operating Expenses",
      "level2": "Rent",
      "icon": "fa-building",
      "description": "Rental expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc5z91f605yh",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 11,
      "level1": "Operating Expenses",
      "level2": "Office Expenses",
      "icon": "fa-briefcase",
      "description": "General office expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc65nns560jv",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 12,
      "level1": "Operating Expenses",
      "level2": "Legal & Professional Fees",
      "icon": "fa-gavel",
      "description": "Legal and professional service fees",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc6c079de8y4",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 13,
      "level1": "Operating Expenses",
      "level2": "Accounting",
      "icon": "fa-calculator",
      "description": "Accounting and bookkeeping expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc6j8ndjvetp",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 14,
      "level1": "Operating Expenses",
      "level2": "Bank Fees",
      "icon": "fa-landmark",
      "description": "Banking and financial service fees",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc6sarv8xknq",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 15,
      "level1": "Operating Expenses",
      "level2": "Consulting",
      "icon": "fa-user-tie",
      "description": "Consulting service expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc70gm9hyfkj",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 16,
      "level1": "Operating Expenses",
      "level2": "Contractors",
      "icon": "fa-user-gear",
      "description": "Contractor and freelancer expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc7b4s08k94h",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 17,
      "level1": "Operating Expenses",
      "level2": "General Expenses",
      "icon": "fa-receipt",
      "description": "Miscellaneous general expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vyfqfbnc7ghb9eae2d",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 18,
      "level1": "Operating Expenses",
      "level2": "Insurance",
      "icon": "fa-shield-halved",
      "description": "Insurance premium expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vzfqfbnc7xsxbf7xfj",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 19,
      "level1": "Operating Expenses",
      "level2": "Licence fees",
      "icon": "fa-id-card",
      "description": "License and permit fees",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vzfqfbnc83dyq7vn0b",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 20,
      "level1": "Operating Expenses",
      "level2": "Building maintenance and repairs",
      "icon": "fa-hammer",
      "description": "Building maintenance and repair expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vzfqfbnc8cetyx8vdd",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 21,
      "level1": "Operating Expenses",
      "level2": "Legal fees",
      "icon": "fa-scale-balanced",
      "description": "Legal service fees",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vzfqfbnc8h0aw1f003",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 22,
      "level1": "Operating Expenses",
      "level2": "Motoring/Vehicle expenses",
      "icon": "fa-car",
      "description": "Vehicle and transportation expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vzfqfbnc8yqdcazbqv",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 23,
      "level1": "Financial Items",
      "level2": "Capital Investments",
      "icon": "fa-chart-line",
      "description": "Capital investment expenses",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vzfqfbnc93rmq5argt",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 24,
      "level1": "Financial Items",
      "level2": "Internal Transfers",
      "icon": "fa-arrows-rotate",
      "description": "Internal fund transfers",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "cat_01k1y1x3vzfqfbnc9as65wbxd5",
      "createdAt": "2025-08-05T22:23:54.296Z",
      "updatedAt": "2025-08-05T22:23:54.296Z",
      "order": 25,
      "level1": "Financial Items",
      "level2": "Interest Income",
      "icon": "fa-percent",
      "description": "Interest income from investments",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    }
  ],
  "documents": [
    {
      "id": "doc_01k6da0fccenabvqzyxx67kppb",
      "createdAt": "2025-09-30T13:36:56.843Z",
      "updatedAt": "2025-09-30T13:36:56.843Z",
      "type": "INVOICE",
      "entityId": null,
      "fileName": "Pembr-Invoice.pdf",
      "bucket": "common-local-bucket-f327b336348aab0fabf9c9e1e02e9668",
      "key": "invoices/org_01k1y1x3vmfqfbnc337k9crvrg/usr_01jwvb5j4he06aqw6yspcywgds/1759235816596-Pembr-Invoice.pdf",
      "location": "https://common-local-bucket-f327b336348aab0fabf9c9e1e02e9668.s3.eu-west-1.amazonaws.com/invoices/org_01k1y1x3vmfqfbnc337k9crvrg/usr_01jwvb5j4he06aqw6yspcywgds/1759235816596-Pembr-Invoice.pdf",
      "uploadedById": "usr_01jwvb5j4he06aqw6yspcywgds",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "doc_01k6fp0badfzz9aeq5pjjv3961",
      "createdAt": "2025-10-01T11:45:04.459Z",
      "updatedAt": "2025-10-01T11:45:04.459Z",
      "type": "INVOICE",
      "entityId": null,
      "fileName": "Pembr-Invoice.pdf",
      "bucket": "common-local-bucket-f327b336348aab0fabf9c9e1e02e9668",
      "key": "invoices/org_01k1y1x3vmfqfbnc337k9crvrg/usr_01jwvb5j4he06aqw6yspcywgds/1759315504270-Pembr-Invoice.pdf",
      "location": "https://common-local-bucket-f327b336348aab0fabf9c9e1e02e9668.s3.eu-west-1.amazonaws.com/invoices/org_01k1y1x3vmfqfbnc337k9crvrg/usr_01jwvb5j4he06aqw6yspcywgds/1759315504270-Pembr-Invoice.pdf",
      "uploadedById": "usr_01jwvb5j4he06aqw6yspcywgds",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg"
    },
    {
      "id": "doc_n3msy4pqxey6nt8kppd743h3zv",
      "createdAt": "2025-12-01T12:00:00.000Z",
      "updatedAt": "2025-12-01T12:00:00.000Z",
      "fileName": "aws-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/aws-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    },
    {
      "id": "doc_2ns21ggjmm3sebvkhm9zxsewn1",
      "createdAt": "2025-12-15T12:00:00.000Z",
      "updatedAt": "2025-12-15T12:00:00.000Z",
      "fileName": "openai-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/openai-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    },
    {
      "id": "doc_sv9ay8wq2vnvmjdth8q8vf5ts9",
      "createdAt": "2025-12-20T12:00:00.000Z",
      "updatedAt": "2025-12-20T12:00:00.000Z",
      "fileName": "anthropic-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/anthropic-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    },
    {
      "id": "doc_b6x9qd0f8vh85v4ba6wzf2ydrn",
      "createdAt": "2026-01-05T12:00:00.000Z",
      "updatedAt": "2026-01-05T12:00:00.000Z",
      "fileName": "slack-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/slack-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    },
    {
      "id": "doc_pxdp6bgpscms04wchyezws8n99",
      "createdAt": "2026-01-08T12:00:00.000Z",
      "updatedAt": "2026-01-08T12:00:00.000Z",
      "fileName": "github-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/github-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    },
    {
      "id": "doc_r23jxkryjq6n808d4j4c9q64qn",
      "createdAt": "2026-01-10T12:00:00.000Z",
      "updatedAt": "2026-01-10T12:00:00.000Z",
      "fileName": "wework-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/wework-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    },
    {
      "id": "doc_rptg70arfctnpfkc4retv5sdd2",
      "createdAt": "2026-01-12T12:00:00.000Z",
      "updatedAt": "2026-01-12T12:00:00.000Z",
      "fileName": "notion-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/notion-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    },
    {
      "id": "doc_1fcnvg1chk7sfgzyy7jymwgxbb",
      "createdAt": "2026-01-13T12:00:00.000Z",
      "updatedAt": "2026-01-13T12:00:00.000Z",
      "fileName": "office-supplies-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/office-supplies-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    },
    {
      "id": "doc_ffaf1rqs7yghvcrcw4fj64bm6p",
      "createdAt": "2026-01-14T12:00:00.000Z",
      "updatedAt": "2026-01-14T12:00:00.000Z",
      "fileName": "vercel-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/vercel-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    },
    {
      "id": "doc_y5pymkmx7vq309w5nkvgbhcwsj",
      "createdAt": "2026-01-06T12:00:00.000Z",
      "updatedAt": "2026-01-06T12:00:00.000Z",
      "fileName": "pembroke-hall-invoice.pdf",
      "contentType": "application/pdf",
      "key": "demo/invoices/pembroke-hall-invoice.pdf",
      "bucketName": "local",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "pageCount": 1
    }
  ],
  "payment": [
    {
      "id": "pi_01k6fm8njrfzz9aekd7czfe3zs",
      "createdAt": "2025-10-01T11:14:39.966Z",
      "updatedAt": "2025-10-01T11:14:39.966Z",
      "status": "SUCCEEDED",
      "type": "INBOUND",
      "amount": 3141592.65,
      "currency": "EUR",
      "reference": "P2100MSVC0",
      "sourceAccountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "evidenceId": null,
      "beneficiaryId": null,
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "externalReferenceId": "P2100MSVC0",
      "fspAdapter": "MODULR",
      "fspRecord": {
        "id": "P2100MSVC0",
        "status": "PROCESSED",
        "createdDate": "2025-10-01T10:14:34.034+0000",
        "details": {
          "created": "2025-10-01T10:14:34.456+00:00",
          "retryCount": 0,
          "sourceService": "inboundPaymentService",
          "requestReference": "mockApiCredit",
          "reprocess": false,
          "priority": 0,
          "accountNumber": "A2100FVFV2",
          "posted": "2025-10-01T10:14:34.456+00:00",
          "type": "PI_BACS",
          "amount": 3141592.65,
          "currency": "EUR",
          "description": "Payment from Captain Nemo: Inbound",
          "providerCode": "MOCK",
          "ledgerBankCode": "MOCK",
          "payerName": "Captain Nemo",
          "payer": {
            "name": "Captain Nemo",
            "identifier": {
              "type": "SCAN",
              "accountNumber": "33188038",
              "sortCode": "000000"
            },
            "address": {
              "addressLine1": "Mock Address Line 1",
              "country": "GB"
            }
          },
          "payee": {
            "name": "name_01jnggpbwvfk68mjphwrydty5b",
            "identifier": {
              "type": "IBAN",
              "iban": "GB93MOCK00000005223150",
              "bic": "MOCKGB21"
            }
          },
          "clearingRequired": false,
          "originatedOverseas": false,
          "details": {},
          "manualRecall": false
        },
        "reference": "P2100MSVC0",
        "createdBy": "U2102BSP",
        "type": "PAYIN",
        "currentUserCanApprove": false,
        "approvals": []
      },
      "bulkPaymentId": null,
      "payeeCheckId": null,
      "destination": {
        "type": null,
        "id": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null,
        "name": null
      },
      "payer": {
        "type": "SCAN",
        "id": null,
        "iban": null,
        "bic": null,
        "sortCode": "000000",
        "accountNumber": "33188038",
        "name": "Captain Nemo"
      }
    },
    {
      "id": "pi_01k6fpf178fzz9aerwenmjwyqw",
      "createdAt": "2025-10-01T11:53:05.640Z",
      "updatedAt": "2025-10-01T11:53:05.957Z",
      "status": "PROCESSING",
      "type": "OUTBOUND",
      "amount": 3690,
      "currency": "EUR",
      "reference": "150660",
      "sourceAccountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "evidenceId": "evi_01k6fp0bb3fzz9aeqfxd6y4tf4",
      "beneficiaryId": "benf_01k6da2eq9enabvr1mt32wrpx6",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "externalReferenceId": null,
      "fspAdapter": "MODULR",
      "fspRecord": null,
      "bulkPaymentId": null,
      "payeeCheckId": null,
      "destination": {
        "type": "BENEFICIARY",
        "id": "benf_01k6da2eq9enabvr1mt32wrpx6",
        "iban": "IE15BOFI99999999999901",
        "bic": null,
        "sortCode": null,
        "accountNumber": null,
        "name": "Pembroke Hall Limited"
      },
      "payer": {
        "type": null,
        "id": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null,
        "name": null
      }
    },
    {
      "id": "pi_01k6fpfzf5fzz9aesh41443cw0",
      "createdAt": "2025-10-01T11:53:36.608Z",
      "updatedAt": "2025-10-01T11:53:58.096Z",
      "status": "SUCCEEDED",
      "type": "OUTBOUND",
      "amount": 3690,
      "currency": "EUR",
      "reference": "150660",
      "sourceAccountId": "acc_01k6fkxs96fzz9aejtgar4j8xp",
      "evidenceId": "evi_01k6fp0bb3fzz9aeqfxd6y4tf4",
      "beneficiaryId": "benf_01k6da2eq9enabvr1mt32wrpx6",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "externalReferenceId": "P2100MSW3J",
      "fspAdapter": "MODULR",
      "fspRecord": {
        "id": "P2100MSW3J",
        "status": "PROCESSED",
        "createdDate": "2025-10-01T10:53:51.051+0000",
        "externalReference": "pi_01k6fpfzf5fzz9aesh41443cw0",
        "details": {
          "sourceAccountId": "A2100FVFV2",
          "destination": {
            "type": "IBAN",
            "iban": "IE15BOFI99999999999901",
            "name": "Pembroke Hall Limited"
          },
          "currency": "EUR",
          "amount": 3690,
          "reference": "150660",
          "externalReference": "pi_01k6fpfzf5fzz9aesh41443cw0",
          "includeBlockedAccount": false
        },
        "reference": "P2100MSW3J",
        "approvalStatus": "NOTNEEDED",
        "schemeInfo": {
          "name": "SEPA_INSTANT"
        },
        "createdBy": "U2102BSP",
        "type": "PAYOUT",
        "currentUserCanApprove": false,
        "approvals": []
      },
      "bulkPaymentId": null,
      "payeeCheckId": null,
      "destination": {
        "type": "BENEFICIARY",
        "id": "benf_01k6da2eq9enabvr1mt32wrpx6",
        "iban": "IE15BOFI99999999999901",
        "bic": null,
        "sortCode": null,
        "accountNumber": null,
        "name": "Pembroke Hall Limited"
      },
      "payer": {
        "type": null,
        "id": null,
        "iban": null,
        "bic": null,
        "sortCode": null,
        "accountNumber": null,
        "name": null
      }
    }
  ],
  "payroll_record": [
    {
      "id": "payr_s0b40xwmc44q94j3pmtgc15cer",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 8500,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_b1q1xwfrt9zw5y5hwvgy3qjk8g",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_zq3md5qpz0r532nqdyznhjpkgc",
      "deletedAt": null
    },
    {
      "id": "payr_63nb3qfwh6q5pvareva90bw386",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 7500,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_x0gfyk80m4h3xtcy7kf9gj27my",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_m0gdmee0j4kcevsjhbqzx5f7tc",
      "deletedAt": null
    },
    {
      "id": "payr_s1r2d1s05pxjx593q9s15m793w",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 7200,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_06asj0g5mwck761jcf34pz6847",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_vfcnttyse3amrgevzk930dqnz3",
      "deletedAt": null
    },
    {
      "id": "payr_d6xrm2zrfq96m82yvyyxv1n590",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 5200,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_dh8tmh6k4tayn9q5mt83hftb79",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_7hpe8spyagpaja1rkkmfdc05x4",
      "deletedAt": null
    },
    {
      "id": "payr_h9fw2w2zwss2pfxjxacf334ct1",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 5050,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_5s6q4bd0m15kxpt8q6s69ma74t",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_8fenvh4xjzer5s14vyzj7yxn2q",
      "deletedAt": null
    },
    {
      "id": "payr_t50rajjhm497n3egkrkqdneqgj",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 4100,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_kfrbmt4scanx753mqwq1jccppt",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_kdf5p201675t6z7f8j4dvdm1xs",
      "deletedAt": null
    },
    {
      "id": "payr_qw1h6pv23rntc05gqhhssgmr53",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 3950,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_9as0h59mrv08jj8391v0a02gej",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_jhf30xfk1pnt2x0csdkbgffce8",
      "deletedAt": null
    },
    {
      "id": "payr_70j3hw2ddbmkdzzzt4eqwjbegn",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 3000,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_84qdv353499f74c2hdm25w2ayp",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_v84e4dkk0a108gmgyxddrex18x",
      "deletedAt": null
    },
    {
      "id": "payr_716qgv5ybbyevm48ybb2caqz1k",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 5700,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_9jmbpvrjbyhnnfayk15f8q2r8t",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_0m3h0ystzhdkv089qtpxgymy0p",
      "deletedAt": null
    },
    {
      "id": "payr_ys061rhxtqp36c31qd1450tg1d",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 4350,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_0x9wgbm1f2j9mbydgrvs2jbnt5",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_bqney2sngj9ht0vw439pk4s511",
      "deletedAt": null
    },
    {
      "id": "payr_7ngp06ptm2qg27jhkc2vk56sks",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 3750,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_csev4dpyfc4q00kmn3zd57j3ma",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_x6438kwbvw2mmzq5d8r2ay8ngh",
      "deletedAt": null
    },
    {
      "id": "payr_jzskg87sbh5kmpxhn8qhzjf4y8",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 4950,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_a6czazny63d85f674fg9j41y31",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_5dpt32a2e7pkakyx43wq731mxb",
      "deletedAt": null
    },
    {
      "id": "payr_pamq2r328dsekgcy2n9991apzq",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 3400,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_c7ctjypt89a30xp631b80wcmsf",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_jvrzahwp2f269f98adpnxzyhkr",
      "deletedAt": null
    },
    {
      "id": "payr_y97bjgarjg2nj4g475fw9er3yr",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 3550,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_frr7tbcj2nzag4wrqyzjy3q33v",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_p6mwbj7ht9st1k0nq5q8b37z5p",
      "deletedAt": null
    },
    {
      "id": "payr_vrzcmj9kmz7hrgcdk9ex51xjt2",
      "createdAt": "2025-12-20T09:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "netPay": 2850,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": "pmnt_rvqk9shbyytqatw23rw6m7r3ae",
      "payrollId": "pay_rn1t5292606mbtdfsyy5t48ky4",
      "employeeId": "emp_3srkf2v3egerrjbg157ssedxb8",
      "deletedAt": null
    },
    {
      "id": "payr_mhey2f82a65jmdxqsh3sne64wy",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 8500,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_zq3md5qpz0r532nqdyznhjpkgc",
      "deletedAt": null
    },
    {
      "id": "payr_2c13b9zkqgja91x2dyhxgvjy9j",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 7500,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_m0gdmee0j4kcevsjhbqzx5f7tc",
      "deletedAt": null
    },
    {
      "id": "payr_1gcj8vnen7ncxv80v4wc5bn1v1",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 7200,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_vfcnttyse3amrgevzk930dqnz3",
      "deletedAt": null
    },
    {
      "id": "payr_e4d7ny0rvn5nebvn73shc70103",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 5200,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_7hpe8spyagpaja1rkkmfdc05x4",
      "deletedAt": null
    },
    {
      "id": "payr_h4z3v37tp5tqy848ny6676zs2m",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 5050,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_8fenvh4xjzer5s14vyzj7yxn2q",
      "deletedAt": null
    },
    {
      "id": "payr_av66ctmz5pqn55r58qnazz7y1p",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 4100,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_kdf5p201675t6z7f8j4dvdm1xs",
      "deletedAt": null
    },
    {
      "id": "payr_tznxna7e29rmwg4dbndxvkpy7h",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 3950,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_jhf30xfk1pnt2x0csdkbgffce8",
      "deletedAt": null
    },
    {
      "id": "payr_2950j8t6nqx2bg311zxfttfvt9",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 3000,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_v84e4dkk0a108gmgyxddrex18x",
      "deletedAt": null
    },
    {
      "id": "payr_krmes5cwd4x9j82qag34775agp",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 5700,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_0m3h0ystzhdkv089qtpxgymy0p",
      "deletedAt": null
    },
    {
      "id": "payr_btabyq931e4ex0p30cjwd8e7jv",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 4350,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_bqney2sngj9ht0vw439pk4s511",
      "deletedAt": null
    },
    {
      "id": "payr_27cprgh5bj95ss9x5fwq7f0r3j",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 3750,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_x6438kwbvw2mmzq5d8r2ay8ngh",
      "deletedAt": null
    },
    {
      "id": "payr_4czmc62dqsg81w9wp670jxvepw",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 4950,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_5dpt32a2e7pkakyx43wq731mxb",
      "deletedAt": null
    },
    {
      "id": "payr_tjkxhntejcn3r318xzf1c13gzs",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 3400,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_jvrzahwp2f269f98adpnxzyhkr",
      "deletedAt": null
    },
    {
      "id": "payr_anttarqx9fv6v6190n2m05caee",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 3550,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_p6mwbj7ht9st1k0nq5q8b37z5p",
      "deletedAt": null
    },
    {
      "id": "payr_gdbrp90hj7vmar9zd21brpg5de",
      "createdAt": "2026-01-10T09:00:00.000Z",
      "updatedAt": "2026-01-13T11:00:00.000Z",
      "netPay": 2850,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_pcw446txdzytt0kd9cqd37ajhp",
      "employeeId": "emp_3srkf2v3egerrjbg157ssedxb8",
      "deletedAt": null
    },
    {
      "id": "payr_647pef5be0q8jng7vf3hpmynwv",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 8500,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_zq3md5qpz0r532nqdyznhjpkgc",
      "deletedAt": null
    },
    {
      "id": "payr_n440995rm0s28xmhzw9nfxjqhn",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 7500,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_m0gdmee0j4kcevsjhbqzx5f7tc",
      "deletedAt": null
    },
    {
      "id": "payr_javf5ydmzcrmamgv581cpyyh6z",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 7200,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_vfcnttyse3amrgevzk930dqnz3",
      "deletedAt": null
    },
    {
      "id": "payr_fp75j1xz693syvm2cyc56gbgg6",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 5200,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_7hpe8spyagpaja1rkkmfdc05x4",
      "deletedAt": null
    },
    {
      "id": "payr_w0trnjq144b2f4qjha4sgca6q5",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 5050,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_8fenvh4xjzer5s14vyzj7yxn2q",
      "deletedAt": null
    },
    {
      "id": "payr_vasbdsjjarj4vhgvqs7g6nnvfe",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 4100,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_kdf5p201675t6z7f8j4dvdm1xs",
      "deletedAt": null
    },
    {
      "id": "payr_mx9hzj2sm8r0hgb0zvqw2zxgqm",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 3950,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_jhf30xfk1pnt2x0csdkbgffce8",
      "deletedAt": null
    },
    {
      "id": "payr_jj2nk6egfh3nh2wv6g9sfn0jts",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 3000,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_v84e4dkk0a108gmgyxddrex18x",
      "deletedAt": null
    },
    {
      "id": "payr_6bdw0ev2svhafhtmakhr6v1s7k",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 5700,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_0m3h0ystzhdkv089qtpxgymy0p",
      "deletedAt": null
    },
    {
      "id": "payr_c0wsycvwaz0g8j0cncehmggx79",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 4350,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_bqney2sngj9ht0vw439pk4s511",
      "deletedAt": null
    },
    {
      "id": "payr_x5r167tkvx6n6x58ch88846a53",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 3750,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_x6438kwbvw2mmzq5d8r2ay8ngh",
      "deletedAt": null
    },
    {
      "id": "payr_v3056cjeybr2gn8z58rwd9wy4c",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 4950,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_5dpt32a2e7pkakyx43wq731mxb",
      "deletedAt": null
    },
    {
      "id": "payr_carm92m9pz5fs7m5645sxs2fpt",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 3400,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_jvrzahwp2f269f98adpnxzyhkr",
      "deletedAt": null
    },
    {
      "id": "payr_d3vbesngmm6n9zc4hrrnct2kes",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 3550,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_p6mwbj7ht9st1k0nq5q8b37z5p",
      "deletedAt": null
    },
    {
      "id": "payr_0v95t2ek2ee3zmbxct2py5pzq9",
      "createdAt": "2026-01-14T09:00:00.000Z",
      "updatedAt": "2026-01-14T09:00:00.000Z",
      "netPay": 2850,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "paymentId": null,
      "payrollId": "pay_qg3793t6vaqvntd6hah46qh7a2",
      "employeeId": "emp_3srkf2v3egerrjbg157ssedxb8",
      "deletedAt": null
    }
  ],
  "authorisation": [
    {
      "id": "auth_01k6fpf19ffzz9aes53xqg8nf4",
      "createdAt": "2025-10-01T11:53:05.711Z",
      "updatedAt": "2025-10-01T11:53:05.957Z",
      "type": "payment",
      "state": "2606f5a3-6c6a-43db-ae15-62edbf0c0086",
      "linkingId": null,
      "status": "PENDING",
      "authorisedAt": null,
      "authorisationRecord": null,
      "requiresSCA": false,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "userId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "paymentId": "pi_01k6fpf178fzz9aerwenmjwyqw",
      "authorisationUrl": null
    },
    {
      "id": "auth_01k6fpfzh0fzz9aestbnskg3ne",
      "createdAt": "2025-10-01T11:53:36.667Z",
      "updatedAt": "2025-10-01T11:53:51.150Z",
      "type": "payment",
      "state": "b08f1142-0a19-4496-9faf-7f0e8a838918",
      "linkingId": "ghcTRGlmTY-SujU5N-j8HMJO_Dw",
      "status": "AUTHORIZED",
      "authorisedAt": "2025-10-01T10:53:51.195Z",
      "authorisationRecord": [
        {
          "type": "payment_initiation",
          "amount": {
            "amount": 3690,
            "currency": "EUR"
          },
          "recipient": {
            "name": "Pembroke Hall Limited",
            "iban": "IE15BOFI99999999999901",
            "bic": null
          },
          "reference": "150660"
        }
      ],
      "requiresSCA": false,
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "userId": "usr_01jwvb5j4he06aqw6yspcywgds",
      "paymentId": "pi_01k6fpfzf5fzz9aesh41443cw0",
      "authorisationUrl": null
    }
  ],
  "payroll_payment": [
    {
      "id": "pmnt_b1q1xwfrt9zw5y5hwvgy3qjk8g",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 8500,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-MITCHELL",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_zq3md5qpz0r532nqdyznhjpkgc",
        "name": "Sarah Mitchell",
        "accountNumber": "12345601",
        "sortCode": "20-00-00",
        "iban": null
      },
      "fspPaymentId": "fsp_3kej18hah1pnb5fkxexsk1yg74",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_x0gfyk80m4h3xtcy7kf9gj27my",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 7500,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-ANDERSON",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_m0gdmee0j4kcevsjhbqzx5f7tc",
        "name": "James Anderson",
        "accountNumber": "12345602",
        "sortCode": "20-00-00",
        "iban": null
      },
      "fspPaymentId": "fsp_e7e30ne599bbjsrxr4arwzxsce",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_06asj0g5mwck761jcf34pz6847",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 7200,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-CHEN",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_vfcnttyse3amrgevzk930dqnz3",
        "name": "Emily Chen",
        "accountNumber": "87654301",
        "sortCode": "30-15-89",
        "iban": null
      },
      "fspPaymentId": "fsp_vmybx2hwcwed37f9346q5a8fdd",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_dh8tmh6k4tayn9q5mt83hftb79",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 5200,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-KUMAR",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_7hpe8spyagpaja1rkkmfdc05x4",
        "name": "David Kumar",
        "accountNumber": "23456701",
        "sortCode": "40-05-30",
        "iban": null
      },
      "fspPaymentId": "fsp_rhk03d1a9ggag5a534xb1nnfqr",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_5s6q4bd0m15kxpt8q6s69ma74t",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 5050,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-O'BRIEN",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_8fenvh4xjzer5s14vyzj7yxn2q",
        "name": "Sophie O'Brien",
        "accountNumber": "34567801",
        "sortCode": "90-01-23",
        "iban": null
      },
      "fspPaymentId": "fsp_xpsj5vngbwawe90h63ptdj2hce",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_kfrbmt4scanx753mqwq1jccppt",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 4100,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-TAYLOR",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_kdf5p201675t6z7f8j4dvdm1xs",
        "name": "Michael Taylor",
        "accountNumber": "45678901",
        "sortCode": "20-00-00",
        "iban": null
      },
      "fspPaymentId": "fsp_c51jxz9kjeb14g8h9hgkaj5sgh",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_9as0h59mrv08jj8391v0a02gej",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 3950,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-SHARMA",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_jhf30xfk1pnt2x0csdkbgffce8",
        "name": "Priya Sharma",
        "accountNumber": "56789012",
        "sortCode": "30-15-89",
        "iban": null
      },
      "fspPaymentId": "fsp_y68jgn1zvv2za2zxgy19c0s7s4",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_84qdv353499f74c2hdm25w2ayp",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 3000,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-MURPHY",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_v84e4dkk0a108gmgyxddrex18x",
        "name": "Conor Murphy",
        "accountNumber": "67890123",
        "sortCode": "90-01-23",
        "iban": null
      },
      "fspPaymentId": "fsp_xp6tr33kse70rwsrkhtp451pj7",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_9jmbpvrjbyhnnfayk15f8q2r8t",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 5700,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-WILLIAMS",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_0m3h0ystzhdkv089qtpxgymy0p",
        "name": "Rebecca Williams",
        "accountNumber": "78901234",
        "sortCode": "40-05-30",
        "iban": null
      },
      "fspPaymentId": "fsp_6whddsdngdj4zs5vnhmfdn8me7",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_0x9wgbm1f2j9mbydgrvs2jbnt5",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 4350,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-JOHNSON",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_bqney2sngj9ht0vw439pk4s511",
        "name": "Alex Johnson",
        "accountNumber": "89012345",
        "sortCode": "20-00-00",
        "iban": null
      },
      "fspPaymentId": "fsp_r3gh3bxbs76r4m41rnrg89tk53",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_csev4dpyfc4q00kmn3zd57j3ma",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 3750,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-FITZGERALD",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_x6438kwbvw2mmzq5d8r2ay8ngh",
        "name": "Niamh Fitzgerald",
        "accountNumber": "90123456",
        "sortCode": "90-01-23",
        "iban": null
      },
      "fspPaymentId": "fsp_30tzvy8z1fsmnpegjhmfh2ky77",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_a6czazny63d85f674fg9j41y31",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 4950,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-BROWN",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_5dpt32a2e7pkakyx43wq731mxb",
        "name": "Thomas Brown",
        "accountNumber": "01234567",
        "sortCode": "30-15-89",
        "iban": null
      },
      "fspPaymentId": "fsp_16bd235msqbzakf5303k2y05fj",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_c7ctjypt89a30xp631b80wcmsf",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 3400,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-DAVIES",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_jvrzahwp2f269f98adpnxzyhkr",
        "name": "Hannah Davies",
        "accountNumber": "11234567",
        "sortCode": "40-05-30",
        "iban": null
      },
      "fspPaymentId": "fsp_ab8f3pdyg7r4bnja8ktczndxdr",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_frr7tbcj2nzag4wrqyzjy3q33v",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 3550,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-KELLY",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_p6mwbj7ht9st1k0nq5q8b37z5p",
        "name": "Sean Kelly",
        "accountNumber": "21234567",
        "sortCode": "90-01-23",
        "iban": null
      },
      "fspPaymentId": "fsp_46451yg2q4zf5c5mhj3th3c531",
      "fspAdapter": "MOCK",
      "errorMessage": null
    },
    {
      "id": "pmnt_rvqk9shbyytqatw23rw6m7r3ae",
      "createdAt": "2025-12-24T10:00:00.000Z",
      "updatedAt": "2025-12-24T10:00:00.000Z",
      "amount": 2850,
      "currency": "GBP",
      "reference": "PAY-DEC-2025-WILSON",
      "status": "SUCCEEDED",
      "type": "DOMESTIC",
      "bulkPaymentId": "bp_9sz29pkhnjpctd0xkkp1fyqhab",
      "sourceAccountId": "acc_01k6bbebrefvhrjkygcj8nkg3j",
      "companyId": "com_01k1y1ypa1fqfbnc9xn5secx0d",
      "organisationId": "org_01k1y1x3vmfqfbnc337k9crvrg",
      "destination": {
        "type": "EMPLOYEE",
        "id": "emp_3srkf2v3egerrjbg157ssedxb8",
        "name": "Emma Wilson",
        "accountNumber": "31234567",
        "sortCode": "20-00-00",
        "iban": null
      },
      "fspPaymentId": "fsp_9631d52j89sq5vh0b0ze6eks1s",
      "fspAdapter": "MOCK",
      "errorMessage": null
    }
  ]
};

// Demo constants
const DEMO_ORG_ID = 'org_01k1y1x3vmfqfbnc337k9crvrg';
const DEMO_COMPANY_ID = 'com_01k1y1ypa1fqfbnc9xn5secx0d';
const DEMO_USER_ID = 'usr_01jwvb5j4he06aqw6yspcywgds';

// Generate TypeID-like IDs for mock responses
function generateId(prefix: string): string {
  const chars = '0123456789abcdefghjkmnpqrstvwxyz';
  let id = '';
  for (let i = 0; i < 26; i++) {
    id += chars[Math.floor(Math.random() * chars.length)];
  }
  return `${prefix}_${id}`;
}

/**
 * Generated handlers from controller routes
 */
export const generatedHandlers = [

  http.get('/api/email/search', () => {
    return HttpResponse.json({});
  }),

  http.get('/api/email/messages/:messageId', () => {
    return HttpResponse.json({});
  }),

  http.get('/api/email/messages/:messageId/attachments/:attachmentId', () => {
    return HttpResponse.json({});
  }),

  http.post('/api/email/extract-invoices', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.put('/api/email/connections/:connectionId/excluded-senders', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['connectionId'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/reflect/beneficiaries', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['id'],
    });
  }),

  http.delete('/api/reflect/investment-kiid-acceptances', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['id'],
    });
  }),

  http.post('/api/admin/modulr/accounts/:accountId/sandbox-credit', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/modulr/customers/onboarding', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.put('/api/admin/modulr/customers/onboarding/:onboardingId', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['onboardingId'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/modulr/customers/onboarding/:onboardingId/document/upload', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/admin/modulr/customers/onboarding/:onboardingId/document/:documentId', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['onboardingId'],
    });
  }),

  http.post('/api/admin/modulr/customers/onboarding/:onboardingId/send', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/wealthkernel/party', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/wealthkernel/account', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/wealthkernel/portfolio', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/wealthkernel/sandbox/deposit', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/wealthkernel/investment-holding', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/wealthkernel/sandbox/management-fee', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/payment-monitoring/trigger', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/admin/invoice/:invoiceId/download', () => {
    return HttpResponse.json({});
  }),

  http.post('/api/admin/invoice/reset-xero-sync', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/cards/:cardId/authorisations', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/cards/:cardId/authorisations/:authorisationId/settle', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/cards/:cardId/authorisations/:authorisationId/reverse', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/admin/employee/:employeeId/delete', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['employeeId'],
    });
  }),

  http.post('/api/admin/transaction/re-enrich', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/accounts', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/admin/documents/:documentId', () => {
    return HttpResponse.json({});
  }),

  http.post('/api/admin/trigger-workflow', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/terms-and-conditions', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/admin/organisation/:organisationId/invoice-match-scores', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['organisationId'],
    });
  }),

  http.delete('/api/admin/organisation/:organisationId/clear-email-scanned-evidence', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['organisationId'],
    });
  }),

  http.post('/api/admin/oauth-connections/:connectionId/reset', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.put('/api/admin/user/:userId', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['userId'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/payment-simulation/simulate-delayed', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/payment-simulation/simulate-failed', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/payment-simulation/cleanup', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/accounting/:connectionId/bank-accounts', () => {
    return HttpResponse.json({});
  }),

  http.get('/api/accounting/:connectionId/account-mappings', () => {
    return HttpResponse.json({});
  }),

  http.post('/api/accounting/:connectionId/account-mappings', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/accounting/:connectionId/create-bank-account', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/accounting/trigger-xero-sync', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/accounting/:connectionId/bank-feed-connections', () => {
    return HttpResponse.json({});
  }),

  http.delete('/api/accounting/:connectionId/bank-feed-connections/:mappingId', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['connectionId'],
    });
  }),

  http.post('/api/accounting/:connectionId/bank-feed-connections/:mappingId/reconnect', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/accounting/invoices/:invoiceId/reset-xero-sync', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/accounting/:connectionId/unmapped-xero-accounts', () => {
    return HttpResponse.json({});
  }),

  http.post('/api/accounting/:connectionId/import-xero-account', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/admin/xero/disconnect-account', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/users/:id', ({ params }) => {
    const id = params['id'];
    const data = demoData['user'] || [];
    const item = data.find((e: any) => e.id === id);

    if (!item) {
      return HttpResponse.json({ message: 'user not found' }, { status: 404 });
    }

    return HttpResponse.json(item);
  }),

  http.post('/api/users/:id/resend-verification-email', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('user'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/users/me/phone/send-otp', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('user'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/users/me/phone/verify-otp', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('user'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.patch('/api/users/me', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['id'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/transactions', ({ request }) => {
    const url = new URL(request.url);
    const since = url.searchParams.get('since');

    let data = demoData['transaction'] || [];

    // Filter by organisation
    data = data.filter((item: any) =>
      !item.organisationId || item.organisationId === 'org_01k1y1x3vmfqfbnc337k9crvrg'
    );

    // Filter by since param
    if (since) {
      const sinceDate = new Date(since);
      data = data.filter((item: any) =>
        item.updatedAt && new Date(item.updatedAt) > sinceDate
      );
    }

    return HttpResponse.json(data);
  }),

  http.get('/api/employee', ({ request }) => {
    const url = new URL(request.url);
    const since = url.searchParams.get('since');

    let data = demoData['employee'] || [];

    // Filter by organisation
    data = data.filter((item: any) =>
      !item.organisationId || item.organisationId === 'org_01k1y1x3vmfqfbnc337k9crvrg'
    );

    // Filter by since param
    if (since) {
      const sinceDate = new Date(since);
      data = data.filter((item: any) =>
        item.updatedAt && new Date(item.updatedAt) > sinceDate
      );
    }

    return HttpResponse.json(data);
  }),

  http.post('/api/employee', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('empl'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.put('/api/employee/:employeeId', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['employeeId'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/treasury/investment-holdings', () => {
    return HttpResponse.json({});
  }),

  http.post('/api/treasury/kiid-acceptance', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/treasury/register-interest', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/evidence/invoice', ({ request }) => {
    const url = new URL(request.url);
    const since = url.searchParams.get('since');

    let data = demoData['evidence'] || [];

    // Filter by organisation
    data = data.filter((item: any) =>
      !item.organisationId || item.organisationId === 'org_01k1y1x3vmfqfbnc337k9crvrg'
    );

    // Filter by since param
    if (since) {
      const sinceDate = new Date(since);
      data = data.filter((item: any) =>
        item.updatedAt && new Date(item.updatedAt) > sinceDate
      );
    }

    return HttpResponse.json(data);
  }),

  http.post('/api/evidence/invoice/:invoiceId/is-paid', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('evid'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.put('/api/evidence/invoice/:invoiceId', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['invoiceId'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/evidence/invoice/approve', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('evid'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/evidence/invoice/:invoiceId', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['invoiceId'],
    });
  }),

  http.get('/api/evidence', ({ request }) => {
    const url = new URL(request.url);
    const since = url.searchParams.get('since');

    let data = demoData['evidence'] || [];

    // Filter by organisation
    data = data.filter((item: any) =>
      !item.organisationId || item.organisationId === 'org_01k1y1x3vmfqfbnc337k9crvrg'
    );

    // Filter by since param
    if (since) {
      const sinceDate = new Date(since);
      data = data.filter((item: any) =>
        item.updatedAt && new Date(item.updatedAt) > sinceDate
      );
    }

    return HttpResponse.json(data);
  }),

  http.get('/api/evidence/:evidenceId', ({ params }) => {
    const id = params['evidenceId'];
    const data = demoData['evidence'] || [];
    const item = data.find((e: any) => e.id === id);

    if (!item) {
      return HttpResponse.json({ message: 'evidence not found' }, { status: 404 });
    }

    return HttpResponse.json(item);
  }),

  http.put('/api/evidence/:evidenceId', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['evidenceId'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/evidence/:evidenceId', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['evidenceId'],
    });
  }),

  http.get('/api/beneficiaries', ({ request }) => {
    const url = new URL(request.url);
    const since = url.searchParams.get('since');

    let data = demoData['beneficiary'] || [];

    // Filter by organisation
    data = data.filter((item: any) =>
      !item.organisationId || item.organisationId === 'org_01k1y1x3vmfqfbnc337k9crvrg'
    );

    // Filter by since param
    if (since) {
      const sinceDate = new Date(since);
      data = data.filter((item: any) =>
        item.updatedAt && new Date(item.updatedAt) > sinceDate
      );
    }

    return HttpResponse.json(data);
  }),

  http.post('/api/beneficiaries', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('bene'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.patch('/api/beneficiaries/:beneficiaryId', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['beneficiaryId'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/beneficiaries/:beneficiaryId', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['beneficiaryId'],
    });
  }),

  http.post('/api/categories', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('cate'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/tpp/consent/:consentId', () => {
    return HttpResponse.json({});
  }),

  http.get('/api/tpp/consents', () => {
    return HttpResponse.json({});
  }),

  http.post('/api/tpp/consent/decision', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/tpp/consent/:consentId', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['consentId'],
    });
  }),

  http.post('/api/tpp/eu-gateway/resource', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/tpp/uk-gateway/resource', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/verify-payee/approve/:payeeCheckId', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/companies', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('comp'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/companies', ({ request }) => {
    const url = new URL(request.url);
    const since = url.searchParams.get('since');

    let data = demoData['company'] || [];

    // Filter by organisation
    data = data.filter((item: any) =>
      !item.organisationId || item.organisationId === 'org_01k1y1x3vmfqfbnc337k9crvrg'
    );

    // Filter by since param
    if (since) {
      const sinceDate = new Date(since);
      data = data.filter((item: any) =>
        item.updatedAt && new Date(item.updatedAt) > sinceDate
      );
    }

    return HttpResponse.json(data);
  }),

  http.post('/api/payrolls', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('payr'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.put('/api/payrolls/:payrollId', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['payrollId'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/payrolls/:payrollId/records', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('payr'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.put('/api/payrolls/:payrollId/records/:recordId', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['payrollId'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/payrolls/:payrollId/records/:recordId', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['payrollId'],
    });
  }),

  http.post('/api/payrolls/:payrollId/payments', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('payr'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/payrolls/:payrollId/evidence', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('payr'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/payrolls/:payrollId/evidence/:evidenceId', () => {
    return HttpResponse.json({});
  }),

  http.get('/api/oauth/authorize', () => {
    return HttpResponse.json({});
  }),

  http.get('/api/oauth/callback', () => {
    return HttpResponse.json({});
  }),

  http.get('/api/oauth/disconnect', () => {
    return HttpResponse.json({});
  }),

  http.get('/api/oauth/connection/:connectionId/diagnostics', () => {
    return HttpResponse.json({});
  }),

  http.post('/api/open-banking/payments/authorise', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('item'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/open-banking/payments/callback', () => {
    return HttpResponse.json({});
  }),

  http.post('/api/cards/cancel', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('card'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.patch('/api/cards/display-name', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['id'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/organisations/invite', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('orga'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.get('/api/organisations/members', ({ request }) => {
    const url = new URL(request.url);
    const since = url.searchParams.get('since');

    let data = demoData['organisation'] || [];

    // Filter by organisation
    data = data.filter((item: any) =>
      !item.organisationId || item.organisationId === 'org_01k1y1x3vmfqfbnc337k9crvrg'
    );

    // Filter by since param
    if (since) {
      const sinceDate = new Date(since);
      data = data.filter((item: any) =>
        item.updatedAt && new Date(item.updatedAt) > sinceDate
      );
    }

    return HttpResponse.json(data);
  }),

  http.delete('/api/organisations/invite', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['id'],
    });
  }),

  http.get('/api/entities/by-type/:name', ({ params, request }) => {
    const { name } = params;
    const url = new URL(request.url);
    const since = url.searchParams.get('since');

    const entityName = String(name).toLowerCase();
    let data = demoData[entityName] || [];

    // Filter by organisation if applicable
    data = data.filter((item: any) =>
      !item.organisationId || item.organisationId === 'org_01k1y1x3vmfqfbnc337k9crvrg'
    );

    // Filter by since param
    if (since) {
      const sinceDate = new Date(since);
      data = data.filter((item: any) =>
        item.updatedAt && new Date(item.updatedAt) > sinceDate
      );
    }

    return HttpResponse.json(data);
  }),

  http.get('/api/entities/by-id', ({ request }) => {
    const url = new URL(request.url);
    const ids = url.searchParams.getAll('ids');

    const results: any[] = [];
    for (const id of ids) {
      // Find entity by ID across all data
      for (const [_, entities] of Object.entries(demoData)) {
        const found = (entities as any[]).find((e: any) => e.id === id);
        if (found) {
          results.push(found);
          break;
        }
      }
    }

    return HttpResponse.json(results);
  }),

  http.patch('/api/entities/by-type/:type', async ({ request, params }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: params['type'],
      updatedAt: new Date().toISOString(),
    });
  }),

  http.delete('/api/entities/by-type/:type', ({ params }) => {
    return HttpResponse.json({
      message: 'Deleted successfully',
      id: params['type'],
    });
  }),

  http.post('/api/accounts', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('acco'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),

  http.post('/api/accounts/:accountId/unlink', async ({ request }) => {
    const body = (await request.json().catch(() => ({}))) as Record<string, unknown>;
    return HttpResponse.json({
      ...body,
      id: generateId('acco'),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }),
];

/**
 * Get all handlers including generated ones
 */
export function getGeneratedHandlers() {
  return generatedHandlers;
}

/**
 * Export demo data for use in other handlers
 */
export { demoData, DEMO_ORG_ID, DEMO_COMPANY_ID, DEMO_USER_ID, generateId };
